// Code generated by the Encore v1.48.9 client generator. DO NOT EDIT.

// Disable eslint, jshint, and jslint for this file.
/* eslint-disable */
/* jshint ignore:start */
/*jslint-disable*/

/**
 * BaseURL is the base URL for calling the Encore application's API.
 */
export type BaseURL = string

export const Local: BaseURL = "http://localhost:4000"

/**
 * Environment returns a BaseURL for calling the cloud environment with the given name.
 */
export function Environment(name: string): BaseURL {
    return `https://${name}-skrymr-re72ae.encr.app`
}

/**
 * PreviewEnv returns a BaseURL for calling the preview environment with the given PR number.
 */
export function PreviewEnv(pr: number | string): BaseURL {
    return Environment(`pr${pr}`)
}

const BROWSER = typeof globalThis === "object" && ("window" in globalThis);

/**
 * Client is an API client for the skrymr-re72ae Encore application.
 */
export default class Client {
    public readonly authentication: authentication.ServiceClient
    public readonly binfitting: binfitting.ServiceClient
    public readonly booking: booking.ServiceClient
    public readonly checkout: checkout.ServiceClient
    public readonly core: core.ServiceClient
    public readonly crm: crm.ServiceClient
    public readonly customization: customization.ServiceClient
    public readonly detection: detection.ServiceClient
    public readonly emailer: emailer.ServiceClient
    public readonly environmental: environmental.ServiceClient
    public readonly integrations: integrations.ServiceClient
    public readonly invoicecontrol: invoicecontrol.ServiceClient
    public readonly locations: locations.ServiceClient
    public readonly logger: logger.ServiceClient
    public readonly optimization: optimization.ServiceClient
    public readonly repo: repo.ServiceClient
    public readonly statistics: statistics.ServiceClient
    public readonly tracking: tracking.ServiceClient
    public readonly transportation: transportation.ServiceClient
    private readonly options: ClientOptions
    private readonly target: string


    /**
     * Creates a Client for calling the public and authenticated APIs of your Encore application.
     *
     * @param target  The target which the client should be configured to use. See Local and Environment for options.
     * @param options Options for the client
     */
    constructor(target: BaseURL, options?: ClientOptions) {
        this.target = target
        this.options = options ?? {}
        const base = new BaseClient(this.target, this.options)
        this.authentication = new authentication.ServiceClient(base)
        this.binfitting = new binfitting.ServiceClient(base)
        this.booking = new booking.ServiceClient(base)
        this.checkout = new checkout.ServiceClient(base)
        this.core = new core.ServiceClient(base)
        this.crm = new crm.ServiceClient(base)
        this.customization = new customization.ServiceClient(base)
        this.detection = new detection.ServiceClient(base)
        this.emailer = new emailer.ServiceClient(base)
        this.environmental = new environmental.ServiceClient(base)
        this.integrations = new integrations.ServiceClient(base)
        this.invoicecontrol = new invoicecontrol.ServiceClient(base)
        this.locations = new locations.ServiceClient(base)
        this.logger = new logger.ServiceClient(base)
        this.optimization = new optimization.ServiceClient(base)
        this.repo = new repo.ServiceClient(base)
        this.statistics = new statistics.ServiceClient(base)
        this.tracking = new tracking.ServiceClient(base)
        this.transportation = new transportation.ServiceClient(base)
    }

    /**
     * Creates a new Encore client with the given client options set.
     *
     * @param options Client options to set. They are merged with existing options.
     **/
    public with(options: ClientOptions): Client {
        return new Client(this.target, {
            ...this.options,
            ...options,
        })
    }
}

/**
 * ClientOptions allows you to override any default behaviour within the generated Encore client.
 */
export interface ClientOptions {
    /**
     * By default the client will use the inbuilt fetch function for making the API requests.
     * however you can override it with your own implementation here if you want to run custom
     * code on each API request made or response received.
     */
    fetcher?: Fetcher

    /** Default RequestInit to be used for the client */
    requestInit?: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }

    /**
     * Allows you to set the authentication data to be used for each
     * request either by passing in a static object or by passing in
     * a function which returns a new object for each request.
     */
    auth?: authentication.AuthParams | AuthDataGenerator
}

export namespace authentication {
    export interface AuthParams {
        Authorization: string
        XAuthToken: string
        /**
         * To support multiple organizations connected to the same account on Scope, this header tells us which organization is currently active.
         * NOTE: This is currently optional when authenticating from Scope, but will become required in the future.
         * If not provided, the organization the user is originally connected to will be used.
         */
        ActiveOrganizationID?: string

        /**
         * These fields are used for the widget token auth flow
         * 
         * The token is generated when the URL is created and is passed to the iframe widget.
         * This allows us to know which user is accessing the widget.
         */
        WidgetToken: string

        /**
         * The secret is used to ensure that only we can use this auth flow.
         * It's a secret we have specified on both the server-side of the widget and the backend.
         * This prevents users to use the Widget-Token to make requests to the backend.
         */
        WidgetSecret: string
    }

    export interface CreateBusinessCentralTokenParams {
        orgId: string
    }

    /**
     * CreateBusinessCentralTokenResponse encapsulates the response containing the access token
     */
    export interface CreateBusinessCentralTokenResponse {
        "access_token": string
    }

    export interface CreatePasswordResetParams {
        /**
         * The Origin header is automatically included in the request by the browser
         */
        origin?: string

        email: string
        language?: string
    }

    /**
     * NOTE: Input params struct docs to be modified as we add more permissions
     */
    export interface DeleteRetailerPermParams {
        retailerId: string
        /**
         * Supported permissions can be found in the authentication service
         */
        permissions: number[]
    }

    export interface GetAPIKeyResponse {
        key: string
    }

    export interface GetAccountNamesParams {
        accountIds: string[]
    }

    export interface GetAccountNamesResponse {
        accountNames: models.AccountName[]
        retailerName: string
    }

    export interface GetAccountResponse {
        account: models.Account
    }

    export interface GetAccountRolesResponse {
        /**
         * List of roles associated with the account in the organization
         */
        accountRoles: models.AccountOrganizationRole[]
    }

    export interface GetAccountsResponse {
        accounts: models.Account[]
    }

    export interface GetAllRetailersResponse {
        /**
         * List of entries from the retailer table
         */
        retailers: models.Retailer[]
    }

    export interface GetCompaniesFromBusinessCentralParams {
        orgId: string
    }

    export interface GetCompaniesFromBusinessCentralResponse {
        companies: models.MicrosoftBCCompanyInfo[]
    }

    export interface GetIMICredentialsResponse {
        /**
         * IMI credentials
         */
        credentials: models.IMICredentials
    }

    export interface GetInvitationParams {
        id: string
    }

    export interface GetInvitationResponse {
        invitation: models.Invitation
    }

    export interface GetKlarnaKeyResponse {
        key: string
    }

    export interface GetMicrosoftBCCredentialsResponse {
        credentials: models.MicrosoftBCAuthData
    }

    export interface GetOrganizationAccountsResponse {
        /**
         * List of accounts associated with the organization
         */
        accounts: models.Account[]
    }

    export interface GetOrganizationsParams {
        /**
         * List of organization IDs to fetch
         */
        ids?: string[]
    }

    export interface GetOrganizationsResponse {
        /**
         * List of organizations associated with the authenticated account
         */
        organizations: models.Retailer[]
    }

    export interface GetPasswordResetParams {
        id: string
    }

    export interface GetPasswordResetResponse {
        passwordReset: models.PasswordReset
    }

    export interface GetRetailerByIdParams {
        retailerId: string
    }

    export interface GetRetailerByIdResponse {
        retailer: models.Retailer
    }

    export interface GetRetailerResponse {
        retailer: models.Retailer
    }

    /**
     * GetVersionForOrgResponse represents the response for fetching version information for an organization.
     * 
     * It contains a boolean flag indicating if it's a new version for the organization.
     */
    export interface GetVersionResponse {
        isNewVersion: boolean
    }

    export interface InsertKlarnaAuthDataParams {
        key: string
    }

    /**
     * NOTE: Input params struct docs to be modified as we add more permissions
     */
    export interface InsertRetailerPermParams {
        retailerId: string
        /**
         * Supported permissions can be found in the authentication service
         */
        permissions: number[]
    }

    /**
     * Model representing the incoming request to InsertSelfOnboard
     * 
     * InsertSelfOnboardParams contains the information of the self-onboard record to be inserted.
     */
    export interface InsertSelfOnboardParams {
        info: models.SelfOnboard
    }

    /**
     * Model representing the outgoing response from InsertSelfOnboard
     * 
     * InsertSelfOnboardResponse contains the ID of the newly inserted self-onboard record.
     */
    export interface InsertSelfOnboardResponse {
        id: string
    }

    export interface InviteParams {
        /**
         * Origin of the request (e.g. https://scope.skrym.com). Can be fetched using `document.location.origin`
         */
        origin: string

        email: string
        firstName: string
        lastName: string
        roles: datamodels.Role[]
        language?: string
    }

    export interface MicrosoftBcTokenResponse {
        "access_token": string
        "expires_in": number
    }

    export interface RefreshTokenParams {
        refreshToken: string
    }

    export interface RefreshTokenResponse {
        /**
         * The access token used to make authenticated requests to the API with
         */
        accessToken: string

        /**
         * Expiration time of the access token in seconds since Unix epoch
         */
        expiresAt: number

        /**
         * The refresh token used to get a new access token when the current one expires
         */
        refreshToken: string

        /**
         * The ID of the refresh token. Used for token invalidation
         */
        refreshTokenId: string

        /**
         * The auth data of the user
         */
        authData: datamodels.AuthData
    }

    export interface ResetPasswordParams {
        passwordResetId: string
        password: string
    }

    export interface SignInParams {
        email: string
        password: string
    }

    export interface SignInResponse {
        /**
         * The access token used to make authenticated requests to the API with
         */
        accessToken: string

        /**
         * Expiration time of the access token in seconds since Unix epoch
         */
        expiresAt: number

        /**
         * The refresh token used to get a new access token when the current one expires
         */
        refreshToken: string

        /**
         * The ID of the refresh token. Used for token invalidation
         */
        refreshTokenId: string

        /**
         * The auth data of the user
         */
        authData: datamodels.AuthData
    }

    export interface SignOutParams {
        refreshToken: string
    }

    export interface SignUpParams {
        invitationId: string
        password: string
    }

    export interface TestBCIntegrationResponse {
        message: string
        companies: models.MicrosoftBCCompanyInfo[]
    }

    export interface UpsertIMICredentialsParams {
        /**
         * Unique identifier for the IMI credentials
         */
        id: string

        /**
         * Username for the IMI credentials
         */
        username: string

        /**
         * Password for the IMI credentials
         */
        password: string

        /**
         * Company name for the IMI credentials
         */
        companyName: string

        /**
         * Whether the credentials are allowed to put optimization results or not. Default is false
         */
        putOptimizationResult: boolean
    }

    export interface UpsertMicrosoftCredentialsParams {
        params: models.MicrosoftBCAuthData
    }

    /**
     * It contains a boolean flag that indicates if the organization is using the new version.
     */
    export interface UpsertVersionForOrgParams {
        isNewVersion: boolean
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.CreateBusinessCentralToken = this.CreateBusinessCentralToken.bind(this)
            this.CreatePasswordReset = this.CreatePasswordReset.bind(this)
            this.DeleteRetailerPermissions = this.DeleteRetailerPermissions.bind(this)
            this.DeleteVersion = this.DeleteVersion.bind(this)
            this.GetAPIKey = this.GetAPIKey.bind(this)
            this.GetAccount = this.GetAccount.bind(this)
            this.GetAccountNames = this.GetAccountNames.bind(this)
            this.GetAccountRoles = this.GetAccountRoles.bind(this)
            this.GetAccounts = this.GetAccounts.bind(this)
            this.GetAllRetailers = this.GetAllRetailers.bind(this)
            this.GetCompaniesFromBusinessCentral = this.GetCompaniesFromBusinessCentral.bind(this)
            this.GetIMICredentials = this.GetIMICredentials.bind(this)
            this.GetInvitation = this.GetInvitation.bind(this)
            this.GetKlarnaKey = this.GetKlarnaKey.bind(this)
            this.GetMicrosoftBCCredentials = this.GetMicrosoftBCCredentials.bind(this)
            this.GetOrganizationAccounts = this.GetOrganizationAccounts.bind(this)
            this.GetOrganizations = this.GetOrganizations.bind(this)
            this.GetPasswordReset = this.GetPasswordReset.bind(this)
            this.GetRetailer = this.GetRetailer.bind(this)
            this.GetRetailerById = this.GetRetailerById.bind(this)
            this.GetVersion = this.GetVersion.bind(this)
            this.InsertKlarnaAuthData = this.InsertKlarnaAuthData.bind(this)
            this.InsertRetailerPermissions = this.InsertRetailerPermissions.bind(this)
            this.InsertSelfOnboard = this.InsertSelfOnboard.bind(this)
            this.Invite = this.Invite.bind(this)
            this.MicrosoftBCAuthHandler = this.MicrosoftBCAuthHandler.bind(this)
            this.PingAuth = this.PingAuth.bind(this)
            this.RefreshToken = this.RefreshToken.bind(this)
            this.ResetPassword = this.ResetPassword.bind(this)
            this.SignIn = this.SignIn.bind(this)
            this.SignOut = this.SignOut.bind(this)
            this.SignUp = this.SignUp.bind(this)
            this.TestBusinessCentralIntegration = this.TestBusinessCentralIntegration.bind(this)
            this.UpsertIMICredentials = this.UpsertIMICredentials.bind(this)
            this.UpsertMicrosoftCredentials = this.UpsertMicrosoftCredentials.bind(this)
            this.UpsertVersionForOrg = this.UpsertVersionForOrg.bind(this)
        }

        /**
         * CreateBusinessCentralToken generates a new Business Central bearer token for the given organization
         */
        public async CreateBusinessCentralToken(params: CreateBusinessCentralTokenParams): Promise<CreateBusinessCentralTokenResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.CreateBusinessCentralToken`, JSON.stringify(params))
            return await resp.json() as CreateBusinessCentralTokenResponse
        }

        public async CreatePasswordReset(params: CreatePasswordResetParams): Promise<void> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                origin: params.origin,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                email:    params.email,
                language: params.language,
            }

            await this.baseClient.callTypedAPI("POST", `/authentication.CreatePasswordReset`, JSON.stringify(body), {headers})
        }

        /**
         * InsertRetailerPermissions inserts the provded permissions for the authenticated retailer.
         */
        public async DeleteRetailerPermissions(params: DeleteRetailerPermParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.DeleteRetailerPermissions`, JSON.stringify(params))
        }

        /**
         * DeleteVersion deletes the version information for the authenticated organization.
         * Returns:
         *   - error: An error if the operation fails, nil otherwise.
         */
        public async DeleteVersion(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.DeleteVersion`)
        }

        public async GetAPIKey(): Promise<GetAPIKeyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetAPIKey`)
            return await resp.json() as GetAPIKeyResponse
        }

        public async GetAccount(): Promise<GetAccountResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetAccount`)
            return await resp.json() as GetAccountResponse
        }

        public async GetAccountNames(params: GetAccountNamesParams): Promise<GetAccountNamesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetAccountNames`, JSON.stringify(params))
            return await resp.json() as GetAccountNamesResponse
        }

        /**
         * Fetch the roles of the accounts associated with the authenticated organization.
         */
        public async GetAccountRoles(): Promise<GetAccountRolesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetAccountRoles`)
            return await resp.json() as GetAccountRolesResponse
        }

        public async GetAccounts(): Promise<GetAccountsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetAccounts`)
            return await resp.json() as GetAccountsResponse
        }

        /**
         * GetAllRetailersInternal returns all retailers in the database
         * 
         * # Requires SKRYM permissions
         */
        public async GetAllRetailers(): Promise<GetAllRetailersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetAllRetailers`)
            return await resp.json() as GetAllRetailersResponse
        }

        /**
         * GetCompaniesFromBusinessCentral retrieves the list of companies from Business Central
         * 
         * It is currently only used to test the BC integration
         */
        public async GetCompaniesFromBusinessCentral(params: GetCompaniesFromBusinessCentralParams): Promise<GetCompaniesFromBusinessCentralResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetCompaniesFromBusinessCentral`, JSON.stringify(params))
            return await resp.json() as GetCompaniesFromBusinessCentralResponse
        }

        /**
         * GetIMICredentials gets the IMI credentials for an authenticated user.
         */
        public async GetIMICredentials(): Promise<GetIMICredentialsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetIMICredentials`)
            return await resp.json() as GetIMICredentialsResponse
        }

        public async GetInvitation(params: GetInvitationParams): Promise<GetInvitationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetInvitation`, JSON.stringify(params))
            return await resp.json() as GetInvitationResponse
        }

        public async GetKlarnaKey(): Promise<GetKlarnaKeyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetKlarnaKey`)
            return await resp.json() as GetKlarnaKeyResponse
        }

        public async GetMicrosoftBCCredentials(): Promise<GetMicrosoftBCCredentialsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetMicrosoftBCCredentials`)
            return await resp.json() as GetMicrosoftBCCredentialsResponse
        }

        /**
         * Fetches the accounts associated with the authenticated organization.
         */
        public async GetOrganizationAccounts(): Promise<GetOrganizationAccountsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetOrganizationAccounts`)
            return await resp.json() as GetOrganizationAccountsResponse
        }

        /**
         * GetOrganizations retrieves the organizations associated with the authenticated account, with any filters applied.
         */
        public async GetOrganizations(params: GetOrganizationsParams): Promise<GetOrganizationsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetOrganizations`, JSON.stringify(params))
            return await resp.json() as GetOrganizationsResponse
        }

        public async GetPasswordReset(params: GetPasswordResetParams): Promise<GetPasswordResetResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetPasswordReset`, JSON.stringify(params))
            return await resp.json() as GetPasswordResetResponse
        }

        public async GetRetailer(): Promise<GetRetailerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetRetailer`)
            return await resp.json() as GetRetailerResponse
        }

        public async GetRetailerById(params: GetRetailerByIdParams): Promise<GetRetailerByIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetRetailerById`, JSON.stringify(params))
            return await resp.json() as GetRetailerByIdResponse
        }

        /**
         * GetVersion fetches the version information for the authenticated organization.
         * Returns:
         *   - GetVersionResponse: A response containing the new version boolean flag for the organization.
         *   - error: An error if the operation fails, nil otherwise.
         */
        public async GetVersion(): Promise<GetVersionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.GetVersion`)
            return await resp.json() as GetVersionResponse
        }

        /**
         * InsertKlarnaAuthData inserts the Klarna authentication data into the database
         */
        public async InsertKlarnaAuthData(params: InsertKlarnaAuthDataParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.InsertKlarnaAuthData`, JSON.stringify(params))
        }

        /**
         * InsertRetailerPermissions inserts the provded permissions for the authenticated retailer.
         */
        public async InsertRetailerPermissions(params: InsertRetailerPermParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.InsertRetailerPermissions`, JSON.stringify(params))
        }

        public async InsertSelfOnboard(params: InsertSelfOnboardParams): Promise<InsertSelfOnboardResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.InsertSelfOnboard`, JSON.stringify(params))
            return await resp.json() as InsertSelfOnboardResponse
        }

        public async Invite(params: InviteParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.Invite`, JSON.stringify(params))
        }

        public async MicrosoftBCAuthHandler(): Promise<MicrosoftBcTokenResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.MicrosoftBCAuthHandler`)
            return await resp.json() as MicrosoftBcTokenResponse
        }

        /**
         * The PingAuth endpoint allows you to test if you are authenticated.
         * 
         * If authenticated, the endpoint will respond with a 200 OK.
         * If not, the response will be a 401 Unauthorized instead.
         */
        public async PingAuth(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.PingAuth`)
        }

        public async RefreshToken(params: RefreshTokenParams): Promise<RefreshTokenResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.RefreshToken`, JSON.stringify(params))
            return await resp.json() as RefreshTokenResponse
        }

        public async ResetPassword(params: ResetPasswordParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.ResetPassword`, JSON.stringify(params))
        }

        public async SignIn(params: SignInParams): Promise<SignInResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.SignIn`, JSON.stringify(params))
            return await resp.json() as SignInResponse
        }

        public async SignOut(params: SignOutParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.SignOut`, JSON.stringify(params))
        }

        public async SignUp(params: SignUpParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.SignUp`, JSON.stringify(params))
        }

        /**
         * TestBusinessCentralIntegration tests the Microsoft BC integration
         * 
         * To test it, it simply tries to call the GET on /companies
         */
        public async TestBusinessCentralIntegration(): Promise<TestBCIntegrationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/authentication.TestBusinessCentralIntegration`)
            return await resp.json() as TestBCIntegrationResponse
        }

        /**
         * UpsertIMICredentials upserts the IMI credentials
         */
        public async UpsertIMICredentials(params: UpsertIMICredentialsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.UpsertIMICredentials`, JSON.stringify(params))
        }

        public async UpsertMicrosoftCredentials(params: UpsertMicrosoftCredentialsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.UpsertMicrosoftCredentials`, JSON.stringify(params))
        }

        /**
         * UpsertVersionForOrg upserts the version information for the authenticated organization.
         * If the organization already has a version entry, it updates it.
         * Otherwise, it inserts a new entry.
         * Returns:
         *   - error: An error if the operation fails, nil otherwise.
         */
        public async UpsertVersionForOrg(params: UpsertVersionForOrgParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/authentication.UpsertVersionForOrg`, JSON.stringify(params))
        }
    }
}

export namespace binfitting {
    /**
     * StartParams is the Parameter collection for the Start endpoint of BinFitting Optimization
     */
    export interface StartParams {
        /**
         * Offset is the coefficient for 10000 orders. e.g. Offset = 5 returns 50000 orders if tota number of orders in => 50000. Returns max number of orders if less.
         */
        offset: number

        /**
         * NumberOfPackages is the desired number of result packages
         */
        numberOfPackages: number

        /**
         * MaxNumberOfIter is the maximum number of iterations Powell allowed to do
         */
        maxNumberOfIter: number

        /**
         * TestSamplePercentage sets the Test/Train sample seperation weight. The format is 1/10 (0.3 for 30%)
         */
        testSamplePercentage: number

        /**
         * GenerationType sets that how we want to generate initial points for Powell to start working. "equally spaced" ==> Points from origin to MaxContainerMaxCoord. "weighted distribution" ==> Points distrubuted based on Orders MaxCoord
         */
        generationType: models.InitialContainerSelectionTypes

        /**
         * EvaluationType sets that how we want to evaluate result packages. "binpacking optimization" ==> Runs BinPacking Optimization. "itemsmaxcoord placement" ==> Places order into new packages based on itemsmaxcoord or freeitemsmaxcoord
         */
        evaluationType: models.EvaluationTypes
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.Start = this.Start.bind(this)
        }

        public async Start(params: StartParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/binfitting.Start`, JSON.stringify(params))
        }
    }
}

export namespace booking {
    export interface Availability {
        /**
         * Indicates if the availability has been preselected or not. This determines if the availability will be fetched during the booking request or not.
         */
        exists: boolean

        /**
         * A second-level transporter specific reference associated with the availability event
         */
        transporterReference: string

        /**
         * Pickup location data for the availability event
         */
        pickupLocation: AvailabilityLocation

        /**
         * Delivery location data for the availability event
         */
        deliveryLocation: AvailabilityLocation

        /**
         * Additional delivery location that is to be populated for transporters that require an additional delivery location, e.g. Accesspoint location for DHL Home Deliveries
         */
        additionalDeliveryLocation: AvailabilityLocation
    }

    export interface AvailabilityLocation {
        /**
         * A second-level transporter specific reference associated with the availability event
         */
        externalLocationReference: string

        /**
         * Name of the location
         */
        name: string

        /**
         * Street address.
         */
        address: string

        /**
         * City name
         */
        city: string

        /**
         * ISO country alpha 2 code.
         */
        countryCode: string

        /**
         * The postal code for the location.
         */
        postalCode: string
    }

    /**
     * BookShipmentParams holds all the required information for booking a shipment.
     */
    export interface BookShipmentParams {
        /**
         * A unique identifier referencing the booking.
         */
        bookingReference: string

        /**
         * A unique identifier referencing the shipment in the WMS.
         */
        wmsReference: string

        /**
         * A list of freight objects, representing the individual freight objects in the shipment.
         */
        contents: BookingContent[]

        /**
         * The location where the shipment will be picked up.
         */
        origin: ShipmentLocation

        /**
         * The location where the shipment will be delivered.
         */
        destination: ShipmentLocation

        /**
         * Information about who will receive the shipment.
         */
        receiver: Receiver

        /**
         * Extra features or services required for the shipment.
         */
        addons: { [key: datamodels.SkrymAddon]: string }

        /**
         * Your alias for the transporter to be used. If no alias is provided, it will default to the original transporter name.
         */
        transporter: string

        /**
         * Your alias for the method of transportation to be used. If no alias is provided, it will default to the original method name.
         */
        transportMethod: string

        /**
         * Optional Skrym transport method ID that can be used instead of transporter name/method
         */
        transportMethodId: string

        workstation: datamodels.Workstation
        /**
         * Optional value to pass a selected service point/ box / store / etc
         */
        destinationReference?: string
    }

    /**
     * BookShipmentResponse represents the response after booking a shipment.
     */
    export interface BookShipmentResponse {
        /**
         * The booking object associated with the booking.
         */
        booking: datamodels.SkrymBooking

        /**
         * a list of shipment labels associated with the booking.
         */
        labels: models.ShipmentLabel[]

        /**
         * Tracking data for the booking
         */
        trackingData: datamodels.FreightObjectTrackingData[]
    }

    /**
     * BookingContent contains information about an individual freight object (pallet or parcel) in a shipment.
     */
    export interface BookingContent {
        /**
         * Unique identifier for the freight object.
         */
        id?: string

        /**
         * An identifier referencing the freight object.
         */
        reference: string

        /**
         * Physical attributes of the freight object
         */
        physicalProperties: datamodels.PhysicalProperties

        /**
         * Products contained in the freight object
         */
        products: Product[]

        /**
         * Preselected availability for the freight object
         */
        availability?: Availability
    }

    export interface FreightObjectLabels {
        freightObjectReference: string
        labels: models.BookingLabelURL[]
    }

    export interface GetAddonMappingParams {
        transportMethodId: string
    }

    export interface GetAddonMappingResponse {
        addonMap: models.AddonMapData
    }

    /**
     * GetAddonMappingsParams enables filtering the addons on transport method
     */
    export interface GetAddonMappingsParams {
        /**
         * A slice of UUIDs representing the transport methods to filter the addons on.
         */
        transportMethods: string[]
    }

    /**
     * GetAllAddonMappingResponse represents the response structure for fetching all addon mappings.
     */
    export interface GetAddonMappingsResponse {
        /**
         * A slice of AddonMapData representing the mappings of all addons.
         */
        addonMaps: models.AddonMapData[]
    }

    export interface GetBookingByIDParams {
        /**
         * A unique identifier referencing the booking.
         */
        bookingId: string
    }

    export interface GetBookingByTrackingReferenceParams {
        /**
         * A unique identifier referencing the booking.
         */
        transporterTrackingReference: string

        transporterId: string
    }

    export interface GetBookingByTrackingReferenceRes {
        booking: datamodels.SkrymBooking
    }

    export interface GetBookingsPerHourParams {
        from: string
        to: string
    }

    export interface GetBookingsPerHourResponse {
        bookingsPerHour: repository.BookingsPerHour[]
    }

    export interface GetConsignorDetailsResponse {
        consignorDetails: models.ConsignorDetails
    }

    export interface GetEnumMappingParams {
        transportMethodId: string
    }

    export interface GetEnumMappingResponse {
        enumData: models.AddonEnumData[]
    }

    /**
     * GetLabelContentByExternalBookingReferenceParams contains the parameters for retrieving label content by external booking reference.
     */
    export interface GetLabelContentByExternalBookingReferenceParams {
        /**
         * The external booking reference to look up labels.
         */
        bookingReference: string
    }

    /**
     * GetLabelContentByExternalBookingReferenceResponse contains the response for the label content retrieval.
     */
    export interface GetLabelContentByExternalBookingReferenceResponse {
        /**
         * List of shipment labels associated with the booking reference.
         */
        labels: models.ShipmentLabel[]
    }

    export interface GetLabelsForBookingByIDParams {
        bookingID: string
    }

    export interface GetLabelsForBookingByReferenceParams {
        bookingReference: string
    }

    export interface GetLabelsForBookingResponse {
        freightObjects: FreightObjectLabels[]
    }

    /**
     * Product contains information about a product/item in a shipment.
     */
    export interface Product {
        /**
         * An identifier referencing the product.
         */
        reference: string

        /**
         * Weight of the product in g
         */
        weight: number

        /**
         * Length of the product in mm
         */
        length: number

        /**
         * Width of the product in mm
         */
        width: number

        /**
         * Height of the product in mm
         */
        height: number

        /**
         * The number of products with the same properties.
         */
        quantity: number

        /**
         * The price of the product in the specified currency.
         */
        unitPrice: number

        /**
         * The currency of the unit price.
         */
        currency: string

        /**
         * The tax rate of the product in percent, 0.25 = 25%
         */
        taxRate: number

        /**
         * The discount rate of the product in percent, 0.1 = 10%
         */
        discountRate: number
    }

    /**
     * Receiver holds information about the individual or entity receiving the shipment.
     */
    export interface Receiver {
        /**
         * Name of the receiver.
         */
        name: string

        /**
         * Phone number of the receiver.
         */
        phone: string

        /**
         * Email address of the receiver.
         */
        email: string

        /**
         * Address provides the location details for the receiver.
         */
        address: ShipmentLocation
    }

    /**
     * RetryBookingParams holds all the required information for completing a partial booking.
     */
    export interface RetryBookingParams {
        /**
         * A unique identifier referencing the booking
         */
        bookingReference: string

        /**
         * Optional workstation information
         */
        workstation: datamodels.Workstation
    }

    /**
     * ShipmentLocation defines the attributes for a shipment location.
     */
    export interface ShipmentLocation {
        /**
         * ISO country alpha 2 code.
         */
        countryCode: string

        /**
         * The postal code for the location.
         */
        postalCode: string

        /**
         * City name
         */
        city: string

        /**
         * Street address.
         */
        address: string

        /**
         * Optional secondary address line (e.g., department, floor, suite). Will only be applied if the transporter supports it.
         */
        secondaryAddress?: string

        /**
         * Optional name for the location (e.g., company name). For the origin, if not provided, will default to the retailer name.
         */
        name?: string
    }

    export interface UpsertConsignorDetailsParams {
        /**
         * ID of the consignor details
         */
        id: string

        /**
         * Organization Location ID
         */
        organizationLocationId: string

        /**
         * Name of the company
         */
        organizationName: string

        /**
         * URL of the company
         */
        organizationUrl: string

        /**
         * Reference person for the company
         */
        referencePerson: string

        /**
         * Email of the company
         */
        email: string

        /**
         * Phone number of the company
         */
        phoneNumber: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.BookShipment = this.BookShipment.bind(this)
            this.GetAddonMapping = this.GetAddonMapping.bind(this)
            this.GetAddonMappings = this.GetAddonMappings.bind(this)
            this.GetBookingByID = this.GetBookingByID.bind(this)
            this.GetBookingByTrackingReference = this.GetBookingByTrackingReference.bind(this)
            this.GetBookingsPerHour = this.GetBookingsPerHour.bind(this)
            this.GetConsignorDetails = this.GetConsignorDetails.bind(this)
            this.GetEnumMapping = this.GetEnumMapping.bind(this)
            this.GetLabelContentByExternalBookingReference = this.GetLabelContentByExternalBookingReference.bind(this)
            this.GetLabelsByBookingID = this.GetLabelsByBookingID.bind(this)
            this.GetLabelsForBookingByReference = this.GetLabelsForBookingByReference.bind(this)
            this.RetryBooking = this.RetryBooking.bind(this)
            this.UpsertConsignorDetails = this.UpsertConsignorDetails.bind(this)
        }

        /**
         * REST API endpoint for booking a shipment.
         * 
         * BookShipment books the delivery of the provided parcels with the transporter matching the provided aliases.
         * It validates the delivery with the transporter and then books it. Printing of labels is not done by this endpoint.
         * Responds with an error if validation fails or if something else goes wrong, returns a 200 OK otherwise.
         */
        public async BookShipment(params: BookShipmentParams): Promise<BookShipmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.BookShipment`, JSON.stringify(params))
            return await resp.json() as BookShipmentResponse
        }

        public async GetAddonMapping(params: GetAddonMappingParams): Promise<GetAddonMappingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.GetAddonMapping`, JSON.stringify(params))
            return await resp.json() as GetAddonMappingResponse
        }

        /**
         * GetAddonMappings retrieves all addon mappings for all transport methods
         */
        public async GetAddonMappings(params: GetAddonMappingsParams): Promise<GetAddonMappingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.GetAddonMappings`, JSON.stringify(params))
            return await resp.json() as GetAddonMappingsResponse
        }

        /**
         * Endpoint to fetch a booking by its ID.
         * 
         * GetBooking uses the provided bookingID
         * The booking is then fetched from the database and returned.
         * Responds with an error if validation fails or if something else goes wrong, returns a 200 OK with a booking otherwise.
         */
        public async GetBookingByID(params: GetBookingByIDParams): Promise<datamodels.SkrymBooking> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.GetBookingByID`, JSON.stringify(params))
            return await resp.json() as datamodels.SkrymBooking
        }

        /**
         * Endpoint to fetch a booking by its transporter tracking reference
         * 
         * GetBooking uses the provided transporter tracking reference and transporterID.
         * The booking is then fetched using the GetBookingByID endpoint and returned.
         * Responds with an error if validation fails or if something else goes wrong, returns a 200 OK with a booking otherwise.
         */
        public async GetBookingByTrackingReference(params: GetBookingByTrackingReferenceParams): Promise<GetBookingByTrackingReferenceRes> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.GetBookingByTrackingReference`, JSON.stringify(params))
            return await resp.json() as GetBookingByTrackingReferenceRes
        }

        /**
         * GetBookingsPerHour returns the number of orders per hour between the given time range
         */
        public async GetBookingsPerHour(params: GetBookingsPerHourParams): Promise<GetBookingsPerHourResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.GetBookingsPerHour`, JSON.stringify(params))
            return await resp.json() as GetBookingsPerHourResponse
        }

        /**
         * GetConsignorDetails fetches consignor details for the organization
         */
        public async GetConsignorDetails(): Promise<GetConsignorDetailsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.GetConsignorDetails`)
            return await resp.json() as GetConsignorDetailsResponse
        }

        public async GetEnumMapping(params: GetEnumMappingParams): Promise<GetEnumMappingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.GetEnumMapping`, JSON.stringify(params))
            return await resp.json() as GetEnumMappingResponse
        }

        /**
         * GetLabelContentByExternalBookingReference retrieves the label content for a given external booking reference.
         */
        public async GetLabelContentByExternalBookingReference(params: GetLabelContentByExternalBookingReferenceParams): Promise<GetLabelContentByExternalBookingReferenceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.GetLabelContentByExternalBookingReference`, JSON.stringify(params))
            return await resp.json() as GetLabelContentByExternalBookingReferenceResponse
        }

        /**
         * GetLabelsByBookingID retrieves the labels for a given booking ID.
         */
        public async GetLabelsByBookingID(params: GetLabelsForBookingByIDParams): Promise<GetLabelsForBookingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.GetLabelsByBookingID`, JSON.stringify(params))
            return await resp.json() as GetLabelsForBookingResponse
        }

        /**
         * GetLabelsForBookingByReference retrieves the labels for a given booking reference.
         * It returns a slice of FreightObjectLabels, each containing the reference of a freight object and a slice of BookingLabelURLs.
         * If no labels are found for the booking, it returns a NotFound error.
         */
        public async GetLabelsForBookingByReference(params: GetLabelsForBookingByReferenceParams): Promise<GetLabelsForBookingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.GetLabelsForBookingByReference`, JSON.stringify(params))
            return await resp.json() as GetLabelsForBookingResponse
        }

        /**
         * RetryBooking is an API endpoint that takes a booking reference and completes the booking for the failed parcels.
         */
        public async RetryBooking(params: RetryBookingParams): Promise<BookShipmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/booking.RetryBooking`, JSON.stringify(params))
            return await resp.json() as BookShipmentResponse
        }

        /**
         * UpsertConsignorDetails upserts consignor details for the organization
         */
        public async UpsertConsignorDetails(params: UpsertConsignorDetailsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/booking.UpsertConsignorDetails`, JSON.stringify(params))
        }
    }
}

export namespace checkout {
    /**
     * AbortBucketTestParams holds the parameters required for aborting a bucket test.
     * 
     * It contains a single field, TestID, which is the unique identifier of the bucket test to be aborted.
     */
    export interface AbortBucketTestParams {
        /**
         * The UUID of the bucket test to abort
         */
        testId: string
    }

    export interface AddDemoShipmentAndEventsParams {
        orderReference: string
        trackingNumber?: string
    }

    /**
     * BulkUpsertBucketTestStrategiesParams holds the parameters for the bulk upsert operation
     * on bucket test strategies.
     * 
     * Strategies is an array of BucketTestStrategy models representing the test strategies
     * to be created or updated in bulk.
     */
    export interface BulkUpsertBucketTestStrategiesParams {
        /**
         * Array of bucket test strategies
         */
        strategies: checkoutmodels.BucketTestStrategy[]
    }

    /**
     * CheckoutConfigValidationParams defines parameters for validating a checkout configuration.
     */
    export interface CheckoutConfigValidationParams {
        /**
         * CheckoutConfig contains the checkout configuration to be validated.
         */
        checkoutConfig: checkoutmodels.CheckoutNodeConfig
    }

    export interface CheckoutStrategyValidationParams {
        /**
         * The checkout strategy to validate
         */
        checkoutStrategyData: checkoutmodels.CheckoutStrategyData
    }

    /**
     * ConfigInput represents the model for a single Checkout config
     */
    export interface ConfigInput {
        /**
         * Checkout identifies the checkout integrator.
         */
        checkout: checkoutmodels.Checkout

        /**
         * MethodID identifies the method of the stored method config
         */
        methodId: string

        /**
         * CheckoutCode holds the actual transport method code that will be used in the checkout flow.
         */
        checkoutCode?: string

        /**
         * MaxCostThreshold contains the maximum cost (after cost calculation) a transport method can have before it is removed from the list of methods showed in the checkout
         */
        maxCostThreshold?: number

        /**
         * MaxCostThresholdCurrency contains the currency of the max cost threshold
         */
        maxCostThresholdCurrency?: datamodels.Currency

        /**
         * DisplayName contains the name you want to display as the name for the customer
         */
        displayName: string
    }

    export interface ConfirmPaymentParams {
        /**
         * Skrym ID to indicate which order/basket has been payed for
         */
        basketId: string

        /**
         * An optional reference to the order within skrym, the associated session id is used if not provided
         */
        orderId: string
    }

    export interface ConvertDraftCheckoutStrategyAndConfigToReadyParams {
        /**
         * The checkout node configs to upsert
         */
        checkoutNodeConfigs: checkoutmodels.CheckoutNodeConfig[]

        /**
         * The checkout strategy to upsert
         */
        checkoutStrategyData: checkoutmodels.CheckoutStrategyData

        /**
         * The nodes to delete
         */
        nodesDeleted: string[]
    }

    /**
     * DeleteBucketTestParams holds the parameters for deleting a bucket test.
     * 
     * It contains the unique identifier of the bucket test to be deleted.
     */
    export interface DeleteBucketTestParams {
        /**
         * UUID of the bucket test to be deleted
         */
        testId: string
    }

    /**
     * DeleteCheckoutConfigParams defines parameters for deleting a checkout configuration.
     */
    export interface DeleteCheckoutConfigParams {
        /**
         * NodeID specifies the UUID of the node for which the checkout configuration is to be deleted.
         */
        nodeId: string
    }

    export interface DeleteCheckoutPreferenceParams {
        organizationId: string
        apiTag: checkoutmodels.APIGroup
        preferenceParameter: checkoutmodels.Preference
        checkout: checkoutmodels.Checkout
    }

    export interface DeleteCheckoutStrategyParams {
        /**
         * ID of the checkout strategy to delete
         */
        checkoutStrategyId: string
    }

    export interface DeleteDraftCheckoutStrategyParams {
        /**
         * The ID of the checkout strategy to delete
         */
        checkoutStrategyId: string
    }

    /**
     * DeleteOrganizationTransportMethodCheckoutConfigRequest
     * 
     * DeleteOrganizationTransportMethodCheckoutConfigRequest contains the parameters needed for deleting an OrganizationTransportMethodCheckoutConfig.
     */
    export interface DeleteOrganizationTransportMethodCheckoutConfigRequest {
        /**
         * Checkout identifies the checkout integrator.
         */
        checkout: checkoutmodels.Checkout

        /**
         * MethodID identifies the method of the stored method confi
         */
        methodId: string
    }

    export interface EnableCheckoutStrategyParams {
        /**
         * ID of the checkout strategy to enable
         */
        checkoutStrategyId: string
    }

    /**
     * Input parameters to FinalizeShipment
     */
    export interface FinalizeShipmentParams {
        /**
         * The same input as requested in the checkout
         */
        checkoutInput: checkoutmodels.CheckoutInput

        /**
         * This ID given to the order by the checkout provider
         */
        checkoutProviderId: string

        /**
         * Skrym ID of transporter whose delivery method was chosen as the shipping option
         */
        transporterId: string

        /**
         * Skrym ID of transport method that was chosen as the shipping option
         */
        transportMethodId: string

        /**
         * The specific location chosen by the user; applicable for locker and servicepoint deliveries
         */
        chosenLocation: checkoutmodels.AvailableLocationWithTime

        /**
         * Addons to be added to the shipment. NOTE: This is checkout agnostic and should be transformed to skrym addon format before marshalling
         */
        addons: JSONValue

        /**
         * An optional reference to the order within skrym, the associated session id is used if not provided
         */
        orderId: string
    }

    /**
     * GetAllOrganizationTransportMethodCheckoutConfigRequest
     * 
     * GetAllOrganizationTransportMethodCheckoutConfigRequest represents the request parameters for the
     * GetAllOrganizationTransportMethodCheckoutConfig API endpoint.
     */
    export interface GetAllOrganizationTransportMethodCheckoutConfigRequest {
        /**
         * Checkout identifies the checkout integrator.
         */
        checkout: checkoutmodels.Checkout
    }

    /**
     * GetAllOrganizationTransportMethodCheckoutConfigResponse
     * 
     * GetAllOrganizationTransportMethodCheckoutConfigResponse represents the response returned by the
     * GetAllOrganizationTransportMethodCheckoutConfig API endpoint.
     */
    export interface GetAllOrganizationTransportMethodCheckoutConfigResponse {
        /**
         * MethodConfig contains a list of transport method config.
         */
        methodConfig: checkoutmodels.OrganizationTransportMethodCheckoutConfig[]
    }

    /**
     * GetBasketByExternalIDParams represents the parameters required to get a basket by its external ID.
     */
    export interface GetBasketByExternalIDParams {
        /**
         * The external ID of the basket.
         */
        id: string
    }

    /**
     * GetBasketByExternalIDResponse represents the response containing the requested basket.
     */
    export interface GetBasketByExternalIDResponse {
        /**
         * The basket associated with the given external ID.
         */
        basket: checkoutmodels.ReservedBasket
    }

    export interface GetBasketsCountResponse {
        rowCount: number
    }

    export interface GetBasketsParams {
        Page: number
        PageSize: number
    }

    export interface GetBasketsResponse {
        rowCount: number
        baskets: checkoutmodels.ReservedBasket[]
    }

    /**
     * GetBucketTestStrategiesParams holds the parameters required to retrieve bucket test strategies.
     * 
     * It contains the unique identifier (UUID) of the bucket test for which strategies are to be retrieved.
     */
    export interface GetBucketTestStrategiesParams {
        /**
         * UUID of the bucket test
         */
        testId: string
    }

    /**
     * GetBucketTestStrategiesResponse encapsulates the response from retrieving bucket test strategies.
     * 
     * It contains the BucketTest model, including all related test strategies retrieved from the database.
     */
    export interface GetBucketTestStrategiesResponse {
        /**
         * The bucket test with its associated strategies
         */
        bucketTest: checkoutmodels.BucketTest
    }

    /**
     * GetBucketTestsForOrganizationParams holds the parameters for fetching bucket tests for an organization.
     * 
     * It includes the organization's UUID, pagination parameters like PageSize and Page,
     * and optional filters and sorting criteria for the bucket tests.
     */
    export interface GetBucketTestsForOrganizationParams {
        /**
         * UUID of the organization
         */
        organizationId: string

        /**
         * Number of items per page, defaults to 10 if not provided
         */
        pageSize: number

        /**
         * Page number for pagination
         */
        page: number

        /**
         * Optional filters for querying bucket tests
         */
        filter?: checkoutmodels.BucketTestFilter

        /**
         * Optional sorting criteria for the results
         */
        sort?: checkoutmodels.BucketTestSort[]
    }

    /**
     * GetBucketTestsForOrganizationResponse encapsulates the response from fetching bucket tests for an organization.
     * 
     * It includes the total row count of matching bucket tests and a slice of the bucket tests that match the query parameters.
     */
    export interface GetBucketTestsForOrganizationResponse {
        /**
         * Total count of matching bucket tests
         */
        rowCount: number

        /**
         * Slice of bucket tests matching the query
         */
        bucketTests: checkoutmodels.BucketTest[]
    }

    /**
     * GetCheckoutAddonsParams defines the input parameters for retrieving checkout addons.
     * 
     * This struct holds any filterable fields you might need for filtering checkout addons.
     */
    export interface GetCheckoutAddonsParams {
        /**
         * IDs filters the addons by a list of UUIDs.
         */
        ids: string[]

        /**
         * DataTypes filters the addons by data type.
         */
        dataTypes: checkoutmodels.CheckoutAddonDataType[]

        /**
         * Only fetch active addons
         */
        activeOnly: boolean
    }

    /**
     * GetCheckoutAddonsResponse encapsulates the addons returned by the endpoint.
     */
    export interface GetCheckoutAddonsResponse {
        /**
         * CheckoutAddons holds the filtered addons.
         */
        checkoutAddons: checkoutmodels.CheckoutAddon[]
    }

    /**
     * GetCheckoutConfigParams defines parameters for fetching a checkout configuration by node ID.
     */
    export interface GetCheckoutConfigParams {
        /**
         * NodeId specifies the UUID of the node for which to fetch the checkout configuration.
         */
        nodeId: string
    }

    /**
     * GetCheckoutConfigResponse encapsulates the checkout configurations for a node in the response.
     */
    export interface GetCheckoutConfigResponse {
        /**
         * CheckoutNodeConfig holds the checkout configurations for the specified node.
         */
        checkoutNodeConfig: checkoutmodels.CheckoutNodeConfig[]
    }

    export interface GetCheckoutConversionRateParams {
        from?: string
        to?: string
        bucketTestId?: string
        strategyId?: string
        nodeFilter?: string[]
    }

    export interface GetCheckoutConversionRateResponse {
        totalCheckoutCount: number
        confirmedCheckoutCount: number
    }

    export interface GetCheckoutPreferencesParams {
        organizationId: string
        apiTag: checkoutmodels.APIGroup
    }

    export interface GetCheckoutPreferencesResp {
        organizationId: string
        apiTag: checkoutmodels.APIGroup
        checkouts: { [key: checkoutmodels.Checkout]: { [key: checkoutmodels.Preference]: string } }
    }

    export interface GetCheckoutStatisticsParams {
        from?: string
        to?: string
        bucketTestId?: string
        strategyId?: string
        nodeFilter?: string[]
        currency: datamodels.Currency
    }

    export interface GetCheckoutStatisticsPerTransportMethodParams {
        from?: string
        to?: string
        bucketTestId?: string
        strategyId?: string
        nodeFilter?: string[]
        currency: datamodels.Currency
    }

    export interface GetCheckoutStatisticsPerTransportMethodResponse {
        transportMethodStatistics: repository.TransportMethodAverageStatistics[]
    }

    export interface GetCheckoutStatisticsResponse {
        sampleSize: number
        averageOrderValue: number
        averageEstimatedCost: number
        averageDisplayPrice: number
        averageProfitLoss: number
    }

    export interface GetCheckoutStrategiesForRetailerResponse {
        /**
         * The non-draft checkout strategies for the retailer
         */
        checkoutStrategies: checkoutmodels.CheckoutStrategyData[]
    }

    export interface GetCheckoutStrategyAndCheckoutConfigParams {
        /**
         * ID of the checkout strategy to get
         */
        checkoutStrategyId: string
    }

    export interface GetCheckoutStrategyAndCheckoutConfigResponse {
        /**
         * The checkout node configs
         */
        checkoutNodeConfigs: checkoutmodels.CheckoutNodeConfig[]

        /**
         * The checkout strategy
         */
        checkoutStrategyData: checkoutmodels.CheckoutStrategyData
    }

    export interface GetCheckoutStrategyParams {
        /**
         * ID of the checkout strategy to get
         */
        checkoutStrategyId: string
    }

    export interface GetCheckoutStrategyResponse {
        /**
         * The checkout strategy
         */
        checkoutStrategy: JSONValue
    }

    export interface GetCheckoutTacticParams {
        /**
         * CheckoutData contains the data needed to rank the checkout strategies, obtained from the checkout.
         */
        checkoutData: checkoutmodels.CheckoutData

        /**
         * ID of the strategy to use, if not the enabled one
         */
        overridingStrategyId: string

        /**
         * The exchange rates for the currencies
         */
        currencyExchangeRates: { [key: datamodels.Currency]: number }
    }

    export interface GetCheckoutTacticResponse {
        /**
         * ID of the checkout strategy used
         */
        checkoutStrategyId: string

        /**
         * The path of nodes that were traversed
         */
        nodePath: string[]

        /**
         * The checkout tactic, containing the "blueprint" of how to rank the transport methods
         */
        checkoutTactic: string
    }

    export interface GetCheckoutTransportMethodUsageParams {
        /**
         * The start of the period
         */
        from: string

        /**
         * The end of the period
         */
        to: string
    }

    export interface GetCheckoutTransportMethodUsageResponse {
        transportMethodUsage: { [key: string]: number }
    }

    export interface GetConsignorDetailsParams {
        transporterId: string
    }

    export interface GetConsignorDetailsResponse {
        consignorDetails: checkoutmodels.ConsignorDetails[]
    }

    export interface GetDisplayConfigForKlarnaParams {
        nodes: string[]
    }

    export interface GetDisplayConfigForKlarnaResponse {
        displayConfig: { [key: string]: checkoutmodels.KlarnaShippingDisplayConfig }
    }

    export interface GetDraftAndValidatedCheckoutStrategiesForRetailerResponse {
        /**
         * List of all checkout strategies for a retailer, i.e. both draft and validated.
         */
        checkoutStrategies: checkoutmodels.CheckoutStrategyDataWithDraft[]
    }

    /**
     * GetDraftCheckoutConfigResponse encapsulates the draft checkout configuration for a node.
     */
    export interface GetDraftCheckoutConfigResponse {
        /**
         * DraftCheckoutNodeConfig holds the draft checkout configuration for the specified node.
         */
        checkoutNodeConfig: checkoutmodels.CheckoutNodeConfig[]
    }

    export interface GetDraftCheckoutStrategiesForRetailerResponse {
        /**
         * The checkout strategies
         */
        checkoutStrategies: checkoutmodels.CheckoutStrategyData[]
    }

    export interface GetDraftCheckoutStrategyAndCheckoutConfigParams {
        /**
         * The ID of the checkout strategy
         */
        checkoutStrategyId: string
    }

    export interface GetDraftCheckoutStrategyAndCheckoutConfigResponse {
        /**
         * The checkout strategy
         */
        checkoutStrategyData: checkoutmodels.CheckoutStrategyData

        /**
         * The checkout node configs
         */
        checkoutNodeConfigs: checkoutmodels.CheckoutNodeConfig[]
    }

    export interface GetDraftCheckoutStrategyParams {
        /**
         * The ID of the checkout strategy
         */
        checkoutStrategyId: string
    }

    export interface GetDraftCheckoutStrategyResponse {
        /**
         * The checkout strategy
         */
        checkoutStrategy: JSONValue
    }

    export interface GetEnabledCheckoutStrategyResponse {
        /**
         * The enabled checkout strategy
         */
        checkoutStrategy: JSONValue
    }

    export interface GetHolidaysRequest {
        "country_code": string
        region: string
        "from_date": string
        "to_date": string
    }

    export interface GetHolidaysResponse {
        holidays: datamodels.Holiday[]
    }

    export interface GetHourlyCheckoutConversionForAllOrgsParams {
        /**
         * The start of the period
         */
        from: string

        /**
         * The end of the period
         */
        to: string
    }

    export interface GetHourlyCheckoutConversionForAllOrgsResponse {
        conversionRates: checkoutmodels.CheckoutConversionStatistic[]
    }

    export interface GetHourlyCheckoutConversionRatesParams {
        /**
         * The start of the period
         */
        from: string

        /**
         * The end of the period
         */
        to: string
    }

    export interface GetHourlyCheckoutConversionRatesResponse {
        conversionRates: checkoutmodels.CheckoutConversionStatistic[]
    }

    export interface GetHourlyCheckoutStatisticsParams {
        /**
         * The start of the period
         */
        from: string

        /**
         * The end of the period
         */
        to: string

        /**
         * Optional: The transport method ID
         */
        transportMethodId?: string

        /**
         * Optional: The bucket test ID
         */
        bucketTestId?: string

        /**
         * Optional: The strategy ID
         */
        strategyId?: string

        /**
         * The currency in which the fetched cost statistics should be
         */
        currency: datamodels.Currency
    }

    export interface GetHourlyCheckoutStatisticsResponse {
        averageValues: checkoutmodels.AverageCheckoutStatisticsDataPoint[]
    }

    /**
     * GetKlarnaToSkrymAddonMapResponse represents the response structure for mapping Klarna addons to Skrym addons.
     * It contains mappings for both transporter addons and warehouse addons.
     */
    export interface GetKlarnaToSkrymAddonMapResponse {
        transporterAddons: { [key: checkoutmodels.KlarnaAddonType]: datamodels.SkrymAddon }
        warehouseAddons: { [key: checkoutmodels.KlarnaAddonType]: datamodels.SkrymAddon }
    }

    /**
     * GetOrderInfoByBasketParams represents the parameters required to get the order ID associated with a basket.
     */
    export interface GetOrderInfoByBasketParams {
        basketId: string
    }

    /**
     * GetOrderInfoByBasketResponse represents the response containing the order ID associated with the given basket.
     */
    export interface GetOrderInfoByBasketResponse {
        orderId: string
    }

    /**
     * GetOrganizationTransportMethodCheckoutConfigRequest
     * 
     * GetOrganizationTransportMethodCheckoutConfigRequest represents the request parameters for the
     * GetOrganizationTransportMethodCheckoutConfig API endpoint.
     */
    export interface GetOrganizationTransportMethodCheckoutConfigRequest {
        /**
         * Checkout identifies the checkout integrator.
         */
        checkout: checkoutmodels.Checkout

        /**
         * MethodID identifies the method of the stored method config
         */
        methodId: string
    }

    /**
     * GetOrganizationTransportMethodCheckoutConfigResponse
     * 
     * GetOrganizationTransportMethodCheckoutConfigResponse represents the response returned by the
     * GetOrganizationTransportMethodCheckoutConfig API endpoint.
     */
    export interface GetOrganizationTransportMethodCheckoutConfigResponse {
        /**
         * The actual transport method config that is to be used in the checkout flow.
         */
        methodConfig: checkoutmodels.OrganizationTransportMethodCheckoutConfig
    }

    export interface GetPossiblePreferencesPerCheckoutResp {
        preferences: { [key: checkoutmodels.Checkout]: { [key: checkoutmodels.Preference]: checkoutmodels.PreferenceValue[] } }
    }

    export interface GetRetailerConsignorInfoResponse {
        consignorInfo: checkoutmodels.RetailerConsignorInfo
    }

    /**
     * GetSelectedCheckoutAddonsParams defines the input parameters for retrieving selected checkout addons.
     */
    export interface GetSelectedCheckoutAddonsParams {
        /**
         * A list of specific IDs to filter by
         */
        ids: string[]

        /**
         * A list of checkout_addon IDs to filter by
         */
        checkoutAddonIds: string[]

        /**
         * A list of basket IDs to filter by
         */
        basketIds: string[]
    }

    /**
     * GetSelectedCheckoutAddonsResponse holds the selected checkout addons returned by the endpoint.
     */
    export interface GetSelectedCheckoutAddonsResponse {
        selectedAddons: checkoutmodels.SelectedCheckoutAddon[]
    }

    export interface GetShippingOptionsResponse {
        "shipping_options": checkoutmodels.KlarnaShippingOptionRes[]
    }

    export interface GetSkrymShippingOptionsParams {
        /**
         * Agnostic ID to control which checkout is being "handled"
         */
        sessionId: string

        /**
         * Location of where the order is being shipped from
         */
        from: datamodels.Location

        /**
         * Location of where the order is being shipped to
         */
        to: datamodels.Location

        /**
         * Information about the receiver of the order
         */
        receiver: checkoutmodels.Receiver

        /**
         * Order Reference (if exists)
         */
        referenceId: string

        /**
         * What does this order contain?
         */
        products: SkrymGetShippingOptionsCheckoutProduct[]

        /**
         * Package information (if available)
         */
        packages: checkoutmodels.CheckoutPackage[]

        /**
         * ISO 4217 (SEK / USD / EUR)
         */
        currency: datamodels.Currency

        /**
         * Total price of the order (in the smallest denomination of the currency, e.g. cents for EUR and öre for SEK)
         */
        totalPrice: number

        /**
         * Custom parameters to be used in the checkout. This should also handle the Klarna "tags"
         */
        customParams: { [key: string]: JSONValue }

        /**
         * Optional mock configuration for testing. If set to nil, no mocking will be performed. If not nil, the options in it will be used.
         */
        mockConfig?: checkoutmodels.MockCheckoutConfig
    }

    export interface GetSkrymShippingOptionsResponse {
        /**
         * Agnostic ID to control which checkout is being "handled"
         */
        sessionId: string

        /**
         * List of transport methods available for the checkout
         */
        transportMethods: GetSkrymShippingOptionsTransportMethod[]

        /**
         * ID of the ranking strategy node that was applied
         */
        rankingLeafNode: string

        /**
         * Packaging emissions associated with this order
         */
        packagingEmissions: models.PackageEmissionsForOrder

        /**
         * Signals if the response uses preview data. This happens when we don't get a full location to base the shipping options on
         */
        preview: boolean
    }

    export interface GetSkrymShippingOptionsTransportMethod {
        /**
         * Skrym ID of transporter
         */
        transporterId: string

        /**
         * Skrym ID of transport method
         */
        transportMethodId: string

        /**
         * Name of transporter
         */
        transporter: string

        /**
         * Name of transport method
         */
        transportMethod: string

        /**
         * Configurable checkout code of the transport method
         */
        methodCode: string

        /**
         * Type of delivery
         */
        deliveryType: models.DeliveryType

        /**
         * List of locations for the transporter, e.g. pickup point
         */
        availableLocations: checkoutmodels.AvailableLocationWithTime[]

        /**
         * Price of delivering with transport method that is displayed to the customer (in the smallest denomination of the currency, e.g. cents for EUR and öre for SEK)
         */
        priceForCustomer: number

        /**
         * Cost of delivering with transport method for the retailer (in the smallest denomination of the currency, e.g. cents for EUR and öre for SEK)
         */
        costForRetailer: number

        /**
         * Emissions information of delivering with transport method
         */
        emissions: models.EmissionsForTransportMethod

        /**
         * Delivery time object
         */
        deliveryTime: datamodels.SkrymTime

        /**
         * Signifies if the method is breaking the existing transport agreement
         */
        breaking: boolean

        /**
         * Signals if the method should be displayed as an option or not
         */
        display: boolean

        /**
         * Configuration for the checkout node
         */
        nodeConfig: checkoutmodels.SkrymCheckoutConfigForTransportMethod

        /**
         * Optional label for the method (not guaranteed to be unique)
         */
        methodId?: string
    }

    /**
     * GetSupportedCurrenciesResponse is the response struct for the GetSupportedCurrencies function.
     * It contains a list of all supported currencies.
     */
    export interface GetSupportedCurrenciesResponse {
        /**
         * list of ISO 4217 (SEK / EUR / USD) currency codes
         */
        currencies: datamodels.Currency[]
    }

    export interface GetTransportMethodByCodeParams {
        methodCode: string
    }

    export interface GetTransportMethodByIDParams {
        methodId: string
    }

    export interface GetTransportMethodResponse {
        methodId: string
        transporterId: string
        code: string
        metadata: string
    }

    export interface InsertConsignorDetailsParams {
        id: string
        transporterId: string
        customerNumber: string
    }

    export interface InsertRetailerConsignorInfoParams {
        consignorInfo: checkoutmodels.RetailerConsignorInfo
    }

    export interface InsertTransportMethodDataParams {
        methodId: string
        transporterId: string
        code: string
        metadata: string
    }

    export interface KlarnaGetShippingOptionsParams {
        "session_id": string
        locale: string
        currency: datamodels.Currency
        geoblocking: boolean
        recipient: checkoutmodels.KlarnaRecipient
        order: checkoutmodels.KlarnaOrder
        sender: checkoutmodels.KlarnaSender
    }

    export interface MockKlarnaGetShippingOptionsParams {
        "session_id": string
        locale: string
        currency: datamodels.Currency
        geoblocking: boolean
        recipient: checkoutmodels.KlarnaRecipient
        order: checkoutmodels.KlarnaOrder
        sender: checkoutmodels.KlarnaSender
        strategyId: string
        when: string
        mock: boolean
    }

    export interface MockKlarnaGetShippingOptionsResponse {
        "shipping_options": checkoutmodels.KlarnaShippingOptionRes[]
        nodePath: string[]
    }

    /**
     * Input parameters to ReserveDeliveryChoice
     */
    export interface ReserveDeliveryChoiceParams {
        /**
         * The same input as requested in the checkout
         */
        checkoutInput: checkoutmodels.CheckoutInput

        /**
         * This ID given to the order by the checkout provider
         */
        checkoutProviderId: string

        /**
         * Skrym ID of transporter whose delivery method was chosen as the shipping option
         */
        transporterId: string

        /**
         * Skrym ID of transport method that was chosen as the shipping option
         */
        transportMethodId: string

        /**
         * The specific location chosen by the user; applicable for locker and servicepoint deliveries
         */
        chosenLocation: checkoutmodels.AvailableLocationWithTime

        /**
         * Addons to be added to the shipment. NOTE: This is checkout agnostic and should be transformed to skrym addon format before marshalling
         */
        addons: JSONValue
    }

    export interface ReserveDeliveryChoiceResponse {
        /**
         * Skrym ID for representing the basket / order (will be needed for calling confirm payment)
         */
        basketId: string
    }

    /**
     * ScheduleBucketTestParams holds the parameters necessary for scheduling or unscheduling a bucket test.
     * 
     * It contains the unique identifier of the bucket test to be scheduled or unscheduled.
     */
    export interface ScheduleBucketTestParams {
        /**
         * UUID of the bucket test to schedule
         */
        testId: string
    }

    export interface SetCheckoutPreferencesParams {
        organizationId: string
        apiTag: checkoutmodels.APIGroup
        checkouts: { [key: checkoutmodels.Checkout]: { [key: checkoutmodels.Preference]: string } }
    }

    export interface SkrymGetShippingOptionsCheckoutProduct {
        /**
         * external id
         */
        referenceId: string

        /**
         * Type of the product
         */
        productType: checkoutmodels.CheckoutProductType

        /**
         * Quantity of the product
         */
        quantity: number

        /**
         * Price of the product (in the lowest denomination of the currency, e.g. cents for EUR and öre for SEK)
         */
        unitPrice: number

        /**
         * Name of the product. Empty string indicates no name
         */
        name: string

        /**
         * Weight of the product. 0 will be treated as not entered
         */
        weight: number

        /**
         * Dimensions of the product
         */
        dimensions: number[]
    }

    /**
     * UpsertBucketTestParams holds the parameters for the UpsertBucketTest operation.
     * 
     * It includes a BucketTest model that represents the bucket test to be created or updated.
     */
    export interface UpsertBucketTestParams {
        /**
         * The bucket test data to upsert
         */
        bucketTest: checkoutmodels.BucketTest
    }

    /**
     * UpsertCheckoutAddonParams holds the JSON payload to upsert a checkout_addon record.
     */
    export interface UpsertCheckoutAddonParams {
        /**
         * If empty, a new UUID will be generated
         */
        id: string

        /**
         * Unique key
         */
        key: string

        /**
         * Title of the addon
         */
        title: { [key: iso.IsoLanguage]: string }

        /**
         * Data type of the addon
         */
        dataType: checkoutmodels.CheckoutAddonDataType

        /**
         * Specifies which Icon to display
         */
        icon: string

        /**
         * Specifies color for displaying the addon
         */
        color: string

        active: boolean
    }

    /**
     * UpsertCheckoutAddonResponse returns the newly upserted checkout_addon record.
     */
    export interface UpsertCheckoutAddonResponse {
        checkoutAddon: checkoutmodels.CheckoutAddon
    }

    /**
     * UpsertCheckoutConfigParams defines parameters for upserting a checkout configuration.
     */
    export interface UpsertCheckoutConfigParams {
        /**
         * NodeId specifies the UUID of the node for which to upsert the checkout configuration.
         */
        nodeId: string

        /**
         * Checkout indicates the checkout provider for which the configuration is applied.
         */
        checkout: checkoutmodels.Checkout

        /**
         * Config contains the JSON-encoded checkout configuration data.
         */
        config: JSONValue

        /**
         * Enabled indicates whether the checkout configuration is active.
         */
        enabled: boolean

        /**
         * UpdatedBy specifies the UUID of the user performing the upsert operation.
         */
        updatedBy: string

        /**
         * StrategyID specifies the UUID of the strategy to which the checkout configuration is linked.
         */
        strategyId: string
    }

    export interface UpsertCheckoutStrategyAndCheckoutConfigParams {
        /**
         * The checkout strategy to upsert
         */
        checkoutStrategyData: checkoutmodels.CheckoutStrategyData

        /**
         * The checkout node configs to upsert
         */
        checkoutNodeConfigs: checkoutmodels.CheckoutNodeConfig[]

        /**
         * The nodes to delete
         */
        nodesDeleted: string[]
    }

    export interface UpsertCheckoutStrategyFromDraftParams {
        /**
         * ID of the checkout strategy to upsert
         */
        checkoutStrategyId: string

        /**
         * The user who created the strategy
         */
        createdBy?: string

        /**
         * The user who last changed the strategy
         */
        lastChangeBy: string
    }

    export interface UpsertCheckoutStrategyParams {
        /**
         * ID of the checkout strategy to upsert
         */
        checkoutStrategyId: string

        /**
         * The checkout strategy stored as JSON
         */
        checkoutStrategy: JSONValue

        /**
         * The name of the checkout strategy
         */
        name: string

        /**
         * The user who created the strategy
         */
        createdBy: string

        /**
         * The user who last changed the strategy
         */
        lastChangeBy: string

        /**
         * Whether the strategy is enabled
         */
        enabled: boolean
    }

    /**
     * UpsertDraftCheckoutConfigParams defines parameters for upserting a draft checkout configuration.
     */
    export interface UpsertDraftCheckoutConfigParams {
        /**
         * NodeId specifies the UUID of the node for which to upsert the draft checkout configuration.
         */
        nodeId: string

        /**
         * Checkout indicates the checkout provider for which the draft configuration is applied.
         */
        checkout: checkoutmodels.Checkout

        /**
         * Config contains the JSON-encoded draft checkout configuration data.
         */
        config: JSONValue

        /**
         * UpdatedBy specifies the UUID of the user performing the upsert operation.
         */
        updatedBy: string
    }

    export interface UpsertDraftCheckoutStrategyAndCheckoutParams {
        /**
         * The checkout node configs
         */
        checkoutNodeConfigs: checkoutmodels.CheckoutNodeConfig[]

        /**
         * The checkout strategy data
         */
        checkoutStrategyData: checkoutmodels.CheckoutStrategyData

        /**
         * The nodes to delete
         */
        nodesDeleted: string[]
    }

    export interface UpsertDraftCheckoutStrategyParams {
        /**
         * The ID of the checkout strategy
         */
        checkoutStrategyId: string

        /**
         * The name of the checkout strategy
         */
        name: string

        /**
         * The ID of the user who created the strategy
         */
        createdBy: string

        /**
         * The ID of the user who last changed the strategy
         */
        lastChangeBy: string

        /**
         * The checkout strategy to upsert
         */
        checkoutStrategy: JSONValue
    }

    export interface UpsertDraftFromCheckoutStrategyParams {
        /**
         * The ID of the checkout strategy to make a draft copy of
         */
        checkoutStrategyId: string

        /**
         * The ID of the user who created the draft
         */
        createdBy: string
    }

    export interface UpsertDraftFromCheckoutStrategyResponse {
        /**
         * The ID of the new draft checkout strategy
         */
        checkoutStrategyID: string
    }

    /**
     * UpsertOrganizationTransportMethodCheckoutConfigRequest represents the request parameters for upserting transport method codes.
     */
    export interface UpsertOrganizationTransportMethodCheckoutConfigRequest {
        /**
         * MethodConfig contains the list of transport method config to upsert.
         */
        MethodConfig: ConfigInput[]
    }

    /**
     * UpsertSelectedCheckoutAddonParams defines the payload for performing an insert-or-update
     * on a selected_checkout_addon record.
     */
    export interface UpsertSelectedCheckoutAddonParams {
        addons: checkoutmodels.SelectedCheckoutAddon[]
    }

    /**
     * UpsertSelectedCheckoutAddonResponse is the returned data after upserting a selected_checkout_addon.
     */
    export interface UpsertSelectedCheckoutAddonResponse {
        selectedCheckoutAddon: checkoutmodels.SelectedCheckoutAddon[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AbortBucketTest = this.AbortBucketTest.bind(this)
            this.AddDemoShipmentsAndEventsToCheckoutOrder = this.AddDemoShipmentsAndEventsToCheckoutOrder.bind(this)
            this.BulkUpsertBucketTestStrategies = this.BulkUpsertBucketTestStrategies.bind(this)
            this.CheckoutConfigValidation = this.CheckoutConfigValidation.bind(this)
            this.CheckoutStrategyValidation = this.CheckoutStrategyValidation.bind(this)
            this.ConfirmPayment = this.ConfirmPayment.bind(this)
            this.ConfirmShipment = this.ConfirmShipment.bind(this)
            this.ConvertDraftCheckoutStrategyAndConfigToReady = this.ConvertDraftCheckoutStrategyAndConfigToReady.bind(this)
            this.CreateShipment = this.CreateShipment.bind(this)
            this.DeleteBucketTest = this.DeleteBucketTest.bind(this)
            this.DeleteCheckoutConfig = this.DeleteCheckoutConfig.bind(this)
            this.DeleteCheckoutPreference = this.DeleteCheckoutPreference.bind(this)
            this.DeleteCheckoutStrategy = this.DeleteCheckoutStrategy.bind(this)
            this.DeleteDraftCheckoutConfig = this.DeleteDraftCheckoutConfig.bind(this)
            this.DeleteDraftCheckoutStrategy = this.DeleteDraftCheckoutStrategy.bind(this)
            this.DeleteOrganizationTransportMethodCheckoutConfig = this.DeleteOrganizationTransportMethodCheckoutConfig.bind(this)
            this.DeleteUnsupportedKlarnaAddonsForNodeConfigs = this.DeleteUnsupportedKlarnaAddonsForNodeConfigs.bind(this)
            this.EnableCheckoutStrategy = this.EnableCheckoutStrategy.bind(this)
            this.FinalizeShipment = this.FinalizeShipment.bind(this)
            this.GetAllOrganizationTransportMethodCheckoutConfig = this.GetAllOrganizationTransportMethodCheckoutConfig.bind(this)
            this.GetBasket = this.GetBasket.bind(this)
            this.GetBasketByExternalID = this.GetBasketByExternalID.bind(this)
            this.GetBaskets = this.GetBaskets.bind(this)
            this.GetBasketsCount = this.GetBasketsCount.bind(this)
            this.GetBucketTestStrategies = this.GetBucketTestStrategies.bind(this)
            this.GetBucketTestsForOrganization = this.GetBucketTestsForOrganization.bind(this)
            this.GetCheckoutAddonsForOrganization = this.GetCheckoutAddonsForOrganization.bind(this)
            this.GetCheckoutConfigForRetailerAndNode = this.GetCheckoutConfigForRetailerAndNode.bind(this)
            this.GetCheckoutConversionRate = this.GetCheckoutConversionRate.bind(this)
            this.GetCheckoutPreferences = this.GetCheckoutPreferences.bind(this)
            this.GetCheckoutStatistics = this.GetCheckoutStatistics.bind(this)
            this.GetCheckoutStatisticsPerTransportMethod = this.GetCheckoutStatisticsPerTransportMethod.bind(this)
            this.GetCheckoutStrategiesForRetailer = this.GetCheckoutStrategiesForRetailer.bind(this)
            this.GetCheckoutStrategyAndCheckoutConfig = this.GetCheckoutStrategyAndCheckoutConfig.bind(this)
            this.GetCheckoutStrategyForRetailer = this.GetCheckoutStrategyForRetailer.bind(this)
            this.GetCheckoutTactic = this.GetCheckoutTactic.bind(this)
            this.GetCheckoutTransportMethodUsage = this.GetCheckoutTransportMethodUsage.bind(this)
            this.GetConsignorDetails = this.GetConsignorDetails.bind(this)
            this.GetDisplayConfigForKlarna = this.GetDisplayConfigForKlarna.bind(this)
            this.GetDraftAndValidatedCheckoutStrategiesForRetailer = this.GetDraftAndValidatedCheckoutStrategiesForRetailer.bind(this)
            this.GetDraftCheckoutConfig = this.GetDraftCheckoutConfig.bind(this)
            this.GetDraftCheckoutStrategiesForRetailer = this.GetDraftCheckoutStrategiesForRetailer.bind(this)
            this.GetDraftCheckoutStrategy = this.GetDraftCheckoutStrategy.bind(this)
            this.GetDraftCheckoutStrategyAndCheckoutConfig = this.GetDraftCheckoutStrategyAndCheckoutConfig.bind(this)
            this.GetEnabledCheckoutStrategyForRetailer = this.GetEnabledCheckoutStrategyForRetailer.bind(this)
            this.GetHolidaysAPI = this.GetHolidaysAPI.bind(this)
            this.GetHourlyCheckoutConversionForAllOrgs = this.GetHourlyCheckoutConversionForAllOrgs.bind(this)
            this.GetHourlyCheckoutConversionRates = this.GetHourlyCheckoutConversionRates.bind(this)
            this.GetHourlyCheckoutStatistics = this.GetHourlyCheckoutStatistics.bind(this)
            this.GetKlarnaToSkrymAddonMap = this.GetKlarnaToSkrymAddonMap.bind(this)
            this.GetOrderInfoByBasket = this.GetOrderInfoByBasket.bind(this)
            this.GetOrganizationTransportMethodCheckoutConfig = this.GetOrganizationTransportMethodCheckoutConfig.bind(this)
            this.GetPossiblePreferencesPerCheckout = this.GetPossiblePreferencesPerCheckout.bind(this)
            this.GetRetailerConsignorInfo = this.GetRetailerConsignorInfo.bind(this)
            this.GetSelectedCheckoutAddonsForUser = this.GetSelectedCheckoutAddonsForUser.bind(this)
            this.GetShipment = this.GetShipment.bind(this)
            this.GetSkrymShippingOptions = this.GetSkrymShippingOptions.bind(this)
            this.GetSupportedCurrencies = this.GetSupportedCurrencies.bind(this)
            this.GetTransportMethodDatabyCode = this.GetTransportMethodDatabyCode.bind(this)
            this.GetTransportMethodDatabyID = this.GetTransportMethodDatabyID.bind(this)
            this.InsertRetailerConsignorInfo = this.InsertRetailerConsignorInfo.bind(this)
            this.InsertTransportMethodData = this.InsertTransportMethodData.bind(this)
            this.KlarnaClientAuthentication = this.KlarnaClientAuthentication.bind(this)
            this.KlarnaGetShippingOptions = this.KlarnaGetShippingOptions.bind(this)
            this.MockKlarnaGetShippingOptions = this.MockKlarnaGetShippingOptions.bind(this)
            this.ReserveDeliveryChoice = this.ReserveDeliveryChoice.bind(this)
            this.ReserveDeliveryChoiceFromKlarna = this.ReserveDeliveryChoiceFromKlarna.bind(this)
            this.ScheduleBucketTest = this.ScheduleBucketTest.bind(this)
            this.SetCheckoutPreferences = this.SetCheckoutPreferences.bind(this)
            this.UnscheduleBucketTest = this.UnscheduleBucketTest.bind(this)
            this.UpdateShipmentForKlarna = this.UpdateShipmentForKlarna.bind(this)
            this.UpsertBucketTest = this.UpsertBucketTest.bind(this)
            this.UpsertCheckoutAddonForOrganization = this.UpsertCheckoutAddonForOrganization.bind(this)
            this.UpsertCheckoutConfig = this.UpsertCheckoutConfig.bind(this)
            this.UpsertCheckoutStrategy = this.UpsertCheckoutStrategy.bind(this)
            this.UpsertCheckoutStrategyAndCheckoutConfig = this.UpsertCheckoutStrategyAndCheckoutConfig.bind(this)
            this.UpsertCheckoutStrategyFromDraft = this.UpsertCheckoutStrategyFromDraft.bind(this)
            this.UpsertConsignorDetails = this.UpsertConsignorDetails.bind(this)
            this.UpsertDraftCheckoutConfig = this.UpsertDraftCheckoutConfig.bind(this)
            this.UpsertDraftCheckoutStrategy = this.UpsertDraftCheckoutStrategy.bind(this)
            this.UpsertDraftCheckoutStrategyAndCheckoutConfig = this.UpsertDraftCheckoutStrategyAndCheckoutConfig.bind(this)
            this.UpsertDraftFromCheckoutStrategy = this.UpsertDraftFromCheckoutStrategy.bind(this)
            this.UpsertOrganizationTransportMethodCheckoutConfig = this.UpsertOrganizationTransportMethodCheckoutConfig.bind(this)
            this.UpsertSelectedCheckoutAddonForUser = this.UpsertSelectedCheckoutAddonForUser.bind(this)
        }

        /**
         * AbortBucketTest aborts an active bucket test.
         * 
         * The is aborted  only if it's currently active.
         * 
         * This endpoint requires authentication and is intended for use by clients authorized to manage
         * bucket tests within their organization.// encore:api auth
         */
        public async AbortBucketTest(params: AbortBucketTestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.AbortBucketTest`, JSON.stringify(params))
        }

        /**
         * AddDemoEventsToTrackedOrder adds demo events to an order initialized from the checkout
         */
        public async AddDemoShipmentsAndEventsToCheckoutOrder(params: AddDemoShipmentAndEventsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.AddDemoShipmentsAndEventsToCheckoutOrder`, JSON.stringify(params))
        }

        /**
         * BulkUpsertBucketTestStrategies performs a bulk upsert operation on bucket test strategies.
         * 
         * Can be used in scenarios where multiple bucket test strategies need to be
         * added or modified simultaneously, improving efficiency and reducing the number of database
         * calls required for individual upsert operations.
         */
        public async BulkUpsertBucketTestStrategies(params: BulkUpsertBucketTestStrategiesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.BulkUpsertBucketTestStrategies`, JSON.stringify(params))
        }

        /**
         * CheckoutConfigValidation validates a provided checkout configuration against available transport methods for a retailer.
         * 
         * This function currently supports validation only for Klarna configurations. It requires authentication and uses the authenticated user's context to fetch
         * retailer-specific transport methods. The checkout configuration is validated to ensure it meets the necessary criteria for the specified checkout provider.
         * NOTE: currently only supports the check/validation for Klarna config
         */
        public async CheckoutConfigValidation(params: CheckoutConfigValidationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.CheckoutConfigValidation`, JSON.stringify(params))
        }

        /**
         * CheckoutStrategyValidation validates a checkout strategy.
         */
        public async CheckoutStrategyValidation(params: CheckoutStrategyValidationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.CheckoutStrategyValidation`, JSON.stringify(params))
        }

        /**
         * ConfirmPayment updates the status of a created basket to be set as payed for.
         * 
         * Setting the status of a basket to payed for means that Skrym can produce insights into e.g. Conversion rate and preferred transport methods
         */
        public async ConfirmPayment(params: ConfirmPaymentParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.ConfirmPayment`, JSON.stringify(params))
        }

        public async ConfirmShipment(shipmentId: string): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout/shipment/${encodeURIComponent(shipmentId)}/confirm`)
        }

        /**
         * ConvertDraftCheckoutStrategyAndConfigToReady converts a draft checkout strategy and its configs to a ready state. The strategy is first validated and then upserted in "real" table.
         * The checkout node configs are validated and then upserted. The draft strategy and configs are deleted after the upsert.
         */
        public async ConvertDraftCheckoutStrategyAndConfigToReady(params: ConvertDraftCheckoutStrategyAndConfigToReadyParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.ConvertDraftCheckoutStrategyAndConfigToReady`, JSON.stringify(params))
        }

        public async CreateShipment(params: checkoutmodels.KlarnaSelectedShippingOption): Promise<checkoutmodels.KlarnaShipmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout/shipment`, JSON.stringify(params))
            return await resp.json() as checkoutmodels.KlarnaShipmentResponse
        }

        public async DeleteBucketTest(params: DeleteBucketTestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.DeleteBucketTest`, JSON.stringify(params))
        }

        /**
         * DeleteCheckoutConfig removes a checkout configuration for a specific node and retailer.
         */
        public async DeleteCheckoutConfig(params: DeleteCheckoutConfigParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.DeleteCheckoutConfig`, JSON.stringify(params))
        }

        public async DeleteCheckoutPreference(params: DeleteCheckoutPreferenceParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.DeleteCheckoutPreference`, JSON.stringify(params))
        }

        /**
         * DeleteCheckoutStrategy deletes a checkout strategy and all its associated configs, for a retailer. When deleted, an event is published.
         */
        public async DeleteCheckoutStrategy(params: DeleteCheckoutStrategyParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.DeleteCheckoutStrategy`, JSON.stringify(params))
        }

        /**
         * DeleteDraftCheckoutConfig removes a draft checkout configuration for a specific node and retailer.
         */
        public async DeleteDraftCheckoutConfig(params: DeleteCheckoutConfigParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.DeleteDraftCheckoutConfig`, JSON.stringify(params))
        }

        /**
         * DeleteDraftCheckoutStrategy deletes a checkout strategy from the draft table
         */
        public async DeleteDraftCheckoutStrategy(params: DeleteDraftCheckoutStrategyParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.DeleteDraftCheckoutStrategy`, JSON.stringify(params))
        }

        /**
         * Deleter for transport method codes
         * 
         * The function first validates the incoming parameters, fetches the organization ID
         * from the auth data, and then uses it along with the provided request parameters to delete a specific OrganizationTransportMethodCheckoutConfig from the database for the authenticated retailer.
         */
        public async DeleteOrganizationTransportMethodCheckoutConfig(params: DeleteOrganizationTransportMethodCheckoutConfigRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.DeleteOrganizationTransportMethodCheckoutConfig`, JSON.stringify(params))
        }

        /**
         * DeleteUnsupportedKlarnaAddonsForNodeConfigs is a temporary function that deletes all wrongly configured Klarna addons.
         * These addons will now fail validation (on both the frontend and backend) due to stricter rules based on transporter addon mappings
         * To avoid that, this endpoint should first be called to fix strategies that have unsupported addons configured.
         * 
         * This function retrieves all checkout node configurations for a retailer by checkout and ensures that only supported
         * Klarna addons are retained. Unsupported addons are removed from the node configurations.
         */
        public async DeleteUnsupportedKlarnaAddonsForNodeConfigs(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.DeleteUnsupportedKlarnaAddonsForNodeConfigs`)
        }

        /**
         * EnableCheckoutStrategy enables a checkout strategy for a retailer.
         */
        public async EnableCheckoutStrategy(params: EnableCheckoutStrategyParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.EnableCheckoutStrategy`, JSON.stringify(params))
        }

        /**
         * FinalizeShipment creates a Skrym basket and inserts the end-users delivery choice
         * 
         * Finalizing a shipmment tells us that a user has selected their delivery choice and has paid for the order.
         * The information stored related to transport method and delivery choice will be used to provide further insights into which options are the most popular.
         */
        public async FinalizeShipment(params: FinalizeShipmentParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.FinalizeShipment`, JSON.stringify(params))
        }

        /**
         * GetAllOrganizationTransportMethodCheckoutConfig fetches transport method codes based on the provided checkout.
         * 
         * The function first validates the incoming parameters, fetches the organization ID
         * from the auth data, and then uses it along with the checkout to retrieve the
         * relevant transport method codes for the authenticated retailer.
         * Returns a GetAllOrganizationTransportMethodCheckoutConfigResponse containing the fetched transport method codes
         * or an error if the operation fails.
         */
        public async GetAllOrganizationTransportMethodCheckoutConfig(params: GetAllOrganizationTransportMethodCheckoutConfigRequest): Promise<GetAllOrganizationTransportMethodCheckoutConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetAllOrganizationTransportMethodCheckoutConfig`, JSON.stringify(params))
            return await resp.json() as GetAllOrganizationTransportMethodCheckoutConfigResponse
        }

        public async GetBasket(id: string): Promise<checkoutmodels.ReservedBasket> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/checkout/baskets/${encodeURIComponent(id)}`)
            return await resp.json() as checkoutmodels.ReservedBasket
        }

        /**
         * GetBasketByExternalID fetches a basket by its external ID.
         * 
         * This endpoint requires authentication and retrieves a basket based on the provided external ID.
         * It returns the basket information if found or an appropriate error if not.
         * 
         * Possible errors:
         * - NotFound: If the basket with the given external ID does not exist.
         * - Internal: If an internal error occurs while fetching the basket.
         */
        public async GetBasketByExternalID(params: GetBasketByExternalIDParams): Promise<GetBasketByExternalIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetBasketByExternalID`, JSON.stringify(params))
            return await resp.json() as GetBasketByExternalIDResponse
        }

        public async GetBaskets(params: GetBasketsParams): Promise<GetBasketsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                page:     String(params.Page),
                pageSize: String(params.PageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/checkout/baskets`, undefined, {query})
            return await resp.json() as GetBasketsResponse
        }

        public async GetBasketsCount(): Promise<GetBasketsCountResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetBasketsCount`)
            return await resp.json() as GetBasketsCountResponse
        }

        /**
         * GetBucketTestStrategies retrieves the strategies associated with a specific bucket test.
         * 
         * It first retrives the bucket test itself and then retreives the associated strategies in separate queries.
         */
        public async GetBucketTestStrategies(params: GetBucketTestStrategiesParams): Promise<GetBucketTestStrategiesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetBucketTestStrategies`, JSON.stringify(params))
            return await resp.json() as GetBucketTestStrategiesResponse
        }

        /**
         * GetBucketTestsForOrganization retrieves a list of bucket tests for a specific organization based on provided parameters.
         * 
         * This function checks for required permissions, applies default values for pagination if not specified,
         * and queries the database for bucket tests matching the provided filters and sorting criteria.
         * It returns a structured response with the total count and the matching bucket tests.
         * 
         * This function requires authentication and appropriate permissions to access the specified organization's bucket tests.
         */
        public async GetBucketTestsForOrganization(params: GetBucketTestsForOrganizationParams): Promise<GetBucketTestsForOrganizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetBucketTestsForOrganization`, JSON.stringify(params))
            return await resp.json() as GetBucketTestsForOrganizationResponse
        }

        /**
         * GetCheckoutAddonsForOrganization retrieves checkout addons based on filter criteria.
         * 
         * This endpoint requires authentication. It uses the authenticated caller's organization ID to fetch the relevant checkout addons.
         */
        public async GetCheckoutAddonsForOrganization(params: GetCheckoutAddonsParams): Promise<GetCheckoutAddonsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutAddonsForOrganization`, JSON.stringify(params))
            return await resp.json() as GetCheckoutAddonsResponse
        }

        /**
         * GetCheckoutConfigForRetailerAndNode retrieves the checkout configuration for a specified node and retailer.
         * 
         * This endpoint requires authentication and utilizes the authenticated user's retailer ID to fetch the node-specific checkout configuration.
         * It returns the checkout configuration wrapped in a GetCheckoutConfigResponse or an error if the configuration cannot be retrieved.
         */
        public async GetCheckoutConfigForRetailerAndNode(params: GetCheckoutConfigParams): Promise<GetCheckoutConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutConfigForRetailerAndNode`, JSON.stringify(params))
            return await resp.json() as GetCheckoutConfigResponse
        }

        /**
         * Fetch conversion rate for the given parameters
         * 
         * This gets the conversion rate for the given parameters. If any of the optional filters are omited, all data will be included.
         */
        public async GetCheckoutConversionRate(params: GetCheckoutConversionRateParams): Promise<GetCheckoutConversionRateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutConversionRate`, JSON.stringify(params))
            return await resp.json() as GetCheckoutConversionRateResponse
        }

        public async GetCheckoutPreferences(params: GetCheckoutPreferencesParams): Promise<GetCheckoutPreferencesResp> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutPreferences`, JSON.stringify(params))
            return await resp.json() as GetCheckoutPreferencesResp
        }

        /**
         * Fetch aggregate average statistics for the given parameters
         * 
         * This gets the aggregate average statistics for the given parameters. If any of the optional filters are omited, all data will be included.
         */
        public async GetCheckoutStatistics(params: GetCheckoutStatisticsParams): Promise<GetCheckoutStatisticsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutStatistics`, JSON.stringify(params))
            return await resp.json() as GetCheckoutStatisticsResponse
        }

        /**
         * Fetch aggregate average statistics for the given parameters, grouped by used transport method
         * 
         * This gets the aggregate average statistics for the given parameters. If any of the optional filters are omited, all data will be included.
         */
        public async GetCheckoutStatisticsPerTransportMethod(params: GetCheckoutStatisticsPerTransportMethodParams): Promise<GetCheckoutStatisticsPerTransportMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutStatisticsPerTransportMethod`, JSON.stringify(params))
            return await resp.json() as GetCheckoutStatisticsPerTransportMethodResponse
        }

        /**
         * GetCheckoutStrategiesForRetailer returns the checkout strategies for a retailer.
         */
        public async GetCheckoutStrategiesForRetailer(): Promise<GetCheckoutStrategiesForRetailerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutStrategiesForRetailer`)
            return await resp.json() as GetCheckoutStrategiesForRetailerResponse
        }

        /**
         * GetCheckoutStrategyAndCheckoutConfig returns a checkout strategy and its configs for a retailer.
         */
        public async GetCheckoutStrategyAndCheckoutConfig(params: GetCheckoutStrategyAndCheckoutConfigParams): Promise<GetCheckoutStrategyAndCheckoutConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutStrategyAndCheckoutConfig`, JSON.stringify(params))
            return await resp.json() as GetCheckoutStrategyAndCheckoutConfigResponse
        }

        /**
         * GetCheckoutStrategyForRetailer returns a checkout strategy for a retailer.
         */
        public async GetCheckoutStrategyForRetailer(params: GetCheckoutStrategyParams): Promise<GetCheckoutStrategyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutStrategyForRetailer`, JSON.stringify(params))
            return await resp.json() as GetCheckoutStrategyResponse
        }

        /**
         * GetCheckoutTactic returns the checkout tactic for a retailer, used to rank the transport methods before displaying them.
         */
        public async GetCheckoutTactic(params: GetCheckoutTacticParams): Promise<GetCheckoutTacticResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutTactic`, JSON.stringify(params))
            return await resp.json() as GetCheckoutTacticResponse
        }

        /**
         * Fetch transport method selection count in the checkout for a given period
         * 
         * This gets the transport method selection count in the checkout for a given period.
         */
        public async GetCheckoutTransportMethodUsage(params: GetCheckoutTransportMethodUsageParams): Promise<GetCheckoutTransportMethodUsageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetCheckoutTransportMethodUsage`, JSON.stringify(params))
            return await resp.json() as GetCheckoutTransportMethodUsageResponse
        }

        public async GetConsignorDetails(params: GetConsignorDetailsParams): Promise<GetConsignorDetailsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetConsignorDetails`, JSON.stringify(params))
            return await resp.json() as GetConsignorDetailsResponse
        }

        public async GetDisplayConfigForKlarna(params: GetDisplayConfigForKlarnaParams): Promise<GetDisplayConfigForKlarnaResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetDisplayConfigForKlarna`, JSON.stringify(params))
            return await resp.json() as GetDisplayConfigForKlarnaResponse
        }

        /**
         * GetDraftAndValidatedCheckoutStrategiesForRetailer returns the draft and validated checkout strategies for a retailer.
         */
        public async GetDraftAndValidatedCheckoutStrategiesForRetailer(): Promise<GetDraftAndValidatedCheckoutStrategiesForRetailerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetDraftAndValidatedCheckoutStrategiesForRetailer`)
            return await resp.json() as GetDraftAndValidatedCheckoutStrategiesForRetailerResponse
        }

        /**
         * GetDraftCheckoutConfig retrieves the draft checkout configurations for a specified node and retailer.
         * 
         * This endpoint requires authentication and uses the authenticated user's retailer ID to fetch the node-specific draft checkout configuration.
         * It returns the draft checkout configuration wrapped in a GetDraftCheckoutConfigResponse or an error if the configuration cannot be retrieved.
         */
        public async GetDraftCheckoutConfig(params: GetCheckoutConfigParams): Promise<GetDraftCheckoutConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetDraftCheckoutConfig`, JSON.stringify(params))
            return await resp.json() as GetDraftCheckoutConfigResponse
        }

        /**
         * GetDraftCheckoutStrategiesForRetailer gets all checkout strategies from the draft table for a retailer
         */
        public async GetDraftCheckoutStrategiesForRetailer(): Promise<GetDraftCheckoutStrategiesForRetailerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetDraftCheckoutStrategiesForRetailer`)
            return await resp.json() as GetDraftCheckoutStrategiesForRetailerResponse
        }

        /**
         * GetDraftCheckoutStrategy gets a checkout strategy from the draft table
         */
        public async GetDraftCheckoutStrategy(params: GetDraftCheckoutStrategyParams): Promise<GetDraftCheckoutStrategyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetDraftCheckoutStrategy`, JSON.stringify(params))
            return await resp.json() as GetDraftCheckoutStrategyResponse
        }

        /**
         * GetDraftCheckoutStrategyAndCheckoutConfig gets a checkout strategy and its configs from the draft table
         */
        public async GetDraftCheckoutStrategyAndCheckoutConfig(params: GetDraftCheckoutStrategyAndCheckoutConfigParams): Promise<GetDraftCheckoutStrategyAndCheckoutConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetDraftCheckoutStrategyAndCheckoutConfig`, JSON.stringify(params))
            return await resp.json() as GetDraftCheckoutStrategyAndCheckoutConfigResponse
        }

        /**
         * GetEnabledCheckoutStrategyForRetailer returns the enabled checkout strategy for a retailer.
         */
        public async GetEnabledCheckoutStrategyForRetailer(): Promise<GetEnabledCheckoutStrategyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetEnabledCheckoutStrategyForRetailer`)
            return await resp.json() as GetEnabledCheckoutStrategyResponse
        }

        public async GetHolidaysAPI(params: GetHolidaysRequest): Promise<GetHolidaysResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetHolidaysAPI`, JSON.stringify(params))
            return await resp.json() as GetHolidaysResponse
        }

        /**
         * Fetch checkout conversion rates for a given period for all organizations
         * 
         * This gets the checkout conversion rates for a given period, grouped by hour.
         */
        public async GetHourlyCheckoutConversionForAllOrgs(params: GetHourlyCheckoutConversionForAllOrgsParams): Promise<GetHourlyCheckoutConversionForAllOrgsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetHourlyCheckoutConversionForAllOrgs`, JSON.stringify(params))
            return await resp.json() as GetHourlyCheckoutConversionForAllOrgsResponse
        }

        /**
         * Fetch checkout conversion rates for a given period
         * 
         * This gets the checkout conversion rates for a given period, grouped by hour.
         */
        public async GetHourlyCheckoutConversionRates(params: GetHourlyCheckoutConversionRatesParams): Promise<GetHourlyCheckoutConversionRatesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetHourlyCheckoutConversionRates`, JSON.stringify(params))
            return await resp.json() as GetHourlyCheckoutConversionRatesResponse
        }

        /**
         * Fetch average checkout values for a given period
         * 
         * This gets a few different average values for checkouts in a given period, grouped by hour. It also supports filtering by transport method, bucket test and strategy.
         */
        public async GetHourlyCheckoutStatistics(params: GetHourlyCheckoutStatisticsParams): Promise<GetHourlyCheckoutStatisticsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetHourlyCheckoutStatistics`, JSON.stringify(params))
            return await resp.json() as GetHourlyCheckoutStatisticsResponse
        }

        /**
         * GetKlarnaToSkrymAddonMap retrieves the mappings of Klarna addons to Skrym addons for both transporter and warehouse addons.
         * This function requires authentication.
         */
        public async GetKlarnaToSkrymAddonMap(): Promise<GetKlarnaToSkrymAddonMapResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetKlarnaToSkrymAddonMap`)
            return await resp.json() as GetKlarnaToSkrymAddonMapResponse
        }

        /**
         * GetOrderInfoByBasket fetches the order id associated with a basket.
         */
        public async GetOrderInfoByBasket(params: GetOrderInfoByBasketParams): Promise<GetOrderInfoByBasketResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetOrderInfoByBasket`, JSON.stringify(params))
            return await resp.json() as GetOrderInfoByBasketResponse
        }

        /**
         * GetOrganizationTransportMethodCheckoutConfig fetches transport method codes based on the provided checkout.
         * 
         * The function first validates the incoming parameters, fetches the organization ID
         * from the auth data, and then uses it along with the checkout to retrieve the
         * relevant transport method config for the authenticated retailer.
         * Returns a GetOrganizationTransportMethodCheckoutConfigResponse containing the fetched transport method config
         * or an error if the operation fails
         */
        public async GetOrganizationTransportMethodCheckoutConfig(params: GetOrganizationTransportMethodCheckoutConfigRequest): Promise<GetOrganizationTransportMethodCheckoutConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetOrganizationTransportMethodCheckoutConfig`, JSON.stringify(params))
            return await resp.json() as GetOrganizationTransportMethodCheckoutConfigResponse
        }

        public async GetPossiblePreferencesPerCheckout(): Promise<GetPossiblePreferencesPerCheckoutResp> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetPossiblePreferencesPerCheckout`)
            return await resp.json() as GetPossiblePreferencesPerCheckoutResp
        }

        public async GetRetailerConsignorInfo(): Promise<GetRetailerConsignorInfoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetRetailerConsignorInfo`)
            return await resp.json() as GetRetailerConsignorInfoResponse
        }

        /**
         * GetSelectedCheckoutAddonsForUser retrieves selected checkout addons based on the provided filters.
         * 
         * This endpoint requires authentication.
         */
        public async GetSelectedCheckoutAddonsForUser(params: GetSelectedCheckoutAddonsParams): Promise<GetSelectedCheckoutAddonsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetSelectedCheckoutAddonsForUser`, JSON.stringify(params))
            return await resp.json() as GetSelectedCheckoutAddonsResponse
        }

        public async GetShipment(shipmentId: string): Promise<checkoutmodels.KlarnaShipmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/checkout/shipment/${encodeURIComponent(shipmentId)}`)
            return await resp.json() as checkoutmodels.KlarnaShipmentResponse
        }

        /**
         * GetShippingOptions fetches and ranks shipping options for a given checkout session based on the input parameters.
         * It retrieves available shipping methods, applies various filters and ranking strategies,
         * and optionally includes additional processing like fetching warehouse information, availability checks,
         * route optimizations, cost calculations, and emission calculations.
         * 
         * The API performs several key steps:
         *  1. Fetches enabled shipping methods from the transportation service.
         *  2. Fetches transporter availabilities, calculate delivery route, perform optimizations,
         *     and calculates costs and emissions.
         *  3. Applies global filters based on the checkout data, which includes details like product identifiers,
         *     origin and destination information, and the checkout amount.
         *  4. Retrieves and applies a ranking strategy to order the shipping methods based on predefined criteria.
         *  5. Applies global overrides based on checkout configuration settings.
         * 
         * Usage:
         * This API is typically called during the checkout process to present the user with shipping options.
         */
        public async GetSkrymShippingOptions(params: GetSkrymShippingOptionsParams): Promise<GetSkrymShippingOptionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetSkrymShippingOptions`, JSON.stringify(params))
            return await resp.json() as GetSkrymShippingOptionsResponse
        }

        /**
         * GetSupportedCurrencies returns a list of all supported currencies.
         */
        public async GetSupportedCurrencies(): Promise<GetSupportedCurrenciesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetSupportedCurrencies`)
            return await resp.json() as GetSupportedCurrenciesResponse
        }

        public async GetTransportMethodDatabyCode(params: GetTransportMethodByCodeParams): Promise<GetTransportMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetTransportMethodDatabyCode`, JSON.stringify(params))
            return await resp.json() as GetTransportMethodResponse
        }

        public async GetTransportMethodDatabyID(params: GetTransportMethodByIDParams): Promise<GetTransportMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.GetTransportMethodDatabyID`, JSON.stringify(params))
            return await resp.json() as GetTransportMethodResponse
        }

        /**
         * InsertRetailerConsignorInfo creates a new uuid before inserting
         */
        public async InsertRetailerConsignorInfo(params: InsertRetailerConsignorInfoParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.InsertRetailerConsignorInfo`, JSON.stringify(params))
        }

        public async InsertTransportMethodData(params: InsertTransportMethodDataParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.InsertTransportMethodData`, JSON.stringify(params))
        }

        public async KlarnaClientAuthentication(method: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/checkout/auth`, body, options)
        }

        /**
         * For this to work, there needs to be a key set for the retailer id in the klarna_Auth_credentials table in tms.
         * Before calling it, we need to get a special auth token by calling /tms/auth with id (postman), nonce and digest
         * Read more on docs/klarna
         */
        public async KlarnaGetShippingOptions(params: KlarnaGetShippingOptionsParams): Promise<GetShippingOptionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout/shippingoptions`, JSON.stringify(params))
            return await resp.json() as GetShippingOptionsResponse
        }

        public async MockKlarnaGetShippingOptions(params: MockKlarnaGetShippingOptionsParams): Promise<MockKlarnaGetShippingOptionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.MockKlarnaGetShippingOptions`, JSON.stringify(params))
            return await resp.json() as MockKlarnaGetShippingOptionsResponse
        }

        /**
         * ReserveDeliveryChoice creates a Skrym basket and inserts the end-users delivery choice
         * 
         * Creating a basket with a delivery choice will create a "intended" purchase in our system.
         * The information stored related to transport method and delivery choice will be used to provide further insights into which options are the most popular.
         */
        public async ReserveDeliveryChoice(params: ReserveDeliveryChoiceParams): Promise<ReserveDeliveryChoiceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.ReserveDeliveryChoice`, JSON.stringify(params))
            return await resp.json() as ReserveDeliveryChoiceResponse
        }

        public async ReserveDeliveryChoiceFromKlarna(params: checkoutmodels.KlarnaSelectedShippingOption): Promise<checkoutmodels.KlarnaShipmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.ReserveDeliveryChoiceFromKlarna`, JSON.stringify(params))
            return await resp.json() as checkoutmodels.KlarnaShipmentResponse
        }

        /**
         * ScheduleBucketTest schedules a bucket test that is currently in the draft state.
         * 
         * This API endpoint facilitates transitioning a bucket test from the 'Draft' state to the 'Scheduled' state,
         * making it ready for execution at its configured start time.
         * Only tests in the 'Draft' state can be scheduled. If the test meets the criteria, it proceeds to
         * update the test's status accordingly.
         */
        public async ScheduleBucketTest(params: ScheduleBucketTestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.ScheduleBucketTest`, JSON.stringify(params))
        }

        public async SetCheckoutPreferences(params: SetCheckoutPreferencesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.SetCheckoutPreferences`, JSON.stringify(params))
        }

        /**
         * UnscheduleBucketTest transitions a scheduled bucket test back to the draft state.
         * 
         * This API endpoint allows for a bucket test that is currently in the 'Scheduled' state
         * to be reverted back to 'Draft', effectively canceling its scheduled execution.
         */
        public async UnscheduleBucketTest(params: ScheduleBucketTestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UnscheduleBucketTest`, JSON.stringify(params))
        }

        public async UpdateShipmentForKlarna(shipmentId: string, params: checkoutmodels.KlarnaSelectedShippingOption): Promise<checkoutmodels.KlarnaShipmentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/checkout/shipment/${encodeURIComponent(shipmentId)}`, JSON.stringify(params))
            return await resp.json() as checkoutmodels.KlarnaShipmentResponse
        }

        /**
         * UpsertBucketTest creates or updates a bucket test in the database.
         * 
         * Depending on the bucket test's status, it allows or blocks updates including those to the associated strategies and nodes.
         */
        public async UpsertBucketTest(params: UpsertBucketTestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UpsertBucketTest`, JSON.stringify(params))
        }

        /**
         * UpsertCheckoutAddonForOrganization upserts a checkout_addon record for the calling user's organization.
         * Does not upsert the key
         */
        public async UpsertCheckoutAddonForOrganization(params: UpsertCheckoutAddonParams): Promise<UpsertCheckoutAddonResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.UpsertCheckoutAddonForOrganization`, JSON.stringify(params))
            return await resp.json() as UpsertCheckoutAddonResponse
        }

        /**
         * UpsertCheckoutConfig creates or updates a checkout configuration for a specific node and retailer.
         * 
         * This endpoint requires authentication and uses the authenticated user's retailer ID. It validates the provided checkout configuration against the retailer's
         * transport methods before proceeding with the upsert operation. The function manages the transaction internally, ensuring data integrity.
         */
        public async UpsertCheckoutConfig(params: UpsertCheckoutConfigParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UpsertCheckoutConfig`, JSON.stringify(params))
        }

        /**
         * UpsertCheckoutStrategy inserts or updates a checkout strategy for a retailer.
         */
        public async UpsertCheckoutStrategy(params: UpsertCheckoutStrategyParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UpsertCheckoutStrategy`, JSON.stringify(params))
        }

        /**
         * UpsertCheckoutStrategyAndCheckoutConfig upserts a checkout strategy and its configs for a retailer. The strategy is first validated and then upserted in "real" table.
         * The checkout node configs are validated and then upserted.
         */
        public async UpsertCheckoutStrategyAndCheckoutConfig(params: UpsertCheckoutStrategyAndCheckoutConfigParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UpsertCheckoutStrategyAndCheckoutConfig`, JSON.stringify(params))
        }

        /**
         * UpsertCheckoutStrategyFromDraft upserts a checkout strategy from a draft. The draft is first validated and then upserted in "real" table.
         * After the upsert, the draft is deleted.
         */
        public async UpsertCheckoutStrategyFromDraft(params: UpsertCheckoutStrategyFromDraftParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UpsertCheckoutStrategyFromDraft`, JSON.stringify(params))
        }

        public async UpsertConsignorDetails(params: InsertConsignorDetailsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UpsertConsignorDetails`, JSON.stringify(params))
        }

        /**
         * UpsertDraftCheckoutConfig creates or updates a draft checkout configuration for a specific node and retailer.
         * 
         * This endpoint requires authentication and uses the authenticated user's retailer ID to perform the upsert operation. The function starts a transaction to ensure
         * data integrity during the upsert process. If an error occurs, the transaction is rolled back to maintain consistency.
         */
        public async UpsertDraftCheckoutConfig(params: UpsertDraftCheckoutConfigParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UpsertDraftCheckoutConfig`, JSON.stringify(params))
        }

        /**
         * UpsertDraftCheckoutStrategy upserts a checkout strategy in the draft table
         */
        public async UpsertDraftCheckoutStrategy(params: UpsertDraftCheckoutStrategyParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UpsertDraftCheckoutStrategy`, JSON.stringify(params))
        }

        /**
         * UpsertDraftCheckoutStrategyAndCheckoutConfig upserts a checkout strategy and its configs in the draft table
         */
        public async UpsertDraftCheckoutStrategyAndCheckoutConfig(params: UpsertDraftCheckoutStrategyAndCheckoutParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UpsertDraftCheckoutStrategyAndCheckoutConfig`, JSON.stringify(params))
        }

        /**
         * UpsertDraftFromCheckoutStrategy creates a draft copy of a checkout strategy from the "real" table, and inserts it into the draft table
         */
        public async UpsertDraftFromCheckoutStrategy(params: UpsertDraftFromCheckoutStrategyParams): Promise<UpsertDraftFromCheckoutStrategyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.UpsertDraftFromCheckoutStrategy`, JSON.stringify(params))
            return await resp.json() as UpsertDraftFromCheckoutStrategyResponse
        }

        /**
         * Upserter for transport method checkout config
         * 
         * The function first validates the incoming parameters, fetches the organization ID
         * from the auth data, and then uses it along with the other request parameters for inserting or updating
         * a list of OrganizationTransportMethodCheckout records into the database for the authenticated retailer.
         * checks for conflict on (checkout, organization_id, method_id)
         */
        public async UpsertOrganizationTransportMethodCheckoutConfig(params: UpsertOrganizationTransportMethodCheckoutConfigRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/checkout.UpsertOrganizationTransportMethodCheckoutConfig`, JSON.stringify(params))
        }

        /**
         * UpsertSelectedCheckoutAddonForUser upserts a selected_checkout_addon record for the authenticated user.
         */
        public async UpsertSelectedCheckoutAddonForUser(params: UpsertSelectedCheckoutAddonParams): Promise<UpsertSelectedCheckoutAddonResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/checkout.UpsertSelectedCheckoutAddonForUser`, JSON.stringify(params))
            return await resp.json() as UpsertSelectedCheckoutAddonResponse
        }
    }
}

export namespace cloud {
    export interface GeneralOrderFeedbackEvent {
        /**
         * The order reference used by the retailer. Currently has to be the same as the external ID used for the Skrym optimization.
         */
        retailerOrderReference: string

        /**
         * The ID of the retailer the event concerns.
         */
        retailerID: string

        /**
         * ID of the organization or system that created the event.
         */
        createdByOrganization: string

        /**
         * Enum of where the feedback is called from, allowed values are: WAREHOUSE, TRANSPORTER, INVOICE, OTHER.
         */
        feedbackSourceType: datamodels.FeedbackSourceType

        /**
         * probably reference for the retailer
         */
        organizationReference: string

        /**
         * to enable them to fetch it by ref/key
         */
        eventReference: string

        /**
         * Tracking number used by the transporter, if available.
         */
        trackingReference?: string

        /**
         * The scanned length (or largest dimension) of the freight object.
         */
        scannedLength?: number

        /**
         * The scanned width (or mid dimension) of the freight object.
         */
        scannedWidth?: number

        /**
         * The scanned height (or smallest dimension) of the freight object.
         */
        scannedHeight?: number

        /**
         * Unit of the dimensions, allowed values are: 'mm', 'cm', 'm', 'in', 'ft'
         */
        dimensionUnit?: utils.MeasurementUnit

        /**
         * The scanned weight of the freight object.
         */
        scannedWeight?: number

        /**
         * Unit of the weight, allowed values are: 'kg', 'g'
         */
        weightUnit?: utils.MeasurementUnit

        /**
         * The time the event occured. Will default to the current time if not provided.
         */
        eventTime?: string

        /**
         * The code for the transport method used, if available. Skrym will check this value against configured method aliases.
         */
        transportMethodCode?: string

        /**
         * Indication of order status, if available.
         */
        orderStatus?: string

        /**
         * Additional information about the shipment, if available.
         */
        skrymShipmentInfo?: SkrymShipmentInformation

        /**
         * Extra information about the warehouse, if available.
         */
        warehouseInformation?: datamodels.WarehouseInformation

        Message: {
            text: string
            /**
             * The language of the message
             */
            language: iso.IsoLanguage
        }
        /**
         * Any additional information connected to the event.
         */
        metadata: JSONValue

        orderingKey: string
    }

    export interface SkrymShipmentInformation {
        status: models.Status
        direction: models.Direction
        checkpointType: models.CheckpointType
        location: datamodels.SimplifiedEventLocation
        eventType: models.EventType
    }
}

export namespace core {
    /**
     * CalculateEmissionsForAllMethodsParams is the input for the CalculateEmissionsForAllMethods function
     */
    export interface CalculateEmissionsForAllMethodsParams {
        /**
         * The location from which the emissions are calculated
         */
        from: LocationForEmissions

        /**
         * The location to which the emissions are calculated
         */
        to: LocationForEmissions

        /**
         * A list of packages to which the emission calculations will be applied
         */
        packages: models.EmissionsPackage[]

        /**
         * Skrym ID used to tie the result to its origin. If you do not provide a reference ID, one will be generated for you.
         */
        referenceId: string
    }

    /**
     * CalculateEmissionsForAllMethodsResponse wraps the results of emissions calculations.
     */
    export interface CalculateEmissionsForAllMethodsResponse {
        /**
         * The reference ID for the emissions calculation, which refers to a id linked to the calculation origin.
         */
        referenceId: string

        /**
         * The emissions for the packaging
         */
        packagingEmissions: models.PackageEmissions[]

        /**
         * List of successful emissions calculations.
         */
        successfulShippingEmissionsResult: models.SuccessfulShippingEmissionsResult[]

        /**
         * List of failed emissions calculations.
         */
        failedShippingEmissionsResults: models.FailedShippingEmissionsResult[]
    }

    /**
     * CalculateOptimalPharmacyPackageParams
     * 
     * A model of the expected request body for the pharmacy optimisation flow
     */
    export interface CalculateOptimalPharmacyPackageParams {
        /**
         * String value that can be used to identify an order
         */
        orderID: string

        /**
         * Products that are packed into a prescription bag
         */
        rxProducts: models.OrderProductWithDims[][]

        /**
         * Products that can be directly packed into a package
         */
        regularProducts: models.OrderProductWithDims[]

        /**
         * Optional flag denoting what kind of automation is used for packing products.
         */
        automation: models.WarehouseFlow
    }

    /**
     * CalculatePharmacyPackageResponse
     * 
     * A model of the response body returned by the pharmacy optimisation flow
     */
    export interface CalculatePharmacyPackageResponse {
        /**
         * Array of packages along with the products split up into each package
         */
        splitResults: models.PharmacyResult[]

        /**
         * String value that can be used to identify the package
         */
        packageId: string

        /**
         * Alias of the package. Will only be filled if a package alias has been set.
         */
        packageLabel: string

        /**
         * Outer dimensions of the chosen packager
         */
        estOuterDimensions: number[]

        /**
         * Weight of the chosen package when packed with the products in the order.
         */
        estTotalWeight: number

        /**
         * Array of prescription bags along with prescription products split up into each bag
         */
        prescriptionBag: models.PrescriptionPackage[]
    }

    export interface ConfirmTransportForOrderEmissionsParams {
        /**
         * Your identifier for the given order
         */
        orderReference: string

        /**
         * The transporter for the order. Name or alias works.
         */
        transporter: string

        /**
         * The transport method for the order. Name or alias works.
         */
        transportMethod: string

        /**
         * The uuid used in the emissions calculation - must be a valid uuid for an earlier reference.
         */
        referenceID: string
    }

    export interface DeliveryCostForFreightObject {
        /**
         * Input used for the cost calculation
         */
        input: SimplifiedFreightObject

        /**
         * Results of the cost calculation
         */
        costs: transportation.CalculateCostResponse[]
    }

    export interface DeliveryCostParams {
        /**
         * Determines if all agreements will be used or only those that are active
         */
        onlyActiveAgreements: boolean

        /**
         * Indicates whether to get cost for all methods or just for the one that is specified in the simplified freight object
         */
        onlyUseSpecifiedMethod: boolean

        /**
         * This indicates whether or not the fallback cost will be used if the agreement calculation fails
         */
        allowFallbackCost: boolean

        /**
         * The objects to calculate costs for
         */
        freightObjects: SimplifiedFreightObject[]
    }

    export interface DeliveryCostResponse {
        /**
         * Input and costs for each passed freight object
         */
        freightObjects: DeliveryCostForFreightObject[]
    }

    export interface ExternalProduct {
        name?: string
        retailerId: string
        externalId: string
        dimensions: number[]
        weight?: number
        fragilityIndex?: number
        stackingDelta?: number
        stackingDirection?: number
        family?: models.Family
        attributes?: string[]
    }

    export interface FaultyTrackingNumber {
        trackingNumber: string
        reasons: string[]
    }

    export interface FeedbackRequest {
        /**
         * Optional unique key corresponding to the feedback event that callers can set.
         */
        key?: string

        /**
         * Where the feedback is called from, allowed values are: WAREHOUSE, TRANSPORTER, INVOICE, OTHER.
         */
        feedbackSourceType: datamodels.FeedbackSourceType

        /**
         * Basic declaration if the order fits into recommendation, allowed values are: FITS, TOO_SMALL, TOO_BIG, UNKNOWN.
         */
        fit: datamodels.FitStatus

        /**
         * Optional Skrym ID of the order.
         */
        skrymOrderID?: string

        /**
         * Reference/Identifier of the order.
         */
        externalOrderReference: string

        /**
         * Optional tracking reference that caller has for the shipment.
         */
        shipmentTrackingReference?: string

        /**
         * Optional tracking reference that caller has for the parcel.
         */
        parcelTrackingReference?: string

        /**
         * Optional session ID from the checkout.
         */
        checkoutSessionID?: string

        /**
         * Optional timestamp for when the feedback event occured.
         */
        createdAt?: string

        /**
         * Optional dimensions that caller has measured during feedback event.
         */
        measuredDimensions?: number[]

        /**
         * Optional weight that caller has measured during feedback event.
         */
        measuredWeight?: number

        /**
         * Optional debitable weight that caller has measured during feedback event.
         */
        measuredDebitableWeight?: number

        /**
         * Optional reference/identifier of the actual chosen package.
         */
        chosenPackageReference?: string

        /**
         * Other tags and flags that are important for the feedback event, for example: {"orderIsFragile": "true"}
         */
        metadata: JSONValue

        /**
         * Any additional information.
         */
        freeText?: string
    }

    /**
     * GeneralFeedbackParameters is the request body for GeneralFeedback
     * REST API endpoint.
     */
    export interface GeneralFeedbackParameters {
        feedback: FeedbackRequest[]
    }

    /**
     * GeneralFeedbackResponse is the response body for GeneralFeedback
     * REST API endpoint.
     */
    export interface GeneralFeedbackResponse {
        warnings: string[]
    }

    export interface GetAvailableAddonsParams {
        transportMethod: string
        transporter: string
    }

    export interface GetAvailableAddonsResponse {
        /**
         * A slice of AddonMapData representing the mappings of all addons
         */
        addonMaps: models.AddonMapData[]
    }

    export interface GetFeedbackSummaryForOrdersRequest {
        externalOrderIDs: string[]
    }

    export interface GetFeedbackSummaryForOrdersResponse {
        /**
         * map from externalOrderID to its feedback summary
         */
        feedbackSummaryMap: { [key: string]: datamodels.OrderFeedbackSummary }
    }

    export interface GetProductByIdParams {
        id: string
    }

    export interface GetProductByIdResponse {
        product: ExternalProduct
    }

    export interface GetProductsResponse {
        products: ExternalProduct[]
    }

    export interface GetShipmentByTransporterTrackingNumberParams {
        /**
         * The alias of the transporter
         */
        transporterAlias: string

        /**
         * The tracking identifier provided by the transporter. Note that this should not be a tracking URL, but the actual identifier of the shipment.
         */
        trackingNumber: string
    }

    export interface GetShipmentByTransporterTrackingNumberResponse {
        /**
         * All available tracking information for a shipment
         */
        shipment: models.SingleShipment

        events: models.Event[]
    }

    export interface GetShipmentsByTrackingIDParam {
        trackingNumbers: string[]
    }

    export interface GetShipmentsByTrackingIDResponse {
        shipments: models.SingleShipment[]
        faultyTrackingNumbers: FaultyTrackingNumber[]
    }

    export interface GetTrackedOrderParams {
        /**
         * Any valid reference for the tracked order
         */
        orderReference?: string

        /**
         * The Skrym ID of the tracked order
         */
        trackedOrderID?: string

        /**
         * The sorting order of the events and milestones. Must be one of "ASC" or "DESC". For milestones, it sorts on the sequence.
         */
        sorting?: utils.SortingDirection
    }

    export interface GetTrackedOrderResponse {
        /**
         * The Skrym ID of the tracked order
         */
        id: string

        /**
         * The start of the promised delivery time window for the order
         */
        promisedDeliveryTimeStart?: string

        /**
         * The end of the promised delivery time window for the order
         */
        promisedDeliveryTimeEnd?: string

        /**
         * The postal code of the origin location of the order
         */
        originZipCode?: string

        /**
         * The country of the origin location of the order
         */
        originCountryCode?: string

        /**
         * The postal code of the destination location of the order
         */
        destinationZipCode?: string

        /**
         * The country of the destination location of the order
         */
        destinationCountryCode?: string

        /**
         * The time the order was created
         */
        createdAt: string

        /**
         * A list of references used for the order (e.g. ERP number, WMS number)
         */
        references: ReferenceWithTimestamp[]

        /**
         * A list of shipments that are part of the order
         */
        shipments: SimplifiedShipmentContainer[]

        /**
         * A list of locations that the order has been to, in order
         */
        routeInfo: SimplifiedEventLocation[]

        /**
         * Additional metadata about the order
         */
        metadata?: JSONValue
    }

    export interface InitializeTrackingParams {
        /**
         * Optional string representation of which transporter the provided reference is for. Handles casing variations.
         */
        transporter?: string

        /**
         * Optional name or code for which method the shipment is using. Example values are 'MyPack Collect' and 'budbee-box'.
         */
        transporterMethod: string

        /**
         * Valid tracking identifier for your shipment.
         */
        trackingReference?: string

        /**
         * Optional order reference for the shipment. Often an order id.
         */
        orderReference?: string

        /**
         * Optional string representation of the postal code of the origin location of the shipment
         */
        originZip?: string

        /**
         * Optional string representation of the country of the origin location of the shipment. Country is expected in the ISO 3166 Alpha-2 (2 letter) country code format
         */
        originCountry?: string

        /**
         * Optional string representation of the postal code of the destination location of the shipment
         */
        destinationZip?: string

        /**
         * Optional string representation of the country of the destination location of the shipment. Country is expected in the ISO 3166 Alpha-2 (2 letter) country code format
         */
        destinationCountry?: string

        /**
         * Optional: Timestamp of when the shipment is promised to be delivered to the recipient. Please use the latest acceptable time.
         */
        promisedDeliveryTime?: string

        /**
         * Optional identifier to indicate which location it starts at. Will be used to create an initialization event.
         */
        originLocationIdentifier?: string

        /**
         * Optional list of parcels in the shipment.
         */
        parcels?: InitializeTrackingParcel[]

        /**
         * Optional reference to a journey that this shipment is part of.
         */
        journeyReference?: string

        /**
         * Optional metadata about the shipment
         */
        metadata?: JSONValue
    }

    export interface InitializeTrackingParcel {
        /**
         * Valid tracking identifier for your parcel.
         */
        trackingReference: string

        /**
         * Optional reference for the parcel
         */
        reference: string

        /**
         * Optional metadata about the parcel
         */
        metadata?: JSONValue
    }

    export interface LocationForEmissions {
        /**
         * The country of the location in ISO 3166-1 alpha-2 format, e.g. "SE"
         */
        country: string

        /**
         * The zip code of the location
         */
        zipCode: string

        /**
         * The street of the location
         */
        street: string
    }

    export interface MilestoneDetails {
        /**
         * The name of the milestone
         */
        name: string

        /**
         * The description of the milestone
         */
        description: string
    }

    /**
     * OptimizePostPaymentParams defines the parameters required for optimizing the packaging and shipping process after an order is placed.
     */
    export interface OptimizePostPaymentParams {
        /**
         * OrderId represents the unique identifier of the order being processed.
         */
        orderId: string

        /**
         * OrderDate is the date when the order was placed.
         */
        orderDate?: string

        /**
         * TransportInfo contains information regarding the transportation of the order.
         */
        transportInfo: models.LiveOrderTransport

        /**
         * Products is a list of products included in the order. Each product in this slice is detailed in terms of its unique identifier and quantity.
         */
        products: models.OrderProductQuantity[]

        /**
         * Mock indicates whether the optimization is being run in a mock mode. If true, it will not save any results.
         */
        mock: boolean
    }

    /**
     * OptimizePostPaymentResponse represents the response structure returned by the OptimizePostPayment function.
     */
    export interface OptimizePostPaymentResponse {
        /**
         * Results is a slice of that contains the optimization results.
         */
        results: models.ReturnItemPostPayment[]
    }

    export interface ReferenceWithTimestamp {
        reference: string
        createdAt: string
    }

    export interface SimplifiedEventLocation {
        /**
         * The Skrym ID of the location
         */
        id: string

        /**
         * The shipments that have been to this location. If empty, the location belongs to whole order (i.e. all shipments).
         */
        shipments: string[]

        /**
         * The first time a shipment was at this location
         */
        firstTimestamp: string

        /**
         * The last time a shipment was at this location
         */
        lastTimestamp: string

        /**
         * The postal code of the location
         */
        zipCode: string

        /**
         * The country code of the location
         */
        countryCode: string

        /**
         * The latitude of the location
         */
        latitude: number

        /**
         * The longitude of the location
         */
        longitude: number

        /**
         * The type of the location
         */
        locationType: string

        /**
         * The name of the location
         */
        locationName: string

        /**
         * The city of the location
         */
        city: string
    }

    /**
     * This is to not require the user to pass in the enormous struct we use internally
     */
    export interface SimplifiedFreightObject {
        /**
         * Reference for the freight object
         */
        reference: string

        /**
         * Optional argument that accepts method alias (does not need to be set as display name), Skrym transport method code and transport method ID. Is only needed if OnlyUseSpecifiedMethod is true.
         */
        transportMethod?: string

        /**
         * in mm
         */
        length: number

        /**
         * in mm
         */
        width: number

        /**
         * in mm
         */
        height: number

        /**
         * in grams
         */
        weight: number

        /**
         * Optional argument expecting date input in RFC3339 ISO format. Will default to current time.
         */
        deliveryDate?: string

        /**
         * Where the shipment is going
         */
        destination: datamodels.SimplifiedLocation

        /**
         * Optional argument for where the shipment is going
         */
        origin?: datamodels.SimplifiedLocation

        /**
         * Optional argument specifying type of freight object. Accepted values are 'pallet', 'parcel' and 'bag'. Will default to 'parcel'.
         */
        type?: datamodels.FreightObjectType

        /**
         * Optional argument for addons to the shipment
         */
        addons?: string[]
    }

    export interface SimplifiedJourneyMilestone {
        /**
         * The Skrym ID of the journey milestone
         */
        id: string

        /**
         * The reference of the journey milestone
         */
        reference: string

        /**
         * The translations of the milestone, map of language code to milestone details
         */
        translations: { [key: string]: MilestoneDetails }

        /**
         * The sequence of the milestone
         */
        sequence?: number

        /**
         * The display ordering of the milestone
         */
        displayOrdering?: number

        /**
         * Whether the milestone can be the final one in a journey
         */
        final: boolean

        /**
         * The color of the milestone
         */
        color: string

        /**
         * The icon of the milestone
         */
        icon: string

        /**
         * Whether the milestone is completed
         */
        completed: boolean

        /**
         * The time the milestone was completed
         */
        completedAt: string

        /**
         * The time the milestone was last updated
         */
        updatedAt: string
    }

    export interface SimplifiedLocation {
        /**
         * The postal code of the location
         */
        zipCode: string

        /**
         * The country code of the location
         */
        countryCode: string
    }

    export interface SimplifiedOrderJourney {
        /**
         * The Skrym ID of the order journey
         */
        id: string

        /**
         * The name of the order journey
         */
        name: string

        /**
         * The reference of the order journey
         */
        reference: string

        /**
         * Whether the order journey is completed
         */
        completed: boolean

        /**
         * The time the order journey was completed
         */
        completedAt?: string

        /**
         * The time the order journey was last updated
         */
        updatedAt: string

        /**
         * The milestones that are part of the order journey
         */
        milestones: SimplifiedJourneyMilestone[]
    }

    export interface SimplifiedShipment {
        /**
         * The Skrym ID of the shipment
         */
        id: string

        /**
         * The transporter of the shipment
         */
        transporter: SimplifiedTransporter

        /**
         * The transport method of the shipments
         */
        transportMethod: SimplifiedTransportMethod

        /**
         * The tracking reference of the shipment, used by the transporter
         */
        trackingReference: string

        /**
         * The tracking URL of the shipment for different languages. Note that this is not available for all transporters.
         */
        trackingURL?: { [key: string]: string }

        /**
         * Your own reference for the shipment
         */
        externalReference?: string

        /**
         * Optional: The start of the expected delivery time window, as estimated by the transporter
         */
        expectedDeliveryTimeStart?: string

        /**
         * Optional: The end of the expected delivery time window, as estimated by the transporter
         */
        expectedDeliveryTimeEnd?: string

        /**
         * Optional: The start the promised delivery time window, as promised by the retailer
         */
        promisedDeliveryTimeStart?: string

        /**
         * Optional: The end the promised delivery time window, as promised by the retailer
         */
        promisedDeliveryTimeEnd?: string

        /**
         * The current status of the shipment
         */
        status: string

        /**
         * The time the shipment was created
         */
        createdAt: string

        /**
         * The origin location of the shipment
         */
        origin: SimplifiedLocation

        /**
         * The destination location of the shipment
         */
        destination: SimplifiedLocation

        /**
         * The parcels that are part of the shipment
         */
        parcels: models.TrackedParcel[]

        /**
         * Additional metadata about the shipment
         */
        metadata?: JSONValue
    }

    export interface SimplifiedShipmentContainer {
        /**
         * The actual shipment. Will be null before a shipment has been booked for the order.
         */
        shipment: SimplifiedShipment

        /**
         * The order journeys that are part of the shipment
         */
        orderJourneys: SimplifiedOrderJourney[]
    }

    export interface SimplifiedTransportMethod {
        /**
         * The Skrym ID of the transport method
         */
        id: string

        /**
         * The name of the transporter
         */
        name: string

        /**
         * The type of delivery method
         */
        deliveryType: string

        /**
         * Unique Skrym code for the transport method
         */
        code: string

        /**
         * Retailer-generated aliases for the transport method
         */
        aliases: string[]
    }

    export interface SimplifiedTransporter {
        /**
         * The Skrym ID of the transporter
         */
        id: string

        /**
         * The name of the transporter
         */
        name: string
    }

    /**
     * UpsertProductsParams encapsulates the data required for inserting products.
     * It contains a slice of Product, representing the products to be processed.
     */
    export interface UpsertProductsParams {
        /**
         * List of products for insertion or update.
         */
        products: models.Product[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.CalculateEmissionsForAllMethods = this.CalculateEmissionsForAllMethods.bind(this)
            this.CalculateOptimalPharmacyPackage = this.CalculateOptimalPharmacyPackage.bind(this)
            this.CalculateOptimalPharmacyPackageNoLogging = this.CalculateOptimalPharmacyPackageNoLogging.bind(this)
            this.ConfirmTransportForOrderEmissions = this.ConfirmTransportForOrderEmissions.bind(this)
            this.DeliveryCost = this.DeliveryCost.bind(this)
            this.GeneralFeedback = this.GeneralFeedback.bind(this)
            this.GetAvailableAddons = this.GetAvailableAddons.bind(this)
            this.GetFeedbackSummaryForOrders = this.GetFeedbackSummaryForOrders.bind(this)
            this.GetProductById = this.GetProductById.bind(this)
            this.GetProducts = this.GetProducts.bind(this)
            this.GetShipmentByTransporterTrackingNumber = this.GetShipmentByTransporterTrackingNumber.bind(this)
            this.GetShipmentsByTrackingID = this.GetShipmentsByTrackingID.bind(this)
            this.GetTrackedOrder = this.GetTrackedOrder.bind(this)
            this.InitializeTracking = this.InitializeTracking.bind(this)
            this.InitializeTrackingWrapper = this.InitializeTrackingWrapper.bind(this)
            this.OptimizePostPayment = this.OptimizePostPayment.bind(this)
            this.OptimizePostPaymentAsync = this.OptimizePostPaymentAsync.bind(this)
            this.UpsertOrderEventAndFeedback = this.UpsertOrderEventAndFeedback.bind(this)
            this.UpsertProducts = this.UpsertProducts.bind(this)
        }

        public async CalculateEmissionsForAllMethods(params: CalculateEmissionsForAllMethodsParams): Promise<CalculateEmissionsForAllMethodsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/core.CalculateEmissionsForAllMethods`, JSON.stringify(params))
            return await resp.json() as CalculateEmissionsForAllMethodsResponse
        }

        /**
         * Pharmacy optimisation flow
         * 
         * CalculateOptimalPharmacyPackage performs a 2 layered optimisation, one optimising prescription products into a prescription bag and the other optimising the remaining products along with the chosen prescription bag into a package.
         * Only returns split results if caller has the ORDER_SPLIT permission. Returns 404 NOT FOUND if no suitable package(s) is found.
         */
        public async CalculateOptimalPharmacyPackage(params: CalculateOptimalPharmacyPackageParams): Promise<CalculatePharmacyPackageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/core.CalculateOptimalPharmacyPackage`, JSON.stringify(params))
            return await resp.json() as CalculatePharmacyPackageResponse
        }

        public async CalculateOptimalPharmacyPackageNoLogging(params: CalculateOptimalPharmacyPackageParams): Promise<CalculatePharmacyPackageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/core.CalculateOptimalPharmacyPackageNoLogging`, JSON.stringify(params))
            return await resp.json() as CalculatePharmacyPackageResponse
        }

        /**
         * ConfirmTransportMethodForEmissionsResult confirms the transport method for emissions result based on the provided parameter and inserts a new order for the provided reference.
         * 
         * It also inserts an order for the provided reference to enable keeping track of emissions per order.
         */
        public async ConfirmTransportForOrderEmissions(params: ConfirmTransportForOrderEmissionsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/core.ConfirmTransportForOrderEmissions`, JSON.stringify(params))
        }

        /**
         * This should be turned into a unified endpoint that handles a lot of different cases for our users
         * 
         * It does not provide the fallback costs if a calculation fails
         */
        public async DeliveryCost(params: DeliveryCostParams): Promise<DeliveryCostResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/DeliveryCost`, JSON.stringify(params))
            return await resp.json() as DeliveryCostResponse
        }

        /**
         * GeneralFeedback collects feedback related to packaging and shipping from various sources.
         * It supports bulk submissions and handles feedback for order packaging optimization,
         * including dimensions, weights, and package suitability. The endpoint validates the
         * source and type of feedback, processes each feedback item, and updates existing records
         * or creates new ones as necessary. It requires the caller to be authenticated.
         */
        public async GeneralFeedback(params: GeneralFeedbackParameters): Promise<GeneralFeedbackResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/core.GeneralFeedback`, JSON.stringify(params))
            return await resp.json() as GeneralFeedbackResponse
        }

        /**
         * GetAvailableAddons fetches all available addons for a specified transport method
         * 
         * Note that the transport method has to be added by your organization, which you can do on the transporter page in Scope.
         */
        public async GetAvailableAddons(params: GetAvailableAddonsParams): Promise<GetAvailableAddonsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/GetAvailableAddons`, JSON.stringify(params))
            return await resp.json() as GetAvailableAddonsResponse
        }

        /**
         * GetFeedbackSummaryForOrders returns a summary of feedback events for a list of orders specified by the given externalOrderIDs.
         * 
         * This endpoint analyses all of the raw feedback events, accumulating them into a summary featuring the latest and most important information.
         */
        public async GetFeedbackSummaryForOrders(params: GetFeedbackSummaryForOrdersRequest): Promise<GetFeedbackSummaryForOrdersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/core.GetFeedbackSummaryForOrders`, JSON.stringify(params))
            return await resp.json() as GetFeedbackSummaryForOrdersResponse
        }

        public async GetProductById(params: GetProductByIdParams): Promise<GetProductByIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/core.GetProductById`, JSON.stringify(params))
            return await resp.json() as GetProductByIdResponse
        }

        public async GetProducts(): Promise<GetProductsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/core.GetProducts`)
            return await resp.json() as GetProductsResponse
        }

        /**
         * GetShipmentByTransporterTrackingNumber returns tracking info for a given shipment
         * 
         * Returns all tracking-related information for a transporter tracking reference. Needs to correspond
         * to a shipment that has already been initialized for tracking with the specified reference.
         */
        public async GetShipmentByTransporterTrackingNumber(params: GetShipmentByTransporterTrackingNumberParams): Promise<GetShipmentByTransporterTrackingNumberResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/GetShipment`, JSON.stringify(params))
            return await resp.json() as GetShipmentByTransporterTrackingNumberResponse
        }

        public async GetShipmentsByTrackingID(params: GetShipmentsByTrackingIDParam): Promise<GetShipmentsByTrackingIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/core.GetShipmentsByTrackingID`, JSON.stringify(params))
            return await resp.json() as GetShipmentsByTrackingIDResponse
        }

        /**
         * GetTrackedOrder presents tracking information for an order in a simplified format
         * 
         * It is designed to be used to populate a tracking page for the end customer. You need to provide either a valid Skrym order ID or
         * any of the references you have added to the tracked order.
         */
        public async GetTrackedOrder(params: GetTrackedOrderParams): Promise<GetTrackedOrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/GetTrackedOrder`, JSON.stringify(params))
            return await resp.json() as GetTrackedOrderResponse
        }

        /**
         * InitializeTracking triggers Skrym to start fetching event data for an identified shipment.
         * 
         * Initializes the Skrym tracking process for the provided shipment reference. This means Skrym will start
         * fetching event data from the transporter.
         * 
         * Either a tracking reference, and/or a order reference must be provided. If the order reference is not provided,
         * the same endpoint should later be called with the tracking reference and the same order reference to initialize the tracking.
         */
        public async InitializeTracking(params: InitializeTrackingParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/core.InitializeTracking`, JSON.stringify(params))
        }

        /**
         * TrackShipment triggers Skrym to start fetching event data for an identified shipment.
         * 
         * Initializes the Skrym tracking process for the provided shipment reference. This means Skrym will start
         * fetching event data from the transporter.
         */
        public async InitializeTrackingWrapper(params: InitializeTrackingParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/TrackShipment`, JSON.stringify(params))
        }

        public async OptimizePostPayment(params: OptimizePostPaymentParams): Promise<OptimizePostPaymentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/core.OptimizePostPayment`, JSON.stringify(params))
            return await resp.json() as OptimizePostPaymentResponse
        }

        /**
         * OptimizePostPaymentAsync is an asynchronous version of OptimizePostPayment.
         * It stores the optimization request in the optimization db.
         */
        public async OptimizePostPaymentAsync(params: OptimizePostPaymentParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/core.OptimizePostPaymentAsync`, JSON.stringify(params))
        }

        /**
         * UpsertOrderEventAndFeedback combines order feedback for optimization with a tracking event
         * 
         * This is primarily intended to be used by hardware in warehouses that scan packages and thus can provide both feedback on the physical properties of the freight object and the progress in the order journey.
         */
        public async UpsertOrderEventAndFeedback(params: cloud.GeneralOrderFeedbackEvent): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/core.UpsertOrderEventAndFeedback`, JSON.stringify(params))
        }

        /**
         * UpsertProducts inserts or updates a batch of products in the database.
         * It validates each product for required fields and positive dimensions.
         * If all products are invalid, it returns a response with zero insertions.
         */
        public async UpsertProducts(params: UpsertProductsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/core.UpsertProducts`, JSON.stringify(params))
        }
    }
}

export namespace crm {
    export interface CheckLagoHealthResponse {
        healthy: boolean
    }

    /**
     * Parameters required for executing a soft delete of CallSheet
     */
    export interface DeleteCallSheetRequestParams {
        /**
         * Primary identifier for the CallSheet to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Channel
     */
    export interface DeleteChannelRequestParams {
        /**
         * Primary identifier for the Channel to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of CompanyBillingInfo
     */
    export interface DeleteCompanyBillingInfoRequestParams {
        /**
         * Primary identifier for the CompanyBillingInfo to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of CompanyInvoice
     */
    export interface DeleteCompanyInvoiceRequestParams {
        /**
         * Primary identifier for the CompanyInvoice to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of CompanyNote
     */
    export interface DeleteCompanyNoteRequestParams {
        /**
         * Primary identifier for the CompanyNote to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of CompanyProductAreaEntry
     */
    export interface DeleteCompanyProductAreaEntryRequestParams {
        /**
         * Primary identifier for the CompanyProductAreaEntry to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of CompanyProductArea
     */
    export interface DeleteCompanyProductAreaRequestParams {
        /**
         * Primary identifier for the CompanyProductArea to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Company
     */
    export interface DeleteCompanyRequestParams {
        /**
         * Primary identifier for the Company to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of CompanySegmentEntry
     */
    export interface DeleteCompanySegmentEntryRequestParams {
        /**
         * Primary identifier for the CompanySegmentEntry to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of CompanySegment
     */
    export interface DeleteCompanySegmentRequestParams {
        /**
         * Primary identifier for the CompanySegment to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of CompanyType
     */
    export interface DeleteCompanyTypeRequestParams {
        /**
         * Primary identifier for the CompanyType to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Connection
     */
    export interface DeleteConnectionRequestParams {
        /**
         * Primary identifier for the Connection to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of ContactDetail
     */
    export interface DeleteContactDetailRequestParams {
        /**
         * Primary identifier for the ContactDetail to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of ContactDetailType
     */
    export interface DeleteContactDetailTypeRequestParams {
        /**
         * Primary identifier for the ContactDetailType to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of ContactDocument
     */
    export interface DeleteContactDocumentRequestParams {
        /**
         * Primary identifier for the ContactDocument to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of ContactNote
     */
    export interface DeleteContactNoteRequestParams {
        /**
         * Primary identifier for the ContactNote to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Contact
     */
    export interface DeleteContactRequestParams {
        /**
         * Primary identifier for the Contact to be deleted
         */
        id: string
    }

    /**
     * Parameters required for executing a soft delete of ContactRole
     */
    export interface DeleteContactRoleRequestParams {
        /**
         * Primary identifier for the ContactRole to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Document
     */
    export interface DeleteDocumentRequestParams {
        /**
         * Primary identifier for the Document to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of DocumentType
     */
    export interface DeleteDocumentTypeRequestParams {
        /**
         * Primary identifier for the DocumentType to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Employment
     */
    export interface DeleteEmploymentRequestParams {
        /**
         * Primary identifier for the Employment to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of EventAttendee
     */
    export interface DeleteEventAttendeeRequestParams {
        /**
         * Primary identifier for the EventAttendee to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Event
     */
    export interface DeleteEventRequestParams {
        /**
         * Primary identifier for the Event to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of EventType
     */
    export interface DeleteEventTypeRequestParams {
        /**
         * Primary identifier for the EventType to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of FormSubmission
     */
    export interface DeleteFormSubmissionRequestParams {
        /**
         * Primary identifier for the FormSubmission to be deleted
         */
        id: string
    }

    /**
     * Parameters required for executing a soft delete of MeetingAttendee
     */
    export interface DeleteMeetingAttendeeRequestParams {
        /**
         * Primary identifier for the MeetingAttendee to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of MeetingCompany
     */
    export interface DeleteMeetingCompanyRequestParams {
        /**
         * Primary identifier for the MeetingCompany to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Meeting
     */
    export interface DeleteMeetingRequestParams {
        /**
         * Primary identifier for the Meeting to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of MeetingType
     */
    export interface DeleteMeetingTypeRequestParams {
        /**
         * Primary identifier for the MeetingType to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of NewsletterSignup
     */
    export interface DeleteNewsletterSignupRequestParams {
        /**
         * Primary identifier for the NewsletterSignup to be deleted
         */
        id: string
    }

    /**
     * Parameters required for executing a soft delete of OnCallRole
     */
    export interface DeleteOnCallRoleRequestParams {
        /**
         * Primary identifier for the OnCallRole to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of OnCallSchedule
     */
    export interface DeleteOnCallScheduleRequestParams {
        /**
         * Primary identifier for the OnCallSchedule to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of OpportunityFunnel
     */
    export interface DeleteOpportunityFunnelRequestParams {
        /**
         * Primary identifier for the OpportunityFunnel to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of OpportunityFunnelStep
     */
    export interface DeleteOpportunityFunnelStepRequestParams {
        /**
         * Primary identifier for the OpportunityFunnelStep to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of OpportunityProduct
     */
    export interface DeleteOpportunityProductRequestParams {
        /**
         * Primary identifier for the OpportunityProduct to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Opportunity
     */
    export interface DeleteOpportunityRequestParams {
        /**
         * Primary identifier for the Opportunity to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of OpportunityType
     */
    export interface DeleteOpportunityTypeRequestParams {
        /**
         * Primary identifier for the OpportunityType to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of OrganizationDocument
     */
    export interface DeleteOrganizationDocumentRequestParams {
        /**
         * Primary identifier for the OrganizationDocument to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of ProductCategory
     */
    export interface DeleteProductCategoryRequestParams {
        /**
         * Primary identifier for the ProductCategory to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of ProductDocument
     */
    export interface DeleteProductDocumentRequestParams {
        /**
         * Primary identifier for the ProductDocument to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Product
     */
    export interface DeleteProductRequestParams {
        /**
         * Primary identifier for the Product to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of ProductSubcategory
     */
    export interface DeleteProductSubcategoryRequestParams {
        /**
         * Primary identifier for the ProductSubcategory to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of ProductUser
     */
    export interface DeleteProductUserRequestParams {
        /**
         * Primary identifier for the ProductUser to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of SkrymCompanyRoleArea
     */
    export interface DeleteSkrymCompanyRoleAreaRequestParams {
        /**
         * Primary identifier for the SkrymCompanyRoleArea to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of SkrymCompanyRole
     */
    export interface DeleteSkrymCompanyRoleRequestParams {
        /**
         * Primary identifier for the SkrymCompanyRole to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of SkrymContactRole
     */
    export interface DeleteSkrymContactRoleRequestParams {
        /**
         * Primary identifier for the SkrymContactRole to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of SprintDailyStandupEntry
     */
    export interface DeleteSprintDailyStandupEntryRequestParams {
        /**
         * Primary identifier for the SprintDailyStandupEntry to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of SprintDailyStandup
     */
    export interface DeleteSprintDailyStandupRequestParams {
        /**
         * Primary identifier for the SprintDailyStandup to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of SprintMessage
     */
    export interface DeleteSprintMessageRequestParams {
        /**
         * Primary identifier for the SprintMessage to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of SprintMessageType
     */
    export interface DeleteSprintMessageTypeRequestParams {
        /**
         * Primary identifier for the SprintMessageType to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Sprint
     */
    export interface DeleteSprintRequestParams {
        /**
         * Primary identifier for the Sprint to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of SprintRoleEntry
     */
    export interface DeleteSprintRoleEntryRequestParams {
        /**
         * Primary identifier for the SprintRoleEntry to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of SprintRole
     */
    export interface DeleteSprintRoleRequestParams {
        /**
         * Primary identifier for the SprintRole to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of TaskOwner
     */
    export interface DeleteTaskOwnerRequestParams {
        /**
         * Primary identifier for the TaskOwner to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of Task
     */
    export interface DeleteTaskRequestParams {
        /**
         * Primary identifier for the Task to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of TaskStatus
     */
    export interface DeleteTaskStatusRequestParams {
        /**
         * Primary identifier for the TaskStatus to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of WorkingTimeLocation
     */
    export interface DeleteWorkingTimeLocationRequestParams {
        /**
         * Primary identifier for the WorkingTimeLocation to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of WorkingTime
     */
    export interface DeleteWorkingTimeRequestParams {
        /**
         * Primary identifier for the WorkingTime to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of WorkingTimeType
     */
    export interface DeleteWorkingTimeTypeRequestParams {
        /**
         * Primary identifier for the WorkingTimeType to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    export interface FeedItem {
        title: string
        message: string
        timeStamp: string
        actor?: crmmodels.Contact
        subject: string
    }

    export interface FunnelStepReachedDay {
        day: string
        count: number
    }

    export interface GetAllCallSheetsResponseParams {
        CallSheets: crmmodels.CallSheet[]
    }

    export interface GetAllChannelsByConnectionSourceChannelIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllChannelsResponseParams {
        Channels: crmmodels.Channel[]
    }

    export interface GetAllCompaniesByCompanyBillingInfoCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByCompanyInvoiceCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByCompanyNoteCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByCompanyProductAreaCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByCompanySegmentEntryCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByConnectionReceivingCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByConnectionSourceCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByConnectionTargetCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByContactRoleCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByMeetingCompanyCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByOpportunityCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByOrganizationDocumentOrganizationIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByProductProviderCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByProductUserUserCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesBySkrymContactRoleCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByTaskCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByWorkingTimeLocationCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesByWorkingTimeTypeCompanyIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompaniesResponseParams {
        Companies: crmmodels.Company[]
    }

    export interface GetAllCompanyBillingInfosResponseParams {
        CompanyBillingInfos: crmmodels.CompanyBillingInfo[]
    }

    export interface GetAllCompanyInvoicesResponseParams {
        CompanyInvoices: crmmodels.CompanyInvoice[]
    }

    export interface GetAllCompanyNotesResponseParams {
        CompanyNotes: crmmodels.CompanyNote[]
    }

    export interface GetAllCompanyProductAreaEntriesResponseParams {
        CompanyProductAreaEntries: crmmodels.CompanyProductAreaEntry[]
    }

    export interface GetAllCompanyProductAreasByCompanyProductAreaEntryCompanyAreaIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompanyProductAreasResponseParams {
        CompanyProductAreas: crmmodels.CompanyProductArea[]
    }

    export interface GetAllCompanySegmentEntriesResponseParams {
        CompanySegmentEntries: crmmodels.CompanySegmentEntry[]
    }

    export interface GetAllCompanySegmentsByCompanySegmentEntryCompanySegmentIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompanySegmentsResponseParams {
        CompanySegments: crmmodels.CompanySegment[]
    }

    export interface GetAllCompanyTypesByCompanySegmentTypeIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompanyTypesByCompanyTypeIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllCompanyTypesResponseParams {
        CompanyTypes: crmmodels.CompanyType[]
    }

    export interface GetAllConnectionsResponseParams {
        Connections: crmmodels.Connection[]
    }

    export interface GetAllContactDetailTypesByContactDetailTypeIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactDetailTypesResponseParams {
        ContactDetailTypes: crmmodels.ContactDetailType[]
    }

    export interface GetAllContactDetailsResponseParams {
        ContactDetails: crmmodels.ContactDetail[]
    }

    export interface GetAllContactDocumentsByEmploymentContractRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactDocumentsResponseParams {
        ContactDocuments: crmmodels.ContactDocument[]
    }

    export interface GetAllContactNotesResponseParams {
        ContactNotes: crmmodels.ContactNote[]
    }

    export interface GetAllContactRolesByEmploymentContactRoleIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactRolesByWorkingTimeContactRoleIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactRolesResponseParams {
        ContactRoles: crmmodels.ContactRole[]
    }

    export interface GetAllContactsByCallSheetCallerIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCallSheetCallingIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCallSheetCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCallSheetUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByChannelCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByChannelUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyBillingInfoCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyBillingInfoUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyInvoiceCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyInvoiceUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyNoteCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyNoteUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyProductAreaCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyProductAreaEntryCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyProductAreaEntryUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyProductAreaUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanySegmentCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanySegmentEntryCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanySegmentEntryUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanySegmentUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyTypeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyTypeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByCompanyUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByConnectionCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByConnectionSourceContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByConnectionTargetContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByConnectionUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactDetailContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactDetailCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactDetailTypeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactDetailTypeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactDetailUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactDocumentContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactDocumentCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactDocumentUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactNoteContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactNoteCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactNoteUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactRoleContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactRoleCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByContactRoleUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByDocumentCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByDocumentTypeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByDocumentTypeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByDocumentUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByEmploymentCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByEmploymentUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByEventAttendeeContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByEventAttendeeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByEventAttendeeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByEventCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByEventTypeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByEventTypeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByEventUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByMeetingAttendeeContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByMeetingAttendeeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByMeetingAttendeeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByMeetingCompanyCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByMeetingCompanyUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByMeetingCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByMeetingTypeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByMeetingTypeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByMeetingUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOnCallRoleCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOnCallRoleUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOnCallScheduleContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOnCallScheduleCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOnCallScheduleUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOpportunityCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOpportunityFunnelCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOpportunityFunnelStepCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOpportunityFunnelStepUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOpportunityFunnelUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOpportunityProductCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOpportunityProductUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOpportunityTypeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOpportunityTypeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOpportunityUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOrganizationDocumentCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByOrganizationDocumentUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByProductCategoryCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByProductCategoryUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByProductCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByProductDocumentCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByProductDocumentUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByProductSubcategoryCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByProductSubcategoryUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByProductUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByProductUserCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByProductUserUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySkrymCompanyRoleAreaCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySkrymCompanyRoleAreaUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySkrymCompanyRoleCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySkrymCompanyRoleUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySkrymContactRoleContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySkrymContactRoleCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySkrymContactRoleUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintDailyStandupCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintDailyStandupEntryCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintDailyStandupEntryTeamMemberIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintDailyStandupEntryUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintDailyStandupHostedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintDailyStandupUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintMessageCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintMessageTypeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintMessageTypeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintMessageUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintRoleCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintRoleEntryContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintRoleEntryCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintRoleEntryUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintRoleUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsBySprintUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByTaskCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByTaskOwnerContactIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByTaskOwnerCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByTaskOwnerUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByTaskStatusCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByTaskStatusUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByTaskUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByWorkingTimeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByWorkingTimeLocationCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByWorkingTimeLocationUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByWorkingTimeTypeCreatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByWorkingTimeTypeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsByWorkingTimeUpdatedByRequestParams {
        identifiers: string[]
    }

    export interface GetAllContactsResponseParams {
        Contacts: crmmodels.Contact[]
    }

    export interface GetAllDocumentTypesByDocumentTypeIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllDocumentTypesResponseParams {
        DocumentTypes: crmmodels.DocumentType[]
    }

    export interface GetAllDocumentsByContactDocumentDocumentIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllDocumentsByOrganizationDocumentDocumentIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllDocumentsByProductDocumentDocumentIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllDocumentsResponseParams {
        Documents: crmmodels.Document[]
    }

    export interface GetAllEmploymentsResponseParams {
        Employments: crmmodels.Employment[]
    }

    export interface GetAllEventAttendeesResponseParams {
        EventAttendees: crmmodels.EventAttendee[]
    }

    export interface GetAllEventTypesByEventTypeIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllEventTypesResponseParams {
        EventTypes: crmmodels.EventType[]
    }

    export interface GetAllEventsByConnectionSourceEventIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllEventsByEventAttendeeEventIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllEventsResponseParams {
        Events: crmmodels.Event[]
    }

    export interface GetAllFormSubmissionsResponseParams {
        FormSubmissions: crmmodels.FormSubmission[]
    }

    export interface GetAllMeetingAttendeesResponseParams {
        MeetingAttendees: crmmodels.MeetingAttendee[]
    }

    export interface GetAllMeetingCompaniesResponseParams {
        MeetingCompanies: crmmodels.MeetingCompany[]
    }

    export interface GetAllMeetingTypesByMeetingTypeIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllMeetingTypesResponseParams {
        MeetingTypes: crmmodels.MeetingType[]
    }

    export interface GetAllMeetingsByMeetingAttendeeMeetingIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllMeetingsByMeetingCompanyMeetingIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllMeetingsResponseParams {
        Meetings: crmmodels.Meeting[]
    }

    export interface GetAllNewsletterSignupsResponseParams {
        NewsletterSignups: crmmodels.NewsletterSignup[]
    }

    export interface GetAllOnCallRolesByOnCallScheduleRoleIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllOnCallRolesResponseParams {
        OnCallRoles: crmmodels.OnCallRole[]
    }

    export interface GetAllOnCallSchedulesResponseParams {
        OnCallSchedules: crmmodels.OnCallSchedule[]
    }

    export interface GetAllOpportunitiesByOpportunityProductOpportunityIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllOpportunitiesResponseParams {
        Opportunities: crmmodels.Opportunity[]
    }

    export interface GetAllOpportunityFunnelStepsByOpportunityFunnelStepIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllOpportunityFunnelStepsResponseParams {
        OpportunityFunnelSteps: crmmodels.OpportunityFunnelStep[]
    }

    export interface GetAllOpportunityFunnelsByOpportunityFunnelStepOpportunityFunnelIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllOpportunityFunnelsResponseParams {
        OpportunityFunnels: crmmodels.OpportunityFunnel[]
    }

    export interface GetAllOpportunityProductsResponseParams {
        OpportunityProducts: crmmodels.OpportunityProduct[]
    }

    export interface GetAllOpportunityTypesByOpportunityFunnelOpportunityTypeIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllOpportunityTypesByOpportunityOpportunityTypeIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllOpportunityTypesResponseParams {
        OpportunityTypes: crmmodels.OpportunityType[]
    }

    export interface GetAllOrganizationDocumentsResponseParams {
        OrganizationDocuments: crmmodels.OrganizationDocument[]
    }

    export interface GetAllProductCategoriesByProductProductCategoryIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllProductCategoriesByProductSubcategoryParentCategoryIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllProductCategoriesResponseParams {
        ProductCategories: crmmodels.ProductCategory[]
    }

    export interface GetAllProductDocumentsResponseParams {
        ProductDocuments: crmmodels.ProductDocument[]
    }

    export interface GetAllProductSubcategoriesByProductProductSubcategoryIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllProductSubcategoriesResponseParams {
        ProductSubcategories: crmmodels.ProductSubcategory[]
    }

    export interface GetAllProductUsersResponseParams {
        ProductUsers: crmmodels.ProductUser[]
    }

    export interface GetAllProductsByCompanyProductAreaEntryProductIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllProductsByOpportunityProductProductIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllProductsByProductDocumentProductIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllProductsByProductUserProductIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllProductsResponseParams {
        Products: crmmodels.Product[]
    }

    export interface GetAllSkrymCompanyRoleAreasBySkrymCompanyRoleAreaIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllSkrymCompanyRoleAreasResponseParams {
        SkrymCompanyRoleAreas: crmmodels.SkrymCompanyRoleArea[]
    }

    export interface GetAllSkrymCompanyRolesBySkrymContactRoleCompanyRoleIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllSkrymCompanyRolesResponseParams {
        SkrymCompanyRoles: crmmodels.SkrymCompanyRole[]
    }

    export interface GetAllSkrymContactRolesResponseParams {
        SkrymContactRoles: crmmodels.SkrymContactRole[]
    }

    export interface GetAllSprintDailyStandupEntriesResponseParams {
        SprintDailyStandupEntries: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetAllSprintDailyStandupsBySprintDailyStandupEntryStandupIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllSprintDailyStandupsResponseParams {
        SprintDailyStandups: crmmodels.SprintDailyStandup[]
    }

    export interface GetAllSprintMessageTypesBySprintMessageMessageTypeIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllSprintMessageTypesResponseParams {
        SprintMessageTypes: crmmodels.SprintMessageType[]
    }

    export interface GetAllSprintMessagesResponseParams {
        SprintMessages: crmmodels.SprintMessage[]
    }

    export interface GetAllSprintRoleEntriesResponseParams {
        SprintRoleEntries: crmmodels.SprintRoleEntry[]
    }

    export interface GetAllSprintRolesBySprintRoleEntrySprintRoleIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllSprintRolesResponseParams {
        SprintRoles: crmmodels.SprintRole[]
    }

    export interface GetAllSprintsBySprintDailyStandupSprintIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllSprintsBySprintMessageSprintIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllSprintsBySprintRoleEntrySprintIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllSprintsResponseParams {
        Sprints: crmmodels.Sprint[]
    }

    export interface GetAllTaskOwnersResponseParams {
        TaskOwners: crmmodels.TaskOwner[]
    }

    export interface GetAllTaskStatusesByTaskStatusIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllTaskStatusesResponseParams {
        TaskStatuses: crmmodels.TaskStatus[]
    }

    export interface GetAllTasksByTaskOwnerTaskIdRequestParams {
        identifiers: string[]
    }

    export interface GetAllTasksForTaskOwnerRequestParams {
        taskOwner: string
        /**
         * By default false
         */
        includeCompleted?: boolean
    }

    export interface GetAllTasksForTaskOwnerResponse {
        tasks: crmmodels.TaskWithCompanyAndStatusInfo[]
    }

    export interface GetAllTasksResponseParams {
        Tasks: crmmodels.Task[]
    }

    export interface GetAllWorkingTimeLocationsByWorkingTimeLocationRequestParams {
        identifiers: string[]
    }

    export interface GetAllWorkingTimeLocationsResponseParams {
        WorkingTimeLocations: crmmodels.WorkingTimeLocation[]
    }

    export interface GetAllWorkingTimeTypesByWorkingTimeTypeRequestParams {
        identifiers: string[]
    }

    export interface GetAllWorkingTimeTypesResponseParams {
        WorkingTimeTypes: crmmodels.WorkingTimeType[]
    }

    export interface GetAllWorkingTimesResponseParams {
        WorkingTimes: crmmodels.WorkingTime[]
    }

    /**
     * Parameters required for executing a soft delete of CallSheet
     */
    export interface GetCallSheetAuditByIdRequestParams {
        /**
         * Primary identifier for the CallSheet to fetch history for
         */
        id: string
    }

    export interface GetCallSheetAuditResponseParams {
        CallSheetAudit: crmmodels.CallSheet[]
    }

    /**
     * Parameters required for executing a soft delete of CallSheet
     */
    export interface GetCallSheetByIdRequestParams {
        /**
         * Primary identifier for the CallSheet to be fetched
         */
        id: string
    }

    export interface GetCallSheetByIdResponseParams {
        CallSheet: crmmodels.CallSheet
    }

    export interface GetCallSheetsByCallerIdRequestParams {
        CallerId: string
    }

    export interface GetCallSheetsByCallerIdResponseParams {
        CallSheetList: crmmodels.CallSheet[]
    }

    export interface GetCallSheetsByCallingIdRequestParams {
        CallingId: string
    }

    export interface GetCallSheetsByCallingIdResponseParams {
        CallSheetList: crmmodels.CallSheet[]
    }

    export interface GetCallSheetsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCallSheetsByCreatedAtResponseParams {
        CallSheetList: crmmodels.CallSheet[]
    }

    export interface GetCallSheetsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetCallSheetsByCreatedByResponseParams {
        CallSheetList: crmmodels.CallSheet[]
    }

    export interface GetCallSheetsByDayRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCallSheetsByDayResponseParams {
        CallSheetList: crmmodels.CallSheet[]
    }

    export interface GetCallSheetsByIsCompletedRequestParams {
        IsCompleted: boolean
    }

    export interface GetCallSheetsByIsCompletedResponseParams {
        CallSheetList: crmmodels.CallSheet[]
    }

    export interface GetCallSheetsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetCallSheetsByIsDeletedResponseParams {
        CallSheetList: crmmodels.CallSheet[]
    }

    export interface GetCallSheetsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCallSheetsByUpdatedAtResponseParams {
        CallSheetList: crmmodels.CallSheet[]
    }

    export interface GetCallSheetsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetCallSheetsByUpdatedByResponseParams {
        CallSheetList: crmmodels.CallSheet[]
    }

    /**
     * Parameters required for executing a soft delete of Channel
     */
    export interface GetChannelAuditByIdRequestParams {
        /**
         * Primary identifier for the Channel to fetch history for
         */
        id: string
    }

    export interface GetChannelAuditResponseParams {
        ChannelAudit: crmmodels.Channel[]
    }

    /**
     * Parameters required for executing a soft delete of Channel
     */
    export interface GetChannelByIdRequestParams {
        /**
         * Primary identifier for the Channel to be fetched
         */
        id: string
    }

    export interface GetChannelByIdResponseParams {
        Channel: crmmodels.Channel
    }

    export interface GetCompaniesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetCompaniesByIsDeletedResponseParams {
        CompanyList: crmmodels.Company[]
    }

    export interface GetCompaniesByNameRequestParams {
        Name: string
    }

    export interface GetCompaniesByNameResponseParams {
        CompanyList: crmmodels.Company[]
    }

    export interface GetCompaniesByTypeIdRequestParams {
        TypeId: string
    }

    export interface GetCompaniesByTypeIdResponseParams {
        CompanyList: crmmodels.Company[]
    }

    /**
     * Parameters required for executing a soft delete of Company
     */
    export interface GetCompanyAuditByIdRequestParams {
        /**
         * Primary identifier for the Company to fetch history for
         */
        id: string
    }

    export interface GetCompanyAuditResponseParams {
        CompanyAudit: crmmodels.Company[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyBillingInfo
     */
    export interface GetCompanyBillingInfoAuditByIdRequestParams {
        /**
         * Primary identifier for the CompanyBillingInfo to fetch history for
         */
        id: string
    }

    export interface GetCompanyBillingInfoAuditResponseParams {
        CompanyBillingInfoAudit: crmmodels.CompanyBillingInfo[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyBillingInfo
     */
    export interface GetCompanyBillingInfoByIdRequestParams {
        /**
         * Primary identifier for the CompanyBillingInfo to be fetched
         */
        id: string
    }

    export interface GetCompanyBillingInfoByIdResponseParams {
        CompanyBillingInfo: crmmodels.CompanyBillingInfo
    }

    export interface GetCompanyBillingInfosByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetCompanyBillingInfosByCompanyIdResponseParams {
        CompanyBillingInfoList: crmmodels.CompanyBillingInfo[]
    }

    export interface GetCompanyBillingInfosByCompanyInvoiceEmailRequestParams {
        CompanyInvoiceEmail: string
    }

    export interface GetCompanyBillingInfosByCompanyInvoiceEmailResponseParams {
        CompanyBillingInfoList: crmmodels.CompanyBillingInfo[]
    }

    export interface GetCompanyBillingInfosByCompanyRegisteredLocationRequestParams {
        CompanyRegisteredLocation: string
    }

    export interface GetCompanyBillingInfosByCompanyRegisteredLocationResponseParams {
        CompanyBillingInfoList: crmmodels.CompanyBillingInfo[]
    }

    export interface GetCompanyBillingInfosByCompanyRegistrationNoRequestParams {
        CompanyRegistrationNo: string
    }

    export interface GetCompanyBillingInfosByCompanyRegistrationNoResponseParams {
        CompanyBillingInfoList: crmmodels.CompanyBillingInfo[]
    }

    export interface GetCompanyBillingInfosByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyBillingInfosByCreatedAtResponseParams {
        CompanyBillingInfoList: crmmodels.CompanyBillingInfo[]
    }

    export interface GetCompanyBillingInfosByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetCompanyBillingInfosByCreatedByResponseParams {
        CompanyBillingInfoList: crmmodels.CompanyBillingInfo[]
    }

    export interface GetCompanyBillingInfosByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetCompanyBillingInfosByIsDeletedResponseParams {
        CompanyBillingInfoList: crmmodels.CompanyBillingInfo[]
    }

    export interface GetCompanyBillingInfosByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyBillingInfosByUpdatedAtResponseParams {
        CompanyBillingInfoList: crmmodels.CompanyBillingInfo[]
    }

    export interface GetCompanyBillingInfosByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetCompanyBillingInfosByUpdatedByResponseParams {
        CompanyBillingInfoList: crmmodels.CompanyBillingInfo[]
    }

    /**
     * Parameters required for executing a soft delete of Company
     */
    export interface GetCompanyByIdRequestParams {
        /**
         * Primary identifier for the Company to be fetched
         */
        id: string
    }

    export interface GetCompanyByIdResponseParams {
        Company: crmmodels.Company
    }

    /**
     * Parameters required for executing a soft delete of CompanyInvoice
     */
    export interface GetCompanyInvoiceAuditByIdRequestParams {
        /**
         * Primary identifier for the CompanyInvoice to fetch history for
         */
        id: string
    }

    export interface GetCompanyInvoiceAuditResponseParams {
        CompanyInvoiceAudit: crmmodels.CompanyInvoice[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyInvoice
     */
    export interface GetCompanyInvoiceByIdRequestParams {
        /**
         * Primary identifier for the CompanyInvoice to be fetched
         */
        id: string
    }

    export interface GetCompanyInvoiceByIdResponseParams {
        CompanyInvoice: crmmodels.CompanyInvoice
    }

    export interface GetCompanyInvoicesByAmountSekRequestParams {
        min?: number
        max?: number
    }

    export interface GetCompanyInvoicesByAmountSekResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetCompanyInvoicesByCompanyIdResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyInvoicesByCreatedAtResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetCompanyInvoicesByCreatedByResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByDueDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyInvoicesByDueDateResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByInvoicePeriodEndRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyInvoicesByInvoicePeriodEndResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByInvoicePeriodStartRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyInvoicesByInvoicePeriodStartResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByInvoiceUrlRequestParams {
        InvoiceUrl: string
    }

    export interface GetCompanyInvoicesByInvoiceUrlResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetCompanyInvoicesByIsDeletedResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByIsPaidRequestParams {
        IsPaid: boolean
    }

    export interface GetCompanyInvoicesByIsPaidResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByNameRequestParams {
        Name: string
    }

    export interface GetCompanyInvoicesByNameResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesBySentDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyInvoicesBySentDateResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyInvoicesByUpdatedAtResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyInvoicesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetCompanyInvoicesByUpdatedByResponseParams {
        CompanyInvoiceList: crmmodels.CompanyInvoice[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyNote
     */
    export interface GetCompanyNoteAuditByIdRequestParams {
        /**
         * Primary identifier for the CompanyNote to fetch history for
         */
        id: string
    }

    export interface GetCompanyNoteAuditResponseParams {
        CompanyNoteAudit: crmmodels.CompanyNote[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyNote
     */
    export interface GetCompanyNoteByIdRequestParams {
        /**
         * Primary identifier for the CompanyNote to be fetched
         */
        id: string
    }

    export interface GetCompanyNoteByIdResponseParams {
        CompanyNote: crmmodels.CompanyNote
    }

    export interface GetCompanyNotesByCompanyIdRequestParams {
        CompanyId: string
        Limit: number
    }

    export interface GetCompanyNotesByCompanyIdResponseParams {
        CompanyNoteList: crmmodels.CompanyNote[]
    }

    export interface GetCompanyNotesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyNotesByCreatedAtResponseParams {
        CompanyNoteList: crmmodels.CompanyNote[]
    }

    export interface GetCompanyNotesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetCompanyNotesByCreatedByResponseParams {
        CompanyNoteList: crmmodels.CompanyNote[]
    }

    export interface GetCompanyNotesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetCompanyNotesByIsDeletedResponseParams {
        CompanyNoteList: crmmodels.CompanyNote[]
    }

    export interface GetCompanyNotesByMessageRequestParams {
        Message: string
    }

    export interface GetCompanyNotesByMessageResponseParams {
        CompanyNoteList: crmmodels.CompanyNote[]
    }

    export interface GetCompanyNotesByTitleRequestParams {
        Title: string
    }

    export interface GetCompanyNotesByTitleResponseParams {
        CompanyNoteList: crmmodels.CompanyNote[]
    }

    export interface GetCompanyNotesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyNotesByUpdatedAtResponseParams {
        CompanyNoteList: crmmodels.CompanyNote[]
    }

    export interface GetCompanyNotesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetCompanyNotesByUpdatedByResponseParams {
        CompanyNoteList: crmmodels.CompanyNote[]
    }

    /**
     * Parameters required for executing a soft delete of Company
     */
    export interface GetCompanyPageDataByIdRequest {
        /**
         * Primary identifier for the Company to be fetched
         */
        Id: string
    }

    /**
     * Parameters required for executing a soft delete of Company
     */
    export interface GetCompanyPageDataByIdRequestParams {
        /**
         * Primary identifier for the Company to be fetched
         */
        Id: string
    }

    export interface GetCompanyPageDataByIdResponse {
        Company: crmmodels.Company
        CompanyType: crmmodels.CompanyType
        Notes: crmmodels.CompanyNote[]
        Contacts: crmmodels.ContactRole[]
        Tasks: crmmodels.Task[]
        Customization?: models.Customization
        Logo?: models.OrganizationLogo
        Documents: crmmodels.Document[]
        Opportunities: crmmodels.Opportunity[]
        ProvidingProducts: crmmodels.Product[]
        UsingProducts: crmmodels.ProductUser[]
        Meetings: crmmodels.MeetingWithAttendees[]
        Responsible: crmmodels.SkrymContactRole[]
        Invoices: crmmodels.CompanyInvoice[]
    }

    export interface GetCompanyPageDataByIdResponseParams {
        Company: crmmodels.Company
        CompanyType: crmmodels.CompanyType
        Notes: crmmodels.CompanyNote[]
        Contacts: crmmodels.ContactRole[]
        Tasks: crmmodels.Task[]
        Customization: models.Customization
        Documents: crmmodels.Document[]
        Opportunities: crmmodels.Opportunity[]
        ProvidingProducts: crmmodels.Product[]
        UsingProducts: crmmodels.ProductUser[]
        Meetings: crmmodels.Meeting[]
        Responsible: crmmodels.SkrymContactRole[]
        Invoices: crmmodels.CompanyInvoice[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyProductArea
     */
    export interface GetCompanyProductAreaAuditByIdRequestParams {
        /**
         * Primary identifier for the CompanyProductArea to fetch history for
         */
        id: string
    }

    export interface GetCompanyProductAreaAuditResponseParams {
        CompanyProductAreaAudit: crmmodels.CompanyProductArea[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyProductArea
     */
    export interface GetCompanyProductAreaByIdRequestParams {
        /**
         * Primary identifier for the CompanyProductArea to be fetched
         */
        id: string
    }

    export interface GetCompanyProductAreaByIdResponseParams {
        CompanyProductArea: crmmodels.CompanyProductArea
    }

    export interface GetCompanyProductAreaEntriesByCompanyAreaIdRequestParams {
        CompanyAreaId: string
    }

    export interface GetCompanyProductAreaEntriesByCompanyAreaIdResponseParams {
        CompanyProductAreaEntryList: crmmodels.CompanyProductAreaEntry[]
    }

    export interface GetCompanyProductAreaEntriesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyProductAreaEntriesByCreatedAtResponseParams {
        CompanyProductAreaEntryList: crmmodels.CompanyProductAreaEntry[]
    }

    export interface GetCompanyProductAreaEntriesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetCompanyProductAreaEntriesByCreatedByResponseParams {
        CompanyProductAreaEntryList: crmmodels.CompanyProductAreaEntry[]
    }

    export interface GetCompanyProductAreaEntriesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetCompanyProductAreaEntriesByIsDeletedResponseParams {
        CompanyProductAreaEntryList: crmmodels.CompanyProductAreaEntry[]
    }

    export interface GetCompanyProductAreaEntriesByProductIdRequestParams {
        ProductId: string
    }

    export interface GetCompanyProductAreaEntriesByProductIdResponseParams {
        CompanyProductAreaEntryList: crmmodels.CompanyProductAreaEntry[]
    }

    export interface GetCompanyProductAreaEntriesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyProductAreaEntriesByUpdatedAtResponseParams {
        CompanyProductAreaEntryList: crmmodels.CompanyProductAreaEntry[]
    }

    export interface GetCompanyProductAreaEntriesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetCompanyProductAreaEntriesByUpdatedByResponseParams {
        CompanyProductAreaEntryList: crmmodels.CompanyProductAreaEntry[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyProductAreaEntry
     */
    export interface GetCompanyProductAreaEntryAuditByIdRequestParams {
        /**
         * Primary identifier for the CompanyProductAreaEntry to fetch history for
         */
        id: string
    }

    export interface GetCompanyProductAreaEntryAuditResponseParams {
        CompanyProductAreaEntryAudit: crmmodels.CompanyProductAreaEntry[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyProductAreaEntry
     */
    export interface GetCompanyProductAreaEntryByIdRequestParams {
        /**
         * Primary identifier for the CompanyProductAreaEntry to be fetched
         */
        id: string
    }

    export interface GetCompanyProductAreaEntryByIdResponseParams {
        CompanyProductAreaEntry: crmmodels.CompanyProductAreaEntry
    }

    export interface GetCompanyProductAreasByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetCompanyProductAreasByCompanyIdResponseParams {
        CompanyProductAreaList: crmmodels.CompanyProductArea[]
    }

    export interface GetCompanyProductAreasByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyProductAreasByCreatedAtResponseParams {
        CompanyProductAreaList: crmmodels.CompanyProductArea[]
    }

    export interface GetCompanyProductAreasByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetCompanyProductAreasByCreatedByResponseParams {
        CompanyProductAreaList: crmmodels.CompanyProductArea[]
    }

    export interface GetCompanyProductAreasByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetCompanyProductAreasByIsDeletedResponseParams {
        CompanyProductAreaList: crmmodels.CompanyProductArea[]
    }

    export interface GetCompanyProductAreasByNameRequestParams {
        Name: string
    }

    export interface GetCompanyProductAreasByNameResponseParams {
        CompanyProductAreaList: crmmodels.CompanyProductArea[]
    }

    export interface GetCompanyProductAreasByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanyProductAreasByUpdatedAtResponseParams {
        CompanyProductAreaList: crmmodels.CompanyProductArea[]
    }

    export interface GetCompanyProductAreasByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetCompanyProductAreasByUpdatedByResponseParams {
        CompanyProductAreaList: crmmodels.CompanyProductArea[]
    }

    /**
     * Parameters required for executing a soft delete of CompanySegment
     */
    export interface GetCompanySegmentAuditByIdRequestParams {
        /**
         * Primary identifier for the CompanySegment to fetch history for
         */
        id: string
    }

    export interface GetCompanySegmentAuditResponseParams {
        CompanySegmentAudit: crmmodels.CompanySegment[]
    }

    /**
     * Parameters required for executing a soft delete of CompanySegment
     */
    export interface GetCompanySegmentByIdRequestParams {
        /**
         * Primary identifier for the CompanySegment to be fetched
         */
        id: string
    }

    export interface GetCompanySegmentByIdResponseParams {
        CompanySegment: crmmodels.CompanySegment
    }

    export interface GetCompanySegmentEntriesByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetCompanySegmentEntriesByCompanyIdResponseParams {
        CompanySegmentEntryList: crmmodels.CompanySegmentEntry[]
    }

    export interface GetCompanySegmentEntriesByCompanySegmentIdRequestParams {
        CompanySegmentId: string
    }

    export interface GetCompanySegmentEntriesByCompanySegmentIdResponseParams {
        CompanySegmentEntryList: crmmodels.CompanySegmentEntry[]
    }

    export interface GetCompanySegmentEntriesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanySegmentEntriesByCreatedAtResponseParams {
        CompanySegmentEntryList: crmmodels.CompanySegmentEntry[]
    }

    export interface GetCompanySegmentEntriesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetCompanySegmentEntriesByCreatedByResponseParams {
        CompanySegmentEntryList: crmmodels.CompanySegmentEntry[]
    }

    export interface GetCompanySegmentEntriesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetCompanySegmentEntriesByIsDeletedResponseParams {
        CompanySegmentEntryList: crmmodels.CompanySegmentEntry[]
    }

    export interface GetCompanySegmentEntriesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetCompanySegmentEntriesByUpdatedAtResponseParams {
        CompanySegmentEntryList: crmmodels.CompanySegmentEntry[]
    }

    export interface GetCompanySegmentEntriesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetCompanySegmentEntriesByUpdatedByResponseParams {
        CompanySegmentEntryList: crmmodels.CompanySegmentEntry[]
    }

    /**
     * Parameters required for executing a soft delete of CompanySegmentEntry
     */
    export interface GetCompanySegmentEntryAuditByIdRequestParams {
        /**
         * Primary identifier for the CompanySegmentEntry to fetch history for
         */
        id: string
    }

    export interface GetCompanySegmentEntryAuditResponseParams {
        CompanySegmentEntryAudit: crmmodels.CompanySegmentEntry[]
    }

    /**
     * Parameters required for executing a soft delete of CompanySegmentEntry
     */
    export interface GetCompanySegmentEntryByIdRequestParams {
        /**
         * Primary identifier for the CompanySegmentEntry to be fetched
         */
        id: string
    }

    export interface GetCompanySegmentEntryByIdResponseParams {
        CompanySegmentEntry: crmmodels.CompanySegmentEntry
    }

    export interface GetCompanySegmentsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetCompanySegmentsByIsDeletedResponseParams {
        CompanySegmentList: crmmodels.CompanySegment[]
    }

    export interface GetCompanySegmentsByNameRequestParams {
        Name: string
    }

    export interface GetCompanySegmentsByNameResponseParams {
        CompanySegmentList: crmmodels.CompanySegment[]
    }

    export interface GetCompanySegmentsByTypeIdRequestParams {
        TypeId: string
    }

    export interface GetCompanySegmentsByTypeIdResponseParams {
        CompanySegmentList: crmmodels.CompanySegment[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyType
     */
    export interface GetCompanyTypeAuditByIdRequestParams {
        /**
         * Primary identifier for the CompanyType to fetch history for
         */
        id: string
    }

    export interface GetCompanyTypeAuditResponseParams {
        CompanyTypeAudit: crmmodels.CompanyType[]
    }

    /**
     * Parameters required for executing a soft delete of CompanyType
     */
    export interface GetCompanyTypeByIdRequestParams {
        /**
         * Primary identifier for the CompanyType to be fetched
         */
        id: string
    }

    export interface GetCompanyTypeByIdResponseParams {
        CompanyType: crmmodels.CompanyType
    }

    export interface GetCompanyTypesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetCompanyTypesByIsDeletedResponseParams {
        CompanyTypeList: crmmodels.CompanyType[]
    }

    export interface GetCompanyTypesByNameRequestParams {
        Name: string
    }

    export interface GetCompanyTypesByNameResponseParams {
        CompanyTypeList: crmmodels.CompanyType[]
    }

    /**
     * Parameters required for executing a soft delete of Connection
     */
    export interface GetConnectionAuditByIdRequestParams {
        /**
         * Primary identifier for the Connection to fetch history for
         */
        id: string
    }

    export interface GetConnectionAuditResponseParams {
        ConnectionAudit: crmmodels.Connection[]
    }

    /**
     * Parameters required for executing a soft delete of Connection
     */
    export interface GetConnectionByIdRequestParams {
        /**
         * Primary identifier for the Connection to be fetched
         */
        id: string
    }

    export interface GetConnectionByIdResponseParams {
        Connection: crmmodels.Connection
    }

    export interface GetConnectionsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetConnectionsByCreatedAtResponseParams {
        ConnectionList: crmmodels.Connection[]
    }

    export interface GetConnectionsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetConnectionsByIsDeletedResponseParams {
        ConnectionList: crmmodels.Connection[]
    }

    export interface GetConnectionsByReceivingCompanyIdRequestParams {
        ReceivingCompanyId: string
    }

    export interface GetConnectionsByReceivingCompanyIdResponseParams {
        ConnectionList: crmmodels.Connection[]
    }

    export interface GetConnectionsBySourceChannelIdRequestParams {
        SourceChannelId: string
    }

    export interface GetConnectionsBySourceChannelIdResponseParams {
        ConnectionList: crmmodels.Connection[]
    }

    export interface GetConnectionsBySourceCompanyIdRequestParams {
        SourceCompanyId: string
    }

    export interface GetConnectionsBySourceCompanyIdResponseParams {
        ConnectionList: crmmodels.Connection[]
    }

    export interface GetConnectionsBySourceContactIdRequestParams {
        SourceContactId: string
    }

    export interface GetConnectionsBySourceContactIdResponseParams {
        ConnectionList: crmmodels.Connection[]
    }

    export interface GetConnectionsBySourceEventIdRequestParams {
        SourceEventId: string
    }

    export interface GetConnectionsBySourceEventIdResponseParams {
        ConnectionList: crmmodels.Connection[]
    }

    export interface GetConnectionsByTargetCompanyIdRequestParams {
        TargetCompanyId: string
    }

    export interface GetConnectionsByTargetCompanyIdResponseParams {
        ConnectionList: crmmodels.Connection[]
    }

    export interface GetConnectionsByTargetContactIdRequestParams {
        TargetContactId: string
    }

    export interface GetConnectionsByTargetContactIdResponseParams {
        ConnectionList: crmmodels.Connection[]
    }

    export interface GetConnectionsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetConnectionsByUpdatedAtResponseParams {
        ConnectionList: crmmodels.Connection[]
    }

    /**
     * Parameters required for executing a soft delete of Contact
     */
    export interface GetContactAuditByIdRequestParams {
        /**
         * Primary identifier for the Contact to fetch history for
         */
        id: string
    }

    export interface GetContactAuditResponseParams {
        ContactAudit: crmmodels.Contact[]
    }

    /**
     * Parameters required for executing a soft delete of Contact
     */
    export interface GetContactByIdRequestParams {
        /**
         * Primary identifier for the Contact to be fetched
         */
        id: string
    }

    export interface GetContactByIdResponseParams {
        Contact: crmmodels.Contact
    }

    /**
     * Parameters required for executing a soft delete of ContactDetail
     */
    export interface GetContactDetailAuditByIdRequestParams {
        /**
         * Primary identifier for the ContactDetail to fetch history for
         */
        id: string
    }

    export interface GetContactDetailAuditResponseParams {
        ContactDetailAudit: crmmodels.ContactDetail[]
    }

    /**
     * Parameters required for executing a soft delete of ContactDetail
     */
    export interface GetContactDetailByIdRequestParams {
        /**
         * Primary identifier for the ContactDetail to be fetched
         */
        id: string
    }

    export interface GetContactDetailByIdResponseParams {
        ContactDetail: crmmodels.ContactDetail
    }

    /**
     * Parameters required for executing a soft delete of ContactDetailType
     */
    export interface GetContactDetailTypeAuditByIdRequestParams {
        /**
         * Primary identifier for the ContactDetailType to fetch history for
         */
        id: string
    }

    export interface GetContactDetailTypeAuditResponseParams {
        ContactDetailTypeAudit: crmmodels.ContactDetailType[]
    }

    /**
     * Parameters required for executing a soft delete of ContactDetailType
     */
    export interface GetContactDetailTypeByIdRequestParams {
        /**
         * Primary identifier for the ContactDetailType to be fetched
         */
        id: string
    }

    export interface GetContactDetailTypeByIdResponseParams {
        ContactDetailType: crmmodels.ContactDetailType
    }

    export interface GetContactDetailTypesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactDetailTypesByCreatedAtResponseParams {
        ContactDetailTypeList: crmmodels.ContactDetailType[]
    }

    export interface GetContactDetailTypesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetContactDetailTypesByCreatedByResponseParams {
        ContactDetailTypeList: crmmodels.ContactDetailType[]
    }

    export interface GetContactDetailTypesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetContactDetailTypesByIsDeletedResponseParams {
        ContactDetailTypeList: crmmodels.ContactDetailType[]
    }

    export interface GetContactDetailTypesByNameRequestParams {
        Name: string
    }

    export interface GetContactDetailTypesByNameResponseParams {
        ContactDetailTypeList: crmmodels.ContactDetailType[]
    }

    export interface GetContactDetailTypesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactDetailTypesByUpdatedAtResponseParams {
        ContactDetailTypeList: crmmodels.ContactDetailType[]
    }

    export interface GetContactDetailTypesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetContactDetailTypesByUpdatedByResponseParams {
        ContactDetailTypeList: crmmodels.ContactDetailType[]
    }

    export interface GetContactDetailsByActiveRequestParams {
        Active: boolean
    }

    export interface GetContactDetailsByActiveResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    export interface GetContactDetailsByContactIdRequestParams {
        ContactId: string
    }

    export interface GetContactDetailsByContactIdResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    export interface GetContactDetailsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactDetailsByCreatedAtResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    export interface GetContactDetailsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetContactDetailsByCreatedByResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    export interface GetContactDetailsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetContactDetailsByIsDeletedResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    export interface GetContactDetailsByIsPrimaryRequestParams {
        IsPrimary: boolean
    }

    export interface GetContactDetailsByIsPrimaryResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    export interface GetContactDetailsByLabelRequestParams {
        Label: string
    }

    export interface GetContactDetailsByLabelResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    export interface GetContactDetailsByTypeIdRequestParams {
        TypeId: string
    }

    export interface GetContactDetailsByTypeIdResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    export interface GetContactDetailsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactDetailsByUpdatedAtResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    export interface GetContactDetailsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetContactDetailsByUpdatedByResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    export interface GetContactDetailsByValueRequestParams {
        Value: string
    }

    export interface GetContactDetailsByValueResponseParams {
        ContactDetailList: crmmodels.ContactDetail[]
    }

    /**
     * Parameters required for executing a soft delete of ContactDocument
     */
    export interface GetContactDocumentAuditByIdRequestParams {
        /**
         * Primary identifier for the ContactDocument to fetch history for
         */
        id: string
    }

    export interface GetContactDocumentAuditResponseParams {
        ContactDocumentAudit: crmmodels.ContactDocument[]
    }

    /**
     * Parameters required for executing a soft delete of ContactDocument
     */
    export interface GetContactDocumentByIdRequestParams {
        /**
         * Primary identifier for the ContactDocument to be fetched
         */
        id: string
    }

    export interface GetContactDocumentByIdResponseParams {
        ContactDocument: crmmodels.ContactDocument
    }

    export interface GetContactDocumentsByContactIdRequestParams {
        ContactId: string
    }

    export interface GetContactDocumentsByContactIdResponseParams {
        ContactDocumentList: crmmodels.ContactDocument[]
    }

    export interface GetContactDocumentsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactDocumentsByCreatedAtResponseParams {
        ContactDocumentList: crmmodels.ContactDocument[]
    }

    export interface GetContactDocumentsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetContactDocumentsByCreatedByResponseParams {
        ContactDocumentList: crmmodels.ContactDocument[]
    }

    export interface GetContactDocumentsByDocumentIdRequestParams {
        DocumentId: string
    }

    export interface GetContactDocumentsByDocumentIdResponseParams {
        ContactDocumentList: crmmodels.ContactDocument[]
    }

    export interface GetContactDocumentsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetContactDocumentsByIsDeletedResponseParams {
        ContactDocumentList: crmmodels.ContactDocument[]
    }

    export interface GetContactDocumentsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactDocumentsByUpdatedAtResponseParams {
        ContactDocumentList: crmmodels.ContactDocument[]
    }

    export interface GetContactDocumentsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetContactDocumentsByUpdatedByResponseParams {
        ContactDocumentList: crmmodels.ContactDocument[]
    }

    /**
     * Parameters required for executing a soft delete of ContactNote
     */
    export interface GetContactNoteAuditByIdRequestParams {
        /**
         * Primary identifier for the ContactNote to fetch history for
         */
        id: string
    }

    export interface GetContactNoteAuditResponseParams {
        ContactNoteAudit: crmmodels.ContactNote[]
    }

    /**
     * Parameters required for executing a soft delete of ContactNote
     */
    export interface GetContactNoteByIdRequestParams {
        /**
         * Primary identifier for the ContactNote to be fetched
         */
        id: string
    }

    export interface GetContactNoteByIdResponseParams {
        ContactNote: crmmodels.ContactNote
    }

    export interface GetContactNotesByContactIdRequestParams {
        ContactId: string
    }

    export interface GetContactNotesByContactIdResponseParams {
        ContactNoteList: crmmodels.ContactNote[]
    }

    export interface GetContactNotesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactNotesByCreatedAtResponseParams {
        ContactNoteList: crmmodels.ContactNote[]
    }

    export interface GetContactNotesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetContactNotesByCreatedByResponseParams {
        ContactNoteList: crmmodels.ContactNote[]
    }

    export interface GetContactNotesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetContactNotesByIsDeletedResponseParams {
        ContactNoteList: crmmodels.ContactNote[]
    }

    export interface GetContactNotesByMessageRequestParams {
        Message: string
    }

    export interface GetContactNotesByMessageResponseParams {
        ContactNoteList: crmmodels.ContactNote[]
    }

    export interface GetContactNotesByTitleRequestParams {
        Title: string
    }

    export interface GetContactNotesByTitleResponseParams {
        ContactNoteList: crmmodels.ContactNote[]
    }

    export interface GetContactNotesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactNotesByUpdatedAtResponseParams {
        ContactNoteList: crmmodels.ContactNote[]
    }

    export interface GetContactNotesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetContactNotesByUpdatedByResponseParams {
        ContactNoteList: crmmodels.ContactNote[]
    }

    /**
     * Parameters required for executing a soft delete of ContactRole
     */
    export interface GetContactRoleAuditByIdRequestParams {
        /**
         * Primary identifier for the ContactRole to fetch history for
         */
        id: string
    }

    export interface GetContactRoleAuditResponseParams {
        ContactRoleAudit: crmmodels.ContactRole[]
    }

    /**
     * Parameters required for executing a soft delete of ContactRole
     */
    export interface GetContactRoleByIdRequestParams {
        /**
         * Primary identifier for the ContactRole to be fetched
         */
        id: string
    }

    export interface GetContactRoleByIdResponseParams {
        ContactRole: crmmodels.ContactRole
    }

    export interface GetContactRolesByActiveRequestParams {
        Active: boolean
    }

    export interface GetContactRolesByActiveResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactRolesByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetContactRolesByCompanyIdResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactRolesByContactIdRequestParams {
        ContactId: string
    }

    export interface GetContactRolesByContactIdResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactRolesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactRolesByCreatedAtResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactRolesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetContactRolesByCreatedByResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactRolesByEndDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactRolesByEndDateResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactRolesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetContactRolesByIsDeletedResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactRolesByStartDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactRolesByStartDateResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactRolesByTitleRequestParams {
        Title: string
    }

    export interface GetContactRolesByTitleResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactRolesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactRolesByUpdatedAtResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactRolesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetContactRolesByUpdatedByResponseParams {
        ContactRoleList: crmmodels.ContactRole[]
    }

    export interface GetContactsByBirthdayRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactsByBirthdayResponseParams {
        ContactList: crmmodels.Contact[]
    }

    export interface GetContactsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactsByCreatedAtResponseParams {
        ContactList: crmmodels.Contact[]
    }

    export interface GetContactsByFirstNameRequestParams {
        FirstName: string
    }

    export interface GetContactsByFirstNameResponseParams {
        ContactList: crmmodels.Contact[]
    }

    export interface GetContactsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetContactsByIsDeletedResponseParams {
        ContactList: crmmodels.Contact[]
    }

    export interface GetContactsByLastNameRequestParams {
        LastName: string
    }

    export interface GetContactsByLastNameResponseParams {
        ContactList: crmmodels.Contact[]
    }

    export interface GetContactsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetContactsByUpdatedAtResponseParams {
        ContactList: crmmodels.Contact[]
    }

    export interface GetDevInfoResponse {
        Sprints: crmmodels.Sprint[]
        Standups: crmmodels.SprintDailyStandup[]
        StandupEntries: crmmodels.SprintDailyStandupEntry[]
        SprintMessages: crmmodels.SprintMessage[]
        SprintMessagesTypes: crmmodels.SprintMessageType[]
        SprintRoles: crmmodels.SprintRole[]
        SprintRolesEntries: crmmodels.SprintRoleEntry[]
        OnCallRoles: crmmodels.OnCallRole[]
        OnCallSchedule: crmmodels.OnCallSchedule[]
        Team: crmmodels.Contact[]
    }

    /**
     * Parameters required for executing a soft delete of Document
     */
    export interface GetDocumentAuditByIdRequestParams {
        /**
         * Primary identifier for the Document to fetch history for
         */
        id: string
    }

    export interface GetDocumentAuditResponseParams {
        DocumentAudit: crmmodels.Document[]
    }

    /**
     * Parameters required for executing a soft delete of Document
     */
    export interface GetDocumentByIdRequestParams {
        /**
         * Primary identifier for the Document to be fetched
         */
        id: string
    }

    export interface GetDocumentByIdResponseParams {
        Document: crmmodels.Document
    }

    /**
     * Parameters required for executing a soft delete of DocumentType
     */
    export interface GetDocumentTypeAuditByIdRequestParams {
        /**
         * Primary identifier for the DocumentType to fetch history for
         */
        id: string
    }

    export interface GetDocumentTypeAuditResponseParams {
        DocumentTypeAudit: crmmodels.DocumentType[]
    }

    /**
     * Parameters required for executing a soft delete of DocumentType
     */
    export interface GetDocumentTypeByIdRequestParams {
        /**
         * Primary identifier for the DocumentType to be fetched
         */
        id: string
    }

    export interface GetDocumentTypeByIdResponseParams {
        DocumentType: crmmodels.DocumentType
    }

    export interface GetDocumentTypesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetDocumentTypesByIsDeletedResponseParams {
        DocumentTypeList: crmmodels.DocumentType[]
    }

    export interface GetDocumentTypesByNameRequestParams {
        Name: string
    }

    export interface GetDocumentTypesByNameResponseParams {
        DocumentTypeList: crmmodels.DocumentType[]
    }

    export interface GetDocumentsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetDocumentsByCreatedAtResponseParams {
        DocumentList: crmmodels.Document[]
    }

    export interface GetDocumentsByDocumentDescriptionRequestParams {
        DocumentDescription: string
    }

    export interface GetDocumentsByDocumentDescriptionResponseParams {
        DocumentList: crmmodels.Document[]
    }

    export interface GetDocumentsByDocumentNameRequestParams {
        DocumentName: string
    }

    export interface GetDocumentsByDocumentNameResponseParams {
        DocumentList: crmmodels.Document[]
    }

    export interface GetDocumentsByDocumentUrlRequestParams {
        DocumentUrl: string
    }

    export interface GetDocumentsByDocumentUrlResponseParams {
        DocumentList: crmmodels.Document[]
    }

    export interface GetDocumentsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetDocumentsByIsDeletedResponseParams {
        DocumentList: crmmodels.Document[]
    }

    export interface GetDocumentsByTypeIdRequestParams {
        TypeId: string
    }

    export interface GetDocumentsByTypeIdResponseParams {
        DocumentList: crmmodels.Document[]
    }

    export interface GetDocumentsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetDocumentsByUpdatedAtResponseParams {
        DocumentList: crmmodels.Document[]
    }

    /**
     * Parameters required for executing a soft delete of Employment
     */
    export interface GetEmploymentAuditByIdRequestParams {
        /**
         * Primary identifier for the Employment to fetch history for
         */
        id: string
    }

    export interface GetEmploymentAuditResponseParams {
        EmploymentAudit: crmmodels.Employment[]
    }

    /**
     * Parameters required for executing a soft delete of Employment
     */
    export interface GetEmploymentByIdRequestParams {
        /**
         * Primary identifier for the Employment to be fetched
         */
        id: string
    }

    export interface GetEmploymentByIdResponseParams {
        Employment: crmmodels.Employment
    }

    export interface GetEmploymentsByContactRoleIdRequestParams {
        ContactRoleId: string
    }

    export interface GetEmploymentsByContactRoleIdResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByContractRequestParams {
        Contract: string
    }

    export interface GetEmploymentsByContractResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetEmploymentsByCreatedAtResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetEmploymentsByCreatedByResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByIsActiveRequestParams {
        IsActive: boolean
    }

    export interface GetEmploymentsByIsActiveResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetEmploymentsByIsDeletedResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByIsHourlyRequestParams {
        IsHourly: boolean
    }

    export interface GetEmploymentsByIsHourlyResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByIsMonthlyRequestParams {
        IsMonthly: boolean
    }

    export interface GetEmploymentsByIsMonthlyResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByNameRequestParams {
        Name: string
    }

    export interface GetEmploymentsByNameResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByNoVacationDaysRequestParams {
        NoVacationDays: number
    }

    export interface GetEmploymentsByNoVacationDaysResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsBySalarySekRequestParams {
        SalarySek: number
    }

    export interface GetEmploymentsBySalarySekResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetEmploymentsByUpdatedAtResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    export interface GetEmploymentsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetEmploymentsByUpdatedByResponseParams {
        EmploymentList: crmmodels.Employment[]
    }

    /**
     * Parameters required for executing a soft delete of EventAttendee
     */
    export interface GetEventAttendeeAuditByIdRequestParams {
        /**
         * Primary identifier for the EventAttendee to fetch history for
         */
        id: string
    }

    export interface GetEventAttendeeAuditResponseParams {
        EventAttendeeAudit: crmmodels.EventAttendee[]
    }

    /**
     * Parameters required for executing a soft delete of EventAttendee
     */
    export interface GetEventAttendeeByIdRequestParams {
        /**
         * Primary identifier for the EventAttendee to be fetched
         */
        id: string
    }

    export interface GetEventAttendeeByIdResponseParams {
        EventAttendee: crmmodels.EventAttendee
    }

    export interface GetEventAttendeesByContactIdRequestParams {
        ContactId: string
    }

    export interface GetEventAttendeesByContactIdResponseParams {
        EventAttendeeList: crmmodels.EventAttendee[]
    }

    export interface GetEventAttendeesByEventIdRequestParams {
        EventId: string
    }

    export interface GetEventAttendeesByEventIdResponseParams {
        EventAttendeeList: crmmodels.EventAttendee[]
    }

    export interface GetEventAttendeesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetEventAttendeesByIsDeletedResponseParams {
        EventAttendeeList: crmmodels.EventAttendee[]
    }

    /**
     * Parameters required for executing a soft delete of Event
     */
    export interface GetEventAuditByIdRequestParams {
        /**
         * Primary identifier for the Event to fetch history for
         */
        id: string
    }

    export interface GetEventAuditResponseParams {
        EventAudit: crmmodels.Event[]
    }

    /**
     * Parameters required for executing a soft delete of Event
     */
    export interface GetEventByIdRequestParams {
        /**
         * Primary identifier for the Event to be fetched
         */
        id: string
    }

    export interface GetEventByIdResponseParams {
        Event: crmmodels.Event
    }

    /**
     * Parameters required for executing a soft delete of EventType
     */
    export interface GetEventTypeAuditByIdRequestParams {
        /**
         * Primary identifier for the EventType to fetch history for
         */
        id: string
    }

    export interface GetEventTypeAuditResponseParams {
        EventTypeAudit: crmmodels.EventType[]
    }

    /**
     * Parameters required for executing a soft delete of EventType
     */
    export interface GetEventTypeByIdRequestParams {
        /**
         * Primary identifier for the EventType to be fetched
         */
        id: string
    }

    export interface GetEventTypeByIdResponseParams {
        EventType: crmmodels.EventType
    }

    export interface GetEventTypesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetEventTypesByCreatedByResponseParams {
        EventTypeList: crmmodels.EventType[]
    }

    export interface GetEventTypesByEventTypeRequestParams {
        EventType: string
    }

    export interface GetEventTypesByEventTypeResponseParams {
        EventTypeList: crmmodels.EventType[]
    }

    export interface GetEventTypesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetEventTypesByIsDeletedResponseParams {
        EventTypeList: crmmodels.EventType[]
    }

    export interface GetEventTypesByTypeDescriptionRequestParams {
        TypeDescription: string
    }

    export interface GetEventTypesByTypeDescriptionResponseParams {
        EventTypeList: crmmodels.EventType[]
    }

    export interface GetEventsByEndDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetEventsByEndDateResponseParams {
        EventList: crmmodels.Event[]
    }

    export interface GetEventsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetEventsByIsDeletedResponseParams {
        EventList: crmmodels.Event[]
    }

    export interface GetEventsByNameRequestParams {
        Name: string
    }

    export interface GetEventsByNameResponseParams {
        EventList: crmmodels.Event[]
    }

    export interface GetEventsByStartDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetEventsByStartDateResponseParams {
        EventList: crmmodels.Event[]
    }

    export interface GetEventsByTypeIdRequestParams {
        TypeId: string
    }

    export interface GetEventsByTypeIdResponseParams {
        EventList: crmmodels.Event[]
    }

    export interface GetEventsByUrlRequestParams {
        Url: string
    }

    export interface GetEventsByUrlResponseParams {
        EventList: crmmodels.Event[]
    }

    export interface GetFeedResponse {
        feedItems: FeedItem[]
    }

    /**
     * Parameters required for executing a soft delete of FormSubmission
     */
    export interface GetFormSubmissionAuditByIdRequestParams {
        /**
         * Primary identifier for the FormSubmission to fetch history for
         */
        id: string
    }

    export interface GetFormSubmissionAuditResponseParams {
        FormSubmissionAudit: crmmodels.FormSubmission[]
    }

    /**
     * Parameters required for executing a soft delete of FormSubmission
     */
    export interface GetFormSubmissionByIdRequestParams {
        /**
         * Primary identifier for the FormSubmission to be fetched
         */
        id: string
    }

    export interface GetFormSubmissionByIdResponseParams {
        FormSubmission: crmmodels.FormSubmission
    }

    export interface GetFormSubmissionsByCompanyRequestParams {
        Company: string
    }

    export interface GetFormSubmissionsByCompanyResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetFormSubmissionsByCreatedAtResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByEmailRequestParams {
        Email: string
    }

    export interface GetFormSubmissionsByEmailResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByFormNameRequestParams {
        FormName: string
    }

    export interface GetFormSubmissionsByFormNameResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByFormSubmissionRequestParams {
        FormSubmission: string
    }

    export interface GetFormSubmissionsByFormSubmissionResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByHonungRequestParams {
        Honung: string
    }

    export interface GetFormSubmissionsByHonungResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetFormSubmissionsByIsDeletedResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByMessageRequestParams {
        Message: string
    }

    export interface GetFormSubmissionsByMessageResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByNameRequestParams {
        Name: string
    }

    export interface GetFormSubmissionsByNameResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByPhoneRequestParams {
        Phone: string
    }

    export interface GetFormSubmissionsByPhoneResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByRoleRequestParams {
        Role: string
    }

    export interface GetFormSubmissionsByRoleResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByStatusRequestParams {
        Status: string
    }

    export interface GetFormSubmissionsByStatusResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsBySubjectRequestParams {
        Subject: string
    }

    export interface GetFormSubmissionsBySubjectResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByTimestampRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetFormSubmissionsByTimestampResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    export interface GetFormSubmissionsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetFormSubmissionsByUpdatedAtResponseParams {
        FormSubmissionList: crmmodels.FormSubmission[]
    }

    /**
     * Parameters required for executing a soft delete of MeetingAttendee
     */
    export interface GetMeetingAttendeeAuditByIdRequestParams {
        /**
         * Primary identifier for the MeetingAttendee to fetch history for
         */
        id: string
    }

    export interface GetMeetingAttendeeAuditResponseParams {
        MeetingAttendeeAudit: crmmodels.MeetingAttendee[]
    }

    /**
     * Parameters required for executing a soft delete of MeetingAttendee
     */
    export interface GetMeetingAttendeeByIdRequestParams {
        /**
         * Primary identifier for the MeetingAttendee to be fetched
         */
        id: string
    }

    export interface GetMeetingAttendeeByIdResponseParams {
        MeetingAttendee: crmmodels.MeetingAttendee
    }

    export interface GetMeetingAttendeesByContactIdRequestParams {
        ContactId: string
    }

    export interface GetMeetingAttendeesByContactIdResponseParams {
        MeetingAttendeeList: crmmodels.MeetingAttendee[]
    }

    export interface GetMeetingAttendeesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetMeetingAttendeesByCreatedAtResponseParams {
        MeetingAttendeeList: crmmodels.MeetingAttendee[]
    }

    export interface GetMeetingAttendeesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetMeetingAttendeesByCreatedByResponseParams {
        MeetingAttendeeList: crmmodels.MeetingAttendee[]
    }

    export interface GetMeetingAttendeesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetMeetingAttendeesByIsDeletedResponseParams {
        MeetingAttendeeList: crmmodels.MeetingAttendee[]
    }

    export interface GetMeetingAttendeesByMeetingIdRequestParams {
        MeetingId: string
    }

    export interface GetMeetingAttendeesByMeetingIdResponseParams {
        MeetingAttendeeList: crmmodels.MeetingAttendee[]
    }

    export interface GetMeetingAttendeesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetMeetingAttendeesByUpdatedAtResponseParams {
        MeetingAttendeeList: crmmodels.MeetingAttendee[]
    }

    export interface GetMeetingAttendeesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetMeetingAttendeesByUpdatedByResponseParams {
        MeetingAttendeeList: crmmodels.MeetingAttendee[]
    }

    /**
     * Parameters required for executing a soft delete of Meeting
     */
    export interface GetMeetingAuditByIdRequestParams {
        /**
         * Primary identifier for the Meeting to fetch history for
         */
        id: string
    }

    export interface GetMeetingAuditResponseParams {
        MeetingAudit: crmmodels.Meeting[]
    }

    /**
     * Parameters required for executing a soft delete of Meeting
     */
    export interface GetMeetingByIdRequestParams {
        /**
         * Primary identifier for the Meeting to be fetched
         */
        id: string
    }

    export interface GetMeetingByIdResponseParams {
        Meeting: crmmodels.Meeting
    }

    export interface GetMeetingCompaniesByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetMeetingCompaniesByCompanyIdResponseParams {
        MeetingCompanyList: crmmodels.MeetingCompany[]
    }

    export interface GetMeetingCompaniesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetMeetingCompaniesByCreatedAtResponseParams {
        MeetingCompanyList: crmmodels.MeetingCompany[]
    }

    export interface GetMeetingCompaniesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetMeetingCompaniesByCreatedByResponseParams {
        MeetingCompanyList: crmmodels.MeetingCompany[]
    }

    export interface GetMeetingCompaniesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetMeetingCompaniesByIsDeletedResponseParams {
        MeetingCompanyList: crmmodels.MeetingCompany[]
    }

    export interface GetMeetingCompaniesByMeetingIdRequestParams {
        MeetingId: string
    }

    export interface GetMeetingCompaniesByMeetingIdResponseParams {
        MeetingCompanyList: crmmodels.MeetingCompany[]
    }

    export interface GetMeetingCompaniesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetMeetingCompaniesByUpdatedAtResponseParams {
        MeetingCompanyList: crmmodels.MeetingCompany[]
    }

    export interface GetMeetingCompaniesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetMeetingCompaniesByUpdatedByResponseParams {
        MeetingCompanyList: crmmodels.MeetingCompany[]
    }

    /**
     * Parameters required for executing a soft delete of MeetingCompany
     */
    export interface GetMeetingCompanyAuditByIdRequestParams {
        /**
         * Primary identifier for the MeetingCompany to fetch history for
         */
        id: string
    }

    export interface GetMeetingCompanyAuditResponseParams {
        MeetingCompanyAudit: crmmodels.MeetingCompany[]
    }

    /**
     * Parameters required for executing a soft delete of MeetingCompany
     */
    export interface GetMeetingCompanyByIdRequestParams {
        /**
         * Primary identifier for the MeetingCompany to be fetched
         */
        id: string
    }

    export interface GetMeetingCompanyByIdResponseParams {
        MeetingCompany: crmmodels.MeetingCompany
    }

    /**
     * Parameters required for executing a soft delete of MeetingType
     */
    export interface GetMeetingTypeAuditByIdRequestParams {
        /**
         * Primary identifier for the MeetingType to fetch history for
         */
        id: string
    }

    export interface GetMeetingTypeAuditResponseParams {
        MeetingTypeAudit: crmmodels.MeetingType[]
    }

    /**
     * Parameters required for executing a soft delete of MeetingType
     */
    export interface GetMeetingTypeByIdRequestParams {
        /**
         * Primary identifier for the MeetingType to be fetched
         */
        id: string
    }

    export interface GetMeetingTypeByIdResponseParams {
        MeetingType: crmmodels.MeetingType
    }

    export interface GetMeetingTypesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetMeetingTypesByIsDeletedResponseParams {
        MeetingTypeList: crmmodels.MeetingType[]
    }

    export interface GetMeetingTypesByNameRequestParams {
        Name: string
    }

    export interface GetMeetingTypesByNameResponseParams {
        MeetingTypeList: crmmodels.MeetingType[]
    }

    export interface GetMeetingsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetMeetingsByCreatedAtResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    export interface GetMeetingsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetMeetingsByCreatedByResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    export interface GetMeetingsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetMeetingsByIsDeletedResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    export interface GetMeetingsByMeetingDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetMeetingsByMeetingDateResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    export interface GetMeetingsByMeetingNoteUrlRequestParams {
        MeetingNoteUrl: string
    }

    export interface GetMeetingsByMeetingNoteUrlResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    export interface GetMeetingsByNameRequestParams {
        Name: string
    }

    export interface GetMeetingsByNameResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    export interface GetMeetingsByOrganizationLocationIdRequestParams {
        OrganizationLocationId: string
    }

    export interface GetMeetingsByOrganizationLocationIdResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    export interface GetMeetingsByTypeIdRequestParams {
        TypeId: string
    }

    export interface GetMeetingsByTypeIdResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    export interface GetMeetingsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetMeetingsByUpdatedAtResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    export interface GetMeetingsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetMeetingsByUpdatedByResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    export interface GetMeetingsByVirtualRequestParams {
        Virtual: boolean
    }

    export interface GetMeetingsByVirtualResponseParams {
        MeetingList: crmmodels.Meeting[]
    }

    /**
     * Parameters required for executing a soft delete of NewsletterSignup
     */
    export interface GetNewsletterSignupAuditByIdRequestParams {
        /**
         * Primary identifier for the NewsletterSignup to fetch history for
         */
        id: string
    }

    export interface GetNewsletterSignupAuditResponseParams {
        NewsletterSignupAudit: crmmodels.NewsletterSignup[]
    }

    /**
     * Parameters required for executing a soft delete of NewsletterSignup
     */
    export interface GetNewsletterSignupByIdRequestParams {
        /**
         * Primary identifier for the NewsletterSignup to be fetched
         */
        id: string
    }

    export interface GetNewsletterSignupByIdResponseParams {
        NewsletterSignup: crmmodels.NewsletterSignup
    }

    export interface GetNewsletterSignupsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetNewsletterSignupsByCreatedAtResponseParams {
        NewsletterSignupList: crmmodels.NewsletterSignup[]
    }

    export interface GetNewsletterSignupsByEmailRequestParams {
        Email: string
    }

    export interface GetNewsletterSignupsByEmailResponseParams {
        NewsletterSignupList: crmmodels.NewsletterSignup[]
    }

    export interface GetNewsletterSignupsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetNewsletterSignupsByIsDeletedResponseParams {
        NewsletterSignupList: crmmodels.NewsletterSignup[]
    }

    export interface GetNewsletterSignupsByTimestampRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetNewsletterSignupsByTimestampResponseParams {
        NewsletterSignupList: crmmodels.NewsletterSignup[]
    }

    export interface GetNewsletterSignupsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetNewsletterSignupsByUpdatedAtResponseParams {
        NewsletterSignupList: crmmodels.NewsletterSignup[]
    }

    /**
     * Parameters required for executing a soft delete of OnCallRole
     */
    export interface GetOnCallRoleAuditByIdRequestParams {
        /**
         * Primary identifier for the OnCallRole to fetch history for
         */
        id: string
    }

    export interface GetOnCallRoleAuditResponseParams {
        OnCallRoleAudit: crmmodels.OnCallRole[]
    }

    /**
     * Parameters required for executing a soft delete of OnCallRole
     */
    export interface GetOnCallRoleByIdRequestParams {
        /**
         * Primary identifier for the OnCallRole to be fetched
         */
        id: string
    }

    export interface GetOnCallRoleByIdResponseParams {
        OnCallRole: crmmodels.OnCallRole
    }

    export interface GetOnCallRolesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOnCallRolesByCreatedAtResponseParams {
        OnCallRoleList: crmmodels.OnCallRole[]
    }

    export interface GetOnCallRolesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetOnCallRolesByCreatedByResponseParams {
        OnCallRoleList: crmmodels.OnCallRole[]
    }

    export interface GetOnCallRolesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetOnCallRolesByIsDeletedResponseParams {
        OnCallRoleList: crmmodels.OnCallRole[]
    }

    export interface GetOnCallRolesByMoreInfoUrlRequestParams {
        MoreInfoUrl: string
    }

    export interface GetOnCallRolesByMoreInfoUrlResponseParams {
        OnCallRoleList: crmmodels.OnCallRole[]
    }

    export interface GetOnCallRolesByNameRequestParams {
        Name: string
    }

    export interface GetOnCallRolesByNameResponseParams {
        OnCallRoleList: crmmodels.OnCallRole[]
    }

    export interface GetOnCallRolesByRoleCodeRequestParams {
        RoleCode: string
    }

    export interface GetOnCallRolesByRoleCodeResponseParams {
        OnCallRoleList: crmmodels.OnCallRole[]
    }

    export interface GetOnCallRolesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOnCallRolesByUpdatedAtResponseParams {
        OnCallRoleList: crmmodels.OnCallRole[]
    }

    export interface GetOnCallRolesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetOnCallRolesByUpdatedByResponseParams {
        OnCallRoleList: crmmodels.OnCallRole[]
    }

    /**
     * Parameters required for executing a soft delete of OnCallSchedule
     */
    export interface GetOnCallScheduleAuditByIdRequestParams {
        /**
         * Primary identifier for the OnCallSchedule to fetch history for
         */
        id: string
    }

    export interface GetOnCallScheduleAuditResponseParams {
        OnCallScheduleAudit: crmmodels.OnCallSchedule[]
    }

    /**
     * Parameters required for executing a soft delete of OnCallSchedule
     */
    export interface GetOnCallScheduleByIdRequestParams {
        /**
         * Primary identifier for the OnCallSchedule to be fetched
         */
        id: string
    }

    export interface GetOnCallScheduleByIdResponseParams {
        OnCallSchedule: crmmodels.OnCallSchedule
    }

    export interface GetOnCallSchedulesByContactIdRequestParams {
        ContactId: string
    }

    export interface GetOnCallSchedulesByContactIdResponseParams {
        OnCallScheduleList: crmmodels.OnCallSchedule[]
    }

    export interface GetOnCallSchedulesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOnCallSchedulesByCreatedAtResponseParams {
        OnCallScheduleList: crmmodels.OnCallSchedule[]
    }

    export interface GetOnCallSchedulesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetOnCallSchedulesByCreatedByResponseParams {
        OnCallScheduleList: crmmodels.OnCallSchedule[]
    }

    export interface GetOnCallSchedulesByDurationHoursRequestParams {
        DurationHours: number
    }

    export interface GetOnCallSchedulesByDurationHoursResponseParams {
        OnCallScheduleList: crmmodels.OnCallSchedule[]
    }

    export interface GetOnCallSchedulesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetOnCallSchedulesByIsDeletedResponseParams {
        OnCallScheduleList: crmmodels.OnCallSchedule[]
    }

    export interface GetOnCallSchedulesByRoleIdRequestParams {
        RoleId: string
    }

    export interface GetOnCallSchedulesByRoleIdResponseParams {
        OnCallScheduleList: crmmodels.OnCallSchedule[]
    }

    export interface GetOnCallSchedulesByStartDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOnCallSchedulesByStartDateResponseParams {
        OnCallScheduleList: crmmodels.OnCallSchedule[]
    }

    export interface GetOnCallSchedulesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOnCallSchedulesByUpdatedAtResponseParams {
        OnCallScheduleList: crmmodels.OnCallSchedule[]
    }

    export interface GetOnCallSchedulesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetOnCallSchedulesByUpdatedByResponseParams {
        OnCallScheduleList: crmmodels.OnCallSchedule[]
    }

    export interface GetOpenPRsStatisticsParams {
        from: string
        to: string
    }

    export interface GetOpenPRsStatisticsResponse {
        statistics: crmmodels.OpenPRsStatistics[]
    }

    export interface GetOpportunitiesByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetOpportunitiesByCompanyIdResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunitiesByCreatedAtResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetOpportunitiesByCreatedByResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByEstimatedCloseRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunitiesByEstimatedCloseResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByEstimatedMrrRequestParams {
        min?: number
        max?: number
    }

    export interface GetOpportunitiesByEstimatedMrrResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByFunnelStepIdRequestParams {
        FunnelStepId: string
    }

    export interface GetOpportunitiesByFunnelStepIdResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetOpportunitiesByIsDeletedResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByNameRequestParams {
        Name: string
    }

    export interface GetOpportunitiesByNameResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByOpportunityTypeIdRequestParams {
        OpportunityTypeId: string
    }

    export interface GetOpportunitiesByOpportunityTypeIdResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByProbabilityPercentageRequestParams {
        min?: number
        max?: number
    }

    export interface GetOpportunitiesByProbabilityPercentageResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunitiesByUpdatedAtResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    export interface GetOpportunitiesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetOpportunitiesByUpdatedByResponseParams {
        OpportunityList: crmmodels.Opportunity[]
    }

    /**
     * Parameters required for executing a soft delete of Opportunity
     */
    export interface GetOpportunityAuditByIdRequestParams {
        /**
         * Primary identifier for the Opportunity to fetch history for
         */
        id: string
    }

    export interface GetOpportunityAuditResponseParams {
        OpportunityAudit: crmmodels.Opportunity[]
    }

    /**
     * Parameters required for executing a soft delete of Opportunity
     */
    export interface GetOpportunityByIdRequestParams {
        /**
         * Primary identifier for the Opportunity to be fetched
         */
        id: string
    }

    export interface GetOpportunityByIdResponseParams {
        Opportunity: crmmodels.Opportunity
    }

    /**
     * Parameters required for executing a soft delete of OpportunityFunnel
     */
    export interface GetOpportunityFunnelAuditByIdRequestParams {
        /**
         * Primary identifier for the OpportunityFunnel to fetch history for
         */
        id: string
    }

    export interface GetOpportunityFunnelAuditResponseParams {
        OpportunityFunnelAudit: crmmodels.OpportunityFunnel[]
    }

    /**
     * Parameters required for executing a soft delete of OpportunityFunnel
     */
    export interface GetOpportunityFunnelByIdRequestParams {
        /**
         * Primary identifier for the OpportunityFunnel to be fetched
         */
        id: string
    }

    export interface GetOpportunityFunnelByIdResponseParams {
        OpportunityFunnel: crmmodels.OpportunityFunnel
    }

    /**
     * Parameters required for executing a soft delete of OpportunityFunnelStep
     */
    export interface GetOpportunityFunnelStepAuditByIdRequestParams {
        /**
         * Primary identifier for the OpportunityFunnelStep to fetch history for
         */
        id: string
    }

    export interface GetOpportunityFunnelStepAuditResponseParams {
        OpportunityFunnelStepAudit: crmmodels.OpportunityFunnelStep[]
    }

    /**
     * Parameters required for executing a soft delete of OpportunityFunnelStep
     */
    export interface GetOpportunityFunnelStepByIdRequestParams {
        /**
         * Primary identifier for the OpportunityFunnelStep to be fetched
         */
        id: string
    }

    export interface GetOpportunityFunnelStepByIdResponseParams {
        OpportunityFunnelStep: crmmodels.OpportunityFunnelStep
    }

    export interface GetOpportunityFunnelStepsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunityFunnelStepsByCreatedAtResponseParams {
        OpportunityFunnelStepList: crmmodels.OpportunityFunnelStep[]
    }

    export interface GetOpportunityFunnelStepsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetOpportunityFunnelStepsByCreatedByResponseParams {
        OpportunityFunnelStepList: crmmodels.OpportunityFunnelStep[]
    }

    export interface GetOpportunityFunnelStepsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetOpportunityFunnelStepsByIsDeletedResponseParams {
        OpportunityFunnelStepList: crmmodels.OpportunityFunnelStep[]
    }

    export interface GetOpportunityFunnelStepsByNameRequestParams {
        Name: string
    }

    export interface GetOpportunityFunnelStepsByNameResponseParams {
        OpportunityFunnelStepList: crmmodels.OpportunityFunnelStep[]
    }

    export interface GetOpportunityFunnelStepsByOpportunityFunnelIdRequestParams {
        OpportunityFunnelId: string
    }

    export interface GetOpportunityFunnelStepsByOpportunityFunnelIdResponseParams {
        OpportunityFunnelStepList: crmmodels.OpportunityFunnelStep[]
    }

    export interface GetOpportunityFunnelStepsBySequenceRequestParams {
        Sequence: number
    }

    export interface GetOpportunityFunnelStepsBySequenceResponseParams {
        OpportunityFunnelStepList: crmmodels.OpportunityFunnelStep[]
    }

    export interface GetOpportunityFunnelStepsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunityFunnelStepsByUpdatedAtResponseParams {
        OpportunityFunnelStepList: crmmodels.OpportunityFunnelStep[]
    }

    export interface GetOpportunityFunnelStepsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetOpportunityFunnelStepsByUpdatedByResponseParams {
        OpportunityFunnelStepList: crmmodels.OpportunityFunnelStep[]
    }

    export interface GetOpportunityFunnelsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunityFunnelsByCreatedAtResponseParams {
        OpportunityFunnelList: crmmodels.OpportunityFunnel[]
    }

    export interface GetOpportunityFunnelsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetOpportunityFunnelsByCreatedByResponseParams {
        OpportunityFunnelList: crmmodels.OpportunityFunnel[]
    }

    export interface GetOpportunityFunnelsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetOpportunityFunnelsByIsDeletedResponseParams {
        OpportunityFunnelList: crmmodels.OpportunityFunnel[]
    }

    export interface GetOpportunityFunnelsByNameRequestParams {
        Name: string
    }

    export interface GetOpportunityFunnelsByNameResponseParams {
        OpportunityFunnelList: crmmodels.OpportunityFunnel[]
    }

    export interface GetOpportunityFunnelsByOpportunityTypeIdRequestParams {
        OpportunityTypeId: string
    }

    export interface GetOpportunityFunnelsByOpportunityTypeIdResponseParams {
        OpportunityFunnelList: crmmodels.OpportunityFunnel[]
    }

    export interface GetOpportunityFunnelsBySequenceRequestParams {
        Sequence: number
    }

    export interface GetOpportunityFunnelsBySequenceResponseParams {
        OpportunityFunnelList: crmmodels.OpportunityFunnel[]
    }

    export interface GetOpportunityFunnelsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunityFunnelsByUpdatedAtResponseParams {
        OpportunityFunnelList: crmmodels.OpportunityFunnel[]
    }

    export interface GetOpportunityFunnelsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetOpportunityFunnelsByUpdatedByResponseParams {
        OpportunityFunnelList: crmmodels.OpportunityFunnel[]
    }

    /**
     * Parameters required for executing a soft delete of OpportunityProduct
     */
    export interface GetOpportunityProductAuditByIdRequestParams {
        /**
         * Primary identifier for the OpportunityProduct to fetch history for
         */
        id: string
    }

    export interface GetOpportunityProductAuditResponseParams {
        OpportunityProductAudit: crmmodels.OpportunityProduct[]
    }

    /**
     * Parameters required for executing a soft delete of OpportunityProduct
     */
    export interface GetOpportunityProductByIdRequestParams {
        /**
         * Primary identifier for the OpportunityProduct to be fetched
         */
        id: string
    }

    export interface GetOpportunityProductByIdResponseParams {
        OpportunityProduct: crmmodels.OpportunityProduct
    }

    export interface GetOpportunityProductsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunityProductsByCreatedAtResponseParams {
        OpportunityProductList: crmmodels.OpportunityProduct[]
    }

    export interface GetOpportunityProductsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetOpportunityProductsByCreatedByResponseParams {
        OpportunityProductList: crmmodels.OpportunityProduct[]
    }

    export interface GetOpportunityProductsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetOpportunityProductsByIsDeletedResponseParams {
        OpportunityProductList: crmmodels.OpportunityProduct[]
    }

    export interface GetOpportunityProductsByNoteRequestParams {
        Note: string
    }

    export interface GetOpportunityProductsByNoteResponseParams {
        OpportunityProductList: crmmodels.OpportunityProduct[]
    }

    export interface GetOpportunityProductsByOpportunityIdRequestParams {
        OpportunityId: string
    }

    export interface GetOpportunityProductsByOpportunityIdResponseParams {
        OpportunityProductList: crmmodels.OpportunityProduct[]
    }

    export interface GetOpportunityProductsByProductIdRequestParams {
        ProductId: string
    }

    export interface GetOpportunityProductsByProductIdResponseParams {
        OpportunityProductList: crmmodels.OpportunityProduct[]
    }

    export interface GetOpportunityProductsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunityProductsByUpdatedAtResponseParams {
        OpportunityProductList: crmmodels.OpportunityProduct[]
    }

    export interface GetOpportunityProductsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetOpportunityProductsByUpdatedByResponseParams {
        OpportunityProductList: crmmodels.OpportunityProduct[]
    }

    /**
     * Parameters required for executing a soft delete of OpportunityType
     */
    export interface GetOpportunityTypeAuditByIdRequestParams {
        /**
         * Primary identifier for the OpportunityType to fetch history for
         */
        id: string
    }

    export interface GetOpportunityTypeAuditResponseParams {
        OpportunityTypeAudit: crmmodels.OpportunityType[]
    }

    /**
     * Parameters required for executing a soft delete of OpportunityType
     */
    export interface GetOpportunityTypeByIdRequestParams {
        /**
         * Primary identifier for the OpportunityType to be fetched
         */
        id: string
    }

    export interface GetOpportunityTypeByIdResponseParams {
        OpportunityType: crmmodels.OpportunityType
    }

    export interface GetOpportunityTypesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunityTypesByCreatedAtResponseParams {
        OpportunityTypeList: crmmodels.OpportunityType[]
    }

    export interface GetOpportunityTypesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetOpportunityTypesByCreatedByResponseParams {
        OpportunityTypeList: crmmodels.OpportunityType[]
    }

    export interface GetOpportunityTypesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetOpportunityTypesByIsDeletedResponseParams {
        OpportunityTypeList: crmmodels.OpportunityType[]
    }

    export interface GetOpportunityTypesByNameRequestParams {
        Name: string
    }

    export interface GetOpportunityTypesByNameResponseParams {
        OpportunityTypeList: crmmodels.OpportunityType[]
    }

    export interface GetOpportunityTypesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOpportunityTypesByUpdatedAtResponseParams {
        OpportunityTypeList: crmmodels.OpportunityType[]
    }

    export interface GetOpportunityTypesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetOpportunityTypesByUpdatedByResponseParams {
        OpportunityTypeList: crmmodels.OpportunityType[]
    }

    /**
     * Parameters required for executing a soft delete of OrganizationDocument
     */
    export interface GetOrganizationDocumentAuditByIdRequestParams {
        /**
         * Primary identifier for the OrganizationDocument to fetch history for
         */
        id: string
    }

    export interface GetOrganizationDocumentAuditResponseParams {
        OrganizationDocumentAudit: crmmodels.OrganizationDocument[]
    }

    /**
     * Parameters required for executing a soft delete of OrganizationDocument
     */
    export interface GetOrganizationDocumentByIdRequestParams {
        /**
         * Primary identifier for the OrganizationDocument to be fetched
         */
        id: string
    }

    export interface GetOrganizationDocumentByIdResponseParams {
        OrganizationDocument: crmmodels.OrganizationDocument
    }

    export interface GetOrganizationDocumentsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOrganizationDocumentsByCreatedAtResponseParams {
        OrganizationDocumentList: crmmodels.OrganizationDocument[]
    }

    export interface GetOrganizationDocumentsByDocumentIdRequestParams {
        DocumentId: string
    }

    export interface GetOrganizationDocumentsByDocumentIdResponseParams {
        OrganizationDocumentList: crmmodels.OrganizationDocument[]
    }

    export interface GetOrganizationDocumentsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetOrganizationDocumentsByIsDeletedResponseParams {
        OrganizationDocumentList: crmmodels.OrganizationDocument[]
    }

    export interface GetOrganizationDocumentsByOrganizationIdRequestParams {
        OrganizationId: string
    }

    export interface GetOrganizationDocumentsByOrganizationIdResponseParams {
        OrganizationDocumentList: crmmodels.OrganizationDocument[]
    }

    export interface GetOrganizationDocumentsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetOrganizationDocumentsByUpdatedAtResponseParams {
        OrganizationDocumentList: crmmodels.OrganizationDocument[]
    }

    /**
     * Parameters required for executing a soft delete of Product
     */
    export interface GetProductAuditByIdRequestParams {
        /**
         * Primary identifier for the Product to fetch history for
         */
        id: string
    }

    export interface GetProductAuditResponseParams {
        ProductAudit: crmmodels.Product[]
    }

    /**
     * Parameters required for executing a soft delete of Product
     */
    export interface GetProductByIdRequestParams {
        /**
         * Primary identifier for the Product to be fetched
         */
        id: string
    }

    export interface GetProductByIdResponseParams {
        Product: crmmodels.Product
    }

    export interface GetProductCategoriesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductCategoriesByCreatedAtResponseParams {
        ProductCategoryList: crmmodels.ProductCategory[]
    }

    export interface GetProductCategoriesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetProductCategoriesByCreatedByResponseParams {
        ProductCategoryList: crmmodels.ProductCategory[]
    }

    export interface GetProductCategoriesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetProductCategoriesByIsDeletedResponseParams {
        ProductCategoryList: crmmodels.ProductCategory[]
    }

    export interface GetProductCategoriesByNameRequestParams {
        Name: string
    }

    export interface GetProductCategoriesByNameResponseParams {
        ProductCategoryList: crmmodels.ProductCategory[]
    }

    export interface GetProductCategoriesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductCategoriesByUpdatedAtResponseParams {
        ProductCategoryList: crmmodels.ProductCategory[]
    }

    export interface GetProductCategoriesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetProductCategoriesByUpdatedByResponseParams {
        ProductCategoryList: crmmodels.ProductCategory[]
    }

    /**
     * Parameters required for executing a soft delete of ProductCategory
     */
    export interface GetProductCategoryAuditByIdRequestParams {
        /**
         * Primary identifier for the ProductCategory to fetch history for
         */
        id: string
    }

    export interface GetProductCategoryAuditResponseParams {
        ProductCategoryAudit: crmmodels.ProductCategory[]
    }

    /**
     * Parameters required for executing a soft delete of ProductCategory
     */
    export interface GetProductCategoryByIdRequestParams {
        /**
         * Primary identifier for the ProductCategory to be fetched
         */
        id: string
    }

    export interface GetProductCategoryByIdResponseParams {
        ProductCategory: crmmodels.ProductCategory
    }

    /**
     * Parameters required for executing a soft delete of ProductDocument
     */
    export interface GetProductDocumentAuditByIdRequestParams {
        /**
         * Primary identifier for the ProductDocument to fetch history for
         */
        id: string
    }

    export interface GetProductDocumentAuditResponseParams {
        ProductDocumentAudit: crmmodels.ProductDocument[]
    }

    /**
     * Parameters required for executing a soft delete of ProductDocument
     */
    export interface GetProductDocumentByIdRequestParams {
        /**
         * Primary identifier for the ProductDocument to be fetched
         */
        id: string
    }

    export interface GetProductDocumentByIdResponseParams {
        ProductDocument: crmmodels.ProductDocument
    }

    export interface GetProductDocumentsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductDocumentsByCreatedAtResponseParams {
        ProductDocumentList: crmmodels.ProductDocument[]
    }

    export interface GetProductDocumentsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetProductDocumentsByCreatedByResponseParams {
        ProductDocumentList: crmmodels.ProductDocument[]
    }

    export interface GetProductDocumentsByDocumentIdRequestParams {
        DocumentId: string
    }

    export interface GetProductDocumentsByDocumentIdResponseParams {
        ProductDocumentList: crmmodels.ProductDocument[]
    }

    export interface GetProductDocumentsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetProductDocumentsByIsDeletedResponseParams {
        ProductDocumentList: crmmodels.ProductDocument[]
    }

    export interface GetProductDocumentsByProductIdRequestParams {
        ProductId: string
    }

    export interface GetProductDocumentsByProductIdResponseParams {
        ProductDocumentList: crmmodels.ProductDocument[]
    }

    export interface GetProductDocumentsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductDocumentsByUpdatedAtResponseParams {
        ProductDocumentList: crmmodels.ProductDocument[]
    }

    export interface GetProductDocumentsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetProductDocumentsByUpdatedByResponseParams {
        ProductDocumentList: crmmodels.ProductDocument[]
    }

    export interface GetProductSubcategoriesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductSubcategoriesByCreatedAtResponseParams {
        ProductSubcategoryList: crmmodels.ProductSubcategory[]
    }

    export interface GetProductSubcategoriesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetProductSubcategoriesByCreatedByResponseParams {
        ProductSubcategoryList: crmmodels.ProductSubcategory[]
    }

    export interface GetProductSubcategoriesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetProductSubcategoriesByIsDeletedResponseParams {
        ProductSubcategoryList: crmmodels.ProductSubcategory[]
    }

    export interface GetProductSubcategoriesByNameRequestParams {
        Name: string
    }

    export interface GetProductSubcategoriesByNameResponseParams {
        ProductSubcategoryList: crmmodels.ProductSubcategory[]
    }

    export interface GetProductSubcategoriesByParentCategoryIdRequestParams {
        ParentCategoryId: string
    }

    export interface GetProductSubcategoriesByParentCategoryIdResponseParams {
        ProductSubcategoryList: crmmodels.ProductSubcategory[]
    }

    export interface GetProductSubcategoriesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductSubcategoriesByUpdatedAtResponseParams {
        ProductSubcategoryList: crmmodels.ProductSubcategory[]
    }

    export interface GetProductSubcategoriesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetProductSubcategoriesByUpdatedByResponseParams {
        ProductSubcategoryList: crmmodels.ProductSubcategory[]
    }

    /**
     * Parameters required for executing a soft delete of ProductSubcategory
     */
    export interface GetProductSubcategoryAuditByIdRequestParams {
        /**
         * Primary identifier for the ProductSubcategory to fetch history for
         */
        id: string
    }

    export interface GetProductSubcategoryAuditResponseParams {
        ProductSubcategoryAudit: crmmodels.ProductSubcategory[]
    }

    /**
     * Parameters required for executing a soft delete of ProductSubcategory
     */
    export interface GetProductSubcategoryByIdRequestParams {
        /**
         * Primary identifier for the ProductSubcategory to be fetched
         */
        id: string
    }

    export interface GetProductSubcategoryByIdResponseParams {
        ProductSubcategory: crmmodels.ProductSubcategory
    }

    /**
     * Parameters required for executing a soft delete of ProductUser
     */
    export interface GetProductUserAuditByIdRequestParams {
        /**
         * Primary identifier for the ProductUser to fetch history for
         */
        id: string
    }

    export interface GetProductUserAuditResponseParams {
        ProductUserAudit: crmmodels.ProductUser[]
    }

    /**
     * Parameters required for executing a soft delete of ProductUser
     */
    export interface GetProductUserByIdRequestParams {
        /**
         * Primary identifier for the ProductUser to be fetched
         */
        id: string
    }

    export interface GetProductUserByIdResponseParams {
        ProductUser: crmmodels.ProductUser
    }

    export interface GetProductUsersByActiveRequestParams {
        Active: boolean
    }

    export interface GetProductUsersByActiveResponseParams {
        ProductUserList: crmmodels.ProductUser[]
    }

    export interface GetProductUsersByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductUsersByCreatedAtResponseParams {
        ProductUserList: crmmodels.ProductUser[]
    }

    export interface GetProductUsersByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetProductUsersByCreatedByResponseParams {
        ProductUserList: crmmodels.ProductUser[]
    }

    export interface GetProductUsersByEndDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductUsersByEndDateResponseParams {
        ProductUserList: crmmodels.ProductUser[]
    }

    export interface GetProductUsersByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetProductUsersByIsDeletedResponseParams {
        ProductUserList: crmmodels.ProductUser[]
    }

    export interface GetProductUsersByProductIdRequestParams {
        ProductId: string
    }

    export interface GetProductUsersByProductIdResponseParams {
        ProductUserList: crmmodels.ProductUser[]
    }

    export interface GetProductUsersByStartDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductUsersByStartDateResponseParams {
        ProductUserList: crmmodels.ProductUser[]
    }

    export interface GetProductUsersByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductUsersByUpdatedAtResponseParams {
        ProductUserList: crmmodels.ProductUser[]
    }

    export interface GetProductUsersByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetProductUsersByUpdatedByResponseParams {
        ProductUserList: crmmodels.ProductUser[]
    }

    export interface GetProductUsersByUserCompanyIdRequestParams {
        UserCompanyId: string
    }

    export interface GetProductUsersByUserCompanyIdResponseParams {
        ProductUserList: crmmodels.ProductUser[]
    }

    export interface GetProductsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductsByCreatedAtResponseParams {
        ProductList: crmmodels.Product[]
    }

    export interface GetProductsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetProductsByCreatedByResponseParams {
        ProductList: crmmodels.Product[]
    }

    export interface GetProductsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetProductsByIsDeletedResponseParams {
        ProductList: crmmodels.Product[]
    }

    export interface GetProductsByNameRequestParams {
        Name: string
    }

    export interface GetProductsByNameResponseParams {
        ProductList: crmmodels.Product[]
    }

    export interface GetProductsByProductCategoryIdRequestParams {
        ProductCategoryId: string
    }

    export interface GetProductsByProductCategoryIdResponseParams {
        ProductList: crmmodels.Product[]
    }

    export interface GetProductsByProductInformationUrlRequestParams {
        ProductInformationUrl: string
    }

    export interface GetProductsByProductInformationUrlResponseParams {
        ProductList: crmmodels.Product[]
    }

    export interface GetProductsByProductSubcategoryIdRequestParams {
        ProductSubcategoryId: string
    }

    export interface GetProductsByProductSubcategoryIdResponseParams {
        ProductList: crmmodels.Product[]
    }

    export interface GetProductsByProviderCompanyIdRequestParams {
        ProviderCompanyId: string
    }

    export interface GetProductsByProviderCompanyIdResponseParams {
        ProductList: crmmodels.Product[]
    }

    export interface GetProductsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetProductsByUpdatedAtResponseParams {
        ProductList: crmmodels.Product[]
    }

    export interface GetProductsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetProductsByUpdatedByResponseParams {
        ProductList: crmmodels.Product[]
    }

    export interface GetReachedFunnelStepPerDayParams {
        startDate: string
        endDate: string
    }

    export interface GetReachedFunnelStepPerDayResponse {
        /**
         * A map of funnel steps with their respective counts per day.
         */
        funnelSteps: { [key: string]: FunnelStepReachedDay[] }
    }

    /**
     * Parameters required for executing a soft delete of SkrymCompanyRoleArea
     */
    export interface GetSkrymCompanyRoleAreaAuditByIdRequestParams {
        /**
         * Primary identifier for the SkrymCompanyRoleArea to fetch history for
         */
        id: string
    }

    export interface GetSkrymCompanyRoleAreaAuditResponseParams {
        SkrymCompanyRoleAreaAudit: crmmodels.SkrymCompanyRoleArea[]
    }

    /**
     * Parameters required for executing a soft delete of SkrymCompanyRoleArea
     */
    export interface GetSkrymCompanyRoleAreaByIdRequestParams {
        /**
         * Primary identifier for the SkrymCompanyRoleArea to be fetched
         */
        id: string
    }

    export interface GetSkrymCompanyRoleAreaByIdResponseParams {
        SkrymCompanyRoleArea: crmmodels.SkrymCompanyRoleArea
    }

    export interface GetSkrymCompanyRoleAreasByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSkrymCompanyRoleAreasByCreatedAtResponseParams {
        SkrymCompanyRoleAreaList: crmmodels.SkrymCompanyRoleArea[]
    }

    export interface GetSkrymCompanyRoleAreasByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetSkrymCompanyRoleAreasByCreatedByResponseParams {
        SkrymCompanyRoleAreaList: crmmodels.SkrymCompanyRoleArea[]
    }

    export interface GetSkrymCompanyRoleAreasByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetSkrymCompanyRoleAreasByIsDeletedResponseParams {
        SkrymCompanyRoleAreaList: crmmodels.SkrymCompanyRoleArea[]
    }

    export interface GetSkrymCompanyRoleAreasByNameRequestParams {
        Name: string
    }

    export interface GetSkrymCompanyRoleAreasByNameResponseParams {
        SkrymCompanyRoleAreaList: crmmodels.SkrymCompanyRoleArea[]
    }

    export interface GetSkrymCompanyRoleAreasByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSkrymCompanyRoleAreasByUpdatedAtResponseParams {
        SkrymCompanyRoleAreaList: crmmodels.SkrymCompanyRoleArea[]
    }

    export interface GetSkrymCompanyRoleAreasByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetSkrymCompanyRoleAreasByUpdatedByResponseParams {
        SkrymCompanyRoleAreaList: crmmodels.SkrymCompanyRoleArea[]
    }

    /**
     * Parameters required for executing a soft delete of SkrymCompanyRole
     */
    export interface GetSkrymCompanyRoleAuditByIdRequestParams {
        /**
         * Primary identifier for the SkrymCompanyRole to fetch history for
         */
        id: string
    }

    export interface GetSkrymCompanyRoleAuditResponseParams {
        SkrymCompanyRoleAudit: crmmodels.SkrymCompanyRole[]
    }

    /**
     * Parameters required for executing a soft delete of SkrymCompanyRole
     */
    export interface GetSkrymCompanyRoleByIdRequestParams {
        /**
         * Primary identifier for the SkrymCompanyRole to be fetched
         */
        id: string
    }

    export interface GetSkrymCompanyRoleByIdResponseParams {
        SkrymCompanyRole: crmmodels.SkrymCompanyRole
    }

    export interface GetSkrymCompanyRolesByAreaIdRequestParams {
        AreaId: string
    }

    export interface GetSkrymCompanyRolesByAreaIdResponseParams {
        SkrymCompanyRoleList: crmmodels.SkrymCompanyRole[]
    }

    export interface GetSkrymCompanyRolesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSkrymCompanyRolesByCreatedAtResponseParams {
        SkrymCompanyRoleList: crmmodels.SkrymCompanyRole[]
    }

    export interface GetSkrymCompanyRolesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetSkrymCompanyRolesByCreatedByResponseParams {
        SkrymCompanyRoleList: crmmodels.SkrymCompanyRole[]
    }

    export interface GetSkrymCompanyRolesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetSkrymCompanyRolesByIsDeletedResponseParams {
        SkrymCompanyRoleList: crmmodels.SkrymCompanyRole[]
    }

    export interface GetSkrymCompanyRolesByNameRequestParams {
        Name: string
    }

    export interface GetSkrymCompanyRolesByNameResponseParams {
        SkrymCompanyRoleList: crmmodels.SkrymCompanyRole[]
    }

    export interface GetSkrymCompanyRolesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSkrymCompanyRolesByUpdatedAtResponseParams {
        SkrymCompanyRoleList: crmmodels.SkrymCompanyRole[]
    }

    export interface GetSkrymCompanyRolesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetSkrymCompanyRolesByUpdatedByResponseParams {
        SkrymCompanyRoleList: crmmodels.SkrymCompanyRole[]
    }

    /**
     * Parameters required for executing a soft delete of SkrymContactRole
     */
    export interface GetSkrymContactRoleAuditByIdRequestParams {
        /**
         * Primary identifier for the SkrymContactRole to fetch history for
         */
        id: string
    }

    export interface GetSkrymContactRoleAuditResponseParams {
        SkrymContactRoleAudit: crmmodels.SkrymContactRole[]
    }

    /**
     * Parameters required for executing a soft delete of SkrymContactRole
     */
    export interface GetSkrymContactRoleByIdRequestParams {
        /**
         * Primary identifier for the SkrymContactRole to be fetched
         */
        id: string
    }

    export interface GetSkrymContactRoleByIdResponseParams {
        SkrymContactRole: crmmodels.SkrymContactRole
    }

    export interface GetSkrymContactRolesByActiveRequestParams {
        Active: boolean
    }

    export interface GetSkrymContactRolesByActiveResponseParams {
        SkrymContactRoleList: crmmodels.SkrymContactRole[]
    }

    export interface GetSkrymContactRolesByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetSkrymContactRolesByCompanyIdResponseParams {
        SkrymContactRoleList: crmmodels.SkrymContactRole[]
    }

    export interface GetSkrymContactRolesByCompanyRoleIdRequestParams {
        CompanyRoleId: string
    }

    export interface GetSkrymContactRolesByCompanyRoleIdResponseParams {
        SkrymContactRoleList: crmmodels.SkrymContactRole[]
    }

    export interface GetSkrymContactRolesByContactIdRequestParams {
        ContactId: string
    }

    export interface GetSkrymContactRolesByContactIdResponseParams {
        SkrymContactRoleList: crmmodels.SkrymContactRole[]
    }

    export interface GetSkrymContactRolesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSkrymContactRolesByCreatedAtResponseParams {
        SkrymContactRoleList: crmmodels.SkrymContactRole[]
    }

    export interface GetSkrymContactRolesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetSkrymContactRolesByCreatedByResponseParams {
        SkrymContactRoleList: crmmodels.SkrymContactRole[]
    }

    export interface GetSkrymContactRolesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetSkrymContactRolesByIsDeletedResponseParams {
        SkrymContactRoleList: crmmodels.SkrymContactRole[]
    }

    export interface GetSkrymContactRolesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSkrymContactRolesByUpdatedAtResponseParams {
        SkrymContactRoleList: crmmodels.SkrymContactRole[]
    }

    export interface GetSkrymContactRolesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetSkrymContactRolesByUpdatedByResponseParams {
        SkrymContactRoleList: crmmodels.SkrymContactRole[]
    }

    /**
     * Parameters required for executing a soft delete of Sprint
     */
    export interface GetSprintAuditByIdRequestParams {
        /**
         * Primary identifier for the Sprint to fetch history for
         */
        id: string
    }

    export interface GetSprintAuditResponseParams {
        SprintAudit: crmmodels.Sprint[]
    }

    /**
     * Parameters required for executing a soft delete of Sprint
     */
    export interface GetSprintByIdRequestParams {
        /**
         * Primary identifier for the Sprint to be fetched
         */
        id: string
    }

    export interface GetSprintByIdResponseParams {
        Sprint: crmmodels.Sprint
    }

    /**
     * Parameters required for executing a soft delete of SprintDailyStandup
     */
    export interface GetSprintDailyStandupAuditByIdRequestParams {
        /**
         * Primary identifier for the SprintDailyStandup to fetch history for
         */
        id: string
    }

    export interface GetSprintDailyStandupAuditResponseParams {
        SprintDailyStandupAudit: crmmodels.SprintDailyStandup[]
    }

    /**
     * Parameters required for executing a soft delete of SprintDailyStandup
     */
    export interface GetSprintDailyStandupByIdRequestParams {
        /**
         * Primary identifier for the SprintDailyStandup to be fetched
         */
        id: string
    }

    export interface GetSprintDailyStandupByIdResponseParams {
        SprintDailyStandup: crmmodels.SprintDailyStandup
    }

    export interface GetSprintDailyStandupEntriesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintDailyStandupEntriesByCreatedAtResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetSprintDailyStandupEntriesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetSprintDailyStandupEntriesByCreatedByResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetSprintDailyStandupEntriesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetSprintDailyStandupEntriesByIsDeletedResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetSprintDailyStandupEntriesByPresentRequestParams {
        Present: string
    }

    export interface GetSprintDailyStandupEntriesByPresentResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetSprintDailyStandupEntriesByStandupIdRequestParams {
        StandupId: string
    }

    export interface GetSprintDailyStandupEntriesByStandupIdResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetSprintDailyStandupEntriesByTeamMemberAvailabilityRequestParams {
        TeamMemberAvailability: string
    }

    export interface GetSprintDailyStandupEntriesByTeamMemberAvailabilityResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetSprintDailyStandupEntriesByTeamMemberIdRequestParams {
        TeamMemberId: string
    }

    export interface GetSprintDailyStandupEntriesByTeamMemberIdResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetSprintDailyStandupEntriesByTeamMemberNoteRequestParams {
        TeamMemberNote: string
    }

    export interface GetSprintDailyStandupEntriesByTeamMemberNoteResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetSprintDailyStandupEntriesByTeamMemberWorkingOnRequestParams {
        TeamMemberWorkingOn: string
    }

    export interface GetSprintDailyStandupEntriesByTeamMemberWorkingOnResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetSprintDailyStandupEntriesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintDailyStandupEntriesByUpdatedAtResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    export interface GetSprintDailyStandupEntriesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetSprintDailyStandupEntriesByUpdatedByResponseParams {
        SprintDailyStandupEntryList: crmmodels.SprintDailyStandupEntry[]
    }

    /**
     * Parameters required for executing a soft delete of SprintDailyStandupEntry
     */
    export interface GetSprintDailyStandupEntryAuditByIdRequestParams {
        /**
         * Primary identifier for the SprintDailyStandupEntry to fetch history for
         */
        id: string
    }

    export interface GetSprintDailyStandupEntryAuditResponseParams {
        SprintDailyStandupEntryAudit: crmmodels.SprintDailyStandupEntry[]
    }

    /**
     * Parameters required for executing a soft delete of SprintDailyStandupEntry
     */
    export interface GetSprintDailyStandupEntryByIdRequestParams {
        /**
         * Primary identifier for the SprintDailyStandupEntry to be fetched
         */
        id: string
    }

    export interface GetSprintDailyStandupEntryByIdResponseParams {
        SprintDailyStandupEntry: crmmodels.SprintDailyStandupEntry
    }

    export interface GetSprintDailyStandupsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintDailyStandupsByCreatedAtResponseParams {
        SprintDailyStandupList: crmmodels.SprintDailyStandup[]
    }

    export interface GetSprintDailyStandupsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetSprintDailyStandupsByCreatedByResponseParams {
        SprintDailyStandupList: crmmodels.SprintDailyStandup[]
    }

    export interface GetSprintDailyStandupsByHostedByRequestParams {
        HostedBy: string
    }

    export interface GetSprintDailyStandupsByHostedByResponseParams {
        SprintDailyStandupList: crmmodels.SprintDailyStandup[]
    }

    export interface GetSprintDailyStandupsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetSprintDailyStandupsByIsDeletedResponseParams {
        SprintDailyStandupList: crmmodels.SprintDailyStandup[]
    }

    export interface GetSprintDailyStandupsByMostImportantRequestParams {
        MostImportant: string
    }

    export interface GetSprintDailyStandupsByMostImportantResponseParams {
        SprintDailyStandupList: crmmodels.SprintDailyStandup[]
    }

    export interface GetSprintDailyStandupsBySprintDayRequestParams {
        SprintDay: number
    }

    export interface GetSprintDailyStandupsBySprintDayResponseParams {
        SprintDailyStandupList: crmmodels.SprintDailyStandup[]
    }

    export interface GetSprintDailyStandupsBySprintIdRequestParams {
        SprintId: string
    }

    export interface GetSprintDailyStandupsBySprintIdResponseParams {
        SprintDailyStandupList: crmmodels.SprintDailyStandup[]
    }

    export interface GetSprintDailyStandupsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintDailyStandupsByUpdatedAtResponseParams {
        SprintDailyStandupList: crmmodels.SprintDailyStandup[]
    }

    export interface GetSprintDailyStandupsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetSprintDailyStandupsByUpdatedByResponseParams {
        SprintDailyStandupList: crmmodels.SprintDailyStandup[]
    }

    /**
     * Parameters required for executing a soft delete of SprintMessage
     */
    export interface GetSprintMessageAuditByIdRequestParams {
        /**
         * Primary identifier for the SprintMessage to fetch history for
         */
        id: string
    }

    export interface GetSprintMessageAuditResponseParams {
        SprintMessageAudit: crmmodels.SprintMessage[]
    }

    /**
     * Parameters required for executing a soft delete of SprintMessage
     */
    export interface GetSprintMessageByIdRequestParams {
        /**
         * Primary identifier for the SprintMessage to be fetched
         */
        id: string
    }

    export interface GetSprintMessageByIdResponseParams {
        SprintMessage: crmmodels.SprintMessage
    }

    /**
     * Parameters required for executing a soft delete of SprintMessageType
     */
    export interface GetSprintMessageTypeAuditByIdRequestParams {
        /**
         * Primary identifier for the SprintMessageType to fetch history for
         */
        id: string
    }

    export interface GetSprintMessageTypeAuditResponseParams {
        SprintMessageTypeAudit: crmmodels.SprintMessageType[]
    }

    /**
     * Parameters required for executing a soft delete of SprintMessageType
     */
    export interface GetSprintMessageTypeByIdRequestParams {
        /**
         * Primary identifier for the SprintMessageType to be fetched
         */
        id: string
    }

    export interface GetSprintMessageTypeByIdResponseParams {
        SprintMessageType: crmmodels.SprintMessageType
    }

    export interface GetSprintMessageTypesByColorRequestParams {
        Color: string
    }

    export interface GetSprintMessageTypesByColorResponseParams {
        SprintMessageTypeList: crmmodels.SprintMessageType[]
    }

    export interface GetSprintMessageTypesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintMessageTypesByCreatedAtResponseParams {
        SprintMessageTypeList: crmmodels.SprintMessageType[]
    }

    export interface GetSprintMessageTypesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetSprintMessageTypesByCreatedByResponseParams {
        SprintMessageTypeList: crmmodels.SprintMessageType[]
    }

    export interface GetSprintMessageTypesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetSprintMessageTypesByIsDeletedResponseParams {
        SprintMessageTypeList: crmmodels.SprintMessageType[]
    }

    export interface GetSprintMessageTypesByNameRequestParams {
        Name: string
    }

    export interface GetSprintMessageTypesByNameResponseParams {
        SprintMessageTypeList: crmmodels.SprintMessageType[]
    }

    export interface GetSprintMessageTypesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintMessageTypesByUpdatedAtResponseParams {
        SprintMessageTypeList: crmmodels.SprintMessageType[]
    }

    export interface GetSprintMessageTypesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetSprintMessageTypesByUpdatedByResponseParams {
        SprintMessageTypeList: crmmodels.SprintMessageType[]
    }

    export interface GetSprintMessagesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintMessagesByCreatedAtResponseParams {
        SprintMessageList: crmmodels.SprintMessage[]
    }

    export interface GetSprintMessagesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetSprintMessagesByCreatedByResponseParams {
        SprintMessageList: crmmodels.SprintMessage[]
    }

    export interface GetSprintMessagesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetSprintMessagesByIsDeletedResponseParams {
        SprintMessageList: crmmodels.SprintMessage[]
    }

    export interface GetSprintMessagesByMessageRequestParams {
        Message: string
    }

    export interface GetSprintMessagesByMessageResponseParams {
        SprintMessageList: crmmodels.SprintMessage[]
    }

    export interface GetSprintMessagesByMessageTypeIdRequestParams {
        MessageTypeId: string
    }

    export interface GetSprintMessagesByMessageTypeIdResponseParams {
        SprintMessageList: crmmodels.SprintMessage[]
    }

    export interface GetSprintMessagesBySprintIdRequestParams {
        SprintId: string
    }

    export interface GetSprintMessagesBySprintIdResponseParams {
        SprintMessageList: crmmodels.SprintMessage[]
    }

    export interface GetSprintMessagesByTitleRequestParams {
        Title: string
    }

    export interface GetSprintMessagesByTitleResponseParams {
        SprintMessageList: crmmodels.SprintMessage[]
    }

    export interface GetSprintMessagesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintMessagesByUpdatedAtResponseParams {
        SprintMessageList: crmmodels.SprintMessage[]
    }

    export interface GetSprintMessagesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetSprintMessagesByUpdatedByResponseParams {
        SprintMessageList: crmmodels.SprintMessage[]
    }

    /**
     * Parameters required for executing a soft delete of SprintRole
     */
    export interface GetSprintRoleAuditByIdRequestParams {
        /**
         * Primary identifier for the SprintRole to fetch history for
         */
        id: string
    }

    export interface GetSprintRoleAuditResponseParams {
        SprintRoleAudit: crmmodels.SprintRole[]
    }

    /**
     * Parameters required for executing a soft delete of SprintRole
     */
    export interface GetSprintRoleByIdRequestParams {
        /**
         * Primary identifier for the SprintRole to be fetched
         */
        id: string
    }

    export interface GetSprintRoleByIdResponseParams {
        SprintRole: crmmodels.SprintRole
    }

    export interface GetSprintRoleEntriesByContactIdRequestParams {
        ContactId: string
    }

    export interface GetSprintRoleEntriesByContactIdResponseParams {
        SprintRoleEntryList: crmmodels.SprintRoleEntry[]
    }

    export interface GetSprintRoleEntriesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintRoleEntriesByCreatedAtResponseParams {
        SprintRoleEntryList: crmmodels.SprintRoleEntry[]
    }

    export interface GetSprintRoleEntriesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetSprintRoleEntriesByCreatedByResponseParams {
        SprintRoleEntryList: crmmodels.SprintRoleEntry[]
    }

    export interface GetSprintRoleEntriesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetSprintRoleEntriesByIsDeletedResponseParams {
        SprintRoleEntryList: crmmodels.SprintRoleEntry[]
    }

    export interface GetSprintRoleEntriesBySprintIdRequestParams {
        SprintId: string
    }

    export interface GetSprintRoleEntriesBySprintIdResponseParams {
        SprintRoleEntryList: crmmodels.SprintRoleEntry[]
    }

    export interface GetSprintRoleEntriesBySprintRoleIdRequestParams {
        SprintRoleId: string
    }

    export interface GetSprintRoleEntriesBySprintRoleIdResponseParams {
        SprintRoleEntryList: crmmodels.SprintRoleEntry[]
    }

    export interface GetSprintRoleEntriesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintRoleEntriesByUpdatedAtResponseParams {
        SprintRoleEntryList: crmmodels.SprintRoleEntry[]
    }

    export interface GetSprintRoleEntriesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetSprintRoleEntriesByUpdatedByResponseParams {
        SprintRoleEntryList: crmmodels.SprintRoleEntry[]
    }

    /**
     * Parameters required for executing a soft delete of SprintRoleEntry
     */
    export interface GetSprintRoleEntryAuditByIdRequestParams {
        /**
         * Primary identifier for the SprintRoleEntry to fetch history for
         */
        id: string
    }

    export interface GetSprintRoleEntryAuditResponseParams {
        SprintRoleEntryAudit: crmmodels.SprintRoleEntry[]
    }

    /**
     * Parameters required for executing a soft delete of SprintRoleEntry
     */
    export interface GetSprintRoleEntryByIdRequestParams {
        /**
         * Primary identifier for the SprintRoleEntry to be fetched
         */
        id: string
    }

    export interface GetSprintRoleEntryByIdResponseParams {
        SprintRoleEntry: crmmodels.SprintRoleEntry
    }

    export interface GetSprintRolesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintRolesByCreatedAtResponseParams {
        SprintRoleList: crmmodels.SprintRole[]
    }

    export interface GetSprintRolesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetSprintRolesByCreatedByResponseParams {
        SprintRoleList: crmmodels.SprintRole[]
    }

    export interface GetSprintRolesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetSprintRolesByIsDeletedResponseParams {
        SprintRoleList: crmmodels.SprintRole[]
    }

    export interface GetSprintRolesByNameRequestParams {
        Name: string
    }

    export interface GetSprintRolesByNameResponseParams {
        SprintRoleList: crmmodels.SprintRole[]
    }

    export interface GetSprintRolesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintRolesByUpdatedAtResponseParams {
        SprintRoleList: crmmodels.SprintRole[]
    }

    export interface GetSprintRolesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetSprintRolesByUpdatedByResponseParams {
        SprintRoleList: crmmodels.SprintRole[]
    }

    export interface GetSprintsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintsByCreatedAtResponseParams {
        SprintList: crmmodels.Sprint[]
    }

    export interface GetSprintsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetSprintsByCreatedByResponseParams {
        SprintList: crmmodels.Sprint[]
    }

    export interface GetSprintsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetSprintsByIsDeletedResponseParams {
        SprintList: crmmodels.Sprint[]
    }

    export interface GetSprintsBySprintNumberRequestParams {
        SprintNumber: number
    }

    export interface GetSprintsBySprintNumberResponseParams {
        SprintList: crmmodels.Sprint[]
    }

    export interface GetSprintsByStartDateRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintsByStartDateResponseParams {
        SprintList: crmmodels.Sprint[]
    }

    export interface GetSprintsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetSprintsByUpdatedAtResponseParams {
        SprintList: crmmodels.Sprint[]
    }

    export interface GetSprintsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetSprintsByUpdatedByResponseParams {
        SprintList: crmmodels.Sprint[]
    }

    /**
     * Parameters required for executing a soft delete of Task
     */
    export interface GetTaskAuditByIdRequestParams {
        /**
         * Primary identifier for the Task to fetch history for
         */
        id: string
    }

    export interface GetTaskAuditResponseParams {
        TaskAudit: crmmodels.Task[]
    }

    /**
     * Parameters required for executing a soft delete of Task
     */
    export interface GetTaskByIdRequestParams {
        /**
         * Primary identifier for the Task to be fetched
         */
        id: string
    }

    export interface GetTaskByIdResponseParams {
        Task: crmmodels.Task
    }

    /**
     * Parameters required for executing a soft delete of TaskOwner
     */
    export interface GetTaskOwnerAuditByIdRequestParams {
        /**
         * Primary identifier for the TaskOwner to fetch history for
         */
        id: string
    }

    export interface GetTaskOwnerAuditResponseParams {
        TaskOwnerAudit: crmmodels.TaskOwner[]
    }

    /**
     * Parameters required for executing a soft delete of TaskOwner
     */
    export interface GetTaskOwnerByIdRequestParams {
        /**
         * Primary identifier for the TaskOwner to be fetched
         */
        id: string
    }

    export interface GetTaskOwnerByIdResponseParams {
        TaskOwner: crmmodels.TaskOwner
    }

    export interface GetTaskOwnersByContactIdRequestParams {
        ContactId: string
    }

    export interface GetTaskOwnersByContactIdResponseParams {
        TaskOwnerList: crmmodels.TaskOwner[]
    }

    export interface GetTaskOwnersByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetTaskOwnersByCreatedAtResponseParams {
        TaskOwnerList: crmmodels.TaskOwner[]
    }

    export interface GetTaskOwnersByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetTaskOwnersByCreatedByResponseParams {
        TaskOwnerList: crmmodels.TaskOwner[]
    }

    export interface GetTaskOwnersByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetTaskOwnersByIsDeletedResponseParams {
        TaskOwnerList: crmmodels.TaskOwner[]
    }

    export interface GetTaskOwnersByNoteRequestParams {
        Note: string
    }

    export interface GetTaskOwnersByNoteResponseParams {
        TaskOwnerList: crmmodels.TaskOwner[]
    }

    export interface GetTaskOwnersByTaskIdRequestParams {
        TaskId: string
    }

    export interface GetTaskOwnersByTaskIdResponseParams {
        TaskOwnerList: crmmodels.TaskOwner[]
    }

    export interface GetTaskOwnersByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetTaskOwnersByUpdatedAtResponseParams {
        TaskOwnerList: crmmodels.TaskOwner[]
    }

    export interface GetTaskOwnersByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetTaskOwnersByUpdatedByResponseParams {
        TaskOwnerList: crmmodels.TaskOwner[]
    }

    /**
     * Parameters required for executing a soft delete of TaskStatus
     */
    export interface GetTaskStatusAuditByIdRequestParams {
        /**
         * Primary identifier for the TaskStatus to fetch history for
         */
        id: string
    }

    export interface GetTaskStatusAuditResponseParams {
        TaskStatusAudit: crmmodels.TaskStatus[]
    }

    /**
     * Parameters required for executing a soft delete of TaskStatus
     */
    export interface GetTaskStatusByIdRequestParams {
        /**
         * Primary identifier for the TaskStatus to be fetched
         */
        id: string
    }

    export interface GetTaskStatusByIdResponseParams {
        TaskStatus: crmmodels.TaskStatus
    }

    export interface GetTaskStatusesByCodeRequestParams {
        Code: string
    }

    export interface GetTaskStatusesByCodeResponseParams {
        TaskStatusList: crmmodels.TaskStatus[]
    }

    export interface GetTaskStatusesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetTaskStatusesByCreatedAtResponseParams {
        TaskStatusList: crmmodels.TaskStatus[]
    }

    export interface GetTaskStatusesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetTaskStatusesByCreatedByResponseParams {
        TaskStatusList: crmmodels.TaskStatus[]
    }

    export interface GetTaskStatusesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetTaskStatusesByIsDeletedResponseParams {
        TaskStatusList: crmmodels.TaskStatus[]
    }

    export interface GetTaskStatusesByNameRequestParams {
        Name: string
    }

    export interface GetTaskStatusesByNameResponseParams {
        TaskStatusList: crmmodels.TaskStatus[]
    }

    export interface GetTaskStatusesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetTaskStatusesByUpdatedAtResponseParams {
        TaskStatusList: crmmodels.TaskStatus[]
    }

    export interface GetTaskStatusesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetTaskStatusesByUpdatedByResponseParams {
        TaskStatusList: crmmodels.TaskStatus[]
    }

    export interface GetTasksByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetTasksByCompanyIdResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetTasksByCreatedAtResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetTasksByCreatedByResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksByDeadlineRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetTasksByDeadlineResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetTasksByIsDeletedResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksByIsPriorityRequestParams {
        IsPriority: boolean
    }

    export interface GetTasksByIsPriorityResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksByIsPrivateRequestParams {
        IsPrivate: boolean
    }

    export interface GetTasksByIsPrivateResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksByNameRequestParams {
        Name: string
    }

    export interface GetTasksByNameResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksBySizeRequestParams {
        Size: number
    }

    export interface GetTasksBySizeResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksByStatusIdRequestParams {
        StatusId: string
    }

    export interface GetTasksByStatusIdResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetTasksByUpdatedAtResponseParams {
        TaskList: crmmodels.Task[]
    }

    export interface GetTasksByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetTasksByUpdatedByResponseParams {
        TaskList: crmmodels.Task[]
    }

    /**
     * Parameters required for executing a soft delete of WorkingTime
     */
    export interface GetWorkingTimeAuditByIdRequestParams {
        /**
         * Primary identifier for the WorkingTime to fetch history for
         */
        id: string
    }

    export interface GetWorkingTimeAuditResponseParams {
        WorkingTimeAudit: crmmodels.WorkingTime[]
    }

    /**
     * Parameters required for executing a soft delete of WorkingTime
     */
    export interface GetWorkingTimeByIdRequestParams {
        /**
         * Primary identifier for the WorkingTime to be fetched
         */
        id: string
    }

    export interface GetWorkingTimeByIdResponseParams {
        WorkingTime: crmmodels.WorkingTime
    }

    /**
     * Parameters required for executing a soft delete of WorkingTimeLocation
     */
    export interface GetWorkingTimeLocationAuditByIdRequestParams {
        /**
         * Primary identifier for the WorkingTimeLocation to fetch history for
         */
        id: string
    }

    export interface GetWorkingTimeLocationAuditResponseParams {
        WorkingTimeLocationAudit: crmmodels.WorkingTimeLocation[]
    }

    /**
     * Parameters required for executing a soft delete of WorkingTimeLocation
     */
    export interface GetWorkingTimeLocationByIdRequestParams {
        /**
         * Primary identifier for the WorkingTimeLocation to be fetched
         */
        id: string
    }

    export interface GetWorkingTimeLocationByIdResponseParams {
        WorkingTimeLocation: crmmodels.WorkingTimeLocation
    }

    export interface GetWorkingTimeLocationsByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetWorkingTimeLocationsByCompanyIdResponseParams {
        WorkingTimeLocationList: crmmodels.WorkingTimeLocation[]
    }

    export interface GetWorkingTimeLocationsByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetWorkingTimeLocationsByCreatedAtResponseParams {
        WorkingTimeLocationList: crmmodels.WorkingTimeLocation[]
    }

    export interface GetWorkingTimeLocationsByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetWorkingTimeLocationsByCreatedByResponseParams {
        WorkingTimeLocationList: crmmodels.WorkingTimeLocation[]
    }

    export interface GetWorkingTimeLocationsByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetWorkingTimeLocationsByIsDeletedResponseParams {
        WorkingTimeLocationList: crmmodels.WorkingTimeLocation[]
    }

    export interface GetWorkingTimeLocationsByNameRequestParams {
        Name: string
    }

    export interface GetWorkingTimeLocationsByNameResponseParams {
        WorkingTimeLocationList: crmmodels.WorkingTimeLocation[]
    }

    export interface GetWorkingTimeLocationsByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetWorkingTimeLocationsByUpdatedAtResponseParams {
        WorkingTimeLocationList: crmmodels.WorkingTimeLocation[]
    }

    export interface GetWorkingTimeLocationsByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetWorkingTimeLocationsByUpdatedByResponseParams {
        WorkingTimeLocationList: crmmodels.WorkingTimeLocation[]
    }

    /**
     * Parameters required for executing a soft delete of WorkingTimeType
     */
    export interface GetWorkingTimeTypeAuditByIdRequestParams {
        /**
         * Primary identifier for the WorkingTimeType to fetch history for
         */
        id: string
    }

    export interface GetWorkingTimeTypeAuditResponseParams {
        WorkingTimeTypeAudit: crmmodels.WorkingTimeType[]
    }

    /**
     * Parameters required for executing a soft delete of WorkingTimeType
     */
    export interface GetWorkingTimeTypeByIdRequestParams {
        /**
         * Primary identifier for the WorkingTimeType to be fetched
         */
        id: string
    }

    export interface GetWorkingTimeTypeByIdResponseParams {
        WorkingTimeType: crmmodels.WorkingTimeType
    }

    export interface GetWorkingTimeTypesByCompanyIdRequestParams {
        CompanyId: string
    }

    export interface GetWorkingTimeTypesByCompanyIdResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimeTypesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetWorkingTimeTypesByCreatedAtResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimeTypesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetWorkingTimeTypesByCreatedByResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimeTypesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetWorkingTimeTypesByIsDeletedResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimeTypesByIsParentalLeaveRequestParams {
        IsParentalLeave: boolean
    }

    export interface GetWorkingTimeTypesByIsParentalLeaveResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimeTypesByIsPublicHolidayRequestParams {
        IsPublicHoliday: boolean
    }

    export interface GetWorkingTimeTypesByIsPublicHolidayResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimeTypesByIsVacationRequestParams {
        IsVacation: boolean
    }

    export interface GetWorkingTimeTypesByIsVacationResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimeTypesByIsWorkRequestParams {
        IsWork: boolean
    }

    export interface GetWorkingTimeTypesByIsWorkResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimeTypesByNameRequestParams {
        Name: string
    }

    export interface GetWorkingTimeTypesByNameResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimeTypesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetWorkingTimeTypesByUpdatedAtResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimeTypesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetWorkingTimeTypesByUpdatedByResponseParams {
        WorkingTimeTypeList: crmmodels.WorkingTimeType[]
    }

    export interface GetWorkingTimesByContactRoleIdRequestParams {
        ContactRoleId: string
    }

    export interface GetWorkingTimesByContactRoleIdResponseParams {
        WorkingTimeList: crmmodels.WorkingTime[]
    }

    export interface GetWorkingTimesByCreatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetWorkingTimesByCreatedAtResponseParams {
        WorkingTimeList: crmmodels.WorkingTime[]
    }

    export interface GetWorkingTimesByCreatedByRequestParams {
        CreatedBy: string
    }

    export interface GetWorkingTimesByCreatedByResponseParams {
        WorkingTimeList: crmmodels.WorkingTime[]
    }

    export interface GetWorkingTimesByDayRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetWorkingTimesByDayResponseParams {
        WorkingTimeList: crmmodels.WorkingTime[]
    }

    export interface GetWorkingTimesByDurationHoursRequestParams {
        min?: number
        max?: number
    }

    export interface GetWorkingTimesByDurationHoursResponseParams {
        WorkingTimeList: crmmodels.WorkingTime[]
    }

    export interface GetWorkingTimesByIsDeletedRequestParams {
        IsDeleted: boolean
    }

    export interface GetWorkingTimesByIsDeletedResponseParams {
        WorkingTimeList: crmmodels.WorkingTime[]
    }

    export interface GetWorkingTimesByLocationRequestParams {
        Location: string
    }

    export interface GetWorkingTimesByLocationResponseParams {
        WorkingTimeList: crmmodels.WorkingTime[]
    }

    export interface GetWorkingTimesByTypeRequestParams {
        Type: string
    }

    export interface GetWorkingTimesByTypeResponseParams {
        WorkingTimeList: crmmodels.WorkingTime[]
    }

    export interface GetWorkingTimesByUpdatedAtRequestParams {
        startTime?: string
        endTime?: string
    }

    export interface GetWorkingTimesByUpdatedAtResponseParams {
        WorkingTimeList: crmmodels.WorkingTime[]
    }

    export interface GetWorkingTimesByUpdatedByRequestParams {
        UpdatedBy: string
    }

    export interface GetWorkingTimesByUpdatedByResponseParams {
        WorkingTimeList: crmmodels.WorkingTime[]
    }

    export interface InsertCallSheetRequestParams {
        CallSheet: crmmodels.CallSheet
    }

    export interface InsertChannelRequestParams {
        Channel: crmmodels.Channel
    }

    export interface InsertCompanyBillingInfoRequestParams {
        CompanyBillingInfo: crmmodels.CompanyBillingInfo
    }

    export interface InsertCompanyInvoiceRequestParams {
        CompanyInvoice: crmmodels.CompanyInvoice
    }

    export interface InsertCompanyNoteRequestParams {
        CompanyNote: crmmodels.CompanyNote
    }

    export interface InsertCompanyProductAreaEntryRequestParams {
        CompanyProductAreaEntry: crmmodels.CompanyProductAreaEntry
    }

    export interface InsertCompanyProductAreaRequestParams {
        CompanyProductArea: crmmodels.CompanyProductArea
    }

    export interface InsertCompanyRequestParams {
        Company: crmmodels.Company
    }

    export interface InsertCompanySegmentEntryRequestParams {
        CompanySegmentEntry: crmmodels.CompanySegmentEntry
    }

    export interface InsertCompanySegmentRequestParams {
        CompanySegment: crmmodels.CompanySegment
    }

    export interface InsertCompanyTypeRequestParams {
        CompanyType: crmmodels.CompanyType
    }

    export interface InsertConnectionRequestParams {
        Connection: crmmodels.Connection
    }

    export interface InsertContactDetailRequestParams {
        ContactDetail: crmmodels.ContactDetail
    }

    export interface InsertContactDetailTypeRequestParams {
        ContactDetailType: crmmodels.ContactDetailType
    }

    export interface InsertContactDocumentRequestParams {
        ContactDocument: crmmodels.ContactDocument
    }

    export interface InsertContactNoteRequestParams {
        ContactNote: crmmodels.ContactNote
    }

    export interface InsertContactRequestParams {
        Contact: crmmodels.Contact
    }

    export interface InsertContactRoleRequestParams {
        ContactRole: crmmodels.ContactRole
    }

    export interface InsertDocumentRequestParams {
        Document: crmmodels.Document
    }

    export interface InsertDocumentTypeRequestParams {
        DocumentType: crmmodels.DocumentType
    }

    export interface InsertEmploymentRequestParams {
        Employment: crmmodels.Employment
    }

    export interface InsertEventAttendeeRequestParams {
        EventAttendee: crmmodels.EventAttendee
    }

    export interface InsertEventRequestParams {
        Event: crmmodels.Event
    }

    export interface InsertEventTypeRequestParams {
        EventType: crmmodels.EventType
    }

    export interface InsertFormSubmissionRequestParams {
        FormSubmission: crmmodels.FormSubmission
    }

    export interface InsertMeetingAttendeeRequestParams {
        MeetingAttendee: crmmodels.MeetingAttendee
    }

    export interface InsertMeetingCompanyRequestParams {
        MeetingCompany: crmmodels.MeetingCompany
    }

    export interface InsertMeetingRequestParams {
        Meeting: crmmodels.Meeting
    }

    export interface InsertMeetingTypeRequestParams {
        MeetingType: crmmodels.MeetingType
    }

    export interface InsertNewsletterSignupRequestParams {
        NewsletterSignup: crmmodels.NewsletterSignup
    }

    export interface InsertOnCallRoleRequestParams {
        OnCallRole: crmmodels.OnCallRole
    }

    export interface InsertOnCallScheduleRequestParams {
        OnCallSchedule: crmmodels.OnCallSchedule
    }

    export interface InsertOpportunityFunnelRequestParams {
        OpportunityFunnel: crmmodels.OpportunityFunnel
    }

    export interface InsertOpportunityFunnelStepRequestParams {
        OpportunityFunnelStep: crmmodels.OpportunityFunnelStep
    }

    export interface InsertOpportunityProductRequestParams {
        OpportunityProduct: crmmodels.OpportunityProduct
    }

    export interface InsertOpportunityRequestParams {
        Opportunity: crmmodels.Opportunity
    }

    export interface InsertOpportunityTypeRequestParams {
        OpportunityType: crmmodels.OpportunityType
    }

    export interface InsertOrganizationDocumentRequestParams {
        OrganizationDocument: crmmodels.OrganizationDocument
    }

    export interface InsertProductCategoryRequestParams {
        ProductCategory: crmmodels.ProductCategory
    }

    export interface InsertProductDocumentRequestParams {
        ProductDocument: crmmodels.ProductDocument
    }

    export interface InsertProductRequestParams {
        Product: crmmodels.Product
    }

    export interface InsertProductSubcategoryRequestParams {
        ProductSubcategory: crmmodels.ProductSubcategory
    }

    export interface InsertProductUserRequestParams {
        ProductUser: crmmodels.ProductUser
    }

    export interface InsertSkrymCompanyRoleAreaRequestParams {
        SkrymCompanyRoleArea: crmmodels.SkrymCompanyRoleArea
    }

    export interface InsertSkrymCompanyRoleRequestParams {
        SkrymCompanyRole: crmmodels.SkrymCompanyRole
    }

    export interface InsertSkrymContactRoleRequestParams {
        SkrymContactRole: crmmodels.SkrymContactRole
    }

    export interface InsertSprintDailyStandupEntryRequestParams {
        SprintDailyStandupEntry: crmmodels.SprintDailyStandupEntry
    }

    export interface InsertSprintDailyStandupRequestParams {
        SprintDailyStandup: crmmodels.SprintDailyStandup
    }

    export interface InsertSprintMessageRequestParams {
        SprintMessage: crmmodels.SprintMessage
    }

    export interface InsertSprintMessageTypeRequestParams {
        SprintMessageType: crmmodels.SprintMessageType
    }

    export interface InsertSprintRequestParams {
        Sprint: crmmodels.Sprint
    }

    export interface InsertSprintRoleEntryRequestParams {
        SprintRoleEntry: crmmodels.SprintRoleEntry
    }

    export interface InsertSprintRoleRequestParams {
        SprintRole: crmmodels.SprintRole
    }

    export interface InsertTaskOwnerRequestParams {
        TaskOwner: crmmodels.TaskOwner
    }

    export interface InsertTaskRequestParams {
        Task: crmmodels.Task
    }

    export interface InsertTaskStatusRequestParams {
        TaskStatus: crmmodels.TaskStatus
    }

    export interface InsertWorkingTimeLocationRequestParams {
        WorkingTimeLocation: crmmodels.WorkingTimeLocation
    }

    export interface InsertWorkingTimeRequestParams {
        WorkingTime: crmmodels.WorkingTime
    }

    export interface InsertWorkingTimeTypeRequestParams {
        WorkingTimeType: crmmodels.WorkingTimeType
    }

    export interface SearchCompaniesRequestParams {
        name: string
        limit: number
    }

    export interface SearchCompaniesResponseParams {
        companyList: crmmodels.Company[]
    }

    export interface SearchContactsRequestParams {
        name: string
        limit: number
    }

    export interface SearchContactsResponse {
        contacts: crmmodels.ContactWithDetailAndRoleInfo[]
    }

    export interface UpsertCallSheetRequestParams {
        CallSheet: crmmodels.CallSheet
    }

    export interface UpsertChannelRequestParams {
        Channel: crmmodels.Channel
    }

    export interface UpsertCompanyBillingInfoRequestParams {
        CompanyBillingInfo: crmmodels.CompanyBillingInfo
    }

    export interface UpsertCompanyInvoiceRequestParams {
        CompanyInvoice: crmmodels.CompanyInvoice
    }

    export interface UpsertCompanyNoteRequestParams {
        CompanyNote: crmmodels.CompanyNote
    }

    export interface UpsertCompanyProductAreaEntryRequestParams {
        CompanyProductAreaEntry: crmmodels.CompanyProductAreaEntry
    }

    export interface UpsertCompanyProductAreaRequestParams {
        CompanyProductArea: crmmodels.CompanyProductArea
    }

    export interface UpsertCompanyRequestParams {
        Company: crmmodels.Company
    }

    export interface UpsertCompanySegmentEntryRequestParams {
        CompanySegmentEntry: crmmodels.CompanySegmentEntry
    }

    export interface UpsertCompanySegmentRequestParams {
        CompanySegment: crmmodels.CompanySegment
    }

    export interface UpsertCompanyTypeRequestParams {
        CompanyType: crmmodels.CompanyType
    }

    export interface UpsertConnectionRequestParams {
        Connection: crmmodels.Connection
    }

    export interface UpsertContactDetailRequestParams {
        ContactDetail: crmmodels.ContactDetail
    }

    export interface UpsertContactDetailTypeRequestParams {
        ContactDetailType: crmmodels.ContactDetailType
    }

    export interface UpsertContactDocumentRequestParams {
        ContactDocument: crmmodels.ContactDocument
    }

    export interface UpsertContactNoteRequestParams {
        ContactNote: crmmodels.ContactNote
    }

    export interface UpsertContactRequestParams {
        Contact: crmmodels.Contact
    }

    export interface UpsertContactRoleRequestParams {
        ContactRole: crmmodels.ContactRole
    }

    export interface UpsertDocumentRequestParams {
        Document: crmmodels.Document
    }

    export interface UpsertDocumentTypeRequestParams {
        DocumentType: crmmodels.DocumentType
    }

    export interface UpsertEmploymentRequestParams {
        Employment: crmmodels.Employment
    }

    export interface UpsertEventAttendeeRequestParams {
        EventAttendee: crmmodels.EventAttendee
    }

    export interface UpsertEventRequestParams {
        Event: crmmodels.Event
    }

    export interface UpsertEventTypeRequestParams {
        EventType: crmmodels.EventType
    }

    export interface UpsertFormSubmissionRequestParams {
        FormSubmission: crmmodels.FormSubmission
    }

    export interface UpsertMeetingAttendeeRequestParams {
        MeetingAttendee: crmmodels.MeetingAttendee
    }

    export interface UpsertMeetingCompanyRequestParams {
        MeetingCompany: crmmodels.MeetingCompany
    }

    export interface UpsertMeetingRequestParams {
        Meeting: crmmodels.Meeting
    }

    export interface UpsertMeetingTypeRequestParams {
        MeetingType: crmmodels.MeetingType
    }

    export interface UpsertMeetingWithAttendeesRequest {
        Meeting: crmmodels.MeetingWithAttendees
    }

    export interface UpsertNewsletterSignupRequestParams {
        NewsletterSignup: crmmodels.NewsletterSignup
    }

    export interface UpsertOnCallRoleRequestParams {
        OnCallRole: crmmodels.OnCallRole
    }

    export interface UpsertOnCallScheduleRequestParams {
        OnCallSchedule: crmmodels.OnCallSchedule
    }

    export interface UpsertOpportunityFunnelRequestParams {
        OpportunityFunnel: crmmodels.OpportunityFunnel
    }

    export interface UpsertOpportunityFunnelStepRequestParams {
        OpportunityFunnelStep: crmmodels.OpportunityFunnelStep
    }

    export interface UpsertOpportunityProductRequestParams {
        OpportunityProduct: crmmodels.OpportunityProduct
    }

    export interface UpsertOpportunityRequestParams {
        Opportunity: crmmodels.Opportunity
    }

    export interface UpsertOpportunityTypeRequestParams {
        OpportunityType: crmmodels.OpportunityType
    }

    export interface UpsertOrganizationDocumentRequestParams {
        OrganizationDocument: crmmodels.OrganizationDocument
    }

    export interface UpsertProductCategoryRequestParams {
        ProductCategory: crmmodels.ProductCategory
    }

    export interface UpsertProductDocumentRequestParams {
        ProductDocument: crmmodels.ProductDocument
    }

    export interface UpsertProductRequestParams {
        Product: crmmodels.Product
    }

    export interface UpsertProductSubcategoryRequestParams {
        ProductSubcategory: crmmodels.ProductSubcategory
    }

    export interface UpsertProductUserRequestParams {
        ProductUser: crmmodels.ProductUser
    }

    export interface UpsertSkrymCompanyRoleAreaRequestParams {
        SkrymCompanyRoleArea: crmmodels.SkrymCompanyRoleArea
    }

    export interface UpsertSkrymCompanyRoleRequestParams {
        SkrymCompanyRole: crmmodels.SkrymCompanyRole
    }

    export interface UpsertSkrymContactRoleRequestParams {
        SkrymContactRole: crmmodels.SkrymContactRole
    }

    export interface UpsertSprintDailyStandupEntryRequestParams {
        SprintDailyStandupEntry: crmmodels.SprintDailyStandupEntry
    }

    export interface UpsertSprintDailyStandupRequestParams {
        SprintDailyStandup: crmmodels.SprintDailyStandup
    }

    export interface UpsertSprintMessageRequestParams {
        SprintMessage: crmmodels.SprintMessage
    }

    export interface UpsertSprintMessageTypeRequestParams {
        SprintMessageType: crmmodels.SprintMessageType
    }

    export interface UpsertSprintRequestParams {
        Sprint: crmmodels.Sprint
    }

    export interface UpsertSprintRoleEntryRequestParams {
        SprintRoleEntry: crmmodels.SprintRoleEntry
    }

    export interface UpsertSprintRoleRequestParams {
        SprintRole: crmmodels.SprintRole
    }

    export interface UpsertTaskOwnerRequestParams {
        TaskOwner: crmmodels.TaskOwner
    }

    export interface UpsertTaskRequestParams {
        Task: crmmodels.Task
    }

    export interface UpsertTaskStatusRequestParams {
        TaskStatus: crmmodels.TaskStatus
    }

    export interface UpsertWorkingTimeLocationRequestParams {
        WorkingTimeLocation: crmmodels.WorkingTimeLocation
    }

    export interface UpsertWorkingTimeRequestParams {
        WorkingTime: crmmodels.WorkingTime
    }

    export interface UpsertWorkingTimeTypeRequestParams {
        WorkingTimeType: crmmodels.WorkingTimeType
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.CheckLagoHealth = this.CheckLagoHealth.bind(this)
            this.DeleteCallSheet = this.DeleteCallSheet.bind(this)
            this.DeleteChannel = this.DeleteChannel.bind(this)
            this.DeleteCompany = this.DeleteCompany.bind(this)
            this.DeleteCompanyBillingInfo = this.DeleteCompanyBillingInfo.bind(this)
            this.DeleteCompanyInvoice = this.DeleteCompanyInvoice.bind(this)
            this.DeleteCompanyNote = this.DeleteCompanyNote.bind(this)
            this.DeleteCompanyProductArea = this.DeleteCompanyProductArea.bind(this)
            this.DeleteCompanyProductAreaEntry = this.DeleteCompanyProductAreaEntry.bind(this)
            this.DeleteCompanySegment = this.DeleteCompanySegment.bind(this)
            this.DeleteCompanySegmentEntry = this.DeleteCompanySegmentEntry.bind(this)
            this.DeleteCompanyType = this.DeleteCompanyType.bind(this)
            this.DeleteConnection = this.DeleteConnection.bind(this)
            this.DeleteContact = this.DeleteContact.bind(this)
            this.DeleteContactDetail = this.DeleteContactDetail.bind(this)
            this.DeleteContactDetailType = this.DeleteContactDetailType.bind(this)
            this.DeleteContactDocument = this.DeleteContactDocument.bind(this)
            this.DeleteContactNote = this.DeleteContactNote.bind(this)
            this.DeleteContactRole = this.DeleteContactRole.bind(this)
            this.DeleteDocument = this.DeleteDocument.bind(this)
            this.DeleteDocumentType = this.DeleteDocumentType.bind(this)
            this.DeleteEmployment = this.DeleteEmployment.bind(this)
            this.DeleteEvent = this.DeleteEvent.bind(this)
            this.DeleteEventAttendee = this.DeleteEventAttendee.bind(this)
            this.DeleteEventType = this.DeleteEventType.bind(this)
            this.DeleteFormSubmission = this.DeleteFormSubmission.bind(this)
            this.DeleteMeeting = this.DeleteMeeting.bind(this)
            this.DeleteMeetingAttendee = this.DeleteMeetingAttendee.bind(this)
            this.DeleteMeetingCompany = this.DeleteMeetingCompany.bind(this)
            this.DeleteMeetingType = this.DeleteMeetingType.bind(this)
            this.DeleteNewsletterSignup = this.DeleteNewsletterSignup.bind(this)
            this.DeleteOnCallRole = this.DeleteOnCallRole.bind(this)
            this.DeleteOnCallSchedule = this.DeleteOnCallSchedule.bind(this)
            this.DeleteOpportunity = this.DeleteOpportunity.bind(this)
            this.DeleteOpportunityFunnel = this.DeleteOpportunityFunnel.bind(this)
            this.DeleteOpportunityFunnelStep = this.DeleteOpportunityFunnelStep.bind(this)
            this.DeleteOpportunityProduct = this.DeleteOpportunityProduct.bind(this)
            this.DeleteOpportunityType = this.DeleteOpportunityType.bind(this)
            this.DeleteOrganizationDocument = this.DeleteOrganizationDocument.bind(this)
            this.DeleteProduct = this.DeleteProduct.bind(this)
            this.DeleteProductCategory = this.DeleteProductCategory.bind(this)
            this.DeleteProductDocument = this.DeleteProductDocument.bind(this)
            this.DeleteProductSubcategory = this.DeleteProductSubcategory.bind(this)
            this.DeleteProductUser = this.DeleteProductUser.bind(this)
            this.DeleteSkrymCompanyRole = this.DeleteSkrymCompanyRole.bind(this)
            this.DeleteSkrymCompanyRoleArea = this.DeleteSkrymCompanyRoleArea.bind(this)
            this.DeleteSkrymContactRole = this.DeleteSkrymContactRole.bind(this)
            this.DeleteSprint = this.DeleteSprint.bind(this)
            this.DeleteSprintDailyStandup = this.DeleteSprintDailyStandup.bind(this)
            this.DeleteSprintDailyStandupEntry = this.DeleteSprintDailyStandupEntry.bind(this)
            this.DeleteSprintMessage = this.DeleteSprintMessage.bind(this)
            this.DeleteSprintMessageType = this.DeleteSprintMessageType.bind(this)
            this.DeleteSprintRole = this.DeleteSprintRole.bind(this)
            this.DeleteSprintRoleEntry = this.DeleteSprintRoleEntry.bind(this)
            this.DeleteTask = this.DeleteTask.bind(this)
            this.DeleteTaskOwner = this.DeleteTaskOwner.bind(this)
            this.DeleteTaskStatus = this.DeleteTaskStatus.bind(this)
            this.DeleteWorkingTime = this.DeleteWorkingTime.bind(this)
            this.DeleteWorkingTimeLocation = this.DeleteWorkingTimeLocation.bind(this)
            this.DeleteWorkingTimeType = this.DeleteWorkingTimeType.bind(this)
            this.GetAllCallSheets = this.GetAllCallSheets.bind(this)
            this.GetAllChannels = this.GetAllChannels.bind(this)
            this.GetAllChannelsByConnectionSourceChannelId = this.GetAllChannelsByConnectionSourceChannelId.bind(this)
            this.GetAllCompanies = this.GetAllCompanies.bind(this)
            this.GetAllCompaniesByCompanyBillingInfoCompanyId = this.GetAllCompaniesByCompanyBillingInfoCompanyId.bind(this)
            this.GetAllCompaniesByCompanyInvoiceCompanyId = this.GetAllCompaniesByCompanyInvoiceCompanyId.bind(this)
            this.GetAllCompaniesByCompanyNoteCompanyId = this.GetAllCompaniesByCompanyNoteCompanyId.bind(this)
            this.GetAllCompaniesByCompanyProductAreaCompanyId = this.GetAllCompaniesByCompanyProductAreaCompanyId.bind(this)
            this.GetAllCompaniesByCompanySegmentEntryCompanyId = this.GetAllCompaniesByCompanySegmentEntryCompanyId.bind(this)
            this.GetAllCompaniesByConnectionReceivingCompanyId = this.GetAllCompaniesByConnectionReceivingCompanyId.bind(this)
            this.GetAllCompaniesByConnectionSourceCompanyId = this.GetAllCompaniesByConnectionSourceCompanyId.bind(this)
            this.GetAllCompaniesByConnectionTargetCompanyId = this.GetAllCompaniesByConnectionTargetCompanyId.bind(this)
            this.GetAllCompaniesByContactRoleCompanyId = this.GetAllCompaniesByContactRoleCompanyId.bind(this)
            this.GetAllCompaniesByMeetingCompanyCompanyId = this.GetAllCompaniesByMeetingCompanyCompanyId.bind(this)
            this.GetAllCompaniesByOpportunityCompanyId = this.GetAllCompaniesByOpportunityCompanyId.bind(this)
            this.GetAllCompaniesByOrganizationDocumentOrganizationId = this.GetAllCompaniesByOrganizationDocumentOrganizationId.bind(this)
            this.GetAllCompaniesByProductProviderCompanyId = this.GetAllCompaniesByProductProviderCompanyId.bind(this)
            this.GetAllCompaniesByProductUserUserCompanyId = this.GetAllCompaniesByProductUserUserCompanyId.bind(this)
            this.GetAllCompaniesBySkrymContactRoleCompanyId = this.GetAllCompaniesBySkrymContactRoleCompanyId.bind(this)
            this.GetAllCompaniesByTaskCompanyId = this.GetAllCompaniesByTaskCompanyId.bind(this)
            this.GetAllCompaniesByWorkingTimeLocationCompanyId = this.GetAllCompaniesByWorkingTimeLocationCompanyId.bind(this)
            this.GetAllCompaniesByWorkingTimeTypeCompanyId = this.GetAllCompaniesByWorkingTimeTypeCompanyId.bind(this)
            this.GetAllCompanyBillingInfos = this.GetAllCompanyBillingInfos.bind(this)
            this.GetAllCompanyInvoices = this.GetAllCompanyInvoices.bind(this)
            this.GetAllCompanyNotes = this.GetAllCompanyNotes.bind(this)
            this.GetAllCompanyProductAreaEntries = this.GetAllCompanyProductAreaEntries.bind(this)
            this.GetAllCompanyProductAreas = this.GetAllCompanyProductAreas.bind(this)
            this.GetAllCompanyProductAreasByCompanyProductAreaEntryCompanyAreaId = this.GetAllCompanyProductAreasByCompanyProductAreaEntryCompanyAreaId.bind(this)
            this.GetAllCompanySegmentEntries = this.GetAllCompanySegmentEntries.bind(this)
            this.GetAllCompanySegments = this.GetAllCompanySegments.bind(this)
            this.GetAllCompanySegmentsByCompanySegmentEntryCompanySegmentId = this.GetAllCompanySegmentsByCompanySegmentEntryCompanySegmentId.bind(this)
            this.GetAllCompanyTypes = this.GetAllCompanyTypes.bind(this)
            this.GetAllCompanyTypesByCompanySegmentTypeId = this.GetAllCompanyTypesByCompanySegmentTypeId.bind(this)
            this.GetAllCompanyTypesByCompanyTypeId = this.GetAllCompanyTypesByCompanyTypeId.bind(this)
            this.GetAllConnections = this.GetAllConnections.bind(this)
            this.GetAllContactDetailTypes = this.GetAllContactDetailTypes.bind(this)
            this.GetAllContactDetailTypesByContactDetailTypeId = this.GetAllContactDetailTypesByContactDetailTypeId.bind(this)
            this.GetAllContactDetails = this.GetAllContactDetails.bind(this)
            this.GetAllContactDocuments = this.GetAllContactDocuments.bind(this)
            this.GetAllContactDocumentsByEmploymentContract = this.GetAllContactDocumentsByEmploymentContract.bind(this)
            this.GetAllContactNotes = this.GetAllContactNotes.bind(this)
            this.GetAllContactRoles = this.GetAllContactRoles.bind(this)
            this.GetAllContactRolesByEmploymentContactRoleId = this.GetAllContactRolesByEmploymentContactRoleId.bind(this)
            this.GetAllContactRolesByWorkingTimeContactRoleId = this.GetAllContactRolesByWorkingTimeContactRoleId.bind(this)
            this.GetAllContacts = this.GetAllContacts.bind(this)
            this.GetAllContactsByCallSheetCallerId = this.GetAllContactsByCallSheetCallerId.bind(this)
            this.GetAllContactsByCallSheetCallingId = this.GetAllContactsByCallSheetCallingId.bind(this)
            this.GetAllContactsByCallSheetCreatedBy = this.GetAllContactsByCallSheetCreatedBy.bind(this)
            this.GetAllContactsByCallSheetUpdatedBy = this.GetAllContactsByCallSheetUpdatedBy.bind(this)
            this.GetAllContactsByChannelCreatedBy = this.GetAllContactsByChannelCreatedBy.bind(this)
            this.GetAllContactsByChannelUpdatedBy = this.GetAllContactsByChannelUpdatedBy.bind(this)
            this.GetAllContactsByCompanyBillingInfoCreatedBy = this.GetAllContactsByCompanyBillingInfoCreatedBy.bind(this)
            this.GetAllContactsByCompanyBillingInfoUpdatedBy = this.GetAllContactsByCompanyBillingInfoUpdatedBy.bind(this)
            this.GetAllContactsByCompanyCreatedBy = this.GetAllContactsByCompanyCreatedBy.bind(this)
            this.GetAllContactsByCompanyInvoiceCreatedBy = this.GetAllContactsByCompanyInvoiceCreatedBy.bind(this)
            this.GetAllContactsByCompanyInvoiceUpdatedBy = this.GetAllContactsByCompanyInvoiceUpdatedBy.bind(this)
            this.GetAllContactsByCompanyNoteCreatedBy = this.GetAllContactsByCompanyNoteCreatedBy.bind(this)
            this.GetAllContactsByCompanyNoteUpdatedBy = this.GetAllContactsByCompanyNoteUpdatedBy.bind(this)
            this.GetAllContactsByCompanyProductAreaCreatedBy = this.GetAllContactsByCompanyProductAreaCreatedBy.bind(this)
            this.GetAllContactsByCompanyProductAreaEntryCreatedBy = this.GetAllContactsByCompanyProductAreaEntryCreatedBy.bind(this)
            this.GetAllContactsByCompanyProductAreaEntryUpdatedBy = this.GetAllContactsByCompanyProductAreaEntryUpdatedBy.bind(this)
            this.GetAllContactsByCompanyProductAreaUpdatedBy = this.GetAllContactsByCompanyProductAreaUpdatedBy.bind(this)
            this.GetAllContactsByCompanySegmentCreatedBy = this.GetAllContactsByCompanySegmentCreatedBy.bind(this)
            this.GetAllContactsByCompanySegmentEntryCreatedBy = this.GetAllContactsByCompanySegmentEntryCreatedBy.bind(this)
            this.GetAllContactsByCompanySegmentEntryUpdatedBy = this.GetAllContactsByCompanySegmentEntryUpdatedBy.bind(this)
            this.GetAllContactsByCompanySegmentUpdatedBy = this.GetAllContactsByCompanySegmentUpdatedBy.bind(this)
            this.GetAllContactsByCompanyTypeCreatedBy = this.GetAllContactsByCompanyTypeCreatedBy.bind(this)
            this.GetAllContactsByCompanyTypeUpdatedBy = this.GetAllContactsByCompanyTypeUpdatedBy.bind(this)
            this.GetAllContactsByCompanyUpdatedBy = this.GetAllContactsByCompanyUpdatedBy.bind(this)
            this.GetAllContactsByConnectionCreatedBy = this.GetAllContactsByConnectionCreatedBy.bind(this)
            this.GetAllContactsByConnectionSourceContactId = this.GetAllContactsByConnectionSourceContactId.bind(this)
            this.GetAllContactsByConnectionTargetContactId = this.GetAllContactsByConnectionTargetContactId.bind(this)
            this.GetAllContactsByConnectionUpdatedBy = this.GetAllContactsByConnectionUpdatedBy.bind(this)
            this.GetAllContactsByContactDetailContactId = this.GetAllContactsByContactDetailContactId.bind(this)
            this.GetAllContactsByContactDetailCreatedBy = this.GetAllContactsByContactDetailCreatedBy.bind(this)
            this.GetAllContactsByContactDetailTypeCreatedBy = this.GetAllContactsByContactDetailTypeCreatedBy.bind(this)
            this.GetAllContactsByContactDetailTypeUpdatedBy = this.GetAllContactsByContactDetailTypeUpdatedBy.bind(this)
            this.GetAllContactsByContactDetailUpdatedBy = this.GetAllContactsByContactDetailUpdatedBy.bind(this)
            this.GetAllContactsByContactDocumentContactId = this.GetAllContactsByContactDocumentContactId.bind(this)
            this.GetAllContactsByContactDocumentCreatedBy = this.GetAllContactsByContactDocumentCreatedBy.bind(this)
            this.GetAllContactsByContactDocumentUpdatedBy = this.GetAllContactsByContactDocumentUpdatedBy.bind(this)
            this.GetAllContactsByContactNoteContactId = this.GetAllContactsByContactNoteContactId.bind(this)
            this.GetAllContactsByContactNoteCreatedBy = this.GetAllContactsByContactNoteCreatedBy.bind(this)
            this.GetAllContactsByContactNoteUpdatedBy = this.GetAllContactsByContactNoteUpdatedBy.bind(this)
            this.GetAllContactsByContactRoleContactId = this.GetAllContactsByContactRoleContactId.bind(this)
            this.GetAllContactsByContactRoleCreatedBy = this.GetAllContactsByContactRoleCreatedBy.bind(this)
            this.GetAllContactsByContactRoleUpdatedBy = this.GetAllContactsByContactRoleUpdatedBy.bind(this)
            this.GetAllContactsByDocumentCreatedBy = this.GetAllContactsByDocumentCreatedBy.bind(this)
            this.GetAllContactsByDocumentTypeCreatedBy = this.GetAllContactsByDocumentTypeCreatedBy.bind(this)
            this.GetAllContactsByDocumentTypeUpdatedBy = this.GetAllContactsByDocumentTypeUpdatedBy.bind(this)
            this.GetAllContactsByDocumentUpdatedBy = this.GetAllContactsByDocumentUpdatedBy.bind(this)
            this.GetAllContactsByEmploymentCreatedBy = this.GetAllContactsByEmploymentCreatedBy.bind(this)
            this.GetAllContactsByEmploymentUpdatedBy = this.GetAllContactsByEmploymentUpdatedBy.bind(this)
            this.GetAllContactsByEventAttendeeContactId = this.GetAllContactsByEventAttendeeContactId.bind(this)
            this.GetAllContactsByEventAttendeeCreatedBy = this.GetAllContactsByEventAttendeeCreatedBy.bind(this)
            this.GetAllContactsByEventAttendeeUpdatedBy = this.GetAllContactsByEventAttendeeUpdatedBy.bind(this)
            this.GetAllContactsByEventCreatedBy = this.GetAllContactsByEventCreatedBy.bind(this)
            this.GetAllContactsByEventTypeCreatedBy = this.GetAllContactsByEventTypeCreatedBy.bind(this)
            this.GetAllContactsByEventTypeUpdatedBy = this.GetAllContactsByEventTypeUpdatedBy.bind(this)
            this.GetAllContactsByEventUpdatedBy = this.GetAllContactsByEventUpdatedBy.bind(this)
            this.GetAllContactsByMeetingAttendeeContactId = this.GetAllContactsByMeetingAttendeeContactId.bind(this)
            this.GetAllContactsByMeetingAttendeeCreatedBy = this.GetAllContactsByMeetingAttendeeCreatedBy.bind(this)
            this.GetAllContactsByMeetingAttendeeUpdatedBy = this.GetAllContactsByMeetingAttendeeUpdatedBy.bind(this)
            this.GetAllContactsByMeetingCompanyCreatedBy = this.GetAllContactsByMeetingCompanyCreatedBy.bind(this)
            this.GetAllContactsByMeetingCompanyUpdatedBy = this.GetAllContactsByMeetingCompanyUpdatedBy.bind(this)
            this.GetAllContactsByMeetingCreatedBy = this.GetAllContactsByMeetingCreatedBy.bind(this)
            this.GetAllContactsByMeetingTypeCreatedBy = this.GetAllContactsByMeetingTypeCreatedBy.bind(this)
            this.GetAllContactsByMeetingTypeUpdatedBy = this.GetAllContactsByMeetingTypeUpdatedBy.bind(this)
            this.GetAllContactsByMeetingUpdatedBy = this.GetAllContactsByMeetingUpdatedBy.bind(this)
            this.GetAllContactsByOnCallRoleCreatedBy = this.GetAllContactsByOnCallRoleCreatedBy.bind(this)
            this.GetAllContactsByOnCallRoleUpdatedBy = this.GetAllContactsByOnCallRoleUpdatedBy.bind(this)
            this.GetAllContactsByOnCallScheduleContactId = this.GetAllContactsByOnCallScheduleContactId.bind(this)
            this.GetAllContactsByOnCallScheduleCreatedBy = this.GetAllContactsByOnCallScheduleCreatedBy.bind(this)
            this.GetAllContactsByOnCallScheduleUpdatedBy = this.GetAllContactsByOnCallScheduleUpdatedBy.bind(this)
            this.GetAllContactsByOpportunityCreatedBy = this.GetAllContactsByOpportunityCreatedBy.bind(this)
            this.GetAllContactsByOpportunityFunnelCreatedBy = this.GetAllContactsByOpportunityFunnelCreatedBy.bind(this)
            this.GetAllContactsByOpportunityFunnelStepCreatedBy = this.GetAllContactsByOpportunityFunnelStepCreatedBy.bind(this)
            this.GetAllContactsByOpportunityFunnelStepUpdatedBy = this.GetAllContactsByOpportunityFunnelStepUpdatedBy.bind(this)
            this.GetAllContactsByOpportunityFunnelUpdatedBy = this.GetAllContactsByOpportunityFunnelUpdatedBy.bind(this)
            this.GetAllContactsByOpportunityProductCreatedBy = this.GetAllContactsByOpportunityProductCreatedBy.bind(this)
            this.GetAllContactsByOpportunityProductUpdatedBy = this.GetAllContactsByOpportunityProductUpdatedBy.bind(this)
            this.GetAllContactsByOpportunityTypeCreatedBy = this.GetAllContactsByOpportunityTypeCreatedBy.bind(this)
            this.GetAllContactsByOpportunityTypeUpdatedBy = this.GetAllContactsByOpportunityTypeUpdatedBy.bind(this)
            this.GetAllContactsByOpportunityUpdatedBy = this.GetAllContactsByOpportunityUpdatedBy.bind(this)
            this.GetAllContactsByOrganizationDocumentCreatedBy = this.GetAllContactsByOrganizationDocumentCreatedBy.bind(this)
            this.GetAllContactsByOrganizationDocumentUpdatedBy = this.GetAllContactsByOrganizationDocumentUpdatedBy.bind(this)
            this.GetAllContactsByProductCategoryCreatedBy = this.GetAllContactsByProductCategoryCreatedBy.bind(this)
            this.GetAllContactsByProductCategoryUpdatedBy = this.GetAllContactsByProductCategoryUpdatedBy.bind(this)
            this.GetAllContactsByProductCreatedBy = this.GetAllContactsByProductCreatedBy.bind(this)
            this.GetAllContactsByProductDocumentCreatedBy = this.GetAllContactsByProductDocumentCreatedBy.bind(this)
            this.GetAllContactsByProductDocumentUpdatedBy = this.GetAllContactsByProductDocumentUpdatedBy.bind(this)
            this.GetAllContactsByProductSubcategoryCreatedBy = this.GetAllContactsByProductSubcategoryCreatedBy.bind(this)
            this.GetAllContactsByProductSubcategoryUpdatedBy = this.GetAllContactsByProductSubcategoryUpdatedBy.bind(this)
            this.GetAllContactsByProductUpdatedBy = this.GetAllContactsByProductUpdatedBy.bind(this)
            this.GetAllContactsByProductUserCreatedBy = this.GetAllContactsByProductUserCreatedBy.bind(this)
            this.GetAllContactsByProductUserUpdatedBy = this.GetAllContactsByProductUserUpdatedBy.bind(this)
            this.GetAllContactsBySkrymCompanyRoleAreaCreatedBy = this.GetAllContactsBySkrymCompanyRoleAreaCreatedBy.bind(this)
            this.GetAllContactsBySkrymCompanyRoleAreaUpdatedBy = this.GetAllContactsBySkrymCompanyRoleAreaUpdatedBy.bind(this)
            this.GetAllContactsBySkrymCompanyRoleCreatedBy = this.GetAllContactsBySkrymCompanyRoleCreatedBy.bind(this)
            this.GetAllContactsBySkrymCompanyRoleUpdatedBy = this.GetAllContactsBySkrymCompanyRoleUpdatedBy.bind(this)
            this.GetAllContactsBySkrymContactRoleContactId = this.GetAllContactsBySkrymContactRoleContactId.bind(this)
            this.GetAllContactsBySkrymContactRoleCreatedBy = this.GetAllContactsBySkrymContactRoleCreatedBy.bind(this)
            this.GetAllContactsBySkrymContactRoleUpdatedBy = this.GetAllContactsBySkrymContactRoleUpdatedBy.bind(this)
            this.GetAllContactsBySprintCreatedBy = this.GetAllContactsBySprintCreatedBy.bind(this)
            this.GetAllContactsBySprintDailyStandupCreatedBy = this.GetAllContactsBySprintDailyStandupCreatedBy.bind(this)
            this.GetAllContactsBySprintDailyStandupEntryCreatedBy = this.GetAllContactsBySprintDailyStandupEntryCreatedBy.bind(this)
            this.GetAllContactsBySprintDailyStandupEntryTeamMemberId = this.GetAllContactsBySprintDailyStandupEntryTeamMemberId.bind(this)
            this.GetAllContactsBySprintDailyStandupEntryUpdatedBy = this.GetAllContactsBySprintDailyStandupEntryUpdatedBy.bind(this)
            this.GetAllContactsBySprintDailyStandupHostedBy = this.GetAllContactsBySprintDailyStandupHostedBy.bind(this)
            this.GetAllContactsBySprintDailyStandupUpdatedBy = this.GetAllContactsBySprintDailyStandupUpdatedBy.bind(this)
            this.GetAllContactsBySprintMessageCreatedBy = this.GetAllContactsBySprintMessageCreatedBy.bind(this)
            this.GetAllContactsBySprintMessageTypeCreatedBy = this.GetAllContactsBySprintMessageTypeCreatedBy.bind(this)
            this.GetAllContactsBySprintMessageTypeUpdatedBy = this.GetAllContactsBySprintMessageTypeUpdatedBy.bind(this)
            this.GetAllContactsBySprintMessageUpdatedBy = this.GetAllContactsBySprintMessageUpdatedBy.bind(this)
            this.GetAllContactsBySprintRoleCreatedBy = this.GetAllContactsBySprintRoleCreatedBy.bind(this)
            this.GetAllContactsBySprintRoleEntryContactId = this.GetAllContactsBySprintRoleEntryContactId.bind(this)
            this.GetAllContactsBySprintRoleEntryCreatedBy = this.GetAllContactsBySprintRoleEntryCreatedBy.bind(this)
            this.GetAllContactsBySprintRoleEntryUpdatedBy = this.GetAllContactsBySprintRoleEntryUpdatedBy.bind(this)
            this.GetAllContactsBySprintRoleUpdatedBy = this.GetAllContactsBySprintRoleUpdatedBy.bind(this)
            this.GetAllContactsBySprintUpdatedBy = this.GetAllContactsBySprintUpdatedBy.bind(this)
            this.GetAllContactsByTaskCreatedBy = this.GetAllContactsByTaskCreatedBy.bind(this)
            this.GetAllContactsByTaskOwnerContactId = this.GetAllContactsByTaskOwnerContactId.bind(this)
            this.GetAllContactsByTaskOwnerCreatedBy = this.GetAllContactsByTaskOwnerCreatedBy.bind(this)
            this.GetAllContactsByTaskOwnerUpdatedBy = this.GetAllContactsByTaskOwnerUpdatedBy.bind(this)
            this.GetAllContactsByTaskStatusCreatedBy = this.GetAllContactsByTaskStatusCreatedBy.bind(this)
            this.GetAllContactsByTaskStatusUpdatedBy = this.GetAllContactsByTaskStatusUpdatedBy.bind(this)
            this.GetAllContactsByTaskUpdatedBy = this.GetAllContactsByTaskUpdatedBy.bind(this)
            this.GetAllContactsByWorkingTimeCreatedBy = this.GetAllContactsByWorkingTimeCreatedBy.bind(this)
            this.GetAllContactsByWorkingTimeLocationCreatedBy = this.GetAllContactsByWorkingTimeLocationCreatedBy.bind(this)
            this.GetAllContactsByWorkingTimeLocationUpdatedBy = this.GetAllContactsByWorkingTimeLocationUpdatedBy.bind(this)
            this.GetAllContactsByWorkingTimeTypeCreatedBy = this.GetAllContactsByWorkingTimeTypeCreatedBy.bind(this)
            this.GetAllContactsByWorkingTimeTypeUpdatedBy = this.GetAllContactsByWorkingTimeTypeUpdatedBy.bind(this)
            this.GetAllContactsByWorkingTimeUpdatedBy = this.GetAllContactsByWorkingTimeUpdatedBy.bind(this)
            this.GetAllDocumentTypes = this.GetAllDocumentTypes.bind(this)
            this.GetAllDocumentTypesByDocumentTypeId = this.GetAllDocumentTypesByDocumentTypeId.bind(this)
            this.GetAllDocuments = this.GetAllDocuments.bind(this)
            this.GetAllDocumentsByContactDocumentDocumentId = this.GetAllDocumentsByContactDocumentDocumentId.bind(this)
            this.GetAllDocumentsByOrganizationDocumentDocumentId = this.GetAllDocumentsByOrganizationDocumentDocumentId.bind(this)
            this.GetAllDocumentsByProductDocumentDocumentId = this.GetAllDocumentsByProductDocumentDocumentId.bind(this)
            this.GetAllEmployments = this.GetAllEmployments.bind(this)
            this.GetAllEventAttendees = this.GetAllEventAttendees.bind(this)
            this.GetAllEventTypes = this.GetAllEventTypes.bind(this)
            this.GetAllEventTypesByEventTypeId = this.GetAllEventTypesByEventTypeId.bind(this)
            this.GetAllEvents = this.GetAllEvents.bind(this)
            this.GetAllEventsByConnectionSourceEventId = this.GetAllEventsByConnectionSourceEventId.bind(this)
            this.GetAllEventsByEventAttendeeEventId = this.GetAllEventsByEventAttendeeEventId.bind(this)
            this.GetAllFormSubmissions = this.GetAllFormSubmissions.bind(this)
            this.GetAllMeetingAttendees = this.GetAllMeetingAttendees.bind(this)
            this.GetAllMeetingCompanies = this.GetAllMeetingCompanies.bind(this)
            this.GetAllMeetingTypes = this.GetAllMeetingTypes.bind(this)
            this.GetAllMeetingTypesByMeetingTypeId = this.GetAllMeetingTypesByMeetingTypeId.bind(this)
            this.GetAllMeetings = this.GetAllMeetings.bind(this)
            this.GetAllMeetingsByMeetingAttendeeMeetingId = this.GetAllMeetingsByMeetingAttendeeMeetingId.bind(this)
            this.GetAllMeetingsByMeetingCompanyMeetingId = this.GetAllMeetingsByMeetingCompanyMeetingId.bind(this)
            this.GetAllNewsletterSignups = this.GetAllNewsletterSignups.bind(this)
            this.GetAllOnCallRoles = this.GetAllOnCallRoles.bind(this)
            this.GetAllOnCallRolesByOnCallScheduleRoleId = this.GetAllOnCallRolesByOnCallScheduleRoleId.bind(this)
            this.GetAllOnCallSchedules = this.GetAllOnCallSchedules.bind(this)
            this.GetAllOpportunities = this.GetAllOpportunities.bind(this)
            this.GetAllOpportunitiesByOpportunityProductOpportunityId = this.GetAllOpportunitiesByOpportunityProductOpportunityId.bind(this)
            this.GetAllOpportunityFunnelSteps = this.GetAllOpportunityFunnelSteps.bind(this)
            this.GetAllOpportunityFunnelStepsByOpportunityFunnelStepId = this.GetAllOpportunityFunnelStepsByOpportunityFunnelStepId.bind(this)
            this.GetAllOpportunityFunnels = this.GetAllOpportunityFunnels.bind(this)
            this.GetAllOpportunityFunnelsByOpportunityFunnelStepOpportunityFunnelId = this.GetAllOpportunityFunnelsByOpportunityFunnelStepOpportunityFunnelId.bind(this)
            this.GetAllOpportunityProducts = this.GetAllOpportunityProducts.bind(this)
            this.GetAllOpportunityTypes = this.GetAllOpportunityTypes.bind(this)
            this.GetAllOpportunityTypesByOpportunityFunnelOpportunityTypeId = this.GetAllOpportunityTypesByOpportunityFunnelOpportunityTypeId.bind(this)
            this.GetAllOpportunityTypesByOpportunityOpportunityTypeId = this.GetAllOpportunityTypesByOpportunityOpportunityTypeId.bind(this)
            this.GetAllOrganizationDocuments = this.GetAllOrganizationDocuments.bind(this)
            this.GetAllProductCategories = this.GetAllProductCategories.bind(this)
            this.GetAllProductCategoriesByProductProductCategoryId = this.GetAllProductCategoriesByProductProductCategoryId.bind(this)
            this.GetAllProductCategoriesByProductSubcategoryParentCategoryId = this.GetAllProductCategoriesByProductSubcategoryParentCategoryId.bind(this)
            this.GetAllProductDocuments = this.GetAllProductDocuments.bind(this)
            this.GetAllProductSubcategories = this.GetAllProductSubcategories.bind(this)
            this.GetAllProductSubcategoriesByProductProductSubcategoryId = this.GetAllProductSubcategoriesByProductProductSubcategoryId.bind(this)
            this.GetAllProductUsers = this.GetAllProductUsers.bind(this)
            this.GetAllProducts = this.GetAllProducts.bind(this)
            this.GetAllProductsByCompanyProductAreaEntryProductId = this.GetAllProductsByCompanyProductAreaEntryProductId.bind(this)
            this.GetAllProductsByOpportunityProductProductId = this.GetAllProductsByOpportunityProductProductId.bind(this)
            this.GetAllProductsByProductDocumentProductId = this.GetAllProductsByProductDocumentProductId.bind(this)
            this.GetAllProductsByProductUserProductId = this.GetAllProductsByProductUserProductId.bind(this)
            this.GetAllSkrymCompanyRoleAreas = this.GetAllSkrymCompanyRoleAreas.bind(this)
            this.GetAllSkrymCompanyRoleAreasBySkrymCompanyRoleAreaId = this.GetAllSkrymCompanyRoleAreasBySkrymCompanyRoleAreaId.bind(this)
            this.GetAllSkrymCompanyRoles = this.GetAllSkrymCompanyRoles.bind(this)
            this.GetAllSkrymCompanyRolesBySkrymContactRoleCompanyRoleId = this.GetAllSkrymCompanyRolesBySkrymContactRoleCompanyRoleId.bind(this)
            this.GetAllSkrymContactRoles = this.GetAllSkrymContactRoles.bind(this)
            this.GetAllSprintDailyStandupEntries = this.GetAllSprintDailyStandupEntries.bind(this)
            this.GetAllSprintDailyStandups = this.GetAllSprintDailyStandups.bind(this)
            this.GetAllSprintDailyStandupsBySprintDailyStandupEntryStandupId = this.GetAllSprintDailyStandupsBySprintDailyStandupEntryStandupId.bind(this)
            this.GetAllSprintMessageTypes = this.GetAllSprintMessageTypes.bind(this)
            this.GetAllSprintMessageTypesBySprintMessageMessageTypeId = this.GetAllSprintMessageTypesBySprintMessageMessageTypeId.bind(this)
            this.GetAllSprintMessages = this.GetAllSprintMessages.bind(this)
            this.GetAllSprintRoleEntries = this.GetAllSprintRoleEntries.bind(this)
            this.GetAllSprintRoles = this.GetAllSprintRoles.bind(this)
            this.GetAllSprintRolesBySprintRoleEntrySprintRoleId = this.GetAllSprintRolesBySprintRoleEntrySprintRoleId.bind(this)
            this.GetAllSprints = this.GetAllSprints.bind(this)
            this.GetAllSprintsBySprintDailyStandupSprintId = this.GetAllSprintsBySprintDailyStandupSprintId.bind(this)
            this.GetAllSprintsBySprintMessageSprintId = this.GetAllSprintsBySprintMessageSprintId.bind(this)
            this.GetAllSprintsBySprintRoleEntrySprintId = this.GetAllSprintsBySprintRoleEntrySprintId.bind(this)
            this.GetAllTaskOwners = this.GetAllTaskOwners.bind(this)
            this.GetAllTaskStatuses = this.GetAllTaskStatuses.bind(this)
            this.GetAllTaskStatusesByTaskStatusId = this.GetAllTaskStatusesByTaskStatusId.bind(this)
            this.GetAllTasks = this.GetAllTasks.bind(this)
            this.GetAllTasksByTaskOwnerTaskId = this.GetAllTasksByTaskOwnerTaskId.bind(this)
            this.GetAllTasksForTaskOwner = this.GetAllTasksForTaskOwner.bind(this)
            this.GetAllWorkingTimeLocations = this.GetAllWorkingTimeLocations.bind(this)
            this.GetAllWorkingTimeLocationsByWorkingTimeLocation = this.GetAllWorkingTimeLocationsByWorkingTimeLocation.bind(this)
            this.GetAllWorkingTimeTypes = this.GetAllWorkingTimeTypes.bind(this)
            this.GetAllWorkingTimeTypesByWorkingTimeType = this.GetAllWorkingTimeTypesByWorkingTimeType.bind(this)
            this.GetAllWorkingTimes = this.GetAllWorkingTimes.bind(this)
            this.GetCallSheetAuditById = this.GetCallSheetAuditById.bind(this)
            this.GetCallSheetById = this.GetCallSheetById.bind(this)
            this.GetCallSheetsByCallerId = this.GetCallSheetsByCallerId.bind(this)
            this.GetCallSheetsByCallingId = this.GetCallSheetsByCallingId.bind(this)
            this.GetCallSheetsByCreatedAt = this.GetCallSheetsByCreatedAt.bind(this)
            this.GetCallSheetsByCreatedBy = this.GetCallSheetsByCreatedBy.bind(this)
            this.GetCallSheetsByDay = this.GetCallSheetsByDay.bind(this)
            this.GetCallSheetsByIsCompleted = this.GetCallSheetsByIsCompleted.bind(this)
            this.GetCallSheetsByIsDeleted = this.GetCallSheetsByIsDeleted.bind(this)
            this.GetCallSheetsByUpdatedAt = this.GetCallSheetsByUpdatedAt.bind(this)
            this.GetCallSheetsByUpdatedBy = this.GetCallSheetsByUpdatedBy.bind(this)
            this.GetChannelAuditById = this.GetChannelAuditById.bind(this)
            this.GetChannelById = this.GetChannelById.bind(this)
            this.GetCompaniesByIsDeleted = this.GetCompaniesByIsDeleted.bind(this)
            this.GetCompaniesByName = this.GetCompaniesByName.bind(this)
            this.GetCompaniesByTypeId = this.GetCompaniesByTypeId.bind(this)
            this.GetCompanyAuditById = this.GetCompanyAuditById.bind(this)
            this.GetCompanyBillingInfoAuditById = this.GetCompanyBillingInfoAuditById.bind(this)
            this.GetCompanyBillingInfoById = this.GetCompanyBillingInfoById.bind(this)
            this.GetCompanyBillingInfosByCompanyId = this.GetCompanyBillingInfosByCompanyId.bind(this)
            this.GetCompanyBillingInfosByCompanyInvoiceEmail = this.GetCompanyBillingInfosByCompanyInvoiceEmail.bind(this)
            this.GetCompanyBillingInfosByCompanyRegisteredLocation = this.GetCompanyBillingInfosByCompanyRegisteredLocation.bind(this)
            this.GetCompanyBillingInfosByCompanyRegistrationNo = this.GetCompanyBillingInfosByCompanyRegistrationNo.bind(this)
            this.GetCompanyBillingInfosByCreatedAt = this.GetCompanyBillingInfosByCreatedAt.bind(this)
            this.GetCompanyBillingInfosByCreatedBy = this.GetCompanyBillingInfosByCreatedBy.bind(this)
            this.GetCompanyBillingInfosByIsDeleted = this.GetCompanyBillingInfosByIsDeleted.bind(this)
            this.GetCompanyBillingInfosByUpdatedAt = this.GetCompanyBillingInfosByUpdatedAt.bind(this)
            this.GetCompanyBillingInfosByUpdatedBy = this.GetCompanyBillingInfosByUpdatedBy.bind(this)
            this.GetCompanyById = this.GetCompanyById.bind(this)
            this.GetCompanyInvoiceAuditById = this.GetCompanyInvoiceAuditById.bind(this)
            this.GetCompanyInvoiceById = this.GetCompanyInvoiceById.bind(this)
            this.GetCompanyInvoicesByAmountSek = this.GetCompanyInvoicesByAmountSek.bind(this)
            this.GetCompanyInvoicesByCompanyId = this.GetCompanyInvoicesByCompanyId.bind(this)
            this.GetCompanyInvoicesByCreatedAt = this.GetCompanyInvoicesByCreatedAt.bind(this)
            this.GetCompanyInvoicesByCreatedBy = this.GetCompanyInvoicesByCreatedBy.bind(this)
            this.GetCompanyInvoicesByDueDate = this.GetCompanyInvoicesByDueDate.bind(this)
            this.GetCompanyInvoicesByInvoicePeriodEnd = this.GetCompanyInvoicesByInvoicePeriodEnd.bind(this)
            this.GetCompanyInvoicesByInvoicePeriodStart = this.GetCompanyInvoicesByInvoicePeriodStart.bind(this)
            this.GetCompanyInvoicesByInvoiceUrl = this.GetCompanyInvoicesByInvoiceUrl.bind(this)
            this.GetCompanyInvoicesByIsDeleted = this.GetCompanyInvoicesByIsDeleted.bind(this)
            this.GetCompanyInvoicesByIsPaid = this.GetCompanyInvoicesByIsPaid.bind(this)
            this.GetCompanyInvoicesByName = this.GetCompanyInvoicesByName.bind(this)
            this.GetCompanyInvoicesBySentDate = this.GetCompanyInvoicesBySentDate.bind(this)
            this.GetCompanyInvoicesByUpdatedAt = this.GetCompanyInvoicesByUpdatedAt.bind(this)
            this.GetCompanyInvoicesByUpdatedBy = this.GetCompanyInvoicesByUpdatedBy.bind(this)
            this.GetCompanyNoteAuditById = this.GetCompanyNoteAuditById.bind(this)
            this.GetCompanyNoteById = this.GetCompanyNoteById.bind(this)
            this.GetCompanyNotesByCompanyId = this.GetCompanyNotesByCompanyId.bind(this)
            this.GetCompanyNotesByCreatedAt = this.GetCompanyNotesByCreatedAt.bind(this)
            this.GetCompanyNotesByCreatedBy = this.GetCompanyNotesByCreatedBy.bind(this)
            this.GetCompanyNotesByIsDeleted = this.GetCompanyNotesByIsDeleted.bind(this)
            this.GetCompanyNotesByMessage = this.GetCompanyNotesByMessage.bind(this)
            this.GetCompanyNotesByTitle = this.GetCompanyNotesByTitle.bind(this)
            this.GetCompanyNotesByUpdatedAt = this.GetCompanyNotesByUpdatedAt.bind(this)
            this.GetCompanyNotesByUpdatedBy = this.GetCompanyNotesByUpdatedBy.bind(this)
            this.GetCompanyPageDataById = this.GetCompanyPageDataById.bind(this)
            this.GetCompanyPageDataByIdCustom = this.GetCompanyPageDataByIdCustom.bind(this)
            this.GetCompanyProductAreaAuditById = this.GetCompanyProductAreaAuditById.bind(this)
            this.GetCompanyProductAreaById = this.GetCompanyProductAreaById.bind(this)
            this.GetCompanyProductAreaEntriesByCompanyAreaId = this.GetCompanyProductAreaEntriesByCompanyAreaId.bind(this)
            this.GetCompanyProductAreaEntriesByCreatedAt = this.GetCompanyProductAreaEntriesByCreatedAt.bind(this)
            this.GetCompanyProductAreaEntriesByCreatedBy = this.GetCompanyProductAreaEntriesByCreatedBy.bind(this)
            this.GetCompanyProductAreaEntriesByIsDeleted = this.GetCompanyProductAreaEntriesByIsDeleted.bind(this)
            this.GetCompanyProductAreaEntriesByProductId = this.GetCompanyProductAreaEntriesByProductId.bind(this)
            this.GetCompanyProductAreaEntriesByUpdatedAt = this.GetCompanyProductAreaEntriesByUpdatedAt.bind(this)
            this.GetCompanyProductAreaEntriesByUpdatedBy = this.GetCompanyProductAreaEntriesByUpdatedBy.bind(this)
            this.GetCompanyProductAreaEntryAuditById = this.GetCompanyProductAreaEntryAuditById.bind(this)
            this.GetCompanyProductAreaEntryById = this.GetCompanyProductAreaEntryById.bind(this)
            this.GetCompanyProductAreasByCompanyId = this.GetCompanyProductAreasByCompanyId.bind(this)
            this.GetCompanyProductAreasByCreatedAt = this.GetCompanyProductAreasByCreatedAt.bind(this)
            this.GetCompanyProductAreasByCreatedBy = this.GetCompanyProductAreasByCreatedBy.bind(this)
            this.GetCompanyProductAreasByIsDeleted = this.GetCompanyProductAreasByIsDeleted.bind(this)
            this.GetCompanyProductAreasByName = this.GetCompanyProductAreasByName.bind(this)
            this.GetCompanyProductAreasByUpdatedAt = this.GetCompanyProductAreasByUpdatedAt.bind(this)
            this.GetCompanyProductAreasByUpdatedBy = this.GetCompanyProductAreasByUpdatedBy.bind(this)
            this.GetCompanySegmentAuditById = this.GetCompanySegmentAuditById.bind(this)
            this.GetCompanySegmentById = this.GetCompanySegmentById.bind(this)
            this.GetCompanySegmentEntriesByCompanyId = this.GetCompanySegmentEntriesByCompanyId.bind(this)
            this.GetCompanySegmentEntriesByCompanySegmentId = this.GetCompanySegmentEntriesByCompanySegmentId.bind(this)
            this.GetCompanySegmentEntriesByCreatedAt = this.GetCompanySegmentEntriesByCreatedAt.bind(this)
            this.GetCompanySegmentEntriesByCreatedBy = this.GetCompanySegmentEntriesByCreatedBy.bind(this)
            this.GetCompanySegmentEntriesByIsDeleted = this.GetCompanySegmentEntriesByIsDeleted.bind(this)
            this.GetCompanySegmentEntriesByUpdatedAt = this.GetCompanySegmentEntriesByUpdatedAt.bind(this)
            this.GetCompanySegmentEntriesByUpdatedBy = this.GetCompanySegmentEntriesByUpdatedBy.bind(this)
            this.GetCompanySegmentEntryAuditById = this.GetCompanySegmentEntryAuditById.bind(this)
            this.GetCompanySegmentEntryById = this.GetCompanySegmentEntryById.bind(this)
            this.GetCompanySegmentsByIsDeleted = this.GetCompanySegmentsByIsDeleted.bind(this)
            this.GetCompanySegmentsByName = this.GetCompanySegmentsByName.bind(this)
            this.GetCompanySegmentsByTypeId = this.GetCompanySegmentsByTypeId.bind(this)
            this.GetCompanyTypeAuditById = this.GetCompanyTypeAuditById.bind(this)
            this.GetCompanyTypeById = this.GetCompanyTypeById.bind(this)
            this.GetCompanyTypesByIsDeleted = this.GetCompanyTypesByIsDeleted.bind(this)
            this.GetCompanyTypesByName = this.GetCompanyTypesByName.bind(this)
            this.GetConnectionAuditById = this.GetConnectionAuditById.bind(this)
            this.GetConnectionById = this.GetConnectionById.bind(this)
            this.GetConnectionsByCreatedAt = this.GetConnectionsByCreatedAt.bind(this)
            this.GetConnectionsByIsDeleted = this.GetConnectionsByIsDeleted.bind(this)
            this.GetConnectionsByReceivingCompanyId = this.GetConnectionsByReceivingCompanyId.bind(this)
            this.GetConnectionsBySourceChannelId = this.GetConnectionsBySourceChannelId.bind(this)
            this.GetConnectionsBySourceCompanyId = this.GetConnectionsBySourceCompanyId.bind(this)
            this.GetConnectionsBySourceContactId = this.GetConnectionsBySourceContactId.bind(this)
            this.GetConnectionsBySourceEventId = this.GetConnectionsBySourceEventId.bind(this)
            this.GetConnectionsByTargetCompanyId = this.GetConnectionsByTargetCompanyId.bind(this)
            this.GetConnectionsByTargetContactId = this.GetConnectionsByTargetContactId.bind(this)
            this.GetConnectionsByUpdatedAt = this.GetConnectionsByUpdatedAt.bind(this)
            this.GetContactAuditById = this.GetContactAuditById.bind(this)
            this.GetContactById = this.GetContactById.bind(this)
            this.GetContactDetailAuditById = this.GetContactDetailAuditById.bind(this)
            this.GetContactDetailById = this.GetContactDetailById.bind(this)
            this.GetContactDetailTypeAuditById = this.GetContactDetailTypeAuditById.bind(this)
            this.GetContactDetailTypeById = this.GetContactDetailTypeById.bind(this)
            this.GetContactDetailTypesByCreatedAt = this.GetContactDetailTypesByCreatedAt.bind(this)
            this.GetContactDetailTypesByCreatedBy = this.GetContactDetailTypesByCreatedBy.bind(this)
            this.GetContactDetailTypesByIsDeleted = this.GetContactDetailTypesByIsDeleted.bind(this)
            this.GetContactDetailTypesByName = this.GetContactDetailTypesByName.bind(this)
            this.GetContactDetailTypesByUpdatedAt = this.GetContactDetailTypesByUpdatedAt.bind(this)
            this.GetContactDetailTypesByUpdatedBy = this.GetContactDetailTypesByUpdatedBy.bind(this)
            this.GetContactDetailsByActive = this.GetContactDetailsByActive.bind(this)
            this.GetContactDetailsByContactId = this.GetContactDetailsByContactId.bind(this)
            this.GetContactDetailsByCreatedAt = this.GetContactDetailsByCreatedAt.bind(this)
            this.GetContactDetailsByCreatedBy = this.GetContactDetailsByCreatedBy.bind(this)
            this.GetContactDetailsByIsDeleted = this.GetContactDetailsByIsDeleted.bind(this)
            this.GetContactDetailsByIsPrimary = this.GetContactDetailsByIsPrimary.bind(this)
            this.GetContactDetailsByLabel = this.GetContactDetailsByLabel.bind(this)
            this.GetContactDetailsByTypeId = this.GetContactDetailsByTypeId.bind(this)
            this.GetContactDetailsByUpdatedAt = this.GetContactDetailsByUpdatedAt.bind(this)
            this.GetContactDetailsByUpdatedBy = this.GetContactDetailsByUpdatedBy.bind(this)
            this.GetContactDetailsByValue = this.GetContactDetailsByValue.bind(this)
            this.GetContactDocumentAuditById = this.GetContactDocumentAuditById.bind(this)
            this.GetContactDocumentById = this.GetContactDocumentById.bind(this)
            this.GetContactDocumentsByContactId = this.GetContactDocumentsByContactId.bind(this)
            this.GetContactDocumentsByCreatedAt = this.GetContactDocumentsByCreatedAt.bind(this)
            this.GetContactDocumentsByCreatedBy = this.GetContactDocumentsByCreatedBy.bind(this)
            this.GetContactDocumentsByDocumentId = this.GetContactDocumentsByDocumentId.bind(this)
            this.GetContactDocumentsByIsDeleted = this.GetContactDocumentsByIsDeleted.bind(this)
            this.GetContactDocumentsByUpdatedAt = this.GetContactDocumentsByUpdatedAt.bind(this)
            this.GetContactDocumentsByUpdatedBy = this.GetContactDocumentsByUpdatedBy.bind(this)
            this.GetContactNoteAuditById = this.GetContactNoteAuditById.bind(this)
            this.GetContactNoteById = this.GetContactNoteById.bind(this)
            this.GetContactNotesByContactId = this.GetContactNotesByContactId.bind(this)
            this.GetContactNotesByCreatedAt = this.GetContactNotesByCreatedAt.bind(this)
            this.GetContactNotesByCreatedBy = this.GetContactNotesByCreatedBy.bind(this)
            this.GetContactNotesByIsDeleted = this.GetContactNotesByIsDeleted.bind(this)
            this.GetContactNotesByMessage = this.GetContactNotesByMessage.bind(this)
            this.GetContactNotesByTitle = this.GetContactNotesByTitle.bind(this)
            this.GetContactNotesByUpdatedAt = this.GetContactNotesByUpdatedAt.bind(this)
            this.GetContactNotesByUpdatedBy = this.GetContactNotesByUpdatedBy.bind(this)
            this.GetContactRoleAuditById = this.GetContactRoleAuditById.bind(this)
            this.GetContactRoleById = this.GetContactRoleById.bind(this)
            this.GetContactRolesByActive = this.GetContactRolesByActive.bind(this)
            this.GetContactRolesByCompanyId = this.GetContactRolesByCompanyId.bind(this)
            this.GetContactRolesByContactId = this.GetContactRolesByContactId.bind(this)
            this.GetContactRolesByCreatedAt = this.GetContactRolesByCreatedAt.bind(this)
            this.GetContactRolesByCreatedBy = this.GetContactRolesByCreatedBy.bind(this)
            this.GetContactRolesByEndDate = this.GetContactRolesByEndDate.bind(this)
            this.GetContactRolesByIsDeleted = this.GetContactRolesByIsDeleted.bind(this)
            this.GetContactRolesByStartDate = this.GetContactRolesByStartDate.bind(this)
            this.GetContactRolesByTitle = this.GetContactRolesByTitle.bind(this)
            this.GetContactRolesByUpdatedAt = this.GetContactRolesByUpdatedAt.bind(this)
            this.GetContactRolesByUpdatedBy = this.GetContactRolesByUpdatedBy.bind(this)
            this.GetContactsByBirthday = this.GetContactsByBirthday.bind(this)
            this.GetContactsByCreatedAt = this.GetContactsByCreatedAt.bind(this)
            this.GetContactsByFirstName = this.GetContactsByFirstName.bind(this)
            this.GetContactsByIsDeleted = this.GetContactsByIsDeleted.bind(this)
            this.GetContactsByLastName = this.GetContactsByLastName.bind(this)
            this.GetContactsByUpdatedAt = this.GetContactsByUpdatedAt.bind(this)
            this.GetDevInfo = this.GetDevInfo.bind(this)
            this.GetDocumentAuditById = this.GetDocumentAuditById.bind(this)
            this.GetDocumentById = this.GetDocumentById.bind(this)
            this.GetDocumentTypeAuditById = this.GetDocumentTypeAuditById.bind(this)
            this.GetDocumentTypeById = this.GetDocumentTypeById.bind(this)
            this.GetDocumentTypesByIsDeleted = this.GetDocumentTypesByIsDeleted.bind(this)
            this.GetDocumentTypesByName = this.GetDocumentTypesByName.bind(this)
            this.GetDocumentsByCreatedAt = this.GetDocumentsByCreatedAt.bind(this)
            this.GetDocumentsByDocumentDescription = this.GetDocumentsByDocumentDescription.bind(this)
            this.GetDocumentsByDocumentName = this.GetDocumentsByDocumentName.bind(this)
            this.GetDocumentsByDocumentUrl = this.GetDocumentsByDocumentUrl.bind(this)
            this.GetDocumentsByIsDeleted = this.GetDocumentsByIsDeleted.bind(this)
            this.GetDocumentsByTypeId = this.GetDocumentsByTypeId.bind(this)
            this.GetDocumentsByUpdatedAt = this.GetDocumentsByUpdatedAt.bind(this)
            this.GetEmploymentAuditById = this.GetEmploymentAuditById.bind(this)
            this.GetEmploymentById = this.GetEmploymentById.bind(this)
            this.GetEmploymentsByContactRoleId = this.GetEmploymentsByContactRoleId.bind(this)
            this.GetEmploymentsByContract = this.GetEmploymentsByContract.bind(this)
            this.GetEmploymentsByCreatedAt = this.GetEmploymentsByCreatedAt.bind(this)
            this.GetEmploymentsByCreatedBy = this.GetEmploymentsByCreatedBy.bind(this)
            this.GetEmploymentsByIsActive = this.GetEmploymentsByIsActive.bind(this)
            this.GetEmploymentsByIsDeleted = this.GetEmploymentsByIsDeleted.bind(this)
            this.GetEmploymentsByIsHourly = this.GetEmploymentsByIsHourly.bind(this)
            this.GetEmploymentsByIsMonthly = this.GetEmploymentsByIsMonthly.bind(this)
            this.GetEmploymentsByName = this.GetEmploymentsByName.bind(this)
            this.GetEmploymentsByNoVacationDays = this.GetEmploymentsByNoVacationDays.bind(this)
            this.GetEmploymentsBySalarySek = this.GetEmploymentsBySalarySek.bind(this)
            this.GetEmploymentsByUpdatedAt = this.GetEmploymentsByUpdatedAt.bind(this)
            this.GetEmploymentsByUpdatedBy = this.GetEmploymentsByUpdatedBy.bind(this)
            this.GetEventAttendeeAuditById = this.GetEventAttendeeAuditById.bind(this)
            this.GetEventAttendeeById = this.GetEventAttendeeById.bind(this)
            this.GetEventAttendeesByContactId = this.GetEventAttendeesByContactId.bind(this)
            this.GetEventAttendeesByEventId = this.GetEventAttendeesByEventId.bind(this)
            this.GetEventAttendeesByIsDeleted = this.GetEventAttendeesByIsDeleted.bind(this)
            this.GetEventAuditById = this.GetEventAuditById.bind(this)
            this.GetEventById = this.GetEventById.bind(this)
            this.GetEventTypeAuditById = this.GetEventTypeAuditById.bind(this)
            this.GetEventTypeById = this.GetEventTypeById.bind(this)
            this.GetEventTypesByCreatedBy = this.GetEventTypesByCreatedBy.bind(this)
            this.GetEventTypesByEventType = this.GetEventTypesByEventType.bind(this)
            this.GetEventTypesByIsDeleted = this.GetEventTypesByIsDeleted.bind(this)
            this.GetEventTypesByTypeDescription = this.GetEventTypesByTypeDescription.bind(this)
            this.GetEventsByEndDate = this.GetEventsByEndDate.bind(this)
            this.GetEventsByIsDeleted = this.GetEventsByIsDeleted.bind(this)
            this.GetEventsByName = this.GetEventsByName.bind(this)
            this.GetEventsByStartDate = this.GetEventsByStartDate.bind(this)
            this.GetEventsByTypeId = this.GetEventsByTypeId.bind(this)
            this.GetEventsByUrl = this.GetEventsByUrl.bind(this)
            this.GetFeed = this.GetFeed.bind(this)
            this.GetFormSubmissionAuditById = this.GetFormSubmissionAuditById.bind(this)
            this.GetFormSubmissionById = this.GetFormSubmissionById.bind(this)
            this.GetFormSubmissionsByCompany = this.GetFormSubmissionsByCompany.bind(this)
            this.GetFormSubmissionsByCreatedAt = this.GetFormSubmissionsByCreatedAt.bind(this)
            this.GetFormSubmissionsByEmail = this.GetFormSubmissionsByEmail.bind(this)
            this.GetFormSubmissionsByFormName = this.GetFormSubmissionsByFormName.bind(this)
            this.GetFormSubmissionsByFormSubmission = this.GetFormSubmissionsByFormSubmission.bind(this)
            this.GetFormSubmissionsByHonung = this.GetFormSubmissionsByHonung.bind(this)
            this.GetFormSubmissionsByIsDeleted = this.GetFormSubmissionsByIsDeleted.bind(this)
            this.GetFormSubmissionsByMessage = this.GetFormSubmissionsByMessage.bind(this)
            this.GetFormSubmissionsByName = this.GetFormSubmissionsByName.bind(this)
            this.GetFormSubmissionsByPhone = this.GetFormSubmissionsByPhone.bind(this)
            this.GetFormSubmissionsByRole = this.GetFormSubmissionsByRole.bind(this)
            this.GetFormSubmissionsByStatus = this.GetFormSubmissionsByStatus.bind(this)
            this.GetFormSubmissionsBySubject = this.GetFormSubmissionsBySubject.bind(this)
            this.GetFormSubmissionsByTimestamp = this.GetFormSubmissionsByTimestamp.bind(this)
            this.GetFormSubmissionsByUpdatedAt = this.GetFormSubmissionsByUpdatedAt.bind(this)
            this.GetMeetingAttendeeAuditById = this.GetMeetingAttendeeAuditById.bind(this)
            this.GetMeetingAttendeeById = this.GetMeetingAttendeeById.bind(this)
            this.GetMeetingAttendeesByContactId = this.GetMeetingAttendeesByContactId.bind(this)
            this.GetMeetingAttendeesByCreatedAt = this.GetMeetingAttendeesByCreatedAt.bind(this)
            this.GetMeetingAttendeesByCreatedBy = this.GetMeetingAttendeesByCreatedBy.bind(this)
            this.GetMeetingAttendeesByIsDeleted = this.GetMeetingAttendeesByIsDeleted.bind(this)
            this.GetMeetingAttendeesByMeetingId = this.GetMeetingAttendeesByMeetingId.bind(this)
            this.GetMeetingAttendeesByUpdatedAt = this.GetMeetingAttendeesByUpdatedAt.bind(this)
            this.GetMeetingAttendeesByUpdatedBy = this.GetMeetingAttendeesByUpdatedBy.bind(this)
            this.GetMeetingAuditById = this.GetMeetingAuditById.bind(this)
            this.GetMeetingById = this.GetMeetingById.bind(this)
            this.GetMeetingCompaniesByCompanyId = this.GetMeetingCompaniesByCompanyId.bind(this)
            this.GetMeetingCompaniesByCreatedAt = this.GetMeetingCompaniesByCreatedAt.bind(this)
            this.GetMeetingCompaniesByCreatedBy = this.GetMeetingCompaniesByCreatedBy.bind(this)
            this.GetMeetingCompaniesByIsDeleted = this.GetMeetingCompaniesByIsDeleted.bind(this)
            this.GetMeetingCompaniesByMeetingId = this.GetMeetingCompaniesByMeetingId.bind(this)
            this.GetMeetingCompaniesByUpdatedAt = this.GetMeetingCompaniesByUpdatedAt.bind(this)
            this.GetMeetingCompaniesByUpdatedBy = this.GetMeetingCompaniesByUpdatedBy.bind(this)
            this.GetMeetingCompanyAuditById = this.GetMeetingCompanyAuditById.bind(this)
            this.GetMeetingCompanyById = this.GetMeetingCompanyById.bind(this)
            this.GetMeetingTypeAuditById = this.GetMeetingTypeAuditById.bind(this)
            this.GetMeetingTypeById = this.GetMeetingTypeById.bind(this)
            this.GetMeetingTypesByIsDeleted = this.GetMeetingTypesByIsDeleted.bind(this)
            this.GetMeetingTypesByName = this.GetMeetingTypesByName.bind(this)
            this.GetMeetingsByCreatedAt = this.GetMeetingsByCreatedAt.bind(this)
            this.GetMeetingsByCreatedBy = this.GetMeetingsByCreatedBy.bind(this)
            this.GetMeetingsByIsDeleted = this.GetMeetingsByIsDeleted.bind(this)
            this.GetMeetingsByMeetingDate = this.GetMeetingsByMeetingDate.bind(this)
            this.GetMeetingsByMeetingNoteUrl = this.GetMeetingsByMeetingNoteUrl.bind(this)
            this.GetMeetingsByName = this.GetMeetingsByName.bind(this)
            this.GetMeetingsByOrganizationLocationId = this.GetMeetingsByOrganizationLocationId.bind(this)
            this.GetMeetingsByTypeId = this.GetMeetingsByTypeId.bind(this)
            this.GetMeetingsByUpdatedAt = this.GetMeetingsByUpdatedAt.bind(this)
            this.GetMeetingsByUpdatedBy = this.GetMeetingsByUpdatedBy.bind(this)
            this.GetMeetingsByVirtual = this.GetMeetingsByVirtual.bind(this)
            this.GetNewsletterSignupAuditById = this.GetNewsletterSignupAuditById.bind(this)
            this.GetNewsletterSignupById = this.GetNewsletterSignupById.bind(this)
            this.GetNewsletterSignupsByCreatedAt = this.GetNewsletterSignupsByCreatedAt.bind(this)
            this.GetNewsletterSignupsByEmail = this.GetNewsletterSignupsByEmail.bind(this)
            this.GetNewsletterSignupsByIsDeleted = this.GetNewsletterSignupsByIsDeleted.bind(this)
            this.GetNewsletterSignupsByTimestamp = this.GetNewsletterSignupsByTimestamp.bind(this)
            this.GetNewsletterSignupsByUpdatedAt = this.GetNewsletterSignupsByUpdatedAt.bind(this)
            this.GetOnCallRoleAuditById = this.GetOnCallRoleAuditById.bind(this)
            this.GetOnCallRoleById = this.GetOnCallRoleById.bind(this)
            this.GetOnCallRolesByCreatedAt = this.GetOnCallRolesByCreatedAt.bind(this)
            this.GetOnCallRolesByCreatedBy = this.GetOnCallRolesByCreatedBy.bind(this)
            this.GetOnCallRolesByIsDeleted = this.GetOnCallRolesByIsDeleted.bind(this)
            this.GetOnCallRolesByMoreInfoUrl = this.GetOnCallRolesByMoreInfoUrl.bind(this)
            this.GetOnCallRolesByName = this.GetOnCallRolesByName.bind(this)
            this.GetOnCallRolesByRoleCode = this.GetOnCallRolesByRoleCode.bind(this)
            this.GetOnCallRolesByUpdatedAt = this.GetOnCallRolesByUpdatedAt.bind(this)
            this.GetOnCallRolesByUpdatedBy = this.GetOnCallRolesByUpdatedBy.bind(this)
            this.GetOnCallScheduleAuditById = this.GetOnCallScheduleAuditById.bind(this)
            this.GetOnCallScheduleById = this.GetOnCallScheduleById.bind(this)
            this.GetOnCallSchedulesByContactId = this.GetOnCallSchedulesByContactId.bind(this)
            this.GetOnCallSchedulesByCreatedAt = this.GetOnCallSchedulesByCreatedAt.bind(this)
            this.GetOnCallSchedulesByCreatedBy = this.GetOnCallSchedulesByCreatedBy.bind(this)
            this.GetOnCallSchedulesByDurationHours = this.GetOnCallSchedulesByDurationHours.bind(this)
            this.GetOnCallSchedulesByIsDeleted = this.GetOnCallSchedulesByIsDeleted.bind(this)
            this.GetOnCallSchedulesByRoleId = this.GetOnCallSchedulesByRoleId.bind(this)
            this.GetOnCallSchedulesByStartDate = this.GetOnCallSchedulesByStartDate.bind(this)
            this.GetOnCallSchedulesByUpdatedAt = this.GetOnCallSchedulesByUpdatedAt.bind(this)
            this.GetOnCallSchedulesByUpdatedBy = this.GetOnCallSchedulesByUpdatedBy.bind(this)
            this.GetOpenPRsStatistics = this.GetOpenPRsStatistics.bind(this)
            this.GetOpportunitiesByCompanyId = this.GetOpportunitiesByCompanyId.bind(this)
            this.GetOpportunitiesByCreatedAt = this.GetOpportunitiesByCreatedAt.bind(this)
            this.GetOpportunitiesByCreatedBy = this.GetOpportunitiesByCreatedBy.bind(this)
            this.GetOpportunitiesByEstimatedClose = this.GetOpportunitiesByEstimatedClose.bind(this)
            this.GetOpportunitiesByEstimatedMrr = this.GetOpportunitiesByEstimatedMrr.bind(this)
            this.GetOpportunitiesByFunnelStepId = this.GetOpportunitiesByFunnelStepId.bind(this)
            this.GetOpportunitiesByIsDeleted = this.GetOpportunitiesByIsDeleted.bind(this)
            this.GetOpportunitiesByName = this.GetOpportunitiesByName.bind(this)
            this.GetOpportunitiesByOpportunityTypeId = this.GetOpportunitiesByOpportunityTypeId.bind(this)
            this.GetOpportunitiesByProbabilityPercentage = this.GetOpportunitiesByProbabilityPercentage.bind(this)
            this.GetOpportunitiesByUpdatedAt = this.GetOpportunitiesByUpdatedAt.bind(this)
            this.GetOpportunitiesByUpdatedBy = this.GetOpportunitiesByUpdatedBy.bind(this)
            this.GetOpportunityAuditById = this.GetOpportunityAuditById.bind(this)
            this.GetOpportunityById = this.GetOpportunityById.bind(this)
            this.GetOpportunityFunnelAuditById = this.GetOpportunityFunnelAuditById.bind(this)
            this.GetOpportunityFunnelById = this.GetOpportunityFunnelById.bind(this)
            this.GetOpportunityFunnelStepAuditById = this.GetOpportunityFunnelStepAuditById.bind(this)
            this.GetOpportunityFunnelStepById = this.GetOpportunityFunnelStepById.bind(this)
            this.GetOpportunityFunnelStepsByCreatedAt = this.GetOpportunityFunnelStepsByCreatedAt.bind(this)
            this.GetOpportunityFunnelStepsByCreatedBy = this.GetOpportunityFunnelStepsByCreatedBy.bind(this)
            this.GetOpportunityFunnelStepsByIsDeleted = this.GetOpportunityFunnelStepsByIsDeleted.bind(this)
            this.GetOpportunityFunnelStepsByName = this.GetOpportunityFunnelStepsByName.bind(this)
            this.GetOpportunityFunnelStepsByOpportunityFunnelId = this.GetOpportunityFunnelStepsByOpportunityFunnelId.bind(this)
            this.GetOpportunityFunnelStepsBySequence = this.GetOpportunityFunnelStepsBySequence.bind(this)
            this.GetOpportunityFunnelStepsByUpdatedAt = this.GetOpportunityFunnelStepsByUpdatedAt.bind(this)
            this.GetOpportunityFunnelStepsByUpdatedBy = this.GetOpportunityFunnelStepsByUpdatedBy.bind(this)
            this.GetOpportunityFunnelsByCreatedAt = this.GetOpportunityFunnelsByCreatedAt.bind(this)
            this.GetOpportunityFunnelsByCreatedBy = this.GetOpportunityFunnelsByCreatedBy.bind(this)
            this.GetOpportunityFunnelsByIsDeleted = this.GetOpportunityFunnelsByIsDeleted.bind(this)
            this.GetOpportunityFunnelsByName = this.GetOpportunityFunnelsByName.bind(this)
            this.GetOpportunityFunnelsByOpportunityTypeId = this.GetOpportunityFunnelsByOpportunityTypeId.bind(this)
            this.GetOpportunityFunnelsBySequence = this.GetOpportunityFunnelsBySequence.bind(this)
            this.GetOpportunityFunnelsByUpdatedAt = this.GetOpportunityFunnelsByUpdatedAt.bind(this)
            this.GetOpportunityFunnelsByUpdatedBy = this.GetOpportunityFunnelsByUpdatedBy.bind(this)
            this.GetOpportunityProductAuditById = this.GetOpportunityProductAuditById.bind(this)
            this.GetOpportunityProductById = this.GetOpportunityProductById.bind(this)
            this.GetOpportunityProductsByCreatedAt = this.GetOpportunityProductsByCreatedAt.bind(this)
            this.GetOpportunityProductsByCreatedBy = this.GetOpportunityProductsByCreatedBy.bind(this)
            this.GetOpportunityProductsByIsDeleted = this.GetOpportunityProductsByIsDeleted.bind(this)
            this.GetOpportunityProductsByNote = this.GetOpportunityProductsByNote.bind(this)
            this.GetOpportunityProductsByOpportunityId = this.GetOpportunityProductsByOpportunityId.bind(this)
            this.GetOpportunityProductsByProductId = this.GetOpportunityProductsByProductId.bind(this)
            this.GetOpportunityProductsByUpdatedAt = this.GetOpportunityProductsByUpdatedAt.bind(this)
            this.GetOpportunityProductsByUpdatedBy = this.GetOpportunityProductsByUpdatedBy.bind(this)
            this.GetOpportunityTypeAuditById = this.GetOpportunityTypeAuditById.bind(this)
            this.GetOpportunityTypeById = this.GetOpportunityTypeById.bind(this)
            this.GetOpportunityTypesByCreatedAt = this.GetOpportunityTypesByCreatedAt.bind(this)
            this.GetOpportunityTypesByCreatedBy = this.GetOpportunityTypesByCreatedBy.bind(this)
            this.GetOpportunityTypesByIsDeleted = this.GetOpportunityTypesByIsDeleted.bind(this)
            this.GetOpportunityTypesByName = this.GetOpportunityTypesByName.bind(this)
            this.GetOpportunityTypesByUpdatedAt = this.GetOpportunityTypesByUpdatedAt.bind(this)
            this.GetOpportunityTypesByUpdatedBy = this.GetOpportunityTypesByUpdatedBy.bind(this)
            this.GetOrganizationDocumentAuditById = this.GetOrganizationDocumentAuditById.bind(this)
            this.GetOrganizationDocumentById = this.GetOrganizationDocumentById.bind(this)
            this.GetOrganizationDocumentsByCreatedAt = this.GetOrganizationDocumentsByCreatedAt.bind(this)
            this.GetOrganizationDocumentsByDocumentId = this.GetOrganizationDocumentsByDocumentId.bind(this)
            this.GetOrganizationDocumentsByIsDeleted = this.GetOrganizationDocumentsByIsDeleted.bind(this)
            this.GetOrganizationDocumentsByOrganizationId = this.GetOrganizationDocumentsByOrganizationId.bind(this)
            this.GetOrganizationDocumentsByUpdatedAt = this.GetOrganizationDocumentsByUpdatedAt.bind(this)
            this.GetProductAuditById = this.GetProductAuditById.bind(this)
            this.GetProductById = this.GetProductById.bind(this)
            this.GetProductCategoriesByCreatedAt = this.GetProductCategoriesByCreatedAt.bind(this)
            this.GetProductCategoriesByCreatedBy = this.GetProductCategoriesByCreatedBy.bind(this)
            this.GetProductCategoriesByIsDeleted = this.GetProductCategoriesByIsDeleted.bind(this)
            this.GetProductCategoriesByName = this.GetProductCategoriesByName.bind(this)
            this.GetProductCategoriesByUpdatedAt = this.GetProductCategoriesByUpdatedAt.bind(this)
            this.GetProductCategoriesByUpdatedBy = this.GetProductCategoriesByUpdatedBy.bind(this)
            this.GetProductCategoryAuditById = this.GetProductCategoryAuditById.bind(this)
            this.GetProductCategoryById = this.GetProductCategoryById.bind(this)
            this.GetProductDocumentAuditById = this.GetProductDocumentAuditById.bind(this)
            this.GetProductDocumentById = this.GetProductDocumentById.bind(this)
            this.GetProductDocumentsByCreatedAt = this.GetProductDocumentsByCreatedAt.bind(this)
            this.GetProductDocumentsByCreatedBy = this.GetProductDocumentsByCreatedBy.bind(this)
            this.GetProductDocumentsByDocumentId = this.GetProductDocumentsByDocumentId.bind(this)
            this.GetProductDocumentsByIsDeleted = this.GetProductDocumentsByIsDeleted.bind(this)
            this.GetProductDocumentsByProductId = this.GetProductDocumentsByProductId.bind(this)
            this.GetProductDocumentsByUpdatedAt = this.GetProductDocumentsByUpdatedAt.bind(this)
            this.GetProductDocumentsByUpdatedBy = this.GetProductDocumentsByUpdatedBy.bind(this)
            this.GetProductSubcategoriesByCreatedAt = this.GetProductSubcategoriesByCreatedAt.bind(this)
            this.GetProductSubcategoriesByCreatedBy = this.GetProductSubcategoriesByCreatedBy.bind(this)
            this.GetProductSubcategoriesByIsDeleted = this.GetProductSubcategoriesByIsDeleted.bind(this)
            this.GetProductSubcategoriesByName = this.GetProductSubcategoriesByName.bind(this)
            this.GetProductSubcategoriesByParentCategoryId = this.GetProductSubcategoriesByParentCategoryId.bind(this)
            this.GetProductSubcategoriesByUpdatedAt = this.GetProductSubcategoriesByUpdatedAt.bind(this)
            this.GetProductSubcategoriesByUpdatedBy = this.GetProductSubcategoriesByUpdatedBy.bind(this)
            this.GetProductSubcategoryAuditById = this.GetProductSubcategoryAuditById.bind(this)
            this.GetProductSubcategoryById = this.GetProductSubcategoryById.bind(this)
            this.GetProductUserAuditById = this.GetProductUserAuditById.bind(this)
            this.GetProductUserById = this.GetProductUserById.bind(this)
            this.GetProductUsersByActive = this.GetProductUsersByActive.bind(this)
            this.GetProductUsersByCreatedAt = this.GetProductUsersByCreatedAt.bind(this)
            this.GetProductUsersByCreatedBy = this.GetProductUsersByCreatedBy.bind(this)
            this.GetProductUsersByEndDate = this.GetProductUsersByEndDate.bind(this)
            this.GetProductUsersByIsDeleted = this.GetProductUsersByIsDeleted.bind(this)
            this.GetProductUsersByProductId = this.GetProductUsersByProductId.bind(this)
            this.GetProductUsersByStartDate = this.GetProductUsersByStartDate.bind(this)
            this.GetProductUsersByUpdatedAt = this.GetProductUsersByUpdatedAt.bind(this)
            this.GetProductUsersByUpdatedBy = this.GetProductUsersByUpdatedBy.bind(this)
            this.GetProductUsersByUserCompanyId = this.GetProductUsersByUserCompanyId.bind(this)
            this.GetProductsByCreatedAt = this.GetProductsByCreatedAt.bind(this)
            this.GetProductsByCreatedBy = this.GetProductsByCreatedBy.bind(this)
            this.GetProductsByIsDeleted = this.GetProductsByIsDeleted.bind(this)
            this.GetProductsByName = this.GetProductsByName.bind(this)
            this.GetProductsByProductCategoryId = this.GetProductsByProductCategoryId.bind(this)
            this.GetProductsByProductInformationUrl = this.GetProductsByProductInformationUrl.bind(this)
            this.GetProductsByProductSubcategoryId = this.GetProductsByProductSubcategoryId.bind(this)
            this.GetProductsByProviderCompanyId = this.GetProductsByProviderCompanyId.bind(this)
            this.GetProductsByUpdatedAt = this.GetProductsByUpdatedAt.bind(this)
            this.GetProductsByUpdatedBy = this.GetProductsByUpdatedBy.bind(this)
            this.GetReachedFunnelStepPerDay = this.GetReachedFunnelStepPerDay.bind(this)
            this.GetSkrymCompanyRoleAreaAuditById = this.GetSkrymCompanyRoleAreaAuditById.bind(this)
            this.GetSkrymCompanyRoleAreaById = this.GetSkrymCompanyRoleAreaById.bind(this)
            this.GetSkrymCompanyRoleAreasByCreatedAt = this.GetSkrymCompanyRoleAreasByCreatedAt.bind(this)
            this.GetSkrymCompanyRoleAreasByCreatedBy = this.GetSkrymCompanyRoleAreasByCreatedBy.bind(this)
            this.GetSkrymCompanyRoleAreasByIsDeleted = this.GetSkrymCompanyRoleAreasByIsDeleted.bind(this)
            this.GetSkrymCompanyRoleAreasByName = this.GetSkrymCompanyRoleAreasByName.bind(this)
            this.GetSkrymCompanyRoleAreasByUpdatedAt = this.GetSkrymCompanyRoleAreasByUpdatedAt.bind(this)
            this.GetSkrymCompanyRoleAreasByUpdatedBy = this.GetSkrymCompanyRoleAreasByUpdatedBy.bind(this)
            this.GetSkrymCompanyRoleAuditById = this.GetSkrymCompanyRoleAuditById.bind(this)
            this.GetSkrymCompanyRoleById = this.GetSkrymCompanyRoleById.bind(this)
            this.GetSkrymCompanyRolesByAreaId = this.GetSkrymCompanyRolesByAreaId.bind(this)
            this.GetSkrymCompanyRolesByCreatedAt = this.GetSkrymCompanyRolesByCreatedAt.bind(this)
            this.GetSkrymCompanyRolesByCreatedBy = this.GetSkrymCompanyRolesByCreatedBy.bind(this)
            this.GetSkrymCompanyRolesByIsDeleted = this.GetSkrymCompanyRolesByIsDeleted.bind(this)
            this.GetSkrymCompanyRolesByName = this.GetSkrymCompanyRolesByName.bind(this)
            this.GetSkrymCompanyRolesByUpdatedAt = this.GetSkrymCompanyRolesByUpdatedAt.bind(this)
            this.GetSkrymCompanyRolesByUpdatedBy = this.GetSkrymCompanyRolesByUpdatedBy.bind(this)
            this.GetSkrymContactRoleAuditById = this.GetSkrymContactRoleAuditById.bind(this)
            this.GetSkrymContactRoleById = this.GetSkrymContactRoleById.bind(this)
            this.GetSkrymContactRolesByActive = this.GetSkrymContactRolesByActive.bind(this)
            this.GetSkrymContactRolesByCompanyId = this.GetSkrymContactRolesByCompanyId.bind(this)
            this.GetSkrymContactRolesByCompanyRoleId = this.GetSkrymContactRolesByCompanyRoleId.bind(this)
            this.GetSkrymContactRolesByContactId = this.GetSkrymContactRolesByContactId.bind(this)
            this.GetSkrymContactRolesByCreatedAt = this.GetSkrymContactRolesByCreatedAt.bind(this)
            this.GetSkrymContactRolesByCreatedBy = this.GetSkrymContactRolesByCreatedBy.bind(this)
            this.GetSkrymContactRolesByIsDeleted = this.GetSkrymContactRolesByIsDeleted.bind(this)
            this.GetSkrymContactRolesByUpdatedAt = this.GetSkrymContactRolesByUpdatedAt.bind(this)
            this.GetSkrymContactRolesByUpdatedBy = this.GetSkrymContactRolesByUpdatedBy.bind(this)
            this.GetSprintAuditById = this.GetSprintAuditById.bind(this)
            this.GetSprintById = this.GetSprintById.bind(this)
            this.GetSprintDailyStandupAuditById = this.GetSprintDailyStandupAuditById.bind(this)
            this.GetSprintDailyStandupById = this.GetSprintDailyStandupById.bind(this)
            this.GetSprintDailyStandupEntriesByCreatedAt = this.GetSprintDailyStandupEntriesByCreatedAt.bind(this)
            this.GetSprintDailyStandupEntriesByCreatedBy = this.GetSprintDailyStandupEntriesByCreatedBy.bind(this)
            this.GetSprintDailyStandupEntriesByIsDeleted = this.GetSprintDailyStandupEntriesByIsDeleted.bind(this)
            this.GetSprintDailyStandupEntriesByPresent = this.GetSprintDailyStandupEntriesByPresent.bind(this)
            this.GetSprintDailyStandupEntriesByStandupId = this.GetSprintDailyStandupEntriesByStandupId.bind(this)
            this.GetSprintDailyStandupEntriesByTeamMemberAvailability = this.GetSprintDailyStandupEntriesByTeamMemberAvailability.bind(this)
            this.GetSprintDailyStandupEntriesByTeamMemberId = this.GetSprintDailyStandupEntriesByTeamMemberId.bind(this)
            this.GetSprintDailyStandupEntriesByTeamMemberNote = this.GetSprintDailyStandupEntriesByTeamMemberNote.bind(this)
            this.GetSprintDailyStandupEntriesByTeamMemberWorkingOn = this.GetSprintDailyStandupEntriesByTeamMemberWorkingOn.bind(this)
            this.GetSprintDailyStandupEntriesByUpdatedAt = this.GetSprintDailyStandupEntriesByUpdatedAt.bind(this)
            this.GetSprintDailyStandupEntriesByUpdatedBy = this.GetSprintDailyStandupEntriesByUpdatedBy.bind(this)
            this.GetSprintDailyStandupEntryAuditById = this.GetSprintDailyStandupEntryAuditById.bind(this)
            this.GetSprintDailyStandupEntryById = this.GetSprintDailyStandupEntryById.bind(this)
            this.GetSprintDailyStandupsByCreatedAt = this.GetSprintDailyStandupsByCreatedAt.bind(this)
            this.GetSprintDailyStandupsByCreatedBy = this.GetSprintDailyStandupsByCreatedBy.bind(this)
            this.GetSprintDailyStandupsByHostedBy = this.GetSprintDailyStandupsByHostedBy.bind(this)
            this.GetSprintDailyStandupsByIsDeleted = this.GetSprintDailyStandupsByIsDeleted.bind(this)
            this.GetSprintDailyStandupsByMostImportant = this.GetSprintDailyStandupsByMostImportant.bind(this)
            this.GetSprintDailyStandupsBySprintDay = this.GetSprintDailyStandupsBySprintDay.bind(this)
            this.GetSprintDailyStandupsBySprintId = this.GetSprintDailyStandupsBySprintId.bind(this)
            this.GetSprintDailyStandupsByUpdatedAt = this.GetSprintDailyStandupsByUpdatedAt.bind(this)
            this.GetSprintDailyStandupsByUpdatedBy = this.GetSprintDailyStandupsByUpdatedBy.bind(this)
            this.GetSprintMessageAuditById = this.GetSprintMessageAuditById.bind(this)
            this.GetSprintMessageById = this.GetSprintMessageById.bind(this)
            this.GetSprintMessageTypeAuditById = this.GetSprintMessageTypeAuditById.bind(this)
            this.GetSprintMessageTypeById = this.GetSprintMessageTypeById.bind(this)
            this.GetSprintMessageTypesByColor = this.GetSprintMessageTypesByColor.bind(this)
            this.GetSprintMessageTypesByCreatedAt = this.GetSprintMessageTypesByCreatedAt.bind(this)
            this.GetSprintMessageTypesByCreatedBy = this.GetSprintMessageTypesByCreatedBy.bind(this)
            this.GetSprintMessageTypesByIsDeleted = this.GetSprintMessageTypesByIsDeleted.bind(this)
            this.GetSprintMessageTypesByName = this.GetSprintMessageTypesByName.bind(this)
            this.GetSprintMessageTypesByUpdatedAt = this.GetSprintMessageTypesByUpdatedAt.bind(this)
            this.GetSprintMessageTypesByUpdatedBy = this.GetSprintMessageTypesByUpdatedBy.bind(this)
            this.GetSprintMessagesByCreatedAt = this.GetSprintMessagesByCreatedAt.bind(this)
            this.GetSprintMessagesByCreatedBy = this.GetSprintMessagesByCreatedBy.bind(this)
            this.GetSprintMessagesByIsDeleted = this.GetSprintMessagesByIsDeleted.bind(this)
            this.GetSprintMessagesByMessage = this.GetSprintMessagesByMessage.bind(this)
            this.GetSprintMessagesByMessageTypeId = this.GetSprintMessagesByMessageTypeId.bind(this)
            this.GetSprintMessagesBySprintId = this.GetSprintMessagesBySprintId.bind(this)
            this.GetSprintMessagesByTitle = this.GetSprintMessagesByTitle.bind(this)
            this.GetSprintMessagesByUpdatedAt = this.GetSprintMessagesByUpdatedAt.bind(this)
            this.GetSprintMessagesByUpdatedBy = this.GetSprintMessagesByUpdatedBy.bind(this)
            this.GetSprintRoleAuditById = this.GetSprintRoleAuditById.bind(this)
            this.GetSprintRoleById = this.GetSprintRoleById.bind(this)
            this.GetSprintRoleEntriesByContactId = this.GetSprintRoleEntriesByContactId.bind(this)
            this.GetSprintRoleEntriesByCreatedAt = this.GetSprintRoleEntriesByCreatedAt.bind(this)
            this.GetSprintRoleEntriesByCreatedBy = this.GetSprintRoleEntriesByCreatedBy.bind(this)
            this.GetSprintRoleEntriesByIsDeleted = this.GetSprintRoleEntriesByIsDeleted.bind(this)
            this.GetSprintRoleEntriesBySprintId = this.GetSprintRoleEntriesBySprintId.bind(this)
            this.GetSprintRoleEntriesBySprintRoleId = this.GetSprintRoleEntriesBySprintRoleId.bind(this)
            this.GetSprintRoleEntriesByUpdatedAt = this.GetSprintRoleEntriesByUpdatedAt.bind(this)
            this.GetSprintRoleEntriesByUpdatedBy = this.GetSprintRoleEntriesByUpdatedBy.bind(this)
            this.GetSprintRoleEntryAuditById = this.GetSprintRoleEntryAuditById.bind(this)
            this.GetSprintRoleEntryById = this.GetSprintRoleEntryById.bind(this)
            this.GetSprintRolesByCreatedAt = this.GetSprintRolesByCreatedAt.bind(this)
            this.GetSprintRolesByCreatedBy = this.GetSprintRolesByCreatedBy.bind(this)
            this.GetSprintRolesByIsDeleted = this.GetSprintRolesByIsDeleted.bind(this)
            this.GetSprintRolesByName = this.GetSprintRolesByName.bind(this)
            this.GetSprintRolesByUpdatedAt = this.GetSprintRolesByUpdatedAt.bind(this)
            this.GetSprintRolesByUpdatedBy = this.GetSprintRolesByUpdatedBy.bind(this)
            this.GetSprintsByCreatedAt = this.GetSprintsByCreatedAt.bind(this)
            this.GetSprintsByCreatedBy = this.GetSprintsByCreatedBy.bind(this)
            this.GetSprintsByIsDeleted = this.GetSprintsByIsDeleted.bind(this)
            this.GetSprintsBySprintNumber = this.GetSprintsBySprintNumber.bind(this)
            this.GetSprintsByStartDate = this.GetSprintsByStartDate.bind(this)
            this.GetSprintsByUpdatedAt = this.GetSprintsByUpdatedAt.bind(this)
            this.GetSprintsByUpdatedBy = this.GetSprintsByUpdatedBy.bind(this)
            this.GetTaskAuditById = this.GetTaskAuditById.bind(this)
            this.GetTaskById = this.GetTaskById.bind(this)
            this.GetTaskOwnerAuditById = this.GetTaskOwnerAuditById.bind(this)
            this.GetTaskOwnerById = this.GetTaskOwnerById.bind(this)
            this.GetTaskOwnersByContactId = this.GetTaskOwnersByContactId.bind(this)
            this.GetTaskOwnersByCreatedAt = this.GetTaskOwnersByCreatedAt.bind(this)
            this.GetTaskOwnersByCreatedBy = this.GetTaskOwnersByCreatedBy.bind(this)
            this.GetTaskOwnersByIsDeleted = this.GetTaskOwnersByIsDeleted.bind(this)
            this.GetTaskOwnersByNote = this.GetTaskOwnersByNote.bind(this)
            this.GetTaskOwnersByTaskId = this.GetTaskOwnersByTaskId.bind(this)
            this.GetTaskOwnersByUpdatedAt = this.GetTaskOwnersByUpdatedAt.bind(this)
            this.GetTaskOwnersByUpdatedBy = this.GetTaskOwnersByUpdatedBy.bind(this)
            this.GetTaskStatusAuditById = this.GetTaskStatusAuditById.bind(this)
            this.GetTaskStatusById = this.GetTaskStatusById.bind(this)
            this.GetTaskStatusesByCode = this.GetTaskStatusesByCode.bind(this)
            this.GetTaskStatusesByCreatedAt = this.GetTaskStatusesByCreatedAt.bind(this)
            this.GetTaskStatusesByCreatedBy = this.GetTaskStatusesByCreatedBy.bind(this)
            this.GetTaskStatusesByIsDeleted = this.GetTaskStatusesByIsDeleted.bind(this)
            this.GetTaskStatusesByName = this.GetTaskStatusesByName.bind(this)
            this.GetTaskStatusesByUpdatedAt = this.GetTaskStatusesByUpdatedAt.bind(this)
            this.GetTaskStatusesByUpdatedBy = this.GetTaskStatusesByUpdatedBy.bind(this)
            this.GetTasksByCompanyId = this.GetTasksByCompanyId.bind(this)
            this.GetTasksByCreatedAt = this.GetTasksByCreatedAt.bind(this)
            this.GetTasksByCreatedBy = this.GetTasksByCreatedBy.bind(this)
            this.GetTasksByDeadline = this.GetTasksByDeadline.bind(this)
            this.GetTasksByIsDeleted = this.GetTasksByIsDeleted.bind(this)
            this.GetTasksByIsPriority = this.GetTasksByIsPriority.bind(this)
            this.GetTasksByIsPrivate = this.GetTasksByIsPrivate.bind(this)
            this.GetTasksByName = this.GetTasksByName.bind(this)
            this.GetTasksBySize = this.GetTasksBySize.bind(this)
            this.GetTasksByStatusId = this.GetTasksByStatusId.bind(this)
            this.GetTasksByUpdatedAt = this.GetTasksByUpdatedAt.bind(this)
            this.GetTasksByUpdatedBy = this.GetTasksByUpdatedBy.bind(this)
            this.GetWorkingTimeAuditById = this.GetWorkingTimeAuditById.bind(this)
            this.GetWorkingTimeById = this.GetWorkingTimeById.bind(this)
            this.GetWorkingTimeLocationAuditById = this.GetWorkingTimeLocationAuditById.bind(this)
            this.GetWorkingTimeLocationById = this.GetWorkingTimeLocationById.bind(this)
            this.GetWorkingTimeLocationsByCompanyId = this.GetWorkingTimeLocationsByCompanyId.bind(this)
            this.GetWorkingTimeLocationsByCreatedAt = this.GetWorkingTimeLocationsByCreatedAt.bind(this)
            this.GetWorkingTimeLocationsByCreatedBy = this.GetWorkingTimeLocationsByCreatedBy.bind(this)
            this.GetWorkingTimeLocationsByIsDeleted = this.GetWorkingTimeLocationsByIsDeleted.bind(this)
            this.GetWorkingTimeLocationsByName = this.GetWorkingTimeLocationsByName.bind(this)
            this.GetWorkingTimeLocationsByUpdatedAt = this.GetWorkingTimeLocationsByUpdatedAt.bind(this)
            this.GetWorkingTimeLocationsByUpdatedBy = this.GetWorkingTimeLocationsByUpdatedBy.bind(this)
            this.GetWorkingTimeTypeAuditById = this.GetWorkingTimeTypeAuditById.bind(this)
            this.GetWorkingTimeTypeById = this.GetWorkingTimeTypeById.bind(this)
            this.GetWorkingTimeTypesByCompanyId = this.GetWorkingTimeTypesByCompanyId.bind(this)
            this.GetWorkingTimeTypesByCreatedAt = this.GetWorkingTimeTypesByCreatedAt.bind(this)
            this.GetWorkingTimeTypesByCreatedBy = this.GetWorkingTimeTypesByCreatedBy.bind(this)
            this.GetWorkingTimeTypesByIsDeleted = this.GetWorkingTimeTypesByIsDeleted.bind(this)
            this.GetWorkingTimeTypesByIsParentalLeave = this.GetWorkingTimeTypesByIsParentalLeave.bind(this)
            this.GetWorkingTimeTypesByIsPublicHoliday = this.GetWorkingTimeTypesByIsPublicHoliday.bind(this)
            this.GetWorkingTimeTypesByIsVacation = this.GetWorkingTimeTypesByIsVacation.bind(this)
            this.GetWorkingTimeTypesByIsWork = this.GetWorkingTimeTypesByIsWork.bind(this)
            this.GetWorkingTimeTypesByName = this.GetWorkingTimeTypesByName.bind(this)
            this.GetWorkingTimeTypesByUpdatedAt = this.GetWorkingTimeTypesByUpdatedAt.bind(this)
            this.GetWorkingTimeTypesByUpdatedBy = this.GetWorkingTimeTypesByUpdatedBy.bind(this)
            this.GetWorkingTimesByContactRoleId = this.GetWorkingTimesByContactRoleId.bind(this)
            this.GetWorkingTimesByCreatedAt = this.GetWorkingTimesByCreatedAt.bind(this)
            this.GetWorkingTimesByCreatedBy = this.GetWorkingTimesByCreatedBy.bind(this)
            this.GetWorkingTimesByDay = this.GetWorkingTimesByDay.bind(this)
            this.GetWorkingTimesByDurationHours = this.GetWorkingTimesByDurationHours.bind(this)
            this.GetWorkingTimesByIsDeleted = this.GetWorkingTimesByIsDeleted.bind(this)
            this.GetWorkingTimesByLocation = this.GetWorkingTimesByLocation.bind(this)
            this.GetWorkingTimesByType = this.GetWorkingTimesByType.bind(this)
            this.GetWorkingTimesByUpdatedAt = this.GetWorkingTimesByUpdatedAt.bind(this)
            this.GetWorkingTimesByUpdatedBy = this.GetWorkingTimesByUpdatedBy.bind(this)
            this.InsertCallSheet = this.InsertCallSheet.bind(this)
            this.InsertChannel = this.InsertChannel.bind(this)
            this.InsertCompany = this.InsertCompany.bind(this)
            this.InsertCompanyBillingInfo = this.InsertCompanyBillingInfo.bind(this)
            this.InsertCompanyInvoice = this.InsertCompanyInvoice.bind(this)
            this.InsertCompanyNote = this.InsertCompanyNote.bind(this)
            this.InsertCompanyProductArea = this.InsertCompanyProductArea.bind(this)
            this.InsertCompanyProductAreaEntry = this.InsertCompanyProductAreaEntry.bind(this)
            this.InsertCompanySegment = this.InsertCompanySegment.bind(this)
            this.InsertCompanySegmentEntry = this.InsertCompanySegmentEntry.bind(this)
            this.InsertCompanyType = this.InsertCompanyType.bind(this)
            this.InsertConnection = this.InsertConnection.bind(this)
            this.InsertContact = this.InsertContact.bind(this)
            this.InsertContactDetail = this.InsertContactDetail.bind(this)
            this.InsertContactDetailType = this.InsertContactDetailType.bind(this)
            this.InsertContactDocument = this.InsertContactDocument.bind(this)
            this.InsertContactNote = this.InsertContactNote.bind(this)
            this.InsertContactRole = this.InsertContactRole.bind(this)
            this.InsertDocument = this.InsertDocument.bind(this)
            this.InsertDocumentType = this.InsertDocumentType.bind(this)
            this.InsertEmployment = this.InsertEmployment.bind(this)
            this.InsertEvent = this.InsertEvent.bind(this)
            this.InsertEventAttendee = this.InsertEventAttendee.bind(this)
            this.InsertEventType = this.InsertEventType.bind(this)
            this.InsertFormSubmission = this.InsertFormSubmission.bind(this)
            this.InsertMeeting = this.InsertMeeting.bind(this)
            this.InsertMeetingAttendee = this.InsertMeetingAttendee.bind(this)
            this.InsertMeetingCompany = this.InsertMeetingCompany.bind(this)
            this.InsertMeetingType = this.InsertMeetingType.bind(this)
            this.InsertNewsletterSignup = this.InsertNewsletterSignup.bind(this)
            this.InsertOnCallRole = this.InsertOnCallRole.bind(this)
            this.InsertOnCallSchedule = this.InsertOnCallSchedule.bind(this)
            this.InsertOpportunity = this.InsertOpportunity.bind(this)
            this.InsertOpportunityFunnel = this.InsertOpportunityFunnel.bind(this)
            this.InsertOpportunityFunnelStep = this.InsertOpportunityFunnelStep.bind(this)
            this.InsertOpportunityProduct = this.InsertOpportunityProduct.bind(this)
            this.InsertOpportunityType = this.InsertOpportunityType.bind(this)
            this.InsertOrganizationDocument = this.InsertOrganizationDocument.bind(this)
            this.InsertProduct = this.InsertProduct.bind(this)
            this.InsertProductCategory = this.InsertProductCategory.bind(this)
            this.InsertProductDocument = this.InsertProductDocument.bind(this)
            this.InsertProductSubcategory = this.InsertProductSubcategory.bind(this)
            this.InsertProductUser = this.InsertProductUser.bind(this)
            this.InsertSkrymCompanyRole = this.InsertSkrymCompanyRole.bind(this)
            this.InsertSkrymCompanyRoleArea = this.InsertSkrymCompanyRoleArea.bind(this)
            this.InsertSkrymContactRole = this.InsertSkrymContactRole.bind(this)
            this.InsertSprint = this.InsertSprint.bind(this)
            this.InsertSprintDailyStandup = this.InsertSprintDailyStandup.bind(this)
            this.InsertSprintDailyStandupEntry = this.InsertSprintDailyStandupEntry.bind(this)
            this.InsertSprintMessage = this.InsertSprintMessage.bind(this)
            this.InsertSprintMessageType = this.InsertSprintMessageType.bind(this)
            this.InsertSprintRole = this.InsertSprintRole.bind(this)
            this.InsertSprintRoleEntry = this.InsertSprintRoleEntry.bind(this)
            this.InsertTask = this.InsertTask.bind(this)
            this.InsertTaskOwner = this.InsertTaskOwner.bind(this)
            this.InsertTaskStatus = this.InsertTaskStatus.bind(this)
            this.InsertWorkingTime = this.InsertWorkingTime.bind(this)
            this.InsertWorkingTimeLocation = this.InsertWorkingTimeLocation.bind(this)
            this.InsertWorkingTimeType = this.InsertWorkingTimeType.bind(this)
            this.SearchCompanies = this.SearchCompanies.bind(this)
            this.SearchContacts = this.SearchContacts.bind(this)
            this.UpsertCallSheet = this.UpsertCallSheet.bind(this)
            this.UpsertChannel = this.UpsertChannel.bind(this)
            this.UpsertCompany = this.UpsertCompany.bind(this)
            this.UpsertCompanyBillingInfo = this.UpsertCompanyBillingInfo.bind(this)
            this.UpsertCompanyInvoice = this.UpsertCompanyInvoice.bind(this)
            this.UpsertCompanyNote = this.UpsertCompanyNote.bind(this)
            this.UpsertCompanyProductArea = this.UpsertCompanyProductArea.bind(this)
            this.UpsertCompanyProductAreaEntry = this.UpsertCompanyProductAreaEntry.bind(this)
            this.UpsertCompanySegment = this.UpsertCompanySegment.bind(this)
            this.UpsertCompanySegmentEntry = this.UpsertCompanySegmentEntry.bind(this)
            this.UpsertCompanyType = this.UpsertCompanyType.bind(this)
            this.UpsertConnection = this.UpsertConnection.bind(this)
            this.UpsertContact = this.UpsertContact.bind(this)
            this.UpsertContactDetail = this.UpsertContactDetail.bind(this)
            this.UpsertContactDetailType = this.UpsertContactDetailType.bind(this)
            this.UpsertContactDocument = this.UpsertContactDocument.bind(this)
            this.UpsertContactNote = this.UpsertContactNote.bind(this)
            this.UpsertContactRole = this.UpsertContactRole.bind(this)
            this.UpsertDocument = this.UpsertDocument.bind(this)
            this.UpsertDocumentType = this.UpsertDocumentType.bind(this)
            this.UpsertEmployment = this.UpsertEmployment.bind(this)
            this.UpsertEvent = this.UpsertEvent.bind(this)
            this.UpsertEventAttendee = this.UpsertEventAttendee.bind(this)
            this.UpsertEventType = this.UpsertEventType.bind(this)
            this.UpsertFormSubmission = this.UpsertFormSubmission.bind(this)
            this.UpsertMeeting = this.UpsertMeeting.bind(this)
            this.UpsertMeetingAttendee = this.UpsertMeetingAttendee.bind(this)
            this.UpsertMeetingCompany = this.UpsertMeetingCompany.bind(this)
            this.UpsertMeetingType = this.UpsertMeetingType.bind(this)
            this.UpsertMeetingWithAttendees = this.UpsertMeetingWithAttendees.bind(this)
            this.UpsertNewsletterSignup = this.UpsertNewsletterSignup.bind(this)
            this.UpsertOnCallRole = this.UpsertOnCallRole.bind(this)
            this.UpsertOnCallSchedule = this.UpsertOnCallSchedule.bind(this)
            this.UpsertOpportunity = this.UpsertOpportunity.bind(this)
            this.UpsertOpportunityFunnel = this.UpsertOpportunityFunnel.bind(this)
            this.UpsertOpportunityFunnelStep = this.UpsertOpportunityFunnelStep.bind(this)
            this.UpsertOpportunityProduct = this.UpsertOpportunityProduct.bind(this)
            this.UpsertOpportunityType = this.UpsertOpportunityType.bind(this)
            this.UpsertOrganizationDocument = this.UpsertOrganizationDocument.bind(this)
            this.UpsertProduct = this.UpsertProduct.bind(this)
            this.UpsertProductCategory = this.UpsertProductCategory.bind(this)
            this.UpsertProductDocument = this.UpsertProductDocument.bind(this)
            this.UpsertProductSubcategory = this.UpsertProductSubcategory.bind(this)
            this.UpsertProductUser = this.UpsertProductUser.bind(this)
            this.UpsertSkrymCompanyRole = this.UpsertSkrymCompanyRole.bind(this)
            this.UpsertSkrymCompanyRoleArea = this.UpsertSkrymCompanyRoleArea.bind(this)
            this.UpsertSkrymContactRole = this.UpsertSkrymContactRole.bind(this)
            this.UpsertSprint = this.UpsertSprint.bind(this)
            this.UpsertSprintDailyStandup = this.UpsertSprintDailyStandup.bind(this)
            this.UpsertSprintDailyStandupEntry = this.UpsertSprintDailyStandupEntry.bind(this)
            this.UpsertSprintMessage = this.UpsertSprintMessage.bind(this)
            this.UpsertSprintMessageType = this.UpsertSprintMessageType.bind(this)
            this.UpsertSprintRole = this.UpsertSprintRole.bind(this)
            this.UpsertSprintRoleEntry = this.UpsertSprintRoleEntry.bind(this)
            this.UpsertTask = this.UpsertTask.bind(this)
            this.UpsertTaskOwner = this.UpsertTaskOwner.bind(this)
            this.UpsertTaskStatus = this.UpsertTaskStatus.bind(this)
            this.UpsertWorkingTime = this.UpsertWorkingTime.bind(this)
            this.UpsertWorkingTimeLocation = this.UpsertWorkingTimeLocation.bind(this)
            this.UpsertWorkingTimeType = this.UpsertWorkingTimeType.bind(this)
        }

        public async CheckLagoHealth(): Promise<CheckLagoHealthResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.CheckLagoHealth`)
            return await resp.json() as CheckLagoHealthResponse
        }

        /**
         * DeleteCallSheet carries out a soft delete for a specified row in the call_sheet table
         * 
         * It will also propagate an insertion to the call_sheet_audit table
         */
        public async DeleteCallSheet(params: DeleteCallSheetRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteCallSheet`, JSON.stringify(params))
        }

        /**
         * DeleteChannel carries out a soft delete for a specified row in the channel table
         * 
         * It will also propagate an insertion to the channel_audit table
         */
        public async DeleteChannel(params: DeleteChannelRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteChannel`, JSON.stringify(params))
        }

        /**
         * DeleteCompany carries out a soft delete for a specified row in the company table
         * 
         * It will also propagate an insertion to the company_audit table
         */
        public async DeleteCompany(params: DeleteCompanyRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteCompany`, JSON.stringify(params))
        }

        /**
         * DeleteCompanyBillingInfo carries out a soft delete for a specified row in the company_billing_info table
         * 
         * It will also propagate an insertion to the company_billing_info_audit table
         */
        public async DeleteCompanyBillingInfo(params: DeleteCompanyBillingInfoRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteCompanyBillingInfo`, JSON.stringify(params))
        }

        /**
         * DeleteCompanyInvoice carries out a soft delete for a specified row in the company_invoice table
         * 
         * It will also propagate an insertion to the company_invoice_audit table
         */
        public async DeleteCompanyInvoice(params: DeleteCompanyInvoiceRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteCompanyInvoice`, JSON.stringify(params))
        }

        /**
         * DeleteCompanyNote carries out a soft delete for a specified row in the company_note table
         * 
         * It will also propagate an insertion to the company_note_audit table
         */
        public async DeleteCompanyNote(params: DeleteCompanyNoteRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteCompanyNote`, JSON.stringify(params))
        }

        /**
         * DeleteCompanyProductArea carries out a soft delete for a specified row in the company_product_area table
         * 
         * It will also propagate an insertion to the company_product_area_audit table
         */
        public async DeleteCompanyProductArea(params: DeleteCompanyProductAreaRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteCompanyProductArea`, JSON.stringify(params))
        }

        /**
         * DeleteCompanyProductAreaEntry carries out a soft delete for a specified row in the company_product_area_entry table
         * 
         * It will also propagate an insertion to the company_product_area_entry_audit table
         */
        public async DeleteCompanyProductAreaEntry(params: DeleteCompanyProductAreaEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteCompanyProductAreaEntry`, JSON.stringify(params))
        }

        /**
         * DeleteCompanySegment carries out a soft delete for a specified row in the company_segment table
         * 
         * It will also propagate an insertion to the company_segment_audit table
         */
        public async DeleteCompanySegment(params: DeleteCompanySegmentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteCompanySegment`, JSON.stringify(params))
        }

        /**
         * DeleteCompanySegmentEntry carries out a soft delete for a specified row in the company_segment_entry table
         * 
         * It will also propagate an insertion to the company_segment_entry_audit table
         */
        public async DeleteCompanySegmentEntry(params: DeleteCompanySegmentEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteCompanySegmentEntry`, JSON.stringify(params))
        }

        /**
         * DeleteCompanyType carries out a soft delete for a specified row in the company_type table
         * 
         * It will also propagate an insertion to the company_type_audit table
         */
        public async DeleteCompanyType(params: DeleteCompanyTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteCompanyType`, JSON.stringify(params))
        }

        /**
         * DeleteConnection carries out a soft delete for a specified row in the connection table
         * 
         * It will also propagate an insertion to the connection_audit table
         */
        public async DeleteConnection(params: DeleteConnectionRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteConnection`, JSON.stringify(params))
        }

        /**
         * DeleteContact carries out a soft delete for a specified row in the contact table
         * 
         * It will also propagate an insertion to the contact_audit table
         */
        public async DeleteContact(params: DeleteContactRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteContact`, JSON.stringify(params))
        }

        /**
         * DeleteContactDetail carries out a soft delete for a specified row in the contact_detail table
         * 
         * It will also propagate an insertion to the contact_detail_audit table
         */
        public async DeleteContactDetail(params: DeleteContactDetailRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteContactDetail`, JSON.stringify(params))
        }

        /**
         * DeleteContactDetailType carries out a soft delete for a specified row in the contact_detail_type table
         * 
         * It will also propagate an insertion to the contact_detail_type_audit table
         */
        public async DeleteContactDetailType(params: DeleteContactDetailTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteContactDetailType`, JSON.stringify(params))
        }

        /**
         * DeleteContactDocument carries out a soft delete for a specified row in the contact_document table
         * 
         * It will also propagate an insertion to the contact_document_audit table
         */
        public async DeleteContactDocument(params: DeleteContactDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteContactDocument`, JSON.stringify(params))
        }

        /**
         * DeleteContactNote carries out a soft delete for a specified row in the contact_note table
         * 
         * It will also propagate an insertion to the contact_note_audit table
         */
        public async DeleteContactNote(params: DeleteContactNoteRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteContactNote`, JSON.stringify(params))
        }

        /**
         * DeleteContactRole carries out a soft delete for a specified row in the contact_role table
         * 
         * It will also propagate an insertion to the contact_role_audit table
         */
        public async DeleteContactRole(params: DeleteContactRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteContactRole`, JSON.stringify(params))
        }

        /**
         * DeleteDocument carries out a soft delete for a specified row in the document table
         * 
         * It will also propagate an insertion to the document_audit table
         */
        public async DeleteDocument(params: DeleteDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteDocument`, JSON.stringify(params))
        }

        /**
         * DeleteDocumentType carries out a soft delete for a specified row in the document_type table
         * 
         * It will also propagate an insertion to the document_type_audit table
         */
        public async DeleteDocumentType(params: DeleteDocumentTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteDocumentType`, JSON.stringify(params))
        }

        /**
         * DeleteEmployment carries out a soft delete for a specified row in the employment table
         * 
         * It will also propagate an insertion to the employment_audit table
         */
        public async DeleteEmployment(params: DeleteEmploymentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteEmployment`, JSON.stringify(params))
        }

        /**
         * DeleteEvent carries out a soft delete for a specified row in the event table
         * 
         * It will also propagate an insertion to the event_audit table
         */
        public async DeleteEvent(params: DeleteEventRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteEvent`, JSON.stringify(params))
        }

        /**
         * DeleteEventAttendee carries out a soft delete for a specified row in the event_attendee table
         * 
         * It will also propagate an insertion to the event_attendee_audit table
         */
        public async DeleteEventAttendee(params: DeleteEventAttendeeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteEventAttendee`, JSON.stringify(params))
        }

        /**
         * DeleteEventType carries out a soft delete for a specified row in the event_type table
         * 
         * It will also propagate an insertion to the event_type_audit table
         */
        public async DeleteEventType(params: DeleteEventTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteEventType`, JSON.stringify(params))
        }

        /**
         * DeleteFormSubmission carries out a soft delete for a specified row in the form_submission table
         * 
         * It will also propagate an insertion to the form_submission_audit table
         */
        public async DeleteFormSubmission(params: DeleteFormSubmissionRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteFormSubmission`, JSON.stringify(params))
        }

        /**
         * DeleteMeeting carries out a soft delete for a specified row in the meeting table
         * 
         * It will also propagate an insertion to the meeting_audit table
         */
        public async DeleteMeeting(params: DeleteMeetingRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteMeeting`, JSON.stringify(params))
        }

        /**
         * DeleteMeetingAttendee carries out a soft delete for a specified row in the meeting_attendee table
         * 
         * It will also propagate an insertion to the meeting_attendee_audit table
         */
        public async DeleteMeetingAttendee(params: DeleteMeetingAttendeeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteMeetingAttendee`, JSON.stringify(params))
        }

        /**
         * DeleteMeetingCompany carries out a soft delete for a specified row in the meeting_company table
         * 
         * It will also propagate an insertion to the meeting_company_audit table
         */
        public async DeleteMeetingCompany(params: DeleteMeetingCompanyRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteMeetingCompany`, JSON.stringify(params))
        }

        /**
         * DeleteMeetingType carries out a soft delete for a specified row in the meeting_type table
         * 
         * It will also propagate an insertion to the meeting_type_audit table
         */
        public async DeleteMeetingType(params: DeleteMeetingTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteMeetingType`, JSON.stringify(params))
        }

        /**
         * DeleteNewsletterSignup carries out a soft delete for a specified row in the newsletter_signup table
         * 
         * It will also propagate an insertion to the newsletter_signup_audit table
         */
        public async DeleteNewsletterSignup(params: DeleteNewsletterSignupRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteNewsletterSignup`, JSON.stringify(params))
        }

        /**
         * DeleteOnCallRole carries out a soft delete for a specified row in the on_call_role table
         * 
         * It will also propagate an insertion to the on_call_role_audit table
         */
        public async DeleteOnCallRole(params: DeleteOnCallRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteOnCallRole`, JSON.stringify(params))
        }

        /**
         * DeleteOnCallSchedule carries out a soft delete for a specified row in the on_call_schedule table
         * 
         * It will also propagate an insertion to the on_call_schedule_audit table
         */
        public async DeleteOnCallSchedule(params: DeleteOnCallScheduleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteOnCallSchedule`, JSON.stringify(params))
        }

        /**
         * DeleteOpportunity carries out a soft delete for a specified row in the opportunity table
         * 
         * It will also propagate an insertion to the opportunity_audit table
         */
        public async DeleteOpportunity(params: DeleteOpportunityRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteOpportunity`, JSON.stringify(params))
        }

        /**
         * DeleteOpportunityFunnel carries out a soft delete for a specified row in the opportunity_funnel table
         * 
         * It will also propagate an insertion to the opportunity_funnel_audit table
         */
        public async DeleteOpportunityFunnel(params: DeleteOpportunityFunnelRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteOpportunityFunnel`, JSON.stringify(params))
        }

        /**
         * DeleteOpportunityFunnelStep carries out a soft delete for a specified row in the opportunity_funnel_step table
         * 
         * It will also propagate an insertion to the opportunity_funnel_step_audit table
         */
        public async DeleteOpportunityFunnelStep(params: DeleteOpportunityFunnelStepRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteOpportunityFunnelStep`, JSON.stringify(params))
        }

        /**
         * DeleteOpportunityProduct carries out a soft delete for a specified row in the opportunity_product table
         * 
         * It will also propagate an insertion to the opportunity_product_audit table
         */
        public async DeleteOpportunityProduct(params: DeleteOpportunityProductRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteOpportunityProduct`, JSON.stringify(params))
        }

        /**
         * DeleteOpportunityType carries out a soft delete for a specified row in the opportunity_type table
         * 
         * It will also propagate an insertion to the opportunity_type_audit table
         */
        public async DeleteOpportunityType(params: DeleteOpportunityTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteOpportunityType`, JSON.stringify(params))
        }

        /**
         * DeleteOrganizationDocument carries out a soft delete for a specified row in the organization_document table
         * 
         * It will also propagate an insertion to the organization_document_audit table
         */
        public async DeleteOrganizationDocument(params: DeleteOrganizationDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteOrganizationDocument`, JSON.stringify(params))
        }

        /**
         * DeleteProduct carries out a soft delete for a specified row in the product table
         * 
         * It will also propagate an insertion to the product_audit table
         */
        public async DeleteProduct(params: DeleteProductRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteProduct`, JSON.stringify(params))
        }

        /**
         * DeleteProductCategory carries out a soft delete for a specified row in the product_category table
         * 
         * It will also propagate an insertion to the product_category_audit table
         */
        public async DeleteProductCategory(params: DeleteProductCategoryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteProductCategory`, JSON.stringify(params))
        }

        /**
         * DeleteProductDocument carries out a soft delete for a specified row in the product_document table
         * 
         * It will also propagate an insertion to the product_document_audit table
         */
        public async DeleteProductDocument(params: DeleteProductDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteProductDocument`, JSON.stringify(params))
        }

        /**
         * DeleteProductSubcategory carries out a soft delete for a specified row in the product_subcategory table
         * 
         * It will also propagate an insertion to the product_subcategory_audit table
         */
        public async DeleteProductSubcategory(params: DeleteProductSubcategoryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteProductSubcategory`, JSON.stringify(params))
        }

        /**
         * DeleteProductUser carries out a soft delete for a specified row in the product_user table
         * 
         * It will also propagate an insertion to the product_user_audit table
         */
        public async DeleteProductUser(params: DeleteProductUserRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteProductUser`, JSON.stringify(params))
        }

        /**
         * DeleteSkrymCompanyRole carries out a soft delete for a specified row in the skrym_company_role table
         * 
         * It will also propagate an insertion to the skrym_company_role_audit table
         */
        public async DeleteSkrymCompanyRole(params: DeleteSkrymCompanyRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteSkrymCompanyRole`, JSON.stringify(params))
        }

        /**
         * DeleteSkrymCompanyRoleArea carries out a soft delete for a specified row in the skrym_company_role_area table
         * 
         * It will also propagate an insertion to the skrym_company_role_area_audit table
         */
        public async DeleteSkrymCompanyRoleArea(params: DeleteSkrymCompanyRoleAreaRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteSkrymCompanyRoleArea`, JSON.stringify(params))
        }

        /**
         * DeleteSkrymContactRole carries out a soft delete for a specified row in the skrym_contact_role table
         * 
         * It will also propagate an insertion to the skrym_contact_role_audit table
         */
        public async DeleteSkrymContactRole(params: DeleteSkrymContactRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteSkrymContactRole`, JSON.stringify(params))
        }

        /**
         * DeleteSprint carries out a soft delete for a specified row in the sprint table
         * 
         * It will also propagate an insertion to the sprint_audit table
         */
        public async DeleteSprint(params: DeleteSprintRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteSprint`, JSON.stringify(params))
        }

        /**
         * DeleteSprintDailyStandup carries out a soft delete for a specified row in the sprint_daily_standup table
         * 
         * It will also propagate an insertion to the sprint_daily_standup_audit table
         */
        public async DeleteSprintDailyStandup(params: DeleteSprintDailyStandupRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteSprintDailyStandup`, JSON.stringify(params))
        }

        /**
         * DeleteSprintDailyStandupEntry carries out a soft delete for a specified row in the sprint_daily_standup_entry table
         * 
         * It will also propagate an insertion to the sprint_daily_standup_entry_audit table
         */
        public async DeleteSprintDailyStandupEntry(params: DeleteSprintDailyStandupEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteSprintDailyStandupEntry`, JSON.stringify(params))
        }

        /**
         * DeleteSprintMessage carries out a soft delete for a specified row in the sprint_message table
         * 
         * It will also propagate an insertion to the sprint_message_audit table
         */
        public async DeleteSprintMessage(params: DeleteSprintMessageRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteSprintMessage`, JSON.stringify(params))
        }

        /**
         * DeleteSprintMessageType carries out a soft delete for a specified row in the sprint_message_type table
         * 
         * It will also propagate an insertion to the sprint_message_type_audit table
         */
        public async DeleteSprintMessageType(params: DeleteSprintMessageTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteSprintMessageType`, JSON.stringify(params))
        }

        /**
         * DeleteSprintRole carries out a soft delete for a specified row in the sprint_role table
         * 
         * It will also propagate an insertion to the sprint_role_audit table
         */
        public async DeleteSprintRole(params: DeleteSprintRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteSprintRole`, JSON.stringify(params))
        }

        /**
         * DeleteSprintRoleEntry carries out a soft delete for a specified row in the sprint_role_entry table
         * 
         * It will also propagate an insertion to the sprint_role_entry_audit table
         */
        public async DeleteSprintRoleEntry(params: DeleteSprintRoleEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteSprintRoleEntry`, JSON.stringify(params))
        }

        /**
         * DeleteTask carries out a soft delete for a specified row in the task table
         * 
         * It will also propagate an insertion to the task_audit table
         */
        public async DeleteTask(params: DeleteTaskRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteTask`, JSON.stringify(params))
        }

        /**
         * DeleteTaskOwner carries out a soft delete for a specified row in the task_owner table
         * 
         * It will also propagate an insertion to the task_owner_audit table
         */
        public async DeleteTaskOwner(params: DeleteTaskOwnerRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteTaskOwner`, JSON.stringify(params))
        }

        /**
         * DeleteTaskStatus carries out a soft delete for a specified row in the task_status table
         * 
         * It will also propagate an insertion to the task_status_audit table
         */
        public async DeleteTaskStatus(params: DeleteTaskStatusRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteTaskStatus`, JSON.stringify(params))
        }

        /**
         * DeleteWorkingTime carries out a soft delete for a specified row in the working_time table
         * 
         * It will also propagate an insertion to the working_time_audit table
         */
        public async DeleteWorkingTime(params: DeleteWorkingTimeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteWorkingTime`, JSON.stringify(params))
        }

        /**
         * DeleteWorkingTimeLocation carries out a soft delete for a specified row in the working_time_location table
         * 
         * It will also propagate an insertion to the working_time_location_audit table
         */
        public async DeleteWorkingTimeLocation(params: DeleteWorkingTimeLocationRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteWorkingTimeLocation`, JSON.stringify(params))
        }

        /**
         * DeleteWorkingTimeType carries out a soft delete for a specified row in the working_time_type table
         * 
         * It will also propagate an insertion to the working_time_type_audit table
         */
        public async DeleteWorkingTimeType(params: DeleteWorkingTimeTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.DeleteWorkingTimeType`, JSON.stringify(params))
        }

        /**
         * GetAllCallSheets retrieves all rows from the call_sheet
         */
        public async GetAllCallSheets(): Promise<GetAllCallSheetsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCallSheets`)
            return await resp.json() as GetAllCallSheetsResponseParams
        }

        /**
         * GetAllChannels retrieves all rows from the channel
         */
        public async GetAllChannels(): Promise<GetAllChannelsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllChannels`)
            return await resp.json() as GetAllChannelsResponseParams
        }

        /**
         * GetAllChannelsByConnectionSourceChannelId retrieves all entries from the channel that are referenced by a collection of rows in the Connection table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllChannelsByConnectionSourceChannelId(params: GetAllChannelsByConnectionSourceChannelIdRequestParams): Promise<GetAllChannelsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllChannelsByConnectionSourceChannelId`, JSON.stringify(params))
            return await resp.json() as GetAllChannelsResponseParams
        }

        /**
         * GetAllCompanies retrieves all rows from the company
         */
        public async GetAllCompanies(): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanies`)
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByCompanyBillingInfoCompanyId retrieves all entries from the company that are referenced by a collection of rows in the CompanyBillingInfo table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByCompanyBillingInfoCompanyId(params: GetAllCompaniesByCompanyBillingInfoCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByCompanyBillingInfoCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByCompanyInvoiceCompanyId retrieves all entries from the company that are referenced by a collection of rows in the CompanyInvoice table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByCompanyInvoiceCompanyId(params: GetAllCompaniesByCompanyInvoiceCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByCompanyInvoiceCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByCompanyNoteCompanyId retrieves all entries from the company that are referenced by a collection of rows in the CompanyNote table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByCompanyNoteCompanyId(params: GetAllCompaniesByCompanyNoteCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByCompanyNoteCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByCompanyProductAreaCompanyId retrieves all entries from the company that are referenced by a collection of rows in the CompanyProductArea table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByCompanyProductAreaCompanyId(params: GetAllCompaniesByCompanyProductAreaCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByCompanyProductAreaCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByCompanySegmentEntryCompanyId retrieves all entries from the company that are referenced by a collection of rows in the CompanySegmentEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByCompanySegmentEntryCompanyId(params: GetAllCompaniesByCompanySegmentEntryCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByCompanySegmentEntryCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByConnectionReceivingCompanyId retrieves all entries from the company that are referenced by a collection of rows in the Connection table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByConnectionReceivingCompanyId(params: GetAllCompaniesByConnectionReceivingCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByConnectionReceivingCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByConnectionSourceCompanyId retrieves all entries from the company that are referenced by a collection of rows in the Connection table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByConnectionSourceCompanyId(params: GetAllCompaniesByConnectionSourceCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByConnectionSourceCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByConnectionTargetCompanyId retrieves all entries from the company that are referenced by a collection of rows in the Connection table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByConnectionTargetCompanyId(params: GetAllCompaniesByConnectionTargetCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByConnectionTargetCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByContactRoleCompanyId retrieves all entries from the company that are referenced by a collection of rows in the ContactRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByContactRoleCompanyId(params: GetAllCompaniesByContactRoleCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByContactRoleCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByMeetingCompanyCompanyId retrieves all entries from the company that are referenced by a collection of rows in the MeetingCompany table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByMeetingCompanyCompanyId(params: GetAllCompaniesByMeetingCompanyCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByMeetingCompanyCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByOpportunityCompanyId retrieves all entries from the company that are referenced by a collection of rows in the Opportunity table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByOpportunityCompanyId(params: GetAllCompaniesByOpportunityCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByOpportunityCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByOrganizationDocumentOrganizationId retrieves all entries from the company that are referenced by a collection of rows in the OrganizationDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByOrganizationDocumentOrganizationId(params: GetAllCompaniesByOrganizationDocumentOrganizationIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByOrganizationDocumentOrganizationId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByProductProviderCompanyId retrieves all entries from the company that are referenced by a collection of rows in the Product table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByProductProviderCompanyId(params: GetAllCompaniesByProductProviderCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByProductProviderCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByProductUserUserCompanyId retrieves all entries from the company that are referenced by a collection of rows in the ProductUser table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByProductUserUserCompanyId(params: GetAllCompaniesByProductUserUserCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByProductUserUserCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesBySkrymContactRoleCompanyId retrieves all entries from the company that are referenced by a collection of rows in the SkrymContactRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesBySkrymContactRoleCompanyId(params: GetAllCompaniesBySkrymContactRoleCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesBySkrymContactRoleCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByTaskCompanyId retrieves all entries from the company that are referenced by a collection of rows in the Task table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByTaskCompanyId(params: GetAllCompaniesByTaskCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByTaskCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByWorkingTimeLocationCompanyId retrieves all entries from the company that are referenced by a collection of rows in the WorkingTimeLocation table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByWorkingTimeLocationCompanyId(params: GetAllCompaniesByWorkingTimeLocationCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByWorkingTimeLocationCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompaniesByWorkingTimeTypeCompanyId retrieves all entries from the company that are referenced by a collection of rows in the WorkingTimeType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompaniesByWorkingTimeTypeCompanyId(params: GetAllCompaniesByWorkingTimeTypeCompanyIdRequestParams): Promise<GetAllCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompaniesByWorkingTimeTypeCompanyId`, JSON.stringify(params))
            return await resp.json() as GetAllCompaniesResponseParams
        }

        /**
         * GetAllCompanyBillingInfos retrieves all rows from the company_billing_info
         */
        public async GetAllCompanyBillingInfos(): Promise<GetAllCompanyBillingInfosResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanyBillingInfos`)
            return await resp.json() as GetAllCompanyBillingInfosResponseParams
        }

        /**
         * GetAllCompanyInvoices retrieves all rows from the company_invoice
         */
        public async GetAllCompanyInvoices(): Promise<GetAllCompanyInvoicesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanyInvoices`)
            return await resp.json() as GetAllCompanyInvoicesResponseParams
        }

        /**
         * GetAllCompanyNotes retrieves all rows from the company_note
         */
        public async GetAllCompanyNotes(): Promise<GetAllCompanyNotesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanyNotes`)
            return await resp.json() as GetAllCompanyNotesResponseParams
        }

        /**
         * GetAllCompanyProductAreaEntries retrieves all rows from the company_product_area_entry
         */
        public async GetAllCompanyProductAreaEntries(): Promise<GetAllCompanyProductAreaEntriesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanyProductAreaEntries`)
            return await resp.json() as GetAllCompanyProductAreaEntriesResponseParams
        }

        /**
         * GetAllCompanyProductAreas retrieves all rows from the company_product_area
         */
        public async GetAllCompanyProductAreas(): Promise<GetAllCompanyProductAreasResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanyProductAreas`)
            return await resp.json() as GetAllCompanyProductAreasResponseParams
        }

        /**
         * GetAllCompanyProductAreasByCompanyProductAreaEntryCompanyAreaId retrieves all entries from the company_product_area that are referenced by a collection of rows in the CompanyProductAreaEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompanyProductAreasByCompanyProductAreaEntryCompanyAreaId(params: GetAllCompanyProductAreasByCompanyProductAreaEntryCompanyAreaIdRequestParams): Promise<GetAllCompanyProductAreasResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanyProductAreasByCompanyProductAreaEntryCompanyAreaId`, JSON.stringify(params))
            return await resp.json() as GetAllCompanyProductAreasResponseParams
        }

        /**
         * GetAllCompanySegmentEntries retrieves all rows from the company_segment_entry
         */
        public async GetAllCompanySegmentEntries(): Promise<GetAllCompanySegmentEntriesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanySegmentEntries`)
            return await resp.json() as GetAllCompanySegmentEntriesResponseParams
        }

        /**
         * GetAllCompanySegments retrieves all rows from the company_segment
         */
        public async GetAllCompanySegments(): Promise<GetAllCompanySegmentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanySegments`)
            return await resp.json() as GetAllCompanySegmentsResponseParams
        }

        /**
         * GetAllCompanySegmentsByCompanySegmentEntryCompanySegmentId retrieves all entries from the company_segment that are referenced by a collection of rows in the CompanySegmentEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompanySegmentsByCompanySegmentEntryCompanySegmentId(params: GetAllCompanySegmentsByCompanySegmentEntryCompanySegmentIdRequestParams): Promise<GetAllCompanySegmentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanySegmentsByCompanySegmentEntryCompanySegmentId`, JSON.stringify(params))
            return await resp.json() as GetAllCompanySegmentsResponseParams
        }

        /**
         * GetAllCompanyTypes retrieves all rows from the company_type
         */
        public async GetAllCompanyTypes(): Promise<GetAllCompanyTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanyTypes`)
            return await resp.json() as GetAllCompanyTypesResponseParams
        }

        /**
         * GetAllCompanyTypesByCompanySegmentTypeId retrieves all entries from the company_type that are referenced by a collection of rows in the CompanySegment table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompanyTypesByCompanySegmentTypeId(params: GetAllCompanyTypesByCompanySegmentTypeIdRequestParams): Promise<GetAllCompanyTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanyTypesByCompanySegmentTypeId`, JSON.stringify(params))
            return await resp.json() as GetAllCompanyTypesResponseParams
        }

        /**
         * GetAllCompanyTypesByCompanyTypeId retrieves all entries from the company_type that are referenced by a collection of rows in the Company table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllCompanyTypesByCompanyTypeId(params: GetAllCompanyTypesByCompanyTypeIdRequestParams): Promise<GetAllCompanyTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllCompanyTypesByCompanyTypeId`, JSON.stringify(params))
            return await resp.json() as GetAllCompanyTypesResponseParams
        }

        /**
         * GetAllConnections retrieves all rows from the connection
         */
        public async GetAllConnections(): Promise<GetAllConnectionsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllConnections`)
            return await resp.json() as GetAllConnectionsResponseParams
        }

        /**
         * GetAllContactDetailTypes retrieves all rows from the contact_detail_type
         */
        public async GetAllContactDetailTypes(): Promise<GetAllContactDetailTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactDetailTypes`)
            return await resp.json() as GetAllContactDetailTypesResponseParams
        }

        /**
         * GetAllContactDetailTypesByContactDetailTypeId retrieves all entries from the contact_detail_type that are referenced by a collection of rows in the ContactDetail table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactDetailTypesByContactDetailTypeId(params: GetAllContactDetailTypesByContactDetailTypeIdRequestParams): Promise<GetAllContactDetailTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactDetailTypesByContactDetailTypeId`, JSON.stringify(params))
            return await resp.json() as GetAllContactDetailTypesResponseParams
        }

        /**
         * GetAllContactDetails retrieves all rows from the contact_detail
         */
        public async GetAllContactDetails(): Promise<GetAllContactDetailsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactDetails`)
            return await resp.json() as GetAllContactDetailsResponseParams
        }

        /**
         * GetAllContactDocuments retrieves all rows from the contact_document
         */
        public async GetAllContactDocuments(): Promise<GetAllContactDocumentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactDocuments`)
            return await resp.json() as GetAllContactDocumentsResponseParams
        }

        /**
         * GetAllContactDocumentsByEmploymentContract retrieves all entries from the contact_document that are referenced by a collection of rows in the Employment table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactDocumentsByEmploymentContract(params: GetAllContactDocumentsByEmploymentContractRequestParams): Promise<GetAllContactDocumentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactDocumentsByEmploymentContract`, JSON.stringify(params))
            return await resp.json() as GetAllContactDocumentsResponseParams
        }

        /**
         * GetAllContactNotes retrieves all rows from the contact_note
         */
        public async GetAllContactNotes(): Promise<GetAllContactNotesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactNotes`)
            return await resp.json() as GetAllContactNotesResponseParams
        }

        /**
         * GetAllContactRoles retrieves all rows from the contact_role
         */
        public async GetAllContactRoles(): Promise<GetAllContactRolesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactRoles`)
            return await resp.json() as GetAllContactRolesResponseParams
        }

        /**
         * GetAllContactRolesByEmploymentContactRoleId retrieves all entries from the contact_role that are referenced by a collection of rows in the Employment table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactRolesByEmploymentContactRoleId(params: GetAllContactRolesByEmploymentContactRoleIdRequestParams): Promise<GetAllContactRolesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactRolesByEmploymentContactRoleId`, JSON.stringify(params))
            return await resp.json() as GetAllContactRolesResponseParams
        }

        /**
         * GetAllContactRolesByWorkingTimeContactRoleId retrieves all entries from the contact_role that are referenced by a collection of rows in the WorkingTime table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactRolesByWorkingTimeContactRoleId(params: GetAllContactRolesByWorkingTimeContactRoleIdRequestParams): Promise<GetAllContactRolesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactRolesByWorkingTimeContactRoleId`, JSON.stringify(params))
            return await resp.json() as GetAllContactRolesResponseParams
        }

        /**
         * GetAllContacts retrieves all rows from the contact
         */
        public async GetAllContacts(): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContacts`)
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCallSheetCallerId retrieves all entries from the contact that are referenced by a collection of rows in the CallSheet table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCallSheetCallerId(params: GetAllContactsByCallSheetCallerIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCallSheetCallerId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCallSheetCallingId retrieves all entries from the contact that are referenced by a collection of rows in the CallSheet table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCallSheetCallingId(params: GetAllContactsByCallSheetCallingIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCallSheetCallingId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCallSheetCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CallSheet table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCallSheetCreatedBy(params: GetAllContactsByCallSheetCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCallSheetCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCallSheetUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CallSheet table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCallSheetUpdatedBy(params: GetAllContactsByCallSheetUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCallSheetUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByChannelCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Channel table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByChannelCreatedBy(params: GetAllContactsByChannelCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByChannelCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByChannelUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Channel table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByChannelUpdatedBy(params: GetAllContactsByChannelUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByChannelUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyBillingInfoCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyBillingInfo table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyBillingInfoCreatedBy(params: GetAllContactsByCompanyBillingInfoCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyBillingInfoCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyBillingInfoUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyBillingInfo table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyBillingInfoUpdatedBy(params: GetAllContactsByCompanyBillingInfoUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyBillingInfoUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Company table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyCreatedBy(params: GetAllContactsByCompanyCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyInvoiceCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyInvoice table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyInvoiceCreatedBy(params: GetAllContactsByCompanyInvoiceCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyInvoiceCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyInvoiceUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyInvoice table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyInvoiceUpdatedBy(params: GetAllContactsByCompanyInvoiceUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyInvoiceUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyNoteCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyNote table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyNoteCreatedBy(params: GetAllContactsByCompanyNoteCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyNoteCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyNoteUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyNote table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyNoteUpdatedBy(params: GetAllContactsByCompanyNoteUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyNoteUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyProductAreaCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyProductArea table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyProductAreaCreatedBy(params: GetAllContactsByCompanyProductAreaCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyProductAreaCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyProductAreaEntryCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyProductAreaEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyProductAreaEntryCreatedBy(params: GetAllContactsByCompanyProductAreaEntryCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyProductAreaEntryCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyProductAreaEntryUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyProductAreaEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyProductAreaEntryUpdatedBy(params: GetAllContactsByCompanyProductAreaEntryUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyProductAreaEntryUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyProductAreaUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyProductArea table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyProductAreaUpdatedBy(params: GetAllContactsByCompanyProductAreaUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyProductAreaUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanySegmentCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanySegment table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanySegmentCreatedBy(params: GetAllContactsByCompanySegmentCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanySegmentCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanySegmentEntryCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanySegmentEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanySegmentEntryCreatedBy(params: GetAllContactsByCompanySegmentEntryCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanySegmentEntryCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanySegmentEntryUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanySegmentEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanySegmentEntryUpdatedBy(params: GetAllContactsByCompanySegmentEntryUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanySegmentEntryUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanySegmentUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanySegment table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanySegmentUpdatedBy(params: GetAllContactsByCompanySegmentUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanySegmentUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyTypeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyTypeCreatedBy(params: GetAllContactsByCompanyTypeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyTypeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyTypeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the CompanyType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyTypeUpdatedBy(params: GetAllContactsByCompanyTypeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyTypeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByCompanyUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Company table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByCompanyUpdatedBy(params: GetAllContactsByCompanyUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByCompanyUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByConnectionCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Connection table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByConnectionCreatedBy(params: GetAllContactsByConnectionCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByConnectionCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByConnectionSourceContactId retrieves all entries from the contact that are referenced by a collection of rows in the Connection table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByConnectionSourceContactId(params: GetAllContactsByConnectionSourceContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByConnectionSourceContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByConnectionTargetContactId retrieves all entries from the contact that are referenced by a collection of rows in the Connection table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByConnectionTargetContactId(params: GetAllContactsByConnectionTargetContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByConnectionTargetContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByConnectionUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Connection table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByConnectionUpdatedBy(params: GetAllContactsByConnectionUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByConnectionUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactDetailContactId retrieves all entries from the contact that are referenced by a collection of rows in the ContactDetail table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactDetailContactId(params: GetAllContactsByContactDetailContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactDetailContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactDetailCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ContactDetail table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactDetailCreatedBy(params: GetAllContactsByContactDetailCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactDetailCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactDetailTypeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ContactDetailType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactDetailTypeCreatedBy(params: GetAllContactsByContactDetailTypeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactDetailTypeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactDetailTypeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ContactDetailType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactDetailTypeUpdatedBy(params: GetAllContactsByContactDetailTypeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactDetailTypeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactDetailUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ContactDetail table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactDetailUpdatedBy(params: GetAllContactsByContactDetailUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactDetailUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactDocumentContactId retrieves all entries from the contact that are referenced by a collection of rows in the ContactDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactDocumentContactId(params: GetAllContactsByContactDocumentContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactDocumentContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactDocumentCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ContactDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactDocumentCreatedBy(params: GetAllContactsByContactDocumentCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactDocumentCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactDocumentUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ContactDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactDocumentUpdatedBy(params: GetAllContactsByContactDocumentUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactDocumentUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactNoteContactId retrieves all entries from the contact that are referenced by a collection of rows in the ContactNote table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactNoteContactId(params: GetAllContactsByContactNoteContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactNoteContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactNoteCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ContactNote table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactNoteCreatedBy(params: GetAllContactsByContactNoteCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactNoteCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactNoteUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ContactNote table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactNoteUpdatedBy(params: GetAllContactsByContactNoteUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactNoteUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactRoleContactId retrieves all entries from the contact that are referenced by a collection of rows in the ContactRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactRoleContactId(params: GetAllContactsByContactRoleContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactRoleContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactRoleCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ContactRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactRoleCreatedBy(params: GetAllContactsByContactRoleCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactRoleCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByContactRoleUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ContactRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByContactRoleUpdatedBy(params: GetAllContactsByContactRoleUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByContactRoleUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByDocumentCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Document table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByDocumentCreatedBy(params: GetAllContactsByDocumentCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByDocumentCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByDocumentTypeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the DocumentType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByDocumentTypeCreatedBy(params: GetAllContactsByDocumentTypeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByDocumentTypeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByDocumentTypeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the DocumentType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByDocumentTypeUpdatedBy(params: GetAllContactsByDocumentTypeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByDocumentTypeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByDocumentUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Document table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByDocumentUpdatedBy(params: GetAllContactsByDocumentUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByDocumentUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByEmploymentCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Employment table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByEmploymentCreatedBy(params: GetAllContactsByEmploymentCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByEmploymentCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByEmploymentUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Employment table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByEmploymentUpdatedBy(params: GetAllContactsByEmploymentUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByEmploymentUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByEventAttendeeContactId retrieves all entries from the contact that are referenced by a collection of rows in the EventAttendee table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByEventAttendeeContactId(params: GetAllContactsByEventAttendeeContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByEventAttendeeContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByEventAttendeeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the EventAttendee table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByEventAttendeeCreatedBy(params: GetAllContactsByEventAttendeeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByEventAttendeeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByEventAttendeeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the EventAttendee table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByEventAttendeeUpdatedBy(params: GetAllContactsByEventAttendeeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByEventAttendeeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByEventCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Event table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByEventCreatedBy(params: GetAllContactsByEventCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByEventCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByEventTypeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the EventType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByEventTypeCreatedBy(params: GetAllContactsByEventTypeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByEventTypeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByEventTypeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the EventType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByEventTypeUpdatedBy(params: GetAllContactsByEventTypeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByEventTypeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByEventUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Event table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByEventUpdatedBy(params: GetAllContactsByEventUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByEventUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByMeetingAttendeeContactId retrieves all entries from the contact that are referenced by a collection of rows in the MeetingAttendee table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByMeetingAttendeeContactId(params: GetAllContactsByMeetingAttendeeContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByMeetingAttendeeContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByMeetingAttendeeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the MeetingAttendee table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByMeetingAttendeeCreatedBy(params: GetAllContactsByMeetingAttendeeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByMeetingAttendeeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByMeetingAttendeeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the MeetingAttendee table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByMeetingAttendeeUpdatedBy(params: GetAllContactsByMeetingAttendeeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByMeetingAttendeeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByMeetingCompanyCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the MeetingCompany table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByMeetingCompanyCreatedBy(params: GetAllContactsByMeetingCompanyCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByMeetingCompanyCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByMeetingCompanyUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the MeetingCompany table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByMeetingCompanyUpdatedBy(params: GetAllContactsByMeetingCompanyUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByMeetingCompanyUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByMeetingCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Meeting table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByMeetingCreatedBy(params: GetAllContactsByMeetingCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByMeetingCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByMeetingTypeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the MeetingType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByMeetingTypeCreatedBy(params: GetAllContactsByMeetingTypeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByMeetingTypeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByMeetingTypeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the MeetingType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByMeetingTypeUpdatedBy(params: GetAllContactsByMeetingTypeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByMeetingTypeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByMeetingUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Meeting table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByMeetingUpdatedBy(params: GetAllContactsByMeetingUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByMeetingUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOnCallRoleCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OnCallRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOnCallRoleCreatedBy(params: GetAllContactsByOnCallRoleCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOnCallRoleCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOnCallRoleUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OnCallRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOnCallRoleUpdatedBy(params: GetAllContactsByOnCallRoleUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOnCallRoleUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOnCallScheduleContactId retrieves all entries from the contact that are referenced by a collection of rows in the OnCallSchedule table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOnCallScheduleContactId(params: GetAllContactsByOnCallScheduleContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOnCallScheduleContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOnCallScheduleCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OnCallSchedule table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOnCallScheduleCreatedBy(params: GetAllContactsByOnCallScheduleCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOnCallScheduleCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOnCallScheduleUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OnCallSchedule table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOnCallScheduleUpdatedBy(params: GetAllContactsByOnCallScheduleUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOnCallScheduleUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOpportunityCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Opportunity table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOpportunityCreatedBy(params: GetAllContactsByOpportunityCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOpportunityCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOpportunityFunnelCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OpportunityFunnel table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOpportunityFunnelCreatedBy(params: GetAllContactsByOpportunityFunnelCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOpportunityFunnelCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOpportunityFunnelStepCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OpportunityFunnelStep table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOpportunityFunnelStepCreatedBy(params: GetAllContactsByOpportunityFunnelStepCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOpportunityFunnelStepCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOpportunityFunnelStepUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OpportunityFunnelStep table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOpportunityFunnelStepUpdatedBy(params: GetAllContactsByOpportunityFunnelStepUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOpportunityFunnelStepUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOpportunityFunnelUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OpportunityFunnel table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOpportunityFunnelUpdatedBy(params: GetAllContactsByOpportunityFunnelUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOpportunityFunnelUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOpportunityProductCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OpportunityProduct table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOpportunityProductCreatedBy(params: GetAllContactsByOpportunityProductCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOpportunityProductCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOpportunityProductUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OpportunityProduct table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOpportunityProductUpdatedBy(params: GetAllContactsByOpportunityProductUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOpportunityProductUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOpportunityTypeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OpportunityType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOpportunityTypeCreatedBy(params: GetAllContactsByOpportunityTypeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOpportunityTypeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOpportunityTypeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OpportunityType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOpportunityTypeUpdatedBy(params: GetAllContactsByOpportunityTypeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOpportunityTypeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOpportunityUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Opportunity table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOpportunityUpdatedBy(params: GetAllContactsByOpportunityUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOpportunityUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOrganizationDocumentCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OrganizationDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOrganizationDocumentCreatedBy(params: GetAllContactsByOrganizationDocumentCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOrganizationDocumentCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByOrganizationDocumentUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the OrganizationDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByOrganizationDocumentUpdatedBy(params: GetAllContactsByOrganizationDocumentUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByOrganizationDocumentUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByProductCategoryCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ProductCategory table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByProductCategoryCreatedBy(params: GetAllContactsByProductCategoryCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByProductCategoryCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByProductCategoryUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ProductCategory table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByProductCategoryUpdatedBy(params: GetAllContactsByProductCategoryUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByProductCategoryUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByProductCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Product table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByProductCreatedBy(params: GetAllContactsByProductCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByProductCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByProductDocumentCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ProductDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByProductDocumentCreatedBy(params: GetAllContactsByProductDocumentCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByProductDocumentCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByProductDocumentUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ProductDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByProductDocumentUpdatedBy(params: GetAllContactsByProductDocumentUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByProductDocumentUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByProductSubcategoryCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ProductSubcategory table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByProductSubcategoryCreatedBy(params: GetAllContactsByProductSubcategoryCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByProductSubcategoryCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByProductSubcategoryUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ProductSubcategory table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByProductSubcategoryUpdatedBy(params: GetAllContactsByProductSubcategoryUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByProductSubcategoryUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByProductUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Product table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByProductUpdatedBy(params: GetAllContactsByProductUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByProductUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByProductUserCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ProductUser table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByProductUserCreatedBy(params: GetAllContactsByProductUserCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByProductUserCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByProductUserUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the ProductUser table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByProductUserUpdatedBy(params: GetAllContactsByProductUserUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByProductUserUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySkrymCompanyRoleAreaCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SkrymCompanyRoleArea table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySkrymCompanyRoleAreaCreatedBy(params: GetAllContactsBySkrymCompanyRoleAreaCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySkrymCompanyRoleAreaCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySkrymCompanyRoleAreaUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SkrymCompanyRoleArea table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySkrymCompanyRoleAreaUpdatedBy(params: GetAllContactsBySkrymCompanyRoleAreaUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySkrymCompanyRoleAreaUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySkrymCompanyRoleCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SkrymCompanyRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySkrymCompanyRoleCreatedBy(params: GetAllContactsBySkrymCompanyRoleCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySkrymCompanyRoleCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySkrymCompanyRoleUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SkrymCompanyRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySkrymCompanyRoleUpdatedBy(params: GetAllContactsBySkrymCompanyRoleUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySkrymCompanyRoleUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySkrymContactRoleContactId retrieves all entries from the contact that are referenced by a collection of rows in the SkrymContactRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySkrymContactRoleContactId(params: GetAllContactsBySkrymContactRoleContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySkrymContactRoleContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySkrymContactRoleCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SkrymContactRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySkrymContactRoleCreatedBy(params: GetAllContactsBySkrymContactRoleCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySkrymContactRoleCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySkrymContactRoleUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SkrymContactRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySkrymContactRoleUpdatedBy(params: GetAllContactsBySkrymContactRoleUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySkrymContactRoleUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Sprint table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintCreatedBy(params: GetAllContactsBySprintCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintDailyStandupCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintDailyStandup table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintDailyStandupCreatedBy(params: GetAllContactsBySprintDailyStandupCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintDailyStandupCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintDailyStandupEntryCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintDailyStandupEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintDailyStandupEntryCreatedBy(params: GetAllContactsBySprintDailyStandupEntryCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintDailyStandupEntryCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintDailyStandupEntryTeamMemberId retrieves all entries from the contact that are referenced by a collection of rows in the SprintDailyStandupEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintDailyStandupEntryTeamMemberId(params: GetAllContactsBySprintDailyStandupEntryTeamMemberIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintDailyStandupEntryTeamMemberId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintDailyStandupEntryUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintDailyStandupEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintDailyStandupEntryUpdatedBy(params: GetAllContactsBySprintDailyStandupEntryUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintDailyStandupEntryUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintDailyStandupHostedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintDailyStandup table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintDailyStandupHostedBy(params: GetAllContactsBySprintDailyStandupHostedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintDailyStandupHostedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintDailyStandupUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintDailyStandup table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintDailyStandupUpdatedBy(params: GetAllContactsBySprintDailyStandupUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintDailyStandupUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintMessageCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintMessage table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintMessageCreatedBy(params: GetAllContactsBySprintMessageCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintMessageCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintMessageTypeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintMessageType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintMessageTypeCreatedBy(params: GetAllContactsBySprintMessageTypeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintMessageTypeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintMessageTypeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintMessageType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintMessageTypeUpdatedBy(params: GetAllContactsBySprintMessageTypeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintMessageTypeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintMessageUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintMessage table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintMessageUpdatedBy(params: GetAllContactsBySprintMessageUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintMessageUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintRoleCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintRoleCreatedBy(params: GetAllContactsBySprintRoleCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintRoleCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintRoleEntryContactId retrieves all entries from the contact that are referenced by a collection of rows in the SprintRoleEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintRoleEntryContactId(params: GetAllContactsBySprintRoleEntryContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintRoleEntryContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintRoleEntryCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintRoleEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintRoleEntryCreatedBy(params: GetAllContactsBySprintRoleEntryCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintRoleEntryCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintRoleEntryUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintRoleEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintRoleEntryUpdatedBy(params: GetAllContactsBySprintRoleEntryUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintRoleEntryUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintRoleUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the SprintRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintRoleUpdatedBy(params: GetAllContactsBySprintRoleUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintRoleUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsBySprintUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Sprint table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsBySprintUpdatedBy(params: GetAllContactsBySprintUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsBySprintUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByTaskCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Task table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByTaskCreatedBy(params: GetAllContactsByTaskCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByTaskCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByTaskOwnerContactId retrieves all entries from the contact that are referenced by a collection of rows in the TaskOwner table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByTaskOwnerContactId(params: GetAllContactsByTaskOwnerContactIdRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByTaskOwnerContactId`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByTaskOwnerCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the TaskOwner table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByTaskOwnerCreatedBy(params: GetAllContactsByTaskOwnerCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByTaskOwnerCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByTaskOwnerUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the TaskOwner table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByTaskOwnerUpdatedBy(params: GetAllContactsByTaskOwnerUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByTaskOwnerUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByTaskStatusCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the TaskStatus table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByTaskStatusCreatedBy(params: GetAllContactsByTaskStatusCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByTaskStatusCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByTaskStatusUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the TaskStatus table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByTaskStatusUpdatedBy(params: GetAllContactsByTaskStatusUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByTaskStatusUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByTaskUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the Task table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByTaskUpdatedBy(params: GetAllContactsByTaskUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByTaskUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByWorkingTimeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the WorkingTime table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByWorkingTimeCreatedBy(params: GetAllContactsByWorkingTimeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByWorkingTimeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByWorkingTimeLocationCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the WorkingTimeLocation table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByWorkingTimeLocationCreatedBy(params: GetAllContactsByWorkingTimeLocationCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByWorkingTimeLocationCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByWorkingTimeLocationUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the WorkingTimeLocation table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByWorkingTimeLocationUpdatedBy(params: GetAllContactsByWorkingTimeLocationUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByWorkingTimeLocationUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByWorkingTimeTypeCreatedBy retrieves all entries from the contact that are referenced by a collection of rows in the WorkingTimeType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByWorkingTimeTypeCreatedBy(params: GetAllContactsByWorkingTimeTypeCreatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByWorkingTimeTypeCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByWorkingTimeTypeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the WorkingTimeType table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByWorkingTimeTypeUpdatedBy(params: GetAllContactsByWorkingTimeTypeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByWorkingTimeTypeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllContactsByWorkingTimeUpdatedBy retrieves all entries from the contact that are referenced by a collection of rows in the WorkingTime table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllContactsByWorkingTimeUpdatedBy(params: GetAllContactsByWorkingTimeUpdatedByRequestParams): Promise<GetAllContactsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllContactsByWorkingTimeUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetAllContactsResponseParams
        }

        /**
         * GetAllDocumentTypes retrieves all rows from the document_type
         */
        public async GetAllDocumentTypes(): Promise<GetAllDocumentTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllDocumentTypes`)
            return await resp.json() as GetAllDocumentTypesResponseParams
        }

        /**
         * GetAllDocumentTypesByDocumentTypeId retrieves all entries from the document_type that are referenced by a collection of rows in the Document table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllDocumentTypesByDocumentTypeId(params: GetAllDocumentTypesByDocumentTypeIdRequestParams): Promise<GetAllDocumentTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllDocumentTypesByDocumentTypeId`, JSON.stringify(params))
            return await resp.json() as GetAllDocumentTypesResponseParams
        }

        /**
         * GetAllDocuments retrieves all rows from the document
         */
        public async GetAllDocuments(): Promise<GetAllDocumentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllDocuments`)
            return await resp.json() as GetAllDocumentsResponseParams
        }

        /**
         * GetAllDocumentsByContactDocumentDocumentId retrieves all entries from the document that are referenced by a collection of rows in the ContactDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllDocumentsByContactDocumentDocumentId(params: GetAllDocumentsByContactDocumentDocumentIdRequestParams): Promise<GetAllDocumentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllDocumentsByContactDocumentDocumentId`, JSON.stringify(params))
            return await resp.json() as GetAllDocumentsResponseParams
        }

        /**
         * GetAllDocumentsByOrganizationDocumentDocumentId retrieves all entries from the document that are referenced by a collection of rows in the OrganizationDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllDocumentsByOrganizationDocumentDocumentId(params: GetAllDocumentsByOrganizationDocumentDocumentIdRequestParams): Promise<GetAllDocumentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllDocumentsByOrganizationDocumentDocumentId`, JSON.stringify(params))
            return await resp.json() as GetAllDocumentsResponseParams
        }

        /**
         * GetAllDocumentsByProductDocumentDocumentId retrieves all entries from the document that are referenced by a collection of rows in the ProductDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllDocumentsByProductDocumentDocumentId(params: GetAllDocumentsByProductDocumentDocumentIdRequestParams): Promise<GetAllDocumentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllDocumentsByProductDocumentDocumentId`, JSON.stringify(params))
            return await resp.json() as GetAllDocumentsResponseParams
        }

        /**
         * GetAllEmployments retrieves all rows from the employment
         */
        public async GetAllEmployments(): Promise<GetAllEmploymentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllEmployments`)
            return await resp.json() as GetAllEmploymentsResponseParams
        }

        /**
         * GetAllEventAttendees retrieves all rows from the event_attendee
         */
        public async GetAllEventAttendees(): Promise<GetAllEventAttendeesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllEventAttendees`)
            return await resp.json() as GetAllEventAttendeesResponseParams
        }

        /**
         * GetAllEventTypes retrieves all rows from the event_type
         */
        public async GetAllEventTypes(): Promise<GetAllEventTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllEventTypes`)
            return await resp.json() as GetAllEventTypesResponseParams
        }

        /**
         * GetAllEventTypesByEventTypeId retrieves all entries from the event_type that are referenced by a collection of rows in the Event table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllEventTypesByEventTypeId(params: GetAllEventTypesByEventTypeIdRequestParams): Promise<GetAllEventTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllEventTypesByEventTypeId`, JSON.stringify(params))
            return await resp.json() as GetAllEventTypesResponseParams
        }

        /**
         * GetAllEvents retrieves all rows from the event
         */
        public async GetAllEvents(): Promise<GetAllEventsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllEvents`)
            return await resp.json() as GetAllEventsResponseParams
        }

        /**
         * GetAllEventsByConnectionSourceEventId retrieves all entries from the event that are referenced by a collection of rows in the Connection table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllEventsByConnectionSourceEventId(params: GetAllEventsByConnectionSourceEventIdRequestParams): Promise<GetAllEventsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllEventsByConnectionSourceEventId`, JSON.stringify(params))
            return await resp.json() as GetAllEventsResponseParams
        }

        /**
         * GetAllEventsByEventAttendeeEventId retrieves all entries from the event that are referenced by a collection of rows in the EventAttendee table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllEventsByEventAttendeeEventId(params: GetAllEventsByEventAttendeeEventIdRequestParams): Promise<GetAllEventsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllEventsByEventAttendeeEventId`, JSON.stringify(params))
            return await resp.json() as GetAllEventsResponseParams
        }

        /**
         * GetAllFormSubmissions retrieves all rows from the form_submission
         */
        public async GetAllFormSubmissions(): Promise<GetAllFormSubmissionsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllFormSubmissions`)
            return await resp.json() as GetAllFormSubmissionsResponseParams
        }

        /**
         * GetAllMeetingAttendees retrieves all rows from the meeting_attendee
         */
        public async GetAllMeetingAttendees(): Promise<GetAllMeetingAttendeesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllMeetingAttendees`)
            return await resp.json() as GetAllMeetingAttendeesResponseParams
        }

        /**
         * GetAllMeetingCompanies retrieves all rows from the meeting_company
         */
        public async GetAllMeetingCompanies(): Promise<GetAllMeetingCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllMeetingCompanies`)
            return await resp.json() as GetAllMeetingCompaniesResponseParams
        }

        /**
         * GetAllMeetingTypes retrieves all rows from the meeting_type
         */
        public async GetAllMeetingTypes(): Promise<GetAllMeetingTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllMeetingTypes`)
            return await resp.json() as GetAllMeetingTypesResponseParams
        }

        /**
         * GetAllMeetingTypesByMeetingTypeId retrieves all entries from the meeting_type that are referenced by a collection of rows in the Meeting table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllMeetingTypesByMeetingTypeId(params: GetAllMeetingTypesByMeetingTypeIdRequestParams): Promise<GetAllMeetingTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllMeetingTypesByMeetingTypeId`, JSON.stringify(params))
            return await resp.json() as GetAllMeetingTypesResponseParams
        }

        /**
         * GetAllMeetings retrieves all rows from the meeting
         */
        public async GetAllMeetings(): Promise<GetAllMeetingsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllMeetings`)
            return await resp.json() as GetAllMeetingsResponseParams
        }

        /**
         * GetAllMeetingsByMeetingAttendeeMeetingId retrieves all entries from the meeting that are referenced by a collection of rows in the MeetingAttendee table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllMeetingsByMeetingAttendeeMeetingId(params: GetAllMeetingsByMeetingAttendeeMeetingIdRequestParams): Promise<GetAllMeetingsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllMeetingsByMeetingAttendeeMeetingId`, JSON.stringify(params))
            return await resp.json() as GetAllMeetingsResponseParams
        }

        /**
         * GetAllMeetingsByMeetingCompanyMeetingId retrieves all entries from the meeting that are referenced by a collection of rows in the MeetingCompany table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllMeetingsByMeetingCompanyMeetingId(params: GetAllMeetingsByMeetingCompanyMeetingIdRequestParams): Promise<GetAllMeetingsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllMeetingsByMeetingCompanyMeetingId`, JSON.stringify(params))
            return await resp.json() as GetAllMeetingsResponseParams
        }

        /**
         * GetAllNewsletterSignups retrieves all rows from the newsletter_signup
         */
        public async GetAllNewsletterSignups(): Promise<GetAllNewsletterSignupsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllNewsletterSignups`)
            return await resp.json() as GetAllNewsletterSignupsResponseParams
        }

        /**
         * GetAllOnCallRoles retrieves all rows from the on_call_role
         */
        public async GetAllOnCallRoles(): Promise<GetAllOnCallRolesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOnCallRoles`)
            return await resp.json() as GetAllOnCallRolesResponseParams
        }

        /**
         * GetAllOnCallRolesByOnCallScheduleRoleId retrieves all entries from the on_call_role that are referenced by a collection of rows in the OnCallSchedule table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllOnCallRolesByOnCallScheduleRoleId(params: GetAllOnCallRolesByOnCallScheduleRoleIdRequestParams): Promise<GetAllOnCallRolesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOnCallRolesByOnCallScheduleRoleId`, JSON.stringify(params))
            return await resp.json() as GetAllOnCallRolesResponseParams
        }

        /**
         * GetAllOnCallSchedules retrieves all rows from the on_call_schedule
         */
        public async GetAllOnCallSchedules(): Promise<GetAllOnCallSchedulesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOnCallSchedules`)
            return await resp.json() as GetAllOnCallSchedulesResponseParams
        }

        /**
         * GetAllOpportunities retrieves all rows from the opportunity
         */
        public async GetAllOpportunities(): Promise<GetAllOpportunitiesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOpportunities`)
            return await resp.json() as GetAllOpportunitiesResponseParams
        }

        /**
         * GetAllOpportunitiesByOpportunityProductOpportunityId retrieves all entries from the opportunity that are referenced by a collection of rows in the OpportunityProduct table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllOpportunitiesByOpportunityProductOpportunityId(params: GetAllOpportunitiesByOpportunityProductOpportunityIdRequestParams): Promise<GetAllOpportunitiesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOpportunitiesByOpportunityProductOpportunityId`, JSON.stringify(params))
            return await resp.json() as GetAllOpportunitiesResponseParams
        }

        /**
         * GetAllOpportunityFunnelSteps retrieves all rows from the opportunity_funnel_step
         */
        public async GetAllOpportunityFunnelSteps(): Promise<GetAllOpportunityFunnelStepsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOpportunityFunnelSteps`)
            return await resp.json() as GetAllOpportunityFunnelStepsResponseParams
        }

        /**
         * GetAllOpportunityFunnelStepsByOpportunityFunnelStepId retrieves all entries from the opportunity_funnel_step that are referenced by a collection of rows in the Opportunity table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllOpportunityFunnelStepsByOpportunityFunnelStepId(params: GetAllOpportunityFunnelStepsByOpportunityFunnelStepIdRequestParams): Promise<GetAllOpportunityFunnelStepsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOpportunityFunnelStepsByOpportunityFunnelStepId`, JSON.stringify(params))
            return await resp.json() as GetAllOpportunityFunnelStepsResponseParams
        }

        /**
         * GetAllOpportunityFunnels retrieves all rows from the opportunity_funnel
         */
        public async GetAllOpportunityFunnels(): Promise<GetAllOpportunityFunnelsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOpportunityFunnels`)
            return await resp.json() as GetAllOpportunityFunnelsResponseParams
        }

        /**
         * GetAllOpportunityFunnelsByOpportunityFunnelStepOpportunityFunnelId retrieves all entries from the opportunity_funnel that are referenced by a collection of rows in the OpportunityFunnelStep table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllOpportunityFunnelsByOpportunityFunnelStepOpportunityFunnelId(params: GetAllOpportunityFunnelsByOpportunityFunnelStepOpportunityFunnelIdRequestParams): Promise<GetAllOpportunityFunnelsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOpportunityFunnelsByOpportunityFunnelStepOpportunityFunnelId`, JSON.stringify(params))
            return await resp.json() as GetAllOpportunityFunnelsResponseParams
        }

        /**
         * GetAllOpportunityProducts retrieves all rows from the opportunity_product
         */
        public async GetAllOpportunityProducts(): Promise<GetAllOpportunityProductsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOpportunityProducts`)
            return await resp.json() as GetAllOpportunityProductsResponseParams
        }

        /**
         * GetAllOpportunityTypes retrieves all rows from the opportunity_type
         */
        public async GetAllOpportunityTypes(): Promise<GetAllOpportunityTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOpportunityTypes`)
            return await resp.json() as GetAllOpportunityTypesResponseParams
        }

        /**
         * GetAllOpportunityTypesByOpportunityFunnelOpportunityTypeId retrieves all entries from the opportunity_type that are referenced by a collection of rows in the OpportunityFunnel table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllOpportunityTypesByOpportunityFunnelOpportunityTypeId(params: GetAllOpportunityTypesByOpportunityFunnelOpportunityTypeIdRequestParams): Promise<GetAllOpportunityTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOpportunityTypesByOpportunityFunnelOpportunityTypeId`, JSON.stringify(params))
            return await resp.json() as GetAllOpportunityTypesResponseParams
        }

        /**
         * GetAllOpportunityTypesByOpportunityOpportunityTypeId retrieves all entries from the opportunity_type that are referenced by a collection of rows in the Opportunity table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllOpportunityTypesByOpportunityOpportunityTypeId(params: GetAllOpportunityTypesByOpportunityOpportunityTypeIdRequestParams): Promise<GetAllOpportunityTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOpportunityTypesByOpportunityOpportunityTypeId`, JSON.stringify(params))
            return await resp.json() as GetAllOpportunityTypesResponseParams
        }

        /**
         * GetAllOrganizationDocuments retrieves all rows from the organization_document
         */
        public async GetAllOrganizationDocuments(): Promise<GetAllOrganizationDocumentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllOrganizationDocuments`)
            return await resp.json() as GetAllOrganizationDocumentsResponseParams
        }

        /**
         * GetAllProductCategories retrieves all rows from the product_category
         */
        public async GetAllProductCategories(): Promise<GetAllProductCategoriesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductCategories`)
            return await resp.json() as GetAllProductCategoriesResponseParams
        }

        /**
         * GetAllProductCategoriesByProductProductCategoryId retrieves all entries from the product_category that are referenced by a collection of rows in the Product table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllProductCategoriesByProductProductCategoryId(params: GetAllProductCategoriesByProductProductCategoryIdRequestParams): Promise<GetAllProductCategoriesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductCategoriesByProductProductCategoryId`, JSON.stringify(params))
            return await resp.json() as GetAllProductCategoriesResponseParams
        }

        /**
         * GetAllProductCategoriesByProductSubcategoryParentCategoryId retrieves all entries from the product_category that are referenced by a collection of rows in the ProductSubcategory table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllProductCategoriesByProductSubcategoryParentCategoryId(params: GetAllProductCategoriesByProductSubcategoryParentCategoryIdRequestParams): Promise<GetAllProductCategoriesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductCategoriesByProductSubcategoryParentCategoryId`, JSON.stringify(params))
            return await resp.json() as GetAllProductCategoriesResponseParams
        }

        /**
         * GetAllProductDocuments retrieves all rows from the product_document
         */
        public async GetAllProductDocuments(): Promise<GetAllProductDocumentsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductDocuments`)
            return await resp.json() as GetAllProductDocumentsResponseParams
        }

        /**
         * GetAllProductSubcategories retrieves all rows from the product_subcategory
         */
        public async GetAllProductSubcategories(): Promise<GetAllProductSubcategoriesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductSubcategories`)
            return await resp.json() as GetAllProductSubcategoriesResponseParams
        }

        /**
         * GetAllProductSubcategoriesByProductProductSubcategoryId retrieves all entries from the product_subcategory that are referenced by a collection of rows in the Product table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllProductSubcategoriesByProductProductSubcategoryId(params: GetAllProductSubcategoriesByProductProductSubcategoryIdRequestParams): Promise<GetAllProductSubcategoriesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductSubcategoriesByProductProductSubcategoryId`, JSON.stringify(params))
            return await resp.json() as GetAllProductSubcategoriesResponseParams
        }

        /**
         * GetAllProductUsers retrieves all rows from the product_user
         */
        public async GetAllProductUsers(): Promise<GetAllProductUsersResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductUsers`)
            return await resp.json() as GetAllProductUsersResponseParams
        }

        /**
         * GetAllProducts retrieves all rows from the product
         */
        public async GetAllProducts(): Promise<GetAllProductsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProducts`)
            return await resp.json() as GetAllProductsResponseParams
        }

        /**
         * GetAllProductsByCompanyProductAreaEntryProductId retrieves all entries from the product that are referenced by a collection of rows in the CompanyProductAreaEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllProductsByCompanyProductAreaEntryProductId(params: GetAllProductsByCompanyProductAreaEntryProductIdRequestParams): Promise<GetAllProductsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductsByCompanyProductAreaEntryProductId`, JSON.stringify(params))
            return await resp.json() as GetAllProductsResponseParams
        }

        /**
         * GetAllProductsByOpportunityProductProductId retrieves all entries from the product that are referenced by a collection of rows in the OpportunityProduct table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllProductsByOpportunityProductProductId(params: GetAllProductsByOpportunityProductProductIdRequestParams): Promise<GetAllProductsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductsByOpportunityProductProductId`, JSON.stringify(params))
            return await resp.json() as GetAllProductsResponseParams
        }

        /**
         * GetAllProductsByProductDocumentProductId retrieves all entries from the product that are referenced by a collection of rows in the ProductDocument table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllProductsByProductDocumentProductId(params: GetAllProductsByProductDocumentProductIdRequestParams): Promise<GetAllProductsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductsByProductDocumentProductId`, JSON.stringify(params))
            return await resp.json() as GetAllProductsResponseParams
        }

        /**
         * GetAllProductsByProductUserProductId retrieves all entries from the product that are referenced by a collection of rows in the ProductUser table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllProductsByProductUserProductId(params: GetAllProductsByProductUserProductIdRequestParams): Promise<GetAllProductsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllProductsByProductUserProductId`, JSON.stringify(params))
            return await resp.json() as GetAllProductsResponseParams
        }

        /**
         * GetAllSkrymCompanyRoleAreas retrieves all rows from the skrym_company_role_area
         */
        public async GetAllSkrymCompanyRoleAreas(): Promise<GetAllSkrymCompanyRoleAreasResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSkrymCompanyRoleAreas`)
            return await resp.json() as GetAllSkrymCompanyRoleAreasResponseParams
        }

        /**
         * GetAllSkrymCompanyRoleAreasBySkrymCompanyRoleAreaId retrieves all entries from the skrym_company_role_area that are referenced by a collection of rows in the SkrymCompanyRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllSkrymCompanyRoleAreasBySkrymCompanyRoleAreaId(params: GetAllSkrymCompanyRoleAreasBySkrymCompanyRoleAreaIdRequestParams): Promise<GetAllSkrymCompanyRoleAreasResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSkrymCompanyRoleAreasBySkrymCompanyRoleAreaId`, JSON.stringify(params))
            return await resp.json() as GetAllSkrymCompanyRoleAreasResponseParams
        }

        /**
         * GetAllSkrymCompanyRoles retrieves all rows from the skrym_company_role
         */
        public async GetAllSkrymCompanyRoles(): Promise<GetAllSkrymCompanyRolesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSkrymCompanyRoles`)
            return await resp.json() as GetAllSkrymCompanyRolesResponseParams
        }

        /**
         * GetAllSkrymCompanyRolesBySkrymContactRoleCompanyRoleId retrieves all entries from the skrym_company_role that are referenced by a collection of rows in the SkrymContactRole table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllSkrymCompanyRolesBySkrymContactRoleCompanyRoleId(params: GetAllSkrymCompanyRolesBySkrymContactRoleCompanyRoleIdRequestParams): Promise<GetAllSkrymCompanyRolesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSkrymCompanyRolesBySkrymContactRoleCompanyRoleId`, JSON.stringify(params))
            return await resp.json() as GetAllSkrymCompanyRolesResponseParams
        }

        /**
         * GetAllSkrymContactRoles retrieves all rows from the skrym_contact_role
         */
        public async GetAllSkrymContactRoles(): Promise<GetAllSkrymContactRolesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSkrymContactRoles`)
            return await resp.json() as GetAllSkrymContactRolesResponseParams
        }

        /**
         * GetAllSprintDailyStandupEntries retrieves all rows from the sprint_daily_standup_entry
         */
        public async GetAllSprintDailyStandupEntries(): Promise<GetAllSprintDailyStandupEntriesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintDailyStandupEntries`)
            return await resp.json() as GetAllSprintDailyStandupEntriesResponseParams
        }

        /**
         * GetAllSprintDailyStandups retrieves all rows from the sprint_daily_standup
         */
        public async GetAllSprintDailyStandups(): Promise<GetAllSprintDailyStandupsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintDailyStandups`)
            return await resp.json() as GetAllSprintDailyStandupsResponseParams
        }

        /**
         * GetAllSprintDailyStandupsBySprintDailyStandupEntryStandupId retrieves all entries from the sprint_daily_standup that are referenced by a collection of rows in the SprintDailyStandupEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllSprintDailyStandupsBySprintDailyStandupEntryStandupId(params: GetAllSprintDailyStandupsBySprintDailyStandupEntryStandupIdRequestParams): Promise<GetAllSprintDailyStandupsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintDailyStandupsBySprintDailyStandupEntryStandupId`, JSON.stringify(params))
            return await resp.json() as GetAllSprintDailyStandupsResponseParams
        }

        /**
         * GetAllSprintMessageTypes retrieves all rows from the sprint_message_type
         */
        public async GetAllSprintMessageTypes(): Promise<GetAllSprintMessageTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintMessageTypes`)
            return await resp.json() as GetAllSprintMessageTypesResponseParams
        }

        /**
         * GetAllSprintMessageTypesBySprintMessageMessageTypeId retrieves all entries from the sprint_message_type that are referenced by a collection of rows in the SprintMessage table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllSprintMessageTypesBySprintMessageMessageTypeId(params: GetAllSprintMessageTypesBySprintMessageMessageTypeIdRequestParams): Promise<GetAllSprintMessageTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintMessageTypesBySprintMessageMessageTypeId`, JSON.stringify(params))
            return await resp.json() as GetAllSprintMessageTypesResponseParams
        }

        /**
         * GetAllSprintMessages retrieves all rows from the sprint_message
         */
        public async GetAllSprintMessages(): Promise<GetAllSprintMessagesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintMessages`)
            return await resp.json() as GetAllSprintMessagesResponseParams
        }

        /**
         * GetAllSprintRoleEntries retrieves all rows from the sprint_role_entry
         */
        public async GetAllSprintRoleEntries(): Promise<GetAllSprintRoleEntriesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintRoleEntries`)
            return await resp.json() as GetAllSprintRoleEntriesResponseParams
        }

        /**
         * GetAllSprintRoles retrieves all rows from the sprint_role
         */
        public async GetAllSprintRoles(): Promise<GetAllSprintRolesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintRoles`)
            return await resp.json() as GetAllSprintRolesResponseParams
        }

        /**
         * GetAllSprintRolesBySprintRoleEntrySprintRoleId retrieves all entries from the sprint_role that are referenced by a collection of rows in the SprintRoleEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllSprintRolesBySprintRoleEntrySprintRoleId(params: GetAllSprintRolesBySprintRoleEntrySprintRoleIdRequestParams): Promise<GetAllSprintRolesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintRolesBySprintRoleEntrySprintRoleId`, JSON.stringify(params))
            return await resp.json() as GetAllSprintRolesResponseParams
        }

        /**
         * GetAllSprints retrieves all rows from the sprint
         */
        public async GetAllSprints(): Promise<GetAllSprintsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprints`)
            return await resp.json() as GetAllSprintsResponseParams
        }

        /**
         * GetAllSprintsBySprintDailyStandupSprintId retrieves all entries from the sprint that are referenced by a collection of rows in the SprintDailyStandup table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllSprintsBySprintDailyStandupSprintId(params: GetAllSprintsBySprintDailyStandupSprintIdRequestParams): Promise<GetAllSprintsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintsBySprintDailyStandupSprintId`, JSON.stringify(params))
            return await resp.json() as GetAllSprintsResponseParams
        }

        /**
         * GetAllSprintsBySprintMessageSprintId retrieves all entries from the sprint that are referenced by a collection of rows in the SprintMessage table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllSprintsBySprintMessageSprintId(params: GetAllSprintsBySprintMessageSprintIdRequestParams): Promise<GetAllSprintsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintsBySprintMessageSprintId`, JSON.stringify(params))
            return await resp.json() as GetAllSprintsResponseParams
        }

        /**
         * GetAllSprintsBySprintRoleEntrySprintId retrieves all entries from the sprint that are referenced by a collection of rows in the SprintRoleEntry table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllSprintsBySprintRoleEntrySprintId(params: GetAllSprintsBySprintRoleEntrySprintIdRequestParams): Promise<GetAllSprintsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllSprintsBySprintRoleEntrySprintId`, JSON.stringify(params))
            return await resp.json() as GetAllSprintsResponseParams
        }

        /**
         * GetAllTaskOwners retrieves all rows from the task_owner
         */
        public async GetAllTaskOwners(): Promise<GetAllTaskOwnersResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllTaskOwners`)
            return await resp.json() as GetAllTaskOwnersResponseParams
        }

        /**
         * GetAllTaskStatuses retrieves all rows from the task_status
         */
        public async GetAllTaskStatuses(): Promise<GetAllTaskStatusesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllTaskStatuses`)
            return await resp.json() as GetAllTaskStatusesResponseParams
        }

        /**
         * GetAllTaskStatusesByTaskStatusId retrieves all entries from the task_status that are referenced by a collection of rows in the Task table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllTaskStatusesByTaskStatusId(params: GetAllTaskStatusesByTaskStatusIdRequestParams): Promise<GetAllTaskStatusesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllTaskStatusesByTaskStatusId`, JSON.stringify(params))
            return await resp.json() as GetAllTaskStatusesResponseParams
        }

        /**
         * GetAllTasks retrieves all rows from the task
         */
        public async GetAllTasks(): Promise<GetAllTasksResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllTasks`)
            return await resp.json() as GetAllTasksResponseParams
        }

        /**
         * GetAllTasksByTaskOwnerTaskId retrieves all entries from the task that are referenced by a collection of rows in the TaskOwner table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllTasksByTaskOwnerTaskId(params: GetAllTasksByTaskOwnerTaskIdRequestParams): Promise<GetAllTasksResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllTasksByTaskOwnerTaskId`, JSON.stringify(params))
            return await resp.json() as GetAllTasksResponseParams
        }

        /**
         * GetAllTasksForTaskOwner retrieves all entries from the task that are referenced by a collection of rows in the TaskOwner table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllTasksForTaskOwner(params: GetAllTasksForTaskOwnerRequestParams): Promise<GetAllTasksForTaskOwnerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllTasksForTaskOwner`, JSON.stringify(params))
            return await resp.json() as GetAllTasksForTaskOwnerResponse
        }

        /**
         * GetAllWorkingTimeLocations retrieves all rows from the working_time_location
         */
        public async GetAllWorkingTimeLocations(): Promise<GetAllWorkingTimeLocationsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllWorkingTimeLocations`)
            return await resp.json() as GetAllWorkingTimeLocationsResponseParams
        }

        /**
         * GetAllWorkingTimeLocationsByWorkingTimeLocation retrieves all entries from the working_time_location that are referenced by a collection of rows in the WorkingTime table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllWorkingTimeLocationsByWorkingTimeLocation(params: GetAllWorkingTimeLocationsByWorkingTimeLocationRequestParams): Promise<GetAllWorkingTimeLocationsResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllWorkingTimeLocationsByWorkingTimeLocation`, JSON.stringify(params))
            return await resp.json() as GetAllWorkingTimeLocationsResponseParams
        }

        /**
         * GetAllWorkingTimeTypes retrieves all rows from the working_time_type
         */
        public async GetAllWorkingTimeTypes(): Promise<GetAllWorkingTimeTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllWorkingTimeTypes`)
            return await resp.json() as GetAllWorkingTimeTypesResponseParams
        }

        /**
         * GetAllWorkingTimeTypesByWorkingTimeType retrieves all entries from the working_time_type that are referenced by a collection of rows in the WorkingTime table
         * 
         * Note that the referencingTableIdentifiers expects the primary keys of the table referencing the table we want data from. For these rows, it will then select the matched rows for the referncing column of those rows.
         */
        public async GetAllWorkingTimeTypesByWorkingTimeType(params: GetAllWorkingTimeTypesByWorkingTimeTypeRequestParams): Promise<GetAllWorkingTimeTypesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllWorkingTimeTypesByWorkingTimeType`, JSON.stringify(params))
            return await resp.json() as GetAllWorkingTimeTypesResponseParams
        }

        /**
         * GetAllWorkingTimes retrieves all rows from the working_time
         */
        public async GetAllWorkingTimes(): Promise<GetAllWorkingTimesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetAllWorkingTimes`)
            return await resp.json() as GetAllWorkingTimesResponseParams
        }

        /**
         * GetCallSheetAuditById retrieves all rows from the call_sheet_audit table that match the provided identifier for a row in the call_sheet table
         */
        public async GetCallSheetAuditById(params: GetCallSheetAuditByIdRequestParams): Promise<GetCallSheetAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetAuditById`, JSON.stringify(params))
            return await resp.json() as GetCallSheetAuditResponseParams
        }

        /**
         * GetCallSheetById retrieves all rows from the call_sheet table that match the provided identifier
         */
        public async GetCallSheetById(params: GetCallSheetByIdRequestParams): Promise<GetCallSheetByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetById`, JSON.stringify(params))
            return await resp.json() as GetCallSheetByIdResponseParams
        }

        /**
         * GetCallSheetsByCallerId retrieves all rows from the call_sheet table that match the provided CallerId
         */
        public async GetCallSheetsByCallerId(params: GetCallSheetsByCallerIdRequestParams): Promise<GetCallSheetsByCallerIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetsByCallerId`, JSON.stringify(params))
            return await resp.json() as GetCallSheetsByCallerIdResponseParams
        }

        /**
         * GetCallSheetsByCallingId retrieves all rows from the call_sheet table that match the provided CallingId
         */
        public async GetCallSheetsByCallingId(params: GetCallSheetsByCallingIdRequestParams): Promise<GetCallSheetsByCallingIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetsByCallingId`, JSON.stringify(params))
            return await resp.json() as GetCallSheetsByCallingIdResponseParams
        }

        /**
         * GetCallSheetsByCreatedAt retrieves all rows from the call_sheet table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCallSheetsByCreatedAt(params: GetCallSheetsByCreatedAtRequestParams): Promise<GetCallSheetsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetCallSheetsByCreatedAtResponseParams
        }

        /**
         * GetCallSheetsByCreatedBy retrieves all rows from the call_sheet table that match the provided CreatedBy
         */
        public async GetCallSheetsByCreatedBy(params: GetCallSheetsByCreatedByRequestParams): Promise<GetCallSheetsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetCallSheetsByCreatedByResponseParams
        }

        /**
         * GetCallSheetsByDay retrieves all rows from the call_sheet table that match the provided Day
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCallSheetsByDay(params: GetCallSheetsByDayRequestParams): Promise<GetCallSheetsByDayResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetsByDay`, JSON.stringify(params))
            return await resp.json() as GetCallSheetsByDayResponseParams
        }

        /**
         * GetCallSheetsByIsCompleted retrieves all rows from the call_sheet table that match the provided IsCompleted
         */
        public async GetCallSheetsByIsCompleted(params: GetCallSheetsByIsCompletedRequestParams): Promise<GetCallSheetsByIsCompletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetsByIsCompleted`, JSON.stringify(params))
            return await resp.json() as GetCallSheetsByIsCompletedResponseParams
        }

        /**
         * GetCallSheetsByIsDeleted retrieves all rows from the call_sheet table that match the provided IsDeleted
         */
        public async GetCallSheetsByIsDeleted(params: GetCallSheetsByIsDeletedRequestParams): Promise<GetCallSheetsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetCallSheetsByIsDeletedResponseParams
        }

        /**
         * GetCallSheetsByUpdatedAt retrieves all rows from the call_sheet table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCallSheetsByUpdatedAt(params: GetCallSheetsByUpdatedAtRequestParams): Promise<GetCallSheetsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetCallSheetsByUpdatedAtResponseParams
        }

        /**
         * GetCallSheetsByUpdatedBy retrieves all rows from the call_sheet table that match the provided UpdatedBy
         */
        public async GetCallSheetsByUpdatedBy(params: GetCallSheetsByUpdatedByRequestParams): Promise<GetCallSheetsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCallSheetsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetCallSheetsByUpdatedByResponseParams
        }

        /**
         * GetChannelAuditById retrieves all rows from the channel_audit table that match the provided identifier for a row in the channel table
         */
        public async GetChannelAuditById(params: GetChannelAuditByIdRequestParams): Promise<GetChannelAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetChannelAuditById`, JSON.stringify(params))
            return await resp.json() as GetChannelAuditResponseParams
        }

        /**
         * GetChannelById retrieves all rows from the channel table that match the provided identifier
         */
        public async GetChannelById(params: GetChannelByIdRequestParams): Promise<GetChannelByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetChannelById`, JSON.stringify(params))
            return await resp.json() as GetChannelByIdResponseParams
        }

        /**
         * GetCompaniesByIsDeleted retrieves all rows from the company table that match the provided IsDeleted
         */
        public async GetCompaniesByIsDeleted(params: GetCompaniesByIsDeletedRequestParams): Promise<GetCompaniesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompaniesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetCompaniesByIsDeletedResponseParams
        }

        /**
         * GetCompaniesByName retrieves all rows from the company table that match the provided Name
         */
        public async GetCompaniesByName(params: GetCompaniesByNameRequestParams): Promise<GetCompaniesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompaniesByName`, JSON.stringify(params))
            return await resp.json() as GetCompaniesByNameResponseParams
        }

        /**
         * GetCompaniesByTypeId retrieves all rows from the company table that match the provided TypeId
         */
        public async GetCompaniesByTypeId(params: GetCompaniesByTypeIdRequestParams): Promise<GetCompaniesByTypeIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompaniesByTypeId`, JSON.stringify(params))
            return await resp.json() as GetCompaniesByTypeIdResponseParams
        }

        /**
         * GetCompanyAuditById retrieves all rows from the company_audit table that match the provided identifier for a row in the company table
         */
        public async GetCompanyAuditById(params: GetCompanyAuditByIdRequestParams): Promise<GetCompanyAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyAuditById`, JSON.stringify(params))
            return await resp.json() as GetCompanyAuditResponseParams
        }

        /**
         * GetCompanyBillingInfoAuditById retrieves all rows from the company_billing_info_audit table that match the provided identifier for a row in the company_billing_info table
         */
        public async GetCompanyBillingInfoAuditById(params: GetCompanyBillingInfoAuditByIdRequestParams): Promise<GetCompanyBillingInfoAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfoAuditById`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfoAuditResponseParams
        }

        /**
         * GetCompanyBillingInfoById retrieves all rows from the company_billing_info table that match the provided identifier
         */
        public async GetCompanyBillingInfoById(params: GetCompanyBillingInfoByIdRequestParams): Promise<GetCompanyBillingInfoByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfoById`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfoByIdResponseParams
        }

        /**
         * GetCompanyBillingInfosByCompanyId retrieves all rows from the company_billing_info table that match the provided CompanyId
         */
        public async GetCompanyBillingInfosByCompanyId(params: GetCompanyBillingInfosByCompanyIdRequestParams): Promise<GetCompanyBillingInfosByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfosByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfosByCompanyIdResponseParams
        }

        /**
         * GetCompanyBillingInfosByCompanyInvoiceEmail retrieves all rows from the company_billing_info table that match the provided CompanyInvoiceEmail
         */
        public async GetCompanyBillingInfosByCompanyInvoiceEmail(params: GetCompanyBillingInfosByCompanyInvoiceEmailRequestParams): Promise<GetCompanyBillingInfosByCompanyInvoiceEmailResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfosByCompanyInvoiceEmail`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfosByCompanyInvoiceEmailResponseParams
        }

        /**
         * GetCompanyBillingInfosByCompanyRegisteredLocation retrieves all rows from the company_billing_info table that match the provided CompanyRegisteredLocation
         */
        public async GetCompanyBillingInfosByCompanyRegisteredLocation(params: GetCompanyBillingInfosByCompanyRegisteredLocationRequestParams): Promise<GetCompanyBillingInfosByCompanyRegisteredLocationResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfosByCompanyRegisteredLocation`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfosByCompanyRegisteredLocationResponseParams
        }

        /**
         * GetCompanyBillingInfosByCompanyRegistrationNo retrieves all rows from the company_billing_info table that match the provided CompanyRegistrationNo
         */
        public async GetCompanyBillingInfosByCompanyRegistrationNo(params: GetCompanyBillingInfosByCompanyRegistrationNoRequestParams): Promise<GetCompanyBillingInfosByCompanyRegistrationNoResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfosByCompanyRegistrationNo`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfosByCompanyRegistrationNoResponseParams
        }

        /**
         * GetCompanyBillingInfosByCreatedAt retrieves all rows from the company_billing_info table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyBillingInfosByCreatedAt(params: GetCompanyBillingInfosByCreatedAtRequestParams): Promise<GetCompanyBillingInfosByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfosByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfosByCreatedAtResponseParams
        }

        /**
         * GetCompanyBillingInfosByCreatedBy retrieves all rows from the company_billing_info table that match the provided CreatedBy
         */
        public async GetCompanyBillingInfosByCreatedBy(params: GetCompanyBillingInfosByCreatedByRequestParams): Promise<GetCompanyBillingInfosByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfosByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfosByCreatedByResponseParams
        }

        /**
         * GetCompanyBillingInfosByIsDeleted retrieves all rows from the company_billing_info table that match the provided IsDeleted
         */
        public async GetCompanyBillingInfosByIsDeleted(params: GetCompanyBillingInfosByIsDeletedRequestParams): Promise<GetCompanyBillingInfosByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfosByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfosByIsDeletedResponseParams
        }

        /**
         * GetCompanyBillingInfosByUpdatedAt retrieves all rows from the company_billing_info table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyBillingInfosByUpdatedAt(params: GetCompanyBillingInfosByUpdatedAtRequestParams): Promise<GetCompanyBillingInfosByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfosByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfosByUpdatedAtResponseParams
        }

        /**
         * GetCompanyBillingInfosByUpdatedBy retrieves all rows from the company_billing_info table that match the provided UpdatedBy
         */
        public async GetCompanyBillingInfosByUpdatedBy(params: GetCompanyBillingInfosByUpdatedByRequestParams): Promise<GetCompanyBillingInfosByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyBillingInfosByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanyBillingInfosByUpdatedByResponseParams
        }

        /**
         * GetCompanyById retrieves all rows from the company table that match the provided identifier
         */
        public async GetCompanyById(params: GetCompanyByIdRequestParams): Promise<GetCompanyByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyById`, JSON.stringify(params))
            return await resp.json() as GetCompanyByIdResponseParams
        }

        /**
         * GetCompanyInvoiceAuditById retrieves all rows from the company_invoice_audit table that match the provided identifier for a row in the company_invoice table
         */
        public async GetCompanyInvoiceAuditById(params: GetCompanyInvoiceAuditByIdRequestParams): Promise<GetCompanyInvoiceAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoiceAuditById`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoiceAuditResponseParams
        }

        /**
         * GetCompanyInvoiceById retrieves all rows from the company_invoice table that match the provided identifier
         */
        public async GetCompanyInvoiceById(params: GetCompanyInvoiceByIdRequestParams): Promise<GetCompanyInvoiceByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoiceById`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoiceByIdResponseParams
        }

        /**
         * GetCompanyInvoicesByAmountSek retrieves all rows from the company_invoice table that match the provided float query
         * 
         * Supported queries include:
         * - Less
         * - Greater
         * - Between
         */
        public async GetCompanyInvoicesByAmountSek(params: GetCompanyInvoicesByAmountSekRequestParams): Promise<GetCompanyInvoicesByAmountSekResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByAmountSek`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByAmountSekResponseParams
        }

        /**
         * GetCompanyInvoicesByCompanyId retrieves all rows from the company_invoice table that match the provided CompanyId
         */
        public async GetCompanyInvoicesByCompanyId(params: GetCompanyInvoicesByCompanyIdRequestParams): Promise<GetCompanyInvoicesByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByCompanyIdResponseParams
        }

        /**
         * GetCompanyInvoicesByCreatedAt retrieves all rows from the company_invoice table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyInvoicesByCreatedAt(params: GetCompanyInvoicesByCreatedAtRequestParams): Promise<GetCompanyInvoicesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByCreatedAtResponseParams
        }

        /**
         * GetCompanyInvoicesByCreatedBy retrieves all rows from the company_invoice table that match the provided CreatedBy
         */
        public async GetCompanyInvoicesByCreatedBy(params: GetCompanyInvoicesByCreatedByRequestParams): Promise<GetCompanyInvoicesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByCreatedByResponseParams
        }

        /**
         * GetCompanyInvoicesByDueDate retrieves all rows from the company_invoice table that match the provided DueDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyInvoicesByDueDate(params: GetCompanyInvoicesByDueDateRequestParams): Promise<GetCompanyInvoicesByDueDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByDueDate`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByDueDateResponseParams
        }

        /**
         * GetCompanyInvoicesByInvoicePeriodEnd retrieves all rows from the company_invoice table that match the provided InvoicePeriodEnd
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyInvoicesByInvoicePeriodEnd(params: GetCompanyInvoicesByInvoicePeriodEndRequestParams): Promise<GetCompanyInvoicesByInvoicePeriodEndResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByInvoicePeriodEnd`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByInvoicePeriodEndResponseParams
        }

        /**
         * GetCompanyInvoicesByInvoicePeriodStart retrieves all rows from the company_invoice table that match the provided InvoicePeriodStart
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyInvoicesByInvoicePeriodStart(params: GetCompanyInvoicesByInvoicePeriodStartRequestParams): Promise<GetCompanyInvoicesByInvoicePeriodStartResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByInvoicePeriodStart`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByInvoicePeriodStartResponseParams
        }

        /**
         * GetCompanyInvoicesByInvoiceUrl retrieves all rows from the company_invoice table that match the provided InvoiceUrl
         */
        public async GetCompanyInvoicesByInvoiceUrl(params: GetCompanyInvoicesByInvoiceUrlRequestParams): Promise<GetCompanyInvoicesByInvoiceUrlResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByInvoiceUrl`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByInvoiceUrlResponseParams
        }

        /**
         * GetCompanyInvoicesByIsDeleted retrieves all rows from the company_invoice table that match the provided IsDeleted
         */
        public async GetCompanyInvoicesByIsDeleted(params: GetCompanyInvoicesByIsDeletedRequestParams): Promise<GetCompanyInvoicesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByIsDeletedResponseParams
        }

        /**
         * GetCompanyInvoicesByIsPaid retrieves all rows from the company_invoice table that match the provided IsPaid
         */
        public async GetCompanyInvoicesByIsPaid(params: GetCompanyInvoicesByIsPaidRequestParams): Promise<GetCompanyInvoicesByIsPaidResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByIsPaid`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByIsPaidResponseParams
        }

        /**
         * GetCompanyInvoicesByName retrieves all rows from the company_invoice table that match the provided Name
         */
        public async GetCompanyInvoicesByName(params: GetCompanyInvoicesByNameRequestParams): Promise<GetCompanyInvoicesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByName`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByNameResponseParams
        }

        /**
         * GetCompanyInvoicesBySentDate retrieves all rows from the company_invoice table that match the provided SentDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyInvoicesBySentDate(params: GetCompanyInvoicesBySentDateRequestParams): Promise<GetCompanyInvoicesBySentDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesBySentDate`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesBySentDateResponseParams
        }

        /**
         * GetCompanyInvoicesByUpdatedAt retrieves all rows from the company_invoice table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyInvoicesByUpdatedAt(params: GetCompanyInvoicesByUpdatedAtRequestParams): Promise<GetCompanyInvoicesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByUpdatedAtResponseParams
        }

        /**
         * GetCompanyInvoicesByUpdatedBy retrieves all rows from the company_invoice table that match the provided UpdatedBy
         */
        public async GetCompanyInvoicesByUpdatedBy(params: GetCompanyInvoicesByUpdatedByRequestParams): Promise<GetCompanyInvoicesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyInvoicesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanyInvoicesByUpdatedByResponseParams
        }

        /**
         * GetCompanyNoteAuditById retrieves all rows from the company_note_audit table that match the provided identifier for a row in the company_note table
         */
        public async GetCompanyNoteAuditById(params: GetCompanyNoteAuditByIdRequestParams): Promise<GetCompanyNoteAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyNoteAuditById`, JSON.stringify(params))
            return await resp.json() as GetCompanyNoteAuditResponseParams
        }

        /**
         * GetCompanyNoteById retrieves all rows from the company_note table that match the provided identifier
         */
        public async GetCompanyNoteById(params: GetCompanyNoteByIdRequestParams): Promise<GetCompanyNoteByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyNoteById`, JSON.stringify(params))
            return await resp.json() as GetCompanyNoteByIdResponseParams
        }

        /**
         * GetCompanyNotesByCompanyId retrieves all rows from the company_note table that match the provided CompanyId
         */
        public async GetCompanyNotesByCompanyId(params: GetCompanyNotesByCompanyIdRequestParams): Promise<GetCompanyNotesByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyNotesByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetCompanyNotesByCompanyIdResponseParams
        }

        /**
         * GetCompanyNotesByCreatedAt retrieves all rows from the company_note table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyNotesByCreatedAt(params: GetCompanyNotesByCreatedAtRequestParams): Promise<GetCompanyNotesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyNotesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanyNotesByCreatedAtResponseParams
        }

        /**
         * GetCompanyNotesByCreatedBy retrieves all rows from the company_note table that match the provided CreatedBy
         */
        public async GetCompanyNotesByCreatedBy(params: GetCompanyNotesByCreatedByRequestParams): Promise<GetCompanyNotesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyNotesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanyNotesByCreatedByResponseParams
        }

        /**
         * GetCompanyNotesByIsDeleted retrieves all rows from the company_note table that match the provided IsDeleted
         */
        public async GetCompanyNotesByIsDeleted(params: GetCompanyNotesByIsDeletedRequestParams): Promise<GetCompanyNotesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyNotesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetCompanyNotesByIsDeletedResponseParams
        }

        /**
         * GetCompanyNotesByMessage retrieves all rows from the company_note table that match the provided Message
         */
        public async GetCompanyNotesByMessage(params: GetCompanyNotesByMessageRequestParams): Promise<GetCompanyNotesByMessageResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyNotesByMessage`, JSON.stringify(params))
            return await resp.json() as GetCompanyNotesByMessageResponseParams
        }

        /**
         * GetCompanyNotesByTitle retrieves all rows from the company_note table that match the provided Title
         */
        public async GetCompanyNotesByTitle(params: GetCompanyNotesByTitleRequestParams): Promise<GetCompanyNotesByTitleResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyNotesByTitle`, JSON.stringify(params))
            return await resp.json() as GetCompanyNotesByTitleResponseParams
        }

        /**
         * GetCompanyNotesByUpdatedAt retrieves all rows from the company_note table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyNotesByUpdatedAt(params: GetCompanyNotesByUpdatedAtRequestParams): Promise<GetCompanyNotesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyNotesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanyNotesByUpdatedAtResponseParams
        }

        /**
         * GetCompanyNotesByUpdatedBy retrieves all rows from the company_note table that match the provided UpdatedBy
         */
        public async GetCompanyNotesByUpdatedBy(params: GetCompanyNotesByUpdatedByRequestParams): Promise<GetCompanyNotesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyNotesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanyNotesByUpdatedByResponseParams
        }

        /**
         * GetCompanyById retrieves all rows from the company table that match the provided identifier ll
         */
        public async GetCompanyPageDataById(params: GetCompanyPageDataByIdRequestParams): Promise<GetCompanyPageDataByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyPageDataById`, JSON.stringify(params))
            return await resp.json() as GetCompanyPageDataByIdResponseParams
        }

        /**
         * GetCompanyById retrieves all rows from the company table that match the provided identifier ll
         * 
         * This custom version also gets meeting attendees for every meeting and assigns them to the meeting struct.
         */
        public async GetCompanyPageDataByIdCustom(params: GetCompanyPageDataByIdRequest): Promise<GetCompanyPageDataByIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyPageDataByIdCustom`, JSON.stringify(params))
            return await resp.json() as GetCompanyPageDataByIdResponse
        }

        /**
         * GetCompanyProductAreaAuditById retrieves all rows from the company_product_area_audit table that match the provided identifier for a row in the company_product_area table
         */
        public async GetCompanyProductAreaAuditById(params: GetCompanyProductAreaAuditByIdRequestParams): Promise<GetCompanyProductAreaAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaAuditById`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaAuditResponseParams
        }

        /**
         * GetCompanyProductAreaById retrieves all rows from the company_product_area table that match the provided identifier
         */
        public async GetCompanyProductAreaById(params: GetCompanyProductAreaByIdRequestParams): Promise<GetCompanyProductAreaByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaById`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaByIdResponseParams
        }

        /**
         * GetCompanyProductAreaEntriesByCompanyAreaId retrieves all rows from the company_product_area_entry table that match the provided CompanyAreaId
         */
        public async GetCompanyProductAreaEntriesByCompanyAreaId(params: GetCompanyProductAreaEntriesByCompanyAreaIdRequestParams): Promise<GetCompanyProductAreaEntriesByCompanyAreaIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaEntriesByCompanyAreaId`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaEntriesByCompanyAreaIdResponseParams
        }

        /**
         * GetCompanyProductAreaEntriesByCreatedAt retrieves all rows from the company_product_area_entry table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyProductAreaEntriesByCreatedAt(params: GetCompanyProductAreaEntriesByCreatedAtRequestParams): Promise<GetCompanyProductAreaEntriesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaEntriesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaEntriesByCreatedAtResponseParams
        }

        /**
         * GetCompanyProductAreaEntriesByCreatedBy retrieves all rows from the company_product_area_entry table that match the provided CreatedBy
         */
        public async GetCompanyProductAreaEntriesByCreatedBy(params: GetCompanyProductAreaEntriesByCreatedByRequestParams): Promise<GetCompanyProductAreaEntriesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaEntriesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaEntriesByCreatedByResponseParams
        }

        /**
         * GetCompanyProductAreaEntriesByIsDeleted retrieves all rows from the company_product_area_entry table that match the provided IsDeleted
         */
        public async GetCompanyProductAreaEntriesByIsDeleted(params: GetCompanyProductAreaEntriesByIsDeletedRequestParams): Promise<GetCompanyProductAreaEntriesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaEntriesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaEntriesByIsDeletedResponseParams
        }

        /**
         * GetCompanyProductAreaEntriesByProductId retrieves all rows from the company_product_area_entry table that match the provided ProductId
         */
        public async GetCompanyProductAreaEntriesByProductId(params: GetCompanyProductAreaEntriesByProductIdRequestParams): Promise<GetCompanyProductAreaEntriesByProductIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaEntriesByProductId`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaEntriesByProductIdResponseParams
        }

        /**
         * GetCompanyProductAreaEntriesByUpdatedAt retrieves all rows from the company_product_area_entry table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyProductAreaEntriesByUpdatedAt(params: GetCompanyProductAreaEntriesByUpdatedAtRequestParams): Promise<GetCompanyProductAreaEntriesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaEntriesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaEntriesByUpdatedAtResponseParams
        }

        /**
         * GetCompanyProductAreaEntriesByUpdatedBy retrieves all rows from the company_product_area_entry table that match the provided UpdatedBy
         */
        public async GetCompanyProductAreaEntriesByUpdatedBy(params: GetCompanyProductAreaEntriesByUpdatedByRequestParams): Promise<GetCompanyProductAreaEntriesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaEntriesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaEntriesByUpdatedByResponseParams
        }

        /**
         * GetCompanyProductAreaEntryAuditById retrieves all rows from the company_product_area_entry_audit table that match the provided identifier for a row in the company_product_area_entry table
         */
        public async GetCompanyProductAreaEntryAuditById(params: GetCompanyProductAreaEntryAuditByIdRequestParams): Promise<GetCompanyProductAreaEntryAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaEntryAuditById`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaEntryAuditResponseParams
        }

        /**
         * GetCompanyProductAreaEntryById retrieves all rows from the company_product_area_entry table that match the provided identifier
         */
        public async GetCompanyProductAreaEntryById(params: GetCompanyProductAreaEntryByIdRequestParams): Promise<GetCompanyProductAreaEntryByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreaEntryById`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreaEntryByIdResponseParams
        }

        /**
         * GetCompanyProductAreasByCompanyId retrieves all rows from the company_product_area table that match the provided CompanyId
         */
        public async GetCompanyProductAreasByCompanyId(params: GetCompanyProductAreasByCompanyIdRequestParams): Promise<GetCompanyProductAreasByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreasByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreasByCompanyIdResponseParams
        }

        /**
         * GetCompanyProductAreasByCreatedAt retrieves all rows from the company_product_area table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyProductAreasByCreatedAt(params: GetCompanyProductAreasByCreatedAtRequestParams): Promise<GetCompanyProductAreasByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreasByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreasByCreatedAtResponseParams
        }

        /**
         * GetCompanyProductAreasByCreatedBy retrieves all rows from the company_product_area table that match the provided CreatedBy
         */
        public async GetCompanyProductAreasByCreatedBy(params: GetCompanyProductAreasByCreatedByRequestParams): Promise<GetCompanyProductAreasByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreasByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreasByCreatedByResponseParams
        }

        /**
         * GetCompanyProductAreasByIsDeleted retrieves all rows from the company_product_area table that match the provided IsDeleted
         */
        public async GetCompanyProductAreasByIsDeleted(params: GetCompanyProductAreasByIsDeletedRequestParams): Promise<GetCompanyProductAreasByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreasByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreasByIsDeletedResponseParams
        }

        /**
         * GetCompanyProductAreasByName retrieves all rows from the company_product_area table that match the provided Name
         */
        public async GetCompanyProductAreasByName(params: GetCompanyProductAreasByNameRequestParams): Promise<GetCompanyProductAreasByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreasByName`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreasByNameResponseParams
        }

        /**
         * GetCompanyProductAreasByUpdatedAt retrieves all rows from the company_product_area table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanyProductAreasByUpdatedAt(params: GetCompanyProductAreasByUpdatedAtRequestParams): Promise<GetCompanyProductAreasByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreasByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreasByUpdatedAtResponseParams
        }

        /**
         * GetCompanyProductAreasByUpdatedBy retrieves all rows from the company_product_area table that match the provided UpdatedBy
         */
        public async GetCompanyProductAreasByUpdatedBy(params: GetCompanyProductAreasByUpdatedByRequestParams): Promise<GetCompanyProductAreasByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyProductAreasByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanyProductAreasByUpdatedByResponseParams
        }

        /**
         * GetCompanySegmentAuditById retrieves all rows from the company_segment_audit table that match the provided identifier for a row in the company_segment table
         */
        public async GetCompanySegmentAuditById(params: GetCompanySegmentAuditByIdRequestParams): Promise<GetCompanySegmentAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentAuditById`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentAuditResponseParams
        }

        /**
         * GetCompanySegmentById retrieves all rows from the company_segment table that match the provided identifier
         */
        public async GetCompanySegmentById(params: GetCompanySegmentByIdRequestParams): Promise<GetCompanySegmentByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentById`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentByIdResponseParams
        }

        /**
         * GetCompanySegmentEntriesByCompanyId retrieves all rows from the company_segment_entry table that match the provided CompanyId
         */
        public async GetCompanySegmentEntriesByCompanyId(params: GetCompanySegmentEntriesByCompanyIdRequestParams): Promise<GetCompanySegmentEntriesByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentEntriesByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentEntriesByCompanyIdResponseParams
        }

        /**
         * GetCompanySegmentEntriesByCompanySegmentId retrieves all rows from the company_segment_entry table that match the provided CompanySegmentId
         */
        public async GetCompanySegmentEntriesByCompanySegmentId(params: GetCompanySegmentEntriesByCompanySegmentIdRequestParams): Promise<GetCompanySegmentEntriesByCompanySegmentIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentEntriesByCompanySegmentId`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentEntriesByCompanySegmentIdResponseParams
        }

        /**
         * GetCompanySegmentEntriesByCreatedAt retrieves all rows from the company_segment_entry table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanySegmentEntriesByCreatedAt(params: GetCompanySegmentEntriesByCreatedAtRequestParams): Promise<GetCompanySegmentEntriesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentEntriesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentEntriesByCreatedAtResponseParams
        }

        /**
         * GetCompanySegmentEntriesByCreatedBy retrieves all rows from the company_segment_entry table that match the provided CreatedBy
         */
        public async GetCompanySegmentEntriesByCreatedBy(params: GetCompanySegmentEntriesByCreatedByRequestParams): Promise<GetCompanySegmentEntriesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentEntriesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentEntriesByCreatedByResponseParams
        }

        /**
         * GetCompanySegmentEntriesByIsDeleted retrieves all rows from the company_segment_entry table that match the provided IsDeleted
         */
        public async GetCompanySegmentEntriesByIsDeleted(params: GetCompanySegmentEntriesByIsDeletedRequestParams): Promise<GetCompanySegmentEntriesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentEntriesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentEntriesByIsDeletedResponseParams
        }

        /**
         * GetCompanySegmentEntriesByUpdatedAt retrieves all rows from the company_segment_entry table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetCompanySegmentEntriesByUpdatedAt(params: GetCompanySegmentEntriesByUpdatedAtRequestParams): Promise<GetCompanySegmentEntriesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentEntriesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentEntriesByUpdatedAtResponseParams
        }

        /**
         * GetCompanySegmentEntriesByUpdatedBy retrieves all rows from the company_segment_entry table that match the provided UpdatedBy
         */
        public async GetCompanySegmentEntriesByUpdatedBy(params: GetCompanySegmentEntriesByUpdatedByRequestParams): Promise<GetCompanySegmentEntriesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentEntriesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentEntriesByUpdatedByResponseParams
        }

        /**
         * GetCompanySegmentEntryAuditById retrieves all rows from the company_segment_entry_audit table that match the provided identifier for a row in the company_segment_entry table
         */
        public async GetCompanySegmentEntryAuditById(params: GetCompanySegmentEntryAuditByIdRequestParams): Promise<GetCompanySegmentEntryAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentEntryAuditById`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentEntryAuditResponseParams
        }

        /**
         * GetCompanySegmentEntryById retrieves all rows from the company_segment_entry table that match the provided identifier
         */
        public async GetCompanySegmentEntryById(params: GetCompanySegmentEntryByIdRequestParams): Promise<GetCompanySegmentEntryByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentEntryById`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentEntryByIdResponseParams
        }

        /**
         * GetCompanySegmentsByIsDeleted retrieves all rows from the company_segment table that match the provided IsDeleted
         */
        public async GetCompanySegmentsByIsDeleted(params: GetCompanySegmentsByIsDeletedRequestParams): Promise<GetCompanySegmentsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentsByIsDeletedResponseParams
        }

        /**
         * GetCompanySegmentsByName retrieves all rows from the company_segment table that match the provided Name
         */
        public async GetCompanySegmentsByName(params: GetCompanySegmentsByNameRequestParams): Promise<GetCompanySegmentsByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentsByName`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentsByNameResponseParams
        }

        /**
         * GetCompanySegmentsByTypeId retrieves all rows from the company_segment table that match the provided TypeId
         */
        public async GetCompanySegmentsByTypeId(params: GetCompanySegmentsByTypeIdRequestParams): Promise<GetCompanySegmentsByTypeIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanySegmentsByTypeId`, JSON.stringify(params))
            return await resp.json() as GetCompanySegmentsByTypeIdResponseParams
        }

        /**
         * GetCompanyTypeAuditById retrieves all rows from the company_type_audit table that match the provided identifier for a row in the company_type table
         */
        public async GetCompanyTypeAuditById(params: GetCompanyTypeAuditByIdRequestParams): Promise<GetCompanyTypeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyTypeAuditById`, JSON.stringify(params))
            return await resp.json() as GetCompanyTypeAuditResponseParams
        }

        /**
         * GetCompanyTypeById retrieves all rows from the company_type table that match the provided identifier
         */
        public async GetCompanyTypeById(params: GetCompanyTypeByIdRequestParams): Promise<GetCompanyTypeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyTypeById`, JSON.stringify(params))
            return await resp.json() as GetCompanyTypeByIdResponseParams
        }

        /**
         * GetCompanyTypesByIsDeleted retrieves all rows from the company_type table that match the provided IsDeleted
         */
        public async GetCompanyTypesByIsDeleted(params: GetCompanyTypesByIsDeletedRequestParams): Promise<GetCompanyTypesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyTypesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetCompanyTypesByIsDeletedResponseParams
        }

        /**
         * GetCompanyTypesByName retrieves all rows from the company_type table that match the provided Name
         */
        public async GetCompanyTypesByName(params: GetCompanyTypesByNameRequestParams): Promise<GetCompanyTypesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetCompanyTypesByName`, JSON.stringify(params))
            return await resp.json() as GetCompanyTypesByNameResponseParams
        }

        /**
         * GetConnectionAuditById retrieves all rows from the connection_audit table that match the provided identifier for a row in the connection table
         */
        public async GetConnectionAuditById(params: GetConnectionAuditByIdRequestParams): Promise<GetConnectionAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionAuditById`, JSON.stringify(params))
            return await resp.json() as GetConnectionAuditResponseParams
        }

        /**
         * GetConnectionById retrieves all rows from the connection table that match the provided identifier
         */
        public async GetConnectionById(params: GetConnectionByIdRequestParams): Promise<GetConnectionByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionById`, JSON.stringify(params))
            return await resp.json() as GetConnectionByIdResponseParams
        }

        /**
         * GetConnectionsByCreatedAt retrieves all rows from the connection table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetConnectionsByCreatedAt(params: GetConnectionsByCreatedAtRequestParams): Promise<GetConnectionsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetConnectionsByCreatedAtResponseParams
        }

        /**
         * GetConnectionsByIsDeleted retrieves all rows from the connection table that match the provided IsDeleted
         */
        public async GetConnectionsByIsDeleted(params: GetConnectionsByIsDeletedRequestParams): Promise<GetConnectionsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetConnectionsByIsDeletedResponseParams
        }

        /**
         * GetConnectionsByReceivingCompanyId retrieves all rows from the connection table that match the provided ReceivingCompanyId
         */
        public async GetConnectionsByReceivingCompanyId(params: GetConnectionsByReceivingCompanyIdRequestParams): Promise<GetConnectionsByReceivingCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionsByReceivingCompanyId`, JSON.stringify(params))
            return await resp.json() as GetConnectionsByReceivingCompanyIdResponseParams
        }

        /**
         * GetConnectionsBySourceChannelId retrieves all rows from the connection table that match the provided SourceChannelId
         */
        public async GetConnectionsBySourceChannelId(params: GetConnectionsBySourceChannelIdRequestParams): Promise<GetConnectionsBySourceChannelIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionsBySourceChannelId`, JSON.stringify(params))
            return await resp.json() as GetConnectionsBySourceChannelIdResponseParams
        }

        /**
         * GetConnectionsBySourceCompanyId retrieves all rows from the connection table that match the provided SourceCompanyId
         */
        public async GetConnectionsBySourceCompanyId(params: GetConnectionsBySourceCompanyIdRequestParams): Promise<GetConnectionsBySourceCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionsBySourceCompanyId`, JSON.stringify(params))
            return await resp.json() as GetConnectionsBySourceCompanyIdResponseParams
        }

        /**
         * GetConnectionsBySourceContactId retrieves all rows from the connection table that match the provided SourceContactId
         */
        public async GetConnectionsBySourceContactId(params: GetConnectionsBySourceContactIdRequestParams): Promise<GetConnectionsBySourceContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionsBySourceContactId`, JSON.stringify(params))
            return await resp.json() as GetConnectionsBySourceContactIdResponseParams
        }

        /**
         * GetConnectionsBySourceEventId retrieves all rows from the connection table that match the provided SourceEventId
         */
        public async GetConnectionsBySourceEventId(params: GetConnectionsBySourceEventIdRequestParams): Promise<GetConnectionsBySourceEventIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionsBySourceEventId`, JSON.stringify(params))
            return await resp.json() as GetConnectionsBySourceEventIdResponseParams
        }

        /**
         * GetConnectionsByTargetCompanyId retrieves all rows from the connection table that match the provided TargetCompanyId
         */
        public async GetConnectionsByTargetCompanyId(params: GetConnectionsByTargetCompanyIdRequestParams): Promise<GetConnectionsByTargetCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionsByTargetCompanyId`, JSON.stringify(params))
            return await resp.json() as GetConnectionsByTargetCompanyIdResponseParams
        }

        /**
         * GetConnectionsByTargetContactId retrieves all rows from the connection table that match the provided TargetContactId
         */
        public async GetConnectionsByTargetContactId(params: GetConnectionsByTargetContactIdRequestParams): Promise<GetConnectionsByTargetContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionsByTargetContactId`, JSON.stringify(params))
            return await resp.json() as GetConnectionsByTargetContactIdResponseParams
        }

        /**
         * GetConnectionsByUpdatedAt retrieves all rows from the connection table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetConnectionsByUpdatedAt(params: GetConnectionsByUpdatedAtRequestParams): Promise<GetConnectionsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetConnectionsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetConnectionsByUpdatedAtResponseParams
        }

        /**
         * GetContactAuditById retrieves all rows from the contact_audit table that match the provided identifier for a row in the contact table
         */
        public async GetContactAuditById(params: GetContactAuditByIdRequestParams): Promise<GetContactAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactAuditById`, JSON.stringify(params))
            return await resp.json() as GetContactAuditResponseParams
        }

        /**
         * GetContactById retrieves all rows from the contact table that match the provided identifier
         */
        public async GetContactById(params: GetContactByIdRequestParams): Promise<GetContactByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactById`, JSON.stringify(params))
            return await resp.json() as GetContactByIdResponseParams
        }

        /**
         * GetContactDetailAuditById retrieves all rows from the contact_detail_audit table that match the provided identifier for a row in the contact_detail table
         */
        public async GetContactDetailAuditById(params: GetContactDetailAuditByIdRequestParams): Promise<GetContactDetailAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailAuditById`, JSON.stringify(params))
            return await resp.json() as GetContactDetailAuditResponseParams
        }

        /**
         * GetContactDetailById retrieves all rows from the contact_detail table that match the provided identifier
         */
        public async GetContactDetailById(params: GetContactDetailByIdRequestParams): Promise<GetContactDetailByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailById`, JSON.stringify(params))
            return await resp.json() as GetContactDetailByIdResponseParams
        }

        /**
         * GetContactDetailTypeAuditById retrieves all rows from the contact_detail_type_audit table that match the provided identifier for a row in the contact_detail_type table
         */
        public async GetContactDetailTypeAuditById(params: GetContactDetailTypeAuditByIdRequestParams): Promise<GetContactDetailTypeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailTypeAuditById`, JSON.stringify(params))
            return await resp.json() as GetContactDetailTypeAuditResponseParams
        }

        /**
         * GetContactDetailTypeById retrieves all rows from the contact_detail_type table that match the provided identifier
         */
        public async GetContactDetailTypeById(params: GetContactDetailTypeByIdRequestParams): Promise<GetContactDetailTypeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailTypeById`, JSON.stringify(params))
            return await resp.json() as GetContactDetailTypeByIdResponseParams
        }

        /**
         * GetContactDetailTypesByCreatedAt retrieves all rows from the contact_detail_type table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactDetailTypesByCreatedAt(params: GetContactDetailTypesByCreatedAtRequestParams): Promise<GetContactDetailTypesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailTypesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactDetailTypesByCreatedAtResponseParams
        }

        /**
         * GetContactDetailTypesByCreatedBy retrieves all rows from the contact_detail_type table that match the provided CreatedBy
         */
        public async GetContactDetailTypesByCreatedBy(params: GetContactDetailTypesByCreatedByRequestParams): Promise<GetContactDetailTypesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailTypesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetContactDetailTypesByCreatedByResponseParams
        }

        /**
         * GetContactDetailTypesByIsDeleted retrieves all rows from the contact_detail_type table that match the provided IsDeleted
         */
        public async GetContactDetailTypesByIsDeleted(params: GetContactDetailTypesByIsDeletedRequestParams): Promise<GetContactDetailTypesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailTypesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetContactDetailTypesByIsDeletedResponseParams
        }

        /**
         * GetContactDetailTypesByName retrieves all rows from the contact_detail_type table that match the provided Name
         */
        public async GetContactDetailTypesByName(params: GetContactDetailTypesByNameRequestParams): Promise<GetContactDetailTypesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailTypesByName`, JSON.stringify(params))
            return await resp.json() as GetContactDetailTypesByNameResponseParams
        }

        /**
         * GetContactDetailTypesByUpdatedAt retrieves all rows from the contact_detail_type table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactDetailTypesByUpdatedAt(params: GetContactDetailTypesByUpdatedAtRequestParams): Promise<GetContactDetailTypesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailTypesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactDetailTypesByUpdatedAtResponseParams
        }

        /**
         * GetContactDetailTypesByUpdatedBy retrieves all rows from the contact_detail_type table that match the provided UpdatedBy
         */
        public async GetContactDetailTypesByUpdatedBy(params: GetContactDetailTypesByUpdatedByRequestParams): Promise<GetContactDetailTypesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailTypesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetContactDetailTypesByUpdatedByResponseParams
        }

        /**
         * GetContactDetailsByActive retrieves all rows from the contact_detail table that match the provided Active
         */
        public async GetContactDetailsByActive(params: GetContactDetailsByActiveRequestParams): Promise<GetContactDetailsByActiveResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByActive`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByActiveResponseParams
        }

        /**
         * GetContactDetailsByContactId retrieves all rows from the contact_detail table that match the provided ContactId
         */
        public async GetContactDetailsByContactId(params: GetContactDetailsByContactIdRequestParams): Promise<GetContactDetailsByContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByContactId`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByContactIdResponseParams
        }

        /**
         * GetContactDetailsByCreatedAt retrieves all rows from the contact_detail table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactDetailsByCreatedAt(params: GetContactDetailsByCreatedAtRequestParams): Promise<GetContactDetailsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByCreatedAtResponseParams
        }

        /**
         * GetContactDetailsByCreatedBy retrieves all rows from the contact_detail table that match the provided CreatedBy
         */
        public async GetContactDetailsByCreatedBy(params: GetContactDetailsByCreatedByRequestParams): Promise<GetContactDetailsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByCreatedByResponseParams
        }

        /**
         * GetContactDetailsByIsDeleted retrieves all rows from the contact_detail table that match the provided IsDeleted
         */
        public async GetContactDetailsByIsDeleted(params: GetContactDetailsByIsDeletedRequestParams): Promise<GetContactDetailsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByIsDeletedResponseParams
        }

        /**
         * GetContactDetailsByIsPrimary retrieves all rows from the contact_detail table that match the provided IsPrimary
         */
        public async GetContactDetailsByIsPrimary(params: GetContactDetailsByIsPrimaryRequestParams): Promise<GetContactDetailsByIsPrimaryResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByIsPrimary`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByIsPrimaryResponseParams
        }

        /**
         * GetContactDetailsByLabel retrieves all rows from the contact_detail table that match the provided Label
         */
        public async GetContactDetailsByLabel(params: GetContactDetailsByLabelRequestParams): Promise<GetContactDetailsByLabelResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByLabel`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByLabelResponseParams
        }

        /**
         * GetContactDetailsByTypeId retrieves all rows from the contact_detail table that match the provided TypeId
         */
        public async GetContactDetailsByTypeId(params: GetContactDetailsByTypeIdRequestParams): Promise<GetContactDetailsByTypeIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByTypeId`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByTypeIdResponseParams
        }

        /**
         * GetContactDetailsByUpdatedAt retrieves all rows from the contact_detail table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactDetailsByUpdatedAt(params: GetContactDetailsByUpdatedAtRequestParams): Promise<GetContactDetailsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByUpdatedAtResponseParams
        }

        /**
         * GetContactDetailsByUpdatedBy retrieves all rows from the contact_detail table that match the provided UpdatedBy
         */
        public async GetContactDetailsByUpdatedBy(params: GetContactDetailsByUpdatedByRequestParams): Promise<GetContactDetailsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByUpdatedByResponseParams
        }

        /**
         * GetContactDetailsByValue retrieves all rows from the contact_detail table that match the provided Value
         */
        public async GetContactDetailsByValue(params: GetContactDetailsByValueRequestParams): Promise<GetContactDetailsByValueResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDetailsByValue`, JSON.stringify(params))
            return await resp.json() as GetContactDetailsByValueResponseParams
        }

        /**
         * GetContactDocumentAuditById retrieves all rows from the contact_document_audit table that match the provided identifier for a row in the contact_document table
         */
        public async GetContactDocumentAuditById(params: GetContactDocumentAuditByIdRequestParams): Promise<GetContactDocumentAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDocumentAuditById`, JSON.stringify(params))
            return await resp.json() as GetContactDocumentAuditResponseParams
        }

        /**
         * GetContactDocumentById retrieves all rows from the contact_document table that match the provided identifier
         */
        public async GetContactDocumentById(params: GetContactDocumentByIdRequestParams): Promise<GetContactDocumentByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDocumentById`, JSON.stringify(params))
            return await resp.json() as GetContactDocumentByIdResponseParams
        }

        /**
         * GetContactDocumentsByContactId retrieves all rows from the contact_document table that match the provided ContactId
         */
        public async GetContactDocumentsByContactId(params: GetContactDocumentsByContactIdRequestParams): Promise<GetContactDocumentsByContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDocumentsByContactId`, JSON.stringify(params))
            return await resp.json() as GetContactDocumentsByContactIdResponseParams
        }

        /**
         * GetContactDocumentsByCreatedAt retrieves all rows from the contact_document table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactDocumentsByCreatedAt(params: GetContactDocumentsByCreatedAtRequestParams): Promise<GetContactDocumentsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDocumentsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactDocumentsByCreatedAtResponseParams
        }

        /**
         * GetContactDocumentsByCreatedBy retrieves all rows from the contact_document table that match the provided CreatedBy
         */
        public async GetContactDocumentsByCreatedBy(params: GetContactDocumentsByCreatedByRequestParams): Promise<GetContactDocumentsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDocumentsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetContactDocumentsByCreatedByResponseParams
        }

        /**
         * GetContactDocumentsByDocumentId retrieves all rows from the contact_document table that match the provided DocumentId
         */
        public async GetContactDocumentsByDocumentId(params: GetContactDocumentsByDocumentIdRequestParams): Promise<GetContactDocumentsByDocumentIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDocumentsByDocumentId`, JSON.stringify(params))
            return await resp.json() as GetContactDocumentsByDocumentIdResponseParams
        }

        /**
         * GetContactDocumentsByIsDeleted retrieves all rows from the contact_document table that match the provided IsDeleted
         */
        public async GetContactDocumentsByIsDeleted(params: GetContactDocumentsByIsDeletedRequestParams): Promise<GetContactDocumentsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDocumentsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetContactDocumentsByIsDeletedResponseParams
        }

        /**
         * GetContactDocumentsByUpdatedAt retrieves all rows from the contact_document table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactDocumentsByUpdatedAt(params: GetContactDocumentsByUpdatedAtRequestParams): Promise<GetContactDocumentsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDocumentsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactDocumentsByUpdatedAtResponseParams
        }

        /**
         * GetContactDocumentsByUpdatedBy retrieves all rows from the contact_document table that match the provided UpdatedBy
         */
        public async GetContactDocumentsByUpdatedBy(params: GetContactDocumentsByUpdatedByRequestParams): Promise<GetContactDocumentsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactDocumentsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetContactDocumentsByUpdatedByResponseParams
        }

        /**
         * GetContactNoteAuditById retrieves all rows from the contact_note_audit table that match the provided identifier for a row in the contact_note table
         */
        public async GetContactNoteAuditById(params: GetContactNoteAuditByIdRequestParams): Promise<GetContactNoteAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactNoteAuditById`, JSON.stringify(params))
            return await resp.json() as GetContactNoteAuditResponseParams
        }

        /**
         * GetContactNoteById retrieves all rows from the contact_note table that match the provided identifier
         */
        public async GetContactNoteById(params: GetContactNoteByIdRequestParams): Promise<GetContactNoteByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactNoteById`, JSON.stringify(params))
            return await resp.json() as GetContactNoteByIdResponseParams
        }

        /**
         * GetContactNotesByContactId retrieves all rows from the contact_note table that match the provided ContactId
         */
        public async GetContactNotesByContactId(params: GetContactNotesByContactIdRequestParams): Promise<GetContactNotesByContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactNotesByContactId`, JSON.stringify(params))
            return await resp.json() as GetContactNotesByContactIdResponseParams
        }

        /**
         * GetContactNotesByCreatedAt retrieves all rows from the contact_note table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactNotesByCreatedAt(params: GetContactNotesByCreatedAtRequestParams): Promise<GetContactNotesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactNotesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactNotesByCreatedAtResponseParams
        }

        /**
         * GetContactNotesByCreatedBy retrieves all rows from the contact_note table that match the provided CreatedBy
         */
        public async GetContactNotesByCreatedBy(params: GetContactNotesByCreatedByRequestParams): Promise<GetContactNotesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactNotesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetContactNotesByCreatedByResponseParams
        }

        /**
         * GetContactNotesByIsDeleted retrieves all rows from the contact_note table that match the provided IsDeleted
         */
        public async GetContactNotesByIsDeleted(params: GetContactNotesByIsDeletedRequestParams): Promise<GetContactNotesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactNotesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetContactNotesByIsDeletedResponseParams
        }

        /**
         * GetContactNotesByMessage retrieves all rows from the contact_note table that match the provided Message
         */
        public async GetContactNotesByMessage(params: GetContactNotesByMessageRequestParams): Promise<GetContactNotesByMessageResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactNotesByMessage`, JSON.stringify(params))
            return await resp.json() as GetContactNotesByMessageResponseParams
        }

        /**
         * GetContactNotesByTitle retrieves all rows from the contact_note table that match the provided Title
         */
        public async GetContactNotesByTitle(params: GetContactNotesByTitleRequestParams): Promise<GetContactNotesByTitleResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactNotesByTitle`, JSON.stringify(params))
            return await resp.json() as GetContactNotesByTitleResponseParams
        }

        /**
         * GetContactNotesByUpdatedAt retrieves all rows from the contact_note table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactNotesByUpdatedAt(params: GetContactNotesByUpdatedAtRequestParams): Promise<GetContactNotesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactNotesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactNotesByUpdatedAtResponseParams
        }

        /**
         * GetContactNotesByUpdatedBy retrieves all rows from the contact_note table that match the provided UpdatedBy
         */
        public async GetContactNotesByUpdatedBy(params: GetContactNotesByUpdatedByRequestParams): Promise<GetContactNotesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactNotesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetContactNotesByUpdatedByResponseParams
        }

        /**
         * GetContactRoleAuditById retrieves all rows from the contact_role_audit table that match the provided identifier for a row in the contact_role table
         */
        public async GetContactRoleAuditById(params: GetContactRoleAuditByIdRequestParams): Promise<GetContactRoleAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRoleAuditById`, JSON.stringify(params))
            return await resp.json() as GetContactRoleAuditResponseParams
        }

        /**
         * GetContactRoleById retrieves all rows from the contact_role table that match the provided identifier
         */
        public async GetContactRoleById(params: GetContactRoleByIdRequestParams): Promise<GetContactRoleByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRoleById`, JSON.stringify(params))
            return await resp.json() as GetContactRoleByIdResponseParams
        }

        /**
         * GetContactRolesByActive retrieves all rows from the contact_role table that match the provided Active
         */
        public async GetContactRolesByActive(params: GetContactRolesByActiveRequestParams): Promise<GetContactRolesByActiveResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByActive`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByActiveResponseParams
        }

        /**
         * GetContactRolesByCompanyId retrieves all rows from the contact_role table that match the provided CompanyId
         */
        public async GetContactRolesByCompanyId(params: GetContactRolesByCompanyIdRequestParams): Promise<GetContactRolesByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByCompanyIdResponseParams
        }

        /**
         * GetContactRolesByContactId retrieves all rows from the contact_role table that match the provided ContactId
         */
        public async GetContactRolesByContactId(params: GetContactRolesByContactIdRequestParams): Promise<GetContactRolesByContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByContactId`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByContactIdResponseParams
        }

        /**
         * GetContactRolesByCreatedAt retrieves all rows from the contact_role table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactRolesByCreatedAt(params: GetContactRolesByCreatedAtRequestParams): Promise<GetContactRolesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByCreatedAtResponseParams
        }

        /**
         * GetContactRolesByCreatedBy retrieves all rows from the contact_role table that match the provided CreatedBy
         */
        public async GetContactRolesByCreatedBy(params: GetContactRolesByCreatedByRequestParams): Promise<GetContactRolesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByCreatedByResponseParams
        }

        /**
         * GetContactRolesByEndDate retrieves all rows from the contact_role table that match the provided EndDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactRolesByEndDate(params: GetContactRolesByEndDateRequestParams): Promise<GetContactRolesByEndDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByEndDate`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByEndDateResponseParams
        }

        /**
         * GetContactRolesByIsDeleted retrieves all rows from the contact_role table that match the provided IsDeleted
         */
        public async GetContactRolesByIsDeleted(params: GetContactRolesByIsDeletedRequestParams): Promise<GetContactRolesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByIsDeletedResponseParams
        }

        /**
         * GetContactRolesByStartDate retrieves all rows from the contact_role table that match the provided StartDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactRolesByStartDate(params: GetContactRolesByStartDateRequestParams): Promise<GetContactRolesByStartDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByStartDate`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByStartDateResponseParams
        }

        /**
         * GetContactRolesByTitle retrieves all rows from the contact_role table that match the provided Title
         */
        public async GetContactRolesByTitle(params: GetContactRolesByTitleRequestParams): Promise<GetContactRolesByTitleResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByTitle`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByTitleResponseParams
        }

        /**
         * GetContactRolesByUpdatedAt retrieves all rows from the contact_role table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactRolesByUpdatedAt(params: GetContactRolesByUpdatedAtRequestParams): Promise<GetContactRolesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByUpdatedAtResponseParams
        }

        /**
         * GetContactRolesByUpdatedBy retrieves all rows from the contact_role table that match the provided UpdatedBy
         */
        public async GetContactRolesByUpdatedBy(params: GetContactRolesByUpdatedByRequestParams): Promise<GetContactRolesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactRolesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetContactRolesByUpdatedByResponseParams
        }

        /**
         * GetContactsByBirthday retrieves all rows from the contact table that match the provided Birthday
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactsByBirthday(params: GetContactsByBirthdayRequestParams): Promise<GetContactsByBirthdayResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactsByBirthday`, JSON.stringify(params))
            return await resp.json() as GetContactsByBirthdayResponseParams
        }

        /**
         * GetContactsByCreatedAt retrieves all rows from the contact table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactsByCreatedAt(params: GetContactsByCreatedAtRequestParams): Promise<GetContactsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactsByCreatedAtResponseParams
        }

        /**
         * GetContactsByFirstName retrieves all rows from the contact table that match the provided FirstName
         */
        public async GetContactsByFirstName(params: GetContactsByFirstNameRequestParams): Promise<GetContactsByFirstNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactsByFirstName`, JSON.stringify(params))
            return await resp.json() as GetContactsByFirstNameResponseParams
        }

        /**
         * GetContactsByIsDeleted retrieves all rows from the contact table that match the provided IsDeleted
         */
        public async GetContactsByIsDeleted(params: GetContactsByIsDeletedRequestParams): Promise<GetContactsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetContactsByIsDeletedResponseParams
        }

        /**
         * GetContactsByLastName retrieves all rows from the contact table that match the provided LastName
         */
        public async GetContactsByLastName(params: GetContactsByLastNameRequestParams): Promise<GetContactsByLastNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactsByLastName`, JSON.stringify(params))
            return await resp.json() as GetContactsByLastNameResponseParams
        }

        /**
         * GetContactsByUpdatedAt retrieves all rows from the contact table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetContactsByUpdatedAt(params: GetContactsByUpdatedAtRequestParams): Promise<GetContactsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetContactsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetContactsByUpdatedAtResponseParams
        }

        /**
         * GetDevInfo retrieves all developer information for Skrym
         */
        public async GetDevInfo(): Promise<GetDevInfoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDevInfo`)
            return await resp.json() as GetDevInfoResponse
        }

        /**
         * GetDocumentAuditById retrieves all rows from the document_audit table that match the provided identifier for a row in the document table
         */
        public async GetDocumentAuditById(params: GetDocumentAuditByIdRequestParams): Promise<GetDocumentAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentAuditById`, JSON.stringify(params))
            return await resp.json() as GetDocumentAuditResponseParams
        }

        /**
         * GetDocumentById retrieves all rows from the document table that match the provided identifier
         */
        public async GetDocumentById(params: GetDocumentByIdRequestParams): Promise<GetDocumentByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentById`, JSON.stringify(params))
            return await resp.json() as GetDocumentByIdResponseParams
        }

        /**
         * GetDocumentTypeAuditById retrieves all rows from the document_type_audit table that match the provided identifier for a row in the document_type table
         */
        public async GetDocumentTypeAuditById(params: GetDocumentTypeAuditByIdRequestParams): Promise<GetDocumentTypeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentTypeAuditById`, JSON.stringify(params))
            return await resp.json() as GetDocumentTypeAuditResponseParams
        }

        /**
         * GetDocumentTypeById retrieves all rows from the document_type table that match the provided identifier
         */
        public async GetDocumentTypeById(params: GetDocumentTypeByIdRequestParams): Promise<GetDocumentTypeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentTypeById`, JSON.stringify(params))
            return await resp.json() as GetDocumentTypeByIdResponseParams
        }

        /**
         * GetDocumentTypesByIsDeleted retrieves all rows from the document_type table that match the provided IsDeleted
         */
        public async GetDocumentTypesByIsDeleted(params: GetDocumentTypesByIsDeletedRequestParams): Promise<GetDocumentTypesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentTypesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetDocumentTypesByIsDeletedResponseParams
        }

        /**
         * GetDocumentTypesByName retrieves all rows from the document_type table that match the provided Name
         */
        public async GetDocumentTypesByName(params: GetDocumentTypesByNameRequestParams): Promise<GetDocumentTypesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentTypesByName`, JSON.stringify(params))
            return await resp.json() as GetDocumentTypesByNameResponseParams
        }

        /**
         * GetDocumentsByCreatedAt retrieves all rows from the document table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetDocumentsByCreatedAt(params: GetDocumentsByCreatedAtRequestParams): Promise<GetDocumentsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetDocumentsByCreatedAtResponseParams
        }

        /**
         * GetDocumentsByDocumentDescription retrieves all rows from the document table that match the provided DocumentDescription
         */
        public async GetDocumentsByDocumentDescription(params: GetDocumentsByDocumentDescriptionRequestParams): Promise<GetDocumentsByDocumentDescriptionResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentsByDocumentDescription`, JSON.stringify(params))
            return await resp.json() as GetDocumentsByDocumentDescriptionResponseParams
        }

        /**
         * GetDocumentsByDocumentName retrieves all rows from the document table that match the provided DocumentName
         */
        public async GetDocumentsByDocumentName(params: GetDocumentsByDocumentNameRequestParams): Promise<GetDocumentsByDocumentNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentsByDocumentName`, JSON.stringify(params))
            return await resp.json() as GetDocumentsByDocumentNameResponseParams
        }

        /**
         * GetDocumentsByDocumentUrl retrieves all rows from the document table that match the provided DocumentUrl
         */
        public async GetDocumentsByDocumentUrl(params: GetDocumentsByDocumentUrlRequestParams): Promise<GetDocumentsByDocumentUrlResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentsByDocumentUrl`, JSON.stringify(params))
            return await resp.json() as GetDocumentsByDocumentUrlResponseParams
        }

        /**
         * GetDocumentsByIsDeleted retrieves all rows from the document table that match the provided IsDeleted
         */
        public async GetDocumentsByIsDeleted(params: GetDocumentsByIsDeletedRequestParams): Promise<GetDocumentsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetDocumentsByIsDeletedResponseParams
        }

        /**
         * GetDocumentsByTypeId retrieves all rows from the document table that match the provided TypeId
         */
        public async GetDocumentsByTypeId(params: GetDocumentsByTypeIdRequestParams): Promise<GetDocumentsByTypeIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentsByTypeId`, JSON.stringify(params))
            return await resp.json() as GetDocumentsByTypeIdResponseParams
        }

        /**
         * GetDocumentsByUpdatedAt retrieves all rows from the document table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetDocumentsByUpdatedAt(params: GetDocumentsByUpdatedAtRequestParams): Promise<GetDocumentsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetDocumentsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetDocumentsByUpdatedAtResponseParams
        }

        /**
         * GetEmploymentAuditById retrieves all rows from the employment_audit table that match the provided identifier for a row in the employment table
         */
        public async GetEmploymentAuditById(params: GetEmploymentAuditByIdRequestParams): Promise<GetEmploymentAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentAuditById`, JSON.stringify(params))
            return await resp.json() as GetEmploymentAuditResponseParams
        }

        /**
         * GetEmploymentById retrieves all rows from the employment table that match the provided identifier
         */
        public async GetEmploymentById(params: GetEmploymentByIdRequestParams): Promise<GetEmploymentByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentById`, JSON.stringify(params))
            return await resp.json() as GetEmploymentByIdResponseParams
        }

        /**
         * GetEmploymentsByContactRoleId retrieves all rows from the employment table that match the provided ContactRoleId
         */
        public async GetEmploymentsByContactRoleId(params: GetEmploymentsByContactRoleIdRequestParams): Promise<GetEmploymentsByContactRoleIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByContactRoleId`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByContactRoleIdResponseParams
        }

        /**
         * GetEmploymentsByContract retrieves all rows from the employment table that match the provided Contract
         */
        public async GetEmploymentsByContract(params: GetEmploymentsByContractRequestParams): Promise<GetEmploymentsByContractResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByContract`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByContractResponseParams
        }

        /**
         * GetEmploymentsByCreatedAt retrieves all rows from the employment table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetEmploymentsByCreatedAt(params: GetEmploymentsByCreatedAtRequestParams): Promise<GetEmploymentsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByCreatedAtResponseParams
        }

        /**
         * GetEmploymentsByCreatedBy retrieves all rows from the employment table that match the provided CreatedBy
         */
        public async GetEmploymentsByCreatedBy(params: GetEmploymentsByCreatedByRequestParams): Promise<GetEmploymentsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByCreatedByResponseParams
        }

        /**
         * GetEmploymentsByIsActive retrieves all rows from the employment table that match the provided IsActive
         */
        public async GetEmploymentsByIsActive(params: GetEmploymentsByIsActiveRequestParams): Promise<GetEmploymentsByIsActiveResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByIsActive`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByIsActiveResponseParams
        }

        /**
         * GetEmploymentsByIsDeleted retrieves all rows from the employment table that match the provided IsDeleted
         */
        public async GetEmploymentsByIsDeleted(params: GetEmploymentsByIsDeletedRequestParams): Promise<GetEmploymentsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByIsDeletedResponseParams
        }

        /**
         * GetEmploymentsByIsHourly retrieves all rows from the employment table that match the provided IsHourly
         */
        public async GetEmploymentsByIsHourly(params: GetEmploymentsByIsHourlyRequestParams): Promise<GetEmploymentsByIsHourlyResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByIsHourly`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByIsHourlyResponseParams
        }

        /**
         * GetEmploymentsByIsMonthly retrieves all rows from the employment table that match the provided IsMonthly
         */
        public async GetEmploymentsByIsMonthly(params: GetEmploymentsByIsMonthlyRequestParams): Promise<GetEmploymentsByIsMonthlyResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByIsMonthly`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByIsMonthlyResponseParams
        }

        /**
         * GetEmploymentsByName retrieves all rows from the employment table that match the provided Name
         */
        public async GetEmploymentsByName(params: GetEmploymentsByNameRequestParams): Promise<GetEmploymentsByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByName`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByNameResponseParams
        }

        /**
         * GetEmploymentsByNoVacationDays retrieves all rows from the employment table that match the provided NoVacationDays
         */
        public async GetEmploymentsByNoVacationDays(params: GetEmploymentsByNoVacationDaysRequestParams): Promise<GetEmploymentsByNoVacationDaysResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByNoVacationDays`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByNoVacationDaysResponseParams
        }

        /**
         * GetEmploymentsBySalarySek retrieves all rows from the employment table that match the provided SalarySek
         */
        public async GetEmploymentsBySalarySek(params: GetEmploymentsBySalarySekRequestParams): Promise<GetEmploymentsBySalarySekResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsBySalarySek`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsBySalarySekResponseParams
        }

        /**
         * GetEmploymentsByUpdatedAt retrieves all rows from the employment table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetEmploymentsByUpdatedAt(params: GetEmploymentsByUpdatedAtRequestParams): Promise<GetEmploymentsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByUpdatedAtResponseParams
        }

        /**
         * GetEmploymentsByUpdatedBy retrieves all rows from the employment table that match the provided UpdatedBy
         */
        public async GetEmploymentsByUpdatedBy(params: GetEmploymentsByUpdatedByRequestParams): Promise<GetEmploymentsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEmploymentsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetEmploymentsByUpdatedByResponseParams
        }

        /**
         * GetEventAttendeeAuditById retrieves all rows from the event_attendee_audit table that match the provided identifier for a row in the event_attendee table
         */
        public async GetEventAttendeeAuditById(params: GetEventAttendeeAuditByIdRequestParams): Promise<GetEventAttendeeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventAttendeeAuditById`, JSON.stringify(params))
            return await resp.json() as GetEventAttendeeAuditResponseParams
        }

        /**
         * GetEventAttendeeById retrieves all rows from the event_attendee table that match the provided identifier
         */
        public async GetEventAttendeeById(params: GetEventAttendeeByIdRequestParams): Promise<GetEventAttendeeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventAttendeeById`, JSON.stringify(params))
            return await resp.json() as GetEventAttendeeByIdResponseParams
        }

        /**
         * GetEventAttendeesByContactId retrieves all rows from the event_attendee table that match the provided ContactId
         */
        public async GetEventAttendeesByContactId(params: GetEventAttendeesByContactIdRequestParams): Promise<GetEventAttendeesByContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventAttendeesByContactId`, JSON.stringify(params))
            return await resp.json() as GetEventAttendeesByContactIdResponseParams
        }

        /**
         * GetEventAttendeesByEventId retrieves all rows from the event_attendee table that match the provided EventId
         */
        public async GetEventAttendeesByEventId(params: GetEventAttendeesByEventIdRequestParams): Promise<GetEventAttendeesByEventIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventAttendeesByEventId`, JSON.stringify(params))
            return await resp.json() as GetEventAttendeesByEventIdResponseParams
        }

        /**
         * GetEventAttendeesByIsDeleted retrieves all rows from the event_attendee table that match the provided IsDeleted
         */
        public async GetEventAttendeesByIsDeleted(params: GetEventAttendeesByIsDeletedRequestParams): Promise<GetEventAttendeesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventAttendeesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetEventAttendeesByIsDeletedResponseParams
        }

        /**
         * GetEventAuditById retrieves all rows from the event_audit table that match the provided identifier for a row in the event table
         */
        public async GetEventAuditById(params: GetEventAuditByIdRequestParams): Promise<GetEventAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventAuditById`, JSON.stringify(params))
            return await resp.json() as GetEventAuditResponseParams
        }

        /**
         * GetEventById retrieves all rows from the event table that match the provided identifier
         */
        public async GetEventById(params: GetEventByIdRequestParams): Promise<GetEventByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventById`, JSON.stringify(params))
            return await resp.json() as GetEventByIdResponseParams
        }

        /**
         * GetEventTypeAuditById retrieves all rows from the event_type_audit table that match the provided identifier for a row in the event_type table
         */
        public async GetEventTypeAuditById(params: GetEventTypeAuditByIdRequestParams): Promise<GetEventTypeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventTypeAuditById`, JSON.stringify(params))
            return await resp.json() as GetEventTypeAuditResponseParams
        }

        /**
         * GetEventTypeById retrieves all rows from the event_type table that match the provided identifier
         */
        public async GetEventTypeById(params: GetEventTypeByIdRequestParams): Promise<GetEventTypeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventTypeById`, JSON.stringify(params))
            return await resp.json() as GetEventTypeByIdResponseParams
        }

        /**
         * GetEventTypesByCreatedBy retrieves all rows from the event_type table that match the provided CreatedBy
         */
        public async GetEventTypesByCreatedBy(params: GetEventTypesByCreatedByRequestParams): Promise<GetEventTypesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventTypesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetEventTypesByCreatedByResponseParams
        }

        /**
         * GetEventTypesByEventType retrieves all rows from the event_type table that match the provided EventType
         */
        public async GetEventTypesByEventType(params: GetEventTypesByEventTypeRequestParams): Promise<GetEventTypesByEventTypeResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventTypesByEventType`, JSON.stringify(params))
            return await resp.json() as GetEventTypesByEventTypeResponseParams
        }

        /**
         * GetEventTypesByIsDeleted retrieves all rows from the event_type table that match the provided IsDeleted
         */
        public async GetEventTypesByIsDeleted(params: GetEventTypesByIsDeletedRequestParams): Promise<GetEventTypesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventTypesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetEventTypesByIsDeletedResponseParams
        }

        /**
         * GetEventTypesByTypeDescription retrieves all rows from the event_type table that match the provided TypeDescription
         */
        public async GetEventTypesByTypeDescription(params: GetEventTypesByTypeDescriptionRequestParams): Promise<GetEventTypesByTypeDescriptionResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventTypesByTypeDescription`, JSON.stringify(params))
            return await resp.json() as GetEventTypesByTypeDescriptionResponseParams
        }

        /**
         * GetEventsByEndDate retrieves all rows from the event table that match the provided EndDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetEventsByEndDate(params: GetEventsByEndDateRequestParams): Promise<GetEventsByEndDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventsByEndDate`, JSON.stringify(params))
            return await resp.json() as GetEventsByEndDateResponseParams
        }

        /**
         * GetEventsByIsDeleted retrieves all rows from the event table that match the provided IsDeleted
         */
        public async GetEventsByIsDeleted(params: GetEventsByIsDeletedRequestParams): Promise<GetEventsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetEventsByIsDeletedResponseParams
        }

        /**
         * GetEventsByName retrieves all rows from the event table that match the provided Name
         */
        public async GetEventsByName(params: GetEventsByNameRequestParams): Promise<GetEventsByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventsByName`, JSON.stringify(params))
            return await resp.json() as GetEventsByNameResponseParams
        }

        /**
         * GetEventsByStartDate retrieves all rows from the event table that match the provided StartDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetEventsByStartDate(params: GetEventsByStartDateRequestParams): Promise<GetEventsByStartDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventsByStartDate`, JSON.stringify(params))
            return await resp.json() as GetEventsByStartDateResponseParams
        }

        /**
         * GetEventsByTypeId retrieves all rows from the event table that match the provided TypeId
         */
        public async GetEventsByTypeId(params: GetEventsByTypeIdRequestParams): Promise<GetEventsByTypeIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventsByTypeId`, JSON.stringify(params))
            return await resp.json() as GetEventsByTypeIdResponseParams
        }

        /**
         * GetEventsByUrl retrieves all rows from the event table that match the provided Url
         */
        public async GetEventsByUrl(params: GetEventsByUrlRequestParams): Promise<GetEventsByUrlResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetEventsByUrl`, JSON.stringify(params))
            return await resp.json() as GetEventsByUrlResponseParams
        }

        /**
         * GetFeed retrieves all the latest changes/additions from the past 24 hours
         */
        public async GetFeed(): Promise<GetFeedResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFeed`)
            return await resp.json() as GetFeedResponse
        }

        /**
         * GetFormSubmissionAuditById retrieves all rows from the form_submission_audit table that match the provided identifier for a row in the form_submission table
         */
        public async GetFormSubmissionAuditById(params: GetFormSubmissionAuditByIdRequestParams): Promise<GetFormSubmissionAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionAuditById`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionAuditResponseParams
        }

        /**
         * GetFormSubmissionById retrieves all rows from the form_submission table that match the provided identifier
         */
        public async GetFormSubmissionById(params: GetFormSubmissionByIdRequestParams): Promise<GetFormSubmissionByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionById`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionByIdResponseParams
        }

        /**
         * GetFormSubmissionsByCompany retrieves all rows from the form_submission table that match the provided Company
         */
        public async GetFormSubmissionsByCompany(params: GetFormSubmissionsByCompanyRequestParams): Promise<GetFormSubmissionsByCompanyResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByCompany`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByCompanyResponseParams
        }

        /**
         * GetFormSubmissionsByCreatedAt retrieves all rows from the form_submission table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetFormSubmissionsByCreatedAt(params: GetFormSubmissionsByCreatedAtRequestParams): Promise<GetFormSubmissionsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByCreatedAtResponseParams
        }

        /**
         * GetFormSubmissionsByEmail retrieves all rows from the form_submission table that match the provided Email
         */
        public async GetFormSubmissionsByEmail(params: GetFormSubmissionsByEmailRequestParams): Promise<GetFormSubmissionsByEmailResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByEmail`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByEmailResponseParams
        }

        /**
         * GetFormSubmissionsByFormName retrieves all rows from the form_submission table that match the provided FormName
         */
        public async GetFormSubmissionsByFormName(params: GetFormSubmissionsByFormNameRequestParams): Promise<GetFormSubmissionsByFormNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByFormName`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByFormNameResponseParams
        }

        /**
         * GetFormSubmissionsByFormSubmission retrieves all rows from the form_submission table that match the provided FormSubmission
         */
        public async GetFormSubmissionsByFormSubmission(params: GetFormSubmissionsByFormSubmissionRequestParams): Promise<GetFormSubmissionsByFormSubmissionResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByFormSubmission`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByFormSubmissionResponseParams
        }

        /**
         * GetFormSubmissionsByHonung retrieves all rows from the form_submission table that match the provided Honung
         */
        public async GetFormSubmissionsByHonung(params: GetFormSubmissionsByHonungRequestParams): Promise<GetFormSubmissionsByHonungResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByHonung`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByHonungResponseParams
        }

        /**
         * GetFormSubmissionsByIsDeleted retrieves all rows from the form_submission table that match the provided IsDeleted
         */
        public async GetFormSubmissionsByIsDeleted(params: GetFormSubmissionsByIsDeletedRequestParams): Promise<GetFormSubmissionsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByIsDeletedResponseParams
        }

        /**
         * GetFormSubmissionsByMessage retrieves all rows from the form_submission table that match the provided Message
         */
        public async GetFormSubmissionsByMessage(params: GetFormSubmissionsByMessageRequestParams): Promise<GetFormSubmissionsByMessageResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByMessage`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByMessageResponseParams
        }

        /**
         * GetFormSubmissionsByName retrieves all rows from the form_submission table that match the provided Name
         */
        public async GetFormSubmissionsByName(params: GetFormSubmissionsByNameRequestParams): Promise<GetFormSubmissionsByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByName`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByNameResponseParams
        }

        /**
         * GetFormSubmissionsByPhone retrieves all rows from the form_submission table that match the provided Phone
         */
        public async GetFormSubmissionsByPhone(params: GetFormSubmissionsByPhoneRequestParams): Promise<GetFormSubmissionsByPhoneResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByPhone`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByPhoneResponseParams
        }

        /**
         * GetFormSubmissionsByRole retrieves all rows from the form_submission table that match the provided Role
         */
        public async GetFormSubmissionsByRole(params: GetFormSubmissionsByRoleRequestParams): Promise<GetFormSubmissionsByRoleResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByRole`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByRoleResponseParams
        }

        /**
         * GetFormSubmissionsByStatus retrieves all rows from the form_submission table that match the provided Status
         */
        public async GetFormSubmissionsByStatus(params: GetFormSubmissionsByStatusRequestParams): Promise<GetFormSubmissionsByStatusResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByStatus`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByStatusResponseParams
        }

        /**
         * GetFormSubmissionsBySubject retrieves all rows from the form_submission table that match the provided Subject
         */
        public async GetFormSubmissionsBySubject(params: GetFormSubmissionsBySubjectRequestParams): Promise<GetFormSubmissionsBySubjectResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsBySubject`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsBySubjectResponseParams
        }

        /**
         * GetFormSubmissionsByTimestamp retrieves all rows from the form_submission table that match the provided Timestamp
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetFormSubmissionsByTimestamp(params: GetFormSubmissionsByTimestampRequestParams): Promise<GetFormSubmissionsByTimestampResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByTimestamp`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByTimestampResponseParams
        }

        /**
         * GetFormSubmissionsByUpdatedAt retrieves all rows from the form_submission table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetFormSubmissionsByUpdatedAt(params: GetFormSubmissionsByUpdatedAtRequestParams): Promise<GetFormSubmissionsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetFormSubmissionsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetFormSubmissionsByUpdatedAtResponseParams
        }

        /**
         * GetMeetingAttendeeAuditById retrieves all rows from the meeting_attendee_audit table that match the provided identifier for a row in the meeting_attendee table
         */
        public async GetMeetingAttendeeAuditById(params: GetMeetingAttendeeAuditByIdRequestParams): Promise<GetMeetingAttendeeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingAttendeeAuditById`, JSON.stringify(params))
            return await resp.json() as GetMeetingAttendeeAuditResponseParams
        }

        /**
         * GetMeetingAttendeeById retrieves all rows from the meeting_attendee table that match the provided identifier
         */
        public async GetMeetingAttendeeById(params: GetMeetingAttendeeByIdRequestParams): Promise<GetMeetingAttendeeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingAttendeeById`, JSON.stringify(params))
            return await resp.json() as GetMeetingAttendeeByIdResponseParams
        }

        /**
         * GetMeetingAttendeesByContactId retrieves all rows from the meeting_attendee table that match the provided ContactId
         */
        public async GetMeetingAttendeesByContactId(params: GetMeetingAttendeesByContactIdRequestParams): Promise<GetMeetingAttendeesByContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingAttendeesByContactId`, JSON.stringify(params))
            return await resp.json() as GetMeetingAttendeesByContactIdResponseParams
        }

        /**
         * GetMeetingAttendeesByCreatedAt retrieves all rows from the meeting_attendee table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetMeetingAttendeesByCreatedAt(params: GetMeetingAttendeesByCreatedAtRequestParams): Promise<GetMeetingAttendeesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingAttendeesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetMeetingAttendeesByCreatedAtResponseParams
        }

        /**
         * GetMeetingAttendeesByCreatedBy retrieves all rows from the meeting_attendee table that match the provided CreatedBy
         */
        public async GetMeetingAttendeesByCreatedBy(params: GetMeetingAttendeesByCreatedByRequestParams): Promise<GetMeetingAttendeesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingAttendeesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetMeetingAttendeesByCreatedByResponseParams
        }

        /**
         * GetMeetingAttendeesByIsDeleted retrieves all rows from the meeting_attendee table that match the provided IsDeleted
         */
        public async GetMeetingAttendeesByIsDeleted(params: GetMeetingAttendeesByIsDeletedRequestParams): Promise<GetMeetingAttendeesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingAttendeesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetMeetingAttendeesByIsDeletedResponseParams
        }

        /**
         * GetMeetingAttendeesByMeetingId retrieves all rows from the meeting_attendee table that match the provided MeetingId
         */
        public async GetMeetingAttendeesByMeetingId(params: GetMeetingAttendeesByMeetingIdRequestParams): Promise<GetMeetingAttendeesByMeetingIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingAttendeesByMeetingId`, JSON.stringify(params))
            return await resp.json() as GetMeetingAttendeesByMeetingIdResponseParams
        }

        /**
         * GetMeetingAttendeesByUpdatedAt retrieves all rows from the meeting_attendee table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetMeetingAttendeesByUpdatedAt(params: GetMeetingAttendeesByUpdatedAtRequestParams): Promise<GetMeetingAttendeesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingAttendeesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetMeetingAttendeesByUpdatedAtResponseParams
        }

        /**
         * GetMeetingAttendeesByUpdatedBy retrieves all rows from the meeting_attendee table that match the provided UpdatedBy
         */
        public async GetMeetingAttendeesByUpdatedBy(params: GetMeetingAttendeesByUpdatedByRequestParams): Promise<GetMeetingAttendeesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingAttendeesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetMeetingAttendeesByUpdatedByResponseParams
        }

        /**
         * GetMeetingAuditById retrieves all rows from the meeting_audit table that match the provided identifier for a row in the meeting table
         */
        public async GetMeetingAuditById(params: GetMeetingAuditByIdRequestParams): Promise<GetMeetingAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingAuditById`, JSON.stringify(params))
            return await resp.json() as GetMeetingAuditResponseParams
        }

        /**
         * GetMeetingById retrieves all rows from the meeting table that match the provided identifier
         */
        public async GetMeetingById(params: GetMeetingByIdRequestParams): Promise<GetMeetingByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingById`, JSON.stringify(params))
            return await resp.json() as GetMeetingByIdResponseParams
        }

        /**
         * GetMeetingCompaniesByCompanyId retrieves all rows from the meeting_company table that match the provided CompanyId
         */
        public async GetMeetingCompaniesByCompanyId(params: GetMeetingCompaniesByCompanyIdRequestParams): Promise<GetMeetingCompaniesByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingCompaniesByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetMeetingCompaniesByCompanyIdResponseParams
        }

        /**
         * GetMeetingCompaniesByCreatedAt retrieves all rows from the meeting_company table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetMeetingCompaniesByCreatedAt(params: GetMeetingCompaniesByCreatedAtRequestParams): Promise<GetMeetingCompaniesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingCompaniesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetMeetingCompaniesByCreatedAtResponseParams
        }

        /**
         * GetMeetingCompaniesByCreatedBy retrieves all rows from the meeting_company table that match the provided CreatedBy
         */
        public async GetMeetingCompaniesByCreatedBy(params: GetMeetingCompaniesByCreatedByRequestParams): Promise<GetMeetingCompaniesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingCompaniesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetMeetingCompaniesByCreatedByResponseParams
        }

        /**
         * GetMeetingCompaniesByIsDeleted retrieves all rows from the meeting_company table that match the provided IsDeleted
         */
        public async GetMeetingCompaniesByIsDeleted(params: GetMeetingCompaniesByIsDeletedRequestParams): Promise<GetMeetingCompaniesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingCompaniesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetMeetingCompaniesByIsDeletedResponseParams
        }

        /**
         * GetMeetingCompaniesByMeetingId retrieves all rows from the meeting_company table that match the provided MeetingId
         */
        public async GetMeetingCompaniesByMeetingId(params: GetMeetingCompaniesByMeetingIdRequestParams): Promise<GetMeetingCompaniesByMeetingIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingCompaniesByMeetingId`, JSON.stringify(params))
            return await resp.json() as GetMeetingCompaniesByMeetingIdResponseParams
        }

        /**
         * GetMeetingCompaniesByUpdatedAt retrieves all rows from the meeting_company table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetMeetingCompaniesByUpdatedAt(params: GetMeetingCompaniesByUpdatedAtRequestParams): Promise<GetMeetingCompaniesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingCompaniesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetMeetingCompaniesByUpdatedAtResponseParams
        }

        /**
         * GetMeetingCompaniesByUpdatedBy retrieves all rows from the meeting_company table that match the provided UpdatedBy
         */
        public async GetMeetingCompaniesByUpdatedBy(params: GetMeetingCompaniesByUpdatedByRequestParams): Promise<GetMeetingCompaniesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingCompaniesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetMeetingCompaniesByUpdatedByResponseParams
        }

        /**
         * GetMeetingCompanyAuditById retrieves all rows from the meeting_company_audit table that match the provided identifier for a row in the meeting_company table
         */
        public async GetMeetingCompanyAuditById(params: GetMeetingCompanyAuditByIdRequestParams): Promise<GetMeetingCompanyAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingCompanyAuditById`, JSON.stringify(params))
            return await resp.json() as GetMeetingCompanyAuditResponseParams
        }

        /**
         * GetMeetingCompanyById retrieves all rows from the meeting_company table that match the provided identifier
         */
        public async GetMeetingCompanyById(params: GetMeetingCompanyByIdRequestParams): Promise<GetMeetingCompanyByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingCompanyById`, JSON.stringify(params))
            return await resp.json() as GetMeetingCompanyByIdResponseParams
        }

        /**
         * GetMeetingTypeAuditById retrieves all rows from the meeting_type_audit table that match the provided identifier for a row in the meeting_type table
         */
        public async GetMeetingTypeAuditById(params: GetMeetingTypeAuditByIdRequestParams): Promise<GetMeetingTypeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingTypeAuditById`, JSON.stringify(params))
            return await resp.json() as GetMeetingTypeAuditResponseParams
        }

        /**
         * GetMeetingTypeById retrieves all rows from the meeting_type table that match the provided identifier
         */
        public async GetMeetingTypeById(params: GetMeetingTypeByIdRequestParams): Promise<GetMeetingTypeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingTypeById`, JSON.stringify(params))
            return await resp.json() as GetMeetingTypeByIdResponseParams
        }

        /**
         * GetMeetingTypesByIsDeleted retrieves all rows from the meeting_type table that match the provided IsDeleted
         */
        public async GetMeetingTypesByIsDeleted(params: GetMeetingTypesByIsDeletedRequestParams): Promise<GetMeetingTypesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingTypesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetMeetingTypesByIsDeletedResponseParams
        }

        /**
         * GetMeetingTypesByName retrieves all rows from the meeting_type table that match the provided Name
         */
        public async GetMeetingTypesByName(params: GetMeetingTypesByNameRequestParams): Promise<GetMeetingTypesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingTypesByName`, JSON.stringify(params))
            return await resp.json() as GetMeetingTypesByNameResponseParams
        }

        /**
         * GetMeetingsByCreatedAt retrieves all rows from the meeting table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetMeetingsByCreatedAt(params: GetMeetingsByCreatedAtRequestParams): Promise<GetMeetingsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByCreatedAtResponseParams
        }

        /**
         * GetMeetingsByCreatedBy retrieves all rows from the meeting table that match the provided CreatedBy
         */
        public async GetMeetingsByCreatedBy(params: GetMeetingsByCreatedByRequestParams): Promise<GetMeetingsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByCreatedByResponseParams
        }

        /**
         * GetMeetingsByIsDeleted retrieves all rows from the meeting table that match the provided IsDeleted
         */
        public async GetMeetingsByIsDeleted(params: GetMeetingsByIsDeletedRequestParams): Promise<GetMeetingsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByIsDeletedResponseParams
        }

        /**
         * GetMeetingsByMeetingDate retrieves all rows from the meeting table that match the provided MeetingDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetMeetingsByMeetingDate(params: GetMeetingsByMeetingDateRequestParams): Promise<GetMeetingsByMeetingDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByMeetingDate`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByMeetingDateResponseParams
        }

        /**
         * GetMeetingsByMeetingNoteUrl retrieves all rows from the meeting table that match the provided MeetingNoteUrl
         */
        public async GetMeetingsByMeetingNoteUrl(params: GetMeetingsByMeetingNoteUrlRequestParams): Promise<GetMeetingsByMeetingNoteUrlResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByMeetingNoteUrl`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByMeetingNoteUrlResponseParams
        }

        /**
         * GetMeetingsByName retrieves all rows from the meeting table that match the provided Name
         */
        public async GetMeetingsByName(params: GetMeetingsByNameRequestParams): Promise<GetMeetingsByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByName`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByNameResponseParams
        }

        /**
         * GetMeetingsByOrganizationLocationId retrieves all rows from the meeting table that match the provided OrganizationLocationId
         */
        public async GetMeetingsByOrganizationLocationId(params: GetMeetingsByOrganizationLocationIdRequestParams): Promise<GetMeetingsByOrganizationLocationIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByOrganizationLocationId`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByOrganizationLocationIdResponseParams
        }

        /**
         * GetMeetingsByTypeId retrieves all rows from the meeting table that match the provided TypeId
         */
        public async GetMeetingsByTypeId(params: GetMeetingsByTypeIdRequestParams): Promise<GetMeetingsByTypeIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByTypeId`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByTypeIdResponseParams
        }

        /**
         * GetMeetingsByUpdatedAt retrieves all rows from the meeting table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetMeetingsByUpdatedAt(params: GetMeetingsByUpdatedAtRequestParams): Promise<GetMeetingsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByUpdatedAtResponseParams
        }

        /**
         * GetMeetingsByUpdatedBy retrieves all rows from the meeting table that match the provided UpdatedBy
         */
        public async GetMeetingsByUpdatedBy(params: GetMeetingsByUpdatedByRequestParams): Promise<GetMeetingsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByUpdatedByResponseParams
        }

        /**
         * GetMeetingsByVirtual retrieves all rows from the meeting table that match the provided Virtual
         */
        public async GetMeetingsByVirtual(params: GetMeetingsByVirtualRequestParams): Promise<GetMeetingsByVirtualResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetMeetingsByVirtual`, JSON.stringify(params))
            return await resp.json() as GetMeetingsByVirtualResponseParams
        }

        /**
         * GetNewsletterSignupAuditById retrieves all rows from the newsletter_signup_audit table that match the provided identifier for a row in the newsletter_signup table
         */
        public async GetNewsletterSignupAuditById(params: GetNewsletterSignupAuditByIdRequestParams): Promise<GetNewsletterSignupAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetNewsletterSignupAuditById`, JSON.stringify(params))
            return await resp.json() as GetNewsletterSignupAuditResponseParams
        }

        /**
         * GetNewsletterSignupById retrieves all rows from the newsletter_signup table that match the provided identifier
         */
        public async GetNewsletterSignupById(params: GetNewsletterSignupByIdRequestParams): Promise<GetNewsletterSignupByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetNewsletterSignupById`, JSON.stringify(params))
            return await resp.json() as GetNewsletterSignupByIdResponseParams
        }

        /**
         * GetNewsletterSignupsByCreatedAt retrieves all rows from the newsletter_signup table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetNewsletterSignupsByCreatedAt(params: GetNewsletterSignupsByCreatedAtRequestParams): Promise<GetNewsletterSignupsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetNewsletterSignupsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetNewsletterSignupsByCreatedAtResponseParams
        }

        /**
         * GetNewsletterSignupsByEmail retrieves all rows from the newsletter_signup table that match the provided Email
         */
        public async GetNewsletterSignupsByEmail(params: GetNewsletterSignupsByEmailRequestParams): Promise<GetNewsletterSignupsByEmailResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetNewsletterSignupsByEmail`, JSON.stringify(params))
            return await resp.json() as GetNewsletterSignupsByEmailResponseParams
        }

        /**
         * GetNewsletterSignupsByIsDeleted retrieves all rows from the newsletter_signup table that match the provided IsDeleted
         */
        public async GetNewsletterSignupsByIsDeleted(params: GetNewsletterSignupsByIsDeletedRequestParams): Promise<GetNewsletterSignupsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetNewsletterSignupsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetNewsletterSignupsByIsDeletedResponseParams
        }

        /**
         * GetNewsletterSignupsByTimestamp retrieves all rows from the newsletter_signup table that match the provided Timestamp
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetNewsletterSignupsByTimestamp(params: GetNewsletterSignupsByTimestampRequestParams): Promise<GetNewsletterSignupsByTimestampResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetNewsletterSignupsByTimestamp`, JSON.stringify(params))
            return await resp.json() as GetNewsletterSignupsByTimestampResponseParams
        }

        /**
         * GetNewsletterSignupsByUpdatedAt retrieves all rows from the newsletter_signup table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetNewsletterSignupsByUpdatedAt(params: GetNewsletterSignupsByUpdatedAtRequestParams): Promise<GetNewsletterSignupsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetNewsletterSignupsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetNewsletterSignupsByUpdatedAtResponseParams
        }

        /**
         * GetOnCallRoleAuditById retrieves all rows from the on_call_role_audit table that match the provided identifier for a row in the on_call_role table
         */
        public async GetOnCallRoleAuditById(params: GetOnCallRoleAuditByIdRequestParams): Promise<GetOnCallRoleAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallRoleAuditById`, JSON.stringify(params))
            return await resp.json() as GetOnCallRoleAuditResponseParams
        }

        /**
         * GetOnCallRoleById retrieves all rows from the on_call_role table that match the provided identifier
         */
        public async GetOnCallRoleById(params: GetOnCallRoleByIdRequestParams): Promise<GetOnCallRoleByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallRoleById`, JSON.stringify(params))
            return await resp.json() as GetOnCallRoleByIdResponseParams
        }

        /**
         * GetOnCallRolesByCreatedAt retrieves all rows from the on_call_role table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOnCallRolesByCreatedAt(params: GetOnCallRolesByCreatedAtRequestParams): Promise<GetOnCallRolesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallRolesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetOnCallRolesByCreatedAtResponseParams
        }

        /**
         * GetOnCallRolesByCreatedBy retrieves all rows from the on_call_role table that match the provided CreatedBy
         */
        public async GetOnCallRolesByCreatedBy(params: GetOnCallRolesByCreatedByRequestParams): Promise<GetOnCallRolesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallRolesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetOnCallRolesByCreatedByResponseParams
        }

        /**
         * GetOnCallRolesByIsDeleted retrieves all rows from the on_call_role table that match the provided IsDeleted
         */
        public async GetOnCallRolesByIsDeleted(params: GetOnCallRolesByIsDeletedRequestParams): Promise<GetOnCallRolesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallRolesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetOnCallRolesByIsDeletedResponseParams
        }

        /**
         * GetOnCallRolesByMoreInfoUrl retrieves all rows from the on_call_role table that match the provided MoreInfoUrl
         */
        public async GetOnCallRolesByMoreInfoUrl(params: GetOnCallRolesByMoreInfoUrlRequestParams): Promise<GetOnCallRolesByMoreInfoUrlResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallRolesByMoreInfoUrl`, JSON.stringify(params))
            return await resp.json() as GetOnCallRolesByMoreInfoUrlResponseParams
        }

        /**
         * GetOnCallRolesByName retrieves all rows from the on_call_role table that match the provided Name
         */
        public async GetOnCallRolesByName(params: GetOnCallRolesByNameRequestParams): Promise<GetOnCallRolesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallRolesByName`, JSON.stringify(params))
            return await resp.json() as GetOnCallRolesByNameResponseParams
        }

        /**
         * GetOnCallRolesByRoleCode retrieves all rows from the on_call_role table that match the provided RoleCode
         */
        public async GetOnCallRolesByRoleCode(params: GetOnCallRolesByRoleCodeRequestParams): Promise<GetOnCallRolesByRoleCodeResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallRolesByRoleCode`, JSON.stringify(params))
            return await resp.json() as GetOnCallRolesByRoleCodeResponseParams
        }

        /**
         * GetOnCallRolesByUpdatedAt retrieves all rows from the on_call_role table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOnCallRolesByUpdatedAt(params: GetOnCallRolesByUpdatedAtRequestParams): Promise<GetOnCallRolesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallRolesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetOnCallRolesByUpdatedAtResponseParams
        }

        /**
         * GetOnCallRolesByUpdatedBy retrieves all rows from the on_call_role table that match the provided UpdatedBy
         */
        public async GetOnCallRolesByUpdatedBy(params: GetOnCallRolesByUpdatedByRequestParams): Promise<GetOnCallRolesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallRolesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetOnCallRolesByUpdatedByResponseParams
        }

        /**
         * GetOnCallScheduleAuditById retrieves all rows from the on_call_schedule_audit table that match the provided identifier for a row in the on_call_schedule table
         */
        public async GetOnCallScheduleAuditById(params: GetOnCallScheduleAuditByIdRequestParams): Promise<GetOnCallScheduleAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallScheduleAuditById`, JSON.stringify(params))
            return await resp.json() as GetOnCallScheduleAuditResponseParams
        }

        /**
         * GetOnCallScheduleById retrieves all rows from the on_call_schedule table that match the provided identifier
         */
        public async GetOnCallScheduleById(params: GetOnCallScheduleByIdRequestParams): Promise<GetOnCallScheduleByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallScheduleById`, JSON.stringify(params))
            return await resp.json() as GetOnCallScheduleByIdResponseParams
        }

        /**
         * GetOnCallSchedulesByContactId retrieves all rows from the on_call_schedule table that match the provided ContactId
         */
        public async GetOnCallSchedulesByContactId(params: GetOnCallSchedulesByContactIdRequestParams): Promise<GetOnCallSchedulesByContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallSchedulesByContactId`, JSON.stringify(params))
            return await resp.json() as GetOnCallSchedulesByContactIdResponseParams
        }

        /**
         * GetOnCallSchedulesByCreatedAt retrieves all rows from the on_call_schedule table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOnCallSchedulesByCreatedAt(params: GetOnCallSchedulesByCreatedAtRequestParams): Promise<GetOnCallSchedulesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallSchedulesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetOnCallSchedulesByCreatedAtResponseParams
        }

        /**
         * GetOnCallSchedulesByCreatedBy retrieves all rows from the on_call_schedule table that match the provided CreatedBy
         */
        public async GetOnCallSchedulesByCreatedBy(params: GetOnCallSchedulesByCreatedByRequestParams): Promise<GetOnCallSchedulesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallSchedulesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetOnCallSchedulesByCreatedByResponseParams
        }

        /**
         * GetOnCallSchedulesByDurationHours retrieves all rows from the on_call_schedule table that match the provided DurationHours
         */
        public async GetOnCallSchedulesByDurationHours(params: GetOnCallSchedulesByDurationHoursRequestParams): Promise<GetOnCallSchedulesByDurationHoursResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallSchedulesByDurationHours`, JSON.stringify(params))
            return await resp.json() as GetOnCallSchedulesByDurationHoursResponseParams
        }

        /**
         * GetOnCallSchedulesByIsDeleted retrieves all rows from the on_call_schedule table that match the provided IsDeleted
         */
        public async GetOnCallSchedulesByIsDeleted(params: GetOnCallSchedulesByIsDeletedRequestParams): Promise<GetOnCallSchedulesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallSchedulesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetOnCallSchedulesByIsDeletedResponseParams
        }

        /**
         * GetOnCallSchedulesByRoleId retrieves all rows from the on_call_schedule table that match the provided RoleId
         */
        public async GetOnCallSchedulesByRoleId(params: GetOnCallSchedulesByRoleIdRequestParams): Promise<GetOnCallSchedulesByRoleIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallSchedulesByRoleId`, JSON.stringify(params))
            return await resp.json() as GetOnCallSchedulesByRoleIdResponseParams
        }

        /**
         * GetOnCallSchedulesByStartDate retrieves all rows from the on_call_schedule table that match the provided StartDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOnCallSchedulesByStartDate(params: GetOnCallSchedulesByStartDateRequestParams): Promise<GetOnCallSchedulesByStartDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallSchedulesByStartDate`, JSON.stringify(params))
            return await resp.json() as GetOnCallSchedulesByStartDateResponseParams
        }

        /**
         * GetOnCallSchedulesByUpdatedAt retrieves all rows from the on_call_schedule table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOnCallSchedulesByUpdatedAt(params: GetOnCallSchedulesByUpdatedAtRequestParams): Promise<GetOnCallSchedulesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallSchedulesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetOnCallSchedulesByUpdatedAtResponseParams
        }

        /**
         * GetOnCallSchedulesByUpdatedBy retrieves all rows from the on_call_schedule table that match the provided UpdatedBy
         */
        public async GetOnCallSchedulesByUpdatedBy(params: GetOnCallSchedulesByUpdatedByRequestParams): Promise<GetOnCallSchedulesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOnCallSchedulesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetOnCallSchedulesByUpdatedByResponseParams
        }

        public async GetOpenPRsStatistics(params: GetOpenPRsStatisticsParams): Promise<GetOpenPRsStatisticsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpenPRsStatistics`, JSON.stringify(params))
            return await resp.json() as GetOpenPRsStatisticsResponse
        }

        /**
         * GetOpportunitiesByCompanyId retrieves all rows from the opportunity table that match the provided CompanyId
         */
        public async GetOpportunitiesByCompanyId(params: GetOpportunitiesByCompanyIdRequestParams): Promise<GetOpportunitiesByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByCompanyIdResponseParams
        }

        /**
         * GetOpportunitiesByCreatedAt retrieves all rows from the opportunity table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunitiesByCreatedAt(params: GetOpportunitiesByCreatedAtRequestParams): Promise<GetOpportunitiesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByCreatedAtResponseParams
        }

        /**
         * GetOpportunitiesByCreatedBy retrieves all rows from the opportunity table that match the provided CreatedBy
         */
        public async GetOpportunitiesByCreatedBy(params: GetOpportunitiesByCreatedByRequestParams): Promise<GetOpportunitiesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByCreatedByResponseParams
        }

        /**
         * GetOpportunitiesByEstimatedClose retrieves all rows from the opportunity table that match the provided EstimatedClose
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunitiesByEstimatedClose(params: GetOpportunitiesByEstimatedCloseRequestParams): Promise<GetOpportunitiesByEstimatedCloseResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByEstimatedClose`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByEstimatedCloseResponseParams
        }

        /**
         * GetOpportunitiesByEstimatedMrr retrieves all rows from the opportunity table that match the provided float query
         * 
         * Supported queries include:
         * - Less
         * - Greater
         * - Between
         */
        public async GetOpportunitiesByEstimatedMrr(params: GetOpportunitiesByEstimatedMrrRequestParams): Promise<GetOpportunitiesByEstimatedMrrResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByEstimatedMrr`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByEstimatedMrrResponseParams
        }

        /**
         * GetOpportunitiesByFunnelStepId retrieves all rows from the opportunity table that match the provided FunnelStepId
         */
        public async GetOpportunitiesByFunnelStepId(params: GetOpportunitiesByFunnelStepIdRequestParams): Promise<GetOpportunitiesByFunnelStepIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByFunnelStepId`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByFunnelStepIdResponseParams
        }

        /**
         * GetOpportunitiesByIsDeleted retrieves all rows from the opportunity table that match the provided IsDeleted
         */
        public async GetOpportunitiesByIsDeleted(params: GetOpportunitiesByIsDeletedRequestParams): Promise<GetOpportunitiesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByIsDeletedResponseParams
        }

        /**
         * GetOpportunitiesByName retrieves all rows from the opportunity table that match the provided Name
         */
        public async GetOpportunitiesByName(params: GetOpportunitiesByNameRequestParams): Promise<GetOpportunitiesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByName`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByNameResponseParams
        }

        /**
         * GetOpportunitiesByOpportunityTypeId retrieves all rows from the opportunity table that match the provided OpportunityTypeId
         */
        public async GetOpportunitiesByOpportunityTypeId(params: GetOpportunitiesByOpportunityTypeIdRequestParams): Promise<GetOpportunitiesByOpportunityTypeIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByOpportunityTypeId`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByOpportunityTypeIdResponseParams
        }

        /**
         * GetOpportunitiesByProbabilityPercentage retrieves all rows from the opportunity table that match the provided float query
         * 
         * Supported queries include:
         * - Less
         * - Greater
         * - Between
         */
        public async GetOpportunitiesByProbabilityPercentage(params: GetOpportunitiesByProbabilityPercentageRequestParams): Promise<GetOpportunitiesByProbabilityPercentageResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByProbabilityPercentage`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByProbabilityPercentageResponseParams
        }

        /**
         * GetOpportunitiesByUpdatedAt retrieves all rows from the opportunity table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunitiesByUpdatedAt(params: GetOpportunitiesByUpdatedAtRequestParams): Promise<GetOpportunitiesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByUpdatedAtResponseParams
        }

        /**
         * GetOpportunitiesByUpdatedBy retrieves all rows from the opportunity table that match the provided UpdatedBy
         */
        public async GetOpportunitiesByUpdatedBy(params: GetOpportunitiesByUpdatedByRequestParams): Promise<GetOpportunitiesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunitiesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetOpportunitiesByUpdatedByResponseParams
        }

        /**
         * GetOpportunityAuditById retrieves all rows from the opportunity_audit table that match the provided identifier for a row in the opportunity table
         */
        public async GetOpportunityAuditById(params: GetOpportunityAuditByIdRequestParams): Promise<GetOpportunityAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityAuditById`, JSON.stringify(params))
            return await resp.json() as GetOpportunityAuditResponseParams
        }

        /**
         * GetOpportunityById retrieves all rows from the opportunity table that match the provided identifier
         */
        public async GetOpportunityById(params: GetOpportunityByIdRequestParams): Promise<GetOpportunityByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityById`, JSON.stringify(params))
            return await resp.json() as GetOpportunityByIdResponseParams
        }

        /**
         * GetOpportunityFunnelAuditById retrieves all rows from the opportunity_funnel_audit table that match the provided identifier for a row in the opportunity_funnel table
         */
        public async GetOpportunityFunnelAuditById(params: GetOpportunityFunnelAuditByIdRequestParams): Promise<GetOpportunityFunnelAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelAuditById`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelAuditResponseParams
        }

        /**
         * GetOpportunityFunnelById retrieves all rows from the opportunity_funnel table that match the provided identifier
         */
        public async GetOpportunityFunnelById(params: GetOpportunityFunnelByIdRequestParams): Promise<GetOpportunityFunnelByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelById`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelByIdResponseParams
        }

        /**
         * GetOpportunityFunnelStepAuditById retrieves all rows from the opportunity_funnel_step_audit table that match the provided identifier for a row in the opportunity_funnel_step table
         */
        public async GetOpportunityFunnelStepAuditById(params: GetOpportunityFunnelStepAuditByIdRequestParams): Promise<GetOpportunityFunnelStepAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelStepAuditById`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelStepAuditResponseParams
        }

        /**
         * GetOpportunityFunnelStepById retrieves all rows from the opportunity_funnel_step table that match the provided identifier
         */
        public async GetOpportunityFunnelStepById(params: GetOpportunityFunnelStepByIdRequestParams): Promise<GetOpportunityFunnelStepByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelStepById`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelStepByIdResponseParams
        }

        /**
         * GetOpportunityFunnelStepsByCreatedAt retrieves all rows from the opportunity_funnel_step table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunityFunnelStepsByCreatedAt(params: GetOpportunityFunnelStepsByCreatedAtRequestParams): Promise<GetOpportunityFunnelStepsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelStepsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelStepsByCreatedAtResponseParams
        }

        /**
         * GetOpportunityFunnelStepsByCreatedBy retrieves all rows from the opportunity_funnel_step table that match the provided CreatedBy
         */
        public async GetOpportunityFunnelStepsByCreatedBy(params: GetOpportunityFunnelStepsByCreatedByRequestParams): Promise<GetOpportunityFunnelStepsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelStepsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelStepsByCreatedByResponseParams
        }

        /**
         * GetOpportunityFunnelStepsByIsDeleted retrieves all rows from the opportunity_funnel_step table that match the provided IsDeleted
         */
        public async GetOpportunityFunnelStepsByIsDeleted(params: GetOpportunityFunnelStepsByIsDeletedRequestParams): Promise<GetOpportunityFunnelStepsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelStepsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelStepsByIsDeletedResponseParams
        }

        /**
         * GetOpportunityFunnelStepsByName retrieves all rows from the opportunity_funnel_step table that match the provided Name
         */
        public async GetOpportunityFunnelStepsByName(params: GetOpportunityFunnelStepsByNameRequestParams): Promise<GetOpportunityFunnelStepsByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelStepsByName`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelStepsByNameResponseParams
        }

        /**
         * GetOpportunityFunnelStepsByOpportunityFunnelId retrieves all rows from the opportunity_funnel_step table that match the provided OpportunityFunnelId
         */
        public async GetOpportunityFunnelStepsByOpportunityFunnelId(params: GetOpportunityFunnelStepsByOpportunityFunnelIdRequestParams): Promise<GetOpportunityFunnelStepsByOpportunityFunnelIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelStepsByOpportunityFunnelId`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelStepsByOpportunityFunnelIdResponseParams
        }

        /**
         * GetOpportunityFunnelStepsBySequence retrieves all rows from the opportunity_funnel_step table that match the provided Sequence
         */
        public async GetOpportunityFunnelStepsBySequence(params: GetOpportunityFunnelStepsBySequenceRequestParams): Promise<GetOpportunityFunnelStepsBySequenceResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelStepsBySequence`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelStepsBySequenceResponseParams
        }

        /**
         * GetOpportunityFunnelStepsByUpdatedAt retrieves all rows from the opportunity_funnel_step table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunityFunnelStepsByUpdatedAt(params: GetOpportunityFunnelStepsByUpdatedAtRequestParams): Promise<GetOpportunityFunnelStepsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelStepsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelStepsByUpdatedAtResponseParams
        }

        /**
         * GetOpportunityFunnelStepsByUpdatedBy retrieves all rows from the opportunity_funnel_step table that match the provided UpdatedBy
         */
        public async GetOpportunityFunnelStepsByUpdatedBy(params: GetOpportunityFunnelStepsByUpdatedByRequestParams): Promise<GetOpportunityFunnelStepsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelStepsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelStepsByUpdatedByResponseParams
        }

        /**
         * GetOpportunityFunnelsByCreatedAt retrieves all rows from the opportunity_funnel table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunityFunnelsByCreatedAt(params: GetOpportunityFunnelsByCreatedAtRequestParams): Promise<GetOpportunityFunnelsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelsByCreatedAtResponseParams
        }

        /**
         * GetOpportunityFunnelsByCreatedBy retrieves all rows from the opportunity_funnel table that match the provided CreatedBy
         */
        public async GetOpportunityFunnelsByCreatedBy(params: GetOpportunityFunnelsByCreatedByRequestParams): Promise<GetOpportunityFunnelsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelsByCreatedByResponseParams
        }

        /**
         * GetOpportunityFunnelsByIsDeleted retrieves all rows from the opportunity_funnel table that match the provided IsDeleted
         */
        public async GetOpportunityFunnelsByIsDeleted(params: GetOpportunityFunnelsByIsDeletedRequestParams): Promise<GetOpportunityFunnelsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelsByIsDeletedResponseParams
        }

        /**
         * GetOpportunityFunnelsByName retrieves all rows from the opportunity_funnel table that match the provided Name
         */
        public async GetOpportunityFunnelsByName(params: GetOpportunityFunnelsByNameRequestParams): Promise<GetOpportunityFunnelsByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelsByName`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelsByNameResponseParams
        }

        /**
         * GetOpportunityFunnelsByOpportunityTypeId retrieves all rows from the opportunity_funnel table that match the provided OpportunityTypeId
         */
        public async GetOpportunityFunnelsByOpportunityTypeId(params: GetOpportunityFunnelsByOpportunityTypeIdRequestParams): Promise<GetOpportunityFunnelsByOpportunityTypeIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelsByOpportunityTypeId`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelsByOpportunityTypeIdResponseParams
        }

        /**
         * GetOpportunityFunnelsBySequence retrieves all rows from the opportunity_funnel table that match the provided Sequence
         */
        public async GetOpportunityFunnelsBySequence(params: GetOpportunityFunnelsBySequenceRequestParams): Promise<GetOpportunityFunnelsBySequenceResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelsBySequence`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelsBySequenceResponseParams
        }

        /**
         * GetOpportunityFunnelsByUpdatedAt retrieves all rows from the opportunity_funnel table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunityFunnelsByUpdatedAt(params: GetOpportunityFunnelsByUpdatedAtRequestParams): Promise<GetOpportunityFunnelsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelsByUpdatedAtResponseParams
        }

        /**
         * GetOpportunityFunnelsByUpdatedBy retrieves all rows from the opportunity_funnel table that match the provided UpdatedBy
         */
        public async GetOpportunityFunnelsByUpdatedBy(params: GetOpportunityFunnelsByUpdatedByRequestParams): Promise<GetOpportunityFunnelsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityFunnelsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetOpportunityFunnelsByUpdatedByResponseParams
        }

        /**
         * GetOpportunityProductAuditById retrieves all rows from the opportunity_product_audit table that match the provided identifier for a row in the opportunity_product table
         */
        public async GetOpportunityProductAuditById(params: GetOpportunityProductAuditByIdRequestParams): Promise<GetOpportunityProductAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityProductAuditById`, JSON.stringify(params))
            return await resp.json() as GetOpportunityProductAuditResponseParams
        }

        /**
         * GetOpportunityProductById retrieves all rows from the opportunity_product table that match the provided identifier
         */
        public async GetOpportunityProductById(params: GetOpportunityProductByIdRequestParams): Promise<GetOpportunityProductByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityProductById`, JSON.stringify(params))
            return await resp.json() as GetOpportunityProductByIdResponseParams
        }

        /**
         * GetOpportunityProductsByCreatedAt retrieves all rows from the opportunity_product table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunityProductsByCreatedAt(params: GetOpportunityProductsByCreatedAtRequestParams): Promise<GetOpportunityProductsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityProductsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetOpportunityProductsByCreatedAtResponseParams
        }

        /**
         * GetOpportunityProductsByCreatedBy retrieves all rows from the opportunity_product table that match the provided CreatedBy
         */
        public async GetOpportunityProductsByCreatedBy(params: GetOpportunityProductsByCreatedByRequestParams): Promise<GetOpportunityProductsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityProductsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetOpportunityProductsByCreatedByResponseParams
        }

        /**
         * GetOpportunityProductsByIsDeleted retrieves all rows from the opportunity_product table that match the provided IsDeleted
         */
        public async GetOpportunityProductsByIsDeleted(params: GetOpportunityProductsByIsDeletedRequestParams): Promise<GetOpportunityProductsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityProductsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetOpportunityProductsByIsDeletedResponseParams
        }

        /**
         * GetOpportunityProductsByNote retrieves all rows from the opportunity_product table that match the provided Note
         */
        public async GetOpportunityProductsByNote(params: GetOpportunityProductsByNoteRequestParams): Promise<GetOpportunityProductsByNoteResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityProductsByNote`, JSON.stringify(params))
            return await resp.json() as GetOpportunityProductsByNoteResponseParams
        }

        /**
         * GetOpportunityProductsByOpportunityId retrieves all rows from the opportunity_product table that match the provided OpportunityId
         */
        public async GetOpportunityProductsByOpportunityId(params: GetOpportunityProductsByOpportunityIdRequestParams): Promise<GetOpportunityProductsByOpportunityIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityProductsByOpportunityId`, JSON.stringify(params))
            return await resp.json() as GetOpportunityProductsByOpportunityIdResponseParams
        }

        /**
         * GetOpportunityProductsByProductId retrieves all rows from the opportunity_product table that match the provided ProductId
         */
        public async GetOpportunityProductsByProductId(params: GetOpportunityProductsByProductIdRequestParams): Promise<GetOpportunityProductsByProductIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityProductsByProductId`, JSON.stringify(params))
            return await resp.json() as GetOpportunityProductsByProductIdResponseParams
        }

        /**
         * GetOpportunityProductsByUpdatedAt retrieves all rows from the opportunity_product table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunityProductsByUpdatedAt(params: GetOpportunityProductsByUpdatedAtRequestParams): Promise<GetOpportunityProductsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityProductsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetOpportunityProductsByUpdatedAtResponseParams
        }

        /**
         * GetOpportunityProductsByUpdatedBy retrieves all rows from the opportunity_product table that match the provided UpdatedBy
         */
        public async GetOpportunityProductsByUpdatedBy(params: GetOpportunityProductsByUpdatedByRequestParams): Promise<GetOpportunityProductsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityProductsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetOpportunityProductsByUpdatedByResponseParams
        }

        /**
         * GetOpportunityTypeAuditById retrieves all rows from the opportunity_type_audit table that match the provided identifier for a row in the opportunity_type table
         */
        public async GetOpportunityTypeAuditById(params: GetOpportunityTypeAuditByIdRequestParams): Promise<GetOpportunityTypeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityTypeAuditById`, JSON.stringify(params))
            return await resp.json() as GetOpportunityTypeAuditResponseParams
        }

        /**
         * GetOpportunityTypeById retrieves all rows from the opportunity_type table that match the provided identifier
         */
        public async GetOpportunityTypeById(params: GetOpportunityTypeByIdRequestParams): Promise<GetOpportunityTypeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityTypeById`, JSON.stringify(params))
            return await resp.json() as GetOpportunityTypeByIdResponseParams
        }

        /**
         * GetOpportunityTypesByCreatedAt retrieves all rows from the opportunity_type table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunityTypesByCreatedAt(params: GetOpportunityTypesByCreatedAtRequestParams): Promise<GetOpportunityTypesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityTypesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetOpportunityTypesByCreatedAtResponseParams
        }

        /**
         * GetOpportunityTypesByCreatedBy retrieves all rows from the opportunity_type table that match the provided CreatedBy
         */
        public async GetOpportunityTypesByCreatedBy(params: GetOpportunityTypesByCreatedByRequestParams): Promise<GetOpportunityTypesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityTypesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetOpportunityTypesByCreatedByResponseParams
        }

        /**
         * GetOpportunityTypesByIsDeleted retrieves all rows from the opportunity_type table that match the provided IsDeleted
         */
        public async GetOpportunityTypesByIsDeleted(params: GetOpportunityTypesByIsDeletedRequestParams): Promise<GetOpportunityTypesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityTypesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetOpportunityTypesByIsDeletedResponseParams
        }

        /**
         * GetOpportunityTypesByName retrieves all rows from the opportunity_type table that match the provided Name
         */
        public async GetOpportunityTypesByName(params: GetOpportunityTypesByNameRequestParams): Promise<GetOpportunityTypesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityTypesByName`, JSON.stringify(params))
            return await resp.json() as GetOpportunityTypesByNameResponseParams
        }

        /**
         * GetOpportunityTypesByUpdatedAt retrieves all rows from the opportunity_type table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOpportunityTypesByUpdatedAt(params: GetOpportunityTypesByUpdatedAtRequestParams): Promise<GetOpportunityTypesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityTypesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetOpportunityTypesByUpdatedAtResponseParams
        }

        /**
         * GetOpportunityTypesByUpdatedBy retrieves all rows from the opportunity_type table that match the provided UpdatedBy
         */
        public async GetOpportunityTypesByUpdatedBy(params: GetOpportunityTypesByUpdatedByRequestParams): Promise<GetOpportunityTypesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOpportunityTypesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetOpportunityTypesByUpdatedByResponseParams
        }

        /**
         * GetOrganizationDocumentAuditById retrieves all rows from the organization_document_audit table that match the provided identifier for a row in the organization_document table
         */
        public async GetOrganizationDocumentAuditById(params: GetOrganizationDocumentAuditByIdRequestParams): Promise<GetOrganizationDocumentAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOrganizationDocumentAuditById`, JSON.stringify(params))
            return await resp.json() as GetOrganizationDocumentAuditResponseParams
        }

        /**
         * GetOrganizationDocumentById retrieves all rows from the organization_document table that match the provided identifier
         */
        public async GetOrganizationDocumentById(params: GetOrganizationDocumentByIdRequestParams): Promise<GetOrganizationDocumentByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOrganizationDocumentById`, JSON.stringify(params))
            return await resp.json() as GetOrganizationDocumentByIdResponseParams
        }

        /**
         * GetOrganizationDocumentsByCreatedAt retrieves all rows from the organization_document table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOrganizationDocumentsByCreatedAt(params: GetOrganizationDocumentsByCreatedAtRequestParams): Promise<GetOrganizationDocumentsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOrganizationDocumentsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetOrganizationDocumentsByCreatedAtResponseParams
        }

        /**
         * GetOrganizationDocumentsByDocumentId retrieves all rows from the organization_document table that match the provided DocumentId
         */
        public async GetOrganizationDocumentsByDocumentId(params: GetOrganizationDocumentsByDocumentIdRequestParams): Promise<GetOrganizationDocumentsByDocumentIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOrganizationDocumentsByDocumentId`, JSON.stringify(params))
            return await resp.json() as GetOrganizationDocumentsByDocumentIdResponseParams
        }

        /**
         * GetOrganizationDocumentsByIsDeleted retrieves all rows from the organization_document table that match the provided IsDeleted
         */
        public async GetOrganizationDocumentsByIsDeleted(params: GetOrganizationDocumentsByIsDeletedRequestParams): Promise<GetOrganizationDocumentsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOrganizationDocumentsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetOrganizationDocumentsByIsDeletedResponseParams
        }

        /**
         * GetOrganizationDocumentsByOrganizationId retrieves all rows from the organization_document table that match the provided OrganizationId
         */
        public async GetOrganizationDocumentsByOrganizationId(params: GetOrganizationDocumentsByOrganizationIdRequestParams): Promise<GetOrganizationDocumentsByOrganizationIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOrganizationDocumentsByOrganizationId`, JSON.stringify(params))
            return await resp.json() as GetOrganizationDocumentsByOrganizationIdResponseParams
        }

        /**
         * GetOrganizationDocumentsByUpdatedAt retrieves all rows from the organization_document table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetOrganizationDocumentsByUpdatedAt(params: GetOrganizationDocumentsByUpdatedAtRequestParams): Promise<GetOrganizationDocumentsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetOrganizationDocumentsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetOrganizationDocumentsByUpdatedAtResponseParams
        }

        /**
         * GetProductAuditById retrieves all rows from the product_audit table that match the provided identifier for a row in the product table
         */
        public async GetProductAuditById(params: GetProductAuditByIdRequestParams): Promise<GetProductAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductAuditById`, JSON.stringify(params))
            return await resp.json() as GetProductAuditResponseParams
        }

        /**
         * GetProductById retrieves all rows from the product table that match the provided identifier
         */
        public async GetProductById(params: GetProductByIdRequestParams): Promise<GetProductByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductById`, JSON.stringify(params))
            return await resp.json() as GetProductByIdResponseParams
        }

        /**
         * GetProductCategoriesByCreatedAt retrieves all rows from the product_category table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductCategoriesByCreatedAt(params: GetProductCategoriesByCreatedAtRequestParams): Promise<GetProductCategoriesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductCategoriesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetProductCategoriesByCreatedAtResponseParams
        }

        /**
         * GetProductCategoriesByCreatedBy retrieves all rows from the product_category table that match the provided CreatedBy
         */
        public async GetProductCategoriesByCreatedBy(params: GetProductCategoriesByCreatedByRequestParams): Promise<GetProductCategoriesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductCategoriesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetProductCategoriesByCreatedByResponseParams
        }

        /**
         * GetProductCategoriesByIsDeleted retrieves all rows from the product_category table that match the provided IsDeleted
         */
        public async GetProductCategoriesByIsDeleted(params: GetProductCategoriesByIsDeletedRequestParams): Promise<GetProductCategoriesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductCategoriesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetProductCategoriesByIsDeletedResponseParams
        }

        /**
         * GetProductCategoriesByName retrieves all rows from the product_category table that match the provided Name
         */
        public async GetProductCategoriesByName(params: GetProductCategoriesByNameRequestParams): Promise<GetProductCategoriesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductCategoriesByName`, JSON.stringify(params))
            return await resp.json() as GetProductCategoriesByNameResponseParams
        }

        /**
         * GetProductCategoriesByUpdatedAt retrieves all rows from the product_category table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductCategoriesByUpdatedAt(params: GetProductCategoriesByUpdatedAtRequestParams): Promise<GetProductCategoriesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductCategoriesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetProductCategoriesByUpdatedAtResponseParams
        }

        /**
         * GetProductCategoriesByUpdatedBy retrieves all rows from the product_category table that match the provided UpdatedBy
         */
        public async GetProductCategoriesByUpdatedBy(params: GetProductCategoriesByUpdatedByRequestParams): Promise<GetProductCategoriesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductCategoriesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetProductCategoriesByUpdatedByResponseParams
        }

        /**
         * GetProductCategoryAuditById retrieves all rows from the product_category_audit table that match the provided identifier for a row in the product_category table
         */
        public async GetProductCategoryAuditById(params: GetProductCategoryAuditByIdRequestParams): Promise<GetProductCategoryAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductCategoryAuditById`, JSON.stringify(params))
            return await resp.json() as GetProductCategoryAuditResponseParams
        }

        /**
         * GetProductCategoryById retrieves all rows from the product_category table that match the provided identifier
         */
        public async GetProductCategoryById(params: GetProductCategoryByIdRequestParams): Promise<GetProductCategoryByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductCategoryById`, JSON.stringify(params))
            return await resp.json() as GetProductCategoryByIdResponseParams
        }

        /**
         * GetProductDocumentAuditById retrieves all rows from the product_document_audit table that match the provided identifier for a row in the product_document table
         */
        public async GetProductDocumentAuditById(params: GetProductDocumentAuditByIdRequestParams): Promise<GetProductDocumentAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductDocumentAuditById`, JSON.stringify(params))
            return await resp.json() as GetProductDocumentAuditResponseParams
        }

        /**
         * GetProductDocumentById retrieves all rows from the product_document table that match the provided identifier
         */
        public async GetProductDocumentById(params: GetProductDocumentByIdRequestParams): Promise<GetProductDocumentByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductDocumentById`, JSON.stringify(params))
            return await resp.json() as GetProductDocumentByIdResponseParams
        }

        /**
         * GetProductDocumentsByCreatedAt retrieves all rows from the product_document table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductDocumentsByCreatedAt(params: GetProductDocumentsByCreatedAtRequestParams): Promise<GetProductDocumentsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductDocumentsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetProductDocumentsByCreatedAtResponseParams
        }

        /**
         * GetProductDocumentsByCreatedBy retrieves all rows from the product_document table that match the provided CreatedBy
         */
        public async GetProductDocumentsByCreatedBy(params: GetProductDocumentsByCreatedByRequestParams): Promise<GetProductDocumentsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductDocumentsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetProductDocumentsByCreatedByResponseParams
        }

        /**
         * GetProductDocumentsByDocumentId retrieves all rows from the product_document table that match the provided DocumentId
         */
        public async GetProductDocumentsByDocumentId(params: GetProductDocumentsByDocumentIdRequestParams): Promise<GetProductDocumentsByDocumentIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductDocumentsByDocumentId`, JSON.stringify(params))
            return await resp.json() as GetProductDocumentsByDocumentIdResponseParams
        }

        /**
         * GetProductDocumentsByIsDeleted retrieves all rows from the product_document table that match the provided IsDeleted
         */
        public async GetProductDocumentsByIsDeleted(params: GetProductDocumentsByIsDeletedRequestParams): Promise<GetProductDocumentsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductDocumentsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetProductDocumentsByIsDeletedResponseParams
        }

        /**
         * GetProductDocumentsByProductId retrieves all rows from the product_document table that match the provided ProductId
         */
        public async GetProductDocumentsByProductId(params: GetProductDocumentsByProductIdRequestParams): Promise<GetProductDocumentsByProductIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductDocumentsByProductId`, JSON.stringify(params))
            return await resp.json() as GetProductDocumentsByProductIdResponseParams
        }

        /**
         * GetProductDocumentsByUpdatedAt retrieves all rows from the product_document table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductDocumentsByUpdatedAt(params: GetProductDocumentsByUpdatedAtRequestParams): Promise<GetProductDocumentsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductDocumentsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetProductDocumentsByUpdatedAtResponseParams
        }

        /**
         * GetProductDocumentsByUpdatedBy retrieves all rows from the product_document table that match the provided UpdatedBy
         */
        public async GetProductDocumentsByUpdatedBy(params: GetProductDocumentsByUpdatedByRequestParams): Promise<GetProductDocumentsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductDocumentsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetProductDocumentsByUpdatedByResponseParams
        }

        /**
         * GetProductSubcategoriesByCreatedAt retrieves all rows from the product_subcategory table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductSubcategoriesByCreatedAt(params: GetProductSubcategoriesByCreatedAtRequestParams): Promise<GetProductSubcategoriesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductSubcategoriesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetProductSubcategoriesByCreatedAtResponseParams
        }

        /**
         * GetProductSubcategoriesByCreatedBy retrieves all rows from the product_subcategory table that match the provided CreatedBy
         */
        public async GetProductSubcategoriesByCreatedBy(params: GetProductSubcategoriesByCreatedByRequestParams): Promise<GetProductSubcategoriesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductSubcategoriesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetProductSubcategoriesByCreatedByResponseParams
        }

        /**
         * GetProductSubcategoriesByIsDeleted retrieves all rows from the product_subcategory table that match the provided IsDeleted
         */
        public async GetProductSubcategoriesByIsDeleted(params: GetProductSubcategoriesByIsDeletedRequestParams): Promise<GetProductSubcategoriesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductSubcategoriesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetProductSubcategoriesByIsDeletedResponseParams
        }

        /**
         * GetProductSubcategoriesByName retrieves all rows from the product_subcategory table that match the provided Name
         */
        public async GetProductSubcategoriesByName(params: GetProductSubcategoriesByNameRequestParams): Promise<GetProductSubcategoriesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductSubcategoriesByName`, JSON.stringify(params))
            return await resp.json() as GetProductSubcategoriesByNameResponseParams
        }

        /**
         * GetProductSubcategoriesByParentCategoryId retrieves all rows from the product_subcategory table that match the provided ParentCategoryId
         */
        public async GetProductSubcategoriesByParentCategoryId(params: GetProductSubcategoriesByParentCategoryIdRequestParams): Promise<GetProductSubcategoriesByParentCategoryIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductSubcategoriesByParentCategoryId`, JSON.stringify(params))
            return await resp.json() as GetProductSubcategoriesByParentCategoryIdResponseParams
        }

        /**
         * GetProductSubcategoriesByUpdatedAt retrieves all rows from the product_subcategory table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductSubcategoriesByUpdatedAt(params: GetProductSubcategoriesByUpdatedAtRequestParams): Promise<GetProductSubcategoriesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductSubcategoriesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetProductSubcategoriesByUpdatedAtResponseParams
        }

        /**
         * GetProductSubcategoriesByUpdatedBy retrieves all rows from the product_subcategory table that match the provided UpdatedBy
         */
        public async GetProductSubcategoriesByUpdatedBy(params: GetProductSubcategoriesByUpdatedByRequestParams): Promise<GetProductSubcategoriesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductSubcategoriesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetProductSubcategoriesByUpdatedByResponseParams
        }

        /**
         * GetProductSubcategoryAuditById retrieves all rows from the product_subcategory_audit table that match the provided identifier for a row in the product_subcategory table
         */
        public async GetProductSubcategoryAuditById(params: GetProductSubcategoryAuditByIdRequestParams): Promise<GetProductSubcategoryAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductSubcategoryAuditById`, JSON.stringify(params))
            return await resp.json() as GetProductSubcategoryAuditResponseParams
        }

        /**
         * GetProductSubcategoryById retrieves all rows from the product_subcategory table that match the provided identifier
         */
        public async GetProductSubcategoryById(params: GetProductSubcategoryByIdRequestParams): Promise<GetProductSubcategoryByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductSubcategoryById`, JSON.stringify(params))
            return await resp.json() as GetProductSubcategoryByIdResponseParams
        }

        /**
         * GetProductUserAuditById retrieves all rows from the product_user_audit table that match the provided identifier for a row in the product_user table
         */
        public async GetProductUserAuditById(params: GetProductUserAuditByIdRequestParams): Promise<GetProductUserAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUserAuditById`, JSON.stringify(params))
            return await resp.json() as GetProductUserAuditResponseParams
        }

        /**
         * GetProductUserById retrieves all rows from the product_user table that match the provided identifier
         */
        public async GetProductUserById(params: GetProductUserByIdRequestParams): Promise<GetProductUserByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUserById`, JSON.stringify(params))
            return await resp.json() as GetProductUserByIdResponseParams
        }

        /**
         * GetProductUsersByActive retrieves all rows from the product_user table that match the provided Active
         */
        public async GetProductUsersByActive(params: GetProductUsersByActiveRequestParams): Promise<GetProductUsersByActiveResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUsersByActive`, JSON.stringify(params))
            return await resp.json() as GetProductUsersByActiveResponseParams
        }

        /**
         * GetProductUsersByCreatedAt retrieves all rows from the product_user table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductUsersByCreatedAt(params: GetProductUsersByCreatedAtRequestParams): Promise<GetProductUsersByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUsersByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetProductUsersByCreatedAtResponseParams
        }

        /**
         * GetProductUsersByCreatedBy retrieves all rows from the product_user table that match the provided CreatedBy
         */
        public async GetProductUsersByCreatedBy(params: GetProductUsersByCreatedByRequestParams): Promise<GetProductUsersByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUsersByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetProductUsersByCreatedByResponseParams
        }

        /**
         * GetProductUsersByEndDate retrieves all rows from the product_user table that match the provided EndDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductUsersByEndDate(params: GetProductUsersByEndDateRequestParams): Promise<GetProductUsersByEndDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUsersByEndDate`, JSON.stringify(params))
            return await resp.json() as GetProductUsersByEndDateResponseParams
        }

        /**
         * GetProductUsersByIsDeleted retrieves all rows from the product_user table that match the provided IsDeleted
         */
        public async GetProductUsersByIsDeleted(params: GetProductUsersByIsDeletedRequestParams): Promise<GetProductUsersByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUsersByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetProductUsersByIsDeletedResponseParams
        }

        /**
         * GetProductUsersByProductId retrieves all rows from the product_user table that match the provided ProductId
         */
        public async GetProductUsersByProductId(params: GetProductUsersByProductIdRequestParams): Promise<GetProductUsersByProductIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUsersByProductId`, JSON.stringify(params))
            return await resp.json() as GetProductUsersByProductIdResponseParams
        }

        /**
         * GetProductUsersByStartDate retrieves all rows from the product_user table that match the provided StartDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductUsersByStartDate(params: GetProductUsersByStartDateRequestParams): Promise<GetProductUsersByStartDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUsersByStartDate`, JSON.stringify(params))
            return await resp.json() as GetProductUsersByStartDateResponseParams
        }

        /**
         * GetProductUsersByUpdatedAt retrieves all rows from the product_user table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductUsersByUpdatedAt(params: GetProductUsersByUpdatedAtRequestParams): Promise<GetProductUsersByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUsersByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetProductUsersByUpdatedAtResponseParams
        }

        /**
         * GetProductUsersByUpdatedBy retrieves all rows from the product_user table that match the provided UpdatedBy
         */
        public async GetProductUsersByUpdatedBy(params: GetProductUsersByUpdatedByRequestParams): Promise<GetProductUsersByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUsersByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetProductUsersByUpdatedByResponseParams
        }

        /**
         * GetProductUsersByUserCompanyId retrieves all rows from the product_user table that match the provided UserCompanyId
         */
        public async GetProductUsersByUserCompanyId(params: GetProductUsersByUserCompanyIdRequestParams): Promise<GetProductUsersByUserCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductUsersByUserCompanyId`, JSON.stringify(params))
            return await resp.json() as GetProductUsersByUserCompanyIdResponseParams
        }

        /**
         * GetProductsByCreatedAt retrieves all rows from the product table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductsByCreatedAt(params: GetProductsByCreatedAtRequestParams): Promise<GetProductsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetProductsByCreatedAtResponseParams
        }

        /**
         * GetProductsByCreatedBy retrieves all rows from the product table that match the provided CreatedBy
         */
        public async GetProductsByCreatedBy(params: GetProductsByCreatedByRequestParams): Promise<GetProductsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetProductsByCreatedByResponseParams
        }

        /**
         * GetProductsByIsDeleted retrieves all rows from the product table that match the provided IsDeleted
         */
        public async GetProductsByIsDeleted(params: GetProductsByIsDeletedRequestParams): Promise<GetProductsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetProductsByIsDeletedResponseParams
        }

        /**
         * GetProductsByName retrieves all rows from the product table that match the provided Name
         */
        public async GetProductsByName(params: GetProductsByNameRequestParams): Promise<GetProductsByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductsByName`, JSON.stringify(params))
            return await resp.json() as GetProductsByNameResponseParams
        }

        /**
         * GetProductsByProductCategoryId retrieves all rows from the product table that match the provided ProductCategoryId
         */
        public async GetProductsByProductCategoryId(params: GetProductsByProductCategoryIdRequestParams): Promise<GetProductsByProductCategoryIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductsByProductCategoryId`, JSON.stringify(params))
            return await resp.json() as GetProductsByProductCategoryIdResponseParams
        }

        /**
         * GetProductsByProductInformationUrl retrieves all rows from the product table that match the provided ProductInformationUrl
         */
        public async GetProductsByProductInformationUrl(params: GetProductsByProductInformationUrlRequestParams): Promise<GetProductsByProductInformationUrlResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductsByProductInformationUrl`, JSON.stringify(params))
            return await resp.json() as GetProductsByProductInformationUrlResponseParams
        }

        /**
         * GetProductsByProductSubcategoryId retrieves all rows from the product table that match the provided ProductSubcategoryId
         */
        public async GetProductsByProductSubcategoryId(params: GetProductsByProductSubcategoryIdRequestParams): Promise<GetProductsByProductSubcategoryIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductsByProductSubcategoryId`, JSON.stringify(params))
            return await resp.json() as GetProductsByProductSubcategoryIdResponseParams
        }

        /**
         * GetProductsByProviderCompanyId retrieves all rows from the product table that match the provided ProviderCompanyId
         */
        public async GetProductsByProviderCompanyId(params: GetProductsByProviderCompanyIdRequestParams): Promise<GetProductsByProviderCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductsByProviderCompanyId`, JSON.stringify(params))
            return await resp.json() as GetProductsByProviderCompanyIdResponseParams
        }

        /**
         * GetProductsByUpdatedAt retrieves all rows from the product table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetProductsByUpdatedAt(params: GetProductsByUpdatedAtRequestParams): Promise<GetProductsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetProductsByUpdatedAtResponseParams
        }

        /**
         * GetProductsByUpdatedBy retrieves all rows from the product table that match the provided UpdatedBy
         */
        public async GetProductsByUpdatedBy(params: GetProductsByUpdatedByRequestParams): Promise<GetProductsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetProductsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetProductsByUpdatedByResponseParams
        }

        /**
         * This endpoint retrieves the number of opportunities that reached each funnel step per day.
         */
        public async GetReachedFunnelStepPerDay(params: GetReachedFunnelStepPerDayParams): Promise<GetReachedFunnelStepPerDayResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetReachedFunnelStepPerDay`, JSON.stringify(params))
            return await resp.json() as GetReachedFunnelStepPerDayResponse
        }

        /**
         * GetSkrymCompanyRoleAreaAuditById retrieves all rows from the skrym_company_role_area_audit table that match the provided identifier for a row in the skrym_company_role_area table
         */
        public async GetSkrymCompanyRoleAreaAuditById(params: GetSkrymCompanyRoleAreaAuditByIdRequestParams): Promise<GetSkrymCompanyRoleAreaAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRoleAreaAuditById`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRoleAreaAuditResponseParams
        }

        /**
         * GetSkrymCompanyRoleAreaById retrieves all rows from the skrym_company_role_area table that match the provided identifier
         */
        public async GetSkrymCompanyRoleAreaById(params: GetSkrymCompanyRoleAreaByIdRequestParams): Promise<GetSkrymCompanyRoleAreaByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRoleAreaById`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRoleAreaByIdResponseParams
        }

        /**
         * GetSkrymCompanyRoleAreasByCreatedAt retrieves all rows from the skrym_company_role_area table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSkrymCompanyRoleAreasByCreatedAt(params: GetSkrymCompanyRoleAreasByCreatedAtRequestParams): Promise<GetSkrymCompanyRoleAreasByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRoleAreasByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRoleAreasByCreatedAtResponseParams
        }

        /**
         * GetSkrymCompanyRoleAreasByCreatedBy retrieves all rows from the skrym_company_role_area table that match the provided CreatedBy
         */
        public async GetSkrymCompanyRoleAreasByCreatedBy(params: GetSkrymCompanyRoleAreasByCreatedByRequestParams): Promise<GetSkrymCompanyRoleAreasByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRoleAreasByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRoleAreasByCreatedByResponseParams
        }

        /**
         * GetSkrymCompanyRoleAreasByIsDeleted retrieves all rows from the skrym_company_role_area table that match the provided IsDeleted
         */
        public async GetSkrymCompanyRoleAreasByIsDeleted(params: GetSkrymCompanyRoleAreasByIsDeletedRequestParams): Promise<GetSkrymCompanyRoleAreasByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRoleAreasByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRoleAreasByIsDeletedResponseParams
        }

        /**
         * GetSkrymCompanyRoleAreasByName retrieves all rows from the skrym_company_role_area table that match the provided Name
         */
        public async GetSkrymCompanyRoleAreasByName(params: GetSkrymCompanyRoleAreasByNameRequestParams): Promise<GetSkrymCompanyRoleAreasByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRoleAreasByName`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRoleAreasByNameResponseParams
        }

        /**
         * GetSkrymCompanyRoleAreasByUpdatedAt retrieves all rows from the skrym_company_role_area table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSkrymCompanyRoleAreasByUpdatedAt(params: GetSkrymCompanyRoleAreasByUpdatedAtRequestParams): Promise<GetSkrymCompanyRoleAreasByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRoleAreasByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRoleAreasByUpdatedAtResponseParams
        }

        /**
         * GetSkrymCompanyRoleAreasByUpdatedBy retrieves all rows from the skrym_company_role_area table that match the provided UpdatedBy
         */
        public async GetSkrymCompanyRoleAreasByUpdatedBy(params: GetSkrymCompanyRoleAreasByUpdatedByRequestParams): Promise<GetSkrymCompanyRoleAreasByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRoleAreasByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRoleAreasByUpdatedByResponseParams
        }

        /**
         * GetSkrymCompanyRoleAuditById retrieves all rows from the skrym_company_role_audit table that match the provided identifier for a row in the skrym_company_role table
         */
        public async GetSkrymCompanyRoleAuditById(params: GetSkrymCompanyRoleAuditByIdRequestParams): Promise<GetSkrymCompanyRoleAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRoleAuditById`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRoleAuditResponseParams
        }

        /**
         * GetSkrymCompanyRoleById retrieves all rows from the skrym_company_role table that match the provided identifier
         */
        public async GetSkrymCompanyRoleById(params: GetSkrymCompanyRoleByIdRequestParams): Promise<GetSkrymCompanyRoleByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRoleById`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRoleByIdResponseParams
        }

        /**
         * GetSkrymCompanyRolesByAreaId retrieves all rows from the skrym_company_role table that match the provided AreaId
         */
        public async GetSkrymCompanyRolesByAreaId(params: GetSkrymCompanyRolesByAreaIdRequestParams): Promise<GetSkrymCompanyRolesByAreaIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRolesByAreaId`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRolesByAreaIdResponseParams
        }

        /**
         * GetSkrymCompanyRolesByCreatedAt retrieves all rows from the skrym_company_role table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSkrymCompanyRolesByCreatedAt(params: GetSkrymCompanyRolesByCreatedAtRequestParams): Promise<GetSkrymCompanyRolesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRolesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRolesByCreatedAtResponseParams
        }

        /**
         * GetSkrymCompanyRolesByCreatedBy retrieves all rows from the skrym_company_role table that match the provided CreatedBy
         */
        public async GetSkrymCompanyRolesByCreatedBy(params: GetSkrymCompanyRolesByCreatedByRequestParams): Promise<GetSkrymCompanyRolesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRolesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRolesByCreatedByResponseParams
        }

        /**
         * GetSkrymCompanyRolesByIsDeleted retrieves all rows from the skrym_company_role table that match the provided IsDeleted
         */
        public async GetSkrymCompanyRolesByIsDeleted(params: GetSkrymCompanyRolesByIsDeletedRequestParams): Promise<GetSkrymCompanyRolesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRolesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRolesByIsDeletedResponseParams
        }

        /**
         * GetSkrymCompanyRolesByName retrieves all rows from the skrym_company_role table that match the provided Name
         */
        public async GetSkrymCompanyRolesByName(params: GetSkrymCompanyRolesByNameRequestParams): Promise<GetSkrymCompanyRolesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRolesByName`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRolesByNameResponseParams
        }

        /**
         * GetSkrymCompanyRolesByUpdatedAt retrieves all rows from the skrym_company_role table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSkrymCompanyRolesByUpdatedAt(params: GetSkrymCompanyRolesByUpdatedAtRequestParams): Promise<GetSkrymCompanyRolesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRolesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRolesByUpdatedAtResponseParams
        }

        /**
         * GetSkrymCompanyRolesByUpdatedBy retrieves all rows from the skrym_company_role table that match the provided UpdatedBy
         */
        public async GetSkrymCompanyRolesByUpdatedBy(params: GetSkrymCompanyRolesByUpdatedByRequestParams): Promise<GetSkrymCompanyRolesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymCompanyRolesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetSkrymCompanyRolesByUpdatedByResponseParams
        }

        /**
         * GetSkrymContactRoleAuditById retrieves all rows from the skrym_contact_role_audit table that match the provided identifier for a row in the skrym_contact_role table
         */
        public async GetSkrymContactRoleAuditById(params: GetSkrymContactRoleAuditByIdRequestParams): Promise<GetSkrymContactRoleAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRoleAuditById`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRoleAuditResponseParams
        }

        /**
         * GetSkrymContactRoleById retrieves all rows from the skrym_contact_role table that match the provided identifier
         */
        public async GetSkrymContactRoleById(params: GetSkrymContactRoleByIdRequestParams): Promise<GetSkrymContactRoleByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRoleById`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRoleByIdResponseParams
        }

        /**
         * GetSkrymContactRolesByActive retrieves all rows from the skrym_contact_role table that match the provided Active
         */
        public async GetSkrymContactRolesByActive(params: GetSkrymContactRolesByActiveRequestParams): Promise<GetSkrymContactRolesByActiveResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRolesByActive`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRolesByActiveResponseParams
        }

        /**
         * GetSkrymContactRolesByCompanyId retrieves all rows from the skrym_contact_role table that match the provided CompanyId
         */
        public async GetSkrymContactRolesByCompanyId(params: GetSkrymContactRolesByCompanyIdRequestParams): Promise<GetSkrymContactRolesByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRolesByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRolesByCompanyIdResponseParams
        }

        /**
         * GetSkrymContactRolesByCompanyRoleId retrieves all rows from the skrym_contact_role table that match the provided CompanyRoleId
         */
        public async GetSkrymContactRolesByCompanyRoleId(params: GetSkrymContactRolesByCompanyRoleIdRequestParams): Promise<GetSkrymContactRolesByCompanyRoleIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRolesByCompanyRoleId`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRolesByCompanyRoleIdResponseParams
        }

        /**
         * GetSkrymContactRolesByContactId retrieves all rows from the skrym_contact_role table that match the provided ContactId
         */
        public async GetSkrymContactRolesByContactId(params: GetSkrymContactRolesByContactIdRequestParams): Promise<GetSkrymContactRolesByContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRolesByContactId`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRolesByContactIdResponseParams
        }

        /**
         * GetSkrymContactRolesByCreatedAt retrieves all rows from the skrym_contact_role table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSkrymContactRolesByCreatedAt(params: GetSkrymContactRolesByCreatedAtRequestParams): Promise<GetSkrymContactRolesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRolesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRolesByCreatedAtResponseParams
        }

        /**
         * GetSkrymContactRolesByCreatedBy retrieves all rows from the skrym_contact_role table that match the provided CreatedBy
         */
        public async GetSkrymContactRolesByCreatedBy(params: GetSkrymContactRolesByCreatedByRequestParams): Promise<GetSkrymContactRolesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRolesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRolesByCreatedByResponseParams
        }

        /**
         * GetSkrymContactRolesByIsDeleted retrieves all rows from the skrym_contact_role table that match the provided IsDeleted
         */
        public async GetSkrymContactRolesByIsDeleted(params: GetSkrymContactRolesByIsDeletedRequestParams): Promise<GetSkrymContactRolesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRolesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRolesByIsDeletedResponseParams
        }

        /**
         * GetSkrymContactRolesByUpdatedAt retrieves all rows from the skrym_contact_role table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSkrymContactRolesByUpdatedAt(params: GetSkrymContactRolesByUpdatedAtRequestParams): Promise<GetSkrymContactRolesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRolesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRolesByUpdatedAtResponseParams
        }

        /**
         * GetSkrymContactRolesByUpdatedBy retrieves all rows from the skrym_contact_role table that match the provided UpdatedBy
         */
        public async GetSkrymContactRolesByUpdatedBy(params: GetSkrymContactRolesByUpdatedByRequestParams): Promise<GetSkrymContactRolesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSkrymContactRolesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetSkrymContactRolesByUpdatedByResponseParams
        }

        /**
         * GetSprintAuditById retrieves all rows from the sprint_audit table that match the provided identifier for a row in the sprint table
         */
        public async GetSprintAuditById(params: GetSprintAuditByIdRequestParams): Promise<GetSprintAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintAuditById`, JSON.stringify(params))
            return await resp.json() as GetSprintAuditResponseParams
        }

        /**
         * GetSprintById retrieves all rows from the sprint table that match the provided identifier
         */
        public async GetSprintById(params: GetSprintByIdRequestParams): Promise<GetSprintByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintById`, JSON.stringify(params))
            return await resp.json() as GetSprintByIdResponseParams
        }

        /**
         * GetSprintDailyStandupAuditById retrieves all rows from the sprint_daily_standup_audit table that match the provided identifier for a row in the sprint_daily_standup table
         */
        public async GetSprintDailyStandupAuditById(params: GetSprintDailyStandupAuditByIdRequestParams): Promise<GetSprintDailyStandupAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupAuditById`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupAuditResponseParams
        }

        /**
         * GetSprintDailyStandupById retrieves all rows from the sprint_daily_standup table that match the provided identifier
         */
        public async GetSprintDailyStandupById(params: GetSprintDailyStandupByIdRequestParams): Promise<GetSprintDailyStandupByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupById`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupByIdResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByCreatedAt retrieves all rows from the sprint_daily_standup_entry table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintDailyStandupEntriesByCreatedAt(params: GetSprintDailyStandupEntriesByCreatedAtRequestParams): Promise<GetSprintDailyStandupEntriesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByCreatedAtResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByCreatedBy retrieves all rows from the sprint_daily_standup_entry table that match the provided CreatedBy
         */
        public async GetSprintDailyStandupEntriesByCreatedBy(params: GetSprintDailyStandupEntriesByCreatedByRequestParams): Promise<GetSprintDailyStandupEntriesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByCreatedByResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByIsDeleted retrieves all rows from the sprint_daily_standup_entry table that match the provided IsDeleted
         */
        public async GetSprintDailyStandupEntriesByIsDeleted(params: GetSprintDailyStandupEntriesByIsDeletedRequestParams): Promise<GetSprintDailyStandupEntriesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByIsDeletedResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByPresent retrieves all rows from the sprint_daily_standup_entry table that match the provided Present
         */
        public async GetSprintDailyStandupEntriesByPresent(params: GetSprintDailyStandupEntriesByPresentRequestParams): Promise<GetSprintDailyStandupEntriesByPresentResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByPresent`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByPresentResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByStandupId retrieves all rows from the sprint_daily_standup_entry table that match the provided StandupId
         */
        public async GetSprintDailyStandupEntriesByStandupId(params: GetSprintDailyStandupEntriesByStandupIdRequestParams): Promise<GetSprintDailyStandupEntriesByStandupIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByStandupId`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByStandupIdResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByTeamMemberAvailability retrieves all rows from the sprint_daily_standup_entry table that match the provided TeamMemberAvailability
         */
        public async GetSprintDailyStandupEntriesByTeamMemberAvailability(params: GetSprintDailyStandupEntriesByTeamMemberAvailabilityRequestParams): Promise<GetSprintDailyStandupEntriesByTeamMemberAvailabilityResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByTeamMemberAvailability`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByTeamMemberAvailabilityResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByTeamMemberId retrieves all rows from the sprint_daily_standup_entry table that match the provided TeamMemberId
         */
        public async GetSprintDailyStandupEntriesByTeamMemberId(params: GetSprintDailyStandupEntriesByTeamMemberIdRequestParams): Promise<GetSprintDailyStandupEntriesByTeamMemberIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByTeamMemberId`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByTeamMemberIdResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByTeamMemberNote retrieves all rows from the sprint_daily_standup_entry table that match the provided TeamMemberNote
         */
        public async GetSprintDailyStandupEntriesByTeamMemberNote(params: GetSprintDailyStandupEntriesByTeamMemberNoteRequestParams): Promise<GetSprintDailyStandupEntriesByTeamMemberNoteResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByTeamMemberNote`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByTeamMemberNoteResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByTeamMemberWorkingOn retrieves all rows from the sprint_daily_standup_entry table that match the provided TeamMemberWorkingOn
         */
        public async GetSprintDailyStandupEntriesByTeamMemberWorkingOn(params: GetSprintDailyStandupEntriesByTeamMemberWorkingOnRequestParams): Promise<GetSprintDailyStandupEntriesByTeamMemberWorkingOnResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByTeamMemberWorkingOn`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByTeamMemberWorkingOnResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByUpdatedAt retrieves all rows from the sprint_daily_standup_entry table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintDailyStandupEntriesByUpdatedAt(params: GetSprintDailyStandupEntriesByUpdatedAtRequestParams): Promise<GetSprintDailyStandupEntriesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByUpdatedAtResponseParams
        }

        /**
         * GetSprintDailyStandupEntriesByUpdatedBy retrieves all rows from the sprint_daily_standup_entry table that match the provided UpdatedBy
         */
        public async GetSprintDailyStandupEntriesByUpdatedBy(params: GetSprintDailyStandupEntriesByUpdatedByRequestParams): Promise<GetSprintDailyStandupEntriesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntriesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntriesByUpdatedByResponseParams
        }

        /**
         * GetSprintDailyStandupEntryAuditById retrieves all rows from the sprint_daily_standup_entry_audit table that match the provided identifier for a row in the sprint_daily_standup_entry table
         */
        public async GetSprintDailyStandupEntryAuditById(params: GetSprintDailyStandupEntryAuditByIdRequestParams): Promise<GetSprintDailyStandupEntryAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntryAuditById`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntryAuditResponseParams
        }

        /**
         * GetSprintDailyStandupEntryById retrieves all rows from the sprint_daily_standup_entry table that match the provided identifier
         */
        public async GetSprintDailyStandupEntryById(params: GetSprintDailyStandupEntryByIdRequestParams): Promise<GetSprintDailyStandupEntryByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupEntryById`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupEntryByIdResponseParams
        }

        /**
         * GetSprintDailyStandupsByCreatedAt retrieves all rows from the sprint_daily_standup table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintDailyStandupsByCreatedAt(params: GetSprintDailyStandupsByCreatedAtRequestParams): Promise<GetSprintDailyStandupsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupsByCreatedAtResponseParams
        }

        /**
         * GetSprintDailyStandupsByCreatedBy retrieves all rows from the sprint_daily_standup table that match the provided CreatedBy
         */
        public async GetSprintDailyStandupsByCreatedBy(params: GetSprintDailyStandupsByCreatedByRequestParams): Promise<GetSprintDailyStandupsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupsByCreatedByResponseParams
        }

        /**
         * GetSprintDailyStandupsByHostedBy retrieves all rows from the sprint_daily_standup table that match the provided HostedBy
         */
        public async GetSprintDailyStandupsByHostedBy(params: GetSprintDailyStandupsByHostedByRequestParams): Promise<GetSprintDailyStandupsByHostedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupsByHostedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupsByHostedByResponseParams
        }

        /**
         * GetSprintDailyStandupsByIsDeleted retrieves all rows from the sprint_daily_standup table that match the provided IsDeleted
         */
        public async GetSprintDailyStandupsByIsDeleted(params: GetSprintDailyStandupsByIsDeletedRequestParams): Promise<GetSprintDailyStandupsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupsByIsDeletedResponseParams
        }

        /**
         * GetSprintDailyStandupsByMostImportant retrieves all rows from the sprint_daily_standup table that match the provided MostImportant
         */
        public async GetSprintDailyStandupsByMostImportant(params: GetSprintDailyStandupsByMostImportantRequestParams): Promise<GetSprintDailyStandupsByMostImportantResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupsByMostImportant`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupsByMostImportantResponseParams
        }

        /**
         * GetSprintDailyStandupsBySprintDay retrieves all rows from the sprint_daily_standup table that match the provided SprintDay
         */
        public async GetSprintDailyStandupsBySprintDay(params: GetSprintDailyStandupsBySprintDayRequestParams): Promise<GetSprintDailyStandupsBySprintDayResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupsBySprintDay`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupsBySprintDayResponseParams
        }

        /**
         * GetSprintDailyStandupsBySprintId retrieves all rows from the sprint_daily_standup table that match the provided SprintId
         */
        public async GetSprintDailyStandupsBySprintId(params: GetSprintDailyStandupsBySprintIdRequestParams): Promise<GetSprintDailyStandupsBySprintIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupsBySprintId`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupsBySprintIdResponseParams
        }

        /**
         * GetSprintDailyStandupsByUpdatedAt retrieves all rows from the sprint_daily_standup table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintDailyStandupsByUpdatedAt(params: GetSprintDailyStandupsByUpdatedAtRequestParams): Promise<GetSprintDailyStandupsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupsByUpdatedAtResponseParams
        }

        /**
         * GetSprintDailyStandupsByUpdatedBy retrieves all rows from the sprint_daily_standup table that match the provided UpdatedBy
         */
        public async GetSprintDailyStandupsByUpdatedBy(params: GetSprintDailyStandupsByUpdatedByRequestParams): Promise<GetSprintDailyStandupsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintDailyStandupsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintDailyStandupsByUpdatedByResponseParams
        }

        /**
         * GetSprintMessageAuditById retrieves all rows from the sprint_message_audit table that match the provided identifier for a row in the sprint_message table
         */
        public async GetSprintMessageAuditById(params: GetSprintMessageAuditByIdRequestParams): Promise<GetSprintMessageAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageAuditById`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageAuditResponseParams
        }

        /**
         * GetSprintMessageById retrieves all rows from the sprint_message table that match the provided identifier
         */
        public async GetSprintMessageById(params: GetSprintMessageByIdRequestParams): Promise<GetSprintMessageByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageById`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageByIdResponseParams
        }

        /**
         * GetSprintMessageTypeAuditById retrieves all rows from the sprint_message_type_audit table that match the provided identifier for a row in the sprint_message_type table
         */
        public async GetSprintMessageTypeAuditById(params: GetSprintMessageTypeAuditByIdRequestParams): Promise<GetSprintMessageTypeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageTypeAuditById`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageTypeAuditResponseParams
        }

        /**
         * GetSprintMessageTypeById retrieves all rows from the sprint_message_type table that match the provided identifier
         */
        public async GetSprintMessageTypeById(params: GetSprintMessageTypeByIdRequestParams): Promise<GetSprintMessageTypeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageTypeById`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageTypeByIdResponseParams
        }

        /**
         * GetSprintMessageTypesByColor retrieves all rows from the sprint_message_type table that match the provided Color
         */
        public async GetSprintMessageTypesByColor(params: GetSprintMessageTypesByColorRequestParams): Promise<GetSprintMessageTypesByColorResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageTypesByColor`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageTypesByColorResponseParams
        }

        /**
         * GetSprintMessageTypesByCreatedAt retrieves all rows from the sprint_message_type table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintMessageTypesByCreatedAt(params: GetSprintMessageTypesByCreatedAtRequestParams): Promise<GetSprintMessageTypesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageTypesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageTypesByCreatedAtResponseParams
        }

        /**
         * GetSprintMessageTypesByCreatedBy retrieves all rows from the sprint_message_type table that match the provided CreatedBy
         */
        public async GetSprintMessageTypesByCreatedBy(params: GetSprintMessageTypesByCreatedByRequestParams): Promise<GetSprintMessageTypesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageTypesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageTypesByCreatedByResponseParams
        }

        /**
         * GetSprintMessageTypesByIsDeleted retrieves all rows from the sprint_message_type table that match the provided IsDeleted
         */
        public async GetSprintMessageTypesByIsDeleted(params: GetSprintMessageTypesByIsDeletedRequestParams): Promise<GetSprintMessageTypesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageTypesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageTypesByIsDeletedResponseParams
        }

        /**
         * GetSprintMessageTypesByName retrieves all rows from the sprint_message_type table that match the provided Name
         */
        public async GetSprintMessageTypesByName(params: GetSprintMessageTypesByNameRequestParams): Promise<GetSprintMessageTypesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageTypesByName`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageTypesByNameResponseParams
        }

        /**
         * GetSprintMessageTypesByUpdatedAt retrieves all rows from the sprint_message_type table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintMessageTypesByUpdatedAt(params: GetSprintMessageTypesByUpdatedAtRequestParams): Promise<GetSprintMessageTypesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageTypesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageTypesByUpdatedAtResponseParams
        }

        /**
         * GetSprintMessageTypesByUpdatedBy retrieves all rows from the sprint_message_type table that match the provided UpdatedBy
         */
        public async GetSprintMessageTypesByUpdatedBy(params: GetSprintMessageTypesByUpdatedByRequestParams): Promise<GetSprintMessageTypesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessageTypesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintMessageTypesByUpdatedByResponseParams
        }

        /**
         * GetSprintMessagesByCreatedAt retrieves all rows from the sprint_message table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintMessagesByCreatedAt(params: GetSprintMessagesByCreatedAtRequestParams): Promise<GetSprintMessagesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessagesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintMessagesByCreatedAtResponseParams
        }

        /**
         * GetSprintMessagesByCreatedBy retrieves all rows from the sprint_message table that match the provided CreatedBy
         */
        public async GetSprintMessagesByCreatedBy(params: GetSprintMessagesByCreatedByRequestParams): Promise<GetSprintMessagesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessagesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintMessagesByCreatedByResponseParams
        }

        /**
         * GetSprintMessagesByIsDeleted retrieves all rows from the sprint_message table that match the provided IsDeleted
         */
        public async GetSprintMessagesByIsDeleted(params: GetSprintMessagesByIsDeletedRequestParams): Promise<GetSprintMessagesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessagesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetSprintMessagesByIsDeletedResponseParams
        }

        /**
         * GetSprintMessagesByMessage retrieves all rows from the sprint_message table that match the provided Message
         */
        public async GetSprintMessagesByMessage(params: GetSprintMessagesByMessageRequestParams): Promise<GetSprintMessagesByMessageResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessagesByMessage`, JSON.stringify(params))
            return await resp.json() as GetSprintMessagesByMessageResponseParams
        }

        /**
         * GetSprintMessagesByMessageTypeId retrieves all rows from the sprint_message table that match the provided MessageTypeId
         */
        public async GetSprintMessagesByMessageTypeId(params: GetSprintMessagesByMessageTypeIdRequestParams): Promise<GetSprintMessagesByMessageTypeIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessagesByMessageTypeId`, JSON.stringify(params))
            return await resp.json() as GetSprintMessagesByMessageTypeIdResponseParams
        }

        /**
         * GetSprintMessagesBySprintId retrieves all rows from the sprint_message table that match the provided SprintId
         */
        public async GetSprintMessagesBySprintId(params: GetSprintMessagesBySprintIdRequestParams): Promise<GetSprintMessagesBySprintIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessagesBySprintId`, JSON.stringify(params))
            return await resp.json() as GetSprintMessagesBySprintIdResponseParams
        }

        /**
         * GetSprintMessagesByTitle retrieves all rows from the sprint_message table that match the provided Title
         */
        public async GetSprintMessagesByTitle(params: GetSprintMessagesByTitleRequestParams): Promise<GetSprintMessagesByTitleResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessagesByTitle`, JSON.stringify(params))
            return await resp.json() as GetSprintMessagesByTitleResponseParams
        }

        /**
         * GetSprintMessagesByUpdatedAt retrieves all rows from the sprint_message table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintMessagesByUpdatedAt(params: GetSprintMessagesByUpdatedAtRequestParams): Promise<GetSprintMessagesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessagesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintMessagesByUpdatedAtResponseParams
        }

        /**
         * GetSprintMessagesByUpdatedBy retrieves all rows from the sprint_message table that match the provided UpdatedBy
         */
        public async GetSprintMessagesByUpdatedBy(params: GetSprintMessagesByUpdatedByRequestParams): Promise<GetSprintMessagesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintMessagesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintMessagesByUpdatedByResponseParams
        }

        /**
         * GetSprintRoleAuditById retrieves all rows from the sprint_role_audit table that match the provided identifier for a row in the sprint_role table
         */
        public async GetSprintRoleAuditById(params: GetSprintRoleAuditByIdRequestParams): Promise<GetSprintRoleAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleAuditById`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleAuditResponseParams
        }

        /**
         * GetSprintRoleById retrieves all rows from the sprint_role table that match the provided identifier
         */
        public async GetSprintRoleById(params: GetSprintRoleByIdRequestParams): Promise<GetSprintRoleByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleById`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleByIdResponseParams
        }

        /**
         * GetSprintRoleEntriesByContactId retrieves all rows from the sprint_role_entry table that match the provided ContactId
         */
        public async GetSprintRoleEntriesByContactId(params: GetSprintRoleEntriesByContactIdRequestParams): Promise<GetSprintRoleEntriesByContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleEntriesByContactId`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleEntriesByContactIdResponseParams
        }

        /**
         * GetSprintRoleEntriesByCreatedAt retrieves all rows from the sprint_role_entry table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintRoleEntriesByCreatedAt(params: GetSprintRoleEntriesByCreatedAtRequestParams): Promise<GetSprintRoleEntriesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleEntriesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleEntriesByCreatedAtResponseParams
        }

        /**
         * GetSprintRoleEntriesByCreatedBy retrieves all rows from the sprint_role_entry table that match the provided CreatedBy
         */
        public async GetSprintRoleEntriesByCreatedBy(params: GetSprintRoleEntriesByCreatedByRequestParams): Promise<GetSprintRoleEntriesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleEntriesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleEntriesByCreatedByResponseParams
        }

        /**
         * GetSprintRoleEntriesByIsDeleted retrieves all rows from the sprint_role_entry table that match the provided IsDeleted
         */
        public async GetSprintRoleEntriesByIsDeleted(params: GetSprintRoleEntriesByIsDeletedRequestParams): Promise<GetSprintRoleEntriesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleEntriesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleEntriesByIsDeletedResponseParams
        }

        /**
         * GetSprintRoleEntriesBySprintId retrieves all rows from the sprint_role_entry table that match the provided SprintId
         */
        public async GetSprintRoleEntriesBySprintId(params: GetSprintRoleEntriesBySprintIdRequestParams): Promise<GetSprintRoleEntriesBySprintIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleEntriesBySprintId`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleEntriesBySprintIdResponseParams
        }

        /**
         * GetSprintRoleEntriesBySprintRoleId retrieves all rows from the sprint_role_entry table that match the provided SprintRoleId
         */
        public async GetSprintRoleEntriesBySprintRoleId(params: GetSprintRoleEntriesBySprintRoleIdRequestParams): Promise<GetSprintRoleEntriesBySprintRoleIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleEntriesBySprintRoleId`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleEntriesBySprintRoleIdResponseParams
        }

        /**
         * GetSprintRoleEntriesByUpdatedAt retrieves all rows from the sprint_role_entry table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintRoleEntriesByUpdatedAt(params: GetSprintRoleEntriesByUpdatedAtRequestParams): Promise<GetSprintRoleEntriesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleEntriesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleEntriesByUpdatedAtResponseParams
        }

        /**
         * GetSprintRoleEntriesByUpdatedBy retrieves all rows from the sprint_role_entry table that match the provided UpdatedBy
         */
        public async GetSprintRoleEntriesByUpdatedBy(params: GetSprintRoleEntriesByUpdatedByRequestParams): Promise<GetSprintRoleEntriesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleEntriesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleEntriesByUpdatedByResponseParams
        }

        /**
         * GetSprintRoleEntryAuditById retrieves all rows from the sprint_role_entry_audit table that match the provided identifier for a row in the sprint_role_entry table
         */
        public async GetSprintRoleEntryAuditById(params: GetSprintRoleEntryAuditByIdRequestParams): Promise<GetSprintRoleEntryAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleEntryAuditById`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleEntryAuditResponseParams
        }

        /**
         * GetSprintRoleEntryById retrieves all rows from the sprint_role_entry table that match the provided identifier
         */
        public async GetSprintRoleEntryById(params: GetSprintRoleEntryByIdRequestParams): Promise<GetSprintRoleEntryByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRoleEntryById`, JSON.stringify(params))
            return await resp.json() as GetSprintRoleEntryByIdResponseParams
        }

        /**
         * GetSprintRolesByCreatedAt retrieves all rows from the sprint_role table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintRolesByCreatedAt(params: GetSprintRolesByCreatedAtRequestParams): Promise<GetSprintRolesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRolesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintRolesByCreatedAtResponseParams
        }

        /**
         * GetSprintRolesByCreatedBy retrieves all rows from the sprint_role table that match the provided CreatedBy
         */
        public async GetSprintRolesByCreatedBy(params: GetSprintRolesByCreatedByRequestParams): Promise<GetSprintRolesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRolesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintRolesByCreatedByResponseParams
        }

        /**
         * GetSprintRolesByIsDeleted retrieves all rows from the sprint_role table that match the provided IsDeleted
         */
        public async GetSprintRolesByIsDeleted(params: GetSprintRolesByIsDeletedRequestParams): Promise<GetSprintRolesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRolesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetSprintRolesByIsDeletedResponseParams
        }

        /**
         * GetSprintRolesByName retrieves all rows from the sprint_role table that match the provided Name
         */
        public async GetSprintRolesByName(params: GetSprintRolesByNameRequestParams): Promise<GetSprintRolesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRolesByName`, JSON.stringify(params))
            return await resp.json() as GetSprintRolesByNameResponseParams
        }

        /**
         * GetSprintRolesByUpdatedAt retrieves all rows from the sprint_role table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintRolesByUpdatedAt(params: GetSprintRolesByUpdatedAtRequestParams): Promise<GetSprintRolesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRolesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintRolesByUpdatedAtResponseParams
        }

        /**
         * GetSprintRolesByUpdatedBy retrieves all rows from the sprint_role table that match the provided UpdatedBy
         */
        public async GetSprintRolesByUpdatedBy(params: GetSprintRolesByUpdatedByRequestParams): Promise<GetSprintRolesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintRolesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintRolesByUpdatedByResponseParams
        }

        /**
         * GetSprintsByCreatedAt retrieves all rows from the sprint table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintsByCreatedAt(params: GetSprintsByCreatedAtRequestParams): Promise<GetSprintsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintsByCreatedAtResponseParams
        }

        /**
         * GetSprintsByCreatedBy retrieves all rows from the sprint table that match the provided CreatedBy
         */
        public async GetSprintsByCreatedBy(params: GetSprintsByCreatedByRequestParams): Promise<GetSprintsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintsByCreatedByResponseParams
        }

        /**
         * GetSprintsByIsDeleted retrieves all rows from the sprint table that match the provided IsDeleted
         */
        public async GetSprintsByIsDeleted(params: GetSprintsByIsDeletedRequestParams): Promise<GetSprintsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetSprintsByIsDeletedResponseParams
        }

        /**
         * GetSprintsBySprintNumber retrieves all rows from the sprint table that match the provided SprintNumber
         */
        public async GetSprintsBySprintNumber(params: GetSprintsBySprintNumberRequestParams): Promise<GetSprintsBySprintNumberResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintsBySprintNumber`, JSON.stringify(params))
            return await resp.json() as GetSprintsBySprintNumberResponseParams
        }

        /**
         * GetSprintsByStartDate retrieves all rows from the sprint table that match the provided StartDate
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintsByStartDate(params: GetSprintsByStartDateRequestParams): Promise<GetSprintsByStartDateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintsByStartDate`, JSON.stringify(params))
            return await resp.json() as GetSprintsByStartDateResponseParams
        }

        /**
         * GetSprintsByUpdatedAt retrieves all rows from the sprint table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetSprintsByUpdatedAt(params: GetSprintsByUpdatedAtRequestParams): Promise<GetSprintsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetSprintsByUpdatedAtResponseParams
        }

        /**
         * GetSprintsByUpdatedBy retrieves all rows from the sprint table that match the provided UpdatedBy
         */
        public async GetSprintsByUpdatedBy(params: GetSprintsByUpdatedByRequestParams): Promise<GetSprintsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetSprintsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetSprintsByUpdatedByResponseParams
        }

        /**
         * GetTaskAuditById retrieves all rows from the task_audit table that match the provided identifier for a row in the task table
         */
        public async GetTaskAuditById(params: GetTaskAuditByIdRequestParams): Promise<GetTaskAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskAuditById`, JSON.stringify(params))
            return await resp.json() as GetTaskAuditResponseParams
        }

        /**
         * GetTaskById retrieves all rows from the task table that match the provided identifier
         */
        public async GetTaskById(params: GetTaskByIdRequestParams): Promise<GetTaskByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskById`, JSON.stringify(params))
            return await resp.json() as GetTaskByIdResponseParams
        }

        /**
         * GetTaskOwnerAuditById retrieves all rows from the task_owner_audit table that match the provided identifier for a row in the task_owner table
         */
        public async GetTaskOwnerAuditById(params: GetTaskOwnerAuditByIdRequestParams): Promise<GetTaskOwnerAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskOwnerAuditById`, JSON.stringify(params))
            return await resp.json() as GetTaskOwnerAuditResponseParams
        }

        /**
         * GetTaskOwnerById retrieves all rows from the task_owner table that match the provided identifier
         */
        public async GetTaskOwnerById(params: GetTaskOwnerByIdRequestParams): Promise<GetTaskOwnerByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskOwnerById`, JSON.stringify(params))
            return await resp.json() as GetTaskOwnerByIdResponseParams
        }

        /**
         * GetTaskOwnersByContactId retrieves all rows from the task_owner table that match the provided ContactId
         */
        public async GetTaskOwnersByContactId(params: GetTaskOwnersByContactIdRequestParams): Promise<GetTaskOwnersByContactIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskOwnersByContactId`, JSON.stringify(params))
            return await resp.json() as GetTaskOwnersByContactIdResponseParams
        }

        /**
         * GetTaskOwnersByCreatedAt retrieves all rows from the task_owner table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetTaskOwnersByCreatedAt(params: GetTaskOwnersByCreatedAtRequestParams): Promise<GetTaskOwnersByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskOwnersByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetTaskOwnersByCreatedAtResponseParams
        }

        /**
         * GetTaskOwnersByCreatedBy retrieves all rows from the task_owner table that match the provided CreatedBy
         */
        public async GetTaskOwnersByCreatedBy(params: GetTaskOwnersByCreatedByRequestParams): Promise<GetTaskOwnersByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskOwnersByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetTaskOwnersByCreatedByResponseParams
        }

        /**
         * GetTaskOwnersByIsDeleted retrieves all rows from the task_owner table that match the provided IsDeleted
         */
        public async GetTaskOwnersByIsDeleted(params: GetTaskOwnersByIsDeletedRequestParams): Promise<GetTaskOwnersByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskOwnersByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetTaskOwnersByIsDeletedResponseParams
        }

        /**
         * GetTaskOwnersByNote retrieves all rows from the task_owner table that match the provided Note
         */
        public async GetTaskOwnersByNote(params: GetTaskOwnersByNoteRequestParams): Promise<GetTaskOwnersByNoteResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskOwnersByNote`, JSON.stringify(params))
            return await resp.json() as GetTaskOwnersByNoteResponseParams
        }

        /**
         * GetTaskOwnersByTaskId retrieves all rows from the task_owner table that match the provided TaskId
         */
        public async GetTaskOwnersByTaskId(params: GetTaskOwnersByTaskIdRequestParams): Promise<GetTaskOwnersByTaskIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskOwnersByTaskId`, JSON.stringify(params))
            return await resp.json() as GetTaskOwnersByTaskIdResponseParams
        }

        /**
         * GetTaskOwnersByUpdatedAt retrieves all rows from the task_owner table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetTaskOwnersByUpdatedAt(params: GetTaskOwnersByUpdatedAtRequestParams): Promise<GetTaskOwnersByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskOwnersByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetTaskOwnersByUpdatedAtResponseParams
        }

        /**
         * GetTaskOwnersByUpdatedBy retrieves all rows from the task_owner table that match the provided UpdatedBy
         */
        public async GetTaskOwnersByUpdatedBy(params: GetTaskOwnersByUpdatedByRequestParams): Promise<GetTaskOwnersByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskOwnersByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetTaskOwnersByUpdatedByResponseParams
        }

        /**
         * GetTaskStatusAuditById retrieves all rows from the task_status_audit table that match the provided identifier for a row in the task_status table
         */
        public async GetTaskStatusAuditById(params: GetTaskStatusAuditByIdRequestParams): Promise<GetTaskStatusAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskStatusAuditById`, JSON.stringify(params))
            return await resp.json() as GetTaskStatusAuditResponseParams
        }

        /**
         * GetTaskStatusById retrieves all rows from the task_status table that match the provided identifier
         */
        public async GetTaskStatusById(params: GetTaskStatusByIdRequestParams): Promise<GetTaskStatusByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskStatusById`, JSON.stringify(params))
            return await resp.json() as GetTaskStatusByIdResponseParams
        }

        /**
         * GetTaskStatusesByCode retrieves all rows from the task_status table that match the provided Code
         */
        public async GetTaskStatusesByCode(params: GetTaskStatusesByCodeRequestParams): Promise<GetTaskStatusesByCodeResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskStatusesByCode`, JSON.stringify(params))
            return await resp.json() as GetTaskStatusesByCodeResponseParams
        }

        /**
         * GetTaskStatusesByCreatedAt retrieves all rows from the task_status table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetTaskStatusesByCreatedAt(params: GetTaskStatusesByCreatedAtRequestParams): Promise<GetTaskStatusesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskStatusesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetTaskStatusesByCreatedAtResponseParams
        }

        /**
         * GetTaskStatusesByCreatedBy retrieves all rows from the task_status table that match the provided CreatedBy
         */
        public async GetTaskStatusesByCreatedBy(params: GetTaskStatusesByCreatedByRequestParams): Promise<GetTaskStatusesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskStatusesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetTaskStatusesByCreatedByResponseParams
        }

        /**
         * GetTaskStatusesByIsDeleted retrieves all rows from the task_status table that match the provided IsDeleted
         */
        public async GetTaskStatusesByIsDeleted(params: GetTaskStatusesByIsDeletedRequestParams): Promise<GetTaskStatusesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskStatusesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetTaskStatusesByIsDeletedResponseParams
        }

        /**
         * GetTaskStatusesByName retrieves all rows from the task_status table that match the provided Name
         */
        public async GetTaskStatusesByName(params: GetTaskStatusesByNameRequestParams): Promise<GetTaskStatusesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskStatusesByName`, JSON.stringify(params))
            return await resp.json() as GetTaskStatusesByNameResponseParams
        }

        /**
         * GetTaskStatusesByUpdatedAt retrieves all rows from the task_status table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetTaskStatusesByUpdatedAt(params: GetTaskStatusesByUpdatedAtRequestParams): Promise<GetTaskStatusesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskStatusesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetTaskStatusesByUpdatedAtResponseParams
        }

        /**
         * GetTaskStatusesByUpdatedBy retrieves all rows from the task_status table that match the provided UpdatedBy
         */
        public async GetTaskStatusesByUpdatedBy(params: GetTaskStatusesByUpdatedByRequestParams): Promise<GetTaskStatusesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTaskStatusesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetTaskStatusesByUpdatedByResponseParams
        }

        /**
         * GetTasksByCompanyId retrieves all rows from the task table that match the provided CompanyId
         */
        public async GetTasksByCompanyId(params: GetTasksByCompanyIdRequestParams): Promise<GetTasksByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetTasksByCompanyIdResponseParams
        }

        /**
         * GetTasksByCreatedAt retrieves all rows from the task table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetTasksByCreatedAt(params: GetTasksByCreatedAtRequestParams): Promise<GetTasksByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetTasksByCreatedAtResponseParams
        }

        /**
         * GetTasksByCreatedBy retrieves all rows from the task table that match the provided CreatedBy
         */
        public async GetTasksByCreatedBy(params: GetTasksByCreatedByRequestParams): Promise<GetTasksByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetTasksByCreatedByResponseParams
        }

        /**
         * GetTasksByDeadline retrieves all rows from the task table that match the provided Deadline
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetTasksByDeadline(params: GetTasksByDeadlineRequestParams): Promise<GetTasksByDeadlineResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByDeadline`, JSON.stringify(params))
            return await resp.json() as GetTasksByDeadlineResponseParams
        }

        /**
         * GetTasksByIsDeleted retrieves all rows from the task table that match the provided IsDeleted
         */
        public async GetTasksByIsDeleted(params: GetTasksByIsDeletedRequestParams): Promise<GetTasksByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetTasksByIsDeletedResponseParams
        }

        /**
         * GetTasksByIsPriority retrieves all rows from the task table that match the provided IsPriority
         */
        public async GetTasksByIsPriority(params: GetTasksByIsPriorityRequestParams): Promise<GetTasksByIsPriorityResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByIsPriority`, JSON.stringify(params))
            return await resp.json() as GetTasksByIsPriorityResponseParams
        }

        /**
         * GetTasksByIsPrivate retrieves all rows from the task table that match the provided IsPrivate
         */
        public async GetTasksByIsPrivate(params: GetTasksByIsPrivateRequestParams): Promise<GetTasksByIsPrivateResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByIsPrivate`, JSON.stringify(params))
            return await resp.json() as GetTasksByIsPrivateResponseParams
        }

        /**
         * GetTasksByName retrieves all rows from the task table that match the provided Name
         */
        public async GetTasksByName(params: GetTasksByNameRequestParams): Promise<GetTasksByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByName`, JSON.stringify(params))
            return await resp.json() as GetTasksByNameResponseParams
        }

        /**
         * GetTasksBySize retrieves all rows from the task table that match the provided Size
         */
        public async GetTasksBySize(params: GetTasksBySizeRequestParams): Promise<GetTasksBySizeResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksBySize`, JSON.stringify(params))
            return await resp.json() as GetTasksBySizeResponseParams
        }

        /**
         * GetTasksByStatusId retrieves all rows from the task table that match the provided StatusId
         */
        public async GetTasksByStatusId(params: GetTasksByStatusIdRequestParams): Promise<GetTasksByStatusIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByStatusId`, JSON.stringify(params))
            return await resp.json() as GetTasksByStatusIdResponseParams
        }

        /**
         * GetTasksByUpdatedAt retrieves all rows from the task table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetTasksByUpdatedAt(params: GetTasksByUpdatedAtRequestParams): Promise<GetTasksByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetTasksByUpdatedAtResponseParams
        }

        /**
         * GetTasksByUpdatedBy retrieves all rows from the task table that match the provided UpdatedBy
         */
        public async GetTasksByUpdatedBy(params: GetTasksByUpdatedByRequestParams): Promise<GetTasksByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetTasksByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetTasksByUpdatedByResponseParams
        }

        /**
         * GetWorkingTimeAuditById retrieves all rows from the working_time_audit table that match the provided identifier for a row in the working_time table
         */
        public async GetWorkingTimeAuditById(params: GetWorkingTimeAuditByIdRequestParams): Promise<GetWorkingTimeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeAuditById`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeAuditResponseParams
        }

        /**
         * GetWorkingTimeById retrieves all rows from the working_time table that match the provided identifier
         */
        public async GetWorkingTimeById(params: GetWorkingTimeByIdRequestParams): Promise<GetWorkingTimeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeById`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeByIdResponseParams
        }

        /**
         * GetWorkingTimeLocationAuditById retrieves all rows from the working_time_location_audit table that match the provided identifier for a row in the working_time_location table
         */
        public async GetWorkingTimeLocationAuditById(params: GetWorkingTimeLocationAuditByIdRequestParams): Promise<GetWorkingTimeLocationAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeLocationAuditById`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeLocationAuditResponseParams
        }

        /**
         * GetWorkingTimeLocationById retrieves all rows from the working_time_location table that match the provided identifier
         */
        public async GetWorkingTimeLocationById(params: GetWorkingTimeLocationByIdRequestParams): Promise<GetWorkingTimeLocationByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeLocationById`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeLocationByIdResponseParams
        }

        /**
         * GetWorkingTimeLocationsByCompanyId retrieves all rows from the working_time_location table that match the provided CompanyId
         */
        public async GetWorkingTimeLocationsByCompanyId(params: GetWorkingTimeLocationsByCompanyIdRequestParams): Promise<GetWorkingTimeLocationsByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeLocationsByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeLocationsByCompanyIdResponseParams
        }

        /**
         * GetWorkingTimeLocationsByCreatedAt retrieves all rows from the working_time_location table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetWorkingTimeLocationsByCreatedAt(params: GetWorkingTimeLocationsByCreatedAtRequestParams): Promise<GetWorkingTimeLocationsByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeLocationsByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeLocationsByCreatedAtResponseParams
        }

        /**
         * GetWorkingTimeLocationsByCreatedBy retrieves all rows from the working_time_location table that match the provided CreatedBy
         */
        public async GetWorkingTimeLocationsByCreatedBy(params: GetWorkingTimeLocationsByCreatedByRequestParams): Promise<GetWorkingTimeLocationsByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeLocationsByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeLocationsByCreatedByResponseParams
        }

        /**
         * GetWorkingTimeLocationsByIsDeleted retrieves all rows from the working_time_location table that match the provided IsDeleted
         */
        public async GetWorkingTimeLocationsByIsDeleted(params: GetWorkingTimeLocationsByIsDeletedRequestParams): Promise<GetWorkingTimeLocationsByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeLocationsByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeLocationsByIsDeletedResponseParams
        }

        /**
         * GetWorkingTimeLocationsByName retrieves all rows from the working_time_location table that match the provided Name
         */
        public async GetWorkingTimeLocationsByName(params: GetWorkingTimeLocationsByNameRequestParams): Promise<GetWorkingTimeLocationsByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeLocationsByName`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeLocationsByNameResponseParams
        }

        /**
         * GetWorkingTimeLocationsByUpdatedAt retrieves all rows from the working_time_location table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetWorkingTimeLocationsByUpdatedAt(params: GetWorkingTimeLocationsByUpdatedAtRequestParams): Promise<GetWorkingTimeLocationsByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeLocationsByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeLocationsByUpdatedAtResponseParams
        }

        /**
         * GetWorkingTimeLocationsByUpdatedBy retrieves all rows from the working_time_location table that match the provided UpdatedBy
         */
        public async GetWorkingTimeLocationsByUpdatedBy(params: GetWorkingTimeLocationsByUpdatedByRequestParams): Promise<GetWorkingTimeLocationsByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeLocationsByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeLocationsByUpdatedByResponseParams
        }

        /**
         * GetWorkingTimeTypeAuditById retrieves all rows from the working_time_type_audit table that match the provided identifier for a row in the working_time_type table
         */
        public async GetWorkingTimeTypeAuditById(params: GetWorkingTimeTypeAuditByIdRequestParams): Promise<GetWorkingTimeTypeAuditResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypeAuditById`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypeAuditResponseParams
        }

        /**
         * GetWorkingTimeTypeById retrieves all rows from the working_time_type table that match the provided identifier
         */
        public async GetWorkingTimeTypeById(params: GetWorkingTimeTypeByIdRequestParams): Promise<GetWorkingTimeTypeByIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypeById`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypeByIdResponseParams
        }

        /**
         * GetWorkingTimeTypesByCompanyId retrieves all rows from the working_time_type table that match the provided CompanyId
         */
        public async GetWorkingTimeTypesByCompanyId(params: GetWorkingTimeTypesByCompanyIdRequestParams): Promise<GetWorkingTimeTypesByCompanyIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByCompanyId`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByCompanyIdResponseParams
        }

        /**
         * GetWorkingTimeTypesByCreatedAt retrieves all rows from the working_time_type table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetWorkingTimeTypesByCreatedAt(params: GetWorkingTimeTypesByCreatedAtRequestParams): Promise<GetWorkingTimeTypesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByCreatedAtResponseParams
        }

        /**
         * GetWorkingTimeTypesByCreatedBy retrieves all rows from the working_time_type table that match the provided CreatedBy
         */
        public async GetWorkingTimeTypesByCreatedBy(params: GetWorkingTimeTypesByCreatedByRequestParams): Promise<GetWorkingTimeTypesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByCreatedByResponseParams
        }

        /**
         * GetWorkingTimeTypesByIsDeleted retrieves all rows from the working_time_type table that match the provided IsDeleted
         */
        public async GetWorkingTimeTypesByIsDeleted(params: GetWorkingTimeTypesByIsDeletedRequestParams): Promise<GetWorkingTimeTypesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByIsDeletedResponseParams
        }

        /**
         * GetWorkingTimeTypesByIsParentalLeave retrieves all rows from the working_time_type table that match the provided IsParentalLeave
         */
        public async GetWorkingTimeTypesByIsParentalLeave(params: GetWorkingTimeTypesByIsParentalLeaveRequestParams): Promise<GetWorkingTimeTypesByIsParentalLeaveResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByIsParentalLeave`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByIsParentalLeaveResponseParams
        }

        /**
         * GetWorkingTimeTypesByIsPublicHoliday retrieves all rows from the working_time_type table that match the provided IsPublicHoliday
         */
        public async GetWorkingTimeTypesByIsPublicHoliday(params: GetWorkingTimeTypesByIsPublicHolidayRequestParams): Promise<GetWorkingTimeTypesByIsPublicHolidayResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByIsPublicHoliday`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByIsPublicHolidayResponseParams
        }

        /**
         * GetWorkingTimeTypesByIsVacation retrieves all rows from the working_time_type table that match the provided IsVacation
         */
        public async GetWorkingTimeTypesByIsVacation(params: GetWorkingTimeTypesByIsVacationRequestParams): Promise<GetWorkingTimeTypesByIsVacationResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByIsVacation`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByIsVacationResponseParams
        }

        /**
         * GetWorkingTimeTypesByIsWork retrieves all rows from the working_time_type table that match the provided IsWork
         */
        public async GetWorkingTimeTypesByIsWork(params: GetWorkingTimeTypesByIsWorkRequestParams): Promise<GetWorkingTimeTypesByIsWorkResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByIsWork`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByIsWorkResponseParams
        }

        /**
         * GetWorkingTimeTypesByName retrieves all rows from the working_time_type table that match the provided Name
         */
        public async GetWorkingTimeTypesByName(params: GetWorkingTimeTypesByNameRequestParams): Promise<GetWorkingTimeTypesByNameResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByName`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByNameResponseParams
        }

        /**
         * GetWorkingTimeTypesByUpdatedAt retrieves all rows from the working_time_type table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetWorkingTimeTypesByUpdatedAt(params: GetWorkingTimeTypesByUpdatedAtRequestParams): Promise<GetWorkingTimeTypesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByUpdatedAtResponseParams
        }

        /**
         * GetWorkingTimeTypesByUpdatedBy retrieves all rows from the working_time_type table that match the provided UpdatedBy
         */
        public async GetWorkingTimeTypesByUpdatedBy(params: GetWorkingTimeTypesByUpdatedByRequestParams): Promise<GetWorkingTimeTypesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimeTypesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimeTypesByUpdatedByResponseParams
        }

        /**
         * GetWorkingTimesByContactRoleId retrieves all rows from the working_time table that match the provided ContactRoleId
         */
        public async GetWorkingTimesByContactRoleId(params: GetWorkingTimesByContactRoleIdRequestParams): Promise<GetWorkingTimesByContactRoleIdResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimesByContactRoleId`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimesByContactRoleIdResponseParams
        }

        /**
         * GetWorkingTimesByCreatedAt retrieves all rows from the working_time table that match the provided CreatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetWorkingTimesByCreatedAt(params: GetWorkingTimesByCreatedAtRequestParams): Promise<GetWorkingTimesByCreatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimesByCreatedAt`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimesByCreatedAtResponseParams
        }

        /**
         * GetWorkingTimesByCreatedBy retrieves all rows from the working_time table that match the provided CreatedBy
         */
        public async GetWorkingTimesByCreatedBy(params: GetWorkingTimesByCreatedByRequestParams): Promise<GetWorkingTimesByCreatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimesByCreatedBy`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimesByCreatedByResponseParams
        }

        /**
         * GetWorkingTimesByDay retrieves all rows from the working_time table that match the provided Day
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetWorkingTimesByDay(params: GetWorkingTimesByDayRequestParams): Promise<GetWorkingTimesByDayResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimesByDay`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimesByDayResponseParams
        }

        /**
         * GetWorkingTimesByDurationHours retrieves all rows from the working_time table that match the provided float query
         * 
         * Supported queries include:
         * - Less
         * - Greater
         * - Between
         */
        public async GetWorkingTimesByDurationHours(params: GetWorkingTimesByDurationHoursRequestParams): Promise<GetWorkingTimesByDurationHoursResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimesByDurationHours`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimesByDurationHoursResponseParams
        }

        /**
         * GetWorkingTimesByIsDeleted retrieves all rows from the working_time table that match the provided IsDeleted
         */
        public async GetWorkingTimesByIsDeleted(params: GetWorkingTimesByIsDeletedRequestParams): Promise<GetWorkingTimesByIsDeletedResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimesByIsDeleted`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimesByIsDeletedResponseParams
        }

        /**
         * GetWorkingTimesByLocation retrieves all rows from the working_time table that match the provided Location
         */
        public async GetWorkingTimesByLocation(params: GetWorkingTimesByLocationRequestParams): Promise<GetWorkingTimesByLocationResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimesByLocation`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimesByLocationResponseParams
        }

        /**
         * GetWorkingTimesByType retrieves all rows from the working_time table that match the provided Type
         */
        public async GetWorkingTimesByType(params: GetWorkingTimesByTypeRequestParams): Promise<GetWorkingTimesByTypeResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimesByType`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimesByTypeResponseParams
        }

        /**
         * GetWorkingTimesByUpdatedAt retrieves all rows from the working_time table that match the provided UpdatedAt
         * 
         * Supported queries include:
         * - Before
         * - After
         * - Between
         */
        public async GetWorkingTimesByUpdatedAt(params: GetWorkingTimesByUpdatedAtRequestParams): Promise<GetWorkingTimesByUpdatedAtResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimesByUpdatedAt`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimesByUpdatedAtResponseParams
        }

        /**
         * GetWorkingTimesByUpdatedBy retrieves all rows from the working_time table that match the provided UpdatedBy
         */
        public async GetWorkingTimesByUpdatedBy(params: GetWorkingTimesByUpdatedByRequestParams): Promise<GetWorkingTimesByUpdatedByResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.GetWorkingTimesByUpdatedBy`, JSON.stringify(params))
            return await resp.json() as GetWorkingTimesByUpdatedByResponseParams
        }

        /**
         * InsertCallSheet adds a row to the call_sheet table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertCallSheet(params: InsertCallSheetRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertCallSheet`, JSON.stringify(params))
        }

        /**
         * InsertChannel adds a row to the channel table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertChannel(params: InsertChannelRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertChannel`, JSON.stringify(params))
        }

        /**
         * InsertCompany adds a row to the company table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertCompany(params: InsertCompanyRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertCompany`, JSON.stringify(params))
        }

        /**
         * InsertCompanyBillingInfo adds a row to the company_billing_info table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertCompanyBillingInfo(params: InsertCompanyBillingInfoRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertCompanyBillingInfo`, JSON.stringify(params))
        }

        /**
         * InsertCompanyInvoice adds a row to the company_invoice table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertCompanyInvoice(params: InsertCompanyInvoiceRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertCompanyInvoice`, JSON.stringify(params))
        }

        /**
         * InsertCompanyNote adds a row to the company_note table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertCompanyNote(params: InsertCompanyNoteRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertCompanyNote`, JSON.stringify(params))
        }

        /**
         * InsertCompanyProductArea adds a row to the company_product_area table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertCompanyProductArea(params: InsertCompanyProductAreaRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertCompanyProductArea`, JSON.stringify(params))
        }

        /**
         * InsertCompanyProductAreaEntry adds a row to the company_product_area_entry table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertCompanyProductAreaEntry(params: InsertCompanyProductAreaEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertCompanyProductAreaEntry`, JSON.stringify(params))
        }

        /**
         * InsertCompanySegment adds a row to the company_segment table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertCompanySegment(params: InsertCompanySegmentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertCompanySegment`, JSON.stringify(params))
        }

        /**
         * InsertCompanySegmentEntry adds a row to the company_segment_entry table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertCompanySegmentEntry(params: InsertCompanySegmentEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertCompanySegmentEntry`, JSON.stringify(params))
        }

        /**
         * InsertCompanyType adds a row to the company_type table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertCompanyType(params: InsertCompanyTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertCompanyType`, JSON.stringify(params))
        }

        /**
         * InsertConnection adds a row to the connection table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertConnection(params: InsertConnectionRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertConnection`, JSON.stringify(params))
        }

        /**
         * InsertContact adds a row to the contact table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertContact(params: InsertContactRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertContact`, JSON.stringify(params))
        }

        /**
         * InsertContactDetail adds a row to the contact_detail table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertContactDetail(params: InsertContactDetailRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertContactDetail`, JSON.stringify(params))
        }

        /**
         * InsertContactDetailType adds a row to the contact_detail_type table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertContactDetailType(params: InsertContactDetailTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertContactDetailType`, JSON.stringify(params))
        }

        /**
         * InsertContactDocument adds a row to the contact_document table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertContactDocument(params: InsertContactDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertContactDocument`, JSON.stringify(params))
        }

        /**
         * InsertContactNote adds a row to the contact_note table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertContactNote(params: InsertContactNoteRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertContactNote`, JSON.stringify(params))
        }

        /**
         * InsertContactRole adds a row to the contact_role table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertContactRole(params: InsertContactRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertContactRole`, JSON.stringify(params))
        }

        /**
         * InsertDocument adds a row to the document table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertDocument(params: InsertDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertDocument`, JSON.stringify(params))
        }

        /**
         * InsertDocumentType adds a row to the document_type table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertDocumentType(params: InsertDocumentTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertDocumentType`, JSON.stringify(params))
        }

        /**
         * InsertEmployment adds a row to the employment table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertEmployment(params: InsertEmploymentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertEmployment`, JSON.stringify(params))
        }

        /**
         * InsertEvent adds a row to the event table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertEvent(params: InsertEventRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertEvent`, JSON.stringify(params))
        }

        /**
         * InsertEventAttendee adds a row to the event_attendee table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertEventAttendee(params: InsertEventAttendeeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertEventAttendee`, JSON.stringify(params))
        }

        /**
         * InsertEventType adds a row to the event_type table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertEventType(params: InsertEventTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertEventType`, JSON.stringify(params))
        }

        /**
         * InsertFormSubmission adds a row to the form_submission table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertFormSubmission(params: InsertFormSubmissionRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertFormSubmission`, JSON.stringify(params))
        }

        /**
         * InsertMeeting adds a row to the meeting table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertMeeting(params: InsertMeetingRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertMeeting`, JSON.stringify(params))
        }

        /**
         * InsertMeetingAttendee adds a row to the meeting_attendee table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertMeetingAttendee(params: InsertMeetingAttendeeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertMeetingAttendee`, JSON.stringify(params))
        }

        /**
         * InsertMeetingCompany adds a row to the meeting_company table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertMeetingCompany(params: InsertMeetingCompanyRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertMeetingCompany`, JSON.stringify(params))
        }

        /**
         * InsertMeetingType adds a row to the meeting_type table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertMeetingType(params: InsertMeetingTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertMeetingType`, JSON.stringify(params))
        }

        /**
         * InsertNewsletterSignup adds a row to the newsletter_signup table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertNewsletterSignup(params: InsertNewsletterSignupRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertNewsletterSignup`, JSON.stringify(params))
        }

        /**
         * InsertOnCallRole adds a row to the on_call_role table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertOnCallRole(params: InsertOnCallRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertOnCallRole`, JSON.stringify(params))
        }

        /**
         * InsertOnCallSchedule adds a row to the on_call_schedule table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertOnCallSchedule(params: InsertOnCallScheduleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertOnCallSchedule`, JSON.stringify(params))
        }

        /**
         * InsertOpportunity adds a row to the opportunity table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertOpportunity(params: InsertOpportunityRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertOpportunity`, JSON.stringify(params))
        }

        /**
         * InsertOpportunityFunnel adds a row to the opportunity_funnel table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertOpportunityFunnel(params: InsertOpportunityFunnelRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertOpportunityFunnel`, JSON.stringify(params))
        }

        /**
         * InsertOpportunityFunnelStep adds a row to the opportunity_funnel_step table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertOpportunityFunnelStep(params: InsertOpportunityFunnelStepRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertOpportunityFunnelStep`, JSON.stringify(params))
        }

        /**
         * InsertOpportunityProduct adds a row to the opportunity_product table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertOpportunityProduct(params: InsertOpportunityProductRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertOpportunityProduct`, JSON.stringify(params))
        }

        /**
         * InsertOpportunityType adds a row to the opportunity_type table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertOpportunityType(params: InsertOpportunityTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertOpportunityType`, JSON.stringify(params))
        }

        /**
         * InsertOrganizationDocument adds a row to the organization_document table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertOrganizationDocument(params: InsertOrganizationDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertOrganizationDocument`, JSON.stringify(params))
        }

        /**
         * InsertProduct adds a row to the product table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertProduct(params: InsertProductRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertProduct`, JSON.stringify(params))
        }

        /**
         * InsertProductCategory adds a row to the product_category table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertProductCategory(params: InsertProductCategoryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertProductCategory`, JSON.stringify(params))
        }

        /**
         * InsertProductDocument adds a row to the product_document table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertProductDocument(params: InsertProductDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertProductDocument`, JSON.stringify(params))
        }

        /**
         * InsertProductSubcategory adds a row to the product_subcategory table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertProductSubcategory(params: InsertProductSubcategoryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertProductSubcategory`, JSON.stringify(params))
        }

        /**
         * InsertProductUser adds a row to the product_user table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertProductUser(params: InsertProductUserRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertProductUser`, JSON.stringify(params))
        }

        /**
         * InsertSkrymCompanyRole adds a row to the skrym_company_role table¨
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertSkrymCompanyRole(params: InsertSkrymCompanyRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertSkrymCompanyRole`, JSON.stringify(params))
        }

        /**
         * InsertSkrymCompanyRoleArea adds a row to the skrym_company_role_area table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertSkrymCompanyRoleArea(params: InsertSkrymCompanyRoleAreaRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertSkrymCompanyRoleArea`, JSON.stringify(params))
        }

        /**
         * InsertSkrymContactRole adds a row to the skrym_contact_role table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertSkrymContactRole(params: InsertSkrymContactRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertSkrymContactRole`, JSON.stringify(params))
        }

        /**
         * InsertSprint adds a row to the sprint table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertSprint(params: InsertSprintRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertSprint`, JSON.stringify(params))
        }

        /**
         * InsertSprintDailyStandup adds a row to the sprint_daily_standup table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertSprintDailyStandup(params: InsertSprintDailyStandupRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertSprintDailyStandup`, JSON.stringify(params))
        }

        /**
         * InsertSprintDailyStandupEntry adds a row to the sprint_daily_standup_entry table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertSprintDailyStandupEntry(params: InsertSprintDailyStandupEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertSprintDailyStandupEntry`, JSON.stringify(params))
        }

        /**
         * InsertSprintMessage adds a row to the sprint_message table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertSprintMessage(params: InsertSprintMessageRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertSprintMessage`, JSON.stringify(params))
        }

        /**
         * InsertSprintMessageType adds a row to the sprint_message_type table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertSprintMessageType(params: InsertSprintMessageTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertSprintMessageType`, JSON.stringify(params))
        }

        /**
         * InsertSprintRole adds a row to the sprint_role table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertSprintRole(params: InsertSprintRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertSprintRole`, JSON.stringify(params))
        }

        /**
         * InsertSprintRoleEntry adds a row to the sprint_role_entry table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertSprintRoleEntry(params: InsertSprintRoleEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertSprintRoleEntry`, JSON.stringify(params))
        }

        /**
         * InsertTask adds a row to the task table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertTask(params: InsertTaskRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertTask`, JSON.stringify(params))
        }

        /**
         * InsertTaskOwner adds a row to the task_owner table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertTaskOwner(params: InsertTaskOwnerRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertTaskOwner`, JSON.stringify(params))
        }

        /**
         * InsertTaskStatus adds a row to the task_status table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertTaskStatus(params: InsertTaskStatusRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertTaskStatus`, JSON.stringify(params))
        }

        /**
         * InsertWorkingTime adds a row to the working_time table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertWorkingTime(params: InsertWorkingTimeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertWorkingTime`, JSON.stringify(params))
        }

        /**
         * InsertWorkingTimeLocation adds a row to the working_time_location table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertWorkingTimeLocation(params: InsertWorkingTimeLocationRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertWorkingTimeLocation`, JSON.stringify(params))
        }

        /**
         * InsertWorkingTimeType adds a row to the working_time_type table
         * 
         * If no id is passed in, one will be autogenerated
         */
        public async InsertWorkingTimeType(params: InsertWorkingTimeTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.InsertWorkingTimeType`, JSON.stringify(params))
        }

        /**
         * SearchCompanies retrieves all companies from the company table that match the provided Name
         */
        public async SearchCompanies(params: SearchCompaniesRequestParams): Promise<SearchCompaniesResponseParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.SearchCompanies`, JSON.stringify(params))
            return await resp.json() as SearchCompaniesResponseParams
        }

        /**
         * SearchContacts retrieves all companies from the company table that match the provided Name
         */
        public async SearchContacts(params: SearchContactsRequestParams): Promise<SearchContactsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/crm.SearchContacts`, JSON.stringify(params))
            return await resp.json() as SearchContactsResponse
        }

        /**
         * UpsertCallSheet adds or updates a row in the call_sheet table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertCallSheet(params: UpsertCallSheetRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertCallSheet`, JSON.stringify(params))
        }

        /**
         * UpsertChannel adds or updates a row in the channel table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertChannel(params: UpsertChannelRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertChannel`, JSON.stringify(params))
        }

        /**
         * UpsertCompany adds or updates a row in the company table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertCompany(params: UpsertCompanyRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertCompany`, JSON.stringify(params))
        }

        /**
         * UpsertCompanyBillingInfo adds or updates a row in the company_billing_info table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertCompanyBillingInfo(params: UpsertCompanyBillingInfoRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertCompanyBillingInfo`, JSON.stringify(params))
        }

        /**
         * UpsertCompanyInvoice adds or updates a row in the company_invoice table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertCompanyInvoice(params: UpsertCompanyInvoiceRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertCompanyInvoice`, JSON.stringify(params))
        }

        /**
         * UpsertCompanyNote adds or updates a row in the company_note table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertCompanyNote(params: UpsertCompanyNoteRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertCompanyNote`, JSON.stringify(params))
        }

        /**
         * UpsertCompanyProductArea adds or updates a row in the company_product_area table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertCompanyProductArea(params: UpsertCompanyProductAreaRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertCompanyProductArea`, JSON.stringify(params))
        }

        /**
         * UpsertCompanyProductAreaEntry adds or updates a row in the company_product_area_entry table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertCompanyProductAreaEntry(params: UpsertCompanyProductAreaEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertCompanyProductAreaEntry`, JSON.stringify(params))
        }

        /**
         * UpsertCompanySegment adds or updates a row in the company_segment table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertCompanySegment(params: UpsertCompanySegmentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertCompanySegment`, JSON.stringify(params))
        }

        /**
         * UpsertCompanySegmentEntry adds or updates a row in the company_segment_entry table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertCompanySegmentEntry(params: UpsertCompanySegmentEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertCompanySegmentEntry`, JSON.stringify(params))
        }

        public async UpsertCompanyType(params: UpsertCompanyTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertCompanyType`, JSON.stringify(params))
        }

        /**
         * UpsertConnection adds or updates a row in the connection table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertConnection(params: UpsertConnectionRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertConnection`, JSON.stringify(params))
        }

        /**
         * UpsertContact adds or updates a row in the contact table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertContact(params: UpsertContactRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertContact`, JSON.stringify(params))
        }

        /**
         * UpsertContactDetail adds or updates a row in the contact_detail table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertContactDetail(params: UpsertContactDetailRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertContactDetail`, JSON.stringify(params))
        }

        /**
         * UpsertContactDetailType adds or updates a row in the contact_detail_type table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertContactDetailType(params: UpsertContactDetailTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertContactDetailType`, JSON.stringify(params))
        }

        /**
         * UpsertContactDocument adds or updates a row in the contact_document table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertContactDocument(params: UpsertContactDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertContactDocument`, JSON.stringify(params))
        }

        /**
         * UpsertContactNote adds or updates a row in the contact_note table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertContactNote(params: UpsertContactNoteRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertContactNote`, JSON.stringify(params))
        }

        /**
         * UpsertContactRole adds or updates a row in the contact_role table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertContactRole(params: UpsertContactRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertContactRole`, JSON.stringify(params))
        }

        /**
         * UpsertDocument adds or updates a row in the document table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertDocument(params: UpsertDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertDocument`, JSON.stringify(params))
        }

        /**
         * UpsertDocumentType adds or updates a row in the document_type table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertDocumentType(params: UpsertDocumentTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertDocumentType`, JSON.stringify(params))
        }

        /**
         * UpsertEmployment adds or updates a row in the employment table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertEmployment(params: UpsertEmploymentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertEmployment`, JSON.stringify(params))
        }

        /**
         * UpsertEvent adds or updates a row in the event table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertEvent(params: UpsertEventRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertEvent`, JSON.stringify(params))
        }

        /**
         * UpsertEventAttendee adds or updates a row in the event_attendee table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertEventAttendee(params: UpsertEventAttendeeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertEventAttendee`, JSON.stringify(params))
        }

        /**
         * UpsertEventType adds or updates a row in the event_type table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertEventType(params: UpsertEventTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertEventType`, JSON.stringify(params))
        }

        /**
         * UpsertFormSubmission adds or updates a row in the form_submission table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertFormSubmission(params: UpsertFormSubmissionRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertFormSubmission`, JSON.stringify(params))
        }

        /**
         * UpsertMeeting adds or updates a row in the meeting table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertMeeting(params: UpsertMeetingRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertMeeting`, JSON.stringify(params))
        }

        /**
         * UpsertMeetingAttendee adds or updates a row in the meeting_attendee table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertMeetingAttendee(params: UpsertMeetingAttendeeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertMeetingAttendee`, JSON.stringify(params))
        }

        /**
         * UpsertMeetingCompany adds or updates a row in the meeting_company table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertMeetingCompany(params: UpsertMeetingCompanyRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertMeetingCompany`, JSON.stringify(params))
        }

        /**
         * UpsertMeetingType adds or updates a row in the meeting_type table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertMeetingType(params: UpsertMeetingTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertMeetingType`, JSON.stringify(params))
        }

        /**
         * UpsertMeetingWithAttendees adds or updates a row in the meeting table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertMeetingWithAttendees(params: UpsertMeetingWithAttendeesRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertMeetingWithAttendees`, JSON.stringify(params))
        }

        /**
         * UpsertNewsletterSignup adds or updates a row in the newsletter_signup table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertNewsletterSignup(params: UpsertNewsletterSignupRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertNewsletterSignup`, JSON.stringify(params))
        }

        /**
         * UpsertOnCallRole adds or updates a row in the on_call_role table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertOnCallRole(params: UpsertOnCallRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertOnCallRole`, JSON.stringify(params))
        }

        /**
         * UpsertOnCallSchedule adds or updates a row in the on_call_schedule table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertOnCallSchedule(params: UpsertOnCallScheduleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertOnCallSchedule`, JSON.stringify(params))
        }

        /**
         * UpsertOpportunity adds or updates a row in the opportunity table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertOpportunity(params: UpsertOpportunityRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertOpportunity`, JSON.stringify(params))
        }

        /**
         * UpsertOpportunityFunnel adds or updates a row in the opportunity_funnel table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertOpportunityFunnel(params: UpsertOpportunityFunnelRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertOpportunityFunnel`, JSON.stringify(params))
        }

        /**
         * UpsertOpportunityFunnelStep adds or updates a row in the opportunity_funnel_step table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertOpportunityFunnelStep(params: UpsertOpportunityFunnelStepRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertOpportunityFunnelStep`, JSON.stringify(params))
        }

        /**
         * UpsertOpportunityProduct adds or updates a row in the opportunity_product table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertOpportunityProduct(params: UpsertOpportunityProductRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertOpportunityProduct`, JSON.stringify(params))
        }

        /**
         * UpsertOpportunityType adds or updates a row in the opportunity_type table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertOpportunityType(params: UpsertOpportunityTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertOpportunityType`, JSON.stringify(params))
        }

        /**
         * UpsertOrganizationDocument adds or updates a row in the organization_document table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertOrganizationDocument(params: UpsertOrganizationDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertOrganizationDocument`, JSON.stringify(params))
        }

        /**
         * UpsertProduct adds or updates a row in the product table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertProduct(params: UpsertProductRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertProduct`, JSON.stringify(params))
        }

        /**
         * UpsertProductCategory adds or updates a row in the product_category table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertProductCategory(params: UpsertProductCategoryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertProductCategory`, JSON.stringify(params))
        }

        /**
         * UpsertProductDocument adds or updates a row in the product_document table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertProductDocument(params: UpsertProductDocumentRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertProductDocument`, JSON.stringify(params))
        }

        /**
         * UpsertProductSubcategory adds or updates a row in the product_subcategory table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertProductSubcategory(params: UpsertProductSubcategoryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertProductSubcategory`, JSON.stringify(params))
        }

        /**
         * UpsertProductUser adds or updates a row in the product_user table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertProductUser(params: UpsertProductUserRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertProductUser`, JSON.stringify(params))
        }

        /**
         * UpsertSkrymCompanyRole adds or updates a row in the skrym_company_role table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertSkrymCompanyRole(params: UpsertSkrymCompanyRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertSkrymCompanyRole`, JSON.stringify(params))
        }

        /**
         * UpsertSkrymCompanyRoleArea adds or updates a row in the skrym_company_role_area table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertSkrymCompanyRoleArea(params: UpsertSkrymCompanyRoleAreaRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertSkrymCompanyRoleArea`, JSON.stringify(params))
        }

        /**
         * UpsertSkrymContactRole adds or updates a row in the skrym_contact_role table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertSkrymContactRole(params: UpsertSkrymContactRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertSkrymContactRole`, JSON.stringify(params))
        }

        /**
         * UpsertSprint adds or updates a row in the sprint table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertSprint(params: UpsertSprintRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertSprint`, JSON.stringify(params))
        }

        /**
         * UpsertSprintDailyStandup adds or updates a row in the sprint_daily_standup table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertSprintDailyStandup(params: UpsertSprintDailyStandupRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertSprintDailyStandup`, JSON.stringify(params))
        }

        /**
         * UpsertSprintDailyStandupEntry adds or updates a row in the sprint_daily_standup_entry table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertSprintDailyStandupEntry(params: UpsertSprintDailyStandupEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertSprintDailyStandupEntry`, JSON.stringify(params))
        }

        /**
         * UpsertSprintMessage adds or updates a row in the sprint_message table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertSprintMessage(params: UpsertSprintMessageRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertSprintMessage`, JSON.stringify(params))
        }

        /**
         * UpsertSprintMessageType adds or updates a row in the sprint_message_type table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertSprintMessageType(params: UpsertSprintMessageTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertSprintMessageType`, JSON.stringify(params))
        }

        /**
         * UpsertSprintRole adds or updates a row in the sprint_role table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertSprintRole(params: UpsertSprintRoleRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertSprintRole`, JSON.stringify(params))
        }

        /**
         * UpsertSprintRoleEntry adds or updates a row in the sprint_role_entry table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertSprintRoleEntry(params: UpsertSprintRoleEntryRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertSprintRoleEntry`, JSON.stringify(params))
        }

        /**
         * UpsertTask adds or updates a row in the task table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertTask(params: UpsertTaskRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertTask`, JSON.stringify(params))
        }

        /**
         * UpsertTaskOwner adds or updates a row in the task_owner table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertTaskOwner(params: UpsertTaskOwnerRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertTaskOwner`, JSON.stringify(params))
        }

        /**
         * UpsertTaskStatus adds or updates a row in the task_status table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertTaskStatus(params: UpsertTaskStatusRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertTaskStatus`, JSON.stringify(params))
        }

        /**
         * UpsertWorkingTime adds or updates a row in the working_time table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertWorkingTime(params: UpsertWorkingTimeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertWorkingTime`, JSON.stringify(params))
        }

        /**
         * UpsertWorkingTimeLocation adds or updates a row in the working_time_location table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertWorkingTimeLocation(params: UpsertWorkingTimeLocationRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertWorkingTimeLocation`, JSON.stringify(params))
        }

        /**
         * UpsertWorkingTimeType adds or updates a row in the working_time_type table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertWorkingTimeType(params: UpsertWorkingTimeTypeRequestParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/crm.UpsertWorkingTimeType`, JSON.stringify(params))
        }
    }
}

export namespace customization {
    export interface DeleteCustomParameterParams {
        customParameterId: string
    }

    export interface DeleteParsingSchemaParams {
        customParameterId: string
    }

    export interface GetAllCustomParametersResponse {
        customParams: datamodels.ParameterNode[]
    }

    export interface GetAllCustomParametersWithParsingSchemasByOrgIDResponse {
        CustomParameters: models.CustomParameter[]
        ParsingSchema: models.ParsingSchema[]
    }

    /**
     * GetAllCustomizationsResponse contains the response for GetAllCustomizations.
     */
    export interface GetAllCustomizationsResponse {
        /**
         * List of customizations for organizations.
         */
        customizations: models.Customization[]
    }

    /**
     * GetAllLogosByUsageParams contains the parameters for GetAllLogosByUsage.
     */
    export interface GetAllLogosByUsageParams {
        /**
         * Type of logo usage.
         */
        logoUsage: models.LogoUsageType
    }

    /**
     * GetAllLogosByUsageResponse contains the response for GetAllLogosByUsage.
     */
    export interface GetAllLogosByUsageResponse {
        logos: models.OrganizationLogo[]
    }

    export interface GetAllParsingSchemasResponse {
        parsingSchemas: models.ParsingSchema[]
    }

    /**
     * GetCustomizationForOrganizationParams contains the parameters for GetCustomizationForOrganization.
     */
    export interface GetCustomizationForOrganizationParams {
        /**
         * Organization ID.
         */
        organizationId: string
    }

    /**
     * GetLogoByUsageParams contains the parameters for GetLogoByUsage.
     */
    export interface GetLogoByUsageParams {
        /**
         * Type of logo usage.
         */
        logoUsage: models.LogoUsageType
    }

    export interface GetOrganizationCurrencyResponse {
        /**
         * ISO 4217 currency code
         */
        currency: datamodels.Currency
    }

    /**
     * IsValidCustomParamRepresentationParams holds the parameters for the IsValidCustomParamRepresentation function.
     * It includes the raw JSON value of the custom parameter and the corresponding data model node that defines
     * what constitutes a valid parameter.
     */
    export interface IsValidCustomParamRepresentationParams {
        /**
         * Raw JSON of the custom parameter value.
         */
        customParameterValue: JSONValue

        /**
         * Data model node defining the parameter's valid structure.
         */
        parameterNode: datamodels.ParameterNode
    }

    export interface ParseStructuredStringParams {
        /**
         * raw structured string
         */
        inputString: string

        /**
         * delimiter that sperates key from values	; :
         */
        keySeparator: string

        /**
         * delimiter that separates values			; ,
         */
        valueSeparator: string

        /**
         * charachter that begins an array			; [
         */
        beginArray: string

        /**
         * charachter that ends an array				; ]
         */
        endArray: string

        /**
         * characther that begins an object			; {
         */
        beginObject: string

        /**
         * chartacter that ends an object				; }
         */
        endObject: string
    }

    export interface ParseStructuredStringResponse {
        parseRes: JSONValue
    }

    /**
     * SetCustomizationForOrganizationParams contains the parameters for SetCustomizationAndLogosForOrganization.
     */
    export interface SetCustomizationForOrganizationParams {
        /**
         * Identifier must be valid for a company or organization.
         */
        organizationId: string

        /**
         * Color scheme for light mode.
         */
        lightPalette?: models.Palette

        /**
         * Color scheme for dark mode.
         */
        darkPalette?: models.Palette

        /**
         * Border radius for elements.
         */
        borderRadius?: number
    }

    /**
     * SetCustomizationParams contains the parameters for SetCustomizationAndLogos.
     */
    export interface SetCustomizationParams {
        /**
         * Color scheme for light mode.
         */
        lightPalette?: models.Palette

        /**
         * Color scheme for dark mode.
         */
        darkPalette?: models.Palette

        /**
         * Border radius for elements.
         */
        borderRadius?: number
    }

    /**
     * Struct representing the input to UnParseJSON
     * 
     * UnParseJSONParams holds the parameters for converting a JSON object into a structured string.
     * The struct includes fields for delimiters and markers that dictate how to format
     * the resulting string.
     */
    export interface UnParseJSONParams {
        /**
         * json to unparse
         */
        inputJson: JSONValue

        /**
         * delimiter that should sperate key from values				; :
         */
        keySeparator: string

        /**
         * delimiter that should separate values						; ,
         */
        valueSeparator: string

        /**
         * character that should denote the beginning of an array	; [
         */
        beginArray: string

        /**
         * character that should denote the ending of an array		; ]
         */
        endArray: string

        /**
         * character that should denote the beginning of an object	; {
         */
        beginObject: string

        /**
         * character that should denote the ending of an array		; }
         */
        endObject: string
    }

    /**
     * Struct representing the output of UnParseJSON
     * 
     * UnParseJSONResponse holds the response from the UnParseJSON function.
     * It includes the resulting structured string, a flag indicating whether a
     * provided schema was used, and the custom parameter that was used for unparsing.
     */
    export interface UnParseJSONResponse {
        /**
         * raw structured string
         */
        outputString: string

        /**
         * indicates if the provided parsing schema was used (always false if parsing schema not provided)
         */
        schemaIgnored: boolean

        /**
         * the custom parameter used to parse the value
         */
        usedCustomParameter: datamodels.ParameterNode
    }

    export interface UpsertCustomParameterParams {
        /**
         * Skrym internal ID
         */
        id: string

        /**
         * KeyString indicates what Skrym will try to parse as the key in a key-value pair. Example "isBulky: true" has the KeyString "isBulky".
         */
        keyString: string

        /**
         * Will be the label used in e.g. delivery checkout config
         */
        label: string

        /**
         * Description of the CustomParameter
         */
        description: string

        /**
         * Specifies which DataType the CustomParameter is of, this will affect which operations it can be used in. The different types are: [boolean, number, string, object]
         */
        dataType: datamodels.CustomParameterDataType

        /**
         * Identifies if the CustomParameter is a child to any other 'object' CustomParameter
         */
        parentId?: string

        /**
         * optional property that shows a default value for the parameter in previews of the parameter and. Will be in the format "keyString": "defaultString" for strings, or "keyString" : ["default1", "default2"] for string array.
         */
        defaultValue: JSONValue

        /**
         * Specifies if the DataType is an array of said type or a single value.
         */
        isArray: boolean

        /**
         * Specifies color for displaying the CustomParameter
         */
        color: string

        /**
         * Specifies which Icon to show for the CustomParameter
         */
        icon: string

        /**
         * The time of creation, will default to now if not provided
         */
        createdAt?: string
    }

    export interface UpsertCustomParameterResponse {
        Id: string
    }

    export interface UpsertOrganizationCurrencyParams {
        /**
         * ISO 4217 currency code
         */
        currency: datamodels.Currency
    }

    export interface UpsertParsingSchemaParams {
        parsingSchema: models.ParsingSchema
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.DeleteCustomParameter = this.DeleteCustomParameter.bind(this)
            this.DeleteParsingSchema = this.DeleteParsingSchema.bind(this)
            this.GetAllCustomParameters = this.GetAllCustomParameters.bind(this)
            this.GetAllCustomParametersWithParsingSchemasByOrgID = this.GetAllCustomParametersWithParsingSchemasByOrgID.bind(this)
            this.GetAllCustomizations = this.GetAllCustomizations.bind(this)
            this.GetAllLogosByUsage = this.GetAllLogosByUsage.bind(this)
            this.GetAllParsingSchemas = this.GetAllParsingSchemas.bind(this)
            this.GetCustomization = this.GetCustomization.bind(this)
            this.GetCustomizationForOrganization = this.GetCustomizationForOrganization.bind(this)
            this.GetLogoByUsage = this.GetLogoByUsage.bind(this)
            this.GetOrganizationCurrency = this.GetOrganizationCurrency.bind(this)
            this.IsValidCustomParamRepresentation = this.IsValidCustomParamRepresentation.bind(this)
            this.ParseStructuredString = this.ParseStructuredString.bind(this)
            this.SetCustomization = this.SetCustomization.bind(this)
            this.SetCustomizationForOrganization = this.SetCustomizationForOrganization.bind(this)
            this.UnParseJSON = this.UnParseJSON.bind(this)
            this.UpsertCustomParameter = this.UpsertCustomParameter.bind(this)
            this.UpsertOrganizationCurrency = this.UpsertOrganizationCurrency.bind(this)
            this.UpsertParsingSchema = this.UpsertParsingSchema.bind(this)
        }

        /**
         * DeleteCustomParameter deletes a CustomParameter and all of its descendants (children, grandchildren, etc.)
         * from the database.
         * 
         * The function first creates a Recursive Common Table Expression (CTE) to find all the
         * descendants of the CustomParameter identified by 'id'. Then, it deletes all these CustomParameters.
         * The function returns an error if the deletion operation fails.
         * 
         * Note: This operation could be expensive if there are a lot of nested children as it has to retrieve all
         * the descendant custom parameters before it can delete them.
         */
        public async DeleteCustomParameter(params: DeleteCustomParameterParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/customization.DeleteCustomParameter`, JSON.stringify(params))
        }

        /**
         * DeleteParsingSchema deletes a specific parsing schema associated with the authenticated organization.
         * 
         * The function:
         * 1. Begins a database transaction.
         * 2. Extracts the organization ID (RetailerId) from the authenticated user context.
         * 3. Deletes the parsing schema from the repository using the provided key.
         * 4. Commits the transaction if the deletion is successful, otherwise rolls back and returns an error.
         * 
         * Parameters:
         * - ctx: The context used for execution. Contains authentication data.
         * - in: The parameters used to specify which parsing schema to delete. Contains the key of the schema to be deleted.
         * 
         * Returns:
         * - error: An error object in case of failures.
         */
        public async DeleteParsingSchema(params: DeleteParsingSchemaParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/customization.DeleteParsingSchema`, JSON.stringify(params))
        }

        /**
         * GetAllCustomParameters is an API endpoint that retrieves all custom parameters associated with the authenticated retailer.
         * 
         * The function calls a database to get all custom parameters associated with the organization ID,
         * and then constructs a response object that includes a tree structure of the custom parameters.
         * If there is an error fetching the custom parameters, it logs the error and the organization ID.
         * This function requires authentication.
         */
        public async GetAllCustomParameters(): Promise<GetAllCustomParametersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.GetAllCustomParameters`)
            return await resp.json() as GetAllCustomParametersResponse
        }

        public async GetAllCustomParametersWithParsingSchemasByOrgID(): Promise<GetAllCustomParametersWithParsingSchemasByOrgIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.GetAllCustomParametersWithParsingSchemasByOrgID`)
            return await resp.json() as GetAllCustomParametersWithParsingSchemasByOrgIDResponse
        }

        /**
         * GetAllCustomizations retrieves all customization settings for all organizations.
         * Used for e.g. companies table.
         */
        public async GetAllCustomizations(): Promise<GetAllCustomizationsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.GetAllCustomizations`)
            return await resp.json() as GetAllCustomizationsResponse
        }

        /**
         * GetAllLogosByUsage retrieves the logo paths for the given logo usage type for all organizations.
         */
        public async GetAllLogosByUsage(params: GetAllLogosByUsageParams): Promise<GetAllLogosByUsageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.GetAllLogosByUsage`, JSON.stringify(params))
            return await resp.json() as GetAllLogosByUsageResponse
        }

        /**
         * GetAllParsingSchemas retrieves all parsing schemas associated with the authenticated organization.
         * 
         * The function:
         * 1. Extracts the retailer ID from the authenticated user context.
         * 2. Queries the repository to fetch all parsing schemas linked to the organization.
         * 3. Returns a collection of parsing schemas.
         * 
         * Returns:
         * - GetAllParsingSchemasResponse: The response object containing an array of parsing schemas associated with the organization.
         * - error: An error object in case of failures.
         */
        public async GetAllParsingSchemas(): Promise<GetAllParsingSchemasResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.GetAllParsingSchemas`)
            return await resp.json() as GetAllParsingSchemasResponse
        }

        /**
         * GetCustomization retrieves customization settings for the authenticated organization.
         */
        public async GetCustomization(): Promise<models.Customization> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.GetCustomization`)
            return await resp.json() as models.Customization
        }

        /**
         * GetCustomizationForOrganization retrieves customization settings for the given organization ID
         */
        public async GetCustomizationForOrganization(params: GetCustomizationForOrganizationParams): Promise<models.Customization> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.GetCustomizationForOrganization`, JSON.stringify(params))
            return await resp.json() as models.Customization
        }

        /**
         * GetLogoByUsage retrieves the logo path for the given logo usage type for the authenticated organization.
         */
        public async GetLogoByUsage(params: GetLogoByUsageParams): Promise<models.OrganizationLogo> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.GetLogoByUsage`, JSON.stringify(params))
            return await resp.json() as models.OrganizationLogo
        }

        /**
         * GetOrganizationCurrency fetches the preferred currency for the retailer.
         * If no currency is found, SEK is inserted as default and returned.
         */
        public async GetOrganizationCurrency(): Promise<GetOrganizationCurrencyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.GetOrganizationCurrency`)
            return await resp.json() as GetOrganizationCurrencyResponse
        }

        /**
         * Custom param validator
         * 
         * IsValidCustomParamRepresentation checks if the provided custom parameter value conforms to the specifications
         * defined in the associated ParameterNode. It uses the datavalidation package to perform the validation.
         */
        public async IsValidCustomParamRepresentation(params: IsValidCustomParamRepresentationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/customization.IsValidCustomParamRepresentation`, JSON.stringify(params))
        }

        /**
         * ParseStructuredString attempts to parse a structured string input based on predefined custom parameters.
         * Parsing schema elements are assumed to be standard JSON values if empty. (i.e: KeySeparator: ':', ValueSeparator: ',', BeginArray: '[' and so on.)
         * The function handles multiple formats, including JSON and XML, and attempts to validate and structure
         * the input according to the organization's custom parameters. It employs multiple strategies:
         * - It first checks if the input is a valid JSON containing the required keys.
         * - If not, it then assumes the input is a stringified XML and attempts to parse it.
         * - If both strategies fail, it iterates through available custom parameters to identify potential matches.
         * If a valid structured representation is identified, it returns the result as a raw JSON message.
         * If no valid structure is found, an error is returned.
         * 
         * This function requires authentication and will fetch custom parameters based on the authenticated user's organization.
         * 
         * Parameters:
         * 
         * 	ctx: The context for the request.
         * 	in: The parameters required to parse the structured string, including the input string and various delimiters.
         * 
         * Returns:
         * 
         * 	A response containing the parsed result as a raw JSON message or an error if the parsing or validation fails.
         */
        public async ParseStructuredString(params: ParseStructuredStringParams): Promise<ParseStructuredStringResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.ParseStructuredString`, JSON.stringify(params))
            return await resp.json() as ParseStructuredStringResponse
        }

        /**
         * SetCustomization sets the customization for the authenticated organization.
         */
        public async SetCustomization(params: SetCustomizationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/customization.SetCustomization`, JSON.stringify(params))
        }

        /**
         * SetCustomizationForOrganization sets the customization for a specific organization.
         */
        public async SetCustomizationForOrganization(params: SetCustomizationForOrganizationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/customization.SetCustomizationForOrganization`, JSON.stringify(params))
        }

        /**
         * Function to reverse parse a JSON value to a structured string
         * 
         * UnParseJSON takes a JSON object and transforms it into a structured string using the provided parsing schema.
         * Parsing schema elements are assumed to be standard JSON values if empty. (i.e: KeySeparator: ':', ValueSeparator: ',', BeginArray: '[' and so on.)
         * If a matching custom parameter is found for the input JSON, that parameter's settings are used for the transformation.
         * This function is intended to be used as a testing tool for setting up custom parsing schemas, and therefore only reverse-parses the datatypes that are supported in ParseStructuredString.
         * The supported datatypes are: CustomJson, CustomXML, CustomString arrays, and CustomNumber arrays.
         * This is also intended to only be used with objects of one custom parameter at a time as it is difficult to represent multiple custom parameters in a single string.
         */
        public async UnParseJSON(params: UnParseJSONParams): Promise<UnParseJSONResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.UnParseJSON`, JSON.stringify(params))
            return await resp.json() as UnParseJSONResponse
        }

        /**
         * UpsertCustomParameter inserts or updates a CustomParameter in the database.
         * 
         * If the ID field of the provided CustomParameter model is not set, the endpoint generates a new UUID.
         * For fields like description, color, and icon, if they are empty, they will be set to NULL in the database.
         * If parentID is provided, it will be used as the parent for this custom parameter.
         * Upon successful insertion, the endpoint responds with the inserted CustomParameters ID.
         * If the database operation fails for any reason, the endpoint returns an error.
         */
        public async UpsertCustomParameter(params: UpsertCustomParameterParams): Promise<UpsertCustomParameterResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.UpsertCustomParameter`, JSON.stringify(params))
            return await resp.json() as UpsertCustomParameterResponse
        }

        /**
         * UpsertOrganizationCurrency upserts the preferred currency for the retailer.
         */
        public async UpsertOrganizationCurrency(params: UpsertOrganizationCurrencyParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/customization.UpsertOrganizationCurrency`, JSON.stringify(params))
        }

        /**
         * UpsertParsingSchema upserts a parsing schema for a specific organization using the provided parameters.
         * 
         * The function:
         * 1. Extracts the retailer ID from the authenticated user context.
         * 2. Prepares the parsing schema model.
         * 3. Begins a database transaction.
         * 4. Tries to insert or update the parsing schema in the database.
         * 5. Commits the transaction if successful, otherwise rolls back and returns an error.
         * 
         * Authentication is required for this endpoint.
         * 
         * Parameters:
         * - ctx: The context used for execution. Contains authentication data.
         * - in: The parameters to upsert the parsing schema. Contains values for key and value separators, array and object delimiters.
         * 
         * Returns:
         * - UpsertParsingSchemaResponse: The response object which reflects the inserted/updated parsing schema.
         * - error: An error object in case of failures.
         */
        public async UpsertParsingSchema(params: UpsertParsingSchemaParams): Promise<UpsertParsingSchemaParams> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/customization.UpsertParsingSchema`, JSON.stringify(params))
            return await resp.json() as UpsertParsingSchemaParams
        }
    }
}

export namespace detection {
    export interface GetFeedbackForOrdersRequest {
        externalIds: string[]
    }

    export interface GetFeedbackForOrdersResponse {
        orderWithFeedback: { [key: string]: datamodels.Feedback[] }
    }

    export interface GetFeedbackForOrganizationParams {
        filters: datamodels.GetFeedbackFilters
    }

    export interface GetFeedbackForOrganizationResponse {
        feedback: datamodels.Feedback[]
    }

    /**
     * GetInferredProductsParams defines the filter parameters for retrieving inferred products.
     */
    export interface GetInferredProductsParams {
        /**
         * Unique identifiers for products
         */
        productIDs: string[]

        /**
         * External product identifiers
         */
        externalIDs?: string[]

        /**
         * Unique identifiers for organizations
         */
        organizationIDs?: string[]

        /**
         * EAN codes
         */
        eans?: string[]

        /**
         * Filter products created on or after this time
         */
        createdFrom?: string

        /**
         * Filter products created on or before this time
         */
        createdTo?: string
    }

    /**
     * GetInferredProductsResponse defines the response structure containing the filtered inferred products.
     */
    export interface GetInferredProductsResponse {
        /**
         * The inferred products that match the provided filters
         */
        products: models.InferredProduct[]
    }

    export interface RemoveProductsFromMissingParams {
        ExternalIDs: string[]
    }

    /**
     * UpsertInferenceObservationsParams defines the parameters for upserting inference observations.
     */
    export interface UpsertInferenceObservationsParams {
        /**
         * The observations to be upserted
         */
        observations: models.InferenceObservation[]

        /**
         * The organization ID to which the observations belong
         */
        organizationID: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.GetFeedbackForOrders = this.GetFeedbackForOrders.bind(this)
            this.GetFeedbackForOrganization = this.GetFeedbackForOrganization.bind(this)
            this.GetInferredProducts = this.GetInferredProducts.bind(this)
            this.RemoveProductsFromMissing = this.RemoveProductsFromMissing.bind(this)
            this.UpsertInferenceObservations = this.UpsertInferenceObservations.bind(this)
        }

        public async GetFeedbackForOrders(params: GetFeedbackForOrdersRequest): Promise<GetFeedbackForOrdersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/detection.GetFeedbackForOrders`, JSON.stringify(params))
            return await resp.json() as GetFeedbackForOrdersResponse
        }

        /**
         * GetFeedbackForOrganization is an authenticated endpoint that returns all feedback information for a given organization matching the given filters.
         */
        public async GetFeedbackForOrganization(params: GetFeedbackForOrganizationParams): Promise<GetFeedbackForOrganizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/detection.GetFeedbackForOrganization`, JSON.stringify(params))
            return await resp.json() as GetFeedbackForOrganizationResponse
        }

        public async GetInferredProducts(params: GetInferredProductsParams): Promise<GetInferredProductsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/detection.GetInferredProducts`, JSON.stringify(params))
            return await resp.json() as GetInferredProductsResponse
        }

        public async RemoveProductsFromMissing(params: RemoveProductsFromMissingParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/detection.RemoveProductsFromMissing`, JSON.stringify(params))
        }

        public async UpsertInferenceObservations(params: UpsertInferenceObservationsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/detection.UpsertInferenceObservations`, JSON.stringify(params))
        }
    }
}

export namespace emailer {
    export interface GetAllAvailableTopicsAndSubscribedResponse {
        accountId: string
        retailerId: string
        email: string
        subscriptions: models.Subscription[]
    }

    export interface GetAvailableTopicsResponse {
        topics: models.EmailSubscriptionType[]
    }

    export interface GetSubscribedTopicsResponse {
        AccountSubscriptions: models.EmailSubscription
    }

    export interface SendSelfOnboardConfirmationParams {
        onboard: models.SelfOnboard
        links: string[]
        language: string
    }

    export interface SubscribeToTopicParams {
        topic: models.EmailSubscriptionType
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.GetAllAvailableTopics = this.GetAllAvailableTopics.bind(this)
            this.GetAllAvailableTopicsAndSubscribed = this.GetAllAvailableTopicsAndSubscribed.bind(this)
            this.GetSubscribedTopics = this.GetSubscribedTopics.bind(this)
            this.SendSelfOnboardConfirmation = this.SendSelfOnboardConfirmation.bind(this)
            this.SubscribeToTopic = this.SubscribeToTopic.bind(this)
            this.UnsubscribeToTopic = this.UnsubscribeToTopic.bind(this)
        }

        public async GetAllAvailableTopics(): Promise<GetAvailableTopicsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/emailer.GetAllAvailableTopics`)
            return await resp.json() as GetAvailableTopicsResponse
        }

        public async GetAllAvailableTopicsAndSubscribed(): Promise<GetAllAvailableTopicsAndSubscribedResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/emailer.GetAllAvailableTopicsAndSubscribed`)
            return await resp.json() as GetAllAvailableTopicsAndSubscribedResponse
        }

        public async GetSubscribedTopics(): Promise<GetSubscribedTopicsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/emailer.GetSubscribedTopics`)
            return await resp.json() as GetSubscribedTopicsResponse
        }

        public async SendSelfOnboardConfirmation(params: SendSelfOnboardConfirmationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/emailer.SendSelfOnboardConfirmation`, JSON.stringify(params))
        }

        public async SubscribeToTopic(params: SubscribeToTopicParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/emailer.SubscribeToTopic`, JSON.stringify(params))
        }

        public async UnsubscribeToTopic(params: SubscribeToTopicParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/emailer.UnsubscribeToTopic`, JSON.stringify(params))
        }
    }
}

export namespace environmental {
    /**
     * ConfirmTransportMethodForEmissionsResultParams defines the parameters required for confirming the transport method for emissions result.
     * It includes the transporter and transport method aliases set by the user, and a Skrym ID (ReferenceID) tied to the CalculationOrigin.
     */
    export interface ConfirmTransportMethodForEmissionsResultParams {
        /**
         * Transport method alias set by the user.
         */
        transportMethod: string

        /**
         * Skrym ID for the part of the system that provided data for emissions calculation.
         */
        referenceId: string

        /**
         * Skrym ID for the order that the emissions result is tied to.
         */
        orderID: string
    }

    /**
     * GetEmissionResultsBreakdownForOrganizationParams represents the request body for the
     * GetEmissionResultsBreakdownForOrganization API endpont. The OrganizationID is an
     * optional parameter and if not provided it will default to auth data of the caller.
     */
    export interface GetEmissionResultsBreakdownForOrganizationParams {
        organizationId: string
        /**
         * can be empty string or one of: "CHECKOUT", "BOOKING", "OPTIMIZATION", "TRACKING"
         */
        calculationOrigin: models.CalculationOrigin

        onlyLatest: boolean
        /**
         * can be empty string or one of: "CHECKOUT", "BOOKING", "OPTIMIZATION", "TRACKING"
         */
        ignoreOrigin: models.CalculationOrigin

        startDate: string
        endDate: string
    }

    /**
     * GetEmissionResultsBreakdownForOrganizationResponse represents the response body
     * of GetEmissionResultsBreakdownForOrganization API endpoint.
     */
    export interface GetEmissionResultsBreakdownForOrganizationResponse {
        emissionsBreakdown: models.EmissionResultBreakdown
    }

    /**
     * GetOrderEmissionPerformanceParams is the parameter struct for GetOrderEmissionPerformance API
     * Fields "StartDate" and "EndDate" are required, "BestOrdersListSize" and "WorstOrdersListSize" are optional
     */
    export interface GetOrderEmissionPerformanceParams {
        startDate: string
        endDate: string
        /**
         * If not provided, defaults to 1
         */
        limit?: number

        descending?: boolean
    }

    /**
     * GetOrderEmissionPerformanceResponse is the response struct for GetOrderEmissionPerformance API
     */
    export interface GetOrderEmissionPerformanceResponse {
        orders: models.OrderPerformanceModel[]
    }

    /**
     * InsertEmissionsResultReferenceParams holds the parameter for inserting an emissions result reference.
     * It contains the Skrym ID for the referenced entity such as OrderID or BookingID.
     */
    export interface InsertEmissionsResultReferenceParams {
        /**
         * Skrym ID depending on where this is called from. For example, OrderID, BookingID, etc...
         */
        referenceId: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.ConfirmTransportMethodForEmissionsResult = this.ConfirmTransportMethodForEmissionsResult.bind(this)
            this.GetEmissionResultsBreakdownForOrganization = this.GetEmissionResultsBreakdownForOrganization.bind(this)
            this.GetOrderEmissionPerformance = this.GetOrderEmissionPerformance.bind(this)
            this.InsertEmissionsResultReference = this.InsertEmissionsResultReference.bind(this)
        }

        /**
         * ConfirmTransportMethodForEmissionsResult confirms the transport method for emissions result based on the provided parameters.
         * It retrieves the transport method by its aliases, initiates a database transaction, and confirms the transport method for the emissions result.
         */
        public async ConfirmTransportMethodForEmissionsResult(params: ConfirmTransportMethodForEmissionsResultParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/environmental.ConfirmTransportMethodForEmissionsResult`, JSON.stringify(params))
        }

        /**
         * GetEmissionResultsBreakdownForOrganization is an API endpoint retrieving the breakdown of emissions within the specified parameters.
         */
        public async GetEmissionResultsBreakdownForOrganization(params: GetEmissionResultsBreakdownForOrganizationParams): Promise<GetEmissionResultsBreakdownForOrganizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/environmental.GetEmissionResultsBreakdownForOrganization`, JSON.stringify(params))
            return await resp.json() as GetEmissionResultsBreakdownForOrganizationResponse
        }

        /**
         * GetOrderEmissionPerformance is an API endpoint to fetch order performance
         * 
         * GetOrderEmissionPerformance fetches total emission and emission breakdown for each unique orders
         * and returns them in 2 separate lists based on their performance ranking. The split lists are called "BestOrders" and "WorstOrders"
         */
        public async GetOrderEmissionPerformance(params: GetOrderEmissionPerformanceParams): Promise<GetOrderEmissionPerformanceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/environmental.GetOrderEmissionPerformance`, JSON.stringify(params))
            return await resp.json() as GetOrderEmissionPerformanceResponse
        }

        /**
         * InsertEmissionsResultReference inserts an emissions result reference for a specific reference entity
         * into the database.
         */
        public async InsertEmissionsResultReference(params: InsertEmissionsResultReferenceParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/environmental.InsertEmissionsResultReference`, JSON.stringify(params))
        }
    }
}

export namespace integrations {
    /**
     * CreatePrintnodeAccountParams is the request struct for CreatePrintnodeAccount API
     */
    export interface CreatePrintnodeAccountParams {
        email: string
        password: string
        createdBy: string
        name: string
        description: string
    }

    export interface CustomerSlackMessageParams {
        author: string
        email: string
        message: string
        messageOrigin: string
    }

    /**
     * Parameters required for executing a soft delete of PrintnodeComputerAlias
     */
    export interface DeletePrintnodeComputerAliasParams {
        /**
         * Primary identifier for the PrintnodeComputerAlias to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of PrintnodeComputerAliasType
     */
    export interface DeletePrintnodeComputerAliasTypeParams {
        /**
         * Primary identifier for the PrintnodeComputerAliasType to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    /**
     * Parameters required for executing a soft delete of PrintnodeCredentials
     */
    export interface DeletePrintnodeCredentialsParams {
        /**
         * Primary identifier for the PrintnodeCredentials to be deleted
         */
        id: string

        /**
         * Identifier for the user who executes the deletion
         */
        deletedBy: string
    }

    export interface GetAllPrintnodeComputerAliasTypesResponse {
        PrintnodeComputerAliasTypes: models.PrintnodeComputerAliasType[]
    }

    export interface GetAllPrintnodeComputerAliasesResponse {
        PrintnodeComputerAliases: models.PrintnodeComputerAlias[]
    }

    export interface GetAllPrintnodeCredentialsResponse {
        PrintnodeCredentials: models.PrintnodeCredentials[]
    }

    /**
     * GetComputersForOrganizationResponse is the response struct for GetComputersForOrganization API
     */
    export interface GetComputersForOrganizationResponse {
        computers: models.Computer[]
    }

    /**
     * GetCredentialsForOrganizationResponse represents the response object returned by
     * the GetPinmetoCredentialsByOrganization API. It contains the decrypted Pinmeto
     * credentials of the organization retrieved from the database.
     */
    export interface GetCredentialsForOrganizationResponse {
        credentials: models.PinmetoCredentials
    }

    /**
     * GetOngoingCredentialsResponse holds the decrypted Ongoing account details
     * for the authenticated retailer.
     */
    export interface GetOngoingCredentialsResponse {
        info: models.OngoingDbInfo
    }

    /**
     * GetPrintJobHistoryParams is the request struct for GetPrintJobHistory API
     */
    export interface GetPrintJobHistoryParams {
        printerID: string
    }

    /**
     * GetPrintJobHistoryResponse is the response struct for GetPrintJobHistory API
     */
    export interface GetPrintJobHistoryResponse {
        jobs: models.HistoricPrintJob[]
    }

    /**
     * GetPrintersForOrganizationResponse is the response struct for GetPrintersForOrganization API
     */
    export interface GetPrintersForOrganizationResponse {
        printers: models.Printer[]
    }

    /**
     * Parameters required for executing a soft delete of PrintnodeComputerAlias
     */
    export interface GetPrintnodeComputerAliasByIdParams {
        /**
         * Primary identifier for the PrintnodeComputerAlias to be fetched
         */
        id: string
    }

    export interface GetPrintnodeComputerAliasByIdResponse {
        PrintnodeComputerAlias: models.PrintnodeComputerAlias
    }

    /**
     * Parameters required for executing a soft delete of PrintnodeComputerAliasType
     */
    export interface GetPrintnodeComputerAliasTypeByIdParams {
        /**
         * Primary identifier for the PrintnodeComputerAliasType to be fetched
         */
        id: string
    }

    export interface GetPrintnodeComputerAliasTypeByIdResponse {
        PrintnodeComputerAliasType: models.PrintnodeComputerAliasType
    }

    export interface GetPrintnodeComputerAliasTypesByCodeParams {
        Code: string
    }

    export interface GetPrintnodeComputerAliasTypesByCodeResponse {
        PrintnodeComputerAliasTypeList: models.PrintnodeComputerAliasType[]
    }

    export interface GetPrintnodeComputerAliasesByAliasTypeParams {
        AliasType: string
    }

    export interface GetPrintnodeComputerAliasesByAliasTypeResponse {
        PrintnodeComputerAliasList: models.PrintnodeComputerAlias[]
    }

    export interface GetPrintnodeComputerAliasesByAliasValueParams {
        AliasValue: string
    }

    export interface GetPrintnodeComputerAliasesByAliasValueResponse {
        PrintnodeComputerAliasList: models.PrintnodeComputerAlias[]
    }

    export interface GetPrintnodeComputerAliasesByOrganizationIdParams {
        OrganizationId: string
    }

    export interface GetPrintnodeComputerAliasesByOrganizationIdResponse {
        PrintnodeComputerAliasList: models.PrintnodeComputerAlias[]
    }

    export interface GetPrintnodeComputerAliasesByPrintnodeComputerIdParams {
        PrintnodeComputerId: string
    }

    export interface GetPrintnodeComputerAliasesByPrintnodeComputerIdResponse {
        PrintnodeComputerAliasList: models.PrintnodeComputerAlias[]
    }

    /**
     * Parameters required for executing a soft delete of PrintnodeCredentials
     */
    export interface GetPrintnodeCredentialsByIdParams {
        /**
         * Primary identifier for the PrintnodeCredentials to be fetched
         */
        id: string
    }

    export interface GetPrintnodeCredentialsByIdResponse {
        PrintnodeCredentials: models.PrintnodeCredentials
    }

    export interface GetPrintnodeCredentialsByOrganizationIdParams {
        OrganizationId: string
    }

    export interface GetPrintnodeCredentialsByOrganizationIdResponse {
        PrintnodeCredentialsList: models.PrintnodeCredentials[]
    }

    export interface GetPrintnodeCredentialsByPrintnodeAccountIdParams {
        PrintnodeAccountId: string
    }

    export interface GetPrintnodeCredentialsByPrintnodeAccountIdResponse {
        PrintnodeCredentialsList: models.PrintnodeCredentials[]
    }

    export interface InsertPrintnodeComputerAliasParams {
        PrintnodeComputerAlias: models.PrintnodeComputerAlias
    }

    export interface InsertPrintnodeComputerAliasTypeParams {
        PrintnodeComputerAliasType: models.PrintnodeComputerAliasType
    }

    export interface InsertPrintnodeCredentialsParams {
        PrintnodeCredentials: models.PrintnodeCredentials
    }

    /**
     * OngoingArticleUpdatedWebhookParams represents the parameters for the OngoingArticleUpdateWebhook function.
     * It contains details about the webhook event and the article that was updated.
     */
    export interface OngoingArticleUpdatedWebhookParams {
        /**
         * Unique identifier for the webhook article.
         */
        webhookArticlesId: number

        /**
         * Unique identifier for the webhook event.
         */
        webhookEventId: number

        /**
         * System from which the webhook originates.
         */
        system: string

        /**
         * Timestamp of when the webhook event occurred.
         */
        timestamp: string

        /**
         * Unique identifier for the article in the system.
         */
        articleSystemId: number

        /**
         * Number associated with the article.
         */
        articleNumber: string

        /**
         * Unique identifier for the owner of the goods.
         */
        goodsOwnerId: number

        /**
         * Path associated with the webhook.
         */
        path: string

        /**
         * Template used for the webhook.
         */
        webhookTemplate: string
    }

    export interface OngoingBookingWebhookParams {
        webhookOrdersId: number
        webhookEventId: number
        system: string
        timestamp: string
        orderId: number
        orderNumber: string
        goodsOwnerId: number
        path: string
        byUser: {
            userId: number
        }
        byComputer: {
            computerId: number
            computerName: string
        }
        orderStatus: {
            number: number
        }
        currentShipmentId: number
        webhookTemplate: string
        goodsOwnerName: string
    }

    /**
     * PrintLabelParams is the request struct for PrintLabel API
     */
    export interface PrintLabelParams {
        printerID: string
        labelURL: string
        shipmentID: string
    }

    export interface PrintLabelsWithPrintNodeParams {
        /**
         * The pairs of printerId and booking references.
         */
        printingParameters: models.PrinterForBookingReference[]
    }

    export interface SendSlackMessageParams {
        author: string
        message: string
    }

    export interface UpsertOngoingInfoParams {
        /**
         * IF no ID is provided one will be generated and returned
         */
        id: string

        retailerId: string
        url: string
        username: string
        password: string
        goodsOwner: number
        lengthUnit: utils.MeasurementUnit
        weightUnit: utils.MeasurementUnit
        transporterField: models.OngoingTransporterField
        setParcelType: boolean
        printWithSkrym: boolean
    }

    export interface UpsertOngoingInfoResponse {
        /**
         * ID of the upserted Ongoing Info entry
         */
        id: string
    }

    /**
     * UpsertPinmetoCredentialsParams holds the credentials that need to be upserted.
     */
    export interface UpsertPinmetoCredentialsParams {
        credentials: models.PinmetoCredentials
    }

    export interface UpsertPrintnodeComputerAliasParams {
        PrintnodeComputerAlias: models.PrintnodeComputerAlias
    }

    export interface UpsertPrintnodeComputerAliasTypeParams {
        PrintnodeComputerAliasType: models.PrintnodeComputerAliasType
    }

    export interface UpsertPrintnodeCredentialsParams {
        PrintnodeCredentials: models.PrintnodeCredentials
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.BrinkOrderCreatedWebhook = this.BrinkOrderCreatedWebhook.bind(this)
            this.BusinessCentralItemWebhookRaw = this.BusinessCentralItemWebhookRaw.bind(this)
            this.CallGPT = this.CallGPT.bind(this)
            this.CreatePrintNodeAccountForOrganization = this.CreatePrintNodeAccountForOrganization.bind(this)
            this.DeletePinmetoCredentials = this.DeletePinmetoCredentials.bind(this)
            this.DeletePrintnodeComputerAlias = this.DeletePrintnodeComputerAlias.bind(this)
            this.DeletePrintnodeComputerAliasType = this.DeletePrintnodeComputerAliasType.bind(this)
            this.DeletePrintnodeCredentials = this.DeletePrintnodeCredentials.bind(this)
            this.FetchOngoingArticles = this.FetchOngoingArticles.bind(this)
            this.GetAllPrintnodeComputerAliasTypes = this.GetAllPrintnodeComputerAliasTypes.bind(this)
            this.GetAllPrintnodeComputerAliases = this.GetAllPrintnodeComputerAliases.bind(this)
            this.GetAllPrintnodeCredentials = this.GetAllPrintnodeCredentials.bind(this)
            this.GetComputersForOrganization = this.GetComputersForOrganization.bind(this)
            this.GetOngoingCredentials = this.GetOngoingCredentials.bind(this)
            this.GetPinmetoCredentials = this.GetPinmetoCredentials.bind(this)
            this.GetPrintJobHistory = this.GetPrintJobHistory.bind(this)
            this.GetPrintersForOrganization = this.GetPrintersForOrganization.bind(this)
            this.GetPrintnodeComputerAliasById = this.GetPrintnodeComputerAliasById.bind(this)
            this.GetPrintnodeComputerAliasTypeById = this.GetPrintnodeComputerAliasTypeById.bind(this)
            this.GetPrintnodeComputerAliasTypesByCode = this.GetPrintnodeComputerAliasTypesByCode.bind(this)
            this.GetPrintnodeComputerAliasesByAliasType = this.GetPrintnodeComputerAliasesByAliasType.bind(this)
            this.GetPrintnodeComputerAliasesByAliasValue = this.GetPrintnodeComputerAliasesByAliasValue.bind(this)
            this.GetPrintnodeComputerAliasesByOrganizationId = this.GetPrintnodeComputerAliasesByOrganizationId.bind(this)
            this.GetPrintnodeComputerAliasesByPrintnodeComputerId = this.GetPrintnodeComputerAliasesByPrintnodeComputerId.bind(this)
            this.GetPrintnodeCredentialsById = this.GetPrintnodeCredentialsById.bind(this)
            this.GetPrintnodeCredentialsByOrganizationId = this.GetPrintnodeCredentialsByOrganizationId.bind(this)
            this.GetPrintnodeCredentialsByPrintnodeAccountId = this.GetPrintnodeCredentialsByPrintnodeAccountId.bind(this)
            this.InsertAllItemsFromBusinessCentral = this.InsertAllItemsFromBusinessCentral.bind(this)
            this.InsertAllPinmetoLocationsPerOrganization = this.InsertAllPinmetoLocationsPerOrganization.bind(this)
            this.InsertPrintnodeComputerAlias = this.InsertPrintnodeComputerAlias.bind(this)
            this.InsertPrintnodeComputerAliasType = this.InsertPrintnodeComputerAliasType.bind(this)
            this.InsertPrintnodeCredentials = this.InsertPrintnodeCredentials.bind(this)
            this.OngoingArticleUpdateWebhook = this.OngoingArticleUpdateWebhook.bind(this)
            this.OngoingBookAndPrintWebhook = this.OngoingBookAndPrintWebhook.bind(this)
            this.OngoingBookingWebhook = this.OngoingBookingWebhook.bind(this)
            this.OngoingOrderStatusFeedback = this.OngoingOrderStatusFeedback.bind(this)
            this.OngoingPopulateParcelDimensions = this.OngoingPopulateParcelDimensions.bind(this)
            this.OngoingPrintLabelWebhook = this.OngoingPrintLabelWebhook.bind(this)
            this.OngoingRetryBooking = this.OngoingRetryBooking.bind(this)
            this.OngoingWebhookV2 = this.OngoingWebhookV2.bind(this)
            this.OngoingWebhookV3 = this.OngoingWebhookV3.bind(this)
            this.PrintLabel = this.PrintLabel.bind(this)
            this.PrintLabelsWithPrintNode = this.PrintLabelsWithPrintNode.bind(this)
            this.SendCustomerSlackMessage = this.SendCustomerSlackMessage.bind(this)
            this.SendSlackMessage = this.SendSlackMessage.bind(this)
            this.UpsertOngoingInfo = this.UpsertOngoingInfo.bind(this)
            this.UpsertPinmetoCredentials = this.UpsertPinmetoCredentials.bind(this)
            this.UpsertPrintnodeComputerAlias = this.UpsertPrintnodeComputerAlias.bind(this)
            this.UpsertPrintnodeComputerAliasType = this.UpsertPrintnodeComputerAliasType.bind(this)
            this.UpsertPrintnodeCredentials = this.UpsertPrintnodeCredentials.bind(this)
            this.Webhook = this.Webhook.bind(this)
        }

        /**
         * BrinkOrderCreatedWebhook is a webhook that is called when an order is created in Brink
         */
        public async BrinkOrderCreatedWebhook(params: models.BrinkOrderCreatedWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/brink/ordercreated`, JSON.stringify(params))
        }

        /**
         * BusinessCentralItemWebhookRaw is a raw webhook handler for Business Central item webhooks.
         * 
         * We need this because BC requires us to just return a validation token without any key in the response, which we cannot do through non-raw endpoints.
         * This is only needed the first time they call the endpoint, which happens when it's registered.
         * Read more on https://learn.microsoft.com/en-us/dynamics365/business-central/dev-itpro/api-reference/v2.0/dynamics-subscriptions
         */
        public async BusinessCentralItemWebhookRaw(method: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/integrations.BusinessCentralItemWebhookRaw`, body, options)
        }

        /**
         * CallGPT is a backend wrapper for calling ChatGPT
         * 
         * The reason it is auth is to be accessible from Scope, and while we could call it
         * directly from Scope that would mean exposing the API Key through NEXT_PUBLIC, which we don't want.
         * Therefore, we instead have this backend wrapper function to achieve it.
         */
        public async CallGPT(params: gpt.GPTRequest): Promise<gpt.GPTResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.CallGPT`, JSON.stringify(params))
            return await resp.json() as gpt.GPTResponse
        }

        /**
         * This works as a wrapper to create printnode account for a retailer
         * 
         * CreatePrintNodeAccountForOrganization creates a PrintNode account for an organization, similar to GetComputersForChildAccount in style.
         */
        public async CreatePrintNodeAccountForOrganization(params: CreatePrintnodeAccountParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.CreatePrintNodeAccountForOrganization`, JSON.stringify(params))
        }

        /**
         * DeletePinmetoCredentials is an Encore API endpoint that deletes the Pinmeto credentials
         * associated with the authenticated organization.
         * 
         * It initiates a new SQL transaction, calls the repository.DeleteCredentials function to
         * delete the credentials row from the database, and then attempts to commit the transaction.
         */
        public async DeletePinmetoCredentials(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.DeletePinmetoCredentials`)
        }

        /**
         * DeletePrintnodeComputerAlias carries out a soft delete for a specified row in the printnode_computer_alias table
         * 
         * It will also propagate an insertion to the printnode_computer_alias_audit table
         */
        public async DeletePrintnodeComputerAlias(params: DeletePrintnodeComputerAliasParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.DeletePrintnodeComputerAlias`, JSON.stringify(params))
        }

        /**
         * DeletePrintnodeComputerAliasType carries out a soft delete for a specified row in the printnode_computer_alias_type table
         * 
         * It will also propagate an insertion to the printnode_computer_alias_type_audit table
         */
        public async DeletePrintnodeComputerAliasType(params: DeletePrintnodeComputerAliasTypeParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.DeletePrintnodeComputerAliasType`, JSON.stringify(params))
        }

        /**
         * DeletePrintnodeCredentials carries out a soft delete for a specified row in the printnode_credentials table
         * 
         * It will also propagate an insertion to the printnode_credentials_audit table
         */
        public async DeletePrintnodeCredentials(params: DeletePrintnodeCredentialsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.DeletePrintnodeCredentials`, JSON.stringify(params))
        }

        public async FetchOngoingArticles(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.FetchOngoingArticles`)
        }

        /**
         * GetAllPrintnodeComputerAliasTypes retrieves all rows from the printnode_computer_alias_type
         */
        public async GetAllPrintnodeComputerAliasTypes(): Promise<GetAllPrintnodeComputerAliasTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetAllPrintnodeComputerAliasTypes`)
            return await resp.json() as GetAllPrintnodeComputerAliasTypesResponse
        }

        /**
         * GetAllPrintnodeComputerAliases retrieves all rows from the printnode_computer_alias
         */
        public async GetAllPrintnodeComputerAliases(): Promise<GetAllPrintnodeComputerAliasesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetAllPrintnodeComputerAliases`)
            return await resp.json() as GetAllPrintnodeComputerAliasesResponse
        }

        /**
         * GetAllPrintnodeCredentials retrieves all rows from the printnode_credentials
         */
        public async GetAllPrintnodeCredentials(): Promise<GetAllPrintnodeCredentialsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetAllPrintnodeCredentials`)
            return await resp.json() as GetAllPrintnodeCredentialsResponse
        }

        /**
         * GetComputersForOrganization fetches all computers for an organization
         */
        public async GetComputersForOrganization(): Promise<GetComputersForOrganizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetComputersForOrganization`)
            return await resp.json() as GetComputersForOrganizationResponse
        }

        /**
         * GetOngoingCredentials retrieves the stored Ongoing‐service credentials for
         * the current authenticated retailer, decrypts the password, and returns them.
         * 
         * Authentication: requires a active/valid bearer token
         * 
         * Errors:
         *   - errs.NotFound:    no credentials exist for this retailer.
         *   - errs.Internal:    failure in fetching or decrypting the credentials.
         */
        public async GetOngoingCredentials(): Promise<GetOngoingCredentialsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetOngoingCredentials`)
            return await resp.json() as GetOngoingCredentialsResponse
        }

        /**
         * GetPinmetoCredentialsByOrganization is an Encore API endpoint that fetches
         * and decrypts the Pinmeto credentials associated with the authenticated organization.
         * 
         * It calls the repository.GetCredentialsForOrganization function to fetch the credentials
         * from the database, then decrypts the AppSecret field using a predefined secret key.
         * In case of an error (e.g., failed to retrieve credentials from the database or failed
         * to decrypt the AppSecret), it logs the error and returns it.
         * 
         * The API is protected by authentication, and the retailerId (or organizationId) is extracted
         * from the authenticated user’s session data.
         * 
         * Returns:
         *   - A the Pinmeto credentials of the organization (authenticated user), or empty in case of
         *     an error that occurred during execution.
         */
        public async GetPinmetoCredentials(): Promise<GetCredentialsForOrganizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPinmetoCredentials`)
            return await resp.json() as GetCredentialsForOrganizationResponse
        }

        /**
         * GetPrintJobHistory sends a print job to a given printer for a retailer
         * 
         * Can be improved by allowing more granularity on the formats etc
         */
        public async GetPrintJobHistory(params: GetPrintJobHistoryParams): Promise<GetPrintJobHistoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintJobHistory`, JSON.stringify(params))
            return await resp.json() as GetPrintJobHistoryResponse
        }

        /**
         * GetPrintersForOrganization fetches all printers for an organization
         */
        public async GetPrintersForOrganization(): Promise<GetPrintersForOrganizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintersForOrganization`)
            return await resp.json() as GetPrintersForOrganizationResponse
        }

        /**
         * GetPrintnodeComputerAliasById retrieves all rows from the printnode_computer_alias table that match the provided identifier
         */
        public async GetPrintnodeComputerAliasById(params: GetPrintnodeComputerAliasByIdParams): Promise<GetPrintnodeComputerAliasByIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintnodeComputerAliasById`, JSON.stringify(params))
            return await resp.json() as GetPrintnodeComputerAliasByIdResponse
        }

        /**
         * GetPrintnodeComputerAliasTypeById retrieves all rows from the printnode_computer_alias_type table that match the provided identifier
         */
        public async GetPrintnodeComputerAliasTypeById(params: GetPrintnodeComputerAliasTypeByIdParams): Promise<GetPrintnodeComputerAliasTypeByIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintnodeComputerAliasTypeById`, JSON.stringify(params))
            return await resp.json() as GetPrintnodeComputerAliasTypeByIdResponse
        }

        /**
         * GetPrintnodeComputerAliasTypesByCode retrieves all rows from the printnode_computer_alias_type table that match the provided Code
         */
        public async GetPrintnodeComputerAliasTypesByCode(params: GetPrintnodeComputerAliasTypesByCodeParams): Promise<GetPrintnodeComputerAliasTypesByCodeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintnodeComputerAliasTypesByCode`, JSON.stringify(params))
            return await resp.json() as GetPrintnodeComputerAliasTypesByCodeResponse
        }

        /**
         * GetPrintnodeComputerAliasesByAliasType retrieves all rows from the printnode_computer_alias table that match the provided AliasType
         */
        public async GetPrintnodeComputerAliasesByAliasType(params: GetPrintnodeComputerAliasesByAliasTypeParams): Promise<GetPrintnodeComputerAliasesByAliasTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintnodeComputerAliasesByAliasType`, JSON.stringify(params))
            return await resp.json() as GetPrintnodeComputerAliasesByAliasTypeResponse
        }

        /**
         * GetPrintnodeComputerAliasesByAliasValue retrieves all rows from the printnode_computer_alias table that match the provided AliasValue
         */
        public async GetPrintnodeComputerAliasesByAliasValue(params: GetPrintnodeComputerAliasesByAliasValueParams): Promise<GetPrintnodeComputerAliasesByAliasValueResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintnodeComputerAliasesByAliasValue`, JSON.stringify(params))
            return await resp.json() as GetPrintnodeComputerAliasesByAliasValueResponse
        }

        /**
         * GetPrintnodeComputerAliasesByOrganizationId retrieves all rows from the printnode_computer_alias table that match the provided OrganizationId
         */
        public async GetPrintnodeComputerAliasesByOrganizationId(params: GetPrintnodeComputerAliasesByOrganizationIdParams): Promise<GetPrintnodeComputerAliasesByOrganizationIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintnodeComputerAliasesByOrganizationId`, JSON.stringify(params))
            return await resp.json() as GetPrintnodeComputerAliasesByOrganizationIdResponse
        }

        /**
         * GetPrintnodeComputerAliasesByPrintnodeComputerId retrieves all rows from the printnode_computer_alias table that match the provided PrintnodeComputerId
         */
        public async GetPrintnodeComputerAliasesByPrintnodeComputerId(params: GetPrintnodeComputerAliasesByPrintnodeComputerIdParams): Promise<GetPrintnodeComputerAliasesByPrintnodeComputerIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintnodeComputerAliasesByPrintnodeComputerId`, JSON.stringify(params))
            return await resp.json() as GetPrintnodeComputerAliasesByPrintnodeComputerIdResponse
        }

        /**
         * GetPrintnodeCredentialsById retrieves all rows from the printnode_credentials table that match the provided identifier
         */
        public async GetPrintnodeCredentialsById(params: GetPrintnodeCredentialsByIdParams): Promise<GetPrintnodeCredentialsByIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintnodeCredentialsById`, JSON.stringify(params))
            return await resp.json() as GetPrintnodeCredentialsByIdResponse
        }

        /**
         * GetPrintnodeCredentialsByOrganizationId retrieves all rows from the printnode_credentials table that match the provided OrganizationId
         */
        public async GetPrintnodeCredentialsByOrganizationId(params: GetPrintnodeCredentialsByOrganizationIdParams): Promise<GetPrintnodeCredentialsByOrganizationIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintnodeCredentialsByOrganizationId`, JSON.stringify(params))
            return await resp.json() as GetPrintnodeCredentialsByOrganizationIdResponse
        }

        /**
         * GetPrintnodeCredentialsByPrintnodeAccountId retrieves all rows from the printnode_credentials table that match the provided PrintnodeAccountId
         */
        public async GetPrintnodeCredentialsByPrintnodeAccountId(params: GetPrintnodeCredentialsByPrintnodeAccountIdParams): Promise<GetPrintnodeCredentialsByPrintnodeAccountIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.GetPrintnodeCredentialsByPrintnodeAccountId`, JSON.stringify(params))
            return await resp.json() as GetPrintnodeCredentialsByPrintnodeAccountIdResponse
        }

        /**
         * InsertAllItemsFromBusinessCentral fetches all items from Business Central and inserts them into the database.
         * 
         * It currently does not handle dimensions or weights in any great way, because this information is not part of the standard Business Central API.
         */
        public async InsertAllItemsFromBusinessCentral(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.InsertAllItemsFromBusinessCentral`)
        }

        /**
         * InsertAllPinmetoLocationsPerOrganization is an Encore API endpoint that fetches all
         * location data for the authenticated organization from the PinMeTo service and inserts
         * (or updates) this data into the local database.
         * 
         * The function performs the following steps:
         *  1. It fetches the Pinmeto API credentials for the authenticated user's organization.
         *  2. It uses these credentials to obtain an access token from the PinMeTo API.
         *  3. It fetches all location data for the authenticated organization from the PinMeTo API.
         *     If the organization has more than 250 locations, it fetches all of them, spanning
         *     multiple API requests if necessary.
         *  4. It transforms the data from the format used by the PinMeTo API into the models used
         *     by SkrymR. For example, it maps days of the week from strings ("mon", "tue", etc.)
         *     to time.Weekday values.
         *  5. For each fetched location, it inserts (or updates) a corresponding record into
         *     the local database. This is the location, organization location, as well as the
         *     location’s regular opening hours and special opening hours.
         */
        public async InsertAllPinmetoLocationsPerOrganization(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.InsertAllPinmetoLocationsPerOrganization`)
        }

        public async InsertPrintnodeComputerAlias(params: InsertPrintnodeComputerAliasParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.InsertPrintnodeComputerAlias`, JSON.stringify(params))
        }

        public async InsertPrintnodeComputerAliasType(params: InsertPrintnodeComputerAliasTypeParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.InsertPrintnodeComputerAliasType`, JSON.stringify(params))
        }

        public async InsertPrintnodeCredentials(params: InsertPrintnodeCredentialsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.InsertPrintnodeCredentials`, JSON.stringify(params))
        }

        /**
         * OngoingArticleUpdateWebhook
         * 
         * POST API endpoint that processes webhook updates to articles from Ongoing.
         * Fetches the updated product from ongoing and adds the new dimensions & weight to our system.
         * It does not support updating dimensions of irregularly shaped products, so products that are
         * handled by Skrym as irregularly shaped cannot have their dimensions updated through Ongoing.
         * For this, it is better to use Scope or the UpdateProduct API endpooint.
         */
        public async OngoingArticleUpdateWebhook(params: OngoingArticleUpdatedWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.OngoingArticleUpdateWebhook`, JSON.stringify(params))
        }

        /**
         * Ongoing Webhook for Booking an order and Printing its labels.
         */
        public async OngoingBookAndPrintWebhook(params: OngoingBookingWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.OngoingBookAndPrintWebhook`, JSON.stringify(params))
        }

        /**
         * Ongoing Webhook for Booking a order.
         */
        public async OngoingBookingWebhook(params: OngoingBookingWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.OngoingBookingWebhook`, JSON.stringify(params))
        }

        /**
         * OngoingOrderStatusFeedback is used with the Ongoing order status webhook, and creates a combined feedback event for the order
         */
        public async OngoingOrderStatusFeedback(params: models.OngoingWebhook): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.OngoingOrderStatusFeedback`, JSON.stringify(params))
        }

        /**
         * OngoingPopulateParcelDimensions handles the population of parcel dimensions for a order in Ongoing.
         * 
         * This endpoint requires authentication and retrieves the order details from Ongoing WMS
         * using the provided webhook data. If the basket for the order already exists, it uses the stored
         * dimensions. If not, it calculates the dimensions by optimizing the order, then updates the
         * Ongoing system with the parcel data.
         * 
         * Possible errors:
         * - Error fetching URL credentials for the retailer.
         * - Error fetching the order from the Ongoing WMS.
         * - Error retrieving or optimizing the basket for the order.
         * - Error updating Ongoing WMS with the parcel data.
         */
        public async OngoingPopulateParcelDimensions(params: models.OngoingWebhook): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.OngoingPopulateParcelDimensions`, JSON.stringify(params))
        }

        /**
         * Ongoing Webhook for Printing the labels of a booked order.
         */
        public async OngoingPrintLabelWebhook(params: OngoingBookingWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.OngoingPrintLabelWebhook`, JSON.stringify(params))
        }

        /**
         * OngoingRetryBooking handles the retry of a booking in Ongoing.
         */
        public async OngoingRetryBooking(params: OngoingBookingWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.OngoingRetryBooking`, JSON.stringify(params))
        }

        public async OngoingWebhookV2(method: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/integrations.OngoingWebhookV2`, body, options)
        }

        public async OngoingWebhookV3(params: models.OngoingWebhook): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/webhook.OngoingWebhookV2`, JSON.stringify(params))
        }

        /**
         * PrintLabel sends a print job to a given printer for a retailer
         * 
         * Can be improved by allowing more granularity on the formats etc
         */
        public async PrintLabel(params: PrintLabelParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.PrintLabel`, JSON.stringify(params))
        }

        /**
         * PrintLabelsWithPrintNodeParams is an authenticated REST API endpoint for printing labels from several bookings
         * on several printerIds.
         */
        public async PrintLabelsWithPrintNode(params: PrintLabelsWithPrintNodeParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.PrintLabelsWithPrintNode`, JSON.stringify(params))
        }

        public async SendCustomerSlackMessage(params: CustomerSlackMessageParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.SendCustomerSlackMessage`, JSON.stringify(params))
        }

        public async SendSlackMessage(params: SendSlackMessageParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.SendSlackMessage`, JSON.stringify(params))
        }

        public async UpsertOngoingInfo(params: UpsertOngoingInfoParams): Promise<UpsertOngoingInfoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/integrations.UpsertOngoingInfo`, JSON.stringify(params))
            return await resp.json() as UpsertOngoingInfoResponse
        }

        /**
         * UpsertPinmetoCredentials is an API endpoint that securely upserts (inserts or updates)
         * Pinmeto API credentials for a specific organization.
         * 
         * The credentials are associated with the current authenticated retailer,
         * as obtained from the authentication data in the context.
         * 
         * The AppSecret part of the credentials is encrypted before being stored in the database.
         * 
         * This function starts a new database transaction, attempts to upsert the credentials,
         * and then either commits the transaction if everything was successful, or rolls it back if an error was encountered.
         * 
         * The upsert operation in the repository ensures that existing credentials for the retailer are updated if they already exist;
         * otherwise, new credentials are inserted.
         * 
         * Returns:
         *   - error: An error if the operation was unsuccessful, nil otherwise.
         */
        public async UpsertPinmetoCredentials(params: UpsertPinmetoCredentialsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.UpsertPinmetoCredentials`, JSON.stringify(params))
        }

        /**
         * UpsertPrintnodeComputerAlias adds or updates a row in the printnode_computer_alias table
         * 
         * If the row already exists, it will be updated; otherwise, a new row will be inserted.
         * If no id is passed in, one will be autogenerated
         */
        public async UpsertPrintnodeComputerAlias(params: UpsertPrintnodeComputerAliasParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.UpsertPrintnodeComputerAlias`, JSON.stringify(params))
        }

        public async UpsertPrintnodeComputerAliasType(params: UpsertPrintnodeComputerAliasTypeParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.UpsertPrintnodeComputerAliasType`, JSON.stringify(params))
        }

        public async UpsertPrintnodeCredentials(params: UpsertPrintnodeCredentialsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/integrations.UpsertPrintnodeCredentials`, JSON.stringify(params))
        }

        public async Webhook(method: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/encore/webhook`, body, options)
        }
    }
}

export namespace invoicecontrol {
    export interface AnalyzeInvoiceRowParams {
        invoiceRowIds: string[]
        invoiceId: string
    }

    export interface DeleteColumnDefaultValueParams {
        defaultValueID: string
    }

    export interface DeleteColumnMappingParams {
        columnMappingID: string
    }

    export interface DeleteInvoiceMappingParams {
        invoiceMappingID: string
    }

    export interface DeleteInvoiceRowsParams {
        invoiceRowIds: string[]
    }

    export interface DeleteInvoicesParams {
        invoiceIDs: string[]
    }

    export interface DownloadInvoiceRowDataParams {
        /**
         * Default to include all, but allow selection of specific invoices in dialog
         */
        invoices: string[]

        transporters: string[]
        fromDate: string
        toDate: string
        /**
         * Default to include current one, but allow selection of other org users in dialog, so all get the email
         */
        recipientEmails: string[]

        /**
         * Default to include all columns, but allow selection of specific columns in dialog
         */
        excludeColumns: string[]
    }

    export interface GetAllColumnNamesResponse {
        columnNames: models.InvoiceColumn[]
    }

    export interface GetAllInvoiceMappingsResponse {
        mappings: models.InvoiceMapping[]
    }

    export interface GetAllResolversResponse {
        resolvers: models.MultiColumnResolution[]
    }

    export interface GetAverageInvoicedPackageCostPerMonthParams {
        /**
         * Defaults to the organization's currency
         */
        currency?: datamodels.Currency

        fromDate?: string
        toDate?: string
        /**
         * Only include these transporters. Exclude or send `null` to disable filter.
         */
        transporters?: string[]

        /**
         * Only include these methods. Exclude or send `null` to disable filter.
         */
        transportMethods?: string[]

        /**
         * Only include these countries. Exclude or send `null` to disable filter.
         */
        countries?: string[]
    }

    export interface GetAverageInvoicedPackageCostPerMonthResponse {
        months: models.InvoiceMonthInfo[]
    }

    export interface GetInboundEmailForOrganizationResponse {
        inboundEmail: models.InboundEmail
    }

    export interface GetInvoiceAndExpectedPaginationParams {
        filters: models.InvoiceRowControlFilter
        sort: models.InvoiceRowControlSort[]
        pageSize: number
        page: number
    }

    export interface GetInvoiceAndExpectedPaginationResponse {
        invoiceRows: models.InvoiceRowWithExpected[]
        rowCount: number
    }

    export interface GetInvoiceColumnMappingByIDParams {
        id: string
    }

    export interface GetInvoiceColumnMappingByIDResponse {
        columnMapping: models.InvoiceColumnMapping
    }

    export interface GetInvoiceFieldNamesByColumnParams {
        columnName: models.InvoiceColumn
    }

    export interface GetInvoiceFieldNamesByColumnResponse {
        fieldNames: string[]
    }

    export interface GetInvoiceFileURLParams {
        /**
         * Invoice ID
         */
        invoiceId: string
    }

    export interface GetInvoiceFileURLResponse {
        /**
         * URL for downloading the invoice file
         */
        downloadURL: string
    }

    export interface GetInvoiceMappingWithColumnsByIDParams {
        mappingID: string
    }

    export interface GetInvoiceMappingWithColumnsByIDResponse {
        mapping: models.InvoiceMapping
        columnMappings: models.InvoiceColumnMapping[]
        defaultValues: models.ColumnDefaultValue[]
    }

    export interface GetInvoiceRowExpectedDetailsRequest {
        invoiceRowID: string
    }

    export interface GetInvoiceRowExpectedDetailsResponse {
        expectedCostDetails: models.InvoiceRowExpectedDetail[]
    }

    export interface GetInvoiceRowFeeMoreInfoRequest {
        invoiceRowID: string
    }

    export interface GetInvoiceRowFeeMoreInfoResponse {
        invoiceRowFees: models.InvoiceRowFeeMoreInfo[]
    }

    export interface GetInvoiceRowFeesRequest {
        invoiceRowID: string
    }

    export interface GetInvoiceRowFeesResponse {
        invoiceRowFees: models.InvoiceRowFee[]
    }

    /**
     * GetInvoiceRowFieldSourcesParams contains the filter criteria for fetching invoice row field sources.
     */
    export interface GetInvoiceRowFieldSourcesParams {
        /**
         * Filters to apply when retrieving invoice row field sources.
         */
        filters: models.InvoiceRowFieldSourceFilters
    }

    /**
     * GetInvoiceRowFieldSourcesResponse represents the response structure for invoice row field source data.
     */
    export interface GetInvoiceRowFieldSourcesResponse {
        /**
         * List of invoice row field sources matching the filter criteria.
         */
        sources: models.InvoiceRowFieldSource[]
    }

    /**
     * GetInvoiceRowObservationsParams contains the filter criteria for fetching invoice row observations.
     */
    export interface GetInvoiceRowObservationsParams {
        /**
         * Filters to apply when retrieving invoice row observations.
         */
        filters: models.InvoiceRowObservationFilters
    }

    /**
     * GetInvoiceRowObservationsResponse represents the response structure for invoice row observation data.
     */
    export interface GetInvoiceRowObservationsResponse {
        /**
         * List of invoice row observations matching the filter criteria.
         */
        observations: models.InvoiceRowObservation[]
    }

    export interface GetInvoiceRowParams {
        rowId: string
    }

    export interface GetInvoiceRowResponse {
        invoiceRows: models.InvoiceRowWithExpected
    }

    export interface GetInvoiceRowWithDetailsResponse {
        invoiceRow: models.InvoiceRowWithExpected
        invoiceFeeDetails: models.InvoiceRowFeeMoreInfo[]
        expectedCostDetails: models.InvoiceRowExpectedDetail[]
    }

    export interface GetInvoiceStatsByCountryParams {
        /**
         * Which currency to convert the output to. Defaults to the organization's currency
         */
        currency?: datamodels.Currency

        fromDate?: string
        toDate?: string
        /**
         * Only include these transporters. Exclude or send `null` to disable filter.
         */
        transporters?: string[]

        /**
         * Only include these methods. Exclude or send `null` to disable filter.
         */
        transportMethods?: string[]

        /**
         * Only include these countries. Exclude or send `null` to disable filter.
         */
        countries?: string[]
    }

    export interface GetInvoiceStatsByCountryResponse {
        /**
         * List of invoice statistics per country
         */
        countries: models.CountryInvoiceStats[]
    }

    export interface GetInvoiceStatsPerFeeTypeParams {
        currency: datamodels.Currency
        /**
         * Optional invoice ID to filter by, if not provided, all invoices are considered
         */
        invoiceId: string

        fromDate?: string
        toDate?: string
        /**
         * Only include these countries. Exclude or send `null` to disable filter.
         */
        countries?: string[]

        /**
         * Only include these transporters. Exclude or send `null` to disable filter.
         */
        transporters?: string[]

        /**
         * Only include these methods. Exclude or send `null` to disable filter.
         */
        transportMethods?: string[]

        /**
         * Optional fee types to filter by. Exclude or send `null` to disable filter.
         */
        feeTypes?: models.FeeType[]
    }

    export interface GetInvoiceStatsPerFeeTypePerMonthParams {
        currency: datamodels.Currency
        fromDate?: string
        toDate?: string
        /**
         * Optional fee types to filter by. Exclude or send `null` to disable filter.
         */
        feeTypes?: models.FeeType[]

        /**
         * Only include these transporters. Exclude or send `null` to disable filter.
         */
        transporters?: string[]

        /**
         * Only include these methods. Exclude or send `null` to disable filter.
         */
        transportMethods?: string[]

        /**
         * Only include these countries. Exclude or send `null` to disable filter.
         */
        countries?: string[]
    }

    export interface GetInvoiceStatsPerFeeTypePerMonthResponse {
        months: models.InvoiceFeeMonthStats[]
    }

    export interface GetInvoiceStatsPerFeeTypeResponse {
        feeStats: models.InvoiceFeeStats[]
    }

    export interface GetInvoiceStatsPerMethodParams {
        /**
         * Optional invoice ID to filter by, if not provided, all invoices are considered
         */
        invoiceId: string

        currency: datamodels.Currency
        fromDate?: string
        toDate?: string
        /**
         * Only include these transporters. Exclude or send `null` to disable filter.
         */
        transporters?: string[]

        /**
         * Only include these methods. Exclude or send `null` to disable filter.
         */
        transportMethods?: string[]

        /**
         * Only include these countries. Exclude or send `null` to disable filter.
         */
        countries?: string[]
    }

    export interface GetInvoiceStatsPerMethodResponse {
        transportMethods: models.TransportMethodSummary[]
    }

    export interface GetInvoicesPerDayParams {
        from: string
        to: string
    }

    export interface GetInvoicesPerDayResponse {
        invoicesPerDay: repository.InvoicesPerDay[]
    }

    export interface GetInvoicesWithBreakDownParams {
        /**
         * What currency to convert the amounts to. If empty, the organization's default currency is used.
         */
        currency?: datamodels.Currency

        filter: models.InvoicesFilter
        sort: models.InvoicesSort[]
        pageSize?: number
        page?: number
    }

    export interface GetInvoicesWithBreakdownResponse {
        invoices: models.InvoiceWithBreakdown[]
    }

    export interface GetInvoicesWithSummaryStatsParams {
        currency?: datamodels.Currency
        uploadedInvoiceFilter: models.InvoicesFilter
        invoiceRowFilter?: models.InvoiceRowControlFilter
        sort: models.InvoicesSort[]
        pageSize?: number
        page?: number
    }

    export interface GetInvoicesWithSummaryStatsResponse {
        invoices: models.InvoiceWithSummaryStats[]
        rowCount: number
    }

    /**
     * GetPresignedURLParams specifies the file
     * to be uploaded to GCP bucket.
     */
    export interface GetPresignedURLParams {
        /**
         * File ID
         */
        fileId: string

        /**
         * Original file name
         */
        fileName: string

        contentType: string
    }

    /**
     * GetPresignedURLResponse is the response
     * from GetPresignedURL containing the stored
     * name and the actual url.
     */
    export interface GetPresignedURLResponse {
        /**
         * Name of the file to store in the bucket
         */
        storedName: string

        /**
         * Presigned URL to upload the file to
         */
        presignedURL: string
    }

    export interface GetUniqueFeesAndLabelsParams {
        /**
         * Optional list of invoice IDs to filter by
         */
        invoiceIDs?: string[]
    }

    export interface GetUniqueFeesAndLabelsResponse {
        /**
         * List of unique fees and labels
         */
        fees: models.InvoiceFeeTypeWithLabels[]
    }

    /**
     * GetUploadedInvoicesResponse contains the
     * references the invoice files that exist
     * in the GCP bucket.
     */
    export interface GetUploadedInvoicesResponse {
        invoices: models.UploadedInvoice[]
    }

    export interface InsertInvoiceRowExpectedDetailsBatchRequest {
        expectedDetails: models.InvoiceRowExpectedDetail[]
    }

    /**
     * RerunInvoiceParams contains the ID of the invoice to reprocess
     */
    export interface RerunInvoicesParams {
        /**
         * The ID of the invoice to reprocess
         */
        invoices: string[]
    }

    /**
     * SaveReferenceParams contains all the necessary
     * information about the uploaded file.
     */
    export interface SaveReferenceParams {
        /**
         * File ID
         */
        fileId: string

        /**
         * Original file name
         */
        originalName: string

        /**
         * Optional name for display purposes
         */
        displayName: string

        /**
         * Optional description
         */
        description: string

        contentType: string
        /**
         * Name of the file to store in the bucket
         */
        storedName: string

        /**
         * File size in bytes
         */
        fileSize: number

        /**
         * Sheet number to use in the excel file, 0 means all sheets
         */
        sheetNumber?: number

        /**
         * invoice mapping id
         */
        invoiceMappingID?: string
    }

    export interface TestInvoiceMappingParams {
        invoiceMappingID: string
        header: string[]
        row: string[]
    }

    export interface TestInvoiceMappingResponse {
        ParsedRow: models.InvoiceRow
        Fees: models.InvoiceRowFee[]
    }

    export interface UpdateDisplayNameForUploadedInvoiceParams {
        /**
         * Invoice ID
         */
        invoiceId: string

        /**
         * New display name
         */
        displayName: string
    }

    /**
     * UpdateProcessingStatusForInvoicesParams contains the IDs of the invoices to update and the new status
     */
    export interface UpdateProcessingStatusForInvoicesParams {
        invoiceIds: string[]
        status: models.InvoiceProcessingStatus
        /**
         * optional message to provide more context about the status change
         */
        message?: string
    }

    export interface UpdateStatusForInvoiceRowsParams {
        invoiceRowIds: string[]
        status: models.InvoiceRowStatus
    }

    export interface UpsertColumnDefaultValueParams {
        /**
         * If left empty, a new entry is created
         */
        id?: string

        /**
         * ID referencing the invoice mapping it belongs to
         */
        invoiceMappingId: string

        /**
         * The default value for the field
         */
        defaultValue: string

        /**
         * Skrym standardized name for the field
         */
        fieldName: models.InvoiceColumn

        /**
         * Unit for certain values, necessary for conversions
         */
        invoiceFieldUnit?: utils.MeasurementUnit

        /**
         * Optional value for the cost type of the column. Only used for cost columns
         */
        costType?: models.FeeType

        /**
         * Optional value for the cell delimiter of the column. Only used for columns with multiple values. Default is comma
         */
        cellDelimiter?: string
    }

    export interface UpsertInboundEmailParams {
        email: string
    }

    export interface UpsertInvoiceColumnMappingParams {
        /**
         * If left nil or if not corresponding to existing entry, the function creates a new row
         */
        id?: string

        /**
         * ID of the mapping it belongs to
         */
        invoiceMappingId: string

        /**
         * Mapping destination (Skrym column name)
         */
        fieldName: models.InvoiceColumn

        /**
         * Mapping origin (name in file)
         */
        invoiceFieldName: string

        /**
         * Optional unit for numeric columns (e.g. kg and g for weights)
         */
        invoiceFieldUnit?: utils.MeasurementUnit

        /**
         * Indication of what to use for resolving multi-column parsings
         */
        resolver?: models.MultiColumnResolution

        /**
         * Is needed if more than one column mapping has the same destination value and the resolution method is ranked
         */
        resolverPriority?: number

        /**
         * If the column is used for grouping multi-row invoices
         */
        groupingColumn: boolean

        /**
         * Optional value for the fee type of the column. Only used for fee columns
         */
        feeType?: models.FeeType

        /**
         * If the column should be filled with the value form previous row if it's empty
         */
        fillEmptyFromPrevious: boolean

        /**
         * Optional value for the cell delimiter of the column. Only used for columns with multiple values. Default is comma
         */
        cellDelimiter?: string
    }

    export interface UpsertInvoiceMappingParams {
        /**
         * If left empty, a new entry is created
         */
        id?: string

        /**
         * Name for the invoice mapping
         */
        name: string

        /**
         * Description for the invoice mapping, e.g. 'Used for PostNord invoices'
         */
        description: string
    }

    export interface UpsertInvoiceRowExpectedDetailParams {
        id?: string
        invoiceRowID: string
        costID: string
        costGroupID: string
        amount: number
        costType: string
    }

    export interface UpsertInvoiceRowFeeParams {
        id?: string
        invoiceRowID: string
        costID: string
        amount: number
    }

    /**
     * UpsertInvoiceRowFieldSourceOverridesParams contains the parameters for upserting invoice row field sources.
     */
    export interface UpsertInvoiceRowFieldSourceOverridesParams {
        /**
         * List of invoice row field sources to upsert.
         */
        invoiceRowFieldSourceOverrides: models.InvoiceRowFieldSourceOverrides[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AnalyzeInvoiceRows = this.AnalyzeInvoiceRows.bind(this)
            this.DeleteColumnDefaultValue = this.DeleteColumnDefaultValue.bind(this)
            this.DeleteColumnMapping = this.DeleteColumnMapping.bind(this)
            this.DeleteInvoiceMapping = this.DeleteInvoiceMapping.bind(this)
            this.DeleteInvoiceRows = this.DeleteInvoiceRows.bind(this)
            this.DeleteInvoices = this.DeleteInvoices.bind(this)
            this.DownloadInvoiceRowData = this.DownloadInvoiceRowData.bind(this)
            this.GetAllColumnNames = this.GetAllColumnNames.bind(this)
            this.GetAllInvoiceMappings = this.GetAllInvoiceMappings.bind(this)
            this.GetAllResolvers = this.GetAllResolvers.bind(this)
            this.GetAverageInvoicedPackageCostPerMonth = this.GetAverageInvoicedPackageCostPerMonth.bind(this)
            this.GetInboundEmailForOrganization = this.GetInboundEmailForOrganization.bind(this)
            this.GetInvoiceAndExpectedPagination = this.GetInvoiceAndExpectedPagination.bind(this)
            this.GetInvoiceColumnMappingByID = this.GetInvoiceColumnMappingByID.bind(this)
            this.GetInvoiceFieldNamesByColumn = this.GetInvoiceFieldNamesByColumn.bind(this)
            this.GetInvoiceFileURL = this.GetInvoiceFileURL.bind(this)
            this.GetInvoiceMappingWithColumnsByID = this.GetInvoiceMappingWithColumnsByID.bind(this)
            this.GetInvoiceRow = this.GetInvoiceRow.bind(this)
            this.GetInvoiceRowExpectedDetails = this.GetInvoiceRowExpectedDetails.bind(this)
            this.GetInvoiceRowFeeMoreInfo = this.GetInvoiceRowFeeMoreInfo.bind(this)
            this.GetInvoiceRowFees = this.GetInvoiceRowFees.bind(this)
            this.GetInvoiceRowFieldSources = this.GetInvoiceRowFieldSources.bind(this)
            this.GetInvoiceRowObservations = this.GetInvoiceRowObservations.bind(this)
            this.GetInvoiceRowWithAddedCostDetails = this.GetInvoiceRowWithAddedCostDetails.bind(this)
            this.GetInvoiceStatsByCountry = this.GetInvoiceStatsByCountry.bind(this)
            this.GetInvoiceStatsPerFeeType = this.GetInvoiceStatsPerFeeType.bind(this)
            this.GetInvoiceStatsPerFeeTypePerMonth = this.GetInvoiceStatsPerFeeTypePerMonth.bind(this)
            this.GetInvoiceStatsPerMethod = this.GetInvoiceStatsPerMethod.bind(this)
            this.GetInvoicesPerDay = this.GetInvoicesPerDay.bind(this)
            this.GetInvoicesWithBreakdown = this.GetInvoicesWithBreakdown.bind(this)
            this.GetInvoicesWithSummaryStats = this.GetInvoicesWithSummaryStats.bind(this)
            this.GetPresignedURL = this.GetPresignedURL.bind(this)
            this.GetUniqueFeesAndLabels = this.GetUniqueFeesAndLabels.bind(this)
            this.GetUploadedInvoices = this.GetUploadedInvoices.bind(this)
            this.IncomingEmailWebhook = this.IncomingEmailWebhook.bind(this)
            this.InsertInvoiceRowExpectedDetailsBatch = this.InsertInvoiceRowExpectedDetailsBatch.bind(this)
            this.RerunInvoices = this.RerunInvoices.bind(this)
            this.SaveReference = this.SaveReference.bind(this)
            this.TestInvoiceMapping = this.TestInvoiceMapping.bind(this)
            this.UpdateDisplayNameForUploadedInvoice = this.UpdateDisplayNameForUploadedInvoice.bind(this)
            this.UpdateProcessingStatusForInvoices = this.UpdateProcessingStatusForInvoices.bind(this)
            this.UpdateStatusForInvoiceRows = this.UpdateStatusForInvoiceRows.bind(this)
            this.UpsertColumnDefaultValue = this.UpsertColumnDefaultValue.bind(this)
            this.UpsertInboundEmail = this.UpsertInboundEmail.bind(this)
            this.UpsertInvoiceColumnMapping = this.UpsertInvoiceColumnMapping.bind(this)
            this.UpsertInvoiceMapping = this.UpsertInvoiceMapping.bind(this)
            this.UpsertInvoiceRowExpectedDetail = this.UpsertInvoiceRowExpectedDetail.bind(this)
            this.UpsertInvoiceRowFee = this.UpsertInvoiceRowFee.bind(this)
            this.UpsertInvoiceRowFieldSourceOverrides = this.UpsertInvoiceRowFieldSourceOverrides.bind(this)
        }

        public async AnalyzeInvoiceRows(params: AnalyzeInvoiceRowParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.AnalyzeInvoiceRows`, JSON.stringify(params))
        }

        /**
         * DeleteColumnDefaultValue deletes the default value for a column that matches the provided ID.
         */
        public async DeleteColumnDefaultValue(params: DeleteColumnDefaultValueParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.DeleteColumnDefaultValue`, JSON.stringify(params))
        }

        /**
         * DeleteColumnMapping deletes the single map between an invoice column name and Skrym column name
         * that matches the provided ID of the map.
         */
        public async DeleteColumnMapping(params: DeleteColumnMappingParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.DeleteColumnMapping`, JSON.stringify(params))
        }

        /**
         * DeleteInvoiceMapping deletes the invoice mapping based on the provided ID.
         * 
         * It also deletes all the column maps that reference the provided invoice mapping ID.
         */
        public async DeleteInvoiceMapping(params: DeleteInvoiceMappingParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.DeleteInvoiceMapping`, JSON.stringify(params))
        }

        public async DeleteInvoiceRows(params: DeleteInvoiceRowsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.DeleteInvoiceRows`, JSON.stringify(params))
        }

        /**
         * DeleteInvoices deletes an invoice and all associated rows with it
         */
        public async DeleteInvoices(params: DeleteInvoicesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.DeleteInvoices`, JSON.stringify(params))
        }

        /**
         * Uploads a CSV file of all invoice rows to google cloud bucket and sends a download link to user who triggered it
         * 
         * This endpoint may be improved by adding an optimistic return and creating a Pub Sub event to handle the operations.
         * Currently, the fetching of the data means that the user has to wait for confirmation for a while when exporting larget datasets.
         */
        public async DownloadInvoiceRowData(params: DownloadInvoiceRowDataParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.DownloadInvoiceRowData`, JSON.stringify(params))
        }

        /**
         * GetAllColumnNames returns all the column names that Skrym supports in its standardised InvoiceRow structure.
         */
        public async GetAllColumnNames(): Promise<GetAllColumnNamesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetAllColumnNames`)
            return await resp.json() as GetAllColumnNamesResponse
        }

        /**
         * GetAllInvoiceMappings returns all the invoice mappings for the authenticated caller.
         */
        public async GetAllInvoiceMappings(): Promise<GetAllInvoiceMappingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetAllInvoiceMappings`)
            return await resp.json() as GetAllInvoiceMappingsResponse
        }

        /**
         * GetAllResolvers returns all the column names that Skrym supports in its standardised InvoiceRow structure.
         */
        public async GetAllResolvers(): Promise<GetAllResolversResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetAllResolvers`)
            return await resp.json() as GetAllResolversResponse
        }

        /**
         * GetAverageInvoicedPackageCostPerMonth returns the average cost per package for the calendar months
         * 
         * It accepts optional filters on transporter, transport method, destination country and date range
         */
        public async GetAverageInvoicedPackageCostPerMonth(params: GetAverageInvoicedPackageCostPerMonthParams): Promise<GetAverageInvoicedPackageCostPerMonthResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetAverageInvoicedPackageCostPerMonth`, JSON.stringify(params))
            return await resp.json() as GetAverageInvoicedPackageCostPerMonthResponse
        }

        public async GetInboundEmailForOrganization(): Promise<GetInboundEmailForOrganizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInboundEmailForOrganization`)
            return await resp.json() as GetInboundEmailForOrganizationResponse
        }

        /**
         * GetInvoiceAndExpectedPagination returns the parsed InvoiceRows and expected costs for the given
         * retailer/organization ID per specified page, capped by the specified page size.
         */
        public async GetInvoiceAndExpectedPagination(params: GetInvoiceAndExpectedPaginationParams): Promise<GetInvoiceAndExpectedPaginationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceAndExpectedPagination`, JSON.stringify(params))
            return await resp.json() as GetInvoiceAndExpectedPaginationResponse
        }

        /**
         * GetInvoiceColumnMappingByID retrieves a specific invoice column mapping by its ID.
         */
        public async GetInvoiceColumnMappingByID(params: GetInvoiceColumnMappingByIDParams): Promise<GetInvoiceColumnMappingByIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceColumnMappingByID`, JSON.stringify(params))
            return await resp.json() as GetInvoiceColumnMappingByIDResponse
        }

        /**
         * GetInvoiceFieldNamesByColumn returns a list of field names that all map to the provided ColumnName.
         * This is not sorted by retailer or mapping ID.
         */
        public async GetInvoiceFieldNamesByColumn(params: GetInvoiceFieldNamesByColumnParams): Promise<GetInvoiceFieldNamesByColumnResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceFieldNamesByColumn`, JSON.stringify(params))
            return await resp.json() as GetInvoiceFieldNamesByColumnResponse
        }

        /**
         * GetInvoiceFileURL returns the URL to download the invoice file
         */
        public async GetInvoiceFileURL(params: GetInvoiceFileURLParams): Promise<GetInvoiceFileURLResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceFileURL`, JSON.stringify(params))
            return await resp.json() as GetInvoiceFileURLResponse
        }

        /**
         * GetInvoiceMappingWithColumnsByID return the invoice mapping together with its explicit column maps matching
         * the MappingID.
         */
        public async GetInvoiceMappingWithColumnsByID(params: GetInvoiceMappingWithColumnsByIDParams): Promise<GetInvoiceMappingWithColumnsByIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceMappingWithColumnsByID`, JSON.stringify(params))
            return await resp.json() as GetInvoiceMappingWithColumnsByIDResponse
        }

        public async GetInvoiceRow(params: GetInvoiceRowParams): Promise<GetInvoiceRowResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceRow`, JSON.stringify(params))
            return await resp.json() as GetInvoiceRowResponse
        }

        /**
         * GetInvoiceRowExpectedDetails retrieves all expected cost entries with details for a given invoice row ID.
         */
        public async GetInvoiceRowExpectedDetails(params: GetInvoiceRowExpectedDetailsRequest): Promise<GetInvoiceRowExpectedDetailsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceRowExpectedDetails`, JSON.stringify(params))
            return await resp.json() as GetInvoiceRowExpectedDetailsResponse
        }

        /**
         * GetInvoiceRowFeeMoreInfo retrieves all invoice fee entries with details for a given invoice row ID.
         */
        public async GetInvoiceRowFeeMoreInfo(params: GetInvoiceRowFeeMoreInfoRequest): Promise<GetInvoiceRowFeeMoreInfoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceRowFeeMoreInfo`, JSON.stringify(params))
            return await resp.json() as GetInvoiceRowFeeMoreInfoResponse
        }

        /**
         * GetInvoiceRowFees retrieves all invoice fee entries for a given invoice row ID.
         */
        public async GetInvoiceRowFees(params: GetInvoiceRowFeesRequest): Promise<GetInvoiceRowFeesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceRowFees`, JSON.stringify(params))
            return await resp.json() as GetInvoiceRowFeesResponse
        }

        /**
         * GetInvoiceRowFieldSources retrieves invoice row field sources based on the provided filter criteria.
         */
        public async GetInvoiceRowFieldSources(params: GetInvoiceRowFieldSourcesParams): Promise<GetInvoiceRowFieldSourcesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceRowFieldSources`, JSON.stringify(params))
            return await resp.json() as GetInvoiceRowFieldSourcesResponse
        }

        /**
         * GetInvoiceRowObservations retrieves invoice row observations based on the provided filter criteria.
         * 
         * Returns a list of invoice row observations or an error if access is denied or the repository call fails.
         */
        public async GetInvoiceRowObservations(params: GetInvoiceRowObservationsParams): Promise<GetInvoiceRowObservationsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceRowObservations`, JSON.stringify(params))
            return await resp.json() as GetInvoiceRowObservationsResponse
        }

        /**
         * GetInvoiceRowWithAddedCostDetails retrieves the invoice row and its associated added cost details.
         */
        public async GetInvoiceRowWithAddedCostDetails(params: GetInvoiceRowParams): Promise<GetInvoiceRowWithDetailsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceRowWithAddedCostDetails`, JSON.stringify(params))
            return await resp.json() as GetInvoiceRowWithDetailsResponse
        }

        /**
         * GetInvoiceStatsByCountry fetches statistics regarding how much has been invoiced to each country
         */
        public async GetInvoiceStatsByCountry(params: GetInvoiceStatsByCountryParams): Promise<GetInvoiceStatsByCountryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceStatsByCountry`, JSON.stringify(params))
            return await resp.json() as GetInvoiceStatsByCountryResponse
        }

        /**
         * GetInvoiceStatsPerFeeType fetches invoice statistics for each fee type
         */
        public async GetInvoiceStatsPerFeeType(params: GetInvoiceStatsPerFeeTypeParams): Promise<GetInvoiceStatsPerFeeTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceStatsPerFeeType`, JSON.stringify(params))
            return await resp.json() as GetInvoiceStatsPerFeeTypeResponse
        }

        /**
         * GetInvoiceStatsPerFeeTypePerMonth fetches invoice statistics for each fee type per month
         */
        public async GetInvoiceStatsPerFeeTypePerMonth(params: GetInvoiceStatsPerFeeTypePerMonthParams): Promise<GetInvoiceStatsPerFeeTypePerMonthResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceStatsPerFeeTypePerMonth`, JSON.stringify(params))
            return await resp.json() as GetInvoiceStatsPerFeeTypePerMonthResponse
        }

        /**
         * GetInvoiceStatsPerMethod fetches invoice statistics for each used transport method
         */
        public async GetInvoiceStatsPerMethod(params: GetInvoiceStatsPerMethodParams): Promise<GetInvoiceStatsPerMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoiceStatsPerMethod`, JSON.stringify(params))
            return await resp.json() as GetInvoiceStatsPerMethodResponse
        }

        /**
         * GetInvoicesPerDay returns the number of uploaded invoices per day between the given time range
         */
        public async GetInvoicesPerDay(params: GetInvoicesPerDayParams): Promise<GetInvoicesPerDayResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoicesPerDay`, JSON.stringify(params))
            return await resp.json() as GetInvoicesPerDayResponse
        }

        public async GetInvoicesWithBreakdown(params: GetInvoicesWithBreakDownParams): Promise<GetInvoicesWithBreakdownResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoicesWithBreakdown`, JSON.stringify(params))
            return await resp.json() as GetInvoicesWithBreakdownResponse
        }

        public async GetInvoicesWithSummaryStats(params: GetInvoicesWithSummaryStatsParams): Promise<GetInvoicesWithSummaryStatsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetInvoicesWithSummaryStats`, JSON.stringify(params))
            return await resp.json() as GetInvoicesWithSummaryStatsResponse
        }

        /**
         * GetPresignedURL returns a presigned url that allows the holder to upload a file to the
         * "invoice-control-invoices" GCP bucket.
         */
        public async GetPresignedURL(params: GetPresignedURLParams): Promise<GetPresignedURLResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetPresignedURL`, JSON.stringify(params))
            return await resp.json() as GetPresignedURLResponse
        }

        /**
         * GetUniqueFeesAndLabels returns all unique fee types and their associated labels for the authenticated organization
         */
        public async GetUniqueFeesAndLabels(params: GetUniqueFeesAndLabelsParams): Promise<GetUniqueFeesAndLabelsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetUniqueFeesAndLabels`, JSON.stringify(params))
            return await resp.json() as GetUniqueFeesAndLabelsResponse
        }

        /**
         * GetUploadedInvoices simply retrieves the references to all uploaded invoices
         * belonging to  the authenticated caller.
         */
        public async GetUploadedInvoices(): Promise<GetUploadedInvoicesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.GetUploadedInvoices`)
            return await resp.json() as GetUploadedInvoicesResponse
        }

        public async IncomingEmailWebhook(method: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/invoicecontrol.IncomingEmailWebhook`, body, options)
        }

        /**
         * InsertInvoiceRowExpectedDetailsBatch handles the batch insert operation for expected cost details.
         */
        public async InsertInvoiceRowExpectedDetailsBatch(params: InsertInvoiceRowExpectedDetailsBatchRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.InsertInvoiceRowExpectedDetailsBatch`, JSON.stringify(params))
        }

        /**
         * This endpoint allows invoices to be reprocessed.
         * 
         * It removes all existing analysis data and then read and re-analyze the invoices one by one.
         * This is done asynchronously, so a OK response from this endpoint only means that a reprocessing job has been started.
         */
        public async RerunInvoices(params: RerunInvoicesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.RerunInvoices`, JSON.stringify(params))
        }

        /**
         * SaveReference saves information about an uploaded invoice file to the
         * uploaded_invoice table.
         * 
         * This function is called from Scope once the invoice document has been
         * successfully uploaded to GCP bucket.
         */
        public async SaveReference(params: SaveReferenceParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.SaveReference`, JSON.stringify(params))
        }

        /**
         * TestInvoiceMapping is intended to replicate the flow in the main controller to simplify testing
         */
        public async TestInvoiceMapping(params: TestInvoiceMappingParams): Promise<TestInvoiceMappingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/invoicecontrol.TestInvoiceMapping`, JSON.stringify(params))
            return await resp.json() as TestInvoiceMappingResponse
        }

        /**
         * UpdateDisplayNameForUploadedInvoice updates the display name of an uploaded invoice.
         */
        public async UpdateDisplayNameForUploadedInvoice(params: UpdateDisplayNameForUploadedInvoiceParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.UpdateDisplayNameForUploadedInvoice`, JSON.stringify(params))
        }

        /**
         * UpdateProcessingStatusForInvoices updates the processing status for a list of invoices.
         */
        public async UpdateProcessingStatusForInvoices(params: UpdateProcessingStatusForInvoicesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.UpdateProcessingStatusForInvoices`, JSON.stringify(params))
        }

        public async UpdateStatusForInvoiceRows(params: UpdateStatusForInvoiceRowsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.UpdateStatusForInvoiceRows`, JSON.stringify(params))
        }

        /**
         * UpsertColumnDefaultValue inserts a new default value for a column or updates an existing one.
         */
        public async UpsertColumnDefaultValue(params: UpsertColumnDefaultValueParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.UpsertColumnDefaultValue`, JSON.stringify(params))
        }

        public async UpsertInboundEmail(params: UpsertInboundEmailParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.UpsertInboundEmail`, JSON.stringify(params))
        }

        /**
         * UpsertInvoiceColumnMapping inserts a new mapping for the specified InvoiceFieldName to Skrym's
         * FieldName, assigned to the provided InvoiceMappingId, or updates and existing one.
         */
        public async UpsertInvoiceColumnMapping(params: UpsertInvoiceColumnMappingParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.UpsertInvoiceColumnMapping`, JSON.stringify(params))
        }

        /**
         * UpsertInvoiceMapping inserts a new mapping for an invoice or updates an existing one.
         */
        public async UpsertInvoiceMapping(params: UpsertInvoiceMappingParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.UpsertInvoiceMapping`, JSON.stringify(params))
        }

        /**
         * UpsertInvoiceRowExpectedDetail handles the upsert operation for expected cost details of an invoice row.
         */
        public async UpsertInvoiceRowExpectedDetail(params: UpsertInvoiceRowExpectedDetailParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.UpsertInvoiceRowExpectedDetail`, JSON.stringify(params))
        }

        /**
         * UpsertInvoiceRowFee handles the upsert operation for invoice fees of an invoice row.
         */
        public async UpsertInvoiceRowFee(params: UpsertInvoiceRowFeeParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.UpsertInvoiceRowFee`, JSON.stringify(params))
        }

        /**
         * UpsertInvoiceRowFieldSourceOverrides upserts a list of invoice row field sources.
         */
        public async UpsertInvoiceRowFieldSourceOverrides(params: UpsertInvoiceRowFieldSourceOverridesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/invoicecontrol.UpsertInvoiceRowFieldSourceOverrides`, JSON.stringify(params))
        }
    }
}

export namespace locations {
    export interface BirdDistanceParams {
        from: models.Coordinates
        to: models.Coordinates
    }

    export interface BirdDistanceResponse {
        distance: number
    }

    /**
     * DeleteOrgLocationRangeConfigForOrganizationParams represents the
     * request body for DeleteOrgLocationRangeConfigForOrganization
     * endpoint, specifying the max distance configuration to be deleted.
     */
    export interface DeleteOrgLocationRangeConfigForOrganizationParams {
        organizationId: string
        location1Type: datamodels.LocationType
        location2Type: datamodels.LocationType
    }

    export interface DeleteOrganizationLocationAvailabilitiesForTransportMethodParams {
        organizationLocationId?: string
        transportMethodId?: string
        organizationId: string
    }

    export interface DeleteOrganizationLocationsParams {
        organizationLocationIds: string[]
    }

    /**
     * The response from the ORSDirectionsGeoJSON endpoint
     * 
     * This is the exact values that are returned by the /v2/directions/{profile}/geojson endpoint and should follow the [GeoJSON](https://geojson.org/) format. However, there might be missing fields in the response, but it should be enough for the purpose of finding routing directions. More fields can be added if needed. For a description of the fields, see https://openrouteservice.org/dev/#/api-docs/v2/directions/%7Bprofile%7D/geojson/post and https://geojson.org/.
     */
    export interface GeoJSON {
        type: string
        metadata: GeoJSONMetadata
        features: GeoJSONFeature[]
        bbox: number[]
    }

    export interface GeoJSONFeature {
        bbox: number[]
        type: string
        properties: {
            segments: {
                distance: number
                duration: number
                steps: {
                    distance: number
                    duration: number
                    type: number
                    instruction: string
                    name: string
                    "way_points": number[]
                    "exit_number": number
                }[]
            }[]
            "way_points": number[]
            summary: {
                distance: number
                duration: number
            }
        }
        geometry: {
            coordinates: number[][]
            type: string
        }
    }

    export interface GeoJSONMetadata {
        attribution: string
        service: string
        timestamp: number
        query: {
            coordinates: number[][]
            profile: string
            format: string
        }
        engine: {
            version: string
            "build_date": string
            "graph_date": string
        }
    }

    /**
     * GetAllOrganizationLocationsParams holds the parameters for fetching all organization locations.
     * It allows filtering by organization UUIDs, location types, and an optional search query for location names.
     */
    export interface GetAllOrganizationLocationsParams {
        /**
         * Organizations contains the UUIDs of the organizations to fetch locations for.
         */
        organizations: string[]

        /**
         * FilterLocationTypes specifies which location types should be returned. This filter is optional.
         */
        filterLocationTypes: datamodels.LocationType[]

        /**
         * SearchQuery is an optional search string for filtering locations by name.
         */
        searchQuery?: string
    }

    /**
     * GetAllOrganizationLocationsResp is the response returned by the GetAllOrganizationLocations API call.
     * It contains a list of organization locations as determined by the request parameters.
     */
    export interface GetAllOrganizationLocationsResp {
        /**
         * OrganizationLocations holds the list of locations associated with the specified organizations.
         */
        organizationLocations: datamodels.OrganizationLocation[]
    }

    export interface GetLocationByZipAndCountryParams {
        /**
         * Postal Code of the Location
         */
        zipCode: string

        /**
         * Iso alpha2 format representation of the Country. For more on iso standards and alpha2 format: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
         */
        country: string
    }

    export interface GetLocationByZipAndCountryResponse {
        /**
         * Skrym ID of the Location
         */
        locationId: string

        coordinates?: utils.Coordinates
    }

    export interface GetLocationTypesResponse {
        locationTypes: datamodels.LocationType[]
    }

    /**
     * GetOrgLocationRangeConfigForOrganisationParams represents
     * the request body for GetOrgLocationRangeConfigForOrganisation.
     */
    export interface GetOrgLocationRangeConfigForOrganisationParams {
        organizationId: string
    }

    /**
     * GetOrgLocationRangeConfigForOrganizationResponse represents the response
     * body of the GetOrgLocationRangeConfigForOrganization API.
     */
    export interface GetOrgLocationRangeConfigForOrganizationResponse {
        locationsRangeConfig: models.OrgLocationRangeConfig[]
    }

    export interface GetOrgNameLocationByLocationIDParams {
        id: string
        orgId: string
    }

    export interface GetOrgNameLocationByLocationIDResponse {
        location: datamodels.Location
        orgLocations: datamodels.OrganizationLocation[]
    }

    /**
     * GetOrganizationLocationAndSiblingsParams contains the parameters for requesting
     * the details of an organization location along with its sibling locations.
     * It includes the unique identifier of the organization location.
     */
    export interface GetOrganizationLocationAndSiblingsParams {
        /**
         * OrganizationLocationID is the UUID of the organization location to retrieve.
         */
        organizationLocationID: string
    }

    /**
     * GetOrganizationLocationAndSiblingsResponse encapsulates the response from a request
     * to get an organization location and its siblings. It includes the requested organization
     * location and an array of sibling locations within the same parent organization.
     */
    export interface GetOrganizationLocationAndSiblingsResponse {
        /**
         * OrganizationLocation is the requested organization location.
         */
        organizationLocation: datamodels.OrganizationLocation

        /**
         * SiblingOrganizationLocations contains all sibling locations of the requested organization location.
         */
        siblingOrganizationLocations: datamodels.OrganizationLocation[]
    }

    /**
     * GetOrganizationLocationAvailabilityForTransportMethodParams defines the parameters for the GetOrganizationLocationAvailabilityForTransportMethod endpoint
     */
    export interface GetOrganizationLocationAvailabilityForTransportMethodParams {
        /**
         * The filter options for the availability of organization locations for transport methods
         */
        filterOptions?: models.OrganizationLocationAvailabilityFilterOptions
    }

    /**
     * GetOrganizationLocationAvailabilityForTransportMethodResponse defines the response for the GetOrganizationLocationAvailabilityForTransportMethod endpoint
     */
    export interface GetOrganizationLocationAvailabilityForTransportMethodResponse {
        /**
         * The availabilities of organization locations for transport methods
         */
        organizationLocationAvailabilities: models.OrganizationLocationAvailabilityForTransportMethod[]
    }

    export interface GetOrganizationLocationsDailyLimitsParams {
        orgID: string
        filter: models.OrganizationLocationDailyLimitFilter
        sort: models.OrganizationLocationDailyLimitSort[]
        page?: number
        pageSize?: number
    }

    export interface GetOrganizationLocationsDailyLimitsResponse {
        externalLimits: { [key: string]: { [key: string]: datamodels.OrganizationLocationDailyLimit } }
        organizationLocationLimits: { [key: string]: { [key: string]: datamodels.OrganizationLocationDailyLimit } }
        limits: datamodels.OrganizationLocationDailyLimit[]
    }

    export interface GetOrganizationLocationsPaginationParams {
        filters: models.OrganizationLocationFilter
        page: number
        pageSize: number
        sort: models.LocationSort
    }

    export interface GetOrganizationLocationsPaginationResp {
        organizationLocations: datamodels.OrganizationLocation[]
        rowCount: number
    }

    export interface GetOrganizationLocationsParams {
        organizationIds?: string[]
        /**
         * Specify which location types should be returned
         */
        locationTypes?: datamodels.LocationType[]

        /**
         * Filter on these external IDs
         */
        externalIds?: string[]

        /**
         * Filter on these organization location IDs
         */
        organizationLocationIds?: string[]

        /**
         * Filter on these locations
         */
        locations?: models.OrganizationLocationLocationFilter[]

        /**
         * Limit the number of results
         */
        limit?: number

        /**
         * Offset the results
         */
        offset?: number
    }

    export interface GetOrganizationLocationsResp {
        organizationLocations: datamodels.OrganizationLocation[]
    }

    export interface InsertOrganizationLocationParams {
        id: string
        externalId: string
        organizationId: string
        locationId: string
        location?: datamodels.Location
        locationType: datamodels.LocationType
        name: string
        available: boolean
        /**
         * used from frontend to always allow it to fetch with PAP API
         */
        allowExternalFetch?: boolean
    }

    /**
     * Body for the /v2/directions/{profile}/geojson endpoint
     * 
     * This follows the format of the /v2/directions/{profile}/geojson (https://openrouteservice.org/dev/#/api-docs/v2/directions/%7Bprofile%7D/geojson/post) endpoint of the ORS API. However, it is not a 1:1 mapping, as we only need a subset of the fields. More fields can be added if needed.
     */
    export interface ORSBody {
        coordinates: number[][]
    }

    /**
     * Body for the ORSDirectionsGeoJSON endpoint
     * 
     * Apart from the profile, it includes the body to send to the ORS API. The profile will be set in the URL path, while the ORSBody will be sent as the request body.
     */
    export interface ORSDirectionsGeoJSONParams {
        profile: string
        body: ORSBody
    }

    /**
     * UpdateOrganizationLocationAvailabilityParams defines the parameters needed
     * to update the availability status of an organization location.
     */
    export interface UpdateOrganizationLocationsAvailabilityParams {
        organizationLocationIds: string[]
        available: boolean
    }

    export interface UpsertMethodAvailabilitiesForOrganizationLocationsParams {
        organizationLocationAvailabilities: models.OrganizationLocationAvailabilityForTransportMethod[]
    }

    /**
     * UpsertOrgLocationRangeConfigParams represents the request body
     * for the UpsertOrgLocationRangeConfig endpoint. It is the data
     * to upsert.
     */
    export interface UpsertOrgLocationRangeConfigParams {
        locationsRangeConfig: models.OrgLocationRangeConfig[]
    }

    /**
     * UpsertOrganizationLocationAliasesParams defines the input for upserting organization location aliases.
     */
    export interface UpsertOrganizationLocationAliasesParams {
        organizationLocationAliases: datamodels.OrganizationLocationAlias[]
    }

    /**
     * UpsertOrganizationLocationWithDetailsParams represents the parameters needed
     * when upserting (updating or inserting) details of an organization's location.
     * This includes the basic location details, standard opening hours,
     * and special opening hours for dates such as holidays or renovation periods.
     */
    export interface UpsertOrganizationLocationWithDetailsParams {
        location: datamodels.OrganizationLocation
        openingHours: datamodels.OrganizationOpeningHours[]
        specialOpeningHours: datamodels.OrganizationSpecialOpeningHours[]
    }

    /**
     * UpsertOrganizationLocationWithDetailsResponse is the response structure
     * returned after an upsert action on an organization's location. It contains
     * the ID of the organization location and the ID of the location itself.
     */
    export interface UpsertOrganizationLocationWithDetailsResponse {
        organizationLocationId: string
        locationId: string
    }

    export interface UpsertOrganizationLocationsDailyLimitsParams {
        limits: datamodels.OrganizationLocationDailyLimit[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.BirdDistance = this.BirdDistance.bind(this)
            this.DeleteOrgLocationRangeConfigForOrganization = this.DeleteOrgLocationRangeConfigForOrganization.bind(this)
            this.DeleteOrganizationLocationAvailabilitiesForTransportMethod = this.DeleteOrganizationLocationAvailabilitiesForTransportMethod.bind(this)
            this.DeleteOrganizationLocations = this.DeleteOrganizationLocations.bind(this)
            this.GetAllOrganizationLocations = this.GetAllOrganizationLocations.bind(this)
            this.GetLocationAndOrgLocationsByLocationID = this.GetLocationAndOrgLocationsByLocationID.bind(this)
            this.GetLocationByZipAndCountry = this.GetLocationByZipAndCountry.bind(this)
            this.GetLocationTypes = this.GetLocationTypes.bind(this)
            this.GetOrgLocationRangeConfigForOrganization = this.GetOrgLocationRangeConfigForOrganization.bind(this)
            this.GetOrganizationLocationAvailabilityForTransportMethod = this.GetOrganizationLocationAvailabilityForTransportMethod.bind(this)
            this.GetOrganizationLocationByID = this.GetOrganizationLocationByID.bind(this)
            this.GetOrganizationLocations = this.GetOrganizationLocations.bind(this)
            this.GetOrganizationLocationsDailyLimits = this.GetOrganizationLocationsDailyLimits.bind(this)
            this.GetOrganizationLocationsPagination = this.GetOrganizationLocationsPagination.bind(this)
            this.InsertOrganizationLocation = this.InsertOrganizationLocation.bind(this)
            this.ORSDirectionsGeoJSON = this.ORSDirectionsGeoJSON.bind(this)
            this.UpdateOrganizationLocationsAvailability = this.UpdateOrganizationLocationsAvailability.bind(this)
            this.UpsertMethodAvailabilitiesForOrganizationLocations = this.UpsertMethodAvailabilitiesForOrganizationLocations.bind(this)
            this.UpsertOrgLocationRangeConfigForOrganization = this.UpsertOrgLocationRangeConfigForOrganization.bind(this)
            this.UpsertOrganizationLocationAliases = this.UpsertOrganizationLocationAliases.bind(this)
            this.UpsertOrganizationLocationWithDetails = this.UpsertOrganizationLocationWithDetails.bind(this)
            this.UpsertOrganizationLocationsDailyLimits = this.UpsertOrganizationLocationsDailyLimits.bind(this)
        }

        public async BirdDistance(params: BirdDistanceParams): Promise<BirdDistanceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.BirdDistance`, JSON.stringify(params))
            return await resp.json() as BirdDistanceResponse
        }

        /**
         * DeleteOrgLocationRangeConfigForOrganization is an authenticated API endpoint that deletes a organisation location range
         * configuration for the specified organisation that matches on the provided from and to, i.e. Location1Type
         * and Location2Type locations, respectivelly. This endpoint can only be called by a Skrym Admin and will deny access to
         * any other callers.
         */
        public async DeleteOrgLocationRangeConfigForOrganization(params: DeleteOrgLocationRangeConfigForOrganizationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/locations.DeleteOrgLocationRangeConfigForOrganization`, JSON.stringify(params))
        }

        /**
         * DeleteOrganizationLocationAvailabilitiesForTransportMethod deletes the availability of organization locations for transport methods; if organizationLocationID and transportMethodID are provided,
         * only the availability for that pair is deleted, otherwise all availabilities are deleted for either the organizationLocationID or transportMethodID depending on which is provided
         */
        public async DeleteOrganizationLocationAvailabilitiesForTransportMethod(params: DeleteOrganizationLocationAvailabilitiesForTransportMethodParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/locations.DeleteOrganizationLocationAvailabilitiesForTransportMethod`, JSON.stringify(params))
        }

        public async DeleteOrganizationLocations(params: DeleteOrganizationLocationsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/locations.DeleteOrganizationLocations`, JSON.stringify(params))
        }

        /**
         * GetAllOrganizationLocations retrieves all locations associated with the specified organizations.
         * It supports filtering by location types and an optional search query for location names.
         * The function requires authentication and returns a list of organization locations or an error if the operation fails.
         * 
         * Parameters:
         * - ctx: Context for request scoping and cancellation.
         * - params: Parameters for filtering the organization locations, including organization UUIDs, location types, and an optional search query.
         * 
         * Returns:
         * - A pointer to GetAllOrganizationLocationsResp containing the fetched organization locations.
         * - An error if the retrieval fails due to internal issues or invalid input parameters.
         */
        public async GetAllOrganizationLocations(params: GetAllOrganizationLocationsParams): Promise<GetAllOrganizationLocationsResp> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.GetAllOrganizationLocations`, JSON.stringify(params))
            return await resp.json() as GetAllOrganizationLocationsResp
        }

        public async GetLocationAndOrgLocationsByLocationID(params: GetOrgNameLocationByLocationIDParams): Promise<GetOrgNameLocationByLocationIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.GetLocationAndOrgLocationsByLocationID`, JSON.stringify(params))
            return await resp.json() as GetOrgNameLocationByLocationIDResponse
        }

        /**
         * Returns the Skrym ID of the Location based on the search of the provided ZipCode and Country combination
         * This function relies on PAP API which is currently only available in our production environment.
         * This means that for locations without any stored data we will return a error if they try to access the PAP API request.
         */
        public async GetLocationByZipAndCountry(params: GetLocationByZipAndCountryParams): Promise<GetLocationByZipAndCountryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.GetLocationByZipAndCountry`, JSON.stringify(params))
            return await resp.json() as GetLocationByZipAndCountryResponse
        }

        public async GetLocationTypes(): Promise<GetLocationTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.GetLocationTypes`)
            return await resp.json() as GetLocationTypesResponse
        }

        /**
         * GetOrgLocationRangeConfigForOrganization is an authenticated API endpoint that retrieves all organization locations
         * configurations for the specified organization, but is only acessible by a SKrym Admin. Any other caller will be denied.
         */
        public async GetOrgLocationRangeConfigForOrganization(params: GetOrgLocationRangeConfigForOrganisationParams): Promise<GetOrgLocationRangeConfigForOrganizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.GetOrgLocationRangeConfigForOrganization`, JSON.stringify(params))
            return await resp.json() as GetOrgLocationRangeConfigForOrganizationResponse
        }

        /**
         * GetOrganizationLocationAvailabilityForTransportMethod returns the availability of organization locations for transport methods
         */
        public async GetOrganizationLocationAvailabilityForTransportMethod(params: GetOrganizationLocationAvailabilityForTransportMethodParams): Promise<GetOrganizationLocationAvailabilityForTransportMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.GetOrganizationLocationAvailabilityForTransportMethod`, JSON.stringify(params))
            return await resp.json() as GetOrganizationLocationAvailabilityForTransportMethodResponse
        }

        /**
         * GetOrganizationLocationByID retrieves the specified organization location by its ID and
         * all of its sibling locations within the same parent organization. This function requires
         * authentication and checks if the requesting user has the necessary permissions to access the API.
         * 
         * Parameters:
         * - ctx: Context for request scoping, cancellation, and passing request-specific values.
         * - in: A pointer to GetOrganizationLocationAndSiblingsParams containing the ID of the organization location to retrieve.
         * 
         * Returns:
         *   - A pointer to GetOrganizationLocationAndSiblingsResponse containing the requested organization location
         *     and its sibling locations, or an error if the request fails due to internal errors or permission issues.
         * 
         * Permission checks are performed to ensure that the requesting user has the necessary rights to access
         * the requested data. A PermissionDenied error is returned if the user lacks the appropriate permissions.
         */
        public async GetOrganizationLocationByID(params: GetOrganizationLocationAndSiblingsParams): Promise<GetOrganizationLocationAndSiblingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.GetOrganizationLocationByID`, JSON.stringify(params))
            return await resp.json() as GetOrganizationLocationAndSiblingsResponse
        }

        /**
         * Get all organization locations (including their connected location) given the filters specific in the parameters.
         */
        public async GetOrganizationLocations(params: GetOrganizationLocationsParams): Promise<GetOrganizationLocationsResp> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.GetOrganizationLocations`, JSON.stringify(params))
            return await resp.json() as GetOrganizationLocationsResp
        }

        public async GetOrganizationLocationsDailyLimits(params: GetOrganizationLocationsDailyLimitsParams): Promise<GetOrganizationLocationsDailyLimitsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.GetOrganizationLocationsDailyLimits`, JSON.stringify(params))
            return await resp.json() as GetOrganizationLocationsDailyLimitsResponse
        }

        /**
         * DEPRECATED: Use GetOrganizationLocations instead
         */
        public async GetOrganizationLocationsPagination(params: GetOrganizationLocationsPaginationParams): Promise<GetOrganizationLocationsPaginationResp> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.GetOrganizationLocationsPagination`, JSON.stringify(params))
            return await resp.json() as GetOrganizationLocationsPaginationResp
        }

        /**
         * InsertOrganizationLocation inserts a location for a given organization.
         * The function operates in three main stages:
         * 
         * Case A: Checks if the location already exists by a given reference ID. If the
         * location exists, it fetches the location using that ID.
         * 
         * Case B: If Case A is not fulfilled (no existing location by ID), it attempts
         * to find a location with the same zipcode. If a matching location is found
         * with the same country and address, it uses it. If it only matches on country, it instead
         * creates a new location with the zipcode but adding the address info.
         * 
         * Case C: If no location is found in Cases A or B, it tries to create a new
         * location using an external API call through business.GetNewLocation. Note that
         * in non-production environments, this step will fail as the resource required in
         * GetNewLocation is only available in production environments.
         */
        public async InsertOrganizationLocation(params: InsertOrganizationLocationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/locations.InsertOrganizationLocation`, JSON.stringify(params))
        }

        /**
         * ORSDirectionsGeoJSON acts as a proxy our self-hosted ORS directions API.
         * 
         * It calls the POST `/v2/directions/{profile}/geojson` endpoint and simply returns the value.
         * The response follows the [GeoJSON](https://geojson.org/) format. However, there might be missing fields in the response, but it should be enough for the purpose of finding routing directions.
         */
        public async ORSDirectionsGeoJSON(params: ORSDirectionsGeoJSONParams): Promise<GeoJSON> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.ORSDirectionsGeoJSON`, JSON.stringify(params))
            return await resp.json() as GeoJSON
        }

        /**
         * UpdateOrganizationLocationAvailability updates the availability status of a specified
         * organization location in the database. It begins a transaction to ensure data consistency.
         * If the operation is successful, the transaction is committed. Otherwise, it is rolled back.
         * 
         * This function requires authentication.
         * 
         * Params:
         *   - ctx: The context for timeout and cancellation signals.
         *   - in: Parameters containing the organization location ID and its new availability status.
         * 
         * Returns:
         *   - error: An error if the update fails, otherwise nil.
         */
        public async UpdateOrganizationLocationsAvailability(params: UpdateOrganizationLocationsAvailabilityParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/locations.UpdateOrganizationLocationsAvailability`, JSON.stringify(params))
        }

        /**
         * UpsertMethodAvailabilitiesForOrganizationLocations upserts the availability of organization locations for transport methods, creating new records if they do not exist and updating if a given organization_location_id, transport_method_id pair already exists
         */
        public async UpsertMethodAvailabilitiesForOrganizationLocations(params: UpsertMethodAvailabilitiesForOrganizationLocationsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/locations.UpsertMethodAvailabilitiesForOrganizationLocations`, JSON.stringify(params))
        }

        /**
         * UpsertOrgLocationRangeConfigForOrganization is an authenticated API endpoint that inserts or updates an organization location
         * configuration specified in the request. It only allows Skrym Admin users, and will deny other callers.
         */
        public async UpsertOrgLocationRangeConfigForOrganization(params: UpsertOrgLocationRangeConfigParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/locations.UpsertOrgLocationRangeConfigForOrganization`, JSON.stringify(params))
        }

        /**
         * UpsertOrganizationLocationAliases upserts organization location aliases.
         */
        public async UpsertOrganizationLocationAliases(params: UpsertOrganizationLocationAliasesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/locations.UpsertOrganizationLocationAliases`, JSON.stringify(params))
        }

        /**
         * UpsertOrganizationLocationWithDetails is an API endpoint that handles the insertion or
         * update of an organization location, along with its opening hours and special opening hours.
         * 
         * The function inserts or updates the location data in the database. If opening hours or
         * special hours are provided, they are also inserted or updated within the same transaction.
         * 
         * Parameters:
         *   - in: A pointer to an UpsertOrganizationLocationWithDetailsParams object, which contains:
         *   - Location: An OrganizationLocation object to be inserted or updated.
         *   - OpeningHours: A slice of OrganizationOpeningHours objects to be inserted or updated.
         *   - SpecialHours: A slice of OrganizationSpecialOpeningHours objects to be inserted or updated.
         * 
         * Returns:
         *   - A pointer to an UpsertOrganizationLocationWithDetailsResponse object containing:
         *   - OrganizationLocationID: The UUID of the inserted or updated organization location.
         *   - LocationID: The UUID of the inserted or updated location.
         *   - An error if any database operation failed.
         */
        public async UpsertOrganizationLocationWithDetails(params: UpsertOrganizationLocationWithDetailsParams): Promise<UpsertOrganizationLocationWithDetailsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/locations.UpsertOrganizationLocationWithDetails`, JSON.stringify(params))
            return await resp.json() as UpsertOrganizationLocationWithDetailsResponse
        }

        public async UpsertOrganizationLocationsDailyLimits(params: UpsertOrganizationLocationsDailyLimitsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/locations.UpsertOrganizationLocationsDailyLimits`, JSON.stringify(params))
        }
    }
}

export namespace logger {
    export interface GetAllCallLogsByOrderIdParams {
        orderId: string
        /**
         *  The timestamp to fetch dates from. If omitted, it will fetch from the start.
         */
        from?: string

        /**
         *  The timestamp to fetch dates to. If omitted, will fetch all up until now.
         */
        to?: string
    }

    export interface GetAllCallLogsByOrderIdResponse {
        entries: models.CallLogEntry[]
    }

    export interface GetAllCallLogsByRetailerParams {
        retailerId: string
        /**
         *  The timestamp to fetch dates from. If omitted, it will fetch from the start.
         */
        from?: string

        /**
         *  The timestamp to fetch dates to. If omitted, will fetch all up until now.
         */
        to?: string
    }

    export interface GetAllCallLogsByRetailerResponse {
        entries: models.CallLogEntry[]
    }

    export interface GetAllCallLogsParams {
        /**
         *  The timestamp to fetch dates from. If omitted, it will fetch from the start.
         */
        from?: string

        /**
         *  The timestamp to fetch dates to. If omitted, will fetch all up until now.
         */
        to?: string
    }

    export interface GetAllCallLogsResponse {
        entries: models.CallLogEntry[]
    }

    export interface GetEntriesResponse {
        entries: models.LogEntry[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.GetAllCallLogs = this.GetAllCallLogs.bind(this)
            this.GetAllCallLogsByOrderId = this.GetAllCallLogsByOrderId.bind(this)
            this.GetAllCallLogsByRetailer = this.GetAllCallLogsByRetailer.bind(this)
            this.GetEntries = this.GetEntries.bind(this)
        }

        public async GetAllCallLogs(params: GetAllCallLogsParams): Promise<GetAllCallLogsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/logger.GetAllCallLogs`, JSON.stringify(params))
            return await resp.json() as GetAllCallLogsResponse
        }

        public async GetAllCallLogsByOrderId(params: GetAllCallLogsByOrderIdParams): Promise<GetAllCallLogsByOrderIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/logger.GetAllCallLogsByOrderId`, JSON.stringify(params))
            return await resp.json() as GetAllCallLogsByOrderIdResponse
        }

        public async GetAllCallLogsByRetailer(params: GetAllCallLogsByRetailerParams): Promise<GetAllCallLogsByRetailerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/logger.GetAllCallLogsByRetailer`, JSON.stringify(params))
            return await resp.json() as GetAllCallLogsByRetailerResponse
        }

        public async GetEntries(): Promise<GetEntriesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/logger.GetEntries`)
            return await resp.json() as GetEntriesResponse
        }
    }
}

export namespace optimization {
    export interface CalculateOptimalPackageParams {
        products: models.OrderProductWithDims[]
        fixedPackages: models.FixedPackage[]
        heightAdjustablePackages: models.HeightAdjustablePackage[]
        fullyAdjustablePackages: models.FullyAdjustablePackage[]
        /**
         * If true, no results will be saved
         */
        mock?: boolean
    }

    export interface CalculateOptimalPackageResponse {
        results: models.Result[]
    }

    export interface CalculatePharmacyPackageParams {
        orderID: string
        skrymOrderID: string
        products: models.OrderProductWithDims[]
        fixedPackages: models.FixedPackage[]
        heightAdjustablePackages: models.HeightAdjustablePackage[]
        fullyAdjustablePackages: models.FullyAdjustablePackage[]
    }

    export interface CalculatePharmacyPackageResponse {
        results: models.Result[]
    }

    export interface GetAllHyperParametersResponse {
        parameters: models.HyperParameterWithAllowedValues[]
    }

    /**
     * GetCombinedRecommendedPackagesForOrderParams represents the
     * request body of the GetCombinedRecommendedPackagesForOrder API
     * endpoint. If ShowChildren is true, the products inside any child
     * optimization result will be transformed and placed within the
     * parent product placements.
     */
    export interface GetCombinedRecommendedPackagesForOrderParams {
        orderId: string
        showChildren: boolean
    }

    /**
     * GetCombinedRecommendedPackagesForOrderResponse represents the
     * response body of the GetCombinedRecommendedPackagesForOrder API
     */
    export interface GetCombinedRecommendedPackagesForOrderResponse {
        resultPackages: models.ResultPackage[]
    }

    export interface GetOptimizationParametersResponse {
        parameters: models.OptimizationParameter[]
    }

    export interface GetParametersUsedForOptimizationResultsRequest {
        resultIds: string[]
    }

    export interface GetParametersUsedForOptimizationResultsResponse {
        resultParameters: { [key: string]: models.OptimizationParameter[] }
    }

    export interface GetRecommendedPackagesParams {
        OrderId: string
    }

    export interface GetRecommendedPackagesResponse {
        resultPackages: models.ResultPackage[]
        /**
         * Map from resultPackageID to products in that package
         */
        resultProducts: { [key: string]: models.ResultProduct[] }
    }

    export interface GetResultsByOrderIdsParams {
        orderIds: string[]
    }

    export interface GetResultsByOrderIdsResponse {
        results: models.Result[]
    }

    /**
     * OptParams is the parameter for optimization
     */
    export interface OptParams {
        containerSize: number[]
        productsSizes: number[][]
        maxDepth: number
        maxWeight: number
    }

    /**
     * OptimizationResponse is the response type of Optimization
     */
    export interface OptimizationResponse {
        fits: boolean
        container: algorithm.Box
        products: algorithm.Box[]
        maxCoord: number[]
        emptySpaces: algorithm.Box[]
    }

    export interface SelectPrescriptionBagParams {
        bags: models.Bag[]
        products: number[][]
        cumulativeVolume: number
        heightCorrection: number
    }

    /**
     * FIXME: it would make sense to let this return models.Result since it is calling optimization...
     */
    export interface SelectPrescriptionBagResponse {
        selectedBag: models.BagPackage
    }

    export interface StartForPackagesParams {
        id: string
        packages: models.BinPackage[]
    }

    export interface StartForPackagesResponse {
        orderId: string
        packageId: string
        itemsMaxCoord: number[]
    }

    export interface StartOptimizationParam {
        id: string
        /**
         * reference of the external system for the order
         */
        externalReference: string
    }

    export interface StartOptimizationResponse {
        result: models.Result[]
    }

    /**
     * StartOptimizationWithProductDataParams holds the parameters for the
     * StartOptimizationWithProductData function.
     */
    export interface StartOptimizationWithProductDataParams {
        /**
         * OptItem is the optimization item that will be processed to start the optimization.
         * It contains information about products and packages that are necessaruy for the optimization
         */
        optItem: models.OptimizationItem
    }

    /**
     * StartOptimizationWithProductDataResponse holds the response memebers for the
     * StartOptimizationWithProductData function.
     */
    export interface StartOptimizationWithProductDataResponse {
        /**
         * the optimization result
         */
        result: models.Result[]
    }

    export interface UpsertOptimizationParametersParams {
        parameter: models.OptimizationParameters
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.CalculateOptimalPackage = this.CalculateOptimalPackage.bind(this)
            this.CalculatePharmacyPackage = this.CalculatePharmacyPackage.bind(this)
            this.GetAllHyperParameters = this.GetAllHyperParameters.bind(this)
            this.GetCombinedRecommendedPackagesForOrder = this.GetCombinedRecommendedPackagesForOrder.bind(this)
            this.GetLatestResultsByOrderIds = this.GetLatestResultsByOrderIds.bind(this)
            this.GetOptimizationParameters = this.GetOptimizationParameters.bind(this)
            this.GetParametersUsedForOptimizationResults = this.GetParametersUsedForOptimizationResults.bind(this)
            this.GetRecommendedPackages = this.GetRecommendedPackages.bind(this)
            this.GetResultsOnlyRecommendedByOrderIds = this.GetResultsOnlyRecommendedByOrderIds.bind(this)
            this.Optimization = this.Optimization.bind(this)
            this.SelectPrescriptionBag = this.SelectPrescriptionBag.bind(this)
            this.Start = this.Start.bind(this)
            this.StartForPackages = this.StartForPackages.bind(this)
            this.StartOptimizationWithProductData = this.StartOptimizationWithProductData.bind(this)
            this.UpsertOptimizationParameters = this.UpsertOptimizationParameters.bind(this)
        }

        /**
         * CalculateOptimalPackage optimizes the given products into the given package(s).
         * If you have the Splitting permission, this endoint may return multiple results (one for each recommended package).
         * If you don't have the Splitting permission, it will return a single result.
         * If anything goes wrong or if the optimization fails, it will return an error.
         */
        public async CalculateOptimalPackage(params: CalculateOptimalPackageParams): Promise<CalculateOptimalPackageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.CalculateOptimalPackage`, JSON.stringify(params))
            return await resp.json() as CalculateOptimalPackageResponse
        }

        public async CalculatePharmacyPackage(params: CalculatePharmacyPackageParams): Promise<CalculatePharmacyPackageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.CalculatePharmacyPackage`, JSON.stringify(params))
            return await resp.json() as CalculatePharmacyPackageResponse
        }

        /**
         * GetAllHyperParameters fetches all hyperparameters along with their allowed ENUM values if enums
         */
        public async GetAllHyperParameters(): Promise<GetAllHyperParametersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.GetAllHyperParameters`)
            return await resp.json() as GetAllHyperParametersResponse
        }

        /**
         * GetCombinedRecommendedPackagesForOrder is an authentication encore api endpoint that returns the result package of the parent order and optionally
         * combines the products within any child optimization results (such as when a prescription product has products inside it) into it.
         */
        public async GetCombinedRecommendedPackagesForOrder(params: GetCombinedRecommendedPackagesForOrderParams): Promise<GetCombinedRecommendedPackagesForOrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.GetCombinedRecommendedPackagesForOrder`, JSON.stringify(params))
            return await resp.json() as GetCombinedRecommendedPackagesForOrderResponse
        }

        public async GetLatestResultsByOrderIds(params: GetResultsByOrderIdsParams): Promise<GetResultsByOrderIdsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.GetLatestResultsByOrderIds`, JSON.stringify(params))
            return await resp.json() as GetResultsByOrderIdsResponse
        }

        public async GetOptimizationParameters(): Promise<GetOptimizationParametersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.GetOptimizationParameters`)
            return await resp.json() as GetOptimizationParametersResponse
        }

        /**
         * GetParametersUsedForOptimizationResults is an authenticated REST API endpoint that returns the parameters used for optimization results.
         */
        public async GetParametersUsedForOptimizationResults(params: GetParametersUsedForOptimizationResultsRequest): Promise<GetParametersUsedForOptimizationResultsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.GetParametersUsedForOptimizationResults`, JSON.stringify(params))
            return await resp.json() as GetParametersUsedForOptimizationResultsResponse
        }

        public async GetRecommendedPackages(params: GetRecommendedPackagesParams): Promise<GetRecommendedPackagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.GetRecommendedPackages`, JSON.stringify(params))
            return await resp.json() as GetRecommendedPackagesResponse
        }

        /**
         * NOTE: Due to performance reasons, this endpoint only returns the recommended package, even if other result_packages exits for that one optimization_result
         */
        public async GetResultsOnlyRecommendedByOrderIds(params: GetResultsByOrderIdsParams): Promise<GetResultsByOrderIdsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.GetResultsOnlyRecommendedByOrderIds`, JSON.stringify(params))
            return await resp.json() as GetResultsByOrderIdsResponse
        }

        /**
         * Optimization is the API endpoint which triggers optimization
         */
        public async Optimization(params: OptParams): Promise<OptimizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.Optimization`, JSON.stringify(params))
            return await resp.json() as OptimizationResponse
        }

        /**
         * SelectPrescriptionBag is an authenticated REST API endpoint for selecting a prescription bag into which products can fit.
         * It does this in 2 steps:
         *  1. Finds an array of bags that could accommodate the products based on simple volume and products' max dims
         *     checks, and creates the optimization space called 'container' for each bag.
         *  2. Tries to fit the products into each container using the MaxRectTree algorithm starting off with the bag
         *     with smallest surface area, returning on success.
         */
        public async SelectPrescriptionBag(params: SelectPrescriptionBagParams): Promise<SelectPrescriptionBagResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.SelectPrescriptionBag`, JSON.stringify(params))
            return await resp.json() as SelectPrescriptionBagResponse
        }

        /**
         * Start is the API endpoint to start optimization
         */
        public async Start(params: StartOptimizationParam): Promise<StartOptimizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.Start`, JSON.stringify(params))
            return await resp.json() as StartOptimizationResponse
        }

        /**
         * StartForPackages runs the optimization with the packages that has been sent in as argument
         */
        public async StartForPackages(params: StartForPackagesParams): Promise<StartForPackagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.StartForPackages`, JSON.stringify(params))
            return await resp.json() as StartForPackagesResponse
        }

        /**
         * StartOptimizationWithProductData does box optimization expecting necessary data to be sent in.
         * The result field can be empty for non-successful optimizations
         */
        public async StartOptimizationWithProductData(params: StartOptimizationWithProductDataParams): Promise<StartOptimizationWithProductDataResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/optimization.StartOptimizationWithProductData`, JSON.stringify(params))
            return await resp.json() as StartOptimizationWithProductDataResponse
        }

        /**
         * UpsertOptimizationParameters is a REST API authenticated endpoint for upserting optimization hyperparameters.
         */
        public async UpsertOptimizationParameters(params: UpsertOptimizationParametersParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/optimization.UpsertOptimizationParameters`, JSON.stringify(params))
        }
    }
}

export namespace repo {
    export interface AddAttributesToProductExtIDParams {
        externalProductId: string
        attributes: string[]
    }

    export interface AddAttributesToProductParams {
        productId: string
        attributes: string[]
    }

    export interface BundleProductsInOrderParams {
        /**
         * Products in an order existing in an optimization item
         */
        orderProducts: models.OrderProduct[]
    }

    export interface BundleProductsInOrderResponse {
        /**
         * Updated list of order products after bundling
         */
        orderProducts: models.OrderProduct[]
    }

    export interface DeleteBundleParams {
        /**
         * The ID of the bundle
         */
        bundleId: string

        /**
         * The ID of the product representing the bundle in product_core
         */
        bundleProductId: string
    }

    export interface DeleteEnvelopeParams {
        id: string
        envelope: models.Envelope
    }

    export interface DeleteFragilityIndexParams {
        fragilityIndex: number
    }

    /**
     * DeleteOrdersParams is the parameters for the DeleteOrders function.
     * It contains the ids of the orders to be deleted and the organization id.
     */
    export interface DeleteOrdersParams {
        /**
         * The ids of the orders to be deleted.
         */
        ids: string[]

        /**
         * The organization id of the orders to be deleted.
         */
        organizationId: string
    }

    /**
     * DeletePackageParams is used to delete a package
     */
    export interface DeletePackageParams {
        id: string
    }

    /**
     * GetAllBagsRespopnse struct contains the response body for the GetAllBags API.
     * It contains an array of bags
     */
    export interface GetAllBagsResponse {
        /**
         * An array of bags as defined by Skrym.
         */
        bags: models.Bag[]
    }

    export interface GetAllFragilityIndexPaddingResponse {
        fragilityIndexPaddings: models.FragilityIndexPadding[]
    }

    /**
     * GetPackageFoldParams is used to get a package fold
     * It contains an array of all the package folds
     */
    export interface GetAllPackageFoldsRes {
        /**
         * List of returned package folds
         */
        packageFold: models.Fold[]
    }

    /**
     * GetAllPackageMaterialsRes is used to get a package material
     * It contains an array of all the package materials
     */
    export interface GetAllPackageMaterialsRes {
        /**
         * List of returned package materials
         */
        packageMaterials: models.Material[]
    }

    export interface GetAllPackageTypesByExternalIdParams {
        externalId: string
    }

    export interface GetAllPackageTypesByExternalIdResponse {
        fixedPackages: models.FixedPackage[]
        heightAdjustablePackages: models.HeightAdjustablePackage[]
        fullyAdjustablePackages: models.FullyAdjustablePackage[]
    }

    export interface GetAllPackageTypesByIDParams {
        ids: string[]
    }

    export interface GetAllPackageTypesByIDResponse {
        fixedPackages: models.FixedPackage[]
        heightAdjustablePackages: models.HeightAdjustablePackage[]
        fullyAdjustablePackages: models.FullyAdjustablePackage[]
    }

    /**
     * GetAvailableFillMaterialsResponse represents the response object for the GetAvailableFillMaterials endpoint.
     */
    export interface GetAvailableFillMaterialsResponse {
        fillMaterials: models.FillMaterial[]
    }

    export interface GetAvailableProductAttributesForOrganizationResponse {
        attributes: models.ProductAttribute[]
    }

    export interface GetBagParams {
        id: string
    }

    export interface GetBagResponse {
        bag: models.Bag
    }

    export interface GetBundleFromBundleProductIDParams {
        /**
         * The ID of the bundle product that is in product_core
         */
        bundleProductID: string
    }

    export interface GetBundleFromBundleProductIDResponse {
        /**
         * The bundle
         */
        bundle: models.Bundle
    }

    export interface GetBundlesForOrganizationResponse {
        /**
         * The bundles for the organization
         */
        bundles: models.Bundle[]
    }

    export interface GetDailyOrderCountsParams {
        from: string
        to: string
    }

    export interface GetDailyOrderCountsWithSuccessFeedbackParams {
        from: string
        to: string
    }

    export interface GetDailyOrderCountsWithSuccessFeedbackResponse {
        totalOrderCount: number
        dailyCounts: models.DailyOrderCount[]
    }

    export interface GetEnabledBagsResponse {
        bags: models.Bag[]
    }

    export interface GetEnabledFixedPackagesResponse {
        packages: models.FixedPackage[]
    }

    export interface GetEnabledFullyAdjustablePackagesResponse {
        packages: models.FullyAdjustablePackage[]
    }

    export interface GetEnabledHeightAdjustablePackagesResponse {
        packages: models.HeightAdjustablePackage[]
    }

    export interface GetEnabledPackagesResponse {
        packages: models.Package[]
    }

    export interface GetEnvelopeParams {
        id: string
    }

    export interface GetEnvelopeResponse {
        envelope: models.Envelope
    }

    export interface GetEnvelopeTypesResponse {
        envelopeTypes: string[]
    }

    export interface GetEnvelopesResponse {
        envelopes: models.Envelope[]
    }

    export interface GetFixedPackageParams {
        id: string
    }

    export interface GetFixedPackageResponse {
        package: models.FixedPackage
    }

    export interface GetFixedPackagesResponse {
        packages: models.FixedPackage[]
    }

    export interface GetFullyAdjustablePackageParams {
        id: string
    }

    export interface GetFullyAdjustablePackageResponse {
        package: models.FullyAdjustablePackage
    }

    export interface GetFullyAdjustablePackagesResponse {
        packages: models.FullyAdjustablePackage[]
    }

    export interface GetGroupedOrderAnalyticsParams {
        /**
         * Filter criteria for the order analytics
         */
        filter: models.OrderStatisticsFilter

        /**
         * Grouping dimension for the analytics, can be nil for total stats
         */
        grouping: repository.AllowedGroupBy
    }

    export interface GetGroupedOrderAnalyticsResponse {
        /**
         * Map of analytics grouped by the specified dimension, empty string key for total stats
         */
        analytics: { [key: string]: models.OrderAnalytics }
    }

    export interface GetHeightAdjustablePackageParams {
        id: string
    }

    export interface GetHeightAdjustablePackageResponse {
        package: models.HeightAdjustablePackage
    }

    export interface GetHeightAdjustablePackagesResponse {
        packages: models.HeightAdjustablePackage[]
    }

    export interface GetOrderAnalyticsDashboardParams {
        /**
         * Filter criteria for the order analytics dashboard
         */
        filter: models.OrderStatisticsFilter
    }

    export interface GetOrderAnalyticsDashboardResponse {
        /**
         * Total order analytics stats without any grouping
         */
        totalStats: models.OrderAnalytics

        /**
         * Stats grouped by checkout strategy ID
         */
        checkoutStrategyStats: { [key: string]: models.OrderAnalytics }

        /**
         * Stats grouped by checkout tactic branch ID
         */
        checkoutTacticBranchStats: { [key: string]: models.OrderAnalytics }

        /**
         * Stats grouped by invoice transporter ID
         */
        invoiceTransporterStats: { [key: string]: models.OrderAnalytics }

        /**
         * Stats grouped by invoice transport method ID
         */
        invoiceTransportMethodStats: { [key: string]: models.OrderAnalytics }
    }

    export interface GetOrderParams {
        id: string
    }

    export interface GetOrderReferencesParams {
        /**
         * The filter object
         */
        filter: models.OrderReferenceFilter

        /**
         * The sort object
         */
        sort?: models.OrderReferenceSort[]

        /**
         * The page number (0-indexed), the offset will be calculated as Page * PageSize
         */
        page?: number

        /**
         * The size of the page, represents the limit to fetch
         */
        pageSize?: number
    }

    export interface GetOrderReferencesResponse {
        /**
         * The order references
         */
        references: models.OrderReference[]

        /**
         * The total number of order references
         */
        rowCount: number
    }

    export interface GetOrderResponse {
        order: models.Order
    }

    export interface GetOrderStatisticsRowsParams {
        /**
         * Filter criteria for the order statistics rows
         */
        filter: models.OrderStatisticsFilter

        /**
         * Sorting criteria for the order statistics rows
         */
        sort: models.OrderStatisticsSort[]

        /**
         * Maximum number of rows to return. Maximum is 500.
         */
        limit: number

        /**
         * Offset for pagination
         */
        offset: number
    }

    export interface GetOrderStatisticsRowsResponse {
        /**
         * The raw order statistics rows matching the filter and sort criteria
         */
        rows: models.OrderStatistics[]
    }

    export interface GetOrdersParams {
        /**
         * The filter object
         */
        filter?: models.OrderFilter

        /**
         * The sort object
         */
        sort?: models.OrderSort[]

        /**
         * The page number (0-indexed), the offset will be calculated as Page * PageSize
         */
        page?: number

        /**
         * The size of the page, represents the limit to fetch
         */
        pageSize?: number
    }

    export interface GetOrdersPerHourParams {
        from: string
        to: string
    }

    export interface GetOrdersPerHourResponse {
        ordersPerHour: repository.OrdersPerHour[]
    }

    export interface GetOrdersResponse {
        /**
         * The orders
         */
        orders: models.Order[]

        /**
         * The total number of orders
         */
        count: number
    }

    /**
     * GetOrganizationFillMaterialsResponse represents the response for getting a list of fill materials for an organization.
     */
    export interface GetOrganizationFillMaterialsResponse {
        fillMaterials: models.OrganizationFillMaterial[]
    }

    /**
     * GetPackageMaterialByIDParams is used to get a single package material
     * It contains the id of the package material to be retrieved
     */
    export interface GetPackageMaterialByIDParams {
        /**
         * ID of the package material to be retrieved
         */
        id: number
    }

    export interface GetPackageParams {
        id: string
    }

    export interface GetPackageResponse {
        package: models.Package
    }

    /**
     * The params for the GetPackagesByExternalID endpoitn
     */
    export interface GetPackagesByExternalIDParams {
        externalId: string
    }

    /**
     * The response for the GetPackagesByExternalID endpoint
     */
    export interface GetPackagesByExternalIDResponse {
        packages: models.Package[]
    }

    export interface GetPackagesResponse {
        packages: models.Package[]
    }

    /**
     * GetPresignedURLParams specifies the file to be uploaded to GCP bucket.
     */
    export interface GetPresignedURLParams {
        /**
         * File ID
         */
        fileId: string

        /**
         * Original file name
         */
        fileName: string

        contentType: string
    }

    /**
     * GetPresignedURLResponse is the response from GetPresignedURL containing the stored name and the actual URL.
     */
    export interface GetPresignedURLResponse {
        /**
         * Name of the file to store in the bucket
         */
        storedName: string

        /**
         * Presigned URL to upload the file to
         */
        presignedURL: string
    }

    /**
     * GetProductAuditsParams encapsulates the data required for fetching audit logs for products.
     */
    export interface GetProductAuditsParams {
        /**
         * Filter for fetching audit logs.
         */
        filter: models.ProductCoreAuditFilter

        /**
         * Page number for pagination.
         */
        page?: number

        /**
         * Number of items per page.
         */
        pageSize?: number
    }

    /**
     * GetProductAuditsResponse encapsulates the response for fetching audit logs for products.
     */
    export interface GetProductAuditsResponse {
        /**
         * List of product audit logs.
         */
        productAudits: models.ProductCoreAudit[]
    }

    export interface GetProductsForOrderParams {
        id: string
    }

    export interface GetProductsForOrderResponse {
        products: models.OrderProduct[]
    }

    export interface GetProductsParams {
        page: number
        pageSize: number
        filters: models.ProductFilter
        sort: models.ProductSort[]
    }

    /**
     * // Response for GetProductsPagination
     */
    export interface GetProductsResponse {
        /**
         * The total number of products in the database. Useful for showing the total count in a table
         */
        rowCount: number

        /**
         * The historical products for the requested page. Has a max size of PageSize, but can be smaller
         */
        products: models.Product[]
    }

    export interface GetStandardEnvelopesResponse {
        envelopeTypes: models.StandardEnvelope[]
    }

    /**
     * GetUploadedDataFilesResponse contains the references to the data files that exist in the storage.
     */
    export interface GetUploadedDataFilesResponse {
        dataFiles: models.UploadedDataFile[]
    }

    export interface InsertBagParams {
        bag: models.Bag
    }

    export interface InsertEnvelopeParams {
        envelope: models.Envelope
    }

    export interface InsertFixedPackageParams {
        package: models.FixedPackage
    }

    export interface InsertFullyAdjustablePackageParams {
        package: models.FullyAdjustablePackage
    }

    export interface InsertHeightAdjustablePackageParams {
        package: models.HeightAdjustablePackage
    }

    export interface InsertOrderParams {
        order: models.Order
        products: models.OrderProductQuantity[]
    }

    export interface InsertOrderResponse {
        id: string
    }

    export interface InsertOrderWithoutProductParams {
        /**
         * Order to insert
         */
        order: models.Order
    }

    export interface InsertOrderWithoutProductResponse {
        /**
         * UUID that generated by Skrym for given order during the insert process
         */
        id: string
    }

    export interface RemoveAttributeFromProductParams {
        productId: string
        attribute: string
    }

    /**
     * SaveReferenceParams contains all the necessary information about the uploaded file.
     */
    export interface SaveReferenceParams {
        /**
         * File ID
         */
        fileId: string

        /**
         * Original file name
         */
        originalName: string

        /**
         * Optional name for display purposes
         */
        displayName: string

        contentType: string
        /**
         * Name of the file to store in the bucket
         */
        storedName: string

        /**
         * File size in bytes
         */
        fileSize: number

        /**
         * Sheet number to use in the Excel file, 0 means all sheets
         */
        sheetNumber?: number

        /**
         * e.g., 'products', 'orders', etc.
         */
        dataType: string

        /**
         * JSON object containing header mappings
         */
        headerMappings: JSONValue
    }

    export interface UpdateBagParams {
        /**
         * The bag to update
         */
        bag: models.Bag
    }

    export interface UpdateEnvelopeParams {
        envelope: models.Envelope
        id: string
    }

    export interface UpdateEnvelopeResponse {
        envelope: models.Envelope
    }

    /**
     * UpdateFillMaterial represents the data needed to update or create a new filling material entry.
     */
    export interface UpdateFillMaterial {
        /**
         * Used to update existing materials, if not provided or set to a not used value, a new entry will be added
         */
        id?: string

        /**
         * The id of the material to use as filling material
         */
        materialId: string

        /**
         * A name for the material for you to keep track of
         */
        name: string

        /**
         * How much of the volume of the emtpy space is filled with this material, on average. The range is [0, 1]
         */
        usage: number

        /**
         * The density of the material when used as filling material, in kg/m^3
         */
        density: number

        /**
         * The emissions of the material, in kgCO2e/kg
         */
        emissions: number
    }

    export interface UpdateFixedPackageParams {
        package: models.FixedPackage
    }

    export interface UpdateFragilityIndexForProductParams {
        /**
         * If unset, will remove the fragility index for the product
         */
        fragilityIndex?: number

        productID: string
    }

    export interface UpdateFullyAdjustablePackageParams {
        package: models.FullyAdjustablePackage
    }

    export interface UpdateHeightAdjustablePackageParams {
        package: models.HeightAdjustablePackage
    }

    export interface UpdateOrderForOptParams {
        order: models.Order
        products: models.OrderProductId[]
    }

    /**
     * UpdateOrganizationFillMaterialsParams represents the request body for updating fill materials of an organization.
     */
    export interface UpdateOrganizationFillMaterialsParams {
        fillMaterials: UpdateFillMaterial[]
    }

    /**
     * ================ Update packages =================
     */
    export interface UpdatePackageParams {
        package: models.Package
    }

    export interface UpdatePackageStockParams {
        packageId: string
        /**
         * Negative values are considered NULL
         */
        newStock: number
    }

    export interface UpdatePackageThresholdParams {
        packageId: string
        /**
         * Negative values make the threshold inconsequential.
         */
        newThreshold: number
    }

    export interface UpdateProductToDeletedParams {
        /**
         * The ID of the product to be updated
         */
        productId: string
    }

    export interface UpdateStackabilityParams {
        /**
         * External identifier for the product
         */
        productID: string

        /**
         * The dimension increase for stacking +1 product
         */
        stackingDelta: number

        /**
         * Length (0) Width (1) Height (2)
         */
        stackingDirection: number
    }

    export interface UpsertBundleParams {
        /**
         * The bundle to insert
         */
        bundle: models.Bundle

        /**
         * The product representing the bundle
         */
        bundleProduct: models.Product
    }

    export interface UpsertFragilityIndexPaddingParams {
        fragilityIndex: number
        name: string
        description?: string
        paddingMaterial?: string
        paddingThickness: number
    }

    /**
     * UpsertOrderParams represents the request body
     * of the UpsertOrder API endpoint, holding the
     * order to upsert.
     */
    export interface UpsertOrderParams {
        order: models.Order
    }

    /**
     * UpsertOrderReferencesParams represents the request body for the UpsertOrderReferences API endpoint.
     */
    export interface UpsertOrderReferencesParams {
        /**
         * The order references to upsert
         */
        references: models.OrderReference[]
    }

    /**
     * UpsertOrderResp represents the response
     * body of the UpsertOrder API endpoint.
     */
    export interface UpsertOrderResponse {
        orderID: string
    }

    /**
     * UpsertProductsParams encapsulates the data required for inserting products.
     * It contains a slice of ProductForInsert, representing the products to be processed.
     */
    export interface UpsertProductsParams {
        /**
         * List of products for insertion or update.
         */
        products: models.Product[]

        /**
         * Optional field to send in if the data has been inserted from a different organization than the authentication provides
         */
        createdFromOrganizationId?: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AddAttributesToProduct = this.AddAttributesToProduct.bind(this)
            this.AddAttributesToProductExtID = this.AddAttributesToProductExtID.bind(this)
            this.BundleProductsInOrder = this.BundleProductsInOrder.bind(this)
            this.DeleteBundle = this.DeleteBundle.bind(this)
            this.DeleteEnvelope = this.DeleteEnvelope.bind(this)
            this.DeleteFragilityIndex = this.DeleteFragilityIndex.bind(this)
            this.DeleteOrders = this.DeleteOrders.bind(this)
            this.DeletePackageByID = this.DeletePackageByID.bind(this)
            this.GetAllBags = this.GetAllBags.bind(this)
            this.GetAllFragilityIndexPadding = this.GetAllFragilityIndexPadding.bind(this)
            this.GetAllPackageFolds = this.GetAllPackageFolds.bind(this)
            this.GetAllPackageMaterials = this.GetAllPackageMaterials.bind(this)
            this.GetAllPackageTypesByExternalId = this.GetAllPackageTypesByExternalId.bind(this)
            this.GetAllPackageTypesByID = this.GetAllPackageTypesByID.bind(this)
            this.GetAvailableFillMaterials = this.GetAvailableFillMaterials.bind(this)
            this.GetAvailableProductAttributesForOrganization = this.GetAvailableProductAttributesForOrganization.bind(this)
            this.GetBag = this.GetBag.bind(this)
            this.GetBundleFromBundleProductID = this.GetBundleFromBundleProductID.bind(this)
            this.GetBundlesForOrganization = this.GetBundlesForOrganization.bind(this)
            this.GetDailyOrderCounts = this.GetDailyOrderCounts.bind(this)
            this.GetDailyOrderCountsWithSuccessFeedback = this.GetDailyOrderCountsWithSuccessFeedback.bind(this)
            this.GetEnabledFixedPackages = this.GetEnabledFixedPackages.bind(this)
            this.GetEnabledFullyAdjustablePackages = this.GetEnabledFullyAdjustablePackages.bind(this)
            this.GetEnabledHeightAdjustablePackages = this.GetEnabledHeightAdjustablePackages.bind(this)
            this.GetEnabledPackages = this.GetEnabledPackages.bind(this)
            this.GetEnabledPackingBags = this.GetEnabledPackingBags.bind(this)
            this.GetEnabledPrescriptionBags = this.GetEnabledPrescriptionBags.bind(this)
            this.GetEnvelope = this.GetEnvelope.bind(this)
            this.GetEnvelopeTypes = this.GetEnvelopeTypes.bind(this)
            this.GetEnvelopes = this.GetEnvelopes.bind(this)
            this.GetFixedPackage = this.GetFixedPackage.bind(this)
            this.GetFixedPackages = this.GetFixedPackages.bind(this)
            this.GetFullyAdjustablePackage = this.GetFullyAdjustablePackage.bind(this)
            this.GetFullyAdjustablePackages = this.GetFullyAdjustablePackages.bind(this)
            this.GetGroupedOrderAnalytics = this.GetGroupedOrderAnalytics.bind(this)
            this.GetHeightAdjustablePackage = this.GetHeightAdjustablePackage.bind(this)
            this.GetHeightAdjustablePackages = this.GetHeightAdjustablePackages.bind(this)
            this.GetOrder = this.GetOrder.bind(this)
            this.GetOrderAnalyticsDashboard = this.GetOrderAnalyticsDashboard.bind(this)
            this.GetOrderReferences = this.GetOrderReferences.bind(this)
            this.GetOrderStatisticsRows = this.GetOrderStatisticsRows.bind(this)
            this.GetOrders = this.GetOrders.bind(this)
            this.GetOrdersPerHour = this.GetOrdersPerHour.bind(this)
            this.GetOrganizationFillMaterials = this.GetOrganizationFillMaterials.bind(this)
            this.GetPackage = this.GetPackage.bind(this)
            this.GetPackageMaterialByID = this.GetPackageMaterialByID.bind(this)
            this.GetPackages = this.GetPackages.bind(this)
            this.GetPackagesByExternalID = this.GetPackagesByExternalID.bind(this)
            this.GetPresignedURL = this.GetPresignedURL.bind(this)
            this.GetProductAudits = this.GetProductAudits.bind(this)
            this.GetProducts = this.GetProducts.bind(this)
            this.GetProductsForOrder = this.GetProductsForOrder.bind(this)
            this.GetStandardEnvelopes = this.GetStandardEnvelopes.bind(this)
            this.GetUploadedDataFiles = this.GetUploadedDataFiles.bind(this)
            this.InsertBag = this.InsertBag.bind(this)
            this.InsertEnvelope = this.InsertEnvelope.bind(this)
            this.InsertFixedPackage = this.InsertFixedPackage.bind(this)
            this.InsertFullyAdjustablePackage = this.InsertFullyAdjustablePackage.bind(this)
            this.InsertHeightAdjustablePackage = this.InsertHeightAdjustablePackage.bind(this)
            this.InsertOrder = this.InsertOrder.bind(this)
            this.Ping = this.Ping.bind(this)
            this.PingDb = this.PingDb.bind(this)
            this.RemoveAttributeFromProduct = this.RemoveAttributeFromProduct.bind(this)
            this.SaveReference = this.SaveReference.bind(this)
            this.UpdateBag = this.UpdateBag.bind(this)
            this.UpdateEnvelope = this.UpdateEnvelope.bind(this)
            this.UpdateFixedPackage = this.UpdateFixedPackage.bind(this)
            this.UpdateFragilityIndexForProduct = this.UpdateFragilityIndexForProduct.bind(this)
            this.UpdateFullyAdjustablePackage = this.UpdateFullyAdjustablePackage.bind(this)
            this.UpdateHeightAdjustablePackage = this.UpdateHeightAdjustablePackage.bind(this)
            this.UpdateOrderForOpt = this.UpdateOrderForOpt.bind(this)
            this.UpdateOrganizationFillMaterials = this.UpdateOrganizationFillMaterials.bind(this)
            this.UpdatePackage = this.UpdatePackage.bind(this)
            this.UpdatePackageStock = this.UpdatePackageStock.bind(this)
            this.UpdatePackageThreshold = this.UpdatePackageThreshold.bind(this)
            this.UpdateProductToDeleted = this.UpdateProductToDeleted.bind(this)
            this.UpdateStackability = this.UpdateStackability.bind(this)
            this.UpsertBundle = this.UpsertBundle.bind(this)
            this.UpsertFragilityIndexPadding = this.UpsertFragilityIndexPadding.bind(this)
            this.UpsertOrder = this.UpsertOrder.bind(this)
            this.UpsertOrderReferences = this.UpsertOrderReferences.bind(this)
            this.UpsertOrderWithoutProduct = this.UpsertOrderWithoutProduct.bind(this)
            this.UpsertProducts = this.UpsertProducts.bind(this)
        }

        public async AddAttributesToProduct(params: AddAttributesToProductParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.AddAttributesToProduct`, JSON.stringify(params))
        }

        public async AddAttributesToProductExtID(params: AddAttributesToProductExtIDParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.AddAttributesToProductExtID`, JSON.stringify(params))
        }

        /**
         * BundleProductsInOrder bundles products in an order. The function checks if any bundles can be constructed from the order products.
         * If a bundle can be constructed, the bundle is added as an order procuct and the required quantities are subtracted from the order products.
         * The updated list of order products is returned.
         */
        public async BundleProductsInOrder(params: BundleProductsInOrderParams): Promise<BundleProductsInOrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.BundleProductsInOrder`, JSON.stringify(params))
            return await resp.json() as BundleProductsInOrderResponse
        }

        /**
         * DeleteBundle updates the bundle product to deleted in product_core.
         */
        public async DeleteBundle(params: DeleteBundleParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.DeleteBundle`, JSON.stringify(params))
        }

        public async DeleteEnvelope(params: DeleteEnvelopeParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.DeleteEnvelope`, JSON.stringify(params))
        }

        /**
         * DeleteFragilityIndex deletes the given fragility index for the associated retailer. It also removes any associated fragility information for all products with the associated fragility index.
         */
        public async DeleteFragilityIndex(params: DeleteFragilityIndexParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.DeleteFragilityIndex`, JSON.stringify(params))
        }

        /**
         * DeleteOrders removes the orders with the specified ids from the database.
         * This endpoint is only available to the retailer that owns the orders.
         * The retailer must be authenticated and the orders must belong to the retailer.
         * It accepts up to 1000 order ids at a time.
         */
        public async DeleteOrders(params: DeleteOrdersParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.DeleteOrders`, JSON.stringify(params))
        }

        /**
         * DeletePackageByID deletes a package for the authenticated retailer.
         * 
         * It takes a package ID and deletes the package from the packages table.
         * If no package is found with a matching ID it returns an error.
         */
        public async DeletePackageByID(params: DeletePackageParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.DeletePackageByID`, JSON.stringify(params))
        }

        /**
         * GetAllBags fetches all rows from the package_bag table for a retailer.
         * 
         * GetAllBags returns an array of all the available bags for a retailer.
         * If no bags are available, it returns an empty array.
         * Returns an error with an Internal code if something went wrong while querying the database
         */
        public async GetAllBags(): Promise<GetAllBagsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetAllBags`)
            return await resp.json() as GetAllBagsResponse
        }

        /**
         * GetAllFragilityIndexPadding returns all rows from the fragility_index_padding table for a given organization id
         */
        public async GetAllFragilityIndexPadding(): Promise<GetAllFragilityIndexPaddingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetAllFragilityIndexPadding`)
            return await resp.json() as GetAllFragilityIndexPaddingResponse
        }

        /**
         * GetAllPackageFolds fetches all rows from the package_fold table.
         * 
         * GetAllPackageFolds returns all avaialble package folds rows from the package_fold table.
         * Returns an error with a NotFound code if no rows are found
         * Returns an error with an Internal code if something went wrong while querying the database
         */
        public async GetAllPackageFolds(): Promise<GetAllPackageFoldsRes> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetAllPackageFolds`)
            return await resp.json() as GetAllPackageFoldsRes
        }

        /**
         * GetAllPackageMaterials fetches all rows from the package_materials table.
         * 
         * It returns all package material rows stored in the package_materials table.
         * If no rows are found it returns an empty list
         * Returns an error if something went wrong while querying the database
         */
        public async GetAllPackageMaterials(): Promise<GetAllPackageMaterialsRes> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetAllPackageMaterials`)
            return await resp.json() as GetAllPackageMaterialsRes
        }

        /**
         * GetPackageByExternalId fetches all packages with an external ID for a specified retailer. (more than one if there are variations)
         */
        public async GetAllPackageTypesByExternalId(params: GetAllPackageTypesByExternalIdParams): Promise<GetAllPackageTypesByExternalIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetAllPackageTypesByExternalId`, JSON.stringify(params))
            return await resp.json() as GetAllPackageTypesByExternalIdResponse
        }

        /**
         * GetAllPackageTypesByID fetches all packages with an ID for a specified retailer.
         */
        public async GetAllPackageTypesByID(params: GetAllPackageTypesByIDParams): Promise<GetAllPackageTypesByIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetAllPackageTypesByID`, JSON.stringify(params))
            return await resp.json() as GetAllPackageTypesByIDResponse
        }

        /**
         * GetAvailableFillMaterials returns a list of all available fill materials.
         * 
         * It returns a list of all available fill materials stored in the DB. These IDs can be used when updating the fill materials for an organization.
         */
        public async GetAvailableFillMaterials(): Promise<GetAvailableFillMaterialsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetAvailableFillMaterials`)
            return await resp.json() as GetAvailableFillMaterialsResponse
        }

        public async GetAvailableProductAttributesForOrganization(): Promise<GetAvailableProductAttributesForOrganizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetAvailableProductAttributesForOrganization`)
            return await resp.json() as GetAvailableProductAttributesForOrganizationResponse
        }

        public async GetBag(params: GetBagParams): Promise<GetBagResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetBag`, JSON.stringify(params))
            return await resp.json() as GetBagResponse
        }

        /**
         * GetBundleFromBundleProductID fetches a bundle from the bundle product ID.
         */
        public async GetBundleFromBundleProductID(params: GetBundleFromBundleProductIDParams): Promise<GetBundleFromBundleProductIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetBundleFromBundleProductID`, JSON.stringify(params))
            return await resp.json() as GetBundleFromBundleProductIDResponse
        }

        /**
         * GetBundlesForOrganization fetches all bundles for the organization.
         */
        public async GetBundlesForOrganization(): Promise<GetBundlesForOrganizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetBundlesForOrganization`)
            return await resp.json() as GetBundlesForOrganizationResponse
        }

        /**
         * GetDailyOrderCounts is an authenticated API endpoint that returns the daily counts of orders.
         * The daily counts are provided only for days within the from and to timestamps.
         */
        public async GetDailyOrderCounts(params: GetDailyOrderCountsParams): Promise<GetDailyOrderCountsWithSuccessFeedbackResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetDailyOrderCounts`, JSON.stringify(params))
            return await resp.json() as GetDailyOrderCountsWithSuccessFeedbackResponse
        }

        /**
         * GetDailyOrderCountsWithSuccessFeedback is an authenticated API endpoint that returns the daily counts of orders who have been verified to fit into their recommended packages.
         * The daily counts are provided only for days within the from and to timestamps.
         */
        public async GetDailyOrderCountsWithSuccessFeedback(params: GetDailyOrderCountsWithSuccessFeedbackParams): Promise<GetDailyOrderCountsWithSuccessFeedbackResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetDailyOrderCountsWithSuccessFeedback`, JSON.stringify(params))
            return await resp.json() as GetDailyOrderCountsWithSuccessFeedbackResponse
        }

        public async GetEnabledFixedPackages(): Promise<GetEnabledFixedPackagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetEnabledFixedPackages`)
            return await resp.json() as GetEnabledFixedPackagesResponse
        }

        public async GetEnabledFullyAdjustablePackages(): Promise<GetEnabledFullyAdjustablePackagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetEnabledFullyAdjustablePackages`)
            return await resp.json() as GetEnabledFullyAdjustablePackagesResponse
        }

        public async GetEnabledHeightAdjustablePackages(): Promise<GetEnabledHeightAdjustablePackagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetEnabledHeightAdjustablePackages`)
            return await resp.json() as GetEnabledHeightAdjustablePackagesResponse
        }

        public async GetEnabledPackages(): Promise<GetEnabledPackagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetEnabledPackages`)
            return await resp.json() as GetEnabledPackagesResponse
        }

        public async GetEnabledPackingBags(): Promise<GetEnabledBagsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetEnabledPackingBags`)
            return await resp.json() as GetEnabledBagsResponse
        }

        public async GetEnabledPrescriptionBags(): Promise<GetEnabledBagsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetEnabledPrescriptionBags`)
            return await resp.json() as GetEnabledBagsResponse
        }

        public async GetEnvelope(params: GetEnvelopeParams): Promise<GetEnvelopeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetEnvelope`, JSON.stringify(params))
            return await resp.json() as GetEnvelopeResponse
        }

        public async GetEnvelopeTypes(): Promise<GetEnvelopeTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetEnvelopeTypes`)
            return await resp.json() as GetEnvelopeTypesResponse
        }

        public async GetEnvelopes(): Promise<GetEnvelopesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetEnvelopes`)
            return await resp.json() as GetEnvelopesResponse
        }

        /**
         * GetFixedPackage fetches a fixed package for the authenticated retailer.
         */
        public async GetFixedPackage(params: GetFixedPackageParams): Promise<GetFixedPackageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetFixedPackage`, JSON.stringify(params))
            return await resp.json() as GetFixedPackageResponse
        }

        /**
         * GetFixedPackages fetches all fixed packages for the authenticated retailer.
         */
        public async GetFixedPackages(): Promise<GetFixedPackagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetFixedPackages`)
            return await resp.json() as GetFixedPackagesResponse
        }

        /**
         * GetFullyAdjustablePackage fetches a fully adjustable packages for the authenticated retailer.
         */
        public async GetFullyAdjustablePackage(params: GetFullyAdjustablePackageParams): Promise<GetFullyAdjustablePackageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetFullyAdjustablePackage`, JSON.stringify(params))
            return await resp.json() as GetFullyAdjustablePackageResponse
        }

        /**
         * GetFullyAdjustablePackages fetches all fully adjustable packages for the authenticated retailer.
         */
        public async GetFullyAdjustablePackages(): Promise<GetFullyAdjustablePackagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetFullyAdjustablePackages`)
            return await resp.json() as GetFullyAdjustablePackagesResponse
        }

        /**
         * GetGroupedOrderAnalytics retrieves pre-computed order analytics from the database grouped by the specified dimension
         */
        public async GetGroupedOrderAnalytics(params: GetGroupedOrderAnalyticsParams): Promise<GetGroupedOrderAnalyticsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetGroupedOrderAnalytics`, JSON.stringify(params))
            return await resp.json() as GetGroupedOrderAnalyticsResponse
        }

        /**
         * GetHeightAdjustablePackage fetches a height-adjustable package for the authenticated retailer.
         */
        public async GetHeightAdjustablePackage(params: GetHeightAdjustablePackageParams): Promise<GetHeightAdjustablePackageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetHeightAdjustablePackage`, JSON.stringify(params))
            return await resp.json() as GetHeightAdjustablePackageResponse
        }

        /**
         * GetHeightAdjustablePackages fetches all height-adjustable packages for the authenticated retailer.
         */
        public async GetHeightAdjustablePackages(): Promise<GetHeightAdjustablePackagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetHeightAdjustablePackages`)
            return await resp.json() as GetHeightAdjustablePackagesResponse
        }

        /**
         * GetOrder fetches an order for the authenticated retailer.
         */
        public async GetOrder(params: GetOrderParams): Promise<GetOrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetOrder`, JSON.stringify(params))
            return await resp.json() as GetOrderResponse
        }

        /**
         * GetOrderAnalyticsDashboard retrieves a complete dashboard of order analytics
         * with multiple grouping dimensions for visualization and analysis
         */
        public async GetOrderAnalyticsDashboard(params: GetOrderAnalyticsDashboardParams): Promise<GetOrderAnalyticsDashboardResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetOrderAnalyticsDashboard`, JSON.stringify(params))
            return await resp.json() as GetOrderAnalyticsDashboardResponse
        }

        public async GetOrderReferences(params: GetOrderReferencesParams): Promise<GetOrderReferencesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetOrderReferences`, JSON.stringify(params))
            return await resp.json() as GetOrderReferencesResponse
        }

        /**
         * GetOrderStatisticsRows retrieves raw order statistics rows for analysis and debugging
         */
        public async GetOrderStatisticsRows(params: GetOrderStatisticsRowsParams): Promise<GetOrderStatisticsRowsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetOrderStatisticsRows`, JSON.stringify(params))
            return await resp.json() as GetOrderStatisticsRowsResponse
        }

        public async GetOrders(params: GetOrdersParams): Promise<GetOrdersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetOrders`, JSON.stringify(params))
            return await resp.json() as GetOrdersResponse
        }

        /**
         * GetOrdersPerHour returns the number of orders per hour between the given time range
         */
        public async GetOrdersPerHour(params: GetOrdersPerHourParams): Promise<GetOrdersPerHourResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetOrdersPerHour`, JSON.stringify(params))
            return await resp.json() as GetOrdersPerHourResponse
        }

        /**
         * GetOrganizationFillMaterials returns a list of fill materials used by the authenticated organization
         * 
         * If none are defined, the list is empty. Returns a list of specified fill materials on success, or an error on failure.
         */
        public async GetOrganizationFillMaterials(): Promise<GetOrganizationFillMaterialsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetOrganizationFillMaterials`)
            return await resp.json() as GetOrganizationFillMaterialsResponse
        }

        /**
         * NOTE: Package stock can be 0 if stock is NULL or if stock is actually 0
         * GetPackage fetches an package for the authenticated retailer.
         */
        public async GetPackage(params: GetPackageParams): Promise<GetPackageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetPackage`, JSON.stringify(params))
            return await resp.json() as GetPackageResponse
        }

        /**
         * GetPackageMaterialByID fetches a package material row from the package_materials table using the provided ID.
         * 
         * It returns a single package material row from the package_materials table.
         * Returns an error if no package material is found with a matching ID.
         */
        public async GetPackageMaterialByID(params: GetPackageMaterialByIDParams): Promise<models.Material> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetPackageMaterialByID`, JSON.stringify(params))
            return await resp.json() as models.Material
        }

        /**
         * GetPackages fetches all packages (fixed, one-dim and all-dim) for the authenticated retailer. Note that this endpoint
         * only returns common fields.
         */
        public async GetPackages(): Promise<GetPackagesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetPackages`)
            return await resp.json() as GetPackagesResponse
        }

        /**
         * GetPackageByExternalId fetches all packages with an external ID for a specified retailer. (more than one if there are variations)
         * 
         * It takes an external ID and returns all packages with the same external ID for the authenticated retailer. To fetch type-specific information, other endpoints should be used.
         */
        public async GetPackagesByExternalID(params: GetPackagesByExternalIDParams): Promise<GetPackagesByExternalIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetPackagesByExternalID`, JSON.stringify(params))
            return await resp.json() as GetPackagesByExternalIDResponse
        }

        /**
         * GetPresignedURL returns a presigned URL that allows the holder to upload a file to the "data-files" GCP bucket.
         */
        public async GetPresignedURL(params: GetPresignedURLParams): Promise<GetPresignedURLResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetPresignedURL`, JSON.stringify(params))
            return await resp.json() as GetPresignedURLResponse
        }

        /**
         * GetProductAudits fetches the audit logs based on the given filter.
         */
        public async GetProductAudits(params: GetProductAuditsParams): Promise<GetProductAuditsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetProductAudits`, JSON.stringify(params))
            return await resp.json() as GetProductAuditsResponse
        }

        /**
         * GetProducts fetches all filtered products for the authenticated retailer.
         */
        public async GetProducts(params: GetProductsParams): Promise<GetProductsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetProducts`, JSON.stringify(params))
            return await resp.json() as GetProductsResponse
        }

        /**
         * GetProductsForOrder fetches all products and their quantity for an order.
         */
        public async GetProductsForOrder(params: GetProductsForOrderParams): Promise<GetProductsForOrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetProductsForOrder`, JSON.stringify(params))
            return await resp.json() as GetProductsForOrderResponse
        }

        public async GetStandardEnvelopes(): Promise<GetStandardEnvelopesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetStandardEnvelopes`)
            return await resp.json() as GetStandardEnvelopesResponse
        }

        /**
         * GetUploadedDataFiles retrieves the references to all uploaded data files belonging to the authenticated caller.
         */
        public async GetUploadedDataFiles(): Promise<GetUploadedDataFilesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.GetUploadedDataFiles`)
            return await resp.json() as GetUploadedDataFilesResponse
        }

        public async InsertBag(params: InsertBagParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.InsertBag`, JSON.stringify(params))
        }

        public async InsertEnvelope(params: InsertEnvelopeParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.InsertEnvelope`, JSON.stringify(params))
        }

        /**
         * InsertFixedPackage inserts a fixed package for the authenticated retailer. Will overwrite PackageType to "Fixed".
         * Will nullify negative stock values.
         */
        public async InsertFixedPackage(params: InsertFixedPackageParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.InsertFixedPackage`, JSON.stringify(params))
        }

        /**
         * InsertFullyAdjustablePackage inserts a fully adjustable package for the authenticated retailer. Will overwrite
         * PackageType to "Fully adjustable". Will nullify negative stock values.
         */
        public async InsertFullyAdjustablePackage(params: InsertFullyAdjustablePackageParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.InsertFullyAdjustablePackage`, JSON.stringify(params))
        }

        /**
         * InsertHeightAdjustablePackage inserts a height adjustable package for the authenticated retailer. Will overwrite
         * PackageType to "Height adjustable". Will nullify negative stock values.
         */
        public async InsertHeightAdjustablePackage(params: InsertHeightAdjustablePackageParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.InsertHeightAdjustablePackage`, JSON.stringify(params))
        }

        /**
         * InsertOrder inserts an order for the authenticated retailer.
         */
        public async InsertOrder(params: InsertOrderParams): Promise<InsertOrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.InsertOrder`, JSON.stringify(params))
            return await resp.json() as InsertOrderResponse
        }

        /**
         * The Ping endpoint allows you to check if the Skrym API is reachable or not.
         * 
         * It will always respond with a 200 OK.
         */
        public async Ping(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.Ping`)
        }

        public async PingDb(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.PingDb`)
        }

        public async RemoveAttributeFromProduct(params: RemoveAttributeFromProductParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.RemoveAttributeFromProduct`, JSON.stringify(params))
        }

        /**
         * SaveReference saves information about an uploaded data file to the uploaded_data_file table.
         */
        public async SaveReference(params: SaveReferenceParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.SaveReference`, JSON.stringify(params))
        }

        /**
         * UpdateBag updates a package of type bag.
         */
        public async UpdateBag(params: UpdateBagParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdateBag`, JSON.stringify(params))
        }

        public async UpdateEnvelope(params: UpdateEnvelopeParams): Promise<UpdateEnvelopeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.UpdateEnvelope`, JSON.stringify(params))
            return await resp.json() as UpdateEnvelopeResponse
        }

        /**
         * UpdateFixedPackage updates a package for the authenticated retailer.
         */
        public async UpdateFixedPackage(params: UpdateFixedPackageParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdateFixedPackage`, JSON.stringify(params))
        }

        /**
         * UpdateFragilityIndexPaddingForProduct updates the fragility index value stored for a product
         */
        public async UpdateFragilityIndexForProduct(params: UpdateFragilityIndexForProductParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdateFragilityIndexForProduct`, JSON.stringify(params))
        }

        /**
         * UpdateFullyAdjustablePackage updates a fully adjustable package for the authenticated retailer.
         */
        public async UpdateFullyAdjustablePackage(params: UpdateFullyAdjustablePackageParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdateFullyAdjustablePackage`, JSON.stringify(params))
        }

        /**
         * UpdateHeightAdjustablePackage updates a height adjustable package for the authenticated retailer.
         */
        public async UpdateHeightAdjustablePackage(params: UpdateHeightAdjustablePackageParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdateHeightAdjustablePackage`, JSON.stringify(params))
        }

        public async UpdateOrderForOpt(params: UpdateOrderForOptParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdateOrderForOpt`, JSON.stringify(params))
        }

        /**
         * UpdateOrganizationFillMaterialsParams updates the fill materials for the authenticated organization.
         * 
         * It does so by inserting all new materials, updating all existing materials and deleting all materials that are not in the list.
         * The `id` field in the `fillMaterials` array is used to determine if an entry should be updated or inserted. If the `id` field is not set or set to a value that is not used, a new entry will be inserted.
         * Returns nothing on success, or an error on failure.
         */
        public async UpdateOrganizationFillMaterials(params: UpdateOrganizationFillMaterialsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdateOrganizationFillMaterials`, JSON.stringify(params))
        }

        /**
         * UpdatePackage updates a package for the authenticated retailer. Will not update stock or threshold.
         */
        public async UpdatePackage(params: UpdatePackageParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdatePackage`, JSON.stringify(params))
        }

        /**
         * UpdatePackageStock is an authenticated REST API endpoint that updates the stock of a package.
         */
        public async UpdatePackageStock(params: UpdatePackageStockParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdatePackageStock`, JSON.stringify(params))
        }

        /**
         * UpdatePackageThreshold is an authenticated REST API endpoint that updates the threshold of a package.
         */
        public async UpdatePackageThreshold(params: UpdatePackageThresholdParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdatePackageThreshold`, JSON.stringify(params))
        }

        /**
         * UpdateProductToDeleted updates the product status to deleted
         */
        public async UpdateProductToDeleted(params: UpdateProductToDeletedParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdateProductToDeleted`, JSON.stringify(params))
        }

        /**
         * UpdateStackability updates the stacking delta and direction of a product
         * 
         * Note that it does currently not check for invalid stacking dimension arguments.
         */
        public async UpdateStackability(params: UpdateStackabilityParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpdateStackability`, JSON.stringify(params))
        }

        /**
         * UpsertBundle inserts or updates a bundle. If the bundle already exists, it is updated.
         * After the bundle has been inserted or updated, a "product" representing the bundle is inserted into product_core.
         */
        public async UpsertBundle(params: UpsertBundleParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpsertBundle`, JSON.stringify(params))
        }

        /**
         * UpdateFragilityIndexPadding updates or inserts a row in the fragility_index_padding table
         * 
         * Note that it does currently not check for invalid parameters.
         */
        public async UpsertFragilityIndexPadding(params: UpsertFragilityIndexPaddingParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpsertFragilityIndexPadding`, JSON.stringify(params))
        }

        /**
         * UpsertOrder is a private encore API endpoint for upserting an order into the order_core table.
         * On success, it returns the the upserted orderID in the repsponse body and a nil error. On failure,
         * it returns a nil response body and the corresponding error.
         */
        public async UpsertOrder(params: UpsertOrderParams): Promise<UpsertOrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.UpsertOrder`, JSON.stringify(params))
            return await resp.json() as UpsertOrderResponse
        }

        /**
         * UpsertOrderReferences upserts the provided order references into the order_reference table.
         */
        public async UpsertOrderReferences(params: UpsertOrderReferencesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpsertOrderReferences`, JSON.stringify(params))
        }

        /**
         * UpsertOrderWithoutProduct accepts an order, inserts it into the database, and returns a newly generated UUID for the order if the order does not have an ID.
         */
        public async UpsertOrderWithoutProduct(params: InsertOrderWithoutProductParams): Promise<InsertOrderWithoutProductResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repo.UpsertOrderWithoutProduct`, JSON.stringify(params))
            return await resp.json() as InsertOrderWithoutProductResponse
        }

        /**
         * UpsertProducts inserts or updates a batch of products in the database.
         * It validates each product for required fields and positive dimensions.
         * If any product fails validation, a validation error is returned.
         * CAUTION: This function conflicts on the external ID organization ID pair. This means that if other fields are not provided and have default values, they will be set to the default values or null.
         * CAUTION: If you are unsure about the values of the fields, try fetching the product first with `repo.GetProducts` and then upsert it.
         */
        public async UpsertProducts(params: UpsertProductsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/repo.UpsertProducts`, JSON.stringify(params))
        }
    }
}

export namespace statistics {
    export interface DownloadPackageUsageCountParams {
        /**
         * Recipient emails
         */
        recipientEmails: string[]

        /**
         * Filter
         */
        filter: models.PackageFilter
    }

    export interface FillRateDistributionParams {
        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface FillRateDistributionResponse {
        /**
         * The cumulative distribution of all the orders for the specified period
         */
        totalDistribution: number[]

        /**
         * Fill rate distribution for each day in the period
         */
        dailyDistributions: models.FillRateDistribution[]
    }

    export interface FillRateParams {
        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface FillRateResponse {
        /**
         * The cumulative volume of all the products for the specified period. Unit is [mm^3]
         */
        totalProductVolume: number

        /**
         * The cumulative volume of all the packages for the specified period. Unit is [mm^3]
         */
        totalPackageVolume: number

        /**
         * The total fill rate for the specified period. Range is [0, 1]
         */
        totalFillRate: number

        /**
         * Fill rates and total volume for each day in the period
         */
        dailyFillRates: models.FillRate[]
    }

    export interface GetOrdersWithRecommendationParams {
        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface GetOrdersWithRecommendationResponse {
        numberOfOrders: number
    }

    export interface InsertMultipleForSingleOrderParams {
        optimizationResults: models.Result[]
        transporter: string
        transportMethod: string
    }

    export interface InsertParams {
        optimizationResult: models.Result
        transporter: string
        transportMethod: string
    }

    export interface OrderCountParams {
        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface OrderCountPerTransportMethodParams {
        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface OrderCountPerTransportMethodResponse {
        totalPerTransportMethodOrderCount: models.OrderCountPerTransportMethodWithoutDate[]
        /**
         * Emissions for each day in the period
         */
        dailyPerTransportMethodOrderCount: models.OrderCountPerTransportMethod[]
    }

    export interface OrderCountResponse {
        /**
         * The cumulative order count for the specified period
         */
        totalOrderCount: number

        /**
         * Order count for each day in the period
         */
        dailyCounts: models.OrderCount[]
    }

    /**
     * Params for OrderFillRate
     */
    export interface OrderFillRateParams {
        orderId: string
    }

    /**
     * Response for OrderFillRate
     */
    export interface OrderFillRateResponse {
        fillRate: number
    }

    /**
     * Params for OrderVolume
     */
    export interface OrderVolumeParams {
        orderId: string
    }

    /**
     * Response for OrderVolume
     */
    export interface OrderVolumeResponse {
        /**
         * The volume of the package. Unit is m^3
         */
        volume: number
    }

    export interface PackageFillRateDistributionParams {
        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface PackageFillRateDistributionResponse {
        /**
         * The cumulative package distribution for the specified period
         */
        totalPackageFillRateDistributions: models.PackagesFillRateDistributionData

        /**
         * Package distribution for each day in the period
         */
        dailyPackageFillRateDistributions: models.GroupedPackageFillRateDistribution[]
    }

    export interface PackageFillRateParams {
        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface PackageFillRateResponse {
        /**
         * The cumulative fill rates for the package for the specified period
         */
        totalPackageFillRate: models.PackagesFillRateData

        /**
         * Package fill rates for each day in the period
         */
        dailyPackageFillRates: models.GroupedPackageFillRate[]
    }

    export interface PackageUsageCountParams {
        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface PackageUsageCountResponse {
        /**
         * The cumulative package usage count for the specified period
         */
        totalPackageUsageCount: models.PackagesUsageCountData

        /**
         * Package usage count for each day in the period
         */
        dailyPackageUsageCounts: models.GroupedPackageUsageCount[]
    }

    export interface ProductsPerOrderResponse {
        /**
         * The cumulative products per order for the specified period
         */
        totalProductsPerOrder: models.ProductsPerOrderData

        /**
         * Package products per for each day in the period
         */
        dailyProductsPerOrder: models.ProductsPerOrder[]
    }

    export interface ProductsPerPackageParams {
        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface SentVolumeParams {
        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface SentVolumeResponse {
        /**
         * The cumulative sent volume for the specified period
         */
        totalSentVolume: number

        /**
         * Sent volume for each day in the period
         */
        dailySentVolumes: models.SentVolume[]
    }

    export interface SinglePackageFillRateDistributionParams {
        /**
         *  The package id for which we want to fetch the data
         */
        packageId: string

        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface SinglePackageFillRateDistributionResponse {
        /**
         * The cumulative package distribution for the specified period
         */
        totalPackageFillRateDistributions: number[]

        /**
         * Package distribution for each day in the period
         */
        dailyPackageFillRateDistributions: models.PackageFillRateDistribution[]
    }

    export interface SinglePackageFillRateParams {
        /**
         *  The package id for which we want to fetch the data
         */
        packageId: string

        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface SinglePackageFillRateResponse {
        /**
         * The cumulative fill rates for the package for the specified period
         */
        totalPackageFillRate: models.FillRateData

        /**
         * Package fill rates for each day in the period
         */
        dailyPackageFillRates: models.PackageFillRate[]
    }

    export interface SinglePackageUsageCountParams {
        /**
         *  The package id for which we want to fetch the data
         */
        packageId: string

        /**
         *  The start of the period to fetch. If excluded, it will fetch from the first date for which data is available.
         * 	Only the date will be considered, meaning that even if it's 2020-02-13 23:59:59, it will include all of 13th.
         * 	The timezone is UTC.
         */
        from?: string

        /**
         *  The end of the period to fetch. If excluded, it will fetch until today. Only the date will be considered, meaning
         * 	that even if it's 2020-02-13 00:00:01, it will include all of 13th. The timezone is UTC.
         */
        to?: string
    }

    export interface SinglePackageUsageCountResponse {
        /**
         * The cumulative package usage count for the specified period
         */
        totalPackageUsageCount: number

        /**
         * Package usage count for each day in the period
         */
        dailyPackageUsageCounts: models.PackageUsageCount[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.DownloadPackageUsageCount = this.DownloadPackageUsageCount.bind(this)
            this.FillRate = this.FillRate.bind(this)
            this.FillRateDistribution = this.FillRateDistribution.bind(this)
            this.GetOrdersWithRecommendation = this.GetOrdersWithRecommendation.bind(this)
            this.Insert = this.Insert.bind(this)
            this.InsertMultipleForSingleOrder = this.InsertMultipleForSingleOrder.bind(this)
            this.OrderCount = this.OrderCount.bind(this)
            this.OrderCountPerTransportMethod = this.OrderCountPerTransportMethod.bind(this)
            this.OrderFillRate = this.OrderFillRate.bind(this)
            this.OrderVolume = this.OrderVolume.bind(this)
            this.PackageFillRate = this.PackageFillRate.bind(this)
            this.PackageFillRateDistributions = this.PackageFillRateDistributions.bind(this)
            this.PackageUsageCount = this.PackageUsageCount.bind(this)
            this.ProductsPerOrder = this.ProductsPerOrder.bind(this)
            this.SentVolume = this.SentVolume.bind(this)
            this.SinglePackageFillRate = this.SinglePackageFillRate.bind(this)
            this.SinglePackageFillRateDistributions = this.SinglePackageFillRateDistributions.bind(this)
            this.SinglePackageUsageCount = this.SinglePackageUsageCount.bind(this)
        }

        /**
         * DownloadPackageUsageCount downloads package usage count data to a CSV file and uploads it to a GCP bucket.
         */
        public async DownloadPackageUsageCount(params: DownloadPackageUsageCountParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/statistics.DownloadPackageUsageCount`, JSON.stringify(params))
        }

        /**
         * Fetch the fill rates for a period, both for each day and summarized for the complete period
         */
        public async FillRate(params: FillRateParams): Promise<FillRateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.FillRate`, JSON.stringify(params))
            return await resp.json() as FillRateResponse
        }

        /**
         * Fetch the fill rate distribution for a period, both for each day and summarized for the complete period
         */
        public async FillRateDistribution(params: FillRateDistributionParams): Promise<FillRateDistributionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.FillRateDistribution`, JSON.stringify(params))
            return await resp.json() as FillRateDistributionResponse
        }

        public async GetOrdersWithRecommendation(params: GetOrdersWithRecommendationParams): Promise<GetOrdersWithRecommendationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.GetOrdersWithRecommendation`, JSON.stringify(params))
            return await resp.json() as GetOrdersWithRecommendationResponse
        }

        /**
         * Insert all the data from optimizations. We do not currently care about any errors created when inserting, as this
         * should not be affecting other services.
         */
        public async Insert(params: InsertParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/statistics.Insert`, JSON.stringify(params))
        }

        /**
         * InsertMultipleForSingleOrder inserts all statistics for a single order with multiple optimization results, such as when splitting was performed.
         * 
         * Disclaimer: Trying to move away from the statistics service.
         */
        public async InsertMultipleForSingleOrder(params: InsertMultipleForSingleOrderParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/statistics.InsertMultipleForSingleOrder`, JSON.stringify(params))
        }

        /**
         * Fetch the order count for a period, both for each day and summarized for the complete period
         */
        public async OrderCount(params: OrderCountParams): Promise<OrderCountResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.OrderCount`, JSON.stringify(params))
            return await resp.json() as OrderCountResponse
        }

        /**
         * Fetch the emissions for a period, both for each day and summarized for the complete period
         */
        public async OrderCountPerTransportMethod(params: OrderCountPerTransportMethodParams): Promise<OrderCountPerTransportMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.OrderCountPerTransportMethod`, JSON.stringify(params))
            return await resp.json() as OrderCountPerTransportMethodResponse
        }

        public async OrderFillRate(params: OrderFillRateParams): Promise<OrderFillRateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.OrderFillRate`, JSON.stringify(params))
            return await resp.json() as OrderFillRateResponse
        }

        public async OrderVolume(params: OrderVolumeParams): Promise<OrderVolumeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.OrderVolume`, JSON.stringify(params))
            return await resp.json() as OrderVolumeResponse
        }

        /**
         * Fetch the fill rates for the packages for a period, both for each day and summarized for the complete period
         */
        public async PackageFillRate(params: PackageFillRateParams): Promise<PackageFillRateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.PackageFillRate`, JSON.stringify(params))
            return await resp.json() as PackageFillRateResponse
        }

        /**
         * Fetch the fill rate distribution for the packages for a period, both for each day and summarized for the complete period
         */
        public async PackageFillRateDistributions(params: PackageFillRateDistributionParams): Promise<PackageFillRateDistributionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.PackageFillRateDistributions`, JSON.stringify(params))
            return await resp.json() as PackageFillRateDistributionResponse
        }

        /**
         * Fetch the package usage count for a period, both for each day and summarized for the complete period
         */
        public async PackageUsageCount(params: PackageUsageCountParams): Promise<PackageUsageCountResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.PackageUsageCount`, JSON.stringify(params))
            return await resp.json() as PackageUsageCountResponse
        }

        /**
         * Fetch the products per order for a period, both for each day and summarized for the complete period
         */
        public async ProductsPerOrder(params: ProductsPerPackageParams): Promise<ProductsPerOrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.ProductsPerOrder`, JSON.stringify(params))
            return await resp.json() as ProductsPerOrderResponse
        }

        /**
         * Fetch the sent volume for a period, both for each day and summarized for the complete period
         */
        public async SentVolume(params: SentVolumeParams): Promise<SentVolumeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.SentVolume`, JSON.stringify(params))
            return await resp.json() as SentVolumeResponse
        }

        /**
         * Fetch the fill rates for the packages for a period, both for each day and summarized for the complete period
         */
        public async SinglePackageFillRate(params: SinglePackageFillRateParams): Promise<SinglePackageFillRateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.SinglePackageFillRate`, JSON.stringify(params))
            return await resp.json() as SinglePackageFillRateResponse
        }

        /**
         * Fetch the fill rate distribution for the packages for a period, both for each day and summarized for the complete period
         */
        public async SinglePackageFillRateDistributions(params: SinglePackageFillRateDistributionParams): Promise<SinglePackageFillRateDistributionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.SinglePackageFillRateDistributions`, JSON.stringify(params))
            return await resp.json() as SinglePackageFillRateDistributionResponse
        }

        /**
         * Fetch the package usage count for a period, both for each day and summarized for the complete period
         */
        public async SinglePackageUsageCount(params: SinglePackageUsageCountParams): Promise<SinglePackageUsageCountResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/statistics.SinglePackageUsageCount`, JSON.stringify(params))
            return await resp.json() as SinglePackageUsageCountResponse
        }
    }
}

export namespace tracking {
    export interface AddOrderReferencesParams {
        /**
         * A current reference of the order.
         */
        currentReference: string

        /**
         * The references to add to the order.
         */
        references: string[]
    }

    export interface AddShipmentsToOrderParams {
        /**
         * A reference to the order to which the shipment should be added. Can be any of the references provided when initializing the order.
         */
        orderReference: string

        /**
         * Information about the shipments to add to the order.
         */
        shipments: ShipmentToAdd[]

        /**
         * DEPRECATED: Use `OriginLocationIdentifier` for each shipment instead. Optional identifier for the origin location of the shipment. This allows Skrym to use the locations when presenting the data.
         */
        originLocationIdentifier?: string
    }

    /**
     * See https://developer.budbee.com/#Webhooks-V2
     */
    export interface BudbeeTrackingWebhookRequest {
        event: string
        eventData: models.BudbeeEventData
    }

    /**
     * CityMailWebhookParams represents the parameters for the CityMail webhook.
     * The webhook is called by CityMail when the status of a package changes.
     */
    export interface CityMailWebhookParams {
        packageId: string
        /**
         * Is unique per event (Guaranteed by CityMail)
         */
        messageId: number

        time: string
        code: string
        description: string
        isDelivered: boolean
    }

    /**
     * ConditionInput represents the input data for a condition to reach a milestone.
     */
    export interface ConditionInput {
        /**
         * The reference of the condition
         */
        reference: string

        /**
         * ANY or ALL, used for evaluating the thresholds. If ANY, any of the thresholds should be met, if ALL, all thresholds should be met.
         */
        evaluationLogic: models.EvaluationLogic

        /**
         * Thresholds to reach the condition
         */
        thresholds: ThresholdInput[]
    }

    export interface DHLReceiveEventDataRequest {
        Data: string
    }

    /**
     * DeleteJourneyParams represents the parameters for the DeleteJourney API.
     */
    export interface DeleteJourneyParams {
        /**
         * Reference of the journey to delete
         */
        journeyReference: string
    }

    /**
     * DeleteMilestoneParams represents the parameters for the DeleteMilestone API.
     */
    export interface DeleteMilestoneParams {
        /**
         * Reference of the milestone to delete
         */
        milestoneReference: string
    }

    export interface DeleteWebhookParams {
        id: string
    }

    export interface DeleteWebhookSubscriptionForBringParams {
        subscriptionID: string
        apIkey: string
        apiUid: string
    }

    export interface DownloadShipmentsParams {
        /**
         * List of emails to which the download link will be sent
         */
        recipientEmails: string[]

        /**
         * List of columns to exclude from the CSV export
         */
        excludeColumns: string[]

        /**
         * Filter for the shipments
         */
        filter: models.ShipmentFilter
    }

    export interface DownloadTransporterMonthlyAverageDeliveryTimesParams {
        /**
         * List of emails to which the download link will be sent
         */
        recipientEmails: string[]

        /**
         * Filter for the delivery times
         */
        filter: models.DeliveryTimesFilter
    }

    export interface EvaluateJourneyEvent {
        /**
         * ID of the organization event type
         */
        typeId: string

        /**
         * Time of the event
         */
        timeOfEvent: string
    }

    export interface EvaluateJourneyTimestamps {
        /**
         * Time of the shipment initialization
         */
        initializedAt: string

        /**
         * When the shipment is promised to be delivered, earliest
         */
        promisedDeliveryTimeStart?: string

        /**
         * When the shipment is promised to be delivered, latest
         */
        promisedDeliveryTimeEnd?: string

        /**
         * The time to used for evaluation
         */
        currentTime: string
    }

    export interface ExposeMilestoneTriggerDataParams {
        milestoneTriggerData: models.MilestoneTriggerData
    }

    export interface GetAllExternalOrganizationsWithExternalMappingsResponse {
        organizations: string[]
    }

    export interface GetAllOrganizationsWithExternalMappingsResponse {
        organizations: string[]
    }

    export interface GetAllShipmentsParams {
        filters?: models.ShipmentFilter
        sort?: models.ShipmentSort[]
        page: number
        pageSize: number
    }

    export interface GetAllShipmentsResponse {
        shipments: models.TrackedShipmentWithOrder[]
        rowCount: number
    }

    export interface GetAllTrackingInfoForOrderParams {
        /**
         * The ID of the tracked order
         */
        trackedOrderId?: string

        /**
         * Any of the references of the order
         */
        orderReference?: string
    }

    export interface GetAllTrackingInfoForOrderResponse {
        /**
         * The core order data
         */
        order: models.TrackedOrder

        /**
         * If the origin is not known, this field will be null
         */
        origin?: datamodels.Location

        /**
         * If the destination is not known, this field will be null
         */
        destination?: datamodels.Location

        /**
         * All references of the order
         */
        references: models.TrackedOrderReference[]

        /**
         * All connections to the shipments
         */
        shipments?: ShipmentWithEventsAndSnapshots[]

        /**
         * The events that are connected to the order but not the shipment
         */
        events: models.Event[]
    }

    export interface GetAutoArchiveConfigurationResponse {
        configuration: models.AutoArchiveConfiguration
    }

    /**
     * GetAverageDeliveryTimesPerTransportMethodParams holds the parameters for filtering
     * average delivery times per transport method. TimeFilter is optional.
     */
    export interface GetAverageDeliveryTimesPerTransportMethodParams {
        filter?: models.DeliveryTimesFilter
    }

    /**
     * GetAverageDeliveryTimesPerTransportMethodResp is the response type for the
     * GetAverageDeliveryTimesPerTransportMethod API. It contains an array of
     * average delivery times.
     */
    export interface GetAverageDeliveryTimesPerTransportMethodResp {
        averageDeliveryTimes: datamodels.AverageDeliveryTimeByTransportMethod[]
    }

    /**
     * GetEventTypeMappingsParams is the input for the GetEventTypeMappings controller
     */
    export interface GetEventTypeMappingsParams {
        /**
         * ID of the organization
         */
        organizationId?: string

        /**
         * IDs of the organization event types
         */
        organizationEventTypeIds?: string[]

        /**
         * ID of the external organization
         */
        externalOrganizationId?: string
    }

    /**
     * GetEventTypeMappingsResponse is the output for the GetEventTypeMappings controller
     */
    export interface GetEventTypeMappingsResponse {
        /**
         * List of event type maps
         */
        maps: models.EventTypeMap[]
    }

    export interface GetEventsByShipmentIDParams {
        shipmentID: string
    }

    export interface GetEventsByShipmentIDResponse {
        events: models.Event[]
    }

    export interface GetEventsByShipmentTrackingReferenceParams {
        /**
         * The tracking reference provided by the transporter.
         */
        trackingReference: string

        /**
         * The transporter's ID
         */
        transporterId: string
    }

    export interface GetEventsByShipmentTrackingReferenceResponse {
        events: models.Event[]
    }

    export interface GetEventsParams {
        /**
         * Any filter to apply to the events
         */
        filter: models.EventFilter

        /**
         * Any sorting to apply to the events
         */
        sort: models.EventSort[]

        /**
         * The maximum number of events to return
         */
        limit: number

        /**
         * The offset to start from
         */
        offset: number
    }

    export interface GetEventsResponse {
        /**
         * The events that match the filter
         */
        events: models.Event[]
    }

    export interface GetExternalEventTypesParams {
        externalOrganizationId: string
        eventCodes?: string[]
    }

    export interface GetExternalEventTypesResponse {
        externalEventTypes: models.ExternalEventType[]
    }

    /**
     * GetJourneySnapshotsParams represents the parameters for the GetJourneySnapshots API.
     * It contains filters to apply to the journey snapshot search and pagination options.
     */
    export interface GetJourneySnapshotsParams {
        /**
         * Filters to apply to the journey snapshot search
         */
        journeyFilters: models.JourneySnapshotFilter

        /**
         * Pagination options
         */
        paginationOptions: models.PaginationOptions
    }

    /**
     * GetJourneySnapshotsResponse represents the response for the GetJourneySnapshots API.
     * It contains a list of journey snapshots fetched from the database.
     */
    export interface GetJourneySnapshotsResponse {
        /**
         * List of journey snapshots
         */
        journeys: models.JourneySnapshot[]

        /**
         * Total number of journey snapshots with the given filters
         */
        totalCount: number
    }

    /**
     * GetJourneysParams represents the parameters for the GetJourneys API.
     */
    export interface GetJourneysParams {
        /**
         * Filters to apply to the journey search
         */
        journeyFilters?: models.JourneyFilters

        /**
         * Pagination options
         */
        paginationOptions?: models.PaginationOptions
    }

    /**
     * GetJourneysResponse represents the response for the GetJourneys API.
     */
    export interface GetJourneysResponse {
        /**
         * List of journeys fetched from the database
         */
        journeys: models.Journey[]
    }

    export interface GetLatestReachedMilestoneCountsParams {
        journeyIDs: string[]
        from: string
        to: string
        /**
         * 'hour', 'day', 'week', 'month', 'year', defaults to hour
         */
        granularity: string

        /**
         * From IANA Time Zone database, e.g. Europe/Stockholm, defaults to UTC
         */
        timeZone: string
    }

    export interface GetLatestReachedMilestoneCountsResponse {
        timestamps: LatestReachedMilestoneTimestampCounts[]
    }

    /**
     * GetMilestonesParams represents the parameters for the GetMilestones API.
     */
    export interface GetMilestonesParams {
        /**
         * Filters to apply to the milestone search
         */
        milestoneFilters?: models.MilestoneFilters

        /**
         * Pagination options
         */
        paginationOptions?: models.PaginationOptions
    }

    /**
     * GetMilestonesResponse represents the response for the GetMilestones API.
     */
    export interface GetMilestonesResponse {
        /**
         * List of milestones fetched from the database
         */
        milestones: models.Milestone[]
    }

    /**
     * GetMissingEventTypeMappingsResponse is the response from GetMissingEventTypeMappings
     */
    export interface GetMissingEventTypeMappingsResponse {
        /**
         * Map of organization ID to missing mappings
         */
        missingMappings: { [key: string]: models.MissingEventTypeMap[] }
    }

    /**
     * GetMonthlyDeliveryTimeAvgPerTransportMethodParams holds the parameters for filtering
     * average delivery times per transport method. Filter is optional.
     */
    export interface GetMonthlyDeliveryTimeAvgPerTransportMethodParams {
        text: string
        filter?: models.DeliveryTimesFilter
    }

    /**
     * GetMonthlyDeliveryTimeAvgPerTransportMethodResp is the response type for the
     * GetMonthlyDeliveryTimeAvgPerTransportMethod API. It contains an array of
     * average delivery times.
     */
    export interface GetMonthlyDeliveryTimeAvgPerTransportMethodResp {
        averageDeliveryTimes: datamodels.AverageDeliveryTimeByTransportMethod[]
    }

    export interface GetOrderInformationParams {
        /**
         * Any of the references of the order
         */
        orderReference: string
    }

    export interface GetOrderInformationResponse {
        /**
         * The core order data
         */
        order: models.TrackedOrder

        /**
         * If the origin is not known, this field will be null
         */
        origin?: datamodels.Location

        /**
         * If the destination is not known, this field will be null
         */
        destination?: datamodels.Location

        /**
         * If the selected pickup organization location is not known, this field will be null
         */
        selectedPickupOrganizationLocation?: datamodels.OrganizationLocation

        /**
         * All references of the order
         */
        references: models.TrackedOrderReference[]

        /**
         * All connections to the shipments
         */
        connections: models.OrderShipmentConnection[]
    }

    export interface GetOrganizationEventsParams {
        omitMessages: boolean
        onlyActiveMessages: boolean
        organizationEventFilters?: models.OrganizationEventTypeFilter
        organizationEventSorting?: models.OrganizationEventTypeSort[]
        page: number
        pageSize: number
    }

    export interface GetOrganizationEventsResponse {
        organizationEventTypes: models.OrganizationEventType[]
        rowCount: number
    }

    export interface GetShipmentStatusCountHistoryParams {
        from: string
        to: string
        /**
         * 'hour', 'day', 'week', 'month', 'year', defaults to hour
         */
        granularity: string

        /**
         * From IANA Time Zone database, e.g. Europe/Stockholm, defaults to UTC
         */
        timeZone: string
    }

    export interface GetShipmentStatusCountHistoryResponse {
        counts: models.ShipmentStatusCount[]
    }

    export interface GetShipmentStatusCountResponse {
        okCount: number
        delayCount: number
        problemCount: number
        doneCount: number
    }

    export interface GetTrackedParcelsParams {
        filter?: models.ParcelFilter
        sort?: models.ParcelSort[]
        page?: number
        pageSize?: number
    }

    export interface GetTrackedParcelsResponse {
        parcels: models.TrackedParcel[]
    }

    export interface GetTrackedShipmentAndInfoByIDParams {
        trackingID: string
    }

    export interface GetTrackedShipmentAndInfoResponse {
        trackedShipment: models.TrackedShipment
        origin?: datamodels.Location
        destination?: datamodels.Location
        info: models.TrackingStatusInformation
        /**
         * All events for the tracked shipment
         */
        events: models.Event[]

        parcels: GetTrackedShipmentAndInfoResponseParcel[]
    }

    export interface GetTrackedShipmentAndInfoResponseParcel {
        trackedParcel: models.TrackedParcel
        /**
         * All events for the tracked parcel
         */
        events: models.Event[]
    }

    export interface GetTrackedShipmentsByExternalReferenceParams {
        externalReference: string
    }

    export interface GetTrackedShipmentsByExternalReferenceResponse {
        trackedShipments: models.TrackedShipment[]
    }

    export interface GetTrackedShipmentsCountByTransporterIDParams {
        transporterID: string
        start: string
        end: string
        /**
         * The granularity of the returned data. Must be one of: microseconds, milliseconds, second, minute, hour, day, week, month, quarter, year, decade, century, millennium
         */
        granularity: postgres.DateTruncGranularity

        /**
         * If not provided, will be set to UTC. Must be a valid IANA time zone.
         */
        timeZone?: string
    }

    export interface GetTrackedShipmentsCountByTransporterIDResponse {
        counts: models.TrackedShipmentCountByDate[]
    }

    export interface GetTrackedShipmentsPerHourParams {
        from: string
        to: string
    }

    export interface GetTrackedShipmentsPerHourResponse {
        trackedShipmentsPerHour: repository.TrackedShipmentsPerHour[]
    }

    export interface GetTrackingReferenceTypesResponse {
        trackingReferenceTypes: models.TrackingReferenceTypeConfiguration[]
    }

    export interface GetWebhooksResponse {
        webhooks: models.Webhook[]
    }

    export interface GetWidgetURLParams {
        /**
         * The order reference for which to get the widget URL.
         * The input will be trimmed of leading and trailing whitespace.
         */
        orderReference: string

        /**
         * The theme to use for the widget, can either be "light", "dark" or "system".
         * System means that the widget will use `prefers-color-scheme` to determine the theme.
         * If not provided, the widget will use the theme of the user's browser.
         * 
         * The theme can also be changed with the `window.SkrymTrackingWidget.setTheme` function available in the helper script.
         */
        theme?: string

        /**
         * The language for the widget
         * Can be either "en", "sv", "no" or "fi".
         * If not provided, the widget will use the language of the user's browser via the `accept-language` header.
         * 
         * The language can also be changed with the `window.SkrymTrackingWidget.setLanguage` function available in the helper script.
         */
        language?: string

        /**
         * Whether the user is authenticated or not.
         * If not provided or set to false, the widget will not display any user-specific information for legal reasons.
         */
        userIsAuthenticated?: boolean
    }

    export interface GetWidgetURLResponse {
        /**
         * The URL to the widget for the given order reference, including an authentication token
         */
        url: string
    }

    export interface InitializeOrderParams {
        /**
         * Optional ID of the order. If not provided, a new ID will be generated.
         */
        id?: string

        /**
         * Any references that can be used to identify the order. Must be unique for your organization.
         */
        references: string[]

        /**
         * Optional identifier for the origin location of the shipment. This allows Skrym to use the locations when presenting the data. If valid, it will override the origin zip and country codes. If empty, Skrym will try to use origin zip and country code to match the origin location.
         */
        originLocationIdentifier?: string

        /**
         * Optional zip code the order is being shipped from. If provided, the originCountryCode must also be provided.
         */
        originZipCode?: string

        /**
         * Optional two-letter Alpha 2 country code the order is being shipped from. If provided, the originZipCode must also be provided.
         */
        originCountryCode?: string

        /**
         * Optional zip code the order is being shipped to. If provided, the destinationCountryCode must also be provided.
         */
        destinationZipCode?: string

        /**
         * Optional two-letter Alpha 2 country code the order is being shipped to. If provided, the destinationZipCode must also be provided.
         */
        destinationCountryCode?: string

        /**
         * Optional: The start the promised delivery time window, as promised by the retailer. If not provided, the order's promised delivery time will be used.
         */
        promisedDeliveryTimeStart?: string

        /**
         * Optional: The end the promised delivery time window, as promised by the retailer. If not provided, the order's promised delivery time will be used. If you only have a latest delivery time, you can leave the start time empty.
         */
        promisedDeliveryTimeEnd?: string

        /**
         * Optional: The name or alias of the transporter that will be used to ship the order.
         */
        selectedTransporter?: string

        /**
         * Optional: The name or alias of the transport method that will be used to ship the order.
         */
        selectedTransportMethod?: string

        /**
         * Optional: The identifier of the pickup location to be used for the order. The transporter must be provided if the pickup location is provided. If it's a home delivery, leave this field empty.
         */
        selectedPickupLocationIdentifier?: string

        /**
         * Optional references that can be used to apply journeys to the shipments.
         */
        journeyReferences?: string[]

        /**
         * Additional metadata about the order (e.g. the order's contents)
         */
        metadata?: JSONValue
    }

    export interface InitializeTrackedParcel {
        trackingReference: string
        /**
         * A reference for the customer the order that this tracked shipment belongs to
         */
        externalReference?: string

        /**
         * Optional: Metadata for the parcel (e.g. the parcel's contents)
         */
        metadata?: JSONValue
    }

    /**
     * InitializeTrackedShipment represents the details required to initialize a tracked shipment.
     * It contains the necessary information about the transporter, transport method,
     * tracking reference, creation time, and origin and destination details.
     */
    export interface InitializeTrackedShipment {
        transporterId: string
        transportMethodId: string
        trackingReference?: string
        /**
         * A reference for the customer the order that this tracked shipment belongs to, often a order id
         */
        externalReference?: string

        /**
         * If not provided, will be set to current time
         */
        createdAt?: string

        originZip?: string
        /**
         * Has to be in alpha2 format i.e. "SE"
         */
        originCountry?: string

        destinationZip?: string
        /**
         * Has to be in alpha2 format i.e. "SE"
         */
        destinationCountry?: string

        /**
         * Optional: Latest acceptable time for on-time shipment delivery to the recipient.
         */
        promisedDeliveryTime?: string

        /**
         * Optional identifier to indicate which location it starts at. Will be used to create an initialization event.
         */
        originLocationIdentifier?: string

        /**
         * Toggling of whether or not to add an origin event by default (will only happen if there are no events yet).
         */
        addOriginEvent?: boolean

        parcels?: InitializeTrackedParcel[]
        /**
         * Optional: The journey reference that this shipment is part of.
         */
        journeyReference?: string

        /**
         * Optional: Metadata for the shipment
         */
        metadata?: JSONValue
    }

    export interface InsertWebhookParams {
        /**
         * optional
         */
        id?: string

        url: string
        token: string
        status: boolean
        name: string
        description: string
        /**
         * optional
         */
        createdBy?: string
    }

    /**
     * JourneyMilestonesInput represents the input data for a milestone in a journey.
     */
    export interface JourneyMilestonesInput {
        /**
         * Reference of the milestone
         */
        milestoneReference: string

        /**
         * Icon of the milestone to be displayed on scope (optional)
         */
        icon?: string

        /**
         * Color of the milestone to be displayed on scope (optional); hexcode
         */
        color?: string

        /**
         * The order of the milestone within the journey. Must be a positive integer for milestones that are part of a sequence, or 0 if the milestone is not associated with a specific sequence.
         */
        sequence?: number

        /**
         * The order to display the milestone in within its sequence. Should be a positive integer if the milestone has a sequence, or 0 if it does not. This field must be set if a Sequence is set.
         */
        displayOrdering?: number

        /**
         * Whether the milestone is the final milestone in the journey
         */
        final?: boolean

        /**
         * List of triggers that should be triggered when this milestone is reached
         */
        triggers?: TriggerDataInput[]
    }

    export interface LatestReachedMilestoneTimestampCounts {
        timestamp: string
        counts: models.LatestReachedMilestoneCount[]
    }

    export interface MockEvaluateJourneyParams {
        /**
         * Journey to evaluate
         */
        journey: models.Journey

        /**
         * Timestamps for evaluation
         */
        timestamps: EvaluateJourneyTimestamps

        /**
         * Properties to evaluate the property-based thresholds against
         */
        properties: models.PropertyThresholdInput

        /**
         * Events to evaluate the event-based thresholds against
         */
        events: EvaluateJourneyEvent[]
    }

    export interface MockEvaluateJourneyResponse {
        /**
         * The snapshot of the journey after evaluation
         */
        journeySnapshot: models.JourneySnapshot

        /**
         * Milestones to show in the UI, in the order they should be displayed
         */
        milestonesToShow: models.MilestoneSnapshot[]
    }

    export interface MockMilestoneCompletedEventParams {
        journeyId: string
        journeyReference: string
        milestoneId: string
        milestoneReference: string
        webhookId: string
        triggerType: models.TriggerType
    }

    /**
     * OnboardOrganizationForTrackingParams contains the organization ID to onboard
     */
    export interface OnboardOrganizationForTrackingParams {
        /**
         * The organization to onboard
         */
        organizationID: string
    }

    export interface ParcelToAdd {
        /**
         * Your reference of the parcel. Must be unique for the shipment. This can be used if you want to update the parcel later.
         */
        reference?: string

        /**
         * The tracking reference provided by the transporter for the Parcel. This can be used to update the parcel later.
         */
        trackingReference: string

        /**
         * The dimensions of the parcel in millimeters.
         */
        dimensions?: number[]

        /**
         * The weight of the parcel in grams.
         */
        weight?: number

        /**
         * Additional metadata about the parcel (e.g. the parcel's contents)
         */
        metadata?: JSONValue
    }

    export interface PollShipmentsParams {
        shipmentIDs: string[]
    }

    export interface PollShipmentsResponse {
        successfulIDs: string[]
        failedIDs: string[]
    }

    /**
     * ReceiveBringEventParams follows  the Bring webhook format found at:
     * https://developer.bring.com/api/event-cast/
     */
    export interface ReceiveBringEventParams {
        TrackingKey: string
        Application: string
        CorrelationNum: string
        status: string
        id: string
        shipment: string
        package: string
        created: string
        pushed: string
    }

    export interface SendMockWebhookParams {
        WebhookID: string
    }

    /**
     * SetShipmentStatusParams contains a Skrym ID related to the tracked shipment
     */
    export interface SetShipmentStatusParams {
        trackedShipmentID: string
        status: models.Status
    }

    export interface ShipmentToAdd {
        /**
         * Your reference of the shipment. Must be unique for your organization. This is required if no tracking reference is provided.
         * If you have configured to have the reference be a parcel reference but not provided an external reference for the parcel, this will be used as the parcel reference as well.
         */
        reference?: string

        /**
         * The name or an alias of the transporter used for the shipment.
         */
        transporter: string

        /**
         * The name or an alias of the transport method used for the shipment.
         */
        transportMethod?: string

        /**
         * The tracking reference provided by the transporter. This is optional and can be added later. If added Skrym will also populate a "Booked" event to the timeline
         */
        trackingReference?: string

        /**
         * Optional about the parcels in the shipment. Skrym will try to infer any parcels from the transporter if not provided. When updating a shipment, you can add new parcels or update existing ones, but not remove them.
         */
        parcels?: ParcelToAdd[]

        /**
         * Optional identifier for the origin location of the shipment. This allows Skrym to use the locations when presenting the data.
         */
        originLocationIdentifier?: string

        /**
         * Optional zip code the shipment is being shipped from. If provided, the originCountryCode must also be provided. If not provided, the origin will be set to the location set when initializing the order. If valid, it will override the origin zip and country codes. If empty, Skrym will try to use origin zip and country code to match the origin location.
         */
        originZipCode?: string

        /**
         * Optional two-letter Alpha 2 country code the order is being shipped from. If provided, the originZipCode must also be provided. If not provided, the origin will be set to the location set when initializing the order.
         */
        originCountryCode?: string

        /**
         * Optional zip code the order is being shipped to. If provided, the destinationCountryCode must also be provided. If not provided, the destination will be set to the location set when initializing the order.
         */
        destinationZipCode?: string

        /**
         * Optional two-letter Alpha 2 country code the order is being shipped to. If provided, the destinationZipCode must also be provided. If not provided, the destination will be set to the location set when initializing the order.
         */
        destinationCountryCode?: string

        /**
         * Optional: The start of the expected delivery time window, as estimated by the transporter
         */
        expectedDeliverytimeStart?: string

        /**
         * Optional: The end of the expected delivery time window, as estimated by the transporter
         */
        expectedDeliverytimeEnd?: string

        /**
         * Optional: The start the promised delivery time window, as promised by the retailer. If not provided, the order's promised delivery time will be used.
         */
        promisedDeliveryTimeStart?: string

        /**
         * Optional: The end the promised delivery time window, as promised by the retailer. If not provided, the order's promised delivery time will be used. If you only have a latest delivery time, you can leave the start time empty.
         */
        promisedDeliveryTimeEnd?: string

        /**
         * Additional metadata about the shipment
         */
        metadata?: JSONValue
    }

    export interface ShipmentWithEventsAndSnapshots {
        /**
         * The core shipment data
         */
        shipment?: models.TrackedShipment

        /**
         * The parcels that are connected to the shipment
         */
        parcels?: models.TrackedParcel[]

        /**
         * The events that are connected to the shipment
         */
        events?: models.Event[]

        /**
         * The snapshots that are connected to the shipment
         */
        snapshots: models.JourneySnapshot[]

        /**
         * The start of the promised delivery time window
         */
        promisedDeliveryTimeStart?: string

        /**
         * The end of the promised delivery time window
         */
        promisedDeliveryTimeEnd?: string
    }

    /**
     * ThresholdEventInput represents the input data for an event-based threshold.
     */
    export interface ThresholdEventInput {
        /**
         * Comparator for the event threshold; Allowed values: EXIST, NOT_EXIST
         */
        eventComparator: models.TEventComparator

        /**
         * ID of the event type
         */
        eventTypeId: string

        /**
         * ID of the event map
         */
        eventMapId?: string
    }

    /**
     * ThresholdInput represents the input data for a threshold to reach a milestone.
     */
    export interface ThresholdInput {
        /**
         * The reference of the threshold
         */
        reference: string

        /**
         * Description of the threshold
         */
        description: string

        /**
         * Type of the threshold; Event based or Time based. Allowed values: EVENT, TIME
         */
        type: models.TType

        /**
         * Whether the threshold is active
         */
        active: boolean

        /**
         * Event info for the threshold, nil if the threshold is not event-based
         */
        event?: ThresholdEventInput

        /**
         * Time info for the threshold, nil if the threshold is not time-based
         */
        time?: ThresholdTimeInput

        /**
         * Property info for the threshold, nil if the threshold is not property-based
         */
        property?: ThresholdPropertyInput

        /**
         * Milestone info for the threshold, nil if the threshold is not milestone-based
         */
        milestone?: ThresholdMilestoneInput
    }

    export interface ThresholdMilestoneInput {
        /**
         * Comparator for the milestone threshold; Allowed values: COMPLETED, NOT_COMPLETED
         */
        milestoneComparator: models.TMilestoneComparator

        /**
         * The ID of the milestone to depend on
         */
        milestoneId: string
    }

    /**
     * ThresholdPropertyInput represents the input data for a property-based threshold.
     */
    export interface ThresholdPropertyInput {
        /**
         * Name of the property
         */
        propertyName: models.TPropertyName

        /**
         * Value of the property
         */
        propertyValue: string
    }

    /**
     * ThresholdTimeInput represents the input data for a time-based thresholds.
     */
    export interface ThresholdTimeInput {
        /**
         * Comparator for the time threshold; Allowed values: BEFORE, AFTER
         */
        timeComparator: models.TTimeComparator

        /**
         * Type of the time threshold; Allowed values: SHIPMENT_INITIALIZED, PROMISED_DELIVERY, LAST_EVENT, LAST_MILESTONE
         */
        timeType: models.TTimeType

        /**
         * Value of the time threshold
         */
        timeValue: number

        /**
         * Unit of the time value; Allowed values HOUR, DAY, WEEK
         */
        timeValueUnit: utils.SkrymTimeUnit

        /**
         * Adjuster of the time threshold (if the duration should be added or subtracted); Allowed Values: EARLIER, LATER, EQUAL
         */
        timeAdjuster: models.AdjType
    }

    export interface TriggerDataInput {
        /**
         * ID of the webhook that should be triggered once this journey milestone is reached
         */
        webhookId?: string

        /**
         * Whether the trigger is active
         */
        active: boolean
    }

    export interface UpdateShipmentParams {
        /**
         * The reference of the shipment to update
         */
        reference: string

        /**
         * The name or alias of the transporter used for the shipment.
         */
        transporter?: string

        /**
         * The name or an alias of the transport method used for the shipment.
         */
        transportMethod?: string

        /**
         * The tracking reference provided by the transporter.
         */
        trackingReference?: string

        /**
         * Optional info about the parcels in the shipment. Skrym will try to infer any parcels from the transporter if not provided. Will update exsiting parcels or create new ones, but will not remove any parcels.
         */
        parcels?: ParcelToAdd[]

        /**
         * Optional identifier for the origin location of the shipment. This allows Skrym to use the locations when presenting the data.
         */
        originLocationIdentifier?: string

        /**
         * Optional zip code the shipment is being shipped from. If provided, the originCountryCode must also be provided. If not provided, the origin will be set to the location set when initializing the order. If valid, it will override the origin zip and country codes. If empty, Skrym will try to use origin zip and country code to match the origin location.
         */
        originZipCode?: string

        /**
         * Optional two-letter Alpha 2 country code the order is being shipped from. If provided, the originZipCode must also be provided. If not provided, the origin will be set to the location set when initializing the order.
         */
        originCountryCode?: string

        /**
         * Optional zip code the order is being shipped to. If provided, the destinationCountryCode must also be provided. If not provided, the destination will be set to the location set when initializing the order.
         */
        destinationZipCode?: string

        /**
         * Optional two-letter Alpha 2 country code the order is being shipped to. If provided, the destinationZipCode must also be provided. If not provided, the destination will be set to the location set when initializing the order.
         */
        destinationCountryCode?: string

        /**
         * Optional: The start of the expected delivery time window, as estimated by the transporter
         */
        expectedDeliverytimeStart?: string

        /**
         * Optional: The end of the expected delivery time window, as estimated by the transporter
         */
        expectedDeliverytimeEnd?: string

        /**
         * Additional metadata about the shipment
         */
        metadata?: JSONValue
    }

    export interface UpdateWebhookParams {
        id: string
        url: string
        token: string
        status: boolean
        name: string
        description?: string
        /**
         * optional
         */
        updatedBy?: string
    }

    export interface UpsertAutoArchiveConfigurationParams {
        enabled: boolean
        archiveAfterDays: number
    }

    /**
     * UpsertConditionsForMilestoneParams represents the parameters needed for the
     * UpsertConditionsForMilestone API.
     */
    export interface UpsertConditionsForMilestoneParams {
        /**
         * Reference of the milestone
         */
        milestoneReference: string

        /**
         * Conditions required to reach the milestone
         */
        conditions: ConditionInput[]
    }

    export interface UpsertEventParams {
        /**
         * Optional unique key for the event. If not provided, a random key will be generated. If the key already exists, the endpoint will update that event with the new data.
         */
        key?: string

        /**
         * Your own reference for the order.
         */
        orderReference: string

        /**
         * The tracking reference provided by the transporter. Can be empty at first as long as a valid order reference is provided.
         */
        trackingReference: string

        /**
         * Your own identifier for the event type. Can be used to identify the event type in the system. If provided, status, message and type will be ignored. This will replace the EventType in the future.
         */
        eventTypeIdentifier?: string

        /**
         * Optional timestamp that can be used for retroactively adding events. Defaults to current time.
         */
        timestamp: string

        /**
         * The type of event. Can be any of arrival, departure, notification, delay, delivered or error.
         */
        type?: models.EventType

        /**
         * Optional argument that can be 'outbound' or 'inbound'. Defaults to outbound if nothing is specified.
         */
        direction?: models.Direction

        /**
         * Optional message describing the shipment
         */
        message: models.Message

        /**
         * The type of checkpoint for the event.
         */
        checkpointType?: models.CheckpointType

        /**
         * Optional location of the event
         */
        location: datamodels.SimplifiedEventLocation

        /**
         * Will update the shipment status if provided. Use with caution.
         */
        status?: models.Status

        /**
         * Any optional metadata you wish to add to the event
         */
        metadata?: JSONValue

        /**
         * Optional ID indicating which user added an event (in the case of a manually added event)
         */
        createdByUserId?: string

        /**
         * Optional ID indicating which organization created the event. Defaults to retailer ID for current context.
         */
        createdByOrgId?: string
    }

    /**
     * Responds with key of the event in case the user wants to store it for later updates
     */
    export interface UpsertEventResponse {
        /**
         * The key of the event. Can be provided explicitly in the request, and is otherwise autogenerated.
         */
        key: string
    }

    export interface UpsertEventTypeMap {
        mapId: string
        externalEventCode: string
        externalOrganizationId: string
        direction: models.Direction
        /**
         * If not provided, the map will be soft-deleted
         */
        organizationEventTypeId?: string

        messages: UpsertEventTypeMessage[]
    }

    /**
     * UpsertEventTypeMapsParams is the input for the InsertEventTypeMaps controller
     */
    export interface UpsertEventTypeMapsParams {
        /**
         * List of event type maps
         */
        eventTypeMaps: UpsertEventTypeMap[]
    }

    export interface UpsertEventTypeMessage {
        language: string
        message: string
    }

    /**
     * UpsertExternalEventTypesParams is the input for the UpsertExternalEventTypes controller
     */
    export interface UpsertExternalEventTypesParams {
        /**
         * List of external event types
         */
        eventTypes: models.ExternalEventType[]
    }

    /**
     * UpsertJourneysInput represents the input data required to upsert a journey.
     */
    export interface UpsertJourneysInput {
        /**
         * ID of the journey. If not provided, a new ID will be generated
         */
        id?: string

        /**
         * Name of the journey
         */
        name: string

        /**
         * Unique reference identifying the journey
         */
        reference: string

        /**
         * Description of the journey
         */
        description: string

        /**
         * Whether the journey is active
         */
        active: boolean

        /**
         * Whether the journey is the default journey
         */
        default: boolean

        /**
         * Whether the journey is displayed on the widget
         */
        onWidget?: boolean
    }

    /**
     * UpsertJourneysParams represents the parameters needed for the
     * UpsertJourneys API.
     */
    export interface UpsertJourneysParams {
        /**
         * Journeys to be upserted
         */
        journeys: UpsertJourneysInput[]
    }

    /**
     * UpsertMilestonesForJourneyParams represents the parameters needed for the
     * UpsertMilestonesForJourney API.
     */
    export interface UpsertMilestonesForJourneyParams {
        /**
         * Reference of the journey
         */
        journeyReference: string

        /**
         * List of milestones with their sequences
         */
        journeyMilestones: JourneyMilestonesInput[]
    }

    /**
     * UpsertMilestonesInput represents the input data required to upsert a milestone.
     */
    export interface UpsertMilestonesInput {
        /**
         * ID of the milestone
         */
        id: string

        /**
         * Unique reference identifying the milestone
         */
        reference: string

        /**
         * Translations of the milestone name and description, the key is the language code (ISO 639-1)
         */
        translations: { [key: string]: models.MilestoneTranslation }

        /**
         * ANY or ALL. Decides if any of the conditions should be met, or all of them
         */
        evaluationLogic: models.EvaluationLogic

        /**
         * Icon of the milestone to be displayed on scope (optional)
         */
        icon: string

        /**
         * Color of the milestone to be displayed on scope (optional); hexcode
         */
        color: string

        /**
         * Whether the milestone is active
         */
        active: boolean
    }

    /**
     * UpsertMilestonesParams represents the parameters needed for the
     * UpsertMilestones API.
     */
    export interface UpsertMilestonesParams {
        /**
         * Milestones to be upserted
         */
        milestones: UpsertMilestonesInput[]
    }

    /**
     * UpsertOrganizationEventTypesParams is the input for the UpsertOrganizationEventTypes controller
     */
    export interface UpsertOrganizationEventTypesParams {
        /**
         * List of organization event types
         */
        eventTypes: models.OrganizationEventType[]
    }

    /**
     * UpsertSkrymEventTypesParams is the input for the UpsertSkrymEventTypes controller
     */
    export interface UpsertSkrymEventTypesParams {
        /**
         * List of Skrym event types
         */
        eventTypes: models.SkrymEventTypeDAO[]
    }

    export interface UpsertTrackingReferenceConfiguration {
        transporterID: string
        trackingReferenceType: models.TrackingReferenceType
    }

    export interface UpsertTrackingReferenceTypeConfigurationParams {
        trackingReferenceTypes: UpsertTrackingReferenceConfiguration[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AddOrderReferences = this.AddOrderReferences.bind(this)
            this.AddShipmentsToOrder = this.AddShipmentsToOrder.bind(this)
            this.AirmeeTrackingWebhook = this.AirmeeTrackingWebhook.bind(this)
            this.BudbeeTrackingWebhook = this.BudbeeTrackingWebhook.bind(this)
            this.CityMailWebhook = this.CityMailWebhook.bind(this)
            this.DHLReceiveEventData = this.DHLReceiveEventData.bind(this)
            this.DeleteJourney = this.DeleteJourney.bind(this)
            this.DeleteMilestone = this.DeleteMilestone.bind(this)
            this.DeleteWebhook = this.DeleteWebhook.bind(this)
            this.DeleteWebhookSubscriptionForBring = this.DeleteWebhookSubscriptionForBring.bind(this)
            this.DownloadShipments = this.DownloadShipments.bind(this)
            this.DownloadTransporterMonthlyAverageDeliveryTimes = this.DownloadTransporterMonthlyAverageDeliveryTimes.bind(this)
            this.ExposeMilestoneTriggerData = this.ExposeMilestoneTriggerData.bind(this)
            this.GetAllExternalOrganizationsWithExternalMappings = this.GetAllExternalOrganizationsWithExternalMappings.bind(this)
            this.GetAllOrganizationsWithExternalMappings = this.GetAllOrganizationsWithExternalMappings.bind(this)
            this.GetAllShipments = this.GetAllShipments.bind(this)
            this.GetAllTrackingInfoForOrder = this.GetAllTrackingInfoForOrder.bind(this)
            this.GetAutoArchiveConfiguration = this.GetAutoArchiveConfiguration.bind(this)
            this.GetAverageDeliveryTimesPerTransportMethod = this.GetAverageDeliveryTimesPerTransportMethod.bind(this)
            this.GetEventTypeMappings = this.GetEventTypeMappings.bind(this)
            this.GetEvents = this.GetEvents.bind(this)
            this.GetEventsByShipmentID = this.GetEventsByShipmentID.bind(this)
            this.GetEventsByShipmentTrackingReference = this.GetEventsByShipmentTrackingReference.bind(this)
            this.GetExternalEventTypes = this.GetExternalEventTypes.bind(this)
            this.GetJourneySnapshots = this.GetJourneySnapshots.bind(this)
            this.GetJourneys = this.GetJourneys.bind(this)
            this.GetLatestReachedMilestoneCounts = this.GetLatestReachedMilestoneCounts.bind(this)
            this.GetMilestones = this.GetMilestones.bind(this)
            this.GetMissingEventTypeMappings = this.GetMissingEventTypeMappings.bind(this)
            this.GetMonthlyDeliveryTimeAvgPerTransportMethod = this.GetMonthlyDeliveryTimeAvgPerTransportMethod.bind(this)
            this.GetOrderInformation = this.GetOrderInformation.bind(this)
            this.GetOrganizationEvents = this.GetOrganizationEvents.bind(this)
            this.GetShipmentStatusCount = this.GetShipmentStatusCount.bind(this)
            this.GetShipmentStatusCountHistory = this.GetShipmentStatusCountHistory.bind(this)
            this.GetTrackedParcels = this.GetTrackedParcels.bind(this)
            this.GetTrackedShipmentAndInfoByID = this.GetTrackedShipmentAndInfoByID.bind(this)
            this.GetTrackedShipmentsByExternalReference = this.GetTrackedShipmentsByExternalReference.bind(this)
            this.GetTrackedShipmentsCountByTransporterID = this.GetTrackedShipmentsCountByTransporterID.bind(this)
            this.GetTrackedShipmentsPerHour = this.GetTrackedShipmentsPerHour.bind(this)
            this.GetTrackingReferenceTypeConfigurations = this.GetTrackingReferenceTypeConfigurations.bind(this)
            this.GetWebhooks = this.GetWebhooks.bind(this)
            this.GetWidgetURL = this.GetWidgetURL.bind(this)
            this.InitializeOrder = this.InitializeOrder.bind(this)
            this.InitializeTracking = this.InitializeTracking.bind(this)
            this.InsertWebhook = this.InsertWebhook.bind(this)
            this.InstaboxTrackingWebhook = this.InstaboxTrackingWebhook.bind(this)
            this.MockEvaluateJourney = this.MockEvaluateJourney.bind(this)
            this.MockMilestoneCompletedEvent = this.MockMilestoneCompletedEvent.bind(this)
            this.OnboardOrganizationForTracking = this.OnboardOrganizationForTracking.bind(this)
            this.PollShipments = this.PollShipments.bind(this)
            this.ReceiveBringEvent = this.ReceiveBringEvent.bind(this)
            this.ReceiveICATrackingEvent = this.ReceiveICATrackingEvent.bind(this)
            this.RefreshEventTypeMappings = this.RefreshEventTypeMappings.bind(this)
            this.SendMockWebhook = this.SendMockWebhook.bind(this)
            this.SetShipmentStatus = this.SetShipmentStatus.bind(this)
            this.UpdateShipment = this.UpdateShipment.bind(this)
            this.UpdateWebhook = this.UpdateWebhook.bind(this)
            this.UpsertAutoArchiveConfiguration = this.UpsertAutoArchiveConfiguration.bind(this)
            this.UpsertConditionsForMilestone = this.UpsertConditionsForMilestone.bind(this)
            this.UpsertEvent = this.UpsertEvent.bind(this)
            this.UpsertEventTypeMaps = this.UpsertEventTypeMaps.bind(this)
            this.UpsertExternalEventTypes = this.UpsertExternalEventTypes.bind(this)
            this.UpsertJourneys = this.UpsertJourneys.bind(this)
            this.UpsertMilestones = this.UpsertMilestones.bind(this)
            this.UpsertMilestonesForJourney = this.UpsertMilestonesForJourney.bind(this)
            this.UpsertOrganizationEventTypes = this.UpsertOrganizationEventTypes.bind(this)
            this.UpsertSkrymEventTypes = this.UpsertSkrymEventTypes.bind(this)
            this.UpsertTrackingReferenceTypeConfiguration = this.UpsertTrackingReferenceTypeConfiguration.bind(this)
        }

        /**
         * Add more references to an order
         * 
         * This endpoint allows you to add more references to an order. The references can be used to attach shipments or events to the order.
         * It will not fail if the reference already exists for the order referenced by `CurrentReference`. However, it will fail if one of the references exist for another order.
         */
        public async AddOrderReferences(params: AddOrderReferencesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.AddOrderReferences`, JSON.stringify(params))
        }

        /**
         * Add one or more shipments to an order.
         * 
         * The order must have been initialized before adding shipments.
         * The endpoint is idempotent, meaning that it's ok to add the same shipment to an order multiple times, but it will only be added once.
         */
        public async AddShipmentsToOrder(params: AddShipmentsToOrderParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.AddShipmentsToOrder`, JSON.stringify(params))
        }

        /**
         * AirmeeTrackingWebhook receives tracking webhook from Airmee.
         */
        public async AirmeeTrackingWebhook(params: models.AirmeeTrackingWebhookPayload): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking/airmee/webhook`, JSON.stringify(params))
        }

        public async BudbeeTrackingWebhook(params: BudbeeTrackingWebhookRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.BudbeeTrackingWebhook`, JSON.stringify(params))
        }

        public async CityMailWebhook(params: CityMailWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.CityMailWebhook`, JSON.stringify(params))
        }

        public async DHLReceiveEventData(params: DHLReceiveEventDataRequest): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.DHLReceiveEventData`, JSON.stringify(params))
        }

        /**
         * DeleteJourney deletes a journey and its associated milestones and thresholds.
         */
        public async DeleteJourney(params: DeleteJourneyParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.DeleteJourney`, JSON.stringify(params))
        }

        /**
         * DeleteMilestone deletes a milestone, its associated thresholds and any usage it has in journeys.
         */
        public async DeleteMilestone(params: DeleteMilestoneParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.DeleteMilestone`, JSON.stringify(params))
        }

        public async DeleteWebhook(params: DeleteWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.DeleteWebhook`, JSON.stringify(params))
        }

        public async DeleteWebhookSubscriptionForBring(params: DeleteWebhookSubscriptionForBringParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.DeleteWebhookSubscriptionForBring`, JSON.stringify(params))
        }

        /**
         * Uploads a CSV file of all shipments to google cloud bucket and sends a download link to user who triggered it
         * 
         * This endpoint may be improved by adding an optimistic return and creating a Pub Sub event to handle the operations.
         * Currently, the fetching of the data means that the user has to wait for confirmation for a while when exporting larget datasets.
         */
        public async DownloadShipments(params: DownloadShipmentsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.DownloadShipments`, JSON.stringify(params))
        }

        public async DownloadTransporterMonthlyAverageDeliveryTimes(params: DownloadTransporterMonthlyAverageDeliveryTimesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.DownloadTransporterMonthlyAverageDeliveryTimes`, JSON.stringify(params))
        }

        /**
         * This is a dummy endpoint that's just used to expose `models.MilestoneTriggerData` so that it's available for usage in docs etc
         */
        public async ExposeMilestoneTriggerData(params: ExposeMilestoneTriggerDataParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.ExposeMilestoneTriggerData`, JSON.stringify(params))
        }

        public async GetAllExternalOrganizationsWithExternalMappings(): Promise<GetAllExternalOrganizationsWithExternalMappingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetAllExternalOrganizationsWithExternalMappings`)
            return await resp.json() as GetAllExternalOrganizationsWithExternalMappingsResponse
        }

        public async GetAllOrganizationsWithExternalMappings(): Promise<GetAllOrganizationsWithExternalMappingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetAllOrganizationsWithExternalMappings`)
            return await resp.json() as GetAllOrganizationsWithExternalMappingsResponse
        }

        public async GetAllShipments(params: GetAllShipmentsParams): Promise<GetAllShipmentsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetAllShipments`, JSON.stringify(params))
            return await resp.json() as GetAllShipmentsResponse
        }

        /**
         * GetAllTrackingInfoForOrder fetches information about the order with the given reference
         * Apart from just the core order data, it also fetches the origin and destination locations, as well as all references and the connections to the shipments
         */
        public async GetAllTrackingInfoForOrder(params: GetAllTrackingInfoForOrderParams): Promise<GetAllTrackingInfoForOrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetAllTrackingInfoForOrder`, JSON.stringify(params))
            return await resp.json() as GetAllTrackingInfoForOrderResponse
        }

        public async GetAutoArchiveConfiguration(): Promise<GetAutoArchiveConfigurationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetAutoArchiveConfiguration`)
            return await resp.json() as GetAutoArchiveConfigurationResponse
        }

        /**
         * GetAverageDeliveryTimesPerTransportMethod retrieves the average delivery times
         * for each transport method for the authenticated retailer/organization.
         * 
         * The time range can be customized using the optional TimeFilter parameter. If no
         * start- or end- date are provided, only one is used. If neither are provided, the
         * entire historical average is returned. Returns an error if the query fails.
         */
        public async GetAverageDeliveryTimesPerTransportMethod(params: GetAverageDeliveryTimesPerTransportMethodParams): Promise<GetAverageDeliveryTimesPerTransportMethodResp> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetAverageDeliveryTimesPerTransportMethod`, JSON.stringify(params))
            return await resp.json() as GetAverageDeliveryTimesPerTransportMethodResp
        }

        public async GetEventTypeMappings(params: GetEventTypeMappingsParams): Promise<GetEventTypeMappingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetEventTypeMappings`, JSON.stringify(params))
            return await resp.json() as GetEventTypeMappingsResponse
        }

        /**
         * GetEvents fetches all the events that match the provided filter
         * The events are sorted and paginated according to the provided parameters
         * At least one filter must be provided
         */
        public async GetEvents(params: GetEventsParams): Promise<GetEventsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetEvents`, JSON.stringify(params))
            return await resp.json() as GetEventsResponse
        }

        public async GetEventsByShipmentID(params: GetEventsByShipmentIDParams): Promise<GetEventsByShipmentIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetEventsByShipmentID`, JSON.stringify(params))
            return await resp.json() as GetEventsByShipmentIDResponse
        }

        /**
         * GetEventsByShipmentTrackingReference fetches all the events for a certain transporter and tracking reference
         */
        public async GetEventsByShipmentTrackingReference(params: GetEventsByShipmentTrackingReferenceParams): Promise<GetEventsByShipmentTrackingReferenceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetEventsByShipmentTrackingReference`, JSON.stringify(params))
            return await resp.json() as GetEventsByShipmentTrackingReferenceResponse
        }

        public async GetExternalEventTypes(params: GetExternalEventTypesParams): Promise<GetExternalEventTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetExternalEventTypes`, JSON.stringify(params))
            return await resp.json() as GetExternalEventTypesResponse
        }

        /**
         * GetJourneySnapshots retrieves journey snapshots based on the given filters and options.
         * The function supports filtering and pagination.
         */
        public async GetJourneySnapshots(params: GetJourneySnapshotsParams): Promise<GetJourneySnapshotsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetJourneySnapshots`, JSON.stringify(params))
            return await resp.json() as GetJourneySnapshotsResponse
        }

        /**
         * GetJourneys retrieves journeys based on the given filters and options.
         * The function supports filtering and pagination.
         */
        public async GetJourneys(params: GetJourneysParams): Promise<GetJourneysResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetJourneys`, JSON.stringify(params))
            return await resp.json() as GetJourneysResponse
        }

        public async GetLatestReachedMilestoneCounts(params: GetLatestReachedMilestoneCountsParams): Promise<GetLatestReachedMilestoneCountsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetLatestReachedMilestoneCounts`, JSON.stringify(params))
            return await resp.json() as GetLatestReachedMilestoneCountsResponse
        }

        /**
         * GetMilestones retrieves milestones based on the given filters and options.
         * The function supports filtering, pagination, and conditional fetching of related data like thresholds.
         */
        public async GetMilestones(params: GetMilestonesParams): Promise<GetMilestonesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetMilestones`, JSON.stringify(params))
            return await resp.json() as GetMilestonesResponse
        }

        /**
         * GetMissingEventTypeMappings fetches all the default mappings and checks agains the organizations to see if there are any missing mappings
         */
        public async GetMissingEventTypeMappings(): Promise<GetMissingEventTypeMappingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetMissingEventTypeMappings`)
            return await resp.json() as GetMissingEventTypeMappingsResponse
        }

        /**
         * GetMonthlyDeliveryTimeAvgPerTransportMethod retrieves the average delivery times
         * for each transport method for the authenticated retailer/organization.
         * 
         * The time range can be customized using the optional TimeFilter parameter. If no
         * start- or end- date are provided, none of them used. If neither are provided, the
         * last 12 months average is returned. Returns an error if the query fails.
         */
        public async GetMonthlyDeliveryTimeAvgPerTransportMethod(params: GetMonthlyDeliveryTimeAvgPerTransportMethodParams): Promise<GetMonthlyDeliveryTimeAvgPerTransportMethodResp> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetMonthlyDeliveryTimeAvgPerTransportMethod`, JSON.stringify(params))
            return await resp.json() as GetMonthlyDeliveryTimeAvgPerTransportMethodResp
        }

        /**
         * GetOrderInformation fetches information about the order with the given reference
         * Apart from just the core order data, it also fetches the origin and destination locations, as well as all references and the connections to the shipments
         */
        public async GetOrderInformation(params: GetOrderInformationParams): Promise<GetOrderInformationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetOrderInformation`, JSON.stringify(params))
            return await resp.json() as GetOrderInformationResponse
        }

        public async GetOrganizationEvents(params: GetOrganizationEventsParams): Promise<GetOrganizationEventsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetOrganizationEvents`, JSON.stringify(params))
            return await resp.json() as GetOrganizationEventsResponse
        }

        /**
         * GetShipmentStatusCount returns the number of shipments in each status for the current organization.
         */
        public async GetShipmentStatusCount(): Promise<GetShipmentStatusCountResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetShipmentStatusCount`)
            return await resp.json() as GetShipmentStatusCountResponse
        }

        public async GetShipmentStatusCountHistory(params: GetShipmentStatusCountHistoryParams): Promise<GetShipmentStatusCountHistoryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetShipmentStatusCountHistory`, JSON.stringify(params))
            return await resp.json() as GetShipmentStatusCountHistoryResponse
        }

        public async GetTrackedParcels(params: GetTrackedParcelsParams): Promise<GetTrackedParcelsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetTrackedParcels`, JSON.stringify(params))
            return await resp.json() as GetTrackedParcelsResponse
        }

        public async GetTrackedShipmentAndInfoByID(params: GetTrackedShipmentAndInfoByIDParams): Promise<GetTrackedShipmentAndInfoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetTrackedShipmentAndInfoByID`, JSON.stringify(params))
            return await resp.json() as GetTrackedShipmentAndInfoResponse
        }

        /**
         * GetTrackedShipmentsByExternalReference fetches all tracked shipments with the provided external reference
         * 
         * If no shipments are found, an empty array is returned
         */
        public async GetTrackedShipmentsByExternalReference(params: GetTrackedShipmentsByExternalReferenceParams): Promise<GetTrackedShipmentsByExternalReferenceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetTrackedShipmentsByExternalReference`, JSON.stringify(params))
            return await resp.json() as GetTrackedShipmentsByExternalReferenceResponse
        }

        /**
         * GetTrackedShipmentsCountByTransporterID returns the number of tracked shipments for a transporter in a given time range. It does so by grouping the tracked shipments by their timestamp into ranges of the given granularity.
         * A granularity of "day" will return the number of tracked shipments for each day in the given time range. If the start time range is for midday, even tracked shipments earlier that day will be counted in the first day.
         * The same goes for the end of the time range, where tracked shipments after the end time will be counted in the last day, assuming that granularity is "day".
         */
        public async GetTrackedShipmentsCountByTransporterID(params: GetTrackedShipmentsCountByTransporterIDParams): Promise<GetTrackedShipmentsCountByTransporterIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetTrackedShipmentsCountByTransporterID`, JSON.stringify(params))
            return await resp.json() as GetTrackedShipmentsCountByTransporterIDResponse
        }

        /**
         * GetTrackedShipmentsPerHour returns the number of orders per hour between the given time range
         */
        public async GetTrackedShipmentsPerHour(params: GetTrackedShipmentsPerHourParams): Promise<GetTrackedShipmentsPerHourResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetTrackedShipmentsPerHour`, JSON.stringify(params))
            return await resp.json() as GetTrackedShipmentsPerHourResponse
        }

        public async GetTrackingReferenceTypeConfigurations(): Promise<GetTrackingReferenceTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetTrackingReferenceTypeConfigurations`)
            return await resp.json() as GetTrackingReferenceTypesResponse
        }

        public async GetWebhooks(): Promise<GetWebhooksResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetWebhooks`)
            return await resp.json() as GetWebhooksResponse
        }

        /**
         * GetWidgetURL returns the URL to the widget for the given order reference.
         * The URL includes an authentication token that is valid for the widget for 24 hours
         */
        public async GetWidgetURL(params: GetWidgetURLParams): Promise<GetWidgetURLResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.GetWidgetURL`, JSON.stringify(params))
            return await resp.json() as GetWidgetURLResponse
        }

        /**
         * Initialize an order
         * 
         * After an order has been initialized, any of the references can be used to attach shipments or events to the order.
         */
        public async InitializeOrder(params: InitializeOrderParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.InitializeOrder`, JSON.stringify(params))
        }

        /**
         * InitializeTracking initializes a new tracked shipment.
         * 
         * The function then initiates a database transaction to insert the tracked shipment and connect
         * any potential earlier events with the shipment. If any step fails, an appropriate error is returned.
         * If origin and destination details are provided, it fetches the corresponding location IDs.
         * 
         * This function requires authentication and uses the authenticated user's retailer ID.
         * 
         * Parameters:
         *   - shipment: The details of the tracking shipment to be initialized.
         * 
         * Returns:
         *   - error: An error if any step in the initialization process fails.
         */
        public async InitializeTracking(params: InitializeTrackedShipment): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.InitializeTracking`, JSON.stringify(params))
        }

        public async InsertWebhook(params: InsertWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.InsertWebhook`, JSON.stringify(params))
        }

        public async InstaboxTrackingWebhook(params: models.InstaboxWebhookEvent): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.InstaboxTrackingWebhook`, JSON.stringify(params))
        }

        /**
         * This is a pure endpoint that will be used to mock-evaluate a journey given the sent in journey and shipment data
         */
        public async MockEvaluateJourney(params: MockEvaluateJourneyParams): Promise<MockEvaluateJourneyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.MockEvaluateJourney`, JSON.stringify(params))
            return await resp.json() as MockEvaluateJourneyResponse
        }

        public async MockMilestoneCompletedEvent(params: MockMilestoneCompletedEventParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.MockMilestoneCompletedEvent`, JSON.stringify(params))
        }

        /**
         * OnboardOrganizationForTracking onboards an organization for tracking
         * It adds SkrymEventTypes to the organization's event types and sets up a default order journey
         */
        public async OnboardOrganizationForTracking(params: OnboardOrganizationForTrackingParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.OnboardOrganizationForTracking`, JSON.stringify(params))
        }

        /**
         * PollShipments forces our system to poll each provided shipment belonging to the calling organization
         * 
         * The API returns all successful and failed shipments in two arrays.
         * Calling this endpoint with shipment IDs that we do not have in our system will not trigger any error.
         */
        public async PollShipments(params: PollShipmentsParams): Promise<PollShipmentsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.PollShipments`, JSON.stringify(params))
            return await resp.json() as PollShipmentsResponse
        }

        public async ReceiveBringEvent(params: ReceiveBringEventParams): Promise<void> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                "x-bring-application": params.Application,
                "x-bring-correlation": params.CorrelationNum,
                "x-trackingkey":       params.TrackingKey,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                created:  params.created,
                id:       params.id,
                package:  params.package,
                pushed:   params.pushed,
                shipment: params.shipment,
                status:   params.status,
            }

            await this.baseClient.callTypedAPI("POST", `/tracking.ReceiveBringEvent`, JSON.stringify(body), {headers})
        }

        public async ReceiveICATrackingEvent(params: models.IcaTrackingEvent): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.ReceiveICATrackingEvent`, JSON.stringify(params))
        }

        public async RefreshEventTypeMappings(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.RefreshEventTypeMappings`)
        }

        /**
         * SendMockWebhook sends a mock event to a saved webhook with the purpose of letting users
         * test the webhook setup easily from Scope
         */
        public async SendMockWebhook(params: SendMockWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.SendMockWebhook`, JSON.stringify(params))
        }

        /**
         * SetShipmentStatus updates a shipment (the provided ID) to the given status
         */
        public async SetShipmentStatus(params: SetShipmentStatusParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.SetShipmentStatus`, JSON.stringify(params))
        }

        public async UpdateShipment(params: UpdateShipmentParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpdateShipment`, JSON.stringify(params))
        }

        public async UpdateWebhook(params: UpdateWebhookParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpdateWebhook`, JSON.stringify(params))
        }

        public async UpsertAutoArchiveConfiguration(params: UpsertAutoArchiveConfigurationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpsertAutoArchiveConfiguration`, JSON.stringify(params))
        }

        /**
         * UpsertConditionsForMilestone Inserts or updates thresholds for a milestone, cascading updates across related tables.
         * If an existing condition or threshold is not referenced in the input, it will be deleted.
         */
        public async UpsertConditionsForMilestone(params: UpsertConditionsForMilestoneParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpsertConditionsForMilestone`, JSON.stringify(params))
        }

        /**
         * UpsertEvent creates an event for a shipment
         * 
         * Events can be created by different parties (transporter, retailer, Skrym). It is possible to include custom event data
         * by passing in a valid JSON in the metadata field.
         */
        public async UpsertEvent(params: UpsertEventParams): Promise<UpsertEventResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/tracking.UpsertEvent`, JSON.stringify(params))
            return await resp.json() as UpsertEventResponse
        }

        /**
         * UpsertEventTypeMaps inserts event type maps which are used to map transporter event types to organization event types
         */
        public async UpsertEventTypeMaps(params: UpsertEventTypeMapsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpsertEventTypeMaps`, JSON.stringify(params))
        }

        /**
         * UpsertExternalEventTypes upserts transporter's (Postnord, Budbee, etc.) event types
         */
        public async UpsertExternalEventTypes(params: UpsertExternalEventTypesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpsertExternalEventTypes`, JSON.stringify(params))
        }

        /**
         * UpsertJourneys Inserts given journeys if their IDs do not exist in the database, otherwise updates them.
         */
        public async UpsertJourneys(params: UpsertJourneysParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpsertJourneys`, JSON.stringify(params))
        }

        /**
         * UpsertMilestones Inserts given milestones if their names do not exist in the database, otherwise updates them.
         */
        public async UpsertMilestones(params: UpsertMilestonesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpsertMilestones`, JSON.stringify(params))
        }

        /**
         * UpsertMilestonesForJourney Inserts milestones for a given journey, removing any existing milestones first.
         */
        public async UpsertMilestonesForJourney(params: UpsertMilestonesForJourneyParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpsertMilestonesForJourney`, JSON.stringify(params))
        }

        /**
         * UpsertOrganizationEventTypes upserts organization's event types which can be used to map transporter event types to
         */
        public async UpsertOrganizationEventTypes(params: UpsertOrganizationEventTypesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpsertOrganizationEventTypes`, JSON.stringify(params))
        }

        /**
         * UpsertSkrymEventTypes upserts Skrym's default event types which can be used by organizations to map transporter event types to
         */
        public async UpsertSkrymEventTypes(params: UpsertSkrymEventTypesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpsertSkrymEventTypes`, JSON.stringify(params))
        }

        public async UpsertTrackingReferenceTypeConfiguration(params: UpsertTrackingReferenceTypeConfigurationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/tracking.UpsertTrackingReferenceTypeConfiguration`, JSON.stringify(params))
        }
    }
}

export namespace transportation {
    export interface AddUploadedTransportAgreementParams {
        transportMethodId: string
        fileId: string
        fileName: string
        fileSize: number
        fileType?: string
        message?: string
    }

    export interface CalculateCostForAllMethodsParams {
        /**
         * The object to calculate cost for
         */
        freightObject: datamodels.FreightInput

        /**
         * Optional limiting to enabled methods and agreements
         */
        onlyEnabled: boolean
    }

    export interface CalculateCostForMethodParams {
        /**
         * The object to calculate cost for
         */
        freightObject: datamodels.FreightInput

        /**
         * UUID of the transport method to calculate cost for
         */
        transportMethodID: string
    }

    export interface CalculateCostForMultipleMethodsResponse {
        /**
         * Costs for each method
         */
        AgreementCosts: CalculateCostResponse[]
    }

    export interface CalculateCostResponse {
        /**
         * If the cost calculation was successful. Can be "success" or "failure"
         */
        status: models.CostCalculationResultStatus

        /**
         * Specification of error. Only provided if the status is "failure".
         */
        error: string

        /**
         * Unique identifier of the transport method that cost was calculated for
         */
        transportMethodID: string

        /**
         * Unique code used by Skrym for the transport method
         */
        skrymMethodCode: string

        /**
         * Unique identifier of the transport agreement used for the cost calculation
         */
        agreementID: string

        /**
         * Name of the transport method. Will use alias if set to display name. May be empty.
         */
        transportMethod: string

        /**
         * Name of the transporter. Will use alias if set as display name May be empty.
         */
        transporter: string

        /**
         * The actual cost calculation results. Will be empty if status is "failure"
         */
        result: FreightCost
    }

    export interface CalculatePriceGroupCostResponse {
        /**
         * If the cost calculation was successful. Can be "success" or "failure"
         */
        calculationStatus: models.CostCalculationResultStatus

        /**
         * Unique identifier for the matched price group
         */
        priceGroupID: string

        /**
         * Human-readable code for the price group such as 'pg1'
         */
        priceGroupCode: string

        /**
         * Unique identifier for the matched price interval
         */
        priceIntervalID: string

        /**
         *  Human-readable code for the price group such as 'pg1.pi1'. Always begins with its parent price group code.
         */
        priceIntervalCode: string

        /**
         * The sum of the fixed and variable cost
         */
        baseCost: number

        /**
         * Specification of what cost type the result is. Is 'fixed' if consisting only of the fixed cost. Is 'mixed' if consisting of both fixed and variable cost. Is 'variable' if only consisting of the variable cost.
         */
        costType: string

        /**
         * The fixed cost of the price interval. Will always be applied and is independent of any external variables.
         */
        fixedCost: number

        /**
         * The currency of the interval.
         */
        currency: string

        /**
         * Variable cost is the calculated variable cost component, which is found by multiplying the `unitCost` with the applicable `costUnitValue`.
         */
        variableCost: number

        /**
         * The cost per unit
         */
        unitCost: number

        /**
         * Which attribute is the basis of the variable cost. Normally debitable weight or actual weight.
         */
        costAttribute: models.AgreementAttribute

        /**
         * Which unit the `costAttribute` is specified in. Normally kg.
         */
        costUnit: utils.MeasurementUnit

        /**
         * The actual value of the `costAttribute`. This multiplied with the `unitCost` is the variable cost
         */
        costUnitValue: number
    }

    /**
     * Used in the express calculation endpoint
     */
    export interface ConcurrentCostRequest {
        /**
         * The object to calculate the cost for
         */
        FreightObject: datamodels.FreightInput

        /**
         * The ID of the transport agreement to use (agreement must be provided in map)
         */
        AgreementID: string

        /**
         * Reference used to allow connecting back the result to the request (since we are using channels which don't preserve order)
         */
        Reference: string
    }

    export interface ConcurrentCostResponse {
        /**
         * The cost response
         */
        Response: CalculateCostResponse

        /**
         * The reference used to connect back to the request
         */
        Reference: string
    }

    export interface CostCalculationLiveResponse {
        result: models.CostResult
    }

    export interface CostCalculationParams {
        optResult: models.Result
    }

    /**
     * DeleteDigitalTransportAgreementParams represents the parameters for deleting a digital transport agreement.
     * 
     * The struct contains the following field:
     * - AgreementId: The unique identifier of the agreement to be deleted.
     * 
     * The struct is used as a parameter for deleting a digital transport agreement from the repository.
     * It is used in conjunction with the DeleteDigitalTransportAgreement function.
     */
    export interface DeleteDigitalTransportAgreementParams {
        agreementId: string
    }

    /**
     * Struct representing the request body of DeleteEngineFuelLookupsByEngineType
     * 
     * DeleteEngineFuelLookupParams holds the parameters required for the DeleteEngineFuelLookupsByEngineType function.
     * It includes the engine and fuel types for the engine fuel lookup entries to be deleted.
     */
    export interface DeleteEngineFuelLookupParams {
        /**
         * engine type for the lookup entity to be deleted
         */
        engineType: models.EngineType

        /**
         * fuel type for the lookup entity to be deleted
         */
        fuelType: string
    }

    export interface DeleteMethodForAliasRetailerParams {
        retailerMethodId: string
    }

    export interface DeleteMethodForRetailerParams {
        transportMethodId: string
    }

    /**
     * Struct representing the request body to DeleteOrganizationVehicleByID
     * 
     * DeleteOrganizationVehicleByIDParams holds the parameters required for the DeleteVehicleModelByID function.
     * It includes the unique identifier of the organization vehicle to be deleted.
     */
    export interface DeleteOrganizationVehicleByIDParams {
        /**
         * unique identifier of the organization vehicle to be deleted
         */
        vehicleId: string
    }

    /**
     * Struct representing the request body to DeleteOrganizationVehicleLocationRangeByID
     * 
     * DeleteOrganizationVehicleLocationRangeByIDParams holds the parameters required for the DeleteOrganizationVehicleLocationRangeByID function.
     * It includes the unique identifier of the organization vehicle location range to be deleted.
     */
    export interface DeleteOrganizationVehicleLocationRangeByIDParams {
        /**
         * unique identifier of the organization vehicle location range to be deleted.
         */
        organizationVehicleLocationRangeId: string
    }

    /**
     * DeleteRetailerCredentialByTransporterIdParams represents the parameters required
     * to delete a retailer's credentials based on a given transporter ID.
     */
    export interface DeleteRetailerCredentialByTransporterIdParams {
        /**
         * TransporterId is the unique identifier for the transporter whose associated
         * retailer credentials are to be deleted.
         */
        transporterId: string
    }

    /**
     * DeleteTransportMethodLocationParams holds the parameters required to delete a specific location association for a transport method.
     * It contains identifiers for both the transport method and the location to be disassociated, ensuring precise targeting for deletion operations.
     */
    export interface DeleteTransportMethodLocationParams {
        /**
         * MethodID is the UUID of the transport method from which a location association will be removed.
         */
        methodId: string

        /**
         * LocationID is the UUID of the location to be disassociated from the specified transport method.
         */
        locationId: string
    }

    /**
     * Request body for DeleteTransportMethodVehicleByVehicle
     * 
     * DeleteTransportMethodVehicleByVehicleParams holds the parameters for deleting transport methods associated with a vehicle.
     */
    export interface DeleteTransportMethodVehicleByVehicleParams {
        /**
         * OrganizationVehicleID is the identifier of the vehicle for which transport methods are being deleted.
         */
        organizationVehicleId: string
    }

    /**
     * Deleter for Vehicle Model
     * 
     * DeleteVehicleModelByIDParams holds the parameters required for the DeleteVehicleModelByID function.
     * It includes the unique identifier of the vehicle model to be deleted.
     */
    export interface DeleteVehicleModelByIDParams {
        /**
         * unique identifier of the vehicle model to be deleted
         */
        vehicleId: string
    }

    /**
     * Struct representing the request body of DeleteVehicleModelClassificationByID
     * 
     * DeleteVehicleModelClassificationParams holds the parameters required for the DeleteVehicleModelClassification function.
     * It includes the unique identifiers of the vehicle and vehicle classification to be deleted.
     */
    export interface DeleteVehicleModelClassificationParams {
        /**
         * Unique identifier of the vehicle.
         */
        vehicleId: string

        /**
         * Unique identifier of the vehicle classification.
         */
        vehicleClassId: string
    }

    export interface ExpressCostCalculationParams {
        /**
         * The requests to process
         */
        Requests: ConcurrentCostRequest[]

        /**
         * Map of Transport Agreement ID to the agreement data
         */
        Agreements: { [key: string]: models.DigitalTransportAgreementData }
    }

    export interface ExpressCostCalculationParamsResponse {
        /**
         * The responses for each request
         */
        Responses: ConcurrentCostResponse[]
    }

    export interface FeeGroupDescriptionInfo {
        code: string
        descriptions: { [key: string]: string }
        fees: { [key: string]: FeeInfo }
    }

    export interface FeeInfo {
        code: string
        descriptions: { [key: string]: string }
    }

    export interface FreightCost {
        /**
         * The sum of base cost, added fee sum and penalty fee sum (in the standard denomination of the currency)
         */
        totalCost: number

        /**
         * The resulting cost from the matched price group and interval. Equal to the price interval's fixed cost and variable cost (costUnit * unitCost) (in the standard denomination of the currency)
         */
        baseCost: number

        /**
         * Total sum of all applied added fees (in the standard denomination of the currency)
         */
        addedFeeSum: number

        /**
         * Total sum of all applied penalty fees (in the standard denomination of the currency)
         */
        penaltyFeeSum: number

        /**
         * Follows ISO 4217
         */
        currency: string

        /**
         * If a breaking penalty fee has been applied. Means the transport method is NOT available.
         */
        breaking: boolean

        /**
         * List of all penalty fees applied
         */
        penalty: models.FeeApplied[]

        /**
         * List of all added fees applied
         */
        addedFees: models.FeeApplied[]

        /**
         * Detailed information about the matched price group and interval
         */
        details: CalculatePriceGroupCostResponse
    }

    export interface GetActiveDigitalTransportAgreementForMethodParams {
        /**
         * The unique identifier of the retailer
         */
        retailerId: string

        /**
         * The unique identifier of the transport method
         */
        transportMethodId: string
    }

    export interface GetAllDigitalTransportAgreementLabelsResponse {
        agreements: GetDigitalTransportAgreementLabelsResponse[]
    }

    /**
     * Struct representing the response of GetAllEngineTypes
     * 
     * GetAllEngineTypesResponse encapsulates the response from the GetAllEngineTypes function.
     * It contains a slice of EngineType structs representing the names of the engine types.
     */
    export interface GetAllEngineTypesResponse {
        /**
         * slice of EngineTypes
         */
        engineTypes: models.EngineType[]
    }

    /**
     * Struct representing the response body of GetAllFuelTypes
     * 
     * GetAllFuelTypesResponse encapsulates the response from the GetAllFuelTypes function.
     * It contains a slice of Fuel structs representing the details of each fuel type.
     */
    export interface GetAllFuelTypesResponse {
        /**
         *  slice of Fuel structs representing the details of each fuel type
         */
        fuels: models.Fuel[]
    }

    export interface GetAllOrganizationShippingTaxRatesResponse {
        /**
         * All shipping tax rates by destination country
         */
        shippingTaxRates: models.OrganizationShippingTaxRate[]
    }

    /**
     * Parameters struct for the GetAllOrganizationVehicleLocationRanges endpoint
     * 
     * GetAllOrganizationVehicleLocationRangesParams holds the parameters for the GetAllOrganizationVehicleLocationRanges function.
     * Currently, it only requires the OrganizationID.
     */
    export interface GetAllOrganizationVehicleLocationRangesParams {
        /**
         * UUID of the organization to fetch vehicle location ranges for.
         */
        organizationId: string
    }

    /**
     * Struct representing the output from GetAllOrganizationVehicleLocationRanges
     * 
     * GetAllOrganizationVehicleLocationRangesResponse encapsulates the response from the GetAllOrganizationVehicleLocationRanges function.
     * It contains a slice of the retrieved Organization Vehicle Location Range data.
     */
    export interface GetAllOrganizationVehicleLocationRangesResponse {
        /**
         * Retrieved Organization Vehicle Location Ranges data.
         */
        organizationVehicleLocationRanges: models.OrganizationVehicleLocationRange[]
    }

    export interface GetAllOrganizationVehiclesPaginationParams {
        pageSize: number
        page: number
        filters?: models.OrganizationVehicleFilter[]
        sort?: models.OrganizationVehicleSort
    }

    /**
     * Struct representing the response from GetAllOrganizationVehiclesPaginationResponse
     * 
     * GetAllOrganizationVehiclesPaginationResponse encapsulates the response from the bulk fetch function.
     * It contains a slice of the retrieved Organization Vehicles data and row count.
     */
    export interface GetAllOrganizationVehiclesPaginationResponse {
        /**
         * Retrieved Organization Vehicles data
         */
        organizationVehicles: models.OrganizationVehicle[]

        rowCount: number
    }

    /**
     * Struct representing the response from GetAllOrganizationVehicles
     * 
     * GetAllOrganizationVehiclesResponse encapsulates the response from the bulk fetch function.
     * It contains a slice of the retrieved Organization Vehicles data.
     */
    export interface GetAllOrganizationVehiclesResponse {
        /**
         * Retrieved Organization Vehicles data
         */
        organizationVehicles: models.OrganizationVehicle[]
    }

    /**
     * GetAllRetailerCredentialsByRetailerIdResponse represents the response returned after
     * fetching all the retailer credentials associated with a specific retailer ID.
     */
    export interface GetAllRetailerCredentialsByRetailerIdResponse {
        /**
         * RetailerCredentials contains a slice of all the retailer credentials associated
         * with the authenticated retailer.
         */
        retailerCredentials: models.RetailerCredentials[]
    }

    export interface GetAllTransportMethodsAndCodesParams {
        /**
         * Array of transporter names working as a filter. Any transporter not matching a provided name will be excluded. If left null or empty no filtering will be applied.
         */
        filterTransporter?: string[]

        /**
         * Array of codes working as a filter. Any code not matching a provided code will be excluded. If left null or empty no filtering will be applied.
         */
        filterCodes?: string[]
    }

    export interface GetAllTransportMethodsAndCodesResponse {
        /**
         * Transporter and method information and array of all codes used by transporter to refer to the transport method
         */
        methods: datamodels.TransportMethodWithCodes[]
    }

    export interface GetAllTransportMethodsResponse {
        transportMethods: models.TransportMethod[]
    }

    /**
     * Struct representing the request body of GetAllVehicleClassificationStandards
     * 
     * GetAllVehicleClassificationStandardsResponse encapsulates the response from the GetAllVehicleClassificationStandards function.
     * It contains a slice of the retrieved VehicleClassificationStandard data.
     */
    export interface GetAllVehicleClassificationStandardsResponse {
        /**
         * slice of the retrieved VehicleClassificationStandard data
         */
        vehicleClassificationStandards: models.VehicleClassificationStandard[]
    }

    /**
     * Struct representing the request body to GetAllVehicleModelsByIds
     * 
     * It takes in a list of vehicle model IDs to be used in the query.
     */
    export interface GetAllVehicleModelsByIdsParams {
        vehicleModelIds: string[]
    }

    /**
     * Struct representing the request body to GetAllVehicleModels
     * 
     * It takes in a search term and a limit to be used in the query.
     */
    export interface GetAllVehicleModelsParams {
        searchTerm?: string
        limit?: number
    }

    /**
     * GetAllVehicleModelsResponse represents the response from GetAllVehicleModels
     * 
     * It encapsulates the response from the bulk fetch function.
     */
    export interface GetAllVehicleModelsResponse {
        vehicleModels: models.VehicleModel[]
    }

    export interface GetCustomParameterForMethodParams {
        methodId: string
    }

    export interface GetCustomParameterForMethodResponse {
        customParameterKey: string
    }

    export interface GetDigitalTransportAgreementByMethodParams {
        /**
         * The unique identifier of the transport method
         */
        transportMethodId: string
    }

    export interface GetDigitalTransportAgreementByTransportMethodAliasParams {
        transportMethodAlias: string
        transporterAlias: string
    }

    export interface GetDigitalTransportAgreementByTransportMethodAliasResponse {
        digitalTransportAgreement: models.DigitalTransportAgreementData
    }

    export interface GetDigitalTransportAgreementLabelsRequest {
        dtaID: string
    }

    export interface GetDigitalTransportAgreementLabelsResponse {
        name: string
        addedFeeGroups: { [key: string]: FeeGroupDescriptionInfo }
        penaltyFeeGroups: { [key: string]: FeeGroupDescriptionInfo }
        priceGroups: { [key: string]: PriceGroupDescriptionInfo }
    }

    /**
     * GetDigitalTransportAgreementParams represents the parameters for retrieving a digital transport agreement by its ID.
     * 
     * The struct contains the following field:
     * - AgreementId: The unique identifier of the agreement to be retrieved.
     * 
     * The struct is used as a parameter for retrieving a digital transport agreement from the repository.
     * It is used in conjunction with the GetDigitalTransportAgreementById function.
     */
    export interface GetDigitalTransportAgreementParams {
        /**
         * The unique identifier of the agreement
         */
        AgreementId: string
    }

    export interface GetDigitalTransportAgreementResponse {
        /**
         * The digital transport agreement and its metadata
         */
        agreement: models.DigitalTransportAgreementData
    }

    export interface GetDigitalTransportAgreementTemplatesParams {
        /**
         * The transport methods to fetch templates for. If omitted, all templates will be fetched.
         */
        transportMethodIds?: string[]
    }

    export interface GetDigitalTransportAgreementTemplatesResponse {
        templates: models.DigitalTransportAgreementData[]
    }

    export interface GetDigitalTransportAgreementsForMethodResponse {
        /**
         * The agreements associated with the transport method
         */
        agreements: models.DigitalTransportAgreementData[]
    }

    /**
     * Struct representing the request body of GetEngineFuelLookupsByEngineType
     * 
     * GetEngineFuelLookupsByEngineTypeParams holds the parameters for the GetEngineFuelLookupsByEngineType function.
     * It includes the engine type for which fuel compatibilities are being retrieved.
     */
    export interface GetEngineFuelLookupsByEngineTypeParams {
        /**
         * engine type for which fuel compatibilities are being retrieved.
         */
        engineType: models.EngineType
    }

    /**
     * Struct representing the response body of GetEngineFuelLookupsByEngineType
     * 
     * GetEngineFuelLookupsByEngineTypeResponse encapsulates the response from the GetEngineFuelLookupsByEngineType function.
     * It contains a slice of EngineFuelLookup data corresponding to the engine type.
     */
    export interface GetEngineFuelLookupsByEngineTypeResponse {
        /**
         * slice of EngineFuelLookup data
         */
        engineFuelLookups: models.EngineFuelLookup[]
    }

    /**
     * GetLatestCapacityUtilizationBySegmentTypeParams is the request struct for GetLatestCapacityUtilizationBySegmentTypeEndpoint.
     */
    export interface GetLatestCapacityUtilizationBySegmentTypeParams {
        transporterId: string
    }

    /**
     * GetLatestCapacityUtilizationBySegmentTypeResponse is the response struct for GetLatestCapacityUtilizationBySegmentTypeEndpoint.
     */
    export interface GetLatestCapacityUtilizationBySegmentTypeResponse {
        utilizations: models.RouteSegmentCapacityUtilization[]
    }

    export interface GetLatestCapacityUtilizationResponse {
        utilization: models.RouteSegmentCapacityUtilization[]
    }

    /**
     * GetLocationsForTransportMethodsParams holds the parameters for the GetLocationsForTransportMethods API.
     * It specifies the transport methods by their IDs for which locations are to be fetched.
     */
    export interface GetLocationsForTransportMethodsParams {
        /**
         * MethodIDs contains a list of transport method UUIDs.
         */
        methodIds: string[]
    }

    /**
     * GetLocationsForTransportMethodsResponse encapsulates the response from the GetLocationsForTransportMethods API.
     * It maps each transport method ID to a list of location IDs where the method is applicable.
     */
    export interface GetLocationsForTransportMethodsResponse {
        /**
         * TransportMethodLocationMap is a mapping from transport method IDs to their respective location IDs.
         */
        transportMethodLocationMap: { [key: string]: string[] }
    }

    export interface GetMethodForRetailerParams {
        methodID: string
    }

    export interface GetMethodForRetailerResponse {
        method: models.RetailerMethod
    }

    export interface GetMethodsForRetailerByRetailerIDParams {
        onlyEnabled?: boolean
        retailerID: string
    }

    export interface GetMethodsForRetailerParams {
        onlyEnabled?: boolean
    }

    export interface GetMethodsForRetailerResponse {
        methods: models.RetailerMethod[]
    }

    /**
     * Struct representing the request to GetOrganizationVehicleByID
     * 
     * GetOrganizationVehicleByIDParams holds the parameters required for the GetVehicleModelByID function.
     * It includes the unique identifier of the Organization Vehicle to be retrieved.
     */
    export interface GetOrganizationVehicleByIDParams {
        /**
         * unique identifier of the Organization Vehicle to be retrieved.
         */
        organizationVehicleId: string
    }

    /**
     * Struct representing the response from GetOrganizationVehicleByID
     * 
     * GetOrganizationVehicleByIDResponse encapsulates the response from the GetVehicleModelByID function.
     * It contains the retrieved Organization Vehicle data.
     */
    export interface GetOrganizationVehicleByIDResponse {
        /**
         * retrieved Organization Vehicle data
         */
        vehicleModel: models.OrganizationVehicle
    }

    /**
     * Struct representing the input to GetOrganizationVehicleLocationRangeByID
     * 
     * GetOrganizationVehicleLocationRangeByIDParams holds the parameters required for the GetOrganizationVehicleLocationRangeByID function.
     * It includes the unique identifier of the Organization Vehicle Location Range to be retrieved.
     */
    export interface GetOrganizationVehicleLocationRangeByIDParams {
        /**
         * unique identifier of the Organization Vehicle Location Range to be retrieved.
         */
        organizationVehicleLocationRangeId: string
    }

    /**
     * Struct representing the output from GetOrganizationVehicleLocationRangeByID
     * 
     * GetOrganizationVehicleLocationRangeByIDResponse encapsulates the response from the GetOrganizationVehicleLocationRangeByID function.
     * It contains the retrieved Organization Vehicle Location Range data.
     */
    export interface GetOrganizationVehicleLocationRangeByIDResponse {
        /**
         * retrieved Organization Vehicle Location Range data.
         */
        organizationVehicleLocationRange: models.OrganizationVehicleLocationRange
    }

    /**
     * -----------------------------------------------------------------------
     * Struct representing the input to GetOrganizationVehicleLocationRangesByVehicleID
     * 
     * GetOrganizationVehicleLocationRangesByVehicleID holds the parameters required for the GetOrganizationVehicleLocationRangesByVehicleID function.
     * It includes the unique identifier of the vehicle that Organization Vehicle Location Range to be retrieved.
     */
    export interface GetOrganizationVehicleLocationRangesByVehicleIDParams {
        /**
         * unique identifier of the Organization Vehicle Location Range to be retrieved.
         */
        vehicleId: string
    }

    /**
     * Struct representing the output from GetOrganizationVehicleLocationRangesByVehicleID
     * 
     * It contains the retrieved Organization Vehicle Location Range data.
     */
    export interface GetOrganizationVehicleLocationRangesByVehicleIDResponse {
        /**
         * retrieved Organization Vehicle Location Range data.
         */
        organizationVehicleLocationRanges: models.OrganizationVehicleLocationRange[]
    }

    /**
     * GetRetailerCredentialsByTransporterIdParams represents the parameters required
     * to retrieve retailer credentials based on a given transporter ID.
     */
    export interface GetRetailerCredentialsByTransporterIdParams {
        /**
         * TransporterId is the unique identifier for the transporter whose associated
         * retailer credentials are to be fetched.
         */
        transporterId: string
    }

    /**
     * GetRetailerCredentialsByTransporterIdResponse is the response returned after
     * fetching the retailer credentials associated with a given transporter ID.
     */
    export interface GetRetailerCredentialsByTransporterIdResponse {
        /**
         * RetailerCredential contains the detailed information about the retailer credentials
         * associated with the specified transporter.
         */
        retailerCredential: models.RetailerCredentials
    }

    export interface GetRetailerStoreMaxDistanceResponse {
        /**
         * Distance cap [km] for the retailer stores
         */
        maxDistance: number
    }

    /**
     * GetRouteSegmentsParams represents the input parameters required for fetching route segments.
     */
    export interface GetRouteSegmentsParams {
        /**
         * The organization ID associated with the retailer.
         */
        organizationId: string

        /**
         * The transport method ID for which the route segments are fetched.
         */
        transportMethodId: string

        /**
         * The location from which the route segments are fetched.
         */
        from: datamodels.Location

        /**
         * The location to which the route segments are fetched.
         */
        to: datamodels.Location
    }

    /**
     * GetRouteSegmentsResponse holds the result of the GetRouteSegments function call. It includes
     * the route segments that were determined based on the provided parameters and the IDs of the
     * vehicle models that can be used on these segments.
     */
    export interface GetRouteSegmentsResponse {
        routeSegments: models.RouteSegment[]
        vehicleModelIds: string[]
    }

    export interface GetSignedUrlForTransportAgreementParams {
        fileName: string
    }

    export interface GetSignedUrlForTransportAgreementResponse {
        fileId: string
        presignedUrl: string
    }

    export interface GetSkrymCostForOrdersParams {
        orderIds: string[]
    }

    export interface GetSkrymCostForOrdersResponse {
        results: models.CostResult[]
        /**
         * This can be improved to return list of order ids which we could not find result for
         */
        error: string
    }

    export interface GetTransportMethodByAliasParams {
        methodAlias: string
        transporterAlias: string
        onlyEnabled: boolean
    }

    export interface GetTransportMethodResponse {
        method: models.TransportMethod
    }

    export interface GetTransportMethodsForLocationParams {
        locationId: string
    }

    export interface GetTransportMethodsForLocationResponse {
        methodIds: string[]
    }

    /**
     * Request body for GetTransportMethodsForVehicle
     * 
     * GetTransportMethodsForVehicleParams holds the parameters for fetching transport methods associated with a vehicle.
     */
    export interface GetTransportMethodsForVehicleParams {
        /**
         * OrganizationVehicleID is the identifier of the vehicle for which transport methods are being fetched.
         */
        organizationVehicleId: string

        /**
         * TransporterID is the identifier of the transporter that uses the vehicle.
         */
        transporterId: string
    }

    /**
     * Response body for GetTransportMethodsForVehicle
     * 
     * GetTransportMethodsForVehicle fetches transport methods associated with a vehicle.
     */
    export interface GetTransportMethodsForVehicleResponse {
        /**
         * TransportMethodIDs is a list of transport methods associated with the vehicle.
         */
        transportMethodIds: string[]
    }

    export interface GetTransporterAndMethodMapsResponse {
        transporterMap: { [key: string]: models.Transporter }
        transportMethodMap: { [key: string]: models.TransportMethod }
    }

    export interface GetTransporterByAliasParams {
        name: string
    }

    export interface GetTransporterByAliasResponse {
        transporter: models.Transporter
    }

    export interface GetTransporterByNameParams {
        name: string
    }

    export interface GetTransporterByNameResponse {
        transporter: models.Transporter
    }

    export interface GetTransportersResponse {
        /**
         * List of transporters
         */
        transporters: models.Transporter[]
    }

    export interface GetUploadedTransportAgreementsParams {
        transportMethodId: string
    }

    export interface GetUploadedTransportAgreementsResponse {
        /**
         * Ordered by CreatedDate in descending order
         */
        files: models.TransportAgreementFile[]
    }

    /**
     * Struct representing the request body to GetVehicleClasses
     * 
     * GetVehicleClassesParams holds the parameters for the GetVehicleClasses function.
     * It includes the classification standard for which vehicle classes are being retrieved.
     */
    export interface GetVehicleClassesParams {
        /**
         * classification standard for which vehicle classes are being retrieved
         */
        classificationStandard: models.VehicleClassificationStandard
    }

    /**
     * Struct representing the response from GetVehicleClasses
     * 
     * GetVehicleClassesResponse encapsulates the response from the GetVehicleClasses function.
     * It contains a slice of VehicleClass structs representing each row.
     */
    export interface GetVehicleClassesResponse {
        /**
         * slice of VehicleClasses belonging to the provided classification standard
         */
        vehicleClasses: models.VehicleClass[]
    }

    /**
     * Struct representing the request body to GetVehicleModelByID
     * 
     * GetVehicleModelByIDParams holds the parameters required for the GetVehicleModelByID function.
     * It includes the unique identifier of the vehicle model to be retrieved.
     */
    export interface GetVehicleModelByIDParams {
        /**
         * unique identifier of the vehicle model to be retrieved
         */
        vehicleId: string
    }

    /**
     * GetVehicleModelByIDResponse encapsulates the response from the GetVehicleModelByID function.
     * It contains the retrieved vehicle model data.
     */
    export interface GetVehicleModelByIDResponse {
        /**
         * All stored data about the vehicle
         */
        vehicleModel: models.VehicleModel
    }

    /**
     * Struct representing the request body to GetVehicleModelClassificationsByVehicleID
     * 
     * GetVehicleModelClassificationsByVehicleIDParams holds the parameters for the GetVehicleModelClassificationsByVehicleID function.
     * It includes the unique identifier of the vehicle for which classifications are being retrieved.
     */
    export interface GetVehicleModelClassificationsByVehicleIDParams {
        /**
         * unique identifier of the vehicle for which classifications are being retrieved
         */
        vehicleId: string
    }

    /**
     * Struct representing the response body of GetVehicleModelClassificationsByVehicleID
     * 
     * GetVehicleModelClassificationsByVehicleIDResponse encapsulates the response from the GetVehicleModelClassificationsByVehicleID function.
     * It contains a slice of the retrieved VehicleModelClassification data.
     */
    export interface GetVehicleModelClassificationsByVehicleIDResponse {
        /**
         * slice of the retrieved VehicleModelClassification data
         */
        vehicleModelClassifications: models.VehicleModelClassification[]
    }

    export interface InsertAliasForRetailerMethodsParams {
        methodData: {
            transportMethodId: string
            aliases: {
                id: string
                methodAlias: string
                transporterAlias: string
            }[]
        }[]
    }

    /**
     * InsertEngineFuelLookupParams represents the parameters required for the InsertEngineFuelLookup operation.
     * 
     * This struct includes a slice of EngineFuelLookup structs, each representing an engine fuel mapping
     * to be inserted in the database. The EngineFuelLookup struct typically contains fields
     * like EngineType and FuelType, representing the relationship between a specific engine type and
     * its compatible fuel types.
     */
    export interface InsertEngineFuelLookupParams {
        /**
         * slice of EngineFuelLookup structs, each representing an engine fuel mapping
         */
        engineFuelLookups: models.EngineFuelLookup[]
    }

    export interface InsertMethodsForRetailerParams {
        methodData: models.RetailerMethodData[]
    }

    export interface InsertMethodsForRetailerRes {
        methods: models.RetailerMethodData[]
    }

    export interface InsertRouteSegmentCapacityUtilizationParams {
        /**
         * The type of segment [LAST_MILE_DELIVERY, LINE_HAUL, MID_RANGE or PICK_UP]
         */
        segmentType: models.RouteSegmentType

        /**
         * The amount of available space that is utilized in the range [0,1]
         */
        capacityUtilization: number

        /**
         * The organization id (transporter)
         */
        organizationId: string
    }

    /**
     * InsertTransportMethodLocationParams contains the parameters needed to create a new association between a transport method and a location.
     * This struct is used to specify the exact transport method and location to be linked, facilitating precise additions to the system's relational data.
     */
    export interface InsertTransportMethodLocationParams {
        /**
         * MethodID represents the UUID of the transport method to which a location will be associated.
         */
        methodId: string

        /**
         * LocationID denotes the UUID of the location to be linked with the specified transport method.
         */
        locationId: string
    }

    /**
     * Request body for InsertTransportMethodVehicles
     * 
     * InsertTransportMethodVehiclesParams holds the parameters for inserting transport method vehicles.
     */
    export interface InsertTransportMethodVehiclesParams {
        /**
         * TransportMethodVehicles is a list of transport method vehicles to be inserted.
         */
        transportMethodVehicles: models.TransportMethodVehicle[]
    }

    /**
     * Struct representing the input to InsertVehicleModelClassifications
     * 
     * InsertVehicleModelClassificationsParams holds the parameters required for the InsertVehicleModelClassifications function.
     * It includes a slice of VehicleModelClassification structs, each representing a vehicle classification to be inserted.
     */
    export interface InsertVehicleModelClassificationsParams {
        /**
         * a slice of VehicleModelClassification structs, each representing a vehicle classification to be inserted or updated.
         */
        vehicleClassifications: models.VehicleModelClassification[]
    }

    /**
     * Request body for InsertVehiclesForTransportMethod
     * 
     * InsertVehiclesForTransportMethodParams holds the parameters for inserting vehicles associated with a specific transport method.
     */
    export interface InsertVehiclesForTransportMethodParams {
        /**
         * TransportMethodID is the identifier of the transport method to which vehicles are being added.
         */
        transportMethodId: string

        /**
         * TransporterID is the identifier of the transporter that uses the vehicles.
         */
        transporterId: string

        /**
         * OrgVehicleIDs is a list of vehicle identifiers that are to be associated with the transport method.
         */
        orgVehicleIds: string[]
    }

    export interface IntervalInfo {
        code: string
    }

    export interface PriceGroupDescriptionInfo {
        code: string
        name: string
        priceIntervals: { [key: string]: IntervalInfo }
    }

    /**
     * Struct representing the request body for ReplaceOrganizationVehicleLocationRangeParams
     * 
     * ReplaceOrganizationVehicleLocationRangeParams contains parameters for upserting an organization's vehicle location range.
     * This struct includes the range's unique identifier, associated vehicle and location IDs, maximum distance, and validity flags.
     */
    export interface ReplaceOrganizationVehicleLocationRangeParams {
        vehicleId: string
        locations: models.OrganizationVehicleLocationRange[]
    }

    export interface UpdateDisplayNameForRetailerMethodParams {
        defaultAliasId: string
    }

    export interface UpsertCustomParameterForMethodParams {
        retailerId: string
        methodId: string
        customParameterKey: string
    }

    /**
     * UpsertDigitalTransportAgreementParams represents the parameters for upserting a digital transport agreement.
     * 
     * The struct is used as a parameter for upserting a digital transport agreement into the repository.
     * It is used in conjunction with the UpsertDigitalTransportAgreement function.
     */
    export interface UpsertDigitalTransportAgreementParams {
        /**
         * The unique identifier for the agreement
         */
        id: string

        /**
         * The unique identifier for the transport method associated with agreement
         */
        transportMethodID: string

        /**
         * The name of the agreement
         */
        agreementName: string

        /**
         * The description of the agreement
         */
        description: string

        /**
         * The agreement in JSON format
         */
        agreement: JSONValue

        /**
         * Specifies whether the agreement is active or not
         */
        active: boolean

        /**
         * Specifies whether the agreement is a template or not
         */
        isTemplate: boolean

        /**
         * The unique identifier of the template used to create the agreement
         */
        templateId?: string

        /**
         * The date from which the agreement is valid
         */
        validFrom: string

        /**
         * The date until which the agreement is valid
         */
        validTo: string

        /**
         * The factor used to calculate the volumetric weight of one m3, i.e 280 kg/m3.
         */
        volumetricWeightFactor: number
    }

    export interface UpsertOrganizationShippingTaxRatesParams {
        /**
         * All shipping tax rates by destination country
         */
        shippingTaxRates: models.CountryShippingTaxRate[]
    }

    /**
     * Struct representing the request body for UpsertOrganizationVehicleLocationRange
     * 
     * UpsertOrganizationVehicleLocationRangeParams contains parameters for upserting an organization's vehicle location range.
     * This struct includes the range's unique identifier, associated vehicle and location IDs, maximum distance, and validity flags.
     */
    export interface UpsertOrganizationVehicleLocationRangeParams {
        /**
         * Unique identifier for the location range.
         */
        id: string

        /**
         * Identifier of the associated vehicle.
         */
        organizationVehicleId: string

        /**
         * Identifier of the associated organization location.
         */
        organizationLocationId: string

        /**
         * Maximum distance the vehicle can travel from the location.
         */
        maxDistanceKm: number

        /**
         * Indicates if the range is for starting from terminals.
         */
        validFrom: boolean

        /**
         * Indicates if the range is for preventing travel to terminals.
         */
        validTo: boolean
    }

    /**
     * UpsertOrganizationVehicleParams contains parameters for upserting an organization's vehicle.
     * 
     * It includes essential vehicle details like model ID, registration number, and environmental impact metrics.
     * The struct is used in operations to insert or update vehicle records in an organization's context.
     */
    export interface UpsertOrganizationVehicleParams {
        /**
         * Unique identifier for the vehicle.
         */
        id?: string

        /**
         * Unique identifier for the organization.
         */
        organizationId: string

        /**
         * Reference to the vehicle model's unique identifier.
         */
        modelId: string

        /**
         * Registration number of the vehicle; nullable for vehicles like bikes that may not be registered.
         */
        registrationNumber: string

        /**
         * Indicates whether the vehicle details have been verified. Enum values: VERIFIED, INDIRECTLY_VERIFIED, UNVERIFIED.
         */
        verificationTag: models.VerificationType

        /**
         * VIN (Vehicle Identification Number) of the vehicle
         */
        vehicleIdentificationNumber: string

        /**
         * Specifies the type of fuel the vehicle uses, which could be a hybrid or purely electric.
         */
        usedFuel: string

        /**
         * Measures the vehicle's emissions factor based on the fuel type, indicating its environmental impact.
         */
        emissionsByFuel?: number

        /**
         * Indicates the vehicle's fuel consumption rate, measured in liters per kilometer or kWh per kilometer.
         */
        fuelConsumptionRate?: number

        /**
         * Specifies the vehicle's usage types, such as Last mile, line haul pickup, etc.
         */
        vehicleUsageTypes: models.RouteSegmentType[]

        /**
         * List of transport method IDs associated with the vehicle
         */
        transportMethodIds?: string[]
    }

    /**
     * Struct representing the response from UpsertOrganizationVehicle
     * 
     * It contains the number of rows affected by the upsert operation.
     */
    export interface UpsertOrganizationVehicleResponse {
        /**
         * Number of rows affected by the upsert operation.
         */
        rowsAffected: number
    }

    /**
     * UpsertRetailerCredentialsParams represents the parameters required
     * for upserting the credentials related to a retailer.
     */
    export interface UpsertRetailerCredentialsParams {
        /**
         * Id represents the unique identifier for the retailer credentials.
         */
        id?: string

        /**
         * TransporterId is the identifier for the associated transporter.
         */
        transporterId: string

        /**
         * CredentialType denotes the type of the credential data (e.g., API key, username/password).
         */
        credentialType: models.CredentialDataType

        /**
         * CredentialKey could be empty (if it's an API key), a username, or a client ID.
         */
        credentialKey: string

        /**
         * CredentialValue represents the actual value for the credential, such as an API key, password, or secret.
         */
        credentialValue: string

        /**
         * CustomerNumber represents the customer number given to a retailer by a transporter.
         */
        customerNumber: string
    }

    /**
     * UpsertRetailerCredentialsResponse is the response returned after
     * upserting the retailer credentials, containing the ID of the upserted/updated credentials.
     */
    export interface UpsertRetailerCredentialsResponse {
        /**
         * Id represents the unique identifier for the retailer credentials that were upserted or updated.
         */
        id: string
    }

    export interface UpsertRetailerStoreMaxDistanceParams {
        /**
         * Max distance allowed for a store to be shown as a alternative
         */
        maxDistance: number
    }

    /**
     * Struct representing the request body to UpsertVehicleModel
     * 
     * This model represents the details of a vehicle model in the system.
     * It includes information about the vehicle's physical dimensions,
     * engine type, and environmental impact factors such as emissions and fuel consumption.
     */
    export interface UpsertVehicleModelParams {
        /**
         * unique identifier of the vehicle model.
         */
        id: string

        /**
         * name of the vehicle model.
         */
        modelName: string

        /**
         * represents identifies different versions of the same model.
         */
        variant: string

        /**
         * name of the company that manufactures the vehicle.
         */
        manufacturer: string

        /**
         * length of the vehicle in mm.
         */
        vehicleLength: number

        /**
         * height of the vehicle in mm.
         */
        vehicleHeight: number

        /**
         * width of the vehicle in mm.
         */
        vehicleWidth: number

        /**
         * weight of the vehicle without load in kilograms.
         */
        vehicleWeightEmpty: number

        /**
         * length of the storage area in mm.
         */
        storageLength: number

        /**
         * width of the storage area in mm.
         */
        storageWidth: number

        /**
         * height of the storage area in meters.
         */
        storageHeight: number

        /**
         * indicates if the vehicle has facilities for frozen storage.
         */
        frozenStorage: boolean

        /**
         * type of engine the vehicle uses.
         */
        engineType: models.EngineType

        /**
         * maximum load weight the vehicle can carry in kilograms.
         */
        maxLoadWeight: number

        /**
         * vehicle's emissions per kilometer .
         */
        referenceEmissionsByDistance?: number

        /**
         * vehicle's fuel consumption rate in liters per kilometer or kWh per kilometer.
         */
        referenceFuelConsumptionRate?: number

        vehicleUsageTypes: models.RouteSegmentType[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.AddUploadedTransportAgreement = this.AddUploadedTransportAgreement.bind(this)
            this.CalculateCostForAllMethods = this.CalculateCostForAllMethods.bind(this)
            this.CalculateCostForMethod = this.CalculateCostForMethod.bind(this)
            this.CostCalculationLive = this.CostCalculationLive.bind(this)
            this.DeleteAliasForRetailerMethod = this.DeleteAliasForRetailerMethod.bind(this)
            this.DeleteDigitalTransportAgreement = this.DeleteDigitalTransportAgreement.bind(this)
            this.DeleteEngineFuelLookup = this.DeleteEngineFuelLookup.bind(this)
            this.DeleteMethodForRetailer = this.DeleteMethodForRetailer.bind(this)
            this.DeleteOrganizationVehicleByID = this.DeleteOrganizationVehicleByID.bind(this)
            this.DeleteOrganizationVehicleLocationRangeByID = this.DeleteOrganizationVehicleLocationRangeByID.bind(this)
            this.DeleteRetailerCredentialByTransporterId = this.DeleteRetailerCredentialByTransporterId.bind(this)
            this.DeleteTransportMethodLocation = this.DeleteTransportMethodLocation.bind(this)
            this.DeleteTransportMethodVehicleByVehicle = this.DeleteTransportMethodVehicleByVehicle.bind(this)
            this.DeleteVehicleModelByID = this.DeleteVehicleModelByID.bind(this)
            this.DeleteVehicleModelClassification = this.DeleteVehicleModelClassification.bind(this)
            this.ExpressCostCalculation = this.ExpressCostCalculation.bind(this)
            this.GetActiveDigitalTransportAgreementForMethod = this.GetActiveDigitalTransportAgreementForMethod.bind(this)
            this.GetAllCapacityUtilization = this.GetAllCapacityUtilization.bind(this)
            this.GetAllDigitalTransportAgreementLabels = this.GetAllDigitalTransportAgreementLabels.bind(this)
            this.GetAllDigitalTransportAgreementsForRetailer = this.GetAllDigitalTransportAgreementsForRetailer.bind(this)
            this.GetAllEngineTypes = this.GetAllEngineTypes.bind(this)
            this.GetAllFuelTypes = this.GetAllFuelTypes.bind(this)
            this.GetAllMethodsAndCodes = this.GetAllMethodsAndCodes.bind(this)
            this.GetAllOrganizationShippingTaxRates = this.GetAllOrganizationShippingTaxRates.bind(this)
            this.GetAllOrganizationVehicleLocationRanges = this.GetAllOrganizationVehicleLocationRanges.bind(this)
            this.GetAllOrganizationVehiclesByOrganizationID = this.GetAllOrganizationVehiclesByOrganizationID.bind(this)
            this.GetAllOrganizationVehiclesPagination = this.GetAllOrganizationVehiclesPagination.bind(this)
            this.GetAllRetailerCredentialsByRetailerId = this.GetAllRetailerCredentialsByRetailerId.bind(this)
            this.GetAllTransportMethods = this.GetAllTransportMethods.bind(this)
            this.GetAllUploadedTransportAgreementFilesForRetailer = this.GetAllUploadedTransportAgreementFilesForRetailer.bind(this)
            this.GetAllVehicleClassificationStandards = this.GetAllVehicleClassificationStandards.bind(this)
            this.GetAllVehicleModels = this.GetAllVehicleModels.bind(this)
            this.GetAllVehicleModelsByIds = this.GetAllVehicleModelsByIds.bind(this)
            this.GetCustomParameterForMethod = this.GetCustomParameterForMethod.bind(this)
            this.GetDigitalTransportAgreementById = this.GetDigitalTransportAgreementById.bind(this)
            this.GetDigitalTransportAgreementByTransportMethodAlias = this.GetDigitalTransportAgreementByTransportMethodAlias.bind(this)
            this.GetDigitalTransportAgreementLabels = this.GetDigitalTransportAgreementLabels.bind(this)
            this.GetDigitalTransportAgreementTemplates = this.GetDigitalTransportAgreementTemplates.bind(this)
            this.GetDigitalTransportAgreementsForMethod = this.GetDigitalTransportAgreementsForMethod.bind(this)
            this.GetEngineFuelLookupsByEngineType = this.GetEngineFuelLookupsByEngineType.bind(this)
            this.GetLatestCapacityUtilizationBySegmentTypeEndpoint = this.GetLatestCapacityUtilizationBySegmentTypeEndpoint.bind(this)
            this.GetLocationsForTransportMethods = this.GetLocationsForTransportMethods.bind(this)
            this.GetMethodForRetailer = this.GetMethodForRetailer.bind(this)
            this.GetMethodsForRetailer = this.GetMethodsForRetailer.bind(this)
            this.GetMethodsForRetailerByRetailerID = this.GetMethodsForRetailerByRetailerID.bind(this)
            this.GetOrganizationVehicleByID = this.GetOrganizationVehicleByID.bind(this)
            this.GetOrganizationVehicleLocationRangeByID = this.GetOrganizationVehicleLocationRangeByID.bind(this)
            this.GetOrganizationVehicleLocationRangesByVehicleID = this.GetOrganizationVehicleLocationRangesByVehicleID.bind(this)
            this.GetRetailerCredentialsByTransporterId = this.GetRetailerCredentialsByTransporterId.bind(this)
            this.GetRetailerStoreMaxDistance = this.GetRetailerStoreMaxDistance.bind(this)
            this.GetRouteSegments = this.GetRouteSegments.bind(this)
            this.GetSignedUrlForTransportAgreement = this.GetSignedUrlForTransportAgreement.bind(this)
            this.GetSkrymCostForOrders = this.GetSkrymCostForOrders.bind(this)
            this.GetTransportMethodByAliases = this.GetTransportMethodByAliases.bind(this)
            this.GetTransportMethodsForLocationEndpoint = this.GetTransportMethodsForLocationEndpoint.bind(this)
            this.GetTransportMethodsForVehicle = this.GetTransportMethodsForVehicle.bind(this)
            this.GetTransporterAndMethodMaps = this.GetTransporterAndMethodMaps.bind(this)
            this.GetTransporterByAlias = this.GetTransporterByAlias.bind(this)
            this.GetTransporterByName = this.GetTransporterByName.bind(this)
            this.GetTransporters = this.GetTransporters.bind(this)
            this.GetUploadedTransportAgreements = this.GetUploadedTransportAgreements.bind(this)
            this.GetVehicleClasses = this.GetVehicleClasses.bind(this)
            this.GetVehicleModelByID = this.GetVehicleModelByID.bind(this)
            this.GetVehicleModelClassificationsByVehicleID = this.GetVehicleModelClassificationsByVehicleID.bind(this)
            this.InsertAliasForRetailerMethods = this.InsertAliasForRetailerMethods.bind(this)
            this.InsertEngineFuelLookup = this.InsertEngineFuelLookup.bind(this)
            this.InsertMethodsForRetailer = this.InsertMethodsForRetailer.bind(this)
            this.InsertRouteSegmentCapacityUtilization = this.InsertRouteSegmentCapacityUtilization.bind(this)
            this.InsertTransportMethodLocation = this.InsertTransportMethodLocation.bind(this)
            this.InsertTransportMethodVehicles = this.InsertTransportMethodVehicles.bind(this)
            this.InsertVehicleModelClassifications = this.InsertVehicleModelClassifications.bind(this)
            this.InsertVehiclesForTransportMethod = this.InsertVehiclesForTransportMethod.bind(this)
            this.ReplaceOrganizationVehicleLocationRange = this.ReplaceOrganizationVehicleLocationRange.bind(this)
            this.UpdateDisplayNameForRetailerMethod = this.UpdateDisplayNameForRetailerMethod.bind(this)
            this.UpsertCustomParameterForMethod = this.UpsertCustomParameterForMethod.bind(this)
            this.UpsertDigitalTransportAgreement = this.UpsertDigitalTransportAgreement.bind(this)
            this.UpsertOrganizationShippingTaxRates = this.UpsertOrganizationShippingTaxRates.bind(this)
            this.UpsertOrganizationVehicle = this.UpsertOrganizationVehicle.bind(this)
            this.UpsertOrganizationVehicleLocationRange = this.UpsertOrganizationVehicleLocationRange.bind(this)
            this.UpsertRetailerCredentials = this.UpsertRetailerCredentials.bind(this)
            this.UpsertRetailerStoreMaxDistance = this.UpsertRetailerStoreMaxDistance.bind(this)
            this.UpsertVehicleModel = this.UpsertVehicleModel.bind(this)
        }

        public async AddUploadedTransportAgreement(params: AddUploadedTransportAgreementParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.AddUploadedTransportAgreement`, JSON.stringify(params))
        }

        /**
         * CalculateCostForAllMethods calculates the cost for all methods by fetching the agreements
         * 
         * Calculates cost for all methods by fetching agreements and tying them. Allows the `OnlyActive` flag to be provided
         * for indicating whether to only calculate for active methods and agreements.
         */
        public async CalculateCostForAllMethods(params: CalculateCostForAllMethodsParams): Promise<CalculateCostForMultipleMethodsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.CalculateCostForAllMethods`, JSON.stringify(params))
            return await resp.json() as CalculateCostForMultipleMethodsResponse
        }

        /**
         * CalculateCostForMethod calculates the cost for a single transport method and object
         * 
         * Calculates cost for one object and one passed transport method ID. Will only work if
         * the method has an active digital transport agreement. If you instead want to provide the alias
         * for the method, you should instead use core.DeliveryCost.
         */
        public async CalculateCostForMethod(params: CalculateCostForMethodParams): Promise<CalculateCostResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.CalculateCostForMethod`, JSON.stringify(params))
            return await resp.json() as CalculateCostResponse
        }

        public async CostCalculationLive(params: CostCalculationParams): Promise<CostCalculationLiveResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.CostCalculationLive`, JSON.stringify(params))
            return await resp.json() as CostCalculationLiveResponse
        }

        public async DeleteAliasForRetailerMethod(params: DeleteMethodForAliasRetailerParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteAliasForRetailerMethod`, JSON.stringify(params))
        }

        /**
         * DeleteDigitalTransportAgreement deletes a digital transport agreement by its ID.
         * 
         * Parameters:
         * - in:  The DeleteDigitalTransportAgreementParams object containing the ID of the agreement to be deleted.
         * 
         * Returns:
         * - error: Returns an error if any issue occurs during the deletion process or if the agreement does not exist.
         * 
         * The function performs the following steps:
         *  1. Retrieves the digital transport agreement from the repository using the provided 'AgreementId' from 'in' for existence validation.
         *  2. Begins a transaction for atomicity and consistency.
         *  3. Deletes the digital transport agreement from the repository using the provided 'AgreementId' and the transaction context.
         *  4. Commits the transaction if the deletion is successful.
         *  5. Returns an error if any issue occurs during the deletion process or if the agreement does not exist.
         *     The returned error may be of type errs.Error, containing a specific error code and message.
         *     The error may also be a standard Go error type.
         */
        public async DeleteDigitalTransportAgreement(params: DeleteDigitalTransportAgreementParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteDigitalTransportAgreement`, JSON.stringify(params))
        }

        /**
         * Deleter for EngineFuelLookups
         * 
         * DeleteEngineFuelLookup handles the deletion of specific engine fuel lookup entries from the database.
         * It requires both engine_type and fuel_type to identify the records to be deleted.
         */
        public async DeleteEngineFuelLookup(params: DeleteEngineFuelLookupParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteEngineFuelLookup`, JSON.stringify(params))
        }

        public async DeleteMethodForRetailer(params: DeleteMethodForRetailerParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteMethodForRetailer`, JSON.stringify(params))
        }

        /**
         * Deleter for organization vehicles
         * 
         * # DeleteOrganizationVehicleByID handles the deletion of an organization vehicle from the database and attempts to delete the organization vehicle specified by the provided VehicleID
         */
        public async DeleteOrganizationVehicleByID(params: DeleteOrganizationVehicleByIDParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteOrganizationVehicleByID`, JSON.stringify(params))
        }

        /**
         * Deleter for organization vehicle location ranges
         * 
         * DeleteOrganizationVehicleLocationRangeByID handles the deletion of an organization vehicle location range from the database and attempts to delete the location range specified by the provided LocationRangeID.
         */
        public async DeleteOrganizationVehicleLocationRangeByID(params: DeleteOrganizationVehicleLocationRangeByIDParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteOrganizationVehicleLocationRangeByID`, JSON.stringify(params))
        }

        /**
         * DeleteRetailerCredentialByTransporterId is an API endpoint that deletes a retailer's
         * credentials associated with a given transporter ID. The function starts a database
         * transaction, deletes the credentials and commits the transaction if successful.
         * 
         * The function uses the context to control cancellations and timeouts and requires
         * authentication (as denoted by the `encore: api auth` directive).
         * 
         * It returns an error if something goes wrong, especially during the database operations
         * or if the given transporter's credentials are not found.
         */
        public async DeleteRetailerCredentialByTransporterId(params: DeleteRetailerCredentialByTransporterIdParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteRetailerCredentialByTransporterId`, JSON.stringify(params))
        }

        /**
         * DeleteTransportMethodLocation connects a TransportMethod to a Organization location
         */
        public async DeleteTransportMethodLocation(params: DeleteTransportMethodLocationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteTransportMethodLocation`, JSON.stringify(params))
        }

        /**
         * Deleter for TransportMethodVehicles by OrganizationVehicleID
         * 
         * DeleteTransportMethodVehicleByVehicle deletes transport methods associated with an organization vehicle
         */
        public async DeleteTransportMethodVehicleByVehicle(params: DeleteTransportMethodVehicleByVehicleParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteTransportMethodVehicleByVehicle`, JSON.stringify(params))
        }

        /**
         * Deleter for Vehicle Model
         * 
         * # DeleteVehicleModelByID handles the deletion of a vehicle model from the database and attempts to delete the vehicle model specified by the provided VehicleID
         */
        public async DeleteVehicleModelByID(params: DeleteVehicleModelByIDParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteVehicleModelByID`, JSON.stringify(params))
        }

        /**
         * Deleter for VehicleModelClassification
         * 
         * DeleteVehicleModelClassification handles the deletion of a specific vehicle model classification from the database.
         * It requires both vehicle_id and vehicle_class_id to identify the record to be deleted.
         */
        public async DeleteVehicleModelClassification(params: DeleteVehicleModelClassificationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.DeleteVehicleModelClassification`, JSON.stringify(params))
        }

        /**
         * ExpressCostCalculation is used as a wrapper for when we want to calculate a high amount of costs without trace overhead
         * 
         * It accepts the freight objects with references and identifiers of which agreement to use
         */
        public async ExpressCostCalculation(params: ExpressCostCalculationParams): Promise<ExpressCostCalculationParamsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.ExpressCostCalculation`, JSON.stringify(params))
            return await resp.json() as ExpressCostCalculationParamsResponse
        }

        /**
         * GetActiveDigitalTransportAgreementForMethod retrieves the activated digital transport agreement for a specific retailer and transport method.
         */
        public async GetActiveDigitalTransportAgreementForMethod(params: GetActiveDigitalTransportAgreementForMethodParams): Promise<GetDigitalTransportAgreementResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetActiveDigitalTransportAgreementForMethod`, JSON.stringify(params))
            return await resp.json() as GetDigitalTransportAgreementResponse
        }

        /**
         * GetAllCapacityUtilization returns a decendingly SORTED slice of route segment utilization percentages.
         * Returns no error for empty slice
         */
        public async GetAllCapacityUtilization(): Promise<GetLatestCapacityUtilizationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllCapacityUtilization`)
            return await resp.json() as GetLatestCapacityUtilizationResponse
        }

        /**
         * GetAllDigitalTransportAgreementLabels helps retrieve a map from all the uuids to the corresponding human-readable info (code, descriptions, etc)
         */
        public async GetAllDigitalTransportAgreementLabels(): Promise<GetAllDigitalTransportAgreementLabelsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllDigitalTransportAgreementLabels`)
            return await resp.json() as GetAllDigitalTransportAgreementLabelsResponse
        }

        /**
         * GetAllDigitalTransportAgreementsForRetailer retrieves all digital transport agreements associated with a specific retailer.
         */
        public async GetAllDigitalTransportAgreementsForRetailer(): Promise<GetDigitalTransportAgreementsForMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllDigitalTransportAgreementsForRetailer`)
            return await resp.json() as GetDigitalTransportAgreementsForMethodResponse
        }

        /**
         * Getter for Engine types
         * 
         * GetAllEngineTypes retrieves all engine types from the database.
         */
        public async GetAllEngineTypes(): Promise<GetAllEngineTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllEngineTypes`)
            return await resp.json() as GetAllEngineTypesResponse
        }

        /**
         * Getter for fuel types
         * 
         * GetAllFuelTypes retrieves all fuel types and their details from the database.
         */
        public async GetAllFuelTypes(): Promise<GetAllFuelTypesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllFuelTypes`)
            return await resp.json() as GetAllFuelTypesResponse
        }

        /**
         * GetAllMethodsAndCodes fetches all the codes used by a transporter to refer to its transport methods
         * 
         * The function accepts an optional argument to filter on transporters. If no value is provided, it will return the results for all transporters.
         */
        public async GetAllMethodsAndCodes(params: GetAllTransportMethodsAndCodesParams): Promise<GetAllTransportMethodsAndCodesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllMethodsAndCodes`, JSON.stringify(params))
            return await resp.json() as GetAllTransportMethodsAndCodesResponse
        }

        public async GetAllOrganizationShippingTaxRates(): Promise<GetAllOrganizationShippingTaxRatesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllOrganizationShippingTaxRates`)
            return await resp.json() as GetAllOrganizationShippingTaxRatesResponse
        }

        /**
         * Endpoint for getting all Organization Vehicle Location Ranges for a given organization ID
         * 
         * GetAllOrganizationVehicleLocationRanges retrieves all organization vehicle location range records for a given organization ID from the database.
         * The function queries the location range data and returns it in the GetAllOrganizationVehicleLocationRangesResponse struct.
         */
        public async GetAllOrganizationVehicleLocationRanges(params: GetAllOrganizationVehicleLocationRangesParams): Promise<GetAllOrganizationVehicleLocationRangesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllOrganizationVehicleLocationRanges`, JSON.stringify(params))
            return await resp.json() as GetAllOrganizationVehicleLocationRangesResponse
        }

        /**
         * Wrapper function for bulk fetching Organization Vehicles by Organization ID
         * 
         * GetAllOrganizationVehiclesByOrganizationID retrieves all organization vehicles from the database based on the provided OrganizationID.
         * The function queries the vehicle model data and returns it in the GetAllOrganizationVehiclesResponse struct.
         */
        public async GetAllOrganizationVehiclesByOrganizationID(): Promise<GetAllOrganizationVehiclesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllOrganizationVehiclesByOrganizationID`)
            return await resp.json() as GetAllOrganizationVehiclesResponse
        }

        /**
         * Wrapper function for bulk fetching Organization Vehicles by Organization ID
         * 
         * GetAllOrganizationVehicles retrieves all organization vehicles from the database for all organizations.
         * The function queries the vehicle model data and returns it in the GetAllOrganizationVehiclesResponse struct.
         */
        public async GetAllOrganizationVehiclesPagination(params: GetAllOrganizationVehiclesPaginationParams): Promise<GetAllOrganizationVehiclesPaginationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllOrganizationVehiclesPagination`, JSON.stringify(params))
            return await resp.json() as GetAllOrganizationVehiclesPaginationResponse
        }

        /**
         * GetAllRetailerCredentialsByRetailerId is an API endpoint that retrieves all retailer
         * credentials associated with the authenticated retailer's ID. The credentials are decrypted
         * before being returned in the response.
         * 
         * The function uses the context to control cancellations and timeouts and requires
         * authentication (as noted by the `encore: api auth` directive).
         * 
         * It returns the GetAllRetailerCredentialsByRetailerIdResponse containing the decrypted
         * retailer credentials or an error if something goes wrong.
         */
        public async GetAllRetailerCredentialsByRetailerId(): Promise<GetAllRetailerCredentialsByRetailerIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllRetailerCredentialsByRetailerId`)
            return await resp.json() as GetAllRetailerCredentialsByRetailerIdResponse
        }

        public async GetAllTransportMethods(): Promise<GetAllTransportMethodsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllTransportMethods`)
            return await resp.json() as GetAllTransportMethodsResponse
        }

        public async GetAllUploadedTransportAgreementFilesForRetailer(): Promise<GetUploadedTransportAgreementsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllUploadedTransportAgreementFilesForRetailer`)
            return await resp.json() as GetUploadedTransportAgreementsResponse
        }

        /**
         * Getter for VehicleClassificationStandards
         * 
         * GetAllVehicleClassificationStandards retrieves all vehicle classification standards from the database.
         */
        public async GetAllVehicleClassificationStandards(): Promise<GetAllVehicleClassificationStandardsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllVehicleClassificationStandards`)
            return await resp.json() as GetAllVehicleClassificationStandardsResponse
        }

        /**
         * GetAllVehicleModels retrieves all vehicle models from the database.
         * The function queries the vehicle model data and returns it in the GetAllVehicleModelsResponse struct.
         */
        public async GetAllVehicleModels(params: GetAllVehicleModelsParams): Promise<GetAllVehicleModelsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllVehicleModels`, JSON.stringify(params))
            return await resp.json() as GetAllVehicleModelsResponse
        }

        /**
         * GetAllVehicleModelsByIds retrieves all vehicle models from the database based on the provided vehicleModelIds.
         */
        public async GetAllVehicleModelsByIds(params: GetAllVehicleModelsByIdsParams): Promise<GetAllVehicleModelsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetAllVehicleModelsByIds`, JSON.stringify(params))
            return await resp.json() as GetAllVehicleModelsResponse
        }

        /**
         * GetCustomParameterForMethod fetches a custom parameter associated with the provided method ID.
         * 
         * Parameters:
         * - in: The TransportMethodID.
         * 
         * Returns:
         * - The custom parameter key.
         * - An error if the custom parameter couldn't be fetched.
         * 
         * If no rows are found in the database for the provided Method ID, a "NotFound" error is returned.
         * Otherwise, an "Internal" error is returned for other issues.
         */
        public async GetCustomParameterForMethod(params: GetCustomParameterForMethodParams): Promise<GetCustomParameterForMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetCustomParameterForMethod`, JSON.stringify(params))
            return await resp.json() as GetCustomParameterForMethodResponse
        }

        /**
         * GetDigitalTransportAgreementById retrieves a digital transport agreement by its ID.
         */
        public async GetDigitalTransportAgreementById(params: GetDigitalTransportAgreementParams): Promise<GetDigitalTransportAgreementResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetDigitalTransportAgreementById`, JSON.stringify(params))
            return await resp.json() as GetDigitalTransportAgreementResponse
        }

        public async GetDigitalTransportAgreementByTransportMethodAlias(params: GetDigitalTransportAgreementByTransportMethodAliasParams): Promise<GetDigitalTransportAgreementByTransportMethodAliasResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetDigitalTransportAgreementByTransportMethodAlias`, JSON.stringify(params))
            return await resp.json() as GetDigitalTransportAgreementByTransportMethodAliasResponse
        }

        /**
         * GetDigitalTransportAgreementLabels helps retrieve a map from all the uuids to the corresponding human-readable info (code, descriptions, etc)
         */
        public async GetDigitalTransportAgreementLabels(params: GetDigitalTransportAgreementLabelsRequest): Promise<GetDigitalTransportAgreementLabelsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetDigitalTransportAgreementLabels`, JSON.stringify(params))
            return await resp.json() as GetDigitalTransportAgreementLabelsResponse
        }

        /**
         * Fetch all the digital transport agreement templates.
         */
        public async GetDigitalTransportAgreementTemplates(params: GetDigitalTransportAgreementTemplatesParams): Promise<GetDigitalTransportAgreementTemplatesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetDigitalTransportAgreementTemplates`, JSON.stringify(params))
            return await resp.json() as GetDigitalTransportAgreementTemplatesResponse
        }

        /**
         * GetDigitalTransportAgreementsForMethod retrieves all DTAs associated with a specific transport method.
         */
        public async GetDigitalTransportAgreementsForMethod(params: GetDigitalTransportAgreementByMethodParams): Promise<GetDigitalTransportAgreementsForMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetDigitalTransportAgreementsForMethod`, JSON.stringify(params))
            return await resp.json() as GetDigitalTransportAgreementsForMethodResponse
        }

        /**
         * Getter for EngineFuelLookups
         * 
         * GetEngineFuelLookupsByEngineType fetches all fuel type compatibilities for a specific engine type.
         */
        public async GetEngineFuelLookupsByEngineType(params: GetEngineFuelLookupsByEngineTypeParams): Promise<GetEngineFuelLookupsByEngineTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetEngineFuelLookupsByEngineType`, JSON.stringify(params))
            return await resp.json() as GetEngineFuelLookupsByEngineTypeResponse
        }

        /**
         * GetLatestCapacityUtilizationBySegmentTypeEndpoint retrieves the latest capacity utilization for each segment type associated with the passed in transporter.
         * It returns a list of utilization records, each representing the most recent entry for a specific segment type.
         * 
         * The endpoint requires authentication and uses the authenticated user's account role to verify they have the Skrym Admin permission to fetch the data.
         * It returns an array of RouteSegmentCapacityUtilization models, each containing details about a segment type's latest capacity utilization.
         */
        public async GetLatestCapacityUtilizationBySegmentTypeEndpoint(params: GetLatestCapacityUtilizationBySegmentTypeParams): Promise<GetLatestCapacityUtilizationBySegmentTypeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetLatestCapacityUtilizationBySegmentTypeEndpoint`, JSON.stringify(params))
            return await resp.json() as GetLatestCapacityUtilizationBySegmentTypeResponse
        }

        /**
         * GetLocationsForTransportMethods retrieves locations associated with specified transport methods.
         * The function checks the caller's permissions before proceeding with the lookup. If the caller lacks the necessary permissions,
         * it returns an error. Otherwise, it fetches and returns a mapping of transport method IDs to location IDs where those methods are applicable.
         * 
         * Parameters:
         * - ctx: Context for request scoping, cancellation, and authentication data.
         * - params: Parameters specifying the transport methods by their IDs.
         * 
         * Returns:
         * - A pointer to GetLocationsForTransportMethodsResponse containing the mapping of transport method IDs to location IDs.
         * - An error if the operation fails, either due to permission issues or internal errors during data retrieval.
         */
        public async GetLocationsForTransportMethods(params: GetLocationsForTransportMethodsParams): Promise<GetLocationsForTransportMethodsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetLocationsForTransportMethods`, JSON.stringify(params))
            return await resp.json() as GetLocationsForTransportMethodsResponse
        }

        public async GetMethodForRetailer(params: GetMethodForRetailerParams): Promise<GetMethodForRetailerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetMethodForRetailer`, JSON.stringify(params))
            return await resp.json() as GetMethodForRetailerResponse
        }

        public async GetMethodsForRetailer(params: GetMethodsForRetailerParams): Promise<GetMethodsForRetailerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetMethodsForRetailer`, JSON.stringify(params))
            return await resp.json() as GetMethodsForRetailerResponse
        }

        public async GetMethodsForRetailerByRetailerID(params: GetMethodsForRetailerByRetailerIDParams): Promise<GetMethodsForRetailerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetMethodsForRetailerByRetailerID`, JSON.stringify(params))
            return await resp.json() as GetMethodsForRetailerResponse
        }

        /**
         * Getter for Organization Vehicle
         * 
         * GetOrganizationVehicleByID retrieves an organization vehicle from the database based on the provided OrganizationVehicleID.
         * The function queries the vehicle model data and returns it in the GetOrganizationVehicleByIDResponse struct.
         */
        public async GetOrganizationVehicleByID(params: GetOrganizationVehicleByIDParams): Promise<GetOrganizationVehicleByIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetOrganizationVehicleByID`, JSON.stringify(params))
            return await resp.json() as GetOrganizationVehicleByIDResponse
        }

        /**
         * Getter for Organization Vehicle Location Range
         * 
         * GetOrganizationVehicleLocationRangeByID retrieves a specific organization vehicle location range record from the database using its ID.
         * The function queries the location range data and returns it in the GetOrganizationVehicleLocationRangeByIDResponse struct.
         */
        public async GetOrganizationVehicleLocationRangeByID(params: GetOrganizationVehicleLocationRangeByIDParams): Promise<GetOrganizationVehicleLocationRangeByIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetOrganizationVehicleLocationRangeByID`, JSON.stringify(params))
            return await resp.json() as GetOrganizationVehicleLocationRangeByIDResponse
        }

        /**
         * Getter for Organization Vehicle Location Range
         * 
         * GetOrganizationVehicleLocationRangeByVehicleID retrieves a specific organization vehicle location range record from the database using the vehicle's ID.
         * The function queries the location range data and returns it in the GetOrganizationVehicleLocationRangeByVehicleIDResponse struct.
         */
        public async GetOrganizationVehicleLocationRangesByVehicleID(params: GetOrganizationVehicleLocationRangesByVehicleIDParams): Promise<GetOrganizationVehicleLocationRangesByVehicleIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetOrganizationVehicleLocationRangesByVehicleID`, JSON.stringify(params))
            return await resp.json() as GetOrganizationVehicleLocationRangesByVehicleIDResponse
        }

        /**
         * GetRetailerCredentialsByTransporterId is an API endpoint that retrieves the retailer
         * credentials associated with a given transporter ID. The credentials are decrypted
         * before being returned in the response.
         * 
         * It returns the GetRetailerCredentialsByTransporterIdResponse containing the decrypted
         * retailer credentials or an error if something goes wrong.
         */
        public async GetRetailerCredentialsByTransporterId(params: GetRetailerCredentialsByTransporterIdParams): Promise<GetRetailerCredentialsByTransporterIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetRetailerCredentialsByTransporterId`, JSON.stringify(params))
            return await resp.json() as GetRetailerCredentialsByTransporterIdResponse
        }

        public async GetRetailerStoreMaxDistance(): Promise<GetRetailerStoreMaxDistanceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetRetailerStoreMaxDistance`)
            return await resp.json() as GetRetailerStoreMaxDistanceResponse
        }

        /**
         * GetRouteSegments fetches and calculates the route segments for a given transport method between
         * two locations within an organization's operation. It uses the organization's locations, transport
         * method locations, and vehicle location ranges to determine the possible route segments and the
         * vehicle models that can operate on these segments.
         * 
         * This function performs several key operations:
         * 1. Fetches the organization's locations.
         * 2. Fetches the transport method locations for the specified transport method.
         * 3. Retrieves the organization's location range configuration.
         * 4. Fetches all vehicle location ranges for the organization.
         * 5. Calculates the route using the fetched data and the provided from and to locations.
         * 6. Determines the unique vehicle model IDs that are possible for the calculated route segments.
         */
        public async GetRouteSegments(params: GetRouteSegmentsParams): Promise<GetRouteSegmentsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetRouteSegments`, JSON.stringify(params))
            return await resp.json() as GetRouteSegmentsResponse
        }

        /**
         * Retrieves a file id and a presigned url for a transport agreement to be uploaded
         */
        public async GetSignedUrlForTransportAgreement(params: GetSignedUrlForTransportAgreementParams): Promise<GetSignedUrlForTransportAgreementResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetSignedUrlForTransportAgreement`, JSON.stringify(params))
            return await resp.json() as GetSignedUrlForTransportAgreementResponse
        }

        public async GetSkrymCostForOrders(params: GetSkrymCostForOrdersParams): Promise<GetSkrymCostForOrdersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetSkrymCostForOrders`, JSON.stringify(params))
            return await resp.json() as GetSkrymCostForOrdersResponse
        }

        /**
         * This function ignores fallbackCost, enabled, etc
         * We return a 404 if we do not have the provided aliases.
         */
        public async GetTransportMethodByAliases(params: GetTransportMethodByAliasParams): Promise<GetTransportMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetTransportMethodByAliases`, JSON.stringify(params))
            return await resp.json() as GetTransportMethodResponse
        }

        /**
         * GetTransportMethodsForLocationEndpoint returns transport method IDs for a specified location ID.
         * Requires authentication. Logs and returns errors for any issues encountered.
         */
        public async GetTransportMethodsForLocationEndpoint(params: GetTransportMethodsForLocationParams): Promise<GetTransportMethodsForLocationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetTransportMethodsForLocationEndpoint`, JSON.stringify(params))
            return await resp.json() as GetTransportMethodsForLocationResponse
        }

        /**
         * Getter for TransportMethodVehicles by OrganizationVehicleID
         * 
         * GetTransportMethodsForVehicle fetches transport methods associated with an organization vehicle.
         */
        public async GetTransportMethodsForVehicle(params: GetTransportMethodsForVehicleParams): Promise<GetTransportMethodsForVehicleResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetTransportMethodsForVehicle`, JSON.stringify(params))
            return await resp.json() as GetTransportMethodsForVehicleResponse
        }

        public async GetTransporterAndMethodMaps(): Promise<GetTransporterAndMethodMapsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetTransporterAndMethodMaps`)
            return await resp.json() as GetTransporterAndMethodMapsResponse
        }

        public async GetTransporterByAlias(params: GetTransporterByAliasParams): Promise<GetTransporterByAliasResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetTransporterByAlias`, JSON.stringify(params))
            return await resp.json() as GetTransporterByAliasResponse
        }

        public async GetTransporterByName(params: GetTransporterByNameParams): Promise<GetTransporterByNameResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetTransporterByName`, JSON.stringify(params))
            return await resp.json() as GetTransporterByNameResponse
        }

        /**
         * GetTransporters return all transporters available in Skrym
         */
        public async GetTransporters(): Promise<GetTransportersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetTransporters`)
            return await resp.json() as GetTransportersResponse
        }

        public async GetUploadedTransportAgreements(params: GetUploadedTransportAgreementsParams): Promise<GetUploadedTransportAgreementsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetUploadedTransportAgreements`, JSON.stringify(params))
            return await resp.json() as GetUploadedTransportAgreementsResponse
        }

        /**
         * Getter for VehicleClass
         * 
         * GetVehicleClasses retrieves all vehicle classes for a given classification standard from the database.
         */
        public async GetVehicleClasses(params: GetVehicleClassesParams): Promise<GetVehicleClassesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetVehicleClasses`, JSON.stringify(params))
            return await resp.json() as GetVehicleClassesResponse
        }

        /**
         * Getter for Vehicle Model
         * 
         * GetVehicleModelByID retrieves a vehicle model from the database based on the provided VehicleID.
         * The function queries the vehicle model data and returns it in the GetVehicleModelByIDResponse struct.
         */
        public async GetVehicleModelByID(params: GetVehicleModelByIDParams): Promise<GetVehicleModelByIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetVehicleModelByID`, JSON.stringify(params))
            return await resp.json() as GetVehicleModelByIDResponse
        }

        /**
         * Getter for VehicleModelClassifications
         * 
         * GetVehicleModelClassificationsByVehicleID retrieves a list of vehicle model classifications associated with a specific vehicle ID.
         */
        public async GetVehicleModelClassificationsByVehicleID(params: GetVehicleModelClassificationsByVehicleIDParams): Promise<GetVehicleModelClassificationsByVehicleIDResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.GetVehicleModelClassificationsByVehicleID`, JSON.stringify(params))
            return await resp.json() as GetVehicleModelClassificationsByVehicleIDResponse
        }

        public async InsertAliasForRetailerMethods(params: InsertAliasForRetailerMethodsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.InsertAliasForRetailerMethods`, JSON.stringify(params))
        }

        /**
         * InsertEngineFuelLookup performs a bulk insert operation for engine fuel lookup records.
         * 
         * This function takes a slice of EngineFuelLookup structs from the provided params and inserts them into the database.
         * Each EngineFuelLookup struct typically contains fields like EngineType and FuelType, defining the relationship
         * between a specific engine type and its compatible fuel types. If a mapping already exists in the database, nothing happens;
         * otherwise, a new record is inserted.
         */
        public async InsertEngineFuelLookup(params: InsertEngineFuelLookupParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.InsertEngineFuelLookup`, JSON.stringify(params))
        }

        /**
         * InsertMethodsForRetailer returns the input data along with filled in uuid's (if applicable) on successful insert
         */
        public async InsertMethodsForRetailer(params: InsertMethodsForRetailerParams): Promise<InsertMethodsForRetailerRes> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.InsertMethodsForRetailer`, JSON.stringify(params))
            return await resp.json() as InsertMethodsForRetailerRes
        }

        /**
         * InsertRouteSegmentCapacityUtilization adds a new row to the Route Segment Capacity Utilization table.
         * The value represents the actually utilized space of the available "packable" space in a vehicle given a certain route segment: [PICKUP, LINE HAUL, LAST MILE]
         * Each update is stored with a timestamp. Organization ID gets automatically set to the authenticated organization
         */
        public async InsertRouteSegmentCapacityUtilization(params: InsertRouteSegmentCapacityUtilizationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.InsertRouteSegmentCapacityUtilization`, JSON.stringify(params))
        }

        /**
         * InsertTransportMethodLocation connects a TransportMethod to a Organization location
         */
        public async InsertTransportMethodLocation(params: InsertTransportMethodLocationParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.InsertTransportMethodLocation`, JSON.stringify(params))
        }

        /**
         * Inserter for transport method vehicles.
         * 
         * InserrtTransportMethodVehicles inserts a list of transport method vehicles into the database.
         */
        public async InsertTransportMethodVehicles(params: InsertTransportMethodVehiclesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.InsertTransportMethodVehicles`, JSON.stringify(params))
        }

        /**
         * InsertVehicleModelClassifications performs a bulk insert or update of vehicle model classifications.
         * 
         * This function takes a slice of VehicleModelClassification structs from the params and inserts them into the database.
         * If the vehicle classification already exists (based on the VehicleID and VehicleClassID), it does nothing. Otherwise, it inserts a new record.
         * Returns an error if the insert operation fails or if the parameters are invalid.
         */
        public async InsertVehicleModelClassifications(params: InsertVehicleModelClassificationsParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.InsertVehicleModelClassifications`, JSON.stringify(params))
        }

        /**
         * InsertVehiclesForTransportMethod inserts vehicles associated with a specific transport method.
         * 
         * InsertVehiclesForTransportMethod inserts a list of vehicles (specified by OrgVehicleIDs) for a given transport method
         * identified by TransportMethodID and associated with a transporter identified by TransporterID.
         */
        public async InsertVehiclesForTransportMethod(params: InsertVehiclesForTransportMethodParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.InsertVehiclesForTransportMethod`, JSON.stringify(params))
        }

        /**
         * ReplaceOrganizationVehicleLocationRange inserts vehicle locations range records for an organization vehicle.
         * 
         * Replaces organization vehicle location range entries and deletes if the provided list is empty
         * IDs are generated if none is provided.
         */
        public async ReplaceOrganizationVehicleLocationRange(params: ReplaceOrganizationVehicleLocationRangeParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.ReplaceOrganizationVehicleLocationRange`, JSON.stringify(params))
        }

        public async UpdateDisplayNameForRetailerMethod(params: UpdateDisplayNameForRetailerMethodParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.UpdateDisplayNameForRetailerMethod`, JSON.stringify(params))
        }

        /**
         * UpsertCustomParameterForMethod upserts a custom parameter key that we will use to modify the deliverytimes for RetailerTransporter locations
         * The key should always be stored as the full key e.g. CustomParameters.inStore
         */
        public async UpsertCustomParameterForMethod(params: UpsertCustomParameterForMethodParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.UpsertCustomParameterForMethod`, JSON.stringify(params))
        }

        /**
         * UpsertDigitalTransportAgreement inserts a digital transport agreement into the system.
         * 
         * The function performs the following steps:
         * 1. Fetches the already inserted DTAs for the transport method, and the retailer methods.
         * 2. Validates the input agreement using the Validate function.
         * 3. Begins a new transaction using the provided context 'ctx'.
         * 4. Generates a new ID if 'in.Id' is empty, otherwise uses the provided 'in.Id'.
         * 5. Inserts the digital transport agreement into the repository using the repository.UpsertDigitalTransportAgreement function.
         * 6. Commits the transaction if successful, otherwise rolls back the transaction.
         */
        public async UpsertDigitalTransportAgreement(params: UpsertDigitalTransportAgreementParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.UpsertDigitalTransportAgreement`, JSON.stringify(params))
        }

        public async UpsertOrganizationShippingTaxRates(params: UpsertOrganizationShippingTaxRatesParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.UpsertOrganizationShippingTaxRates`, JSON.stringify(params))
        }

        /**
         * UpsertOrganizationVehicle handles the insertion or update of an organization's vehicle record.
         * 
         * Inserts a new organization vehicle if one with the provided ID doesn't already exist in the database. Updates otherwise. Returns the number of rows affected.
         * An ID is generated if none is provided.
         */
        public async UpsertOrganizationVehicle(params: UpsertOrganizationVehicleParams): Promise<UpsertOrganizationVehicleResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.UpsertOrganizationVehicle`, JSON.stringify(params))
            return await resp.json() as UpsertOrganizationVehicleResponse
        }

        /**
         * UpsertOrganizationVehicleLocationRange inserts or updates a vehicle location range record for an organization.
         * 
         * Inserts a new organization vehicle location range entry if one with the provided locationID - vehicle ID pair doesn't already exist in the database. Updates otherwise.
         * An ID is generated if none is provided.
         */
        public async UpsertOrganizationVehicleLocationRange(params: UpsertOrganizationVehicleLocationRangeParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.UpsertOrganizationVehicleLocationRange`, JSON.stringify(params))
        }

        /**
         * UpsertRetailerCredentials is an API endpoint for upserting the retailer credentials.
         * This function begins a transaction and attempts to insert or update the retailer credentials
         * after encrypting the credential key and value. It then commits the transaction if successful.
         * 
         * It returns the UpsertRetailerCredentialsResponse containing the ID of the upserted/updated credentials,
         * or an error if something goes wrong.
         * 
         * NOTE! This implementation allows for ONE credential per transporter.
         */
        public async UpsertRetailerCredentials(params: UpsertRetailerCredentialsParams): Promise<UpsertRetailerCredentialsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/transportation.UpsertRetailerCredentials`, JSON.stringify(params))
            return await resp.json() as UpsertRetailerCredentialsResponse
        }

        public async UpsertRetailerStoreMaxDistance(params: UpsertRetailerStoreMaxDistanceParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.UpsertRetailerStoreMaxDistance`, JSON.stringify(params))
        }

        /**
         * UpsertVehicleModel attempts to insert or update a vehicle model in the database.
         * 
         * Inserts a new model if a vehicle with the provided ID doesn't already exist in the database. Updates otherwise.
         * An ID is generated if none is provided.
         */
        public async UpsertVehicleModel(params: UpsertVehicleModelParams): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/transportation.UpsertVehicleModel`, JSON.stringify(params))
        }
    }
}

export namespace algorithm {
    /**
     * Box structure
     */
    export interface Box {
        productID: string
        externalProductID: string
        weight: number
        /**
         * coordinates of the left-down-front corner
         */
        coord: number[]

        /**
         * (length, width, height) triplet
         */
        size: number[]

        /**
         * rotation with values in {0,1,2,3,4,5}
         */
        rot: number

        /**
         * True if product has been successfuly placed in the container
         */
        placed: boolean
    }
}

export namespace checkoutmodels {
    export type APIGroup = string

    export interface Address {
        /**
         * Address e.g. "Lidnersgatan 12"
         */
        address: string

        /**
         * Zipcode / Postalcode "112 53"
         */
        postalCode: string

        /**
         * City name "Stockholm"
         */
        city: string

        /**
         * Country using ISO 3166-1 alpha-2 "SE"
         */
        country: string
    }

    export interface AvailableLocationWithTime {
        /**
         * Location of the transporter
         */
        organizationLocation: datamodels.OrganizationLocation

        /**
         * Opening hours tied to the location of the availability event
         */
        organizationOpeningHours: datamodels.OrganizationOpeningHours[]

        /**
         * Special opening hours tied to the location of the availability event
         */
        organizationSpecialOpeningHours: datamodels.OrganizationSpecialOpeningHours[]

        /**
         * Time of delivery
         */
        time: datamodels.SkrymTime

        organizationLocationAliases: datamodels.OrganizationLocationAlias[]
    }

    export interface AverageCheckoutStatisticsDataPoint {
        hourStart: string
        sampleSize: number
        /**
         * in the lowest denomination of the currency, e.g. cents
         */
        displayPrice: number

        /**
         * in the lowest denomination of the currency, e.g. cents
         */
        estimatedCost: number

        /**
         * in the lowest denomination of the currency, e.g. cents
         */
        orderValue: number

        /**
         * in the lowest denomination of the currency, e.g. cents
         */
        estimatedProfitLoss: number
    }

    export interface Basket {
        /**
         * Internal identification
         */
        id: string

        /**
         * Organization that the basket is tied to
         */
        organizationId: string

        /**
         * ID from caller
         */
        externalId: string

        /**
         * Time for when basket was received
         */
        created: string

        /**
         * Address information for where the basket is being sent
         */
        to: Address

        /**
         * Address information for where the basket it sent from
         */
        from: Address

        /**
         * Person / Entity reveiving the package
         */
        receiver: Receiver

        orderItems: OrderItem[]
        parcels: Parcel[]
        /**
         * If a basket has a confirmed payment it is considered a order
         */
        paymentConfirmed: boolean

        /**
         * Unique ID from the checkout provider (will be Basket ID if using Skrym API)
         */
        checkoutProviderId: string

        /**
         * ISO4217
         */
        currency: datamodels.Currency
    }

    /**
     * BucketTest represents the metadata of the bucket test
     * The Checkout references the checkout in the checkouts table
     * The OrganizationID references the id in the retailer table from authentication. This will be updated once we migrate everything to the organization table
     * NOTE: A test bucket can be created at any given time and its start and end dates can only be set to later dates than the created_date
     */
    export interface BucketTest {
        id: string
        name: string
        organizationId: string
        checkout: Checkout
        startDate: string
        endDate: string
        createdDate: string
        createdBy: string
        /**
         * Defaults to DRAFT
         */
        status: BucketTestStatus

        testStrategies: BucketTestStrategy[]
    }

    /**
     * BucketTestFilter is a helper struct for filtering
     * the bucket test table in Scope.
     */
    export interface BucketTestFilter {
        /**
         * Searches the name
         */
        search?: string

        /**
         * Searches the status of the bucket test
         */
        statuses?: BucketTestStatus[]

        /**
         * Searches the checkout of the bucket test
         */
        checkouts?: Checkout[]

        /**
         * Searches the start date of the bucket test, inclusive
         */
        periodStart?: string

        /**
         * Searches the end date of the bucket test, inclusive
         */
        periodEnd?: string
    }

    /**
     * BucketTestSort is a helper struct for sorting
     * the bucket test table in Scope.
     */
    export interface BucketTestSort {
        columnField: BucketTestSortColumn
        /**
         * ASC or DESC
         */
        direction: SortDirection
    }

    /**
     * These are enums used for the server-side sorting and filtering of bucket test tables
     */
    export type BucketTestSortColumn = string

    /**
     * BucketTestStatus is the enum for the current status of any bucket test.
     * BucketTestStatus has 4 types; DRAFT, SCHEDULED, ACTIVE, FINISHED
     */
    export type BucketTestStatus = string

    /**
     * BucketTestStrategy represents the ranking strategy and its weight for given test bucket
     * The StrategyID references the ID of a ranking strategy in checkout_strategy table
     * The BucketTestID references the ID of a bucket test in bucket_test_metadata table
     */
    export interface BucketTestStrategy {
        strategyId: string
        name?: string
        bucketTestId: string
        /**
         * The weight of the strategy, must sum up to 1.0
         */
        percentage: number

        /**
         * The strategy config
         */
        strategy?: JSONValue

        nodeConfigs?: BucketTestStrategyNode[]
    }

    /**
     * BucketTestStrategyNode represents the snapshot of the checkout node config in a strategy at the time of the test
     * The NodeID references the ID of a checkout node in the checkout_node_config table
     * The StrategyID references the ID of a ranking strategy in checkout_strategy table
     * The BucketTestID references the ID of a bucket test in bucket_test table
     */
    export interface BucketTestStrategyNode {
        nodeId: string
        bucketTestId: string
        strategyId: string
        checkout: Checkout
        config: JSONValue
    }

    export type Checkout = string

    /**
     * CheckoutAddon corresponds to checkout_addon table
     */
    export interface CheckoutAddon {
        id: string
        key: string
        title: { [key: iso.IsoLanguage]: string }
        orgId: string
        dataType: CheckoutAddonDataType
        /**
         * Specifies which Icon to display
         */
        icon: string

        /**
         * Specifies color for displaying the addon
         */
        color: string

        createdAt: string
        updatedAt: string
        createdBy: string
        updatedBy: string
        active: boolean
    }

    export interface CheckoutAddonChoice {
        /**
         * Checkout addon ID
         */
        checkoutAddonId: string

        /**
         * Needs to be the same key as for the CheckoutAddon
         */
        key: string

        /**
         * The price to be displayed for the service
         */
        price: number

        /**
         * The currency for the service
         */
        currency: string

        /**
         * Which datatype we should try to parse the user value as (STRING, NUMBER, BOOLEAN)
         */
        dataType: CheckoutAddonDataType

        /**
         * String representation of a user input e.g. (User value: "1" for a number, or "True" for a boolean)
         */
        userValue?: string
    }

    export type CheckoutAddonDataType = string

    export interface CheckoutConversionStatistic {
        organizationId: string
        hourStart: string
        totalPromiseCount: number
        confirmedPromiseCount: number
    }

    export type CheckoutData = { [key: string]: JSONValue }

    export interface CheckoutInput {
        /**
         * Agnostic ID to control which checkout is being "handled"
         */
        sessionId: string

        /**
         * Location of where the order is being shipped from
         */
        from: datamodels.Location

        /**
         * Location of where the order is being shipped to
         */
        to: datamodels.Location

        /**
         * Information about the receiver of the order
         */
        receiver: Receiver

        /**
         * Order Reference (if exists)
         */
        referenceId: string

        /**
         * What does this order contain?
         */
        products: CheckoutProducts

        /**
         * Package information (if available)
         */
        packages: CheckoutPackage[]

        /**
         * ISO 4217 (SEK / USD / EUR)
         */
        currency: datamodels.Currency

        /**
         * Total price of the order (in the lowest denomination of the currency, e.g. cents for EUR and öre for SEK)
         */
        totalPrice: number

        /**
         * Custom parameters to be used in the checkout. This should also handle the Klarna "tags"
         */
        customParams: { [key: string]: JSONValue }
    }

    export interface CheckoutNodeConfig {
        nodeId: string
        retailerId: string
        checkout: Checkout
        config: JSONValue
        enabled: boolean
        updatedAt: string
        updatedBy: string
        strategyId: string
    }

    export interface CheckoutPackage {
        /**
         * external ID of package
         */
        referenceId: string

        /**
         * Unit[mm] Outer dimensions of parcel
         */
        outerDimensions: number[]

        /**
         * Unit [g], Weight of the packed parcel, leave empty/0 if no data
         */
        weight: number

        /**
         * name of package
         */
        name: string

        /**
         * alias of package
         */
        alias: string
    }

    export interface CheckoutProduct {
        /**
         * external id
         */
        referenceId: string

        /**
         * Type of the product
         */
        productType: CheckoutProductType

        /**
         * Quantity of the product
         */
        quantity: number

        /**
         * Price of the product (in the lowest denomination of the currency, e.g. cents for EUR and öre for SEK)
         */
        unitPrice: number

        /**
         * Name of the product. Empty string indicates no name
         */
        name: string

        /**
         * Weight of the product. 0 will be treated as not entered
         */
        weight: number

        /**
         * Dimensions of the product
         */
        dimensions: number[]
    }

    export type CheckoutProductType = string

    export type CheckoutProducts = CheckoutProduct[]

    export interface CheckoutStrategyData {
        id: string
        retailerId: string
        name: string
        createdBy: string
        lastChangeBy: string
        checkoutStrategy: JSONValue
        enabled: boolean
        createdAt: string
        updatedAt: string
        locked: boolean
    }

    export interface CheckoutStrategyDataWithDraft {
        id: string
        retailerId: string
        name: string
        createdBy: string
        lastChangeBy: string
        enabled: boolean
        createdAt: string
        updatedAt: string
        draft: boolean
        locked: boolean
    }

    export interface ConsignorDetails {
        id: string
        transporterId: string
        customerNumber: string
        createdAt: string
        updatedAt: string
    }

    export interface Data {
        selected: boolean
        text: string
    }

    export type KlarnaAddonType = string

    export interface KlarnaAddress {
        "street_address": string
        "postal_code": string
        city: string
        country: string
        region: string
        "street_address2": string
    }

    export interface KlarnaAttributes {
        weight: number
        tags: string[]
        dimensions: KlarnaDimensions
    }

    export interface KlarnaCarrierProduct {
        "addon_identifiers": string[]
        identifier: string
        name: string
    }

    export interface KlarnaCoordinates {
        lat: number
        lng: number
    }

    export interface KlarnaDefault {
        open: string
        close: string
        "always_open": boolean
    }

    export interface KlarnaDimensions {
        height: number
        length: number
        width: number
    }

    export interface KlarnaLines {
        type: string
        reference: string
        quantity: number
        "unit_price": number
        "tax_rate": number
        "total_tax_amount": number
        "total_price_including_tax": number
        "total_discount_amount": number
        attributes: KlarnaAttributes
    }

    export interface KlarnaLocation {
        id: string
        name: string
        price: number
        address: KlarnaAddress
        coordinates: KlarnaCoordinates
        "operational_hours": KlarnaOperationalHours
    }

    export interface KlarnaMon {
        "always_open": boolean
    }

    export interface KlarnaOperationalHours {
        overrides: KlarnaOverrides
        default: KlarnaDefault[]
    }

    export interface KlarnaOptAddon {
        id: string
        "max_length"?: number
        preselected?: boolean
        /**
         * In öre
         */
        price?: number

        /**
         * NOTE: This value is not part of Klarna/Kustoms struct and should therefore not ever be set when sending it over to KSA
         */
        currency?: datamodels.Currency

        required?: boolean
        type?: string
        url?: string
        category?: string
    }

    export interface KlarnaOptAddress {
        city: string
        country: string
        "postal_code": string
        region: string
        "street_address": string
        "street_address2": string
    }

    export interface KlarnaOptArea {
        boundary: KlarnaOptBoundary[]
        price: number
        type: string
    }

    export interface KlarnaOptBoundary {
        lat: number
        lng: number
    }

    export interface KlarnaOptDate {
        date: string
        hours: KlarnaOptDefault
    }

    export interface KlarnaOptDefault {
        "always_open": boolean
        close: string
        closed: boolean
        open: string
    }

    export interface KlarnaOptDeliveryTime {
        interval: KlarnaOptInterval
        cutoff: string
        earliest: string
        latest: string
        "time_of_day": KlarnaOptTimeOfDay
    }

    export interface KlarnaOptFeature {
        class?: string
        "merchant_info_text"?: string
        type?: string
        url?: string
    }

    export interface KlarnaOptInterval {
        earliest: number
        latest: number
        "utc_offset_in_seconds": string
    }

    export interface KlarnaOptLocation {
        address: KlarnaOptAddress
        coordinates: KlarnaOptBoundary
        "delivery_time": KlarnaOptDeliveryTime
        id: string
        name: string
        "operational_hours": KlarnaOptOperationalHours
        price: number
    }

    export interface KlarnaOptOperationalHours {
        default: KlarnaOptDefault[]
        overrides: KlarnaOptOverrides
    }

    export interface KlarnaOptOverrides {
        date: KlarnaOptDate[]
        weekday: KlarnaOptWeekday
    }

    export interface KlarnaOptTimeOfDay {
        earliest: string
        latest: string
    }

    export interface KlarnaOptTimeslot {
        cutoff: string
        end: string
        id: string
        price: number
        start: string
    }

    export interface KlarnaOptWeekday {
        fri: KlarnaOptDefault[]
        mon: KlarnaOptDefault[]
        sat: KlarnaOptDefault[]
        sun: KlarnaOptDefault[]
        thu: KlarnaOptDefault[]
        tue: KlarnaOptDefault[]
        wed: KlarnaOptDefault[]
    }

    export interface KlarnaOrder {
        id: string
        "total_amount": number
        "total_tax": number
        "total_weight": number
        tags: string[]
        lines: KlarnaLines[]
        "total_amount_without_shipping_fee": number
        "total_tax_without_shipping_fee": number
    }

    export interface KlarnaOverrides {
        weekday: KlarnaWeekday
    }

    export interface KlarnaRecipient {
        "given_name": string
        "family_name": string
        "company_name": string
        "street_address": string
        "street_address2": string
        "postal_code": string
        city: string
        region: string
        country: string
        phone: string
        email: string
        "customer_type": string
    }

    export interface KlarnaSelectedOption {
        addons: KlarnaSelectedShipmentAddon[]
        carrier: string
        class: string
        id: string
        location: KlarnaLocation
        price: number
        "tax_rate": number
        timeslot: KlarnaOptTimeslot
        type: string
    }

    export interface KlarnaSelectedOptionIdentifier {
        carrier: string
        "carrier_product": KlarnaCarrierProduct
    }

    export interface KlarnaSelectedShipmentAddon {
        data: Data
        id: string
        "max_length": number
        preselected: boolean
        price: number
        required: boolean
        type: string
    }

    /**
     * --------------
     */
    export interface KlarnaSelectedShippingOption {
        currency: datamodels.Currency
        locale: string
        order: KlarnaOrder
        recipient: KlarnaRecipient
        "selected_shipping_option": KlarnaSelectedOption
        sender: KlarnaSender
        "session_id": string
    }

    export interface KlarnaSender {
        address: KlarnaAddress
        "sender_id": string
    }

    export interface KlarnaShipment {
        carrier: string
        "tracking_id": string
        "tracking_url": string
    }

    export interface KlarnaShipmentResponse {
        "additional_info": string
        "selected_shipping_option": KlarnaSelectedOptionIdentifier
        "shipment_id": string
        shipments: KlarnaShipment[]
    }

    export interface KlarnaShippingDisplayConfig {
        /**
         * 	NOTE: Commented out since we are currently not using, unsure of purpose
         * 	 ID       string             `json:"id"`
         */
        addons?: KlarnaOptAddon[]

        features?: KlarnaOptFeature[]
    }

    export interface KlarnaShippingOptionRes {
        id: string
        type: string
        carrier: string
        name: string
        price: number
        "delivery_time": KlarnaOptDeliveryTime
        "tax_rate": number
        addons: KlarnaOptAddon[]
        area: KlarnaOptArea
        class: string
        features: KlarnaOptFeature[]
        "free_above": number
        locations: KlarnaOptLocation[]
        preview: boolean
        timeslots: KlarnaOptTimeslot[]
    }

    export interface KlarnaThu {
        open: string
        close: string
    }

    export interface KlarnaTue {
        open: string
        close: string
    }

    export interface KlarnaWeekday {
        mon: KlarnaMon[]
        tue: KlarnaTue[]
        thu: KlarnaThu[]
    }

    export interface MockCheckoutConfig {
        /**
         * Optional strategy ID use. If not set, the production strategy will be used
         */
        overrideStrategyID?: string

        /**
         * Date of the checkout request. If not set, the current time will be used
         */
        timestamp?: string
    }

    export interface OrderItem {
        /**
         * NOTE: Not the Skrym product ID
         */
        id: string

        SKU: string
        name: string
        quantity: number
        /**
         * grams
         */
        weight: number

        /**
         * lowest denomination (eg. cents)
         */
        amount: number

        /**
         * ISO4217
         */
        currency: datamodels.Currency
    }

    /**
     * OrganizationTransportMethodCheckoutConfig
     * 
     * OrganizationTransportMethodCheckoutConfig represents a configurable code that should be used in checkout flows
     */
    export interface OrganizationTransportMethodCheckoutConfig {
        /**
         * Checkout identifies the checkout integrator.
         */
        checkout: Checkout

        /**
         * OrganizationID specifies the organization ID of the stored method code.
         */
        organizationId: string

        /**
         * MethodID identifies the method of the stored method code
         */
        methodId: string

        /**
         * CheckoutCode holds the actual transport method code that will be used in the checkout flow.
         */
        code: string

        /**
         * DisplayName is the name that will be filled (if possible) to be displayed towards a end consumer
         */
        displayName?: string

        /**
         * MaxCostThreshold contains the maximum cost (after cost calculation) a transport method can have before it is removed from the list of methods showed in the checkout
         */
        maxCostThreshold: number

        /**
         * MaxCostThresholdCurrency contains the currency of the max cost threshold
         */
        maxCostThresholdCurrency: datamodels.Currency
    }

    export interface Parcel {
        id: string
        externalReference: string
        checkoutPromiseId: string
        createdAt: string
        /**
         * [mm]
         */
        length: number

        /**
         * [mm]
         */
        width: number

        /**
         * [mm]
         */
        height: number

        /**
         * grams
         */
        weight: number

        /**
         * Items is a map between SKU (order item ID) and quantity (denoting how many of each orderItem is in the parcel)
         */
        items: { [key: string]: number }
    }

    export type Preference = string

    export interface PreferenceValue {
        value: string
        isDefault: boolean
    }

    export interface Receiver {
        /**
         * Full name of recipient (read as First + Last)
         */
        name: string

        /**
         * Phone number preferably using ITU-T E.123 / E.164
         */
        phone: string

        /**
         * Valid email address
         */
        email: string

        /**
         * Address e.g. "Lidnersgatan 12"
         */
        address: Address
    }

    export interface Reservation {
        basketId: string
        transportMethodId: string
        transportMethodCode: string
        lastModified: string
        sessionId: string
        /**
         * Extracted from the selected shipping option, it is the external ID of the location, not our internal one.
         */
        locationId: string

        selectedShippingOption: JSONValue
        checkout: Checkout
        selectedAddons: JSONValue
        /**
         * Skrym ID of a tracked order connected to a checkout session
         */
        trackedOrderID: string
    }

    export interface ReservedBasket {
        Basket: Basket
        ReservedShipment: Reservation
    }

    export interface RetailerConsignorInfo {
        id: string
        consignerName: string
        companyName: string
        updatedAt: string
    }

    /**
     * SelectedCheckoutAddon corresponds to selected_checkout_addon table
     */
    export interface SelectedCheckoutAddon {
        id: string
        checkoutAddonId: string
        basketId: string
        price: number
        currency: string
        dataType: CheckoutAddonDataType
        userValue: string
    }

    export interface SkrymCheckoutConfigForTransportMethod {
        /**
         * Map of pre-defined
         */
        customParameters: { [key: string]: JSONValue }

        addons: CheckoutAddonChoice[]
    }

    export type SortDirection = string
}

export namespace crmmodels {
    export interface CallSheet {
        id: string
        callerId: string
        callingId: string
        description: string
        day: string
        isCompleted: boolean
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface Channel {
        id: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface Company {
        id: string
        name: string
        typeId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface CompanyBillingInfo {
        id: string
        companyId: string
        companyRegistrationNo: string
        companyRegisteredLocation: string
        companyInvoiceEmail: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface CompanyInvoice {
        id: string
        companyId: string
        name: string
        description: string
        amountSek: number
        invoiceUrl: string
        invoicePeriodStart: string
        invoicePeriodEnd: string
        isPaid: boolean
        sentDate: string
        dueDate: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface CompanyNote {
        id: string
        companyId: string
        title: string
        message: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface CompanyProductArea {
        id: string
        companyId: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface CompanyProductAreaEntry {
        id: string
        productId: string
        companyAreaId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface CompanySegment {
        id: string
        typeId: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface CompanySegmentEntry {
        id: string
        companyId: string
        companySegmentId: string
        createdBy: string
        updatedBy: string
        isDeleted: boolean
        createdAt: string
        updatedAt: string
    }

    export interface CompanyType {
        id: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface Connection {
        id: string
        sourceCompanyId: string
        sourceContactId: string
        sourceChannelId: string
        sourceEventId: string
        targetCompanyId: string
        targetContactId: string
        receivingCompanyId: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface Contact {
        id: string
        firstName: string
        lastName: string
        birthday: string
        isDeleted: boolean
        createdAt: string
        updatedAt: string
    }

    export interface ContactDetail {
        id: string
        contactId: string
        typeId: string
        label: string
        description: string
        value: string
        active: boolean
        isPrimary: boolean
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface ContactDetailType {
        id: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface ContactDocument {
        id: string
        documentId: string
        contactId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface ContactNote {
        id: string
        contactId: string
        title: string
        message: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface ContactRole {
        id: string
        contactId: string
        companyId: string
        title: string
        description: string
        active: boolean
        startDate: string
        endDate: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface ContactWithDetailAndRoleInfo {
        contact: Contact
        company: string
        role: string
    }

    export interface Document {
        id: string
        typeId: string
        documentName: string
        documentDescription: string
        documentUrl: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface DocumentType {
        id: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface Employment {
        id: string
        contactRoleId: string
        name: string
        description: string
        contract: string
        salarySek: number
        noVacationDays: number
        isMonthly: boolean
        isHourly: boolean
        isActive: boolean
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface Event {
        id: string
        name: string
        description: string
        url: string
        typeId: string
        startDate: string
        endDate: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface EventAttendee {
        id: string
        eventId: string
        contactId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface EventType {
        id: string
        eventType: string
        typeDescription: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface FormSubmission {
        id: string
        company: string
        email: string
        formName: string
        formSubmission: string
        honung: string
        message: string
        name: string
        phone: string
        role: string
        status: string
        subject: string
        isDeleted: boolean
        timestamp: string
        createdAt: string
        updatedAt: string
    }

    export interface Meeting {
        id: string
        typeId: string
        name: string
        description: string
        meetingDate: string
        meetingNoteUrl: string
        virtual: boolean
        organizationLocationId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface MeetingAttendee {
        id: string
        meetingId: string
        contactId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface MeetingCompany {
        id: string
        meetingId: string
        companyId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface MeetingType {
        id: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface MeetingWithAttendees {
        id: string
        typeId: string
        name: string
        description: string
        meetingDate: string
        meetingNoteUrl: string
        virtual: boolean
        organizationLocationId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
        meetingAttendees: MeetingAttendee[]
    }

    export interface NewsletterSignup {
        id: string
        email: string
        isDeleted: boolean
        timestamp: string
        createdAt: string
        updatedAt: string
    }

    export interface OnCallRole {
        id: string
        name: string
        description: string
        moreInfoUrl: string
        roleCode: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface OnCallSchedule {
        id: string
        contactId: string
        roleId: string
        startDate: string
        durationHours: number
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface OpenPRsStatistics {
        fetchedAt: string
        openCount: number
        draftCount: number
        averageSize: number
        medianSize: number
        averageChangedFiles: number
        medianChangedFiles: number
        /**
         * In seconds
         */
        averageAge: number

        /**
         * In seconds
         */
        medianAge: number

        /**
         * In seconds
         */
        maxAge: number

        /**
         * Older than two weeks
         */
        staleCount: number
    }

    export interface Opportunity {
        id: string
        companyId: string
        name: string
        description: string
        opportunityTypeId: string
        funnelStepId: string
        probabilityPercentage: number
        estimatedMrr: number
        estimatedClose: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface OpportunityFunnel {
        id: string
        opportunityTypeId: string
        sequence: number
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface OpportunityFunnelStep {
        id: string
        opportunityFunnelId: string
        sequence: number
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface OpportunityProduct {
        id: string
        opportunityId: string
        productId: string
        note: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface OpportunityType {
        id: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface OrganizationDocument {
        id: string
        documentId: string
        organizationId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface Product {
        id: string
        productCategoryId: string
        productSubcategoryId: string
        name: string
        description: string
        providerCompanyId: string
        productInformationUrl: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface ProductCategory {
        id: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface ProductDocument {
        id: string
        documentId: string
        productId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface ProductSubcategory {
        id: string
        parentCategoryId: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface ProductUser {
        id: string
        productId: string
        userCompanyId: string
        startDate: string
        endDate: string
        active: boolean
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface SkrymCompanyRole {
        id: string
        name: string
        description: string
        areaId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface SkrymCompanyRoleArea {
        id: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface SkrymContactRole {
        id: string
        companyId: string
        companyRoleId: string
        contactId: string
        active: boolean
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface Sprint {
        id: string
        sprintNumber: number
        startDate: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface SprintDailyStandup {
        id: string
        sprintId: string
        sprintDay: number
        hostedBy: string
        mostImportant: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface SprintDailyStandupEntry {
        id: string
        standupId: string
        teamMemberId: string
        present: string
        teamMemberAvailability: string
        teamMemberWorkingOn: string
        teamMemberNote: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface SprintMessage {
        id: string
        sprintId: string
        title: string
        message: string
        messageTypeId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface SprintMessageType {
        id: string
        name: string
        description: string
        color: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface SprintRole {
        id: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface SprintRoleEntry {
        id: string
        sprintId: string
        contactId: string
        sprintRoleId: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface Task {
        id: string
        name: string
        description: string
        size: number
        isPriority: boolean
        companyId: string
        isPrivate: boolean
        statusId: string
        deadline: string
        createdBy: string
        updatedBy: string
        isDeleted: boolean
        createdAt: string
        updatedAt: string
    }

    export interface TaskOwner {
        id: string
        taskId: string
        contactId: string
        note: string
        createdBy: string
        updatedBy: string
        isDeleted: boolean
        createdAt: string
        updatedAt: string
    }

    export interface TaskStatus {
        id: string
        code: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface TaskWithCompanyAndStatusInfo {
        task: Task
        statusName: string
        companyName: string
    }

    export interface WorkingTime {
        id: string
        contactRoleId: string
        type: string
        location: string
        day: string
        durationHours: number
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface WorkingTimeLocation {
        id: string
        companyId: string
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface WorkingTimeType {
        id: string
        companyId: string
        name: string
        description: string
        isWork: boolean
        isVacation: boolean
        isParentalLeave: boolean
        isDeleted: boolean
        isPublicHoliday: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }
}

export namespace datamodels {
    export type AddonType = string

    export interface AuthData {
        /**
         * The ID of the retailer. If the current user is a Scope retailer, this is their current active organization ID.
         */
        retailerId: string

        /**
         * The permissions of the retailer. If the current user is a Scope retailer, this is their current active organization permissions.
         */
        retailerPermissions: number[]

        /**
         * The IDs of the organizations the user is connected to. Is nil if the user is a retailer.
         */
        organizationIds: string[]

        /**
         * The ID of the account. If the current user is a retailer, this is uuid.Nil.
         */
        accountId: string

        /**
         * The email of the account. If the current user is a retailer, this is empty.
         */
        accountEmail: string

        /**
         * The roles the user has in for the current organization
         */
        accountRoles: Role[]
    }

    export interface AverageDeliveryTimeByTransportMethod {
        organizationId: string
        transporterId: string
        transportMethodId: string
        /**
         * in seconds. This is the average delivery time from all tracked shipments pertaining to the given transport method.
         */
        meanDeliveryTime: number

        /**
         * in seconds. This is the standard deviation of the mean delivery time. This shows the spread of the data from the mean.
         */
        stdDeliveryTime: number

        /**
         * in seconds. The longest delivery time.
         */
        maxDeliveryTime: number

        /**
         * in seconds. The shortest delivery time.
         */
        minDeliveryTime: number

        numTrackedShipments: number
        timePeriodStartDate: string
        timePeriodLastDate: string
        deliveryMonth: string
    }

    export type BookingStatus = string

    export type Currency = string

    export type CustomParameterDataType = string

    /**
     * DateAndTime is a utility struct for representing a day with a specified interval, which is commonplace in logistics
     */
    export interface DateAndTime {
        date: string
        /**
         * Start of the applicable time interval, must be an integer less than 24
         */
        fromTime?: number

        /**
         * End of the applicable time interval, must be an integer less than 24 and should be greater than FromTime
         */
        toTime?: number
    }

    /**
     * Feedback hold all information form a single Feedback Event.
     * The caller is responsible for specifying as much information as possible, but the model is indendent to accept minimal information by making many fields optional.
     */
    export interface Feedback {
        /**
         * Inernal Skrym ID of the feedback event
         */
        id: string

        /**
         * Internal Skrym ID for the Organisation
         */
        organizationID: string

        /**
         * Where the feedback is called from. Allowed values are: "WAREHOUSE", "TRANSPORTER", "INVOICE", "OTHER".
         */
        feedbackSourceType: FeedbackSourceType

        /**
         * Basic declaration if the order fits into recommendation. Allowed values are: "FITS", "TOO_SMALL", "TOO_BIG", "UNKNOWN".
         */
        fit: FitStatus

        /**
         * Optional unique key that callers can set to identify the feedback event.
         */
        key?: string

        /**
         * Optional Skrym ID of the order.
         */
        skrymOrderID: string

        /**
         * Reference/Identifier that caller has for the order.
         */
        externalOrderReference: string

        /**
         * Optional tracking reference that caller has for the shipment.
         */
        shipmentTrackingReference?: string

        /**
         * Optional tracking reference that caller has for the parcel.
         */
        parcelTrackingReference?: string

        /**
         * Optional session ID from the checkout.
         */
        checkoutSessionID?: string

        /**
         * Optional dimensions that caller has measured during feedback event.
         */
        measuredDimensions?: number[]

        /**
         * Optional weight that caller has measured during feedback event.
         */
        measuredWeight?: number

        /**
         * Optional debitable weight that caller has measured during feedback event.
         */
        measuredDebitableWeight?: number

        /**
         * Optional reference/identifier of the actual chosen package.
         */
        chosenPackageReference?: string

        /**
         * Other tags and flags that are important for the feedback event. For example: {"orderIsFragile": "true"}    NOTE: could be used with custom parameters or special flags like "automation"
         */
        metadata: JSONValue

        /**
         * Any additonal information.
         */
        freeText?: string

        /**
         * Optional timestamp for when the feedback event occured.
         */
        createdAt?: string

        /**
         * When the feedback was received
         */
        receivedAt?: string
    }

    /**
     * FeedbackSourceType represents the currently supported sources from
     * which Skrym is able to gather feedback information.
     */
    export type FeedbackSourceType = string

    /**
     * FitStatus defines the overall status of the fit of
     * a recommended package at the time of the feedback call.
     */
    export type FitStatus = string

    /**
     * FreightInput is a replicated version of the FreightObject but does not have any methods associated with it. This allows us to use it as inputs to Encore API:s.
     */
    export interface FreightInput {
        ShippingProperties: ShippingProperties
        PhysicalProperties: PhysicalProperties
        FreightObjectType: FreightObjectType
    }

    /**
     * FreightObject is a replicated version of the FreightObject but does not have any methods associated with it. This allows us to use it as inputs to Encore API:s.
     */
    export interface FreightObject {
        id: string
        bookingId: string
        shippingProperties: ShippingProperties
        physicalProperties: PhysicalProperties
        bookerExternalReference: string
        freightObjectType: FreightObjectType
        freightObjectChildren?: FreightObject[]
        quantity: number
    }

    export interface FreightObjectTrackingData {
        freightObjectId: string
        freightObjectType: FreightObjectType
        trackingReference: string
        trackingUrl: string
    }

    export type FreightObjectType = string

    /**
     * GetFeedbackFilters are filters used in fetching feedback.
     */
    export interface GetFeedbackFilters {
        organizationId: string
        externalOrderId: string
    }

    /**
     * Holiday represents a public holiday record. It includes details such as the holiday date, country code, region, name, and associated timestamps.
     */
    export interface Holiday {
        /**
         * ID is a unique identifier
         */
        id: string

        /**
         * HolidayDate is the date when the holiday is observed.
         */
        holidayDate: string

        /**
         * CountryCode is the ISO country code where the holiday is recognized.
         */
        countryCode: string

        /**
         * Region specifies the region within the country where the holiday applies.
         */
        region: string

        /**
         * Name is the name of the holiday.
         */
        name: string

        /**
         * Description provides additional details or context about the holiday.
         */
        description: string

        /**
         * CreatedAt is the timestamp when the holiday record was created.
         */
        createdAt: string

        /**
         * UpdatedAt is the timestamp when the holiday record was last updated.
         */
        updatedAt: string
    }

    export interface Location {
        /**
         * A unique identifier for the location
         */
        id: string

        /**
         * Name of the location
         */
        name: string

        /**
         * The latitude coordinate of the location.
         */
        latitude: number

        /**
         * The longitude coordinate of the location.
         */
        longitude: number

        /**
         * Which administrative city the location is in.
         */
        city: string

        /**
         * The city code of the location
         */
        cityCode?: string

        /**
         * The postal code containing the specified latitude and longitude
         */
        zipCode: string

        /**
         * The address of the actual location.
         */
        address: string

        /**
         * Secondary address line (apartment, floor, suite, c/o, etc.)
         */
        addressSecondary?: string

        /**
         * Information about which district (if any) the location is in.
         */
        district: string

        /**
         * Information about which administrative region the location is in.
         */
        region: string

        /**
         * The region code of the location
         */
        regionCode?: string

        /**
         * Country code of the location, conforming to ISO 3166-1. For example `SE` and not `SWE`.
         */
        country: string

        /**
         * Optional string to specify continent
         */
        continent: string

        /**
         * Timestamp for when the location was added
         */
        createdAt: string

        /**
         * Timestamp for when the location was last updated
         */
        updatedAt: string
    }

    export type LocationType = string

    /**
     * OrderFeedbackSummary summarizes all of the feedback events for an order.
     * It is meant to contain the latest not-nil or non-zero datapoints. The
     * Fit status should be infered and/or verified from other data points, such
     * as measured dimensions, if available.
     */
    export interface OrderFeedbackSummary {
        key: string
        feedbackSource: FeedbackSourceType
        fit: FitStatus
        usedPackagedReference: string
        createdAt: string
        estimatedDimensions: number[]
        measuredDimensions: number[]
        estimatedWeight: number
        measuredWeight: number
        actualFillRate: number
        actualPackageVolume: number
        estimatedDebitableWeight: number
        actualDebitableWeight: number
        comment: string
        /**
         * should contain the custom parameter {keyString: value} pairs.
         */
        metadata: JSONValue
    }

    export interface OrganizationLocation {
        id: string
        organizationId: string
        locationId: string
        location: Location
        locationType: LocationType
        /**
         * NOTE: This is for a organization to be able to name a location to something they know e.g. Skrym Office
         */
        name: string

        externalId: string
        description: string
        imageUrl: string
        phone: string
        email: string
        homepage: string
        available: boolean
        createdAt: string
        updatedAt: string
    }

    /**
     * OrganizationLocationAlias represents an alias key/value pair for an organization location.
     */
    export interface OrganizationLocationAlias {
        /**
         * ID of the organization which the alias is created by.
         */
        organizationID: string

        /**
         * ID of the organization location which the alias is connected to.
         */
        organizationLocationId: string

        /**
         * The key for the value e.g. "PostnordServicePointID". This has to be a unique value.
         */
        aliasKey: string

        /**
         * The value connected to the key
         */
        aliasValue: string

        /**
         * User ID of the creator
         */
        createdBy: string

        /**
         * User ID of the last update
         */
        updatedBy: string

        /**
         * Time of creation
         */
        createdAt: string

        /**
         * Time of last update
         */
        updatedAt: string
    }

    export interface OrganizationLocationDailyLimit {
        organizationLocationID: string
        organizationID: string
        transportMethodID: string
        externalID: string
        /**
         * Daily limit for the location
         */
        dailyLimit?: number
    }

    export interface OrganizationOpeningHours {
        organizationLocationId: string
        /**
         * Based on golang's `time.Weekday`, meaning 0 = Sunday, 1 = Monday ...
         */
        day: time.Weekday

        /**
         * open/close
         */
        open: boolean

        /**
         * opening time in military time format (e.g 0800). "0000" when open/closed all day
         */
        openTime: string

        /**
         * closing time in military time format (e.g 1800). "2359" when open all day. "0000" when closed.
         */
        closeTime: string
    }

    export interface OrganizationSpecialOpeningHours {
        organizationLocationId: string
        startDate: string
        endDate: string
        /**
         * opening time in military time format (e.g 0800)
         */
        openTime: string

        /**
         * closing time in military time format (e.g 1800)
         */
        closeTime: string

        open: boolean
        label: string
    }

    export interface ParameterNode {
        /**
         * Skrym internal ID
         */
        id: string

        /**
         * KeyString indicates what Skrym will try to parse as the key in a key-value pair. Example "isBulky: true" has the KeyString "isBulky".
         */
        keyString: string

        /**
         * Specifies which DataType the CustomParameter is of, this will affect which operations it can be used in. The different types are: [boolean, number, string, object]
         */
        dataType: CustomParameterDataType

        /**
         * Specifies if the DataType is an array of said type or a single value.
         */
        isArray: boolean

        /**
         * Description of the CustomParameter
         */
        description: string

        /**
         * Will be the label used in e.g. delivery checkout config
         */
        label: string

        /**
         * Specifies color for displaying the CustomParameter
         */
        color: string

        /**
         * Specifies which Icon to show for the CustomParameter
         */
        icon: string

        /**
         * The time of creation
         */
        createdAt: string

        /**
         * Array of all CustomParameters related to this 'object' type CustomParameter
         */
        children?: ParameterNode[]
    }

    /**
     * Properties relating to the physical aspects of the freight object, such as dimensions and weight
     */
    export interface PhysicalProperties {
        weight?: number
        length?: number
        height?: number
        width?: number
        loadMeters?: number
        palletPlaces?: number
        debitableWeight?: number
        volume?: number
        /**
         * Used to indicate subtypes of the main FreightObjectType (e.g. EUR-pallet, plastic bag etc)
         */
        variant?: string
    }

    export interface Receiver {
        name: string
        phone: string
        email: string
        address: Location
    }

    /**
     * Role represents the roles an account can have.
     */
    export type Role = string

    /**
     * ShippingProperties relate to the process of transporting a freight object from a destination to an origin
     * 
     * Note that the shipping properties is also defined by not containing any physical information about the freight object,
     * since these are instead part of the PhysicalProperties struct
     */
    export interface ShippingProperties {
        /**
         * The receiver indicates who is the juridical recipient of the shipment
         */
        receiver: Receiver

        /**
         * The origin location of the freight object. Normally enough to populate with country and zip code.
         */
        origin: Location

        /**
         * The destination location of the freight object. Normally enough to populate with country and zip code.
         */
        destination: Location

        /**
         * The total distance between origin and destination, in km.
         */
        distance?: number

        /**
         * Reference to the transporter that is used for the shipment
         */
        transporter?: string

        /**
         * Reference to the transport method that is used for the shipment
         */
        transportMethod?: string

        /**
         * Reference to transporters tracking
         */
        transporterTrackingReference?: string

        /**
         * Url to transporters tracking
         */
        transporterTrackingUrl?: string

        /**
         * For more complicated conditions between price groups, we can use this property to indicate which pricing should be applied. A good example is PostNord MyPack Home which has its own routing functionality.
         */
        transporterPriceGroup?: string

        /**
         * The date and time (if specified) when the shipment is delivered or estimated to be delivered
         */
        deliveryDate?: DateAndTime

        /**
         * The date and time (if specified) when the shipment is delivered or estimated to depart from its origin
         */
        departureDate?: DateAndTime

        unitPrice?: number
        currency?: string
        taxRate?: number
        discountRate?: number
        /**
         * addons sent in when making bookings
         */
        addons?: { [key: SkrymAddon]: string }

        /**
         * optional addon field only for calculating historical costs
         */
        addonProperties?: string[]
    }

    export interface SimplifiedEventLocation {
        /**
         * Postal code for the event location
         */
        zipcode: string

        /**
         * Code for the event location country, in ISO 3166-1 alpha-2 (e.g. 'SE' or 'FI')
         */
        country: string

        /**
         * Optional identifier that helps identify one of your locations to add the event to.
         */
        identifier: string
    }

    export interface SimplifiedLocation {
        zipCode: string
        country: string
    }

    export type SkrymAddon = string

    export interface SkrymBooking {
        id: string
        retailerId: string
        externalReference?: string
        wmsReference?: string
        created: string
        freightObjects: FreightObject[]
        bookingSuccessful: boolean
        bookingStatus: BookingStatus
    }

    export interface SkrymTime {
        interval: SkrymTimeInterval
        earliest: string
        latest: string
    }

    export interface SkrymTimeInterval {
        earliest: number
        latest: number
    }

    export interface TransportMethodWithCodes {
        /**
         * The unique id of the transporter
         */
        transporterId: string

        /**
         * The name of the transporter
         */
        transporterName: string

        /**
         * The unique id of the transport method
         */
        transportMethodId: string

        /**
         * The name of the transport method
         */
        transportMethodName: string

        /**
         * Array of codes used by transporter to refer to the transport method
         */
        transporterCodes: TransporterCodeDetails[]
    }

    export interface TransporterCodeDetails {
        /**
         * Code used by the transporter to refer to the transport method
         */
        code: string

        /**
         * Relevant text from transporter specification
         */
        comment: string

        /**
         * Link to transporter specification
         */
        infoUrl: string
    }

    export interface WarehouseInformation {
        /**
         * Reference of which warehouse or system user that created the event.
         */
        warehouseUser?: string

        /**
         * Reference of the section in the warehouse where the event occured.
         */
        section?: string

        /**
         * Reference of the workstation in the warehouse where the event occured.
         */
        workstationReference?: string

        /**
         * Reference of the device in the warehouse where the event occured.
         */
        deviceReference?: string

        /**
         * Name of the device in the warehouse where the event occured.
         */
        deviceName?: string

        /**
         * Model of the device in the warehouse where the event occured.
         */
        deviceModel?: string
    }

    export interface Workstation {
        reference: string
        currentUser: string
    }
}

export namespace gpt {
    export interface GPTFunctionParameters {
        type: string
        /**
         * replace with sub-def
         */
        properties: { [key: string]: GPTParameterProperties }

        /**
         * list of which params are required
         */
        required: string[]

        /**
         * unclear what this does
         */
        additionalProperties: boolean
    }

    export interface GPTMessage {
        role: string
        content: string
    }

    export interface GPTMessageResponseFormat {
        /**
         * e.g. 'json_schema'
         */
        type: string

        "json_schema": GPTMessageResponseFormatJsonSchema
    }

    export interface GPTMessageResponseFormatJsonSchema {
        name: string
        strict: boolean
        schema: GPTFunctionParameters
    }

    /**
     * It only has this if it's an object
     */
    export interface GPTParameterProperties {
        /**
         * enum: can be 'string' / 'array', 'obj
         */
        type: string

        /**
         * if restricting which values are allowed
         */
        enum?: string[]

        /**
         * through this we have recursion á la JSON enabled
         */
        items?: GPTFunctionParameters
    }

    export interface GPTRequest {
        model: string
        messages: GPTMessage[]
        /**
         * NOTE: This requires model to be at least what is specified in https://openai.com/index/introducing-structured-outputs-in-the-api/
         */
        "response_format": GPTMessageResponseFormat
    }

    export interface GPTResponse {
        choices: {
            index: number
            message: {
                role: string
                content: string
                refusal: string
            }
            "finish_reason": string
        }[]
    }
}

export namespace iso {
    /**
     * As defined by ISO 639-1, see: https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
     */
    export type IsoLanguage = string
}

export namespace models {
    export interface Account {
        id: string
        firstName: string
        lastName: string
        email: string
        inviteFinished: boolean
        createdDate: string
        roles: datamodels.Role[]
        retailerId: string
    }

    export interface AccountName {
        id: string
        FirstName: string
        LastName: string
    }

    /**
     * Describes the role an account has for a specific organization.
     */
    export interface AccountOrganizationRole {
        /**
         * The account this role belongs to
         */
        accountId: string

        /**
         * The organization this role belongs to
         */
        organizationId: string

        /**
         * The role type (e.g., `admin`, `standard`, `support-agent`)
         */
        role: datamodels.Role

        /**
         * When the role was created
         */
        createdAt: string

        /**
         * When the role was last updated
         */
        updatedAt: string
    }

    export interface AddonData {
        addonType: datamodels.AddonType
        skrymAddon: datamodels.SkrymAddon
        transporterAddon: string
        objectData?: AddonObjectData
        required: boolean
        defaultValue: string
        requires: datamodels.SkrymAddon[]
        enumOptions?: AddonEnumData[]
    }

    export interface AddonEnumData {
        enumValue: string
        skrymEnumValue: string
    }

    /**
     * Struct used to scan data from addon_map table
     */
    export interface AddonMapData {
        transporterId: string
        transportMethodId: string
        addonData: AddonData[]
    }

    export interface AddonObjectData {
        addonObject: { [key: string]: JSONValue }
        fieldsToUpdate: { [key: string]: AddonObjectField }
    }

    export interface AddonObjectField {
        required: boolean
        dependency: datamodels.SkrymAddon
        type: datamodels.AddonType
    }

    export type AdjType = string

    /**
     * AgreementAttributes are pre-decided variables that are allowed to be used in digital transport agreements.
     * 
     * The attributes are normally either physical properties (e.g. "Weight") of a freight object
     * or properties relating to the shipping of a freight object (e.g. "DestinationZip").
     */
    export type AgreementAttribute = string

    export interface AirmeeAddressDetails {
        city: string
    }

    export type AirmeeDeliveryType = string

    export type AirmeeIntervalCategory = string

    export type AirmeeServiceType = string

    export type AirmeeStatus = string

    export interface AirmeeTrackingWebhookPayload {
        /**
         * Airmee's ID of the pickup place from where the request originates
         */
        "place_id": string

        /**
         * External reference given to Airmee. Usually order reference in an ERP or e-com system.
         */
        "sender_reference": string

        /**
         * Airmee's ID of the order, returned in the response of the order creation in `.../request_delivery/`
         */
        "order_id": string

        /**
         * Short status of the tracked order.
         */
        "order_short_status": AirmeeStatus

        /**
         * Long status of the tracked order.
         */
        "order_long_status": string

        /**
         * Timestamp of this status update.
         */
        "time_of_last_status": string

        /**
         * Main reference to the shipments and used for barcode. Often `shipment number`, `shipment ID` or `Consignment ID`.
         */
        "ecomm_id": string

        /**
         * Can be `Standard` - regular delivery within time interval, or `Express` - express delivery within x hours.
         */
        "interval_category": AirmeeIntervalCategory

        /**
         * Airmee's services such as `Home`, `Point` or `Locker delivery`.
         */
        "type_of_service": AirmeeServiceType

        /**
         * Information about the receiver of the delivery.
         */
        "receiver_delivery_details": AirmeeAddressDetails

        /**
         * Link to Airmee's tracking page: `http://tracking-staging.airmee.com/#/track/` + the tracking ID.
         */
        "tracking_url": string

        /**
         * Can be delivery or a return.
         */
        "type_of_delivery": AirmeeDeliveryType
    }

    export interface AutoArchiveConfiguration {
        organizationID: string
        enabled: boolean
        archiveAfterDays: number
    }

    export interface Bag {
        package: Package
        /**
         * Needs to be the longer side
         */
        length: number

        width: number
        isPrescription: boolean
    }

    export interface BagPackage {
        bag: Bag
        boundingBox: number[]
        bagProducts: OrderProductWithDims[]
        bagProductPlacements: algorithm.Box[]
    }

    export interface BinPackage {
        id: string
        dimensions: number[]
    }

    export interface Bonus {
        status: string
        providerId: string
        providerName: string
        amount: number
        currencyCode: string
        points: number
        reservationId: string
        failedReason: string
    }

    /**
     * For returning the url of a label to external parties
     */
    export interface BookingLabelURL {
        /**
         * The URL of the label.
         */
        url: string

        /**
         * The format of the label, e.g. "PDF" or "ZPL"
         */
        format: string

        /**
         * Physical size of the label
         */
        size: string

        /**
         * The MIME type of the label, e.g. "application/pdf"
         */
        contentType: string

        /**
         * The type of the label (e.g., "BOOKING_LABEL" or "CONSIGNMENT_NOTE"). Default is "BOOKING_LABEL"
         */
        labelType: SkrymLabelType
    }

    export interface BrinkOrder {
        date: string
        isTaxIncludedInPrice: boolean
        shippingFees: ShippingFee[]
        totals: Totals
        discountRules: DiscountRule[]
        languageCode: string
        reference: string
        shipping: Shipping
        orderLines: BrinkOrderLine[]
        discountCode: DiscountCode
        storeGroupId: string
        countryCode: string
        shippingAddress: OrderAddress
        payment: Payment
        id: string
        sessionId: string
        creator: Creator
        billingAddress: OrderAddress
        discountOutcome: OrderDiscountOutcome
        currencyCode: string
        giftCard: GiftCard
        voucher: Voucher
        promotion: Promotion
        merchantReference1: string
        merchantReference2: string
        bonus: Bonus
        revision: number
    }

    /**
     * BrinkOrderCreatedWebhookParams is the params for the BrinkOrderCreatedWebhook function
     */
    export interface BrinkOrderCreatedWebhookParams {
        "$schema": string
        title: string
        "detail-type": string
        resources: string[]
        detail: Detail
        id: string
        source: string
        time: string
        region: string
        version: string
        account: string
    }

    export interface BrinkOrderLine {
        displayDescription: string
        quantity: number
        productVariantId: string
        distributedTotalPriceAmount: number
        totalPriceAmount: number
        displayName: string
        totalDiscountAmount: number
        salePriceAmount: number
        taxPercentage: number
        distributedTotalTaxAmount: number
        description: string
        discountAmount: number
        basePriceAmount: number
        distributedTotalDiscountAmount: number
        imageUrl: string
        taxGroupId: string
        name: string
        id: string
        discountOutcome: OrderLineDiscountOutcome
        totalTaxAmount: number
        currencyCode: string
        taxPercentageDecimals: number
        productParentId: string
        options: { [key: string]: string }
    }

    /**
     * Contains all the possible fields for events, meaning that not all will be set for one event.
     * The event fields can be found at https://developer.budbee.com/#Events
     */
    export interface BudbeeEventData {
        /**
         * Shared fields between all type of events
         */
        tmsId: string

        cartId: string
        budbeeOrderToken: string
        shipmentId: string
        packageId: string
        timestamp: string
        /**
         * Specific fields for the different type of events
         */
        city: string

        postalCode: string
        address: string
        reason: string
        responsible: string
        intervalStart: string
        intervalStop: string
        deliveryInformation: string
        lockerName: string
        street: string
        flow: string
    }

    export interface Bundle {
        /**
         * The ID of the bundle
         */
        id: string

        /**
         * The ID of the organization
         */
        organizationId: string

        /**
         * The external ID of the bundle
         */
        externalId: string

        /**
         * The ID of the product representing the bundle
         */
        bundleProductId: string

        /**
         * The description of the bundle
         */
        description: string

        /**
         * The products in the bundle
         */
        products: BundlePart[]
    }

    export interface BundlePart {
        /**
         * The ID of the bundle
         */
        bundleId: string

        /**
         * The ID of the product
         */
        productId: string

        /**
         * The quantity of the product in the bundle
         */
        quantity: number
    }

    /**
     * CalculationOrigin represents the
     * stage of the order journey at
     * which an emisssion calculation
     * had been made.
     */
    export type CalculationOrigin = string

    export interface CalculationResult {
        id: string
        retailerId: string
        orderId: string
        optimizationResultId: string
    }

    export interface CallLogEntry {
        id: string
        retailerId: string
        reqBody: string
        resBody: string
        statusCode: number
        timestamp: string
        endpoint: string
        service: string
    }

    /**
     * Capabilities represents the printing capabilities of a printer.
     */
    export interface Capabilities {
        bins: string[]
        collate: boolean
        color: boolean
        copies: number
        dpis: string[]
        duplex: boolean
        medias: string[]
        nup: number[]
        supportsCustomPaperSize: boolean
    }

    export interface Checkpoint {
        /**
         * Indicates type of point along the delivery chain. Possible values are 'WAREHOUSE', 'TERMINAL', 'PICKUP_POINT', 'LOCKER', 'DESTINATION_ADDRESSs', 'IN_TRANSIT' and 'CUSTOMS'.
         */
        type: CheckpointType

        /**
         * More detailed data on if the event happened at a particular location. Will be left empty if this cannot be determined.
         */
        location?: datamodels.Location

        /**
         * More detailed data on if the event happened at a particular organization location. Will be left empty if this cannot be determined. Should always point to the same location as in location.
         */
        organizationLocation?: datamodels.OrganizationLocation

        estEarliest?: string
        estLatest?: string
    }

    export type CheckpointType = string

    export interface ColumnDefaultValue {
        /**
         * Unique identifier for the default value
         */
        id: string

        /**
         * ID referencing the invoice mapping it belongs to
         */
        invoiceMappingId: string

        /**
         * The default value for the field
         */
        defaultValue: string

        /**
         * Skrym standardized name for the field
         */
        fieldName: InvoiceColumn

        /**
         * Unit for certain values, necessary for conversions
         */
        invoiceFieldUnit: utils.MeasurementUnit

        /**
         * Optional value for the fee type of the column. Only used for fee columns
         */
        costType: FeeType

        /**
         * Timestamp of when the default value was created
         */
        createdAt: string

        /**
         * Timestamp of the last update to the default value
         */
        updatedAt: string

        /**
         * Optional value for the delimiter used in the cell. Only used for string arrays.
         */
        cellDelimiter: string
    }

    /**
     * CompletedJourneyMilestoneTrigger represents a trigger associated with a journey milestone.
     * It contains details of the action to be tyriggered once a journey milestone is completed
     */
    export interface CompletedJourneyMilestoneTrigger {
        /**
         * ID is the unique identifier for the trigger.
         */
        id: string

        /**
         * JourneyID is the unique identifier for the journey associated with this trigger.
         */
        journeyId: string

        /**
         * MilestoneID is the unique identifier for the milestone within the journey.
         */
        milestoneId: string

        /**
         * TriggerType specifies the type of trigger, e.g., WEBHOOK.
         */
        triggerType: TriggerType

        /**
         * CreatedAt is the timestamp when the trigger was created.
         */
        createdAt: string

        /**
         * CreatedBy is the identifier of the user who created the trigger.
         */
        createdBy: string

        /**
         * UpdatedAt is the timestamp when the trigger was last updated.
         */
        updatedAt: string

        /**
         * UpdatedBy is the identifier of the user who last updated the trigger.
         */
        updatedBy: string

        /**
         * Active indicates whether the trigger is currently active.
         */
        active: boolean

        /**
         * OrganizationID is the unique identifier of the organization that owns the trigger.
         */
        organizationId: string

        /**
         * TriggerData contains optional additional data for the trigger,
         * such as webhook details.
         */
        triggerData: TriggerData
    }

    /**
     * Computer represents the computer to which the printer is connected.
     */
    export interface Computer {
        createTimestamp: string
        hostname: string
        id: number
        inet: string
        name: string
        state: string
        version: string
    }

    export interface Condition {
        /**
         * ID of the condition
         */
        id: string

        /**
         * Reference for the condition
         */
        reference: string

        /**
         * ID of the milestone the condition belongs to
         */
        milestoneId: string

        /**
         * ANY or ALL, how to evaluate the thresholds
         */
        evaluationLogic: EvaluationLogic

        /**
         * Thresholds to reach the condition
         */
        thresholds: Threshold[]

        /**
         * Time the condition was created
         */
        createdAt: string

        /**
         * Time the condition was last updated
         */
        updatedAt: string

        /**
         * ID of the user who created the condition
         */
        createdBy: string

        /**
         * ID of the user who last updated the condition
         */
        updatedBy: string
    }

    export interface ConditionSnapshot {
        id: string
        milestoneSnapshotId: string
        conditionId: string
        conditionReference: string
        evaluationLogic: EvaluationLogic
        thresholds: ThresholdSnapshot[]
    }

    export interface ConsignorDetails {
        /**
         * Unique identifier for the consignor details
         */
        id: string

        /**
         * Organization ID
         */
        organizationId: string

        /**
         * Organization Location ID
         */
        organizationLocationId: string

        /**
         * Name of the company
         */
        organizationName: string

        /**
         * URL of the company
         */
        organizationUrl: string

        /**
         * Reference person for the company
         */
        referencePerson: string

        /**
         * Email of the company
         */
        email: string

        /**
         * Phone number of the company
         */
        phoneNumber: string
    }

    export interface Coordinates {
        latitude: number
        longitude: number
    }

    export type CostCalculationResultStatus = string

    export interface CostResult {
        result: CalculationResult
        retailerPackResult: RetailerPackResult
        optimizedPackResult: OptimizedPackResult[]
    }

    export interface CostStatistics {
        totalCost: number
        averageCost: number
        minCost: number
        maxCost: number
    }

    export interface CountryInvoiceStats {
        /**
         * Country code in Alpha 2 (e.g. 'SE')
         */
        countryCode: string

        /**
         * Country code in Alpha 2 (e.g. 'SWE')
         */
        alpha3: string

        /**
         * Number of invoice rows
         */
        numberOfRows: number

        /**
         * Total amount invoiced (in specified currency)
         */
        totalInvoicedAmount: number

        /**
         * Average invoiced per package (in specified currency)
         */
        averageInvoicedPerPackage: number
    }

    export interface CountryShippingTaxRate {
        /**
         * Country code of the destination, conforming to ISO 3166-1. For example `SE` and not `SWE`.
         */
        countryCode: string

        /**
         * the tax rate, given as a decimal percentage (e.g.: 0.25 for 25%), of the organization's shipping to the destination country.
         */
        taxRate: number
    }

    export interface Creator {
        name: string
        sessionId: string
        checkoutId: string
        importId: string
    }

    export type CredentialDataType = string

    export interface CustomParameter {
        /**
         * Skrym internal ID
         */
        id: string

        /**
         * ID of the organization that can use parameter
         */
        organizationId: string

        /**
         * KeyString indicates what Skrym will try to parse as the key in a key-value pair. Example "isBulky: true" has the KeyString "isBulky".
         */
        keyString: string

        /**
         * Will be the label used in e.g. delivery checkout config
         */
        label: string

        /**
         * Description of the CustomParameter
         */
        description: string

        /**
         * Specifies which DataType the CustomParameter is of, this will affect which operations it can be used in. The different types are: [boolean, number, string, object]
         */
        dataType: datamodels.CustomParameterDataType

        /**
         * Identifies if the CustomParameter is a child to any other 'object' CustomParameter
         */
        parentId: string

        /**
         * optional property that shows a default value for the parameter in previews of the parameter and. Will be in the format "keyString": "defaultString" for strings, or "keyString" : ["default1", "default2"] for string array.
         */
        defaultValue: JSONValue

        /**
         * Specifies if the DataType is an array of said type or a single value.
         */
        isArray: boolean

        /**
         * Specifies color for displaying the CustomParameter
         */
        color: string

        /**
         * Specifies which Icon to show for the CustomParameter
         */
        icon: string

        /**
         * The time of creation
         */
        createdAt: string
    }

    /**
     * Customization represents the customization settings for an organization.
     */
    export interface Customization {
        /**
         * Unique identifier for the organization.
         */
        organizationId: string

        /**
         * Color scheme for light mode.
         */
        lightPalette: Palette

        /**
         * Color scheme for dark mode.
         */
        darkPalette: Palette

        /**
         * Border radius for elements.
         */
        borderRadius?: number
    }

    export type DailyLimitSortColumn = string

    export interface DailyOrderCount {
        /**
         * The date for which the order count is calculated
         */
        date: string

        /**
         * The number of orders for that retailer for that day
         */
        orderCount: number
    }

    export interface DeliveryTimesFilter {
        fromDate: string
        toDate: string
        originCountryCode: string
        destinationCountryCode: string
        originZipCode: string
        destinationZipCode: string
    }

    /**
     * DeliveryType is an enum that should reflect the checkout.delivery_type table
     */
    export type DeliveryType = string

    /**
     * A description in a given langauge
     */
    export interface Description {
        /**
         * ISO 639-1 code e.g. "sv" instead of "se"
         */
        language: string

        /**
         * The text content
         */
        text: string
    }

    export interface Detail {
        data: BrinkOrder
        metadata: Metadata
    }

    /**
     * DigitalTransportAgreementData contains metadata and the agreement JSON
     */
    export interface DigitalTransportAgreementData {
        /**
         * A unique identifier for the DTA.
         */
        id: string

        /**
         * A unique identifier ID for the organization the DTA belongs to.
         */
        retailerID: string

        /**
         * A unique identifier ID for the transport method.
         */
        transportMethodID: string

        /**
         * The name of the DTA (specified by the user).
         */
        agreementName: string

        /**
         * A description of the DTA
         */
        description: string

        /**
         * Denotes the if the DTA is active for a transport method. The definition of active is if the current date is within the validFrom and validTo dates.
         */
        active: boolean

        /**
         * Indicates if the DTA is a template or not.
         */
        isTemplate: boolean

        /**
         * The unique identifier of the template if the agreement was created from a template.
         */
        templateId?: string

        /**
         * The date from which the agreement is valid.
         */
        validFrom: string

        /**
         * The date until which the agreement is valid.
         */
        validTo: string

        /**
         * The factor used to calculate the volumetric weight of one m3, i.e 280 kg/m3.
         */
        volumetricWeightFactor: number

        /**
         * The JSON representation of the physical agreement.
         */
        agreement: JSONValue

        /**
         * Reference the user in the organization who created the DTA.
         */
        createdBy: string

        /**
         * Reference the user in the organization who last updated the DTA.
         */
        changedBy: string

        /**
         * Timestamp of the creation of the DTA.
         */
        createdAt: string

        /**
         * Timestamp of last update of the DTA.
         */
        updatedAt: string
    }

    export type Direction = string

    export interface DiscountCode {
        code: string
        discountCodeRuleId: string
    }

    export interface DiscountOutcomeRule {
        discountAmount: number
        reference: string
        ruleId: string
        code: string
    }

    export interface DiscountRule {
        id: string
        name: string
    }

    export interface EmailSubscription {
        accountId: string
        retailerId: string
        email: string
        subscriptions: EmailSubscriptionType[]
    }

    export type EmailSubscriptionType = string

    /**
     * EmissionResultBreakdown represents the overview and breakdown of the emissions
     * produced by OrganizationID from OrderCount orders. It breaks down the emissions
     * into packaging and shipping emissions.
     */
    export interface EmissionResultBreakdown {
        /**
         * Skrym ID of the organisation
         */
        organizationId: string

        /**
         * Emissions were calculated with data from here
         */
        calculationOrigin: CalculationOrigin

        /**
         * sum(packaging) + sum(shipping)
         */
        totalEmissions: number

        /**
         * sum(unique(orderID))
         */
        orderCount: number

        /**
         * summary of all the packaging emissions
         */
        packagingEmissionsSummary: PackagingEmissionTotals

        /**
         * summary of all shipping emissions
         */
        shippingEmissionsSummary: ShippingEmissionTotals
    }

    /**
     * Emissions information of delivering a package using a specific transport method
     */
    export interface EmissionsForTransportMethod {
        /**
         * Total emissions for the transport method (both packaging and shipping emissions included)
         */
        totalEmissions: number

        /**
         * Total shipping emissions for the transport method
         */
        totalShippingEmissions: number

        /**
         * Shipping Emissions breakdown by route segments for the transport method
         */
        shippingEmissionsBreakdown: ShippingEmissionsForTransportMethod[]
    }

    /**
     * EmissionsPacage represents the input of the package for the general emissions calculations
     * It includes the alias of the package, the dimensions of the package, the fillrate and the total weight of the package + products
     */
    export interface EmissionsPackage {
        /**
         * The alias of the package, inserted by the retailer and stored by Skrym, optional
         */
        packageAlias?: string

        /**
         * The external ID of the package, inserted by the retailer and stored by Skrym, optional
         */
        externalID?: string

        /**
         * Outer dimensions of the package [mm]
         */
        dimensions: number[]

        /**
         * Fill rate of the package, optional
         */
        fillRate?: number

        /**
         * Total weight of the package + products [g], optional
         */
        totalWeight?: number
    }

    /**
     * EmptySpace represents a region within a product that is not occupied by any material.
     * It is defined geometrically, and its shape can be either a box or a triangular prism.
     */
    export interface EmptySpace {
        /**
         * Type specifies the geometric type of the empty space, such as 'box' or 'triangle'.
         */
        type: FamilyType

        /**
         * StartCoords represents the coordinates within the product where the empty space begins. These coordinates are defined as a triplet [x, y, z], representing the starting point in a three-dimensional space.
         */
        startCoords: number[]

        /**
         * Size defines the dimensions of the empty space when it is box-shaped, specified by its length, width, and height. For a triangular shape, this field represents the full dimensions of the bounding box that the triangle fits within.
         */
        size: number[]

        /**
         * TopCoords defines the coordinates of the top back corner of a right-angled triangle, used when the empty space is triangular. This field is ignored if the Type is 'box'.
         */
        topCoords: number[]

        /**
         * TopSize describes the size of the top area of a triangular empty space. It can be zero-dimensional if the top is a point, one-dimensional if the top is a line, or two-dimensional if the top is a plane. This field is ignored if the Type is 'box'.
         */
        topSize: number[]
    }

    /**
     * EngineFuelLookup represents the compatibility between an engine type and its applicable fuel types.
     * This struct is used to define which types of fuel can be used with specific engine types,
     * facilitating accurate matching in systems dealing with vehicle specifications and environmental considerations.
     */
    export interface EngineFuelLookup {
        /**
         * EngineType denotes the type of the engine.
         */
        engineType: EngineType

        /**
         * FuelType specifies the type of fuel that can be used with the engine type.
         */
        fuelType: string
    }

    export type EngineType = string

    export interface EnvMetrics {
        transportEmission: number[]
        transportDistance: number
        packageEmission: number
        amountMaterialUsed: number
        wastedPackageMaterial: number
        fillEmission: number
        fillUsed: number
    }

    export interface Envelope {
        package: Package
        length: number
        width: number
        name?: string
        /**
         * Priority is used for sorting the envelopes in a grouped order in Scope
         */
        priority?: number

        envelopeType: string
        standardEnvelopeId?: string
    }

    export type EvaluationLogic = string

    export type EvaluationTypes = string

    export interface Event {
        /**
         * Unique identifier for the event
         */
        id: string

        /**
         * In-depth data about the event
         */
        data: EventAspect

        /**
         * Time event was reported by carrier
         */
        createdAt: string

        /**
         * Time event was received by Skrym
         */
        receivedAt: string

        /**
         * Skrym identifier of the transporter
         */
        transporterId: string

        /**
         * Skrym identifier of the shipment
         */
        trackedShipmentId: string

        /**
         * The transporter's identifier for the shipment.
         */
        shipmentTrackingReference: string

        /**
         * The retailer's reference for the shipment
         */
        externalShipmentReference: string

        /**
         * Skrym identifier of the parcel
         */
        trackedParcelId: string

        /**
         * The transporter's identifier for the parcel
         */
        parcelTrackingReference: string

        /**
         * Skrym identifier of the order
         */
        trackedOrderId: string

        /**
         * Optional info about who created the event
         */
        createdByOrganizationID: string

        /**
         * Optional info about who created the event (mainly for manual changes or connections to external systems)
         */
        createdByUserID: string

        /**
         * ID of the event map
         */
        eventMapId: string

        /**
         * ID of the event type
         */
        eventTypeId: string

        /**
         * ID of the event type message
         */
        eventTypeMessage: string

        /**
         * The message for the event. Will be empty if no message is provided.
         */
        message?: Message

        /**
         * Information about whether the shipment is inbound or outbound.
         */
        direction?: Direction

        statusIndicator?: Status
    }

    /**
     * EventAspect contains information about the event
     * 
     * Contains high-level information about an event, such as the event message.
     */
    export interface EventAspect {
        /**
         * Indication of what type of event it was. Possible values are 'arrival', 'departure', 'notification', 'delay', 'delivered' and 'error'.
         */
        type?: EventType

        /**
         * Indicates where the event took place. Will be empty if the event does not have a location (e.g. a SMS notification).
         */
        checkpoint?: Checkpoint

        /**
         * What Skrym estimates will be the next step in the delivery sequence. Will be empty if Skrym is unable to infer this.
         */
        next?: Checkpoint
    }

    export interface EventFilter {
        /**
         * Searches tracking reference and key
         */
        search?: string

        /**
         * Filter events by shipment tracking reference
         */
        shipmentTrackingReference?: string

        /**
         * Filter events by parcel tracking reference
         */
        parcelTrackingReference?: string

        createdAtFrom?: string
        createdAtTo?: string
        /**
         * Filter events by order ID
         */
        orderIds?: string[]

        shipmentIds?: string[]
        orgEventTypes?: string[]
        trackedOrderIds?: string[]
        /**
         * Filter events by created by organization ID
         */
        createdByOrganizationIds?: string[]

        /**
         * Filter events that are not mapped to an organization event type
         */
        unmapped?: boolean

        /**
         * Filter events that are not connected to a shipment
         */
        unconnectedToShipment?: boolean
    }

    export interface EventSort {
        column: EventSortColumn
        direction: string
    }

    export type EventSortColumn = string

    export type EventType = string

    export interface EventTypeMap {
        /**
         * ID of the event type map
         */
        id: string

        /**
         * ID of the default map, references defaultMap
         */
        defaultMapId: string

        /**
         * External event type
         */
        externalEventType: ExternalEventType

        /**
         * Organization event type
         */
        organizationEventType: OrganizationEventType

        /**
         * Direction of the event
         */
        direction: Direction

        /**
         * Time the event type map was created
         */
        createdAt: string

        /**
         * Time the event type map was last updated
         */
        updatedAt: string

        /**
         * Whether the event type map is active
         */
        active: boolean

        /**
         * ID of the user who last updated the event type map
         */
        updatedBy: string

        /**
         * Messages for the event type map
         */
        messages: EventTypeMapMessage[]
    }

    /**
     * EventTypeMessage represents a message for an event type in a specific language
     */
    export interface EventTypeMapMessage {
        /**
         * ID of the map message
         */
        id: string

        /**
         * ID of the map, references eventTypeMap
         */
        mapId: string

        /**
         * ID of the default map message, references defaultMapMessage
         */
        defaultMapMessageId: string

        /**
         * Message for the event type map
         */
        message: string

        /**
         * Language of the message in ISO 639-1 format
         */
        language: iso.IsoLanguage

        /**
         * Time the map message was created
         */
        createdAt: string

        /**
         * Time the map message was last updated
         */
        updatedAt: string

        /**
         * Whether the message is active
         */
        active: boolean

        /**
         * ID of the user who created the map message
         */
        createdBy: string

        /**
         * ID of the user who last updated the map message
         */
        updatedBy: string
    }

    /**
     * EventTypeMessage represents a message for an event type in a specific language
     */
    export interface EventTypeMessage {
        /**
         * ID of the event type message
         */
        id: string

        /**
         * ID of the event type, references organizationEventType
         */
        eventTypeId: string

        /**
         * Message for the event type
         */
        message: string

        /**
         * Language of the message in ISO 639-1 format
         */
        language: iso.IsoLanguage

        /**
         * ID of the organization
         */
        organizationId: string

        /**
         * Time the event type message was created
         */
        createdAt: string

        /**
         * Time the event type message was last updated
         */
        updatedAt: string

        /**
         * Whether the message is active
         */
        active: boolean

        /**
         * ID of the user who last updated the event type message
         */
        updatedBy: string
    }

    /**
     * ExternalEventType represents a type of event that can be send by en external organization
     */
    export interface ExternalEventType {
        /**
         * Unique code for the event type
         */
        code: string

        /**
         * ID of the organization
         */
        organizationId: string

        /**
         * Description of the event type
         */
        description: string

        /**
         * Time the event type was created
         */
        createdAt: string

        /**
         * Time the event type was last updated
         */
        updatedAt: string
    }

    /**
     * FailedShippingEmissionsResult captures information about a failed emissions calculation.
     */
    export interface FailedShippingEmissionsResult {
        /**
         * Transporter name.
         */
        transporter: string

        /**
         * Transport method attempted.
         */
        transportMethod: string

        /**
         * Error encountered.
         */
        error: string

        /**
         * User-readable error message.
         */
        errorDetails: string
    }

    /**
     * Family represents different shapes that items in a order can be.
     * Every product that has a special features should also be part of a family.
     * All families have the Type field but depending on what the family type is the rest of the fields may be null/empty.
     */
    export interface Family {
        /**
         * Type represents the family type.
         */
        type: FamilyType

        /**
         * ShapeCoords are the coordinates defining the shape of the family.
         */
        shapeCoords: number[]

        /**
         * TopSize represents the size of the top of the family's shape.
         */
        topSize: number[]

        /**
         * NrFolds is the number of folds in the family's structure.
         */
        nrFolds: number

        /**
         * ESpaces is an array of empty spaces within the family structure.
         */
        emptySpaces: EmptySpace[]

        /**
         * VolumeCompressionFactor indicates how much the family's volume can be compressed.
         */
        volumeCompressionFactor: number
    }

    export type FamilyType = string

    /**
     * FeeApplied is a utility struct for showing which fees have been applied when querying a transport agreement with a freight object
     * 
     * Note that this is not a part of the digital transport agreement itself, but rather an output from querying the agreement.
     * TODO: Adjust cost calculation to return ID, parent ID and code as well
     */
    export interface FeeApplied {
        /**
         * TODO: Make this optional?
         */
        id: string

        /**
         * TODO: Make this optional?
         */
        parentId: string

        /**
         * TODO:  Make this optional?
         */
        code: string

        /**
         * The type of fee that was applied
         */
        feeType: FeeType

        /**
         * Transporter fee codes that this fee is an alias for. Used for mapping fees from different transporters to the same fee in Skrym.
         */
        feeAliases: string[]

        /**
         * The amount (in SEK) of the added fee. We need this for the fees that are percentages of the base cost. (in the standard denomination of the currency)
         */
        amount: number

        /**
         * Descriptions of the fee group in various languages. At least descriptions in English ("EN") and Swedish ("SV") are required.
         */
        description: Description[]

        /**
         * Indicates if the fee will break the availability of the transport method
         */
        breaking: boolean

        /**
         * Used to infer what the actual amount should be
         */
        operation: FeeOperation
    }

    /**
     * FeeOperation determines how a fee will be applied to the total cost when querying a digital transport agreement
     * 
     * Note that the FeeOperation is designed to handle both percentage-based fees and addition-based fees
     */
    export type FeeOperation = string

    export type FeeType = string

    export interface FillMaterial {
        id: string
    }

    /**
     * The fill rate for a specific retailer for a specific date.
     */
    export interface FillRate {
        /**
         * The date for which the fill rate is calculated
         */
        date: string

        /**
         * The cumulative volume of all the products for that retailer for that day. Unit is [mm^3]
         */
        totalProductVolume: number

        /**
         * The cumulative volume of all the packages for that retailer for that day. Unit is [mm^3]
         */
        totalPackageVolume: number

        /**
         * Actually not saved in the database, but is calculated as it's fetched from the DB as ProductVolume divided
         * by PackageVolume. The range is [0, 1]
         */
        fillRate: number
    }

    export interface FillRateData {
        /**
         * The cumulative volume of all the products for that package for that day. Unit is [mm^3]
         */
        productVolume: number

        /**
         * The cumulative volume of all the packages for that package for that day. Unit is [mm^3]
         */
        packageVolume: number

        /**
         * Actually not saved in the database, but is calculated as it's fetched from the DB as ProductVolume divided
         * by PackageVolume. The range is [0, 1]
         */
        fillRate: number
    }

    /**
     * The fill rate distribution for a specific retailer for a specific date.
     */
    export interface FillRateDistribution {
        /**
         * The date for which the fill rate distribution is calculated
         */
        date: string

        /**
         * The fill rate distribution, where index i means the number of orders which has a fill rate between i and i+1 percent
         */
        fillRateDistribution: number[]
    }

    export interface FixedPackage {
        package: Package
        dimensions: number[]
        outerDimensions: number[]
    }

    export interface Fold {
        /**
         * A unique identifier assigned by Skrym to the fold
         */
        id: string

        /**
         * The style of the fold
         */
        style: string

        /**
         * The version of the style
         */
        version: string
    }

    export interface FragilityIndexPadding {
        organizationID: string
        fragilityIndex: number
        name: string
        description: string
        paddingMaterial: string
        paddingThickness: number
        createdAt: string
    }

    /**
     * Fuel represents a row in the fuel table.
     */
    export interface Fuel {
        /**
         * Name of the fuel type.
         */
        name: string

        /**
         * Reference emissions for the fuel, in kg CO2e per unit.
         */
        referenceEmissionsByFuel: number

        /**
         * Description of the fuel type.
         */
        description: string
    }

    export interface FullyAdjustablePackage {
        package: Package
        minHeight: number
        maxHeight: number
        minWidth: number
        maxWidth: number
        minLength: number
        maxLength: number
        outerMinHeight: number
        outerMaxHeight: number
        outerMinWidth: number
        outerMaxWidth: number
        outerMinLength: number
        outerMaxLength: number
    }

    export interface GiftCard {
        status: string
        providerId: string
        additional: GiftCardAdditional
        providerName: string
        giftCards: GiftCardItem[]
    }

    export interface GiftCardAdditional {
        retain24: { [key: string]: string }
    }

    export interface GiftCardItem {
        id: string
        amount: number
        reservationId: string
        redeemId: string
        currencyCode: string
        status: string
    }

    /**
     * The package usage volume for a specific retailer for a specific date.
     */
    export interface GroupedPackageFillRate {
        /**
         * The date for which the order count is calculated
         */
        date: string

        /**
         * The fill rates for different packages for that day
         */
        fillRates: PackagesFillRateData
    }

    /**
     * The fill rate distributions for packages for a specific retailer for a specific date.
     */
    export interface GroupedPackageFillRateDistribution {
        /**
         * The date for which the fill rate distributions are calculated
         */
        date: string

        /**
         * The fill rate distribution for each package, where index i means the number of orders which has a fill rate between i and i+1 percent
         */
        packageFillRateDistribution: PackagesFillRateDistributionData
    }

    /**
     * The package usage count for a specific package specific retailer for a specific date.
     */
    export interface GroupedPackageUsageCount {
        /**
         * The date for which the order count is calculated
         */
        date: string

        /**
         * The number of times the packages was used for that day
         */
        usageCounts: PackagesUsageCountData
    }

    export interface HeightAdjustablePackage {
        package: Package
        minHeight: number
        maxHeight: number
        dimensions: number[]
        outerMinHeight: number
        outerMaxHeight: number
        outerDimensions: number[]
    }

    export interface HistoricPrintJob {
        id: number
        printer: HistoricPrintJobPrinterInfo
        title: string
        contentType: string
        source: string
        /**
         * ExpireAt       interface{} `json:"expireAt"` // Use interface{} as the date format may vary
         */
        createTimestamp: string

        state: string
    }

    /**
     * PrinterInfo details about the printer used for the print job.
     */
    export interface HistoricPrintJobPrinterInfo {
        id: number
        name: string
        description: string
        state: string
        createTimestamp: string
    }

    export interface HyperParameterWithAllowedValues {
        /**
         * Type of the hyperparameter, e.g NUMERIC, ENUM
         */
        parameterType: HyperparameterType

        /**
         * Name of the hyperparameter, e.g NUM_SPLITS, PRESERVE_ORDER_LINES
         */
        parameter: Hyperparameter

        /**
         * Allowed values for the hyperparameter if it is of type ENUM
         */
        enumValues: OptimizationEnumValue[]
    }

    /**
     * Hyperparameter is a string type for
     * all optimization hyperparameters.
     */
    export type Hyperparameter = string

    /**
     * HyperparameterType can be either NUMERIC or ENUM
     */
    export type HyperparameterType = string

    export interface IMICredentials {
        /**
         * Unique identifier for the IMI credentials
         */
        id: string

        /**
         * Organization ID
         */
        organizationId: string

        /**
         * Username for the IMI credentials
         */
        username: string

        /**
         * Password for the IMI credentials
         */
        password: string

        /**
         * Company name for the IMI credentials
         */
        companyName: string

        /**
         * Time when the IMI credentials were created
         */
        createdAt: string

        /**
         * Time when the IMI credentials were last updated
         */
        updatedAt: string

        /**
         * Whether the credentials are allowed to put optimization results or not. Default is false
         */
        putOptimizationResult: boolean
    }

    /**
     * Attributes represents the additional dynamic attributes related to the status
     */
    export interface IcaAttributes {
        /**
         * RACK or LOCKER, sent with Status = delivery.servicepoint.started
         */
        deliveryModule: string

        /**
         * Reason for refusal or comment on a picked-up parcel, optional
         */
        deviation: string

        locationName: string
    }

    /**
     * EstimatedArrivalTime represents the forecasted earliest and latest arrival times
     */
    export interface IcaEstimatedArrivalTime {
        /**
         * RFC 3339 format
         */
        earliest: string

        /**
         * RFC 3339 format
         */
        latest: string
    }

    export type IcaEventStatus = string

    /**
     * Receiver represents the recipient of the package
     */
    export interface IcaReceiver {
        /**
         * Name of the recipient, optional
         */
        name: string

        /**
         * Email of the recipient, optional
         */
        email: string

        /**
         * Phone number of the recipient, optional
         */
        phone: string
    }

    /**
     * Tracking represents the parcel event and tracking information
     */
    export interface IcaTrackingEvent {
        /**
         * Id for the parcel triggering the event, mandatory
         */
        trackingId: string

        /**
         * Event name (status), mandatory
         */
        status: IcaEventStatus

        /**
         * OrderId provided or generated UUID, mandatory
         */
        orderId: string

        /**
         * Value provided when order was placed, optional
         */
        senderReference: string

        /**
         * When the event occurred, RFC 3339 format, mandatory
         */
        timestamp: string

        /**
         * Forecasting earliest and latest arrival times, mandatory
         */
        estimatedArrivalTime: IcaEstimatedArrivalTime

        /**
         * Recipient information, optional
         */
        receiver: IcaReceiver

        /**
         * Different attributes for different statuses, optional
         */
        attributes: IcaAttributes
    }

    export interface InboundEmail {
        retailerId: string
        email: string
    }

    /**
     * An observation of an attribute of a product
     */
    export interface InferenceObservation {
        /**
         * Unique identifier for the observation
         */
        ID: string

        /**
         * ID of the product this observation belongs to
         */
        ProductID: string

        /**
         * External ID of the product this observation belongs to
         */
        ExternalID: string

        /**
         * The type of the observation (min, max, general)
         */
        Type: ObservationType

        /**
         * The attribute of the product this observation is about
         */
        Attribute: ObservationAttribute

        /**
         * The value of the observation. Should be in Skrym standard units (g, mm3, mm)
         */
        Value: number

        /**
         * The source of the observation
         */
        SourceType: ObservationSourceType

        /**
         * A unique identifier for the source of the observation to prevent duplicate observations
         */
        SourceIdentifier: string

        /**
         * The time when the observation was created
         */
        CreatedAt: string

        /**
         * The time when the observation was last updated
         */
        UpdatedAt: string
    }

    /**
     * An inferred product is the collected observations of a product
     */
    export interface InferredProduct {
        /**
         * Unique identifier for the product. Should be same as in the repo service.
         */
        ID: string

        /**
         * External ID of the product. Should be same as in the repo service.
         */
        ExternalID: string

        /**
         * ID of the organization this product belongs to
         */
        OrganizationID: string

        /**
         * Inferred volume
         */
        Volume: MinMaxInterval

        /**
         * Inferred weight
         */
        Weight: MinMaxInterval

        /**
         * Inferred max dimension
         */
        MaxDim: MinMaxInterval

        /**
         * Inferred mid dimension
         */
        MidDim: MinMaxInterval

        /**
         * Inferred min dimension
         */
        MinDim: MinMaxInterval

        /**
         * List of observations for this product
         */
        Observations: InferenceObservation[]

        /**
         * The time when the product was created
         */
        CreatedAt: string

        /**
         * The time when the product inference was last updated
         */
        UpdatedAt: string
    }

    export interface IngridDelivery {
        carrierProductId: string
        currencyCode: string
        taxAmount: number
        name: string
        taxGroupId: string
        taxPercentage: number
        deliveryAddress: IngridDeliveryAddress
        deliveryType: string
        groupId: string
        price: number
        tosId: string
    }

    export interface IngridDeliveryAddress {
        country: string
        city: string
        postalCode: string
        name: string
        addressLines: string[]
    }

    export type InitialContainerSelectionTypes = string

    export type InstaboxEventName = string

    /**
     * https://www.instadocs.se/docs#section-9
     */
    export interface InstaboxWebhookEvent {
        /**
         * Id String
         */
        "checkpoint_id": string

        /**
         * Parcel ID, ie barcode
         */
        "parcel_id": string

        /**
         * Merchants’s order reference
         */
        "order_number": string

        /**
         * InitialCheckpoint|SortingCheckpoint|CourierDropoffCheckpoint|CustomerPickupCheckpoint|CustomerDropoffCheckpoint|CourierPickupCheckpoint etc
         */
        type: InstaboxEventName

        /**
         * type_description
         */
        "type_description": string

        /**
         * location_name
         */
        "location_name": string

        /**
         * ISO-8601 Date String w UTC time zone
         */
        timestamp: string
    }

    export interface Invitation {
        id: string
        expiryDate: string
        accountId: string
        finished: boolean
    }

    /**
     * InvoiceColumn is an enum reflecting the field names of InvoiceRow
     */
    export type InvoiceColumn = string

    /**
     * InvoiceColumnMapping is the actual mapping between single
     * invoice column and the corresponding field in InvoiceRow.
     */
    export interface InvoiceColumnMapping {
        /**
         * Unique identifier for the column mapping
         */
        id: string

        /**
         * ID referencing the invoice mapping it belongs to
         */
        invoiceMappingId: string

        /**
         * Which Skrym column the mapping will send data to
         */
        fieldName: InvoiceColumn

        /**
         * What the column is named in the invoice
         */
        invoiceFieldName: string

        /**
         * Which unit the values in the column are in
         */
        invoiceFieldUnit: utils.MeasurementUnit

        /**
         * Optional value for how to resolve multiple columns poiting to the same `fieldName`. Only needed if more than one column mapping points to the same column.
         */
        resolver?: MultiColumnResolution

        /**
         * Is needed if more than one column mapping has the same destination value and the resolution method is ranked.
         */
        resolverPriority?: number

        /**
         * If the column is used for grouping multi-row invoices
         */
        groupingColumn: boolean

        /**
         * If the column should be filled with the value form previous row if it's empty
         */
        fillEmptyFromPrevious: boolean

        /**
         * Optional value for the fee type of the column. Only used for fee columns
         */
        feeType?: FeeType

        /**
         * Timestamp of when the mapping was created
         */
        createdAt: string

        /**
         * Timestamp of last update to the column mapping
         */
        updatedAt: string

        /**
         * Optional value for the delimiter used in the cell. Only used for string arrays.
         */
        cellDelimiter?: string
    }

    /**
     * These are enums used for the server-side sorting of invoice row (with expected) tables
     */
    export type InvoiceControlRowColumn = string

    export interface InvoiceFeeLabel {
        label: string
        totalCost: number
        averageCost: number
        numberOfRows: number
    }

    export interface InvoiceFeeMonthStats {
        monthStart: string
        feeStats: InvoiceFeeStats[]
    }

    export interface InvoiceFeeStats {
        currency: datamodels.Currency
        feeType: FeeType
        totalCost: number
        averageCost: number
        numberOfRows: number
        /**
         * Breakdown by label
         */
        labelStats: InvoiceFeeLabel[]
    }

    export interface InvoiceFeeTypeWithLabels {
        /**
         * The fee type
         */
        feeType: FeeType

        /**
         * The labels associated with the fee type
         */
        labels: string[]
    }

    /**
     * InvoiceMapping is a reference to a single map between
     * the invoice's native columns/fields and InvoiceRow's
     * fields.
     */
    export interface InvoiceMapping {
        /**
         * Unique identifier for the invoice mapping
         */
        id: string

        /**
         * Identifier for the organization the mapping belongs to
         */
        organizationId: string

        /**
         * Name of the mapping
         */
        mappingName: string

        /**
         * Optional description for the mapping
         */
        description: string

        /**
         * Timestamp of when the mapping was created
         */
        createdAt: string

        /**
         * Timestamp of last update to the invoice mapping (not to its associated column mappings)
         */
        updatedAt: string
    }

    export interface InvoiceMonthInfo {
        monthStart: string
        /**
         * Number of invoice rows
         */
        invoiceRows: number

        /**
         * Sum of the 'quantity' value for all invoice rows
         */
        packages: number

        /**
         * Cost statistics
         */
        cost: CostStatistics
    }

    export type InvoiceProcessingStatus = string

    /**
     * An InvoiceRow represents the structure of a row in the invoice
     * 
     * InvoiceRow is Skrym's standardised structure for representing
     * one unit of invoice data. It mirrors the invoice_row table columns.
     * InvoiceRow is also used in calculating deviations from DTAs.
     * InvoiceRow currency refers to the currency as described in the actual invoice
     */
    export interface InvoiceRow {
        /**
         * Unique identifier for the invoice row
         */
        id: string

        /**
         * Unique identifier the organization uploading the invoice
         */
        organizationID: string

        /**
         * Reference to the invoice
         */
        invoiceID: string

        transporterCodeForMethod: string
        transporterPriceGroup: string
        transporterReference: string
        externalReference: string
        transportMethodID: string
        transportMethod: string
        transporter: string
        transporterID: string
        shipmentDate: string
        shipmentID: string
        parcelReference: string
        costUnit: string
        invoicedBaseCost: number
        invoicedBaseCostCurrency: datamodels.Currency
        invoicedFeeSum: number
        invoicedFeeSumCurrency: datamodels.Currency
        invoicedTotal: number
        invoicedTotalCurrency: datamodels.Currency
        unitType: string
        originAddress: string
        originZip: string
        originCity: string
        originCityCode: string
        originRegion: string
        originRegionCode: string
        /**
         * Alpha 2 format
         */
        originCountryCode: string

        destinationAddress: string
        destinationZip: string
        destinationCity: string
        destinationCityCode: string
        destinationRegion: string
        destinationRegionCode: string
        /**
         * Alpha 2 format
         */
        destinationCountryCode: string

        description: string
        dtaID: string
        quantity: number
        numberOfParcels: number
        palletPlaces: number
        debitableWeight: number
        volume: number
        weight: number
        length: number
        height: number
        width: number
        dimensions: string
        loadingMeter: number
        shippingDistance: number
        createdAt: string
        updatedAt: string
        status: InvoiceRowStatus
        addons: string[]
        skrymOrderID: string
        /**
         * Soft delete timestamp. If present, the row is considered deleted and will be hard deleted sometime in the future.
         */
        deletedAt?: string
    }

    export interface InvoiceRowBestGuessFieldSources {
        /**
         * InvoiceRowID is the invoice row this field source data belongs to.
         */
        invoiceRowId: string

        weightObservationId: string
        dimensionsObservationId: string
        destinationZipObservationId: string
        destinationCountryObservationId: string
        volumeObservationId: string
        debitableWeightObservationId: string
        originZipObservationId: string
        originCountryObservationId: string
        lengthObservationId: string
        widthObservationId: string
        heightObservationId: string
        shippingDistanceObservationId: string
        quantityObservationId: string
        addonsObservationId: string
        destinationCityObservationId: string
        destinationRegionObservationId: string
        destinationCityCodeObservationId: string
        destinationRegionCodeObservationId: string
        originCityObservationId: string
        originRegionObservationId: string
        originCityCodeObservationId: string
        originRegionCodeObservationId: string
        transportMethodObservationId: string
        transporterObservationId: string
        transportMethodIdObservationId: string
        transporterIdObservationId: string
        parcelReferenceObservationId: string
        numberOfParcelsObservationId: string
        palletPlacesObservationId: string
        shipmentDateObservationId: string
    }

    /**
     * InvoiceRowControlFilter is a helper struct for sorting
     * the invoice table in Scope.
     */
    export interface InvoiceRowControlFilter {
        /**
         * Searches for the external reference
         */
        search?: string

        shipmentDateFrom?: string
        shipmentDateTo?: string
        transportMethods?: string[]
        transporters?: string[]
        invoiceId?: string
        status?: InvoiceRowStatus[]
        feeTypes?: string[]
        feeLabels?: string[]
        /**
         * External references to filter by
         */
        references?: string[]
    }

    /**
     * InvoiceRowControlSort is a helper struct for sorting
     * the invoice table in Scope.
     */
    export interface InvoiceRowControlSort {
        columnField: InvoiceControlRowColumn
        direction: string
    }

    /**
     * InvoiceRowExpected summarizes the expected costs of
     * of one InvoiceRow.
     */
    export interface InvoiceRowExpected {
        id: string
        invoiceID: string
        invoiceRowID: string
        expectedBaseCost: number
        expectedBaseCostCurrency: datamodels.Currency
        expectedAddedFeeSum: number
        expectedAddedFeeCurrency: datamodels.Currency
        expectedPenaltyFeeSum: number
        expectedPenaltyFeeCurrency: datamodels.Currency
        expectedTotalCost: number
        expectedTotalCostCurrency: datamodels.Currency
    }

    export interface InvoiceRowExpectedDetail {
        id: string
        invoiceRowID: string
        amount: number
        currency: datamodels.Currency
        costID: string
        costGroupID: string
        costType: string
        createdAt: string
        updatedAt: string
    }

    export interface InvoiceRowFee {
        id: string
        invoiceRowID: string
        costID: string
        currency: datamodels.Currency
        costType: FeeType
        description: string
        amount: number
        createdAt: string
        updatedAt: string
    }

    export interface InvoiceRowFeeMoreInfo {
        id: string
        invoiceRowID: string
        costID: string
        costType: FeeType
        amount: number
        identifierInInvoice: string
        label: string
        description: string
        createdAt: string
        updatedAt: string
    }

    /**
     * InvoiceRowFieldSource represents the best-guess observation IDs for each
     * invoice_row field, establishing a 1-to-1 mapping per invoice row.
     * Each field points to the observation that contributed that value.
     */
    export interface InvoiceRowFieldSource {
        /**
         * InvoiceRowID is the invoice row this field source data belongs to.
         */
        invoiceRowId: string

        /**
         * BestGuessObservationID is the observation ID that best represents the value for this field.
         */
        bestGuessObservationIds: InvoiceRowBestGuessFieldSources

        /**
         * OverrideObservationID is the observation ID that overrides the best guess for this field.
         */
        overrideObservationIds: InvoiceRowFieldSourceOverrides

        /**
         * Timestamps
         */
        createdAt: string

        updatedAt: string
        /**
         * Audit fields
         */
        createdBy: string

        updatedBy: string
    }

    export interface InvoiceRowFieldSourceFilters {
        invoiceRowIds?: string[]
        bestGuessObservationIds?: string[]
        overrideObservationIds?: string[]
    }

    export interface InvoiceRowFieldSourceOverrides {
        /**
         * InvoiceRowID is the invoice row this field source data belongs to.
         */
        invoiceRowId: string

        /**
         * ObservationID Overrides
         * These act as an override to the best guess of the invoice row field source
         */
        weightOverrideObservationId?: string

        dimensionsOverrideObservationId?: string
        destinationZipOverrideObservationId?: string
        destinationCountryOverrideObservationId?: string
        volumeOverrideObservationId?: string
        debitableWeightOverrideObservationId?: string
        originZipOverrideObservationId?: string
        originCountryOverrideObservationId?: string
        lengthOverrideObservationId?: string
        widthOverrideObservationId?: string
        heightOverrideObservationId?: string
        shippingDistanceOverrideObservationId?: string
        quantityOverrideObservationId?: string
        addonsOverrideObservationId?: string
        destinationCityOverrideObservationId?: string
        destinationRegionOverrideObservationId?: string
        destinationCityCodeOverrideObservationId?: string
        destinationRegionCodeOverrideObservationId?: string
        originCityOverrideObservationId?: string
        originRegionOverrideObservationId?: string
        originCityCodeOverrideObservationId?: string
        originRegionCodeOverrideObservationId?: string
        transportMethodOverrideObservationId?: string
        transporterOverrideObservationId?: string
        transportMethodIdOverrideObservationId?: string
        transporterIdOverrideObservationId?: string
        parcelReferenceOverrideObservationId?: string
        numberOfParcelsOverrideObservationId?: string
        palletPlacesOverrideObservationId?: string
        shipmentDateOverrideObservationId?: string
    }

    /**
     * InvoiceRowObservation represents a single measurement or assertion of values
     * for a particular invoice row, originating from a specific source (e.g. warehouse scan,
     * transporter report, order data).
     * 
     * This is used for auditing, comparison, and potentially overriding fields in the invoice_row.
     */
    export interface InvoiceRowObservation {
        /**
         * ID is the unique identifier of this observation.
         */
        id: string

        /**
         * InvoiceRowID links this observation to a specific invoice row. Optional.
         */
        invoiceRowId: string

        /**
         * InvoiceID links this observation to the invoice it belongs to. Optional.
         */
        invoiceId: string

        /**
         * OrganizationID is the ID of the organization this observation belongs to.
         */
        organizationId: string

        /**
         * ShipmentExternalReference is an optional external reference to the invoice row or shipment.
         */
        shipmentExternalReference: string

        /**
         * ObservationSource indicates where this observation originated from (e.g. ORDER, INVOICE, WAREHOUSE_SCANNER).
         */
        observationSource: ObservationSource

        /**
         * Weight is the observed weight of the shipment.
         */
        weight: number

        /**
         * Dimensions is the observed dimensions of the shipment, typically a string like "LxWxH".
         */
        dimensions: string

        /**
         * Volume is the calculated or measured volume of the shipment.
         */
        volume: number

        /**
         * DebitableWeight is the weight used for billing purposes.
         */
        debitableWeight: number

        /**
         * Length is the observed length of the shipment in centimeters.
         */
        length: number

        /**
         * Width is the observed width of the shipment in centimeters.
         */
        width: number

        /**
         * Height is the observed height of the shipment in centimeters.
         */
        height: number

        /**
         * ShippingDistance is the distance covered for the shipment, in kilometers.
         */
        shippingDistance: number

        /**
         * Quantity is the number of units or parcels in the shipment.
         */
        quantity: number

        /**
         * Addons lists any additional services or modifiers observed (e.g. "Fragile", "Express").
         */
        addons: string[]

        /**
         * DestinationZip is the zip code of the destination.
         */
        destinationZip: string

        /**
         * DestinationCountry is the country code of the destination.
         */
        destinationCountry: string

        /**
         * OriginZip is the zip code of the origin.
         */
        originZip: string

        /**
         * OriginCountry is the country code of the origin.
         */
        originCountry: string

        /**
         * ShipmentDate is the date the shipment was made.
         */
        shipmentDate: string

        /**
         * DestinationCity is the name of the destination city.
         */
        destinationCity: string

        /**
         * DestinationRegion is the name of the destination region.
         */
        destinationRegion: string

        /**
         * DestinationCityCode is the code for the destination city.
         */
        destinationCityCode: string

        /**
         * DestinationRegionCode is the code for the destination region.
         */
        destinationRegionCode: string

        /**
         * OriginCity is the name of the origin city.
         */
        originCity: string

        /**
         * OriginRegion is the name of the origin region.
         */
        originRegion: string

        /**
         * OriginCityCode is the code for the origin city.
         */
        originCityCode: string

        /**
         * OriginRegionCode is the code for the origin region.
         */
        originRegionCode: string

        /**
         * TransportMethod is the observed transport method.
         */
        transportMethod: string

        /**
         * Transporter is the name of the transporter.
         */
        transporter: string

        /**
         * TransportMethodID is the ID of the transport method.
         */
        transportMethodId: string

        /**
         * TransporterID is the ID of the transporter.
         */
        transporterId: string

        /**
         * ParcelReference is the reference identifier for the parcel.
         */
        parcelReference: string

        /**
         * NumberOfParcels is the number of parcels in the shipment.
         */
        numberOfParcels: number

        /**
         * PalletPlaces indicates the number of pallet places used.
         */
        palletPlaces: number

        /**
         * CreatedAt is the timestamp when this observation was created.
         */
        createdAt: string

        /**
         * UpdatedAt is the timestamp when this observation was last updated.
         */
        updatedAt: string

        /**
         * CreatedBy is the ID of the user who created the observation.
         */
        createdBy: string

        /**
         * UpdatedBy is the ID of the user who last updated the observation.
         */
        updatedBy: string

        /**
         * SourceID is the ID of the exact source of the information (invoice_id if source is invoice, etc.).
         */
        sourceId: string
    }

    export interface InvoiceRowObservationFilters {
        invoiceRowIds?: string[]
        invoiceIds?: string[]
        organizationId?: string
        ids?: string[]
        shipmentExternalReferences?: string[]
        observationSources?: ObservationSource[]
        sourceIds?: string[]
    }

    export type InvoiceRowStatus = string

    /**
     * InvoiceRowWithExpected shows the expected costs
     * for the Invoice(d)Row.
     */
    export interface InvoiceRowWithExpected {
        invoiced: InvoiceRow
        expected?: InvoiceRowExpected
    }

    export interface InvoiceWithBreakdown {
        invoiceId: string
        displayName: string
        originalName: string
        totalInvoicedForSuccessfulCost: number
        totalExpectedForSuccessfulCost: number
        totalDeviationAmount: number
        averageDeviationAmount: number
        uploadedDate: string
        transportMethods: string[]
        rowStatusBreakdown: { [key: InvoiceRowStatus]: number }
        totalInvoicedAmount: number
        mappingId: string
        supplierReference: string
        supplierContact: string
        invoiceDate: string
        customerName: string
        accountId: string
    }

    export interface InvoiceWithSummaryStats {
        invoiceID: string
        displayName: string
        originalName: string
        totalRows: number
        totalInvoicedAmount: number
        uploadedDate: string
        transportMethods: string[]
        transporters: string[]
        processingStatus: InvoiceProcessingStatus
        processingMessage: string
    }

    export interface InvoicesFilter {
        /**
         * Searches for the name of the invoice
         */
        search?: string

        invoiceIDs?: string[]
        status?: InvoiceProcessingStatus[]
    }

    export interface InvoicesSort {
        columnField: UploadedInvoiceColumn
        direction: string
    }

    /**
     * Journey represents a journey that a shipment can take
     */
    export interface Journey {
        /**
         * ID of the journey
         */
        id: string

        /**
         * Unique reference identifying the journey
         */
        reference: string

        /**
         * Name of the journey
         */
        name: string

        /**
         * Description of the journey
         */
        description: string

        /**
         * ID of the organization
         */
        organizationId: string

        /**
         * Time the journey was created
         */
        createdAt: string

        /**
         * Time the journey was last updated
         */
        updatedAt: string

        /**
         * ID of the user who last updated the journey
         */
        updatedBy: string

        /**
         * Whether the journey is active
         */
        active: boolean

        /**
         * Whether the journey is a default journey
         */
        default: boolean

        /**
         * Whether the journey is a widget journey
         */
        onWidget: boolean

        /**
         * Milestones of the journey
         */
        milestones: JourneyMilestone[]
    }

    export interface JourneyFilters {
        onlyActive?: boolean
        journeyIds?: string[]
        journeyNames?: string[]
        journeyReferences?: string[]
        default?: boolean
        onlyWidget?: boolean
    }

    export interface JourneyMilestone {
        /**
         * ID of the journey
         */
        journeyId: string

        /**
         * ID of the milestone
         */
        milestoneId: string

        /**
         * Sequence of the milestone in the journey
         */
        sequence?: number

        /**
         * The order to display the milestone in within its sequence.
         */
        displayOrdering?: number

        /**
         * Whether the milestone is the final milestone in the journey
         */
        final: boolean

        /**
         * Time the journey milestone was created
         */
        createdAt: string

        /**
         * Time the journey milestone was last updated
         */
        updatedAt: string

        /**
         * ID of the user who last updated the journey milestone
         */
        updatedBy: string

        /**
         * Milestone of the journey
         */
        milestone: Milestone

        /**
         * Icon of the milestone to be shown on scope (optional)
         */
        icon: string

        /**
         * Color of the milestone to be shown on scope (optional); hexcode
         */
        color: string

        /**
         * Triggers for the milestone
         */
        triggers: CompletedJourneyMilestoneTrigger[]
    }

    /**
     * JourneySnapshot represents a snapshot of a journey at a specific point in time.
     */
    export interface JourneySnapshot {
        id: string
        journeyId: string
        /**
         * The ID of the connection between tracked order and tracked shipment
         */
        trackedOrderShipmentId: string

        name: string
        reference: string
        /**
         * Whether the journey has been completed
         */
        completed: boolean

        /**
         * The time at which the journey was completed
         */
        timeOfCompletion: string

        /**
         * The time at which the journey was last updated
         */
        timeOfLastUpdated: string

        milestones: MilestoneSnapshot[]
        /**
         * Whether the journey is used on a widget
         */
        onWidget: boolean
    }

    export interface JourneySnapshotFilter {
        ids?: string[]
        journeyId?: string
        /**
         * NOTE: Not the shipment IDs themselves, but the ID of the connection between the order and the shipment
         */
        trackedOrderShipmentIds?: string[]

        name?: string
        reference?: string
        completed?: boolean
        onlyWidget?: boolean
    }

    export interface KlarnaCarrierProduct {
        identifier: string
        name: string
    }

    export interface KlarnaLocation {
        id: string
        address: KlarnaLocationAddress
        name: string
        price: number
    }

    export interface KlarnaLocationAddress {
        country: string
        city: string
        postalCode: string
        region: string
        streetAddress: string
        streetAddress2: string
    }

    export interface KlarnaSelectedAddon {
        externalId: string
        price: number
        type: string
        userInput: string
    }

    export interface KlarnaShippingOption {
        carrier: string
        carrierProduct: KlarnaCarrierProduct
        location: KlarnaLocation
        name: string
        price: number
        selectedAddons: KlarnaSelectedAddon[]
        taxAmount: number
        taxRate: number
        timeslot: KlarnaTimeslot
        tmsReference?: string
        type: string
    }

    export interface KlarnaTimeslot {
        cutoff: string
        end: string
        id: string
        price: number
        start: string
    }

    export interface LatestReachedMilestoneCount {
        journeyId: string
        milestoneId: string
        organizationId: string
        count: number
        timestamp: string
    }

    export interface LiveOrderTransport {
        originZip: string
        destinationZip: string
        originCountry: string
        destinationCountry: string
        transporter: string
        transportMethod: string
    }

    /**
     * These are enums used for the server-side sorting of location tables
     */
    export type LocationFilterColumn = string

    export interface LocationSort {
        columnField: LocationFilterColumn
        sort: string
    }

    export type LogData = { [key: string]: string }

    export interface LogEntry {
        id: number
        timestamp: string
        service: string
        title: string
        message: string
        data: LogData
        retailerId: string
        accountId: string
    }

    /**
     * LogoUsageType represents the type of usage for a logo.
     */
    export type LogoUsageType = string

    export interface Material {
        /**
         * A unique identifier assigned by Skrym to the material
         */
        id: number

        /**
         * The type of material can be one of the following: "Paper", "Plastic", "Carboard", "Unknown	"
         */
        materialType: string

        /**
         * A name given by the user to the material
         */
        name?: string

        /**
         * Percentage of recycled material to be used as 0.0 to 1.0
         */
        recycledPercentage?: number

        /**
         * The CO2 equivalent of the material
         */
        "co2_equivalent"?: number

        /**
         * The density of the material in kg/m3
         */
        density?: number
    }

    export interface Message {
        /**
         * As defined by ISO 639-1, see: https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         */
        language: iso.IsoLanguage

        message: string
    }

    export interface Metadata {
        awsRequestId: string
    }

    export interface MethodAliasData {
        id: string
        transporterAlias: string
        methodAlias: string
    }

    export interface MicrosoftBCAuthData {
        orgId?: string
        clientId: string
        clientSecret: string
        tenantId: string
        environmentName: string
        /**
         * Company ID as stored in Business Central
         */
        companyId: string

        createdAt?: string
        createdBy?: string
        updatedAt?: string
        updatedBy?: string
    }

    export interface MicrosoftBCCompanyInfo {
        id: string
        name: string
        displayName: string
        businessProfileId: string
        systemVersion: string
    }

    /**
     * Milestone represents a milestone that a shipment can reach during its journey
     */
    export interface Milestone {
        /**
         * ID of the milestone
         */
        id: string

        /**
         * Unique reference identifying the journey
         */
        reference: string

        /**
         * Translations of the milestone name and description, the key is the language code (ISO 639-1)
         */
        translations: { [key: string]: MilestoneTranslation }

        /**
         * ID of the organization
         */
        organizationId: string

        /**
         * Time the milestone was created
         */
        createdAt: string

        /**
         * Time the milestone was last updated
         */
        updatedAt: string

        /**
         * ID of the user who last updated the milestone
         */
        updatedBy: string

        /**
         * Whether the milestone is active
         */
        active: boolean

        /**
         * Evaluation logic of the milestone (ANY, ALL)
         */
        evaluationLogic: EvaluationLogic

        /**
         * Conditions to reach the milestone
         */
        conditions: Condition[]

        /**
         * Icon of the milestone
         */
        icon: string

        /**
         * Color of the milestone
         */
        color: string
    }

    export interface MilestoneFilters {
        onlyActive: boolean
        milestoneIds: string[]
        milestoneReferences: string[]
    }

    /**
     * MilestoneSnapshot represents a snapshot of a milestone at a specific point in time.
     */
    export interface MilestoneSnapshot {
        id: string
        journeySnapshotId: string
        milestoneId: string
        /**
         * Translations of the milestone name and description, the key is the language code (ISO 639-1)
         */
        translations: { [key: string]: MilestoneTranslation }

        reference: string
        /**
         * The sequence number of the milestone in the journey
         */
        sequence?: number

        /**
         * The order to display the milestone in within its sequence.
         */
        displayOrdering?: number

        /**
         * Whether the milestone is a final milestone in the journey
         */
        final: boolean

        /**
         * Whether the milestone has been completed
         */
        completed: boolean

        /**
         * The time at which the milestone was completed
         */
        timeOfCompletion: string

        /**
         * The time at which the milestone was last updated
         */
        timeOfLastUpdated: string

        /**
         * The icon representing the milestone
         */
        icon: string

        /**
         * The color representing the milestone
         */
        color: string

        /**
         * The evaluation logic for the conditions, ANY or ALL
         */
        evaluationLogic: EvaluationLogic

        conditions: ConditionSnapshot[]
    }

    export interface MilestoneTranslation {
        name: string
        description: string
    }

    export interface MilestoneTriggerData {
        /**
         * The ID of the individual trigger
         */
        triggerId: string

        /**
         * The ID of the journey that the milestone belongs to
         */
        journeyId: string

        /**
         * The ID of the completed milestone
         */
        milestoneId: string

        /**
         * Will always be 'WEBHOOK'
         */
        triggerType: string

        /**
         * The reference of the milestone
         */
        milestoneReference: string

        /**
         * The ID of the snapshot taken of the milestone when the shipment was initialized
         */
        milestoneSnapshotId: string

        /**
         * The reference of the journey the milestone belongs to
         */
        journeyReference: string

        /**
         * The timestamp of when the milestone was completed
         */
        timestamp: string

        /**
         * The ID of the webhook that was triggered
         */
        webhookId: string

        /**
         * The ID of the connection between the order and the shipment
         */
        trackedOrderShipmentId: string

        /**
         * The ID of the organization that the milestone belongs to
         */
        organizationId: string

        /**
         * The ID of snapshot taken of the trigger when the shipment was initialized
         */
        triggerSnapshotId: string

        /**
         * The ID of the order that the shipment belongs to
         */
        trackedOrderId: string

        /**
         * All the provided order references for the order that the shipment belongs to
         */
        trackedOrderReferences: string[]
    }

    /**
     * Interval for a given observation attribute
     */
    export interface MinMaxInterval {
        /**
         * The minimum value of the interval
         */
        Min: number

        /**
         * The maximum value of the interval
         */
        Max: number

        /**
         * The unit of the interval
         */
        Unit: string

        /**
         * The time when the interval was last updated
         */
        UpdatedAt: string
    }

    /**
     * MissingEventTypeMap represents an external event code that exists in default_map but not in event_type_map for a specific organization
     */
    export interface MissingEventTypeMap {
        /**
         * Code of the external event type
         */
        externalEventCode: string

        /**
         * ID of the external organization
         */
        externalOrganizationId: string
    }

    /**
     * Used to decide how to handle cases where an invoice row data point is dependent on more than one column in the tabular raw invoice.
     * 
     * For example, invoice fees are summed together to create one invoice fee sum.
     * External reference might be found in one column for certain rows, and in another colum  for other rows.
     * Quantity might be in one column if it's a package shipment, and in another column if it's a pallet shipment
     */
    export type MultiColumnResolution = string

    export interface NshiftAddress {
        zipCode: string
        country: string
        quickId: string
        city: string
        phone: string
        address1: string
        address2: string
        name: string
        mobile: string
        state: string
        email: string
    }

    export interface NshiftPreparedShipment {
        orderNo: string
        prepareId: string
        agent: NshiftAddress
        sender: NshiftAddress
        service: NshiftService
    }

    export interface NshiftService {
        sourceSystem: string
        name: string
        id: string
        title: string
    }

    /**
     * A physical product attribute
     */
    export type ObservationAttribute = string

    export type ObservationSource = string

    /**
     * Source of the observation
     */
    export type ObservationSourceType = string

    /**
     * Type of observation
     */
    export type ObservationType = string

    export interface OngoingByComputer {
        computerId: number
        computerName: string
    }

    export interface OngoingDbInfo {
        id: string
        retailerId: string
        url: string
        username: string
        password: string
        goodsOwner: number
        lengthUnit: utils.MeasurementUnit
        weightUnit: utils.MeasurementUnit
        transporterField: OngoingTransporterField
        /**
         * This field decides if we are populating the "isParcelTypeSuggestion" field in the ongoing orderClass
         */
        setParcelType: boolean

        printWithSkrym: boolean
    }

    export type OngoingTransporterField = string

    export interface OngoingWebhook {
        webhookOrdersId: number
        webhookEventId: number
        system: string
        timestamp: string
        orderId: number
        orderNumber: string
        goodsOwnerId: number
        path: string
        byUser: { [key: string]: number }
        byComputer: OngoingByComputer
        currentShipmentId: number
        orderStatus: {
            number: number
            text: string
        }
        webhookTemplate: string
        goodsOwnerName: string
    }

    export type OptimizationEnumValue = string

    export interface OptimizationItem {
        externalReference: string
        order: Order
        /**
         * Flag to determine if results should not be inserted
         */
        mock: boolean

        products: OrderProduct[]
        fragilityPaddings: FragilityIndexPadding[]
        fillMaterials: OrganizationFillMaterial[]
        fixedPackages: FixedPackage[]
        heightAdjustablePackages: HeightAdjustablePackage[]
        fullyAdjustablePackages: FullyAdjustablePackage[]
    }

    /**
     * OptimizationParameter represents a single
     * key-value pair of an organization's optimization
     * optimization hyperparameter.
     */
    export interface OptimizationParameter {
        /**
         * ID of the optimization parameter
         */
        id: string

        /**
         * ID of the organization
         */
        organizationId: string

        /**
         * Type of the hyperparameter, e.g NUMERIC, ENUM
         */
        parameterType: HyperparameterType

        /**
         * Name of the hyperparameter, e.g NUM_SPLITS, PRESERVE_ORDER_LINES
         */
        parameter: Hyperparameter

        /**
         * Value of the hyperparameter if it is of type NUMERIC
         */
        numericValue: number

        /**
         * Value of the hyperparameter if it is of type ENUM
         */
        enumValue: OptimizationEnumValue

        /**
         * Time of creation
         */
        createdAt: string

        /**
         * Time of the last update
         */
        updatedAt: string
    }

    export interface OptimizationParameters {
        /**
         * Number of splits that an order can be split into
         */
        numberOfSplits: number

        /**
         * Which depth the preprocessing should progress through before continuing to regular optimization (between 0-3)
         */
        trianglePreprocessingDepth: number

        /**
         * Preserve order lines dictates how the order lines are preserved. Can be HARD_PRESERVE, SOFT_PRESERVE, NO_PRESERVE
         */
        preserveOrderLines: OptimizationEnumValue

        /**
         * Sorting method for the optimization. Can be BASE_AREA, VOLUME
         */
        sortingMethod: OptimizationEnumValue

        /**
         * Sorting direction for the optimization. Can be ASC, DESC
         */
        sortingDirection: OptimizationEnumValue
    }

    export interface OptimizationResultPackage {
        id: string
        packageName: string
        variation: number
        containerSize: number[]
        itemsSize: number[]
        type: string
        transportMethods: ResultTransportMethod[]
        alias: string
        weight: number
    }

    export interface OptimizedPackResult {
        id: string
        resultPackageId: string
        packageId: string
        externalId: string
        dimensions: number[]
        combinedProductWeight: number
        methods: OptimizedPackageMethod[]
        packWeight: number
    }

    export interface OptimizedPackageMethod {
        id: string
        resultMethod: ResultMethod
    }

    export interface Order {
        /**
         * The unique identifier for the order
         */
        id: string

        /**
         * The ID of the organization associated with the order
         */
        organizationId: string

        /**
         * The references to the order (formerly known as external_id)
         */
        references?: OrderReference[]

        /**
         * The timestamp when the order was created at
         */
        createdAt?: string

        /**
         * The timestamp when the order was last updated at
         */
        updatedAt?: string

        /**
         * The ZIP code of the origin location
         */
        originZip?: string

        /**
         * The country of the origin location
         */
        originCountry?: string

        /**
         * The ZIP code of the destination location
         */
        destinationZip?: string

        /**
         * The country of the destination location
         */
        destinationCountry?: string

        /**
         * The UUID of the transporter
         */
        transporter?: string

        /**
         * The UUID of the transport method
         */
        transportMethod?: string

        /**
         * The feedback status of the order
         */
        feedbackStatus: string

        /**
         * The organization that created the order
         */
        createdByOrganizationId?: string

        /**
         * The organization that last updated the order
         */
        updatedByOrganizationId?: string

        /**
         * The user who created the order. If no user is associated with the creation, this will be null
         */
        createdByUserId?: string

        /**
         * The user who last updated the order. If no user is associated with the update, this will be null
         */
        updatedByUserId?: string
    }

    export interface OrderAddress {
        country: string
        stateOrProvince: string
        streetAddress: string
        city: string
        givenName: string
        familyName: string
        email: string
        telephoneNumber: string
        postalCode: string
        streetAddress2: string
        pcc: string
    }

    export interface OrderAnalytics {
        totalOrders: number
        totalOrderValue?: number
        averageOrderValue?: number
        medianOrderValue?: number
        totalOrderRows?: number
        averageOrderRows?: number
        medianOrderRows?: number
        totalOrderItems?: number
        averageOrderItems?: number
        medianOrderItems?: number
        /**
         * Checkout-specific fields
         */
        checkoutOptionsDisplayed?: number

        checkoutAverageSelectedShippingPrice?: number
        /**
         * Optimization-specific fields
         */
        optimizationSuccessfulRecommendations?: number

        /**
         * Later on we could possible split up to show breakdowns on different statuses (e.g. missing data)
         */
        optimizationFailedRecommendations?: number

        optimizationTotalPackagesRecommended?: number
        optimizationAveragePackagesRecommended?: number
        optimizationTotalRecommendedVolume?: number
        optimizationTotalRecommendedWeight?: number
        optimizationAverageRecommendedVolume?: number
        optimizationAverageRecommendedWeight?: number
        /**
         * Invoice Control fields
         */
        invoiceControlInvoiceRowsCount?: number

        invoiceControlTotalInvoicedAmount?: number
        invoiceControlAverageInvoicedAmount?: number
        invoiceControlTotalBaseCost?: number
        invoiceControlAverageBaseCost?: number
        invoiceControlTotalAddedFees?: number
        invoiceControlAverageAddedFees?: number
        invoiceControlTotalPenaltyFees?: number
        invoiceControlAveragePenaltyFees?: number
        from: string
        to: string
    }

    /**
     * The order count for a specific retailer for a specific date.
     */
    export interface OrderCount {
        /**
         * The date for which the order count is calculated
         */
        date: string

        /**
         * The number of orders for that retailer for that day
         */
        orderCount: number
    }

    export interface OrderCountPerTransportMethod {
        /**
         * The date for which the order count is calculated
         */
        date: string

        /**
         * The transporter for which the transport method belongs
         */
        transporter: string

        /**
         * The transport method for which we calculate the order count
         */
        transportMethod: string

        /**
         * The number of orders for that retailer and transport method for that day
         */
        orderCount: number
    }

    export interface OrderCountPerTransportMethodWithoutDate {
        /**
         * The transporter for which the transport method belongs
         */
        transporter: string

        /**
         * The transport method for which we calculate the order count
         */
        transportMethod: string

        /**
         * The number of orders for that retailer and transport method for that day
         */
        orderCount: number
    }

    export interface OrderDiscountOutcome {
        codeRules: DiscountOutcomeRule[]
        cartRules: DiscountOutcomeRule[]
        externalRules: DiscountOutcomeRule[]
        totalDiscountAmount: number
        discountReduction: number
        freeShipping: boolean
    }

    export interface OrderFilter {
        /**
         * The search term to filter the orders
         */
        search?: string

        /**
         * The references to the order (formerly known as external_id)
         */
        references?: string[]

        /**
         * The IDs of the orders
         */
        ids?: string[]

        /**
         * The IDs of the organizations
         */
        organizationIds?: string[]

        /**
         * The zip codes of the origin of the orders
         */
        originZips?: string[]

        /**
         * The countries of the origin of the orders
         */
        originCountries?: string[]

        /**
         * The zip codes of the destination of the orders
         */
        destinationZips?: string[]

        /**
         * The countries of the destination of the orders
         */
        destinationCountries?: string[]

        /**
         * The IDs of the transporters
         */
        transporters?: string[]

        /**
         * The IDs of the transport methods
         */
        transportMethods?: string[]

        /**
         * The IDs of the organizations that created the orders
         */
        createdByOrganizationIds?: string[]

        /**
         * The start date of the orders
         */
        from?: string

        /**
         * The end date of the orders
         */
        to?: string

        /**
         * The IDs of the products in the orders
         */
        productIds?: string[]
    }

    export interface OrderLineDiscountOutcome {
        codeRules: DiscountOutcomeRule[]
        cartRules: DiscountOutcomeRule[]
        externalRules: DiscountOutcomeRule[]
        totalDiscountAmount: number
    }

    export interface OrderPerformanceModel {
        orderID: string
        packageEmission: number
        fillMaterialEmission: number
        shippingEmission: number
        totalEmission: number
    }

    export interface OrderProduct {
        product: Product
        quantity: number
    }

    export interface OrderProductId {
        productId: string
        externalId: string
        quantity: number
    }

    export interface OrderProductQuantity {
        /**
         * Id is the unique identifier for a specific product in an order.
         */
        id: string

        /**
         * Quantity indicates the number of units of this product included in the order.
         */
        quantity: number
    }

    export interface OrderProductWithDims {
        id: string
        productId: string
        dimensions: number[]
        weight: number
        quantity: number
    }

    /**
     * OrderReference is a struct that represents a reference to an order. (Formerly known as external_id)
     */
    export interface OrderReference {
        /**
         * The Skrym internal ID of the order
         */
        orderId: string

        /**
         * The reference to the order. (Formerly known as external_id)
         */
        reference: string

        /**
         * The ID of the organization
         */
        organizationId: string

        /**
         * The time the reference was created
         */
        createdAt: string

        /**
         * The time the reference was last updated
         */
        updatedAt: string

        /**
         * The user who created the reference. If no user is associated with the creation, this will be null
         */
        createdByUserId: string

        /**
         * The organization who created the reference.
         */
        createdByOrganizationId: string

        /**
         * The user who last updated the reference. If no user is associated with the update, this will be null
         */
        updatedByUserId: string

        /**
         * The organization who last updated the reference.
         */
        updatedByOrganizationId: string
    }

    /**
     * OrderReferenceFilter is a struct that represents a filter for order references.
     */
    export interface OrderReferenceFilter {
        orderIds?: string[]
        references?: string[]
        organizationId?: string
    }

    /**
     * OrderReferenceSort is a struct that represents a sort for order references.
     */
    export interface OrderReferenceSort {
        column: OrderReferenceSortColumn
        direction: string
    }

    export type OrderReferenceSortColumn = string

    /**
     * Connects orders and shipments. Is also used as the root for a journey of a shipment.
     */
    export interface OrderShipmentConnection {
        id: string
        trackedOrderId: string
        trackedShipmentId?: string
        /**
         * Optional: The start the promised delivery time window, as promised by the retailer
         */
        promisedDeliveryTimeStart?: string

        /**
         * Optional: The end the promised delivery time window, as promised by the retailer
         */
        promisedDeliveryTimeEnd?: string

        createdAt: string
        updatedAt: string
        createdBy: string
        updatedBy: string
    }

    export interface OrderSort {
        column: OrderSortColumn
        direction: string
    }

    export type OrderSortColumn = string

    /**
     * OrderStatistics maps to the order_statistics table.
     * Fields are ordered to minimize padding: fixed‑size values first,
     * then variable‑length types (strings, pointers), and finally UUID pointers.
     */
    export interface OrderStatistics {
        /**
         * Primary keys (16-byte arrays, alignment=1)
         */
        orderId: string

        organizationId: string
        /**
         * Timestamps (alignment=8)
         */
        createdAt: string

        updatedAt: string
        repoOrderDate: string
        invoicecontrolFirstInvoicedDate: string
        invoicecontrolLastInvoicedDate: string
        /**
         * Numeric metrics (float64/int align=8)
         */
        repoTotalOrderWeight: number

        repoTotalOrderVolume: number
        repoTotalItemsInOrder: number
        repoUniqueItemsInOrder: number
        trackingTotalShipments: number
        trackingTotalParcels: number
        trackingOrderJourneys: number
        checkoutCartValue: number
        checkoutCartWeight: number
        checkoutCartVolume: number
        checkoutCartItems: number
        checkoutCartUniqueItems: number
        checkoutOptionsDisplayed: number
        checkoutSelectedShippingPrice: number
        checkoutEstimatedShippingCost: number
        optimizationRecommendedPackages: number
        optimizationTotalRecommendationVolume: number
        optimizationTotalRecommendationWeight: number
        optimizationHeaviestRecommendedPackageWeight: number
        optimizationLargestRecommendedPackageVolume: number
        optimizationLightestRecommendedPackageWeight: number
        optimizationSmallestRecommendedPackageVolume: number
        invoicecontrolTotalInvoicedWeight: number
        invoicecontrolTotalInvoicedVolume: number
        invoicecontrolTotalInvoicedAmount: number
        invoicecontrolTotalAddedFees: number
        invoicecontrolTotalPenaltyFees: number
        invoicecontrolInvoiceRowsCount: number
        invoicecontrolParcelsCount: number
        invoicecontrolExpectedTotalAmount: number
        invoicecontrolExpectedBaseCost: number
        invoicecontrolExpectedAddedFees: number
        invoicecontrolExpectedPenaltyFees: number
        /**
         * Short fixed-length strings (alignment=8)
         */
        checkoutCartValueCurrency: datamodels.Currency

        checkoutSelectedShippingPriceCurrency: datamodels.Currency
        checkoutEstimatedShippingCostCurrency: datamodels.Currency
        invoicecontrolTotalInvoicedAmountCurrency: datamodels.Currency
        invoicecontrolTotalAddedFeesCurrency: datamodels.Currency
        invoicecontrolTotalPenaltyFeesCurrency: datamodels.Currency
        invoicecontrolExpectedTotalAmountCurrency: datamodels.Currency
        invoicecontrolExpectedBaseCostCurrency: datamodels.Currency
        invoicecontrolExpectedAddedFeesCurrency: datamodels.Currency
        invoicecontrolExpectedPenaltyFeesCurrency: datamodels.Currency
        checkoutOriginCountry: string
        checkoutOriginZip: string
        checkoutDestinationCountry: string
        checkoutDestinationZip: string
        /**
         * Variable-length strings (alignment=8)
         */
        checkoutOriginCity: string

        checkoutDestinationCity: string
        checkoutProvider: string
        checkoutProviderSessionID: string
        checkoutSelectedDeliveryType: string
        optimizationRecommendationStatus: string
        invoicecontrolInvoiceRowStatus: string
        /**
         * Nullable UUID references (pointers, alignment=8)
         */
        basketId: string

        checkoutPromiseId: string
        checkoutBucketTestId: string
        checkoutStrategyId: string
        checkoutTacticBranchId: string
        checkoutTacticId: string
        checkoutSelectedTransportMethodId: string
        checkoutSelectedTransporterId: string
        checkoutOriginLocationId: string
        checkoutOriginOrgLocationId: string
        checkoutDestinationLocationId: string
        checkoutDestinationOrgLocationId: string
        optimizationResultId: string
    }

    export interface OrderStatisticsFilter {
        orderIDs?: string[]
        organizationIDs?: string[]
        fromDate?: string
        toDate?: string
        originCountries?: string[]
        originZips?: string[]
        originCities?: string[]
        originLocationIDs?: string[]
        originOrganizationLocationIDs?: string[]
        destinationCountries?: string[]
        destinationZips?: string[]
        destinationCities?: string[]
        destinationLocationIDs?: string[]
        destinationOrganizationLocationIDs?: string[]
        minTotalValue?: number
        maxTotalValue?: number
        maxTotalItems?: number
        minTotalItems?: number
        maxUniqueItems?: number
        minUniqueItems?: number
        maxOrderWeight?: number
        minOrderWeight?: number
        maxOrderVolume?: number
        minOrderVolume?: number
        /**
         * Product-specific filters
         */
        productIDs?: string[]

        /**
         * Checkout-specific filters
         */
        checkoutProviders?: string[]

        checkoutStrategyIDs?: string[]
        checkoutTacticBranchIDs?: string[]
        checkoutTacticIDs?: string[]
        checkoutMaxOptionsDisplayed?: number
        checkoutMinOptionsDisplayed?: number
        checkoutMaxSelectedShippingPrice?: number
        checkoutMinSelectedShippingPrice?: number
        checkoutSelectedTransporterIDs?: string[]
        checkoutSelectedTransportMethodIDs?: string[]
        checkoutSelectedDeliveryTypes?: string[]
        /**
         * Invoice Control-specific filters
         */
        maxInvoiceRowsCount?: number

        minInvoiceRowsCount?: number
        maxInvoiceRowParcelsCount?: number
        minInvoiceRowParcelsCount?: number
        maxTotalInvoicedAmount?: number
        minTotalInvoicedAmount?: number
        maxInvoicedBaseCost?: number
        minInvoicedBaseCost?: number
        maxInvoicedAddedFees?: number
        minInvoicedAddedFees?: number
        maxInvoicedPenaltyFees?: number
        minInvoicedPenaltyFees?: number
        maxTotalExpectedAmount?: number
        minTotalExpectedAmount?: number
        maxExpectedBaseCost?: number
        minExpectedBaseCost?: number
        maxExpectedAddedFees?: number
        minExpectedAddedFees?: number
        maxExpectedPenaltyFees?: number
        minExpectedPenaltyFees?: number
        invoiceControlTransporterIDs?: string[]
        invoiceControlTransportMethodIDs?: string[]
        invoiceControlDeliveryTypes?: string[]
        invoiceRowStatuses?: string[]
        /**
         * Shipment-specific filters
         */
        shipmentTransporterIDs?: string[]

        shipmentTransportMethodIDs?: string[]
        shipmentDeliveryTypes?: string[]
    }

    export interface OrderStatisticsSort {
        Column: OrderStatisticsSortColumn
        /**
         * "ASC" or "DESC"
         */
        Direction: string
    }

    export type OrderStatisticsSortColumn = number

    export interface OrgLocationRangeConfig {
        organizationId: string
        location1Type: datamodels.LocationType
        location2Type: datamodels.LocationType
        /**
         * unit kilometer (km)
         */
        maxDistance: number
    }

    export interface OrganizationEventType {
        /**
         * ID of the organization event type
         */
        id: string

        /**
         * Internal code of the event type
         */
        code: string

        /**
         * Display name of the event type
         */
        displayName: string

        /**
         * Description of the event type
         */
        description: string

        /**
         * ID of the organization
         */
        organizationId: string

        /**
         * Whether the event type is a Skrym event type
         */
        skrymEventType: boolean

        /**
         * ID of the Skrym event type
         */
        skrymEventTypeId: string

        /**
         * Time the event type was created
         */
        createdAt: string

        /**
         * Time the event type was last updated
         */
        updatedAt: string

        /**
         * ID of the user who last updated the event type
         */
        lastUpdatedBy: string

        /**
         * Messages for the event type
         */
        messages: EventTypeMessage[]

        /**
         * Status indicator for the event type
         */
        statusIndicator?: Status

        /**
         * Whether the event type is active to be in use by the organization
         */
        active: boolean

        /**
         * Icon of the event type
         */
        icon: string

        /**
         * Color of the event type
         */
        color: string
    }

    export interface OrganizationEventTypeExternalEventFilter {
        /**
         * Code of the external event type
         */
        externalEventCode: string

        /**
         * ID of the external organization
         */
        externalOrganizationId: string
    }

    export interface OrganizationEventTypeFilter {
        /**
         * Search for event types by name or description
         */
        search?: string

        ids?: string[]
        codes?: string[]
        organizationIds?: string[]
        externalEventFilter?: OrganizationEventTypeExternalEventFilter
        updatedBy?: string
        skrymType?: SkrymTypeFilter
        statusIndicators?: Status[]
        active?: boolean
    }

    export interface OrganizationEventTypeSort {
        column: OrganizationEventTypeSortColumn
        direction: string
    }

    export type OrganizationEventTypeSortColumn = string

    export interface OrganizationFillMaterial {
        id: string
        organizationId: string
        name: string
        materialId: string
        usage: number
        density: number
        emissions: number
        createdAt: string
        updatedAt: string
        createdBy: string
        updatedBy: string
    }

    export interface OrganizationLocationAvailabilityFilterOptions {
        organizationLocationIds?: string[]
        transportMethodIds?: string[]
        organizationIds?: string[]
        onlyAvailable?: boolean
    }

    export interface OrganizationLocationAvailabilityForTransportMethod {
        organizationId: string
        organizationLocationId: string
        transportMethodId: string
        available: boolean
        /**
         * [km]
         */
        distance?: number

        createdAt: string
        updatedAt: string
        updatedBy: string
    }

    export interface OrganizationLocationDailyLimitFilter {
        organizationLocationIds?: string[]
        externalIds?: string[]
        transportMethodIds?: string[]
    }

    export interface OrganizationLocationDailyLimitSort {
        columnField: DailyLimitSortColumn
        direction: string
    }

    export interface OrganizationLocationFilter {
        /**
         * Search term to filter organization locations by name or external ID
         */
        search?: string

        organizations: string[]
        /**
         * Specify which location types should be returned
         */
        locationTypes?: datamodels.LocationType[]

        /**
         * Specify which countries should be returned
         */
        countries?: string[]

        /**
         * Specify which cities should be returned
         */
        cities?: string[]

        /**
         * Filter on these external IDs
         */
        externalIds?: string[]

        /**
         * Filter on these zip codes
         */
        zipCodes?: string[]

        /**
         * Filter on availability of the organization locations
         */
        availability?: boolean[]
    }

    export interface OrganizationLocationLocationFilter {
        countryCode?: string
        zipCode?: string
    }

    /**
     * OrganizationLogo represents a logo associated with an organization.
     */
    export interface OrganizationLogo {
        /**
         * Unique identifier for the organization.
         */
        organizationId: string

        /**
         * Signed URL for accessing the logo.
         */
        signedUrl: string

        /**
         * Usage type of the logo.
         */
        usage: LogoUsageType
    }

    export interface OrganizationShippingTaxRate {
        organizationId: string
        /**
         * Country code of the destination, conforming to ISO 3166-1. For example `SE` and not `SWE`.
         */
        destinationCountry: string

        /**
         * the tax rate, given as a decimal percentage (e.g.: 0.25 for 25%), of the organization's shipping to the destination country.
         */
        taxRate: number

        createdAt: string
        updatedAt: string
    }

    /**
     * OrganizationVehicle represents a vehicle associated with an organization within the system.
     * This struct includes the vehicle's unique identifier, a reference to its model, and
     * the organization it's associated with. It also contains details such as the vehicle's
     * registration number, verification status, and VIN. Additionally, it stores environmental
     * impact information like the type of fuel used, emissions factor, and fuel consumption rate.
     */
    export interface OrganizationVehicle {
        /**
         * Unique identifier for the vehicle.
         */
        id: string

        /**
         * Reference to the vehicle model's unique identifier.
         */
        modelId: string

        /**
         * Reference to the unique identifier of the associated organization.
         */
        organizationId: string

        /**
         * Registration number of the vehicle; nullable for vehicles like bikes that may not be registered.
         */
        registrationNumber: string

        /**
         * Indicates whether the vehicle details have been verified. Enum values: VERIFIED, INDIRECTLY_VERIFIED, UNVERIFIED.
         */
        verificationTag: VerificationType

        /**
         * VIN (Vehicle Identification Number) of the vehicle; may be outdated or inapplicable for certain vehicle types.
         */
        vehicleIdentificationNumber: string

        /**
         * Specifies the type of fuel the vehicle uses, which could be a hybrid or purely electric.
         */
        usedFuel: string

        /**
         * Measures the vehicle's emissions factor based on the fuel type, indicating its environmental impact.
         */
        emissionsByFuel: number

        /**
         * Indicates the vehicle's fuel consumption rate, measured in liters per 100 kilometer or kWh per 100 kilometer.
         */
        fuelConsumptionRate: number

        /**
         * Indicates what the vehicle is used for by the organization
         */
        vehicleUsageTypes: RouteSegmentType[]
    }

    /**
     * These are enums used for the server-side sorting of vehicle table
     */
    export type OrganizationVehicleColumn = string

    /**
     * OrganizationVehicleFilter is a helper struct for sorting
     * the vehicles table in Scope.
     */
    export interface OrganizationVehicleFilter {
        columnField: OrganizationVehicleColumn
        operatorValue: string
        value: string
    }

    /**
     * OrganizationVehicleLocationRange represents the operational range of an organization's vehicle.
     * It defines the geographical boundaries within which the vehicle can operate.
     * This struct includes identifiers for the specific range, the vehicle, and the organization location.
     * It also specifies the maximum distance a vehicle can travel from a given location, as well as
     * flags indicating whether the range is applicable for starting from or traveling to terminals.
     */
    export interface OrganizationVehicleLocationRange {
        /**
         * Unique identifier for the operational range instance.
         */
        id?: string

        /**
         * Reference to the associated vehicle.
         */
        organizationVehicle: OrganizationVehicle

        /**
         * Reference to the unique identifier of the organization location tied to this range.
         */
        organizationLocationId: string

        /**
         * Specifies the maximum distance (in kilometers) the vehicle can travel from the organization location.
         */
        maxDistanceKm: number

        /**
         * Flag indicating if this range is applicable when vehicles start from terminals.
         */
        validFrom: boolean

        /**
         * Flag indicating if this range is used to prevent vehicles from traveling to terminals.
         */
        validTo: boolean
    }

    /**
     * OrganizationVehicleSort is a helper struct for sorting
     * the vehicle table in Scope.
     */
    export interface OrganizationVehicleSort {
        columnField: OrganizationVehicleColumn
        sort: string
    }

    export interface OriginalProvider {
        name: string
        id: string
    }

    export interface Package {
        /**
         * A unique identifier assigned by Skrym to the package
         */
        id: string

        /**
         * Your organization's unique identifier for the package
         */
        externalId: string

        /**
         * Unique id for your organization assigned by Skrym
         */
        retailerId: string

        /**
         * Which variation of the package
         */
        variation: number

        /**
         * Unique id for your organization assigned by Skrym
         */
        importId?: string

        /**
         * A name given by the user to the package
         */
        name?: string

        /**
         * The maximum weight the package can support (grams)
         */
        maxSupportedWeight?: number

        /**
         * The material of the package referencing the Material struct
         */
        material: Material

        /**
         * The type of package can be one of the following: "Fixed", "Height Adjustable", "Fully Adjustable"
         */
        packageType: string

        /**
         * Whether the package is enabled or not
         */
        enabled: boolean

        /**
         * A name given by the user to the package
         */
        alias?: string

        /**
         * The stock of the package
         */
        stock: number

        /**
         * The stock threshold of the package
         */
        stockThreshold: number

        /**
         * Weight of the package (grams)
         */
        weight: number

        /**
         * Unique id for the package supplier
         */
        supplierOrganizationID?: string

        /**
         * The fold of the package referencing the Fold struct
         */
        packageFold?: Fold
    }

    /**
     * PackagEmissionBreakdown represents the emission summary from a single
     * PackageID that was used OrderCount times.
     */
    export interface PackageEmissionBreakdown {
        /**
         * Skrym ID of the package used
         */
        packageId: string

        /**
         * number of orders packed into this package
         */
        orderCount: number

        /**
         * sum of all emissions from packing all ordercount orders
         */
        totalPackageEmissions: number

        /**
         * sum of all emissions from fill materials in all ordercount orders
         */
        totalFillEmissions: number
    }

    /**
     * PackageEmissions represents the emissions for a package for a specific transport method.
     */
    export interface PackageEmissions {
        /**
         * CO2-equivalent emissions [kg]
         */
        emissions: number

        /**
         * CO2-equivalent emissions [kg]
         */
        fillMaterialEmissions: number

        /**
         * CO2-equivalent emissions [kg]
         */
        totalPackagingEmissions: number
    }

    export interface PackageEmissionsForOrder {
        /**
         * Total emissions for all packages
         */
        totalPackageEmissions: number

        /**
         * Emissions for each package
         */
        packageEmissionBreakdown: PackageEmissions[]
    }

    export interface PackageFillRate {
        /**
         * The package for which is calculated, not included in json
         */
        packageId: string

        /**
         * The date for which the order count is calculated
         */
        date: string

        /**
         * The cumulative volume of all the products for that package for that day. Unit is [mm^3]
         */
        productVolume: number

        /**
         * The cumulative volume of all the packages for that package for that day. Unit is [mm^3]
         */
        packageVolume: number

        /**
         * Actually not saved in the database, but is calculated as it's fetched from the DB as ProductVolume divided
         * by PackageVolume. The range is [0, 1]
         */
        fillRate: number
    }

    export interface PackageFillRateDistribution {
        /**
         * The package for which is calculated
         */
        packageId: string

        /**
         * The date for which the order count is calculated
         */
        date: string

        /**
         * The fill rate distribution, where index i means the number of orders which has a fill rate between i and i+1 percent
         */
        fillRateDistribution: number[]
    }

    export interface PackageFilter {
        /**
         * From date
         */
        from: string

        /**
         * To date
         */
        to: string
    }

    export interface PackageUsageCount {
        /**
         * The package for which is calculated
         */
        packageId: string

        /**
         * The date for which the order count is calculated
         */
        date: string

        /**
         * The number of orders for that package for that day
         */
        orderCount: number
    }

    /**
     * Key is the package id and the value is a struct with product and package volume and (after calculation), fill rate
     */
    export type PackagesFillRateData = { [key: string]: FillRateData }

    /**
     * The key is the package id and the value is a distribution of the fill rates
     */
    export type PackagesFillRateDistributionData = { [key: string]: number[] }

    /**
     * Key is the package id and the value is the number of times it has been used
     */
    export type PackagesUsageCountData = { [key: string]: number }

    /**
     * PackagingEmissionTotals summarizes the emissions for each package.
     */
    export interface PackagingEmissionTotals {
        /**
         * the emission breakdown per package ID
         */
        totalsPerPackage: PackageEmissionBreakdown[]
    }

    export interface PaginationOptions {
        page: number
        pageSize: number
    }

    /**
     * Palette represents the color scheme used in customization.
     */
    export interface Palette {
        /**
         * Primary color of the palette.
         */
        primaryColor?: string

        /**
         * Secondary color of the palette.
         */
        secondaryColor?: string

        /**
         * Background color of the palette.
         */
        backgroundColor?: string

        /**
         * Foreground color of the palette.
         */
        foregroundColor?: string

        /**
         * Color scheme for charts.
         */
        chartScheme?: string[]
    }

    export type ParcelCreationSources = string

    export interface ParcelFilter {
        /**
         * Searches both the tracking reference and external ID
         */
        search?: string

        shipmentId?: string[]
        status?: Status[]
        trackingReferences?: string[]
        externalReferences?: string[]
        ids?: string[]
        /**
         * Filter by transporter ID set on the tracked shipment
         */
        transporterId?: string[]
    }

    export interface ParcelSort {
        column?: ParcelSortColumn
        direction?: string
    }

    export type ParcelSortColumn = string

    /**
     * ParsingSchema represents the structure used to define the delimiters and
     * characters used in parsing structured strings.
     * 
     * Fields in this struct can be omitted in JSON serialization and are optional
     * for the encore framework. Delimiters and special characters for structures like
     * arrays and objects can be specified.
     */
    export interface ParsingSchema {
        CustomParameterID: string
        /**
         * delimiter that sperates key from values	; :
         */
        KeySeparator?: string

        /**
         * delimiter that separates values			; ,
         */
        ValueSeparator?: string

        /**
         * character that begins an array			; [
         */
        BeginArray?: string

        /**
         * character that ends an array				; ]
         */
        EndArray?: string

        /**
         * character that begins an object			; {
         */
        BeginObject?: string

        /**
         * character that ends an object				; }
         */
        EndObject?: string

        /**
         * time the schema was created
         */
        CreatedAt?: string
    }

    export interface PasswordReset {
        id: string
        expiryDate: string
        accountId: string
        finished: boolean
    }

    export interface Payment {
        reference: string
        method: string
        providerId: string
        additional: PaymentAdditional
        providerName: string
    }

    export interface PaymentAdditional {
        adyen: PaymentAdditionalAdyen
        klarnaCheckout: PaymentAdditionalKlarnaCheckout
        sveaCheckout: PaymentAdditionalSveaCheckout
        walleyCheckout: PaymentAdditionalWalleyCheckout
        qliroOne: PaymentAdditionalQliroOne
        brinkZeroPayment: PaymentAdditionalBrinkZeroPayment
    }

    export interface PaymentAdditionalAdyen {
        merchantAccountCode: string
        potentialFraud: boolean
        paymentMethod: string
        pspReference: string
        status: string
    }

    export interface PaymentAdditionalBrinkZeroPayment {
        originalProvider: OriginalProvider
    }

    export interface PaymentAdditionalKlarnaCheckout {
        klarnaOrderId: string
        klarnaMerchantId: string
        klarnaReference: string
        fraudStatus: string
        status: string
    }

    export interface PaymentAdditionalQliroOne {
        status: string
        requireIdentityVerification: boolean
        identityVerified: boolean
        privateVerificationCode: string
        orderId: number
        orderItems: QliroOneOrderItem[]
    }

    export interface PaymentAdditionalSveaCheckout {
        sveaOrderId: number
        sveaMerchantId: string
        status: string
        sveaRowIds: { [key: string]: number }
        paymentType: string
        creationDate: string
        expirationDate: string
        peppolId: string
        isCompany: boolean
        sveaWillBuyOrder: boolean
    }

    export interface PaymentAdditionalWalleyCheckout {
        status: string
        amountToPay: number
        purchaseIdentifier: string
        purchaseResult: string
        totalAmount: number
    }

    export interface PharmacyResult {
        packageId: string
        packageLabel: string
        estOuterDimensions: number[]
        estTotalWeight: number
        prescriptionBags: PrescriptionPackage[]
        products: OrderProductWithDims[]
        itemsMaxCoords: number[]
    }

    export interface PinmetoCredentials {
        credentialsId: string
        organizationId: string
        accountId: string
        appId: string
        appSecret: string
        name: string
    }

    export interface PrescriptionPackage {
        prescriptionBagID: string
        prescriptionProducts: OrderProductWithDims[]
    }

    /**
     * Printer represents the structure of a printer and its details.
     */
    export interface Printer {
        capabilities: Capabilities
        computer: Computer
        createTimestamp: string
        default: boolean
        description: string
        id: number
        name: string
        state: string
    }

    export interface PrinterForBookingReference {
        /**
         * The id of the printer on which the labels for the booking should be printed.
         */
        printerId: string

        /**
         * The list of booking references to be printed on the given printerId.
         */
        bookingReferences: string[]
    }

    export interface PrintnodeComputerAlias {
        id: string
        organizationId: string
        printnodeComputerId: string
        aliasType: string
        aliasValue: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface PrintnodeComputerAliasType {
        id: string
        code: PrintnodeComputerAliasTypeCode
        name: string
        description: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export type PrintnodeComputerAliasTypeCode = string

    export interface PrintnodeCredentials {
        id: string
        organizationId: string
        printnodeAccountId: string
        name: string
        description: string
        apiKey: string
        isDeleted: boolean
        createdBy: string
        updatedBy: string
        createdAt: string
        updatedAt: string
    }

    export interface Product {
        id: string
        name?: string
        organizationId: string
        externalId: string
        dimensions: number[]
        weight?: number
        fragilityIndex?: number
        importId?: string
        stackingDelta?: number
        stackingDirection?: number
        family?: Family
        attributes?: string[]
        deleted: boolean
    }

    export interface ProductAttribute {
        code: string
        isGlobal: boolean
        label?: string
        description?: string
    }

    export type ProductColumn = string

    /**
     * ProductCoreAudit represents the core audit information for a product.
     */
    export interface ProductCoreAudit {
        /**
         * ID is the unique identifier for the audit row.
         */
        id: string

        /**
         * Product is the product that was audited.
         */
        product: Product

        /**
         * Timestamp is the time when the audit row was created.
         */
        timestamp: string

        /**
         * Action is the type of action that was performed on the product. It can be either 'UPSERT' or 'DELETE'.
         */
        action: UserAction

        /**
         * CreatedByUserID is the unique identifier for the user who performed the action.
         */
        createdByUserId: string

        /**
         * CreatedByOrganizationID is the unique identifier for the organization that performed the action.
         */
        createdByOrganizationId: string
    }

    /**
     * ProductCoreAuditFilter represents the filter for querying product core audit rows.
     * It is used to filter the audit rows based on the product ID, organization ID, search string, user ID, action type, and time range.
     * All fields are optional, and if a field is not provided, it is not used as a filter with the exception of the time range fields.
     * The time range fields are inclusive, and the audit rows are filtered based on the time range provided.
     * If time range fields are not provided, logs from the last 7 days are returned.
     * If multiple filters are provided, the audit rows must satisfy all the filters to be included in the result.
     */
    export interface ProductCoreAuditFilter {
        /**
         * ProductID is the unique identifier for the product.
         */
        productId?: string

        /**
         * OrganizationID is the unique identifier for the organization.
         */
        organizationId?: string

        /**
         * Search is a string that is used to search for products. It can be the external ID or the name of the product.
         */
        search?: string

        /**
         * CreatedByUserID is the unique identifier for the user who performed the action.
         */
        createdByUserId?: string

        /**
         * CreatedByOrganizationID is the unique identifier for the organization that performed the action.
         */
        createdByOrganizationId?: string

        /**
         * Action is the type of action that was performed on the product. It can be either 'UPSERT' or 'DELETE'.
         */
        action?: UserAction

        /**
         * Before is the time before which the audit rows were created.
         */
        before?: string

        /**
         * After is the time after which the audit rows were created.
         */
        after?: string
    }

    export interface ProductFilter {
        /**
         * IDs is a list of product IDs to filter by.
         */
        ids?: string[]

        /**
         * Searches for the external id, name
         */
        search?: string

        /**
         * ExternalIDs is a list of external IDs to filter by.
         */
        externalIds?: string[]

        fragilityIndex?: number[]
        productAttributes?: string[]
        /**
         * OrganizationID is the unique identifier for the organization.
         */
        organizationId?: string

        isBundle?: boolean
        /**
         * IsDeleted indicates whether the product is deleted.
         */
        isDeleted?: boolean
    }

    export interface ProductSort {
        columnField: ProductColumn
        direction: string
    }

    /**
     * The number of products per order for a specific retailer for a specific date.
     */
    export interface ProductsPerOrder {
        /**
         * The date for which the products per order are calculated
         */
        date: string

        /**
         * The product count per order map, where the key is the number of products, and the value is the number of orders with that many products
         */
        productsPerOrder: ProductsPerOrderData
    }

    /**
     * Key is a number of products and the value is the number of orders that have that many products
     */
    export type ProductsPerOrderData = { [key: number]: number }

    export interface Promotion {
        status: string
        providerId: string
        additional: PromotionAdditional
        providerName: string
        promotions: PromotionItem[]
    }

    export interface PromotionAdditional {
        voyado: { [key: string]: string }
    }

    export interface PromotionItem {
        id: string
        status: string
    }

    /**
     * The input that can affect a property-based threshold.
     * Should match the TPropertyName values.
     */
    export interface PropertyThresholdInput {
        /**
         * Transporter ID
         */
        transporterId?: string

        /**
         * Transport Method ID
         */
        transportMethodId?: string

        /**
         * Transport Method Type
         */
        transportMethodType?: DeliveryType

        /**
         * Origin Country Code (ISO 3166-1 alpha-2)
         */
        originCountryCode?: string

        /**
         * Destination Country Code (ISO 3166-1 alpha-2)
         */
        destinationCountryCode?: string
    }

    export interface QliroIntegratedShipment {
        merchantReference: string
        description: string
        quantity: number
        pricePerItemIncVat: number
        pricePerItemExVat: number
        type: string
        paymentTransactionId: number
        metadata: QliroShipmentMetadata
    }

    export interface QliroOneOrderItem {
        merchantReference: string
        paymentTransactionId: number
    }

    export interface QliroShipmentMetadata {
        shippingMethodMerchantReference: string
    }

    export interface Result {
        id: string
        orderId: string
        externalId: string
        retailerId: string
        products: string
        combinedProductWeight: number
        cumulativeVolume: number
        freeItemsMaxCoord: number[]
        parentResultID: string
        packageFixed: ResultPackage
        packageHeightAdjustable: ResultPackage
        packageFullyAdjustable: ResultPackage
        packageBag: ResultPackage
        resultProduct: OrderProductWithDims[]
        parametersUsed: OptimizationParameter[]
        createdAt: string
    }

    export interface ResultMethod {
        id: string
        cost: number
        retailerId: string
        presented: boolean
        method: TransportMethod
    }

    export interface ResultPackage {
        id: string
        resultId: string
        packageId: string
        externalId: string
        name: string
        variation: number
        container: string
        containerOuterDimensions: number[]
        containerMaxCoord: number[]
        itemsMaxCoord: number[]
        products: string
        productPlacements: algorithm.Box[]
        packageType: string
        recommended: boolean
        alias: string
        weight: number
        /**
         * indicates if all products fit or not. If true, ProductPlacements contains all optItem.Products.
         */
        fitsAllProducts: boolean
    }

    export interface ResultProduct {
        resultId: string
        productId?: string
        externalProductId: string
        dimensions: number[]
        weight: number
        quantity: number
    }

    export interface ResultTransportMethod {
        transporter: string
        method: string
        cost: number
        currency: string
        type: DeliveryType
    }

    export interface Retailer {
        id: string
        name: string
        createdDate: string
        expiryDate: string
        permissions: number[]
    }

    export interface RetailerAlias {
        id: string
        retailerID: string
        transportMethodId: string
        methodAlias: string
        transporterAlias: string
        isDisplayName: boolean
    }

    export interface RetailerCredentials {
        id: string
        retailerId: string
        transportId: string
        credentialType: CredentialDataType
        /**
         * empty (if API key), username, client id
         */
        credentialKey: string

        /**
         * actual API key, password, secret
         */
        credentialValue: string

        createdAt: string
        updatedAt: string
        /**
         * account id
         */
        updatedBy: string

        customerNumber: string
    }

    export interface RetailerMethod {
        retailerId: string
        transportMethod: TransportMethod
        enabled: boolean
        fallbackCost: number
        fallbackCostCurrency: datamodels.Currency
        aliases: RetailerAlias[]
        fallbackEarliestDelivery: number
        fallbackLatestDelivery: number
        requireDTAPass: boolean
        /**
         * If true, this retailer method will be shown in the checkout if it has non-empty fallback times.
         */
        displayUnsuccessfulAvailability: boolean

        /**
         * If true, the fallback cost will be shown as the display price in the checkout (cost calculations will still be run to exclude breaking methods etc.).
         */
        fallbackAsDisplayPrice: boolean

        /**
         * Config to decide if we should always disregard lockers if possible
         */
        excludeLockers: boolean
    }

    /**
     * For inserters
     */
    export interface RetailerMethodData {
        transportMethodId: string
        enabled: boolean
        fallbackCost: number
        fallbackCostCurrency: datamodels.Currency
        aliases: MethodAliasData[]
        fallbackEarliestDelivery: number
        fallbackLatestDelivery: number
        requireDTAPass: boolean
        /**
         * If true, this retailer method will be shown in the checkout if it has non-empty fallback times.
         */
        displayUnsuccessfulAvailability: boolean

        /**
         * If true, the fallback cost will be shown as the display price in the checkout (cost calculations will still be run to exclude breaking methods etc.).
         */
        fallbackAsDisplayPrice: boolean

        /**
         * Config to decide if we should always disregard lockers if possible
         */
        excludeLockers: boolean
    }

    export interface RetailerPackResult {
        id: string
        packageId: string
        dimensions: number[]
        combinedProductWeight: number
        methods: RetailerPackageMethod[]
        packWeight: number
    }

    export interface RetailerPackageMethod {
        id: string
        resultMethod: ResultMethod
    }

    export interface ReturnItemPostPayment {
        /**
         * OrderId represents the unique identifier of the order being processed
         */
        orderId: string

        /**
         * CombinedProductWeight represents the total weight of all products in the order.
         */
        combinedProductWeight: number

        /**
         * TotalVolume indicates the total volume occupied by the products.
         */
        totalVolume: number

        /**
         * PackageFixed refers to a fixed-size packaging option proposed by the optimization algorithm.
         */
        fixedPackage: OptimizationResultPackage

        /**
         * PackageHeightAdjustable refers to a height-adjustable packaging option suggested by the optimization algorithm.
         */
        heightAdjustablePackage: OptimizationResultPackage

        /**
         * PackageFullyAdjustable refers to a fully adjustable packaging option recommended by the optimization algorithm.
         */
        fullyAdjustablePackage: OptimizationResultPackage

        /**
         * EnvironmentalImpact contains data regarding the environmental impact of the packaging and transportation methods suggested.
         */
        environmentalImpact: EnvMetrics

        /**
         * Cost represents the calculated cost for transporting this set of items, considering the optimized packaging and transportation method.
         */
        cost: transportation.CalculateCostResponse

        /**
         * OptimizationDetails contains detailed information about the optimization process, including the methods used and their respective costs.
         */
        optimizationDetails?: Result
    }

    export interface RouteSegment {
        start: datamodels.Location
        end: datamodels.Location
        possibleVehicles: OrganizationVehicle[]
        type: RouteSegmentType
    }

    export interface RouteSegmentCapacityUtilization {
        id: string
        segmentType: RouteSegmentType
        capacityUtilization: number
        organizationID: string
        updatedAt: string
    }

    /**
     * Indicates what the vehicle is used for by the organization
     */
    export type RouteSegmentType = string

    export interface SelfOnboard {
        id?: string
        retailerId: string
        retailerName: string
        firstName: string
        lastName: string
        email: string
        phone: string
        date: string
        otherInfo: string
    }

    /**
     * The sent volume for a specific retailer for a specific date.
     */
    export interface SentVolume {
        /**
         * The date for which the order count is calculated
         */
        date: string

        /**
         * The shipped volume (of the boxes) for that retailer for that day
         */
        sentVolume: number
    }

    export interface ShipmentFilter {
        /**
         * Searches both the tracking reference and external ID
         */
        search?: string

        createdAtFrom?: string
        createdAtTo?: string
        transportMethod?: string[]
        status?: Status[]
        originZipCode?: string
        originCountryCodes?: string[]
        destinationZipCode?: string
        destinationCountryCodes?: string[]
        milestones?: string[]
        trackingReferences?: string[]
        externalReferences?: string[]
        ids?: string[]
    }

    /**
     * ShipmentLabel represents a label for a shipment, including its data, content type, and name.
     */
    export interface ShipmentLabel {
        /**
         * The base64-encoded data of the shipment label.
         */
        dataBase64: string

        /**
         * The MIME type of the shipment label (e.g., "application/pdf").
         */
        contentType: string

        /**
         * The name of the shipment label file.
         */
        name: string

        /**
         * The type of the label (e.g., "BOOKING_LABEL" or "CONSIGNMENT_NOTE"). Default is "BOOKING_LABEL"
         */
        labelType: SkrymLabelType
    }

    export interface ShipmentSort {
        column: ShipmentSortColumn
        direction: string
    }

    export type ShipmentSortColumn = string

    export interface ShipmentStatusCount {
        timestamp: string
        okCount: number
        delayCount: number
        problemCount: number
        doneCount: number
        archivedCount: number
    }

    export interface Shipping {
        providerName: string
        providerId: string
        reference: string
        additional: ShippingAdditional
        providerError: string
    }

    export interface ShippingAdditional {
        ingrid: ShippingAdditionalIngrid
        nshift: ShippingAdditionalNshift
        klarnaShippingAssistant: ShippingAdditionalKlarnaShippingAssistant
        walleyDeliveryModule: ShippingAdditionalWalleyDeliveryModule
        qliroIntegratedShipping: ShippingAdditionalQliroIntegratedShipping
    }

    export interface ShippingAdditionalIngrid {
        checkoutSessionId: string
        deliveries: IngridDelivery[]
    }

    export interface ShippingAdditionalKlarnaShippingAssistant {
        klarnaOrderId: string
        klarnaMerchantId: string
        selectedShippingOption: KlarnaShippingOption
    }

    export interface ShippingAdditionalNshift {
        preparedShipment: NshiftPreparedShipment
    }

    export interface ShippingAdditionalQliroIntegratedShipping {
        shipments: QliroIntegratedShipment[]
    }

    export interface ShippingAdditionalWalleyDeliveryModule {
        purchaseIdentifier: string
        shipping: WalleyDeliveryShipping
    }

    /**
     * ShippingEmissionTotals summarize the emissions for each transport method.
     */
    export interface ShippingEmissionTotals {
        /**
         * the emission breakdown per transportMethod ID
         */
        totalsPerTransportMethod: ShipppingEmissionBreakdown[]
    }

    /**
     * ShippingEmissionsForTransportMethod represents the emissions for a shipping for a specific transport method.
     */
    export interface ShippingEmissionsForTransportMethod {
        /**
         * The distance transported [km]
         */
        transportedDistance: number

        /**
         * CO2-equivalent emissions [kg]
         */
        emissions: number
    }

    export interface ShippingFee {
        basePriceAmount: number
        displayName: string
        taxGroupId: string
        salePriceAmount: number
        taxPercentage: number
        name: string
        discountAmount: number
        id: string
        taxAmount: number
        currencyCode: string
        taxPercentageDecimals: number
    }

    /**
     * ShippingEmissionBreakdown represents the emission summary from a single
     * TransportMethodID that was used OrderCount times.
     */
    export interface ShipppingEmissionBreakdown {
        /**
         * Skrym ID of the transport method
         */
        transportMethodId: string

        /**
         * number of orders transported with this transport method
         */
        orderCount: number

        /**
         * sum of all the (known) shipping emissions from this transport method for all ordercount orders
         */
        totalShippingEmissions: number

        /**
         * sum of the total distance with this transport method
         */
        totalDistance: number
    }

    /**
     * Information regarding the tracking status of one shipment
     */
    export interface SingleShipment {
        /**
         * Tracking reference provided by the transporter.
         */
        trackingNumber: string

        /**
         * Which transport method the shipment uses
         */
        transportMethod: string

        /**
         * Name of the transporter used (e.g. 'budbee')
         */
        transporter: string

        /**
         * Flag indicating if the shipment is completed.
         */
        completed: boolean

        /**
         * The current status of the shipment
         */
        status: Status

        /**
         * In-depth information about the shipment history
         */
        trackingStatusInformation: TrackingStatusInformation

        /**
         * Starting location of the shipment
         */
        originLocation: datamodels.Location

        /**
         * Destination location of the shipment
         */
        destinationLocation: datamodels.Location

        /**
         * Optional: The start of the expected delivery time window, as estimated by the transporter
         */
        expectedDeliveryTimeStart?: string

        /**
         * Optional: The end of the expected delivery time window, as estimated by the transporter
         */
        expectedDeliveryTimeEnd?: string

        /**
         * Additional metadata about the shipment (e.g. the shipment's contents)
         */
        metadata?: JSONValue
    }

    /**
     * SkrymEventTypeDAO represents default event types that are used by Skrym.
     * These can be used by organizations to map external event types to Skrym event types
     */
    export interface SkrymEventTypeDAO {
        /**
         * ID of the event type
         */
        id: string

        /**
         * Code of the event type
         */
        code: EventType

        /**
         * Description of the event type
         */
        description: sql.NullString

        /**
         * Time the event type was created
         */
        createdAt: string

        /**
         * Time the event type was last updated
         */
        updatedAt: string

        /**
         * ID of the user who created the event type
         */
        createdBy: string

        /**
         * ID of the user who last updated the event type
         */
        updatedBy: string

        /**
         * Status indicator for the event type
         */
        statusIndicator: sql.NullString

        /**
         * Icon of the event type
         */
        icon: sql.NullString

        /**
         * Color of the event type
         */
        color: sql.NullString
    }

    export type SkrymLabelType = string

    export interface SkrymTypeFilter {
        skrymType?: boolean
        skrymEventTypeIds?: string[]
    }

    export interface StandardEnvelope {
        id: string
        name: string
        length: number
        width: number
        priority: number
    }

    /**
     * The current status of the shipment
     */
    export type Status = string

    export interface Subscription {
        topic: string
        checked: boolean
    }

    /**
     * SuccessfulShippingEmissionsResult represents a successful emissions calculation for a transport method.
     */
    export interface SuccessfulShippingEmissionsResult {
        /**
         * Transporter name.
         */
        transporter: string

        /**
         * Transport method used.
         */
        transportMethod: string

        /**
         * Emissions for the shipping.
         */
        shippingEmissions: ShippingEmissionsForTransportMethod[]
    }

    export type TEventComparator = string

    export type TMilestoneComparator = string

    export type TPropertyName = string

    export type TTimeComparator = string

    export type TTimeType = string

    export type TType = string

    /**
     * Threshold represents a threshold that needs to be met to reach a milestone
     */
    export interface Threshold {
        /**
         * ID of the threshold
         */
        id: string

        /**
         * Reference for the threshold
         */
        reference: string

        /**
         * Description of the threshold
         */
        description: string

        /**
         * ID of the condition
         */
        conditionId: string

        /**
         * Type of the threshold
         */
        thresholdType: TType

        /**
         * Time the threshold was created
         */
        createdAt: string

        /**
         * Time the threshold was last updated
         */
        updatedAt: string

        /**
         * Whether the threshold is active
         */
        active: boolean

        /**
         * ID of the user who last updated the thresholds
         */
        updatedBy: string

        /**
         * Event-information of the threshold, nil if the threshold is not event-based
         */
        event?: ThresholdEvent

        /**
         * Time-information of the threshold, nil if the threshold is not time-based
         */
        time?: ThresholdTime

        /**
         * Property-information of the threshold, nil if the threshold is not property-based
         */
        property?: ThresholdProperty

        /**
         * Milestone-information of the threshold, nil if the threshold is not milestone-based
         */
        milestone?: ThresholdMilestone
    }

    /**
     * ThresholdEvent represents an event that can be used in a rule to reach a milestone
     */
    export interface ThresholdEvent {
        /**
         * Comparator of the event threshold
         */
        eventComparator: TEventComparator

        /**
         * ID of the event type
         */
        eventTypeId: string

        /**
         * ID of the event map
         */
        eventMapId: string
    }

    export interface ThresholdMilestone {
        /**
         * Comparator of the milestone threshold
         */
        milestoneComparator: TMilestoneComparator

        /**
         * ID of the milestone to compare to
         */
        milestoneId: string
    }

    export interface ThresholdProperty {
        /**
         * Name of the property
         */
        propertyName: TPropertyName

        /**
         * Value of the property
         */
        propertyValue: string
    }

    /**
     * ThresholdSnapshot represents a snapshot of a threshold at a specific point in time.
     */
    export interface ThresholdSnapshot {
        id: string
        conditionSnapshotId: string
        thresholdId: string
        thresholdReference: string
        thresholdDescription: string
        /**
         * The type of threshold, e.g. EVENT, TIME
         */
        thresholdType: TType

        completed: boolean
        timeOfCompletion: string
        timeOfLastCheck: string
        /**
         * The comparator used to compare the time threshold value with the actual time value, BEFORE or AFTER. Nil if the threshold is not a TIME threshold
         */
        timeThresholdComparator: TTimeComparator

        /**
         * The type of time value for TIME thresholds, e.g. SHIPMENT_INITIALIZED, PROMISED_DELIVERY. Nil if the threshold is not a TIME threshold
         */
        timeThresholdValueType: TTimeType

        /**
         * The unit of time value for TIME thresholds, e.g. HOURS, DAYS. Nil if the threshold is not a TIME threshold
         */
        timeThresholdTimeUnit: utils.SkrymTimeUnit

        /**
         * The value of the time threshold, e.g. 1. Nil if the threshold is not a TIME threshold. This represents the number of time units so it should be used in combination with TimeThresholdTimeUnit
         */
        timeThresholdValue: number

        /**
         * The adjuster of the time threshold, e.g. EARLIER, LATER, etc. Nil if the threshold is not a TIME threshold
         */
        timeAdjuster: AdjType

        /**
         * The comparator used to compare the event threshold value with the actual event value, EXISTS/NOT_EXISTS. Nil if the threshold is not an EVENT threshold
         */
        eventThresholdComparator: TEventComparator

        /**
         * The event type for EVENT thresholds, references the OrganizationEventType. Nil if the threshold is not an EVENT threshold
         */
        eventThresholdEventType: string

        /**
         * The event map ID for EVENT thresholds, references the EventMap. Nil if the threshold is not an EVENT threshold
         */
        eventThresholdEventMapId: string

        /**
         * The name of the property for PROPERTY thresholds, e.g. "TRANSPORTER_ID". Nil if the threshold is not a PROPERTY threshold
         */
        propertyThresholdPropertyName: TPropertyName

        /**
         * The value of the property for PROPERTY thresholds, e.g. "Locker". Nil if the threshold is not a PROPERTY threshold
         */
        propertyThresholdValue: string

        /**
         * The comparator used to compare the milestone threshold value with the actual milestone value, EXISTS/NOT_EXISTS. Nil if the threshold is not a MILESTONE threshold
         */
        milestoneThresholdComparator: TMilestoneComparator

        /**
         * The milestone snapshot ID for MILESTONE thresholds. Nil if the threshold is not a MILESTONE threshold
         */
        milestoneThresholdMilestoneSnapshotId: string
    }

    /**
     * ThresholdTime represents a time threshold that can be used in a rule to reach a milestone
     */
    export interface ThresholdTime {
        /**
         * Comparator of the time threshold
         */
        timeComparator: TTimeComparator

        /**
         * Type of the time threshold
         */
        timeType: TTimeType

        /**
         * Value of the time threshold
         */
        timeValue: number

        /**
         * Unit of the time value
         */
        timeValueUnit: utils.SkrymTimeUnit

        /**
         * Adjuster of the time threshold
         */
        timeAdjuster: AdjType
    }

    export interface Totals {
        subTotal: number
        taxTotal: number
        discountTotal: number
        shippingTotal: number
        voucherTotal: number
        giftCardTotal: number
        bonusTotal: number
        grandTotal: number
    }

    export interface TrackedOrder {
        id: string
        organizationId: string
        /**
         * Optional: The start the promised delivery time window, as promised by the retailer
         */
        promisedDeliveryTimeStart?: string

        /**
         * Optional: The end the promised delivery time window, as promised by the retailer
         */
        promisedDeliveryTimeEnd?: string

        /**
         * The location the order is sent from.
         */
        originLocationId: string

        /**
         * The zip code of the origin location.
         */
        originZipCode?: string

        /**
         * The country code of the origin location in Alpha-2 format.
         */
        originCountryCode?: string

        /**
         * The location the order is sent to.
         */
        destinationLocationId: string

        /**
         * The zip code of the destination location.
         */
        destinationZipCode?: string

        /**
         * The country code of the destination location in Alpha-2 format.
         */
        destinationCountryCode?: string

        /**
         * The transporter selected by the user.
         */
        selectedTransporterId?: string

        /**
         * The method selected by the user.
         */
        selectedTransportMethodId?: string

        /**
         * The organization location ID for the pickup location selected by the user.
         */
        selectedPickupOrganizationLocationId?: string

        createdAt: string
        updatedAt: string
        createdBy: string
        updatedBy: string
        /**
         * Additional metadata about the order (e.g. the order's contents)
         */
        metadata?: JSONValue
    }

    export interface TrackedOrderReference {
        id: string
        trackedOrderId: string
        organizationId: string
        reference: string
        createdAt: string
    }

    export interface TrackedParcel {
        id: string
        trackedShipmentId: string
        dimensions?: number[]
        weight?: number
        /**
         * this is the identifier that e-com recieves from the transporter.
         */
        trackingReference: string

        /**
         * A reference for the customer the order that this tracked shipment belongs to, often a order id
         */
        externalReference?: string

        /**
         * Information about the current status of the parcel. Can be either `OK`, `DELAYED` or `PROBLEM`
         */
        status: Status

        /**
         * Additional metadata about the parcel (e.g. the parcel's contents)
         */
        metadata?: JSONValue
    }

    export interface TrackedShipment {
        /**
         * this is Skrym internal ID.
         */
        id: string

        /**
         * this is Skrym internal ID.
         */
        organizationID: string

        transporterId: string
        transportMethodId: string
        trackingMethod: TrackingMethod
        /**
         * this is the identifier that e-com recieves from the transporter.
         */
        trackingReference?: string

        /**
         * A reference for the customer the order that this tracked shipment belongs to, often a order id
         */
        externalReference?: string

        nextPoll: string
        createdAt: string
        origin: string
        originZipCode?: string
        /**
         * Alpha-2 country code
         */
        originCountryCode?: string

        destination: string
        destinationZipCode?: string
        /**
         * Alpha-2 country code
         */
        destinationCountryCode?: string

        /**
         * Optional: The start of the expected delivery time window, as estimated by the transporter
         */
        expectedDeliveryTimeStart?: string

        /**
         * Optional: The end of the expected delivery time window, as estimated by the transporter
         */
        expectedDeliveryTimeEnd?: string

        /**
         * Information about the current status of the shipment. Can be either `OK`, `DELAYED` or `PROBLEM`
         */
        status: Status

        failedPolls: number
        /**
         * Additional metadata about the parcel (e.g. the parcel's contents)
         */
        metadata?: JSONValue
    }

    export interface TrackedShipmentCountByDate {
        startOfRange: string
        count: number
    }

    export interface TrackedShipmentWithOrder {
        trackedShipment: TrackedShipment
        trackedOrder: TrackedOrder
        trackedOrderReferences: TrackedOrderReference[]
    }

    export type TrackingMethod = string

    export type TrackingReferenceType = string

    export interface TrackingReferenceTypeConfiguration {
        organizationID: string
        transporterID: string
        trackingReferenceType: TrackingReferenceType
    }

    export interface TrackingStatusInformation {
        /**
         * Information about where the shipment is in the delivery sequence.
         */
        at?: Checkpoint

        /**
         * Information about what Skrym estimates that the next step in the delivery sequence is.
         */
        next?: Checkpoint

        /**
         * Indication of if you are the shipment's recipient or sender. Can be 'outbound', 'inbound' and 'unknown'
         */
        direction: Direction
    }

    export interface TransportAgreementFile {
        id: string
        transportMethodId: string
        fileName: string
        fileSize: number
        fileType?: string
        message?: string
        uploadedDate: string
        downloadLink: string
    }

    export interface TransportMethod {
        id: string
        name: string
        deliveryType: DeliveryType
        transporter: Transporter
        code: string
    }

    export interface TransportMethodSummary {
        transportMethodID: string
        fromDate: string
        toDate: string
        totalRows: number
        processedRows: number
        totalInvoicedAmount: number
        totalExpectedAmount: number
    }

    /**
     * TransportMethodVehicle represents a vehicle associated with a transport method.
     */
    export interface TransportMethodVehicle {
        /**
         * TransportMethodID is the identifier of the transport method.
         */
        transportMethodId: string

        /**
         * OrganizationVehicleID is the identifier of the vehicle.
         */
        organizationVehicleId: string

        /**
         * OrganizationID is the identifier of the organization that owns the vehicle.
         */
        organizationId: string
    }

    export interface Transporter {
        id: string
        name: string
    }

    /**
     * TriggerData holds optional data specific to a trigger, such as a webhook.
     */
    export interface TriggerData {
        /**
         * Webhook contains the details of a webhook trigger if applicable.
         */
        webhook?: Webhook
    }

    /**
     * TriggerType represents the type of trigger for a journey milestone.
     */
    export type TriggerType = string

    export interface UploadedDataFile {
        id: string
        organizationId: string
        originalName: string
        /**
         * Optional name to be used for display purposes
         */
        displayName: string

        storedName: string
        contentType: string
        /**
         * File size in bytes
         */
        size: number

        /**
         * Sheet number to use in the excel file, 0 means all sheets
         */
        sheetNumber: number

        createdAt: string
        /**
         * e.g. products, orders, etc
         */
        dataType: string

        headerMappings: JSONValue
    }

    export interface UploadedInvoice {
        id: string
        organizationId: string
        mappingID: string
        originalName: string
        /**
         * Optional name to be used for display purposes
         */
        displayName: string

        /**
         * Optional description of the invoice
         */
        description: string

        storedName: string
        contentType: string
        /**
         * File size in bytes
         */
        size: number

        /**
         * Sheet number to use in the excel file, 0 means all sheets
         */
        sheetNumber: number

        createdAt: string
        updatedAt: string
        /**
         * Checks if we successfully stored any rows
         */
        hasStoredRows: boolean

        status: InvoiceProcessingStatus
        processingMessage: string
        /**
         * The total amount of the invoice
         */
        invoicedTotal: number

        /**
         * The currency of the total amount
         */
        invoicedTotalCurrency: datamodels.Currency

        /**
         * The total amount of the invoice for successful cost
         */
        invoicedTotalForSuccessfulCost: number

        /**
         * The currency of the total amount for successful cost
         */
        invoicedTotalForSuccessfulCostCurrency: datamodels.Currency

        /**
         * The expected total amount of the invoice
         */
        expectedTotal: number

        /**
         * The currency of the expected total amount
         */
        expectedTotalCurrency: datamodels.Currency

        /**
         * The time when the statistics were last updated
         */
        statisticsUpdatedAt: string

        /**
         * Invoice metadata for de-duplication
         */
        supplierReference: string

        invoiceDate: string
        customerName: string
        accountId: string
        supplierContact: string
        duplicateOf: string
        /**
         * Soft delete timestamp. If present, the invoice will be hard deleted sometime in the future.
         */
        deletedAt: string
    }

    export type UploadedInvoiceColumn = string

    export type UserAction = string

    /**
     * VehicleClass represents a classification of vehicles within a defined standard.
     */
    export interface VehicleClass {
        /**
         * Unique identifier for the vehicle class.
         */
        id: string

        /**
         * Code representing the vehicle class.
         */
        code: string

        /**
         * Name of the classification standard associated with this class.
         */
        classificationStandard: VehicleClassificationStandard

        /**
         * Definition or description of the vehicle class.
         */
        classDefinition: string
    }

    export type VehicleClassificationStandard = string

    /**
     * VehicleModel represents the details of a vehicle model in the system.
     * It includes information about the vehicle's physical dimensions,
     * engine type, and environmental impact factors such as emissions and fuel consumption.
     */
    export interface VehicleModel {
        /**
         * unique identifier of the vehicle model
         */
        id: string

        /**
         * name of the vehicle model.
         */
        modelName: string

        /**
         * represents identifies different versions of the same model.
         */
        variant: string

        /**
         * name of the company that manufactures the vehicle.
         */
        manufacturer: string

        /**
         * length of the vehicle in mm.
         */
        vehicleLength: number

        /**
         * height of the vehicle in mm.
         */
        vehicleHeight: number

        /**
         * width of the vehicle in mm.
         */
        vehicleWidth: number

        /**
         * weight of the vehicle without load in kilograms.
         */
        vehicleWeightEmpty: number

        /**
         * length of the storage area in mm.
         */
        storageLength: number

        /**
         * width of the storage area in mm.
         */
        storageWidth: number

        /**
         * height of the storage area in meters.
         */
        storageHeight: number

        /**
         * indicates if the vehicle has facilities for frozen storage.
         */
        frozenStorage: boolean

        /**
         * type of engine the vehicle uses.
         */
        engineType: EngineType

        /**
         * maximum load weight the vehicle can carry in kilograms.
         */
        maxLoadWeight: number

        /**
         * vehicle's emissions per 100 kilometer .
         */
        referenceEmissionsByDistance: number

        /**
         * vehicle's fuel consumption rate in liters per 100 kilometer or kWh per 100 kilometer.
         */
        referenceFuelConsumptionRate: number
    }

    /**
     * VehicleModelClassification represents the classification of a vehicle model within the system.
     * It links a specific vehicle to a defined vehicle class, allowing for categorization based on
     * various attributes like size, type, or usage.
     */
    export interface VehicleModelClassification {
        /**
         * Unique identifier for the vehicle.
         */
        vehicleModelId: string

        /**
         * Unique identifier for the classification to which the vehicle belongs.
         */
        vehicleClassId: string
    }

    export type VerificationType = string

    export interface Voucher {
        status: string
        providerId: string
        additional: VoucherAdditional
        providerName: string
        vouchers: VoucherItem[]
    }

    export interface VoucherAdditional {
        voyado: { [key: string]: string }
    }

    export interface VoucherItem {
        id: string
        amount: number
        currencyCode: string
        status: string
    }

    export interface WalleyDeliveryDate {
        fee: number
        date: string
        timeFrom: string
        timeTo: string
        metadata: { [key: string]: JSONValue }
    }

    export interface WalleyDeliveryShipping {
        provider: string
        shippingFee: number
        shipments: WalleyShipment[]
    }

    export interface WalleyDestination {
        id: string
        name: string
        fee: number
        metadata: { [key: string]: JSONValue }
        deliveryDate: WalleyDeliveryDate
    }

    export interface WalleyOption {
        id: string
        description: string
        type: string
        fee: number
        value: JSONValue
    }

    export interface WalleyShipment {
        id: string
        bookedShipmentId: string
        name: string
        feeItemId: string
        metadata: { [key: string]: JSONValue }
        shippingChoice: WalleyShippingChoice
    }

    export interface WalleyShippingChoice {
        id: string
        name: string
        fee: number
        metadata: { [key: string]: JSONValue }
        destination: WalleyDestination
        options: WalleyOption[]
    }

    export type WarehouseFlow = string

    export interface Webhook {
        id: string
        retailerID: string
        name: string
        description?: string
        callbackURL: string
        token: string
        status: boolean
        createdAt: string
        updatedAt: string
        createdBy?: string
        updatedBy?: string
    }
}

export namespace postgres {
    export type DateTruncGranularity = string
}

export namespace repository {
    /**
     * Property to use the query for dynamic grouping
     */
    export type AllowedGroupBy = string

    export interface BookingsPerHour {
        organizationId: string
        hour: string
        count: number
    }

    export interface InvoicesPerDay {
        /**
         * The organization ID
         */
        organizationId: string

        /**
         * Start of the day
         */
        day: string

        /**
         * Number of invoices created on that day
         */
        count: number
    }

    export interface OrdersPerHour {
        /**
         * The organization ID
         */
        organizationId: string

        /**
         * Start of the hour
         */
        hour: string

        /**
         * Number of orders from that hour
         */
        count: number
    }

    export interface TrackedShipmentsPerHour {
        organizationId: string
        hour: string
        count: number
    }

    export interface TransportMethodAverageStatistics {
        transportMethodId: string
        sampleSize: number
        averageOrderValue: number
        averageEstimatedCost: number
        averageDisplayPrice: number
        averageProfitLoss: number
    }
}

export namespace sql {
    /**
     * NullString represents a string that may be null.
     * NullString implements the [Scanner] interface so
     * it can be used as a scan destination:
     * 
     * 	var s NullString
     * 	err := db.QueryRow("SELECT name FROM foo WHERE id=?", id).Scan(&s)
     * 	...
     * 	if s.Valid {
     * 	   // use s.String
     * 	} else {
     * 	   // NULL value
     * 	}
     */
    export interface NullString {
        String: string
        /**
         * Valid is true if String is not NULL
         */
        Valid: boolean
    }
}

export namespace time {
    /**
     * A Weekday specifies a day of the week (Sunday = 0, ...).
     */
    export type Weekday = number
}

export namespace utils {
    export interface Coordinates {
        latitude: number
        longitude: number
    }

    /**
     * MeasurementUnit references a measurement of a physical property and use lowercase abbreviations (e.g. "cm")
     */
    export type MeasurementUnit = string

    export type SkrymTimeUnit = string

    export type SortingDirection = string
}

// JSONValue represents an arbitrary JSON value.
export type JSONValue = string | number | boolean | null | JSONValue[] | {[key: string]: JSONValue}


function encodeQuery(parts: Record<string, string | string[]>): string {
    const pairs: string[] = []
    for (const key in parts) {
        const val = (Array.isArray(parts[key]) ?  parts[key] : [parts[key]]) as string[]
        for (const v of val) {
            pairs.push(`${key}=${encodeURIComponent(v)}`)
        }
    }
    return pairs.join("&")
}

// makeRecord takes a record and strips any undefined values from it,
// and returns the same record with a narrower type.
// @ts-ignore - TS ignore because makeRecord is not always used
function makeRecord<K extends string | number | symbol, V>(record: Record<K, V | undefined>): Record<K, V> {
    for (const key in record) {
        if (record[key] === undefined) {
            delete record[key]
        }
    }
    return record as Record<K, V>
}

function encodeWebSocketHeaders(headers: Record<string, string>) {
    // url safe, no pad
    const base64encoded = btoa(JSON.stringify(headers))
      .replaceAll("=", "")
      .replaceAll("+", "-")
      .replaceAll("/", "_");
    return "encore.dev.headers." + base64encoded;
}

class WebSocketConnection {
    public ws: WebSocket;

    private hasUpdateHandlers: (() => void)[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        let protocols = ["encore-ws"];
        if (headers) {
            protocols.push(encodeWebSocketHeaders(headers))
        }

        this.ws = new WebSocket(url, protocols)

        this.on("error", () => {
            this.resolveHasUpdateHandlers();
        });

        this.on("close", () => {
            this.resolveHasUpdateHandlers();
        });
    }

    resolveHasUpdateHandlers() {
        const handlers = this.hasUpdateHandlers;
        this.hasUpdateHandlers = [];

        for (const handler of handlers) {
            handler()
        }
    }

    async hasUpdate() {
        // await until a new message have been received, or the socket is closed
        await new Promise((resolve) => {
            this.hasUpdateHandlers.push(() => resolve(null))
        });
    }

    on(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.addEventListener(type, handler);
    }

    off(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.removeEventListener(type, handler);
    }

    close() {
        this.ws.close();
    }
}

export class StreamInOut<Request, Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamIn<Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamOut<Request, Response> {
    public socket: WebSocketConnection;
    private responseValue: Promise<Response>;

    constructor(url: string, headers?: Record<string, string>) {
        let responseResolver: (_: any) => void;
        this.responseValue = new Promise((resolve) => responseResolver = resolve);

        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            responseResolver(JSON.parse(event.data))
        });
    }

    async response(): Promise<Response> {
        return this.responseValue;
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }
}
// CallParameters is the type of the parameters to a method call, but require headers to be a Record type
type CallParameters = Omit<RequestInit, "method" | "body" | "headers"> & {
    /** Headers to be sent with the request */
    headers?: Record<string, string>

    /** Query parameters to be sent with the request */
    query?: Record<string, string | string[]>
}

// AuthDataGenerator is a function that returns a new instance of the authentication data required by this API
export type AuthDataGenerator = () =>
  | authentication.AuthParams
  | Promise<authentication.AuthParams | undefined>
  | undefined;

// A fetcher is the prototype for the inbuilt Fetch function
export type Fetcher = typeof fetch;

const boundFetch = fetch.bind(this);

class BaseClient {
    readonly baseURL: string
    readonly fetcher: Fetcher
    readonly headers: Record<string, string>
    readonly requestInit: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }
    readonly authGenerator?: AuthDataGenerator

    constructor(baseURL: string, options: ClientOptions) {
        this.baseURL = baseURL
        this.headers = {}

        // Add User-Agent header if the script is running in the server
        // because browsers do not allow setting User-Agent headers to requests
        if (!BROWSER) {
            this.headers["User-Agent"] = "skrymr-re72ae-Generated-TS-Client (Encore/v1.48.9)";
        }

        this.requestInit = options.requestInit ?? {};

        // Setup what fetch function we'll be using in the base client
        if (options.fetcher !== undefined) {
            this.fetcher = options.fetcher
        } else {
            this.fetcher = boundFetch
        }

        // Setup an authentication data generator using the auth data token option
        if (options.auth !== undefined) {
            const auth = options.auth
            if (typeof auth === "function") {
                this.authGenerator = auth
            } else {
                this.authGenerator = () => auth
            }
        }
    }

    async getAuthData(): Promise<CallParameters | undefined> {
        let authData: authentication.AuthParams | undefined;

        // If authorization data generator is present, call it and add the returned data to the request
        if (this.authGenerator) {
            const mayBePromise = this.authGenerator();
            if (mayBePromise instanceof Promise) {
                authData = await mayBePromise;
            } else {
                authData = mayBePromise;
            }
        }

        if (authData) {
            const data: CallParameters = {};

            data.headers = makeRecord<string, string>({
                authorization:              authData.Authorization,
                "widget-secret":            authData.WidgetSecret,
                "widget-token":             authData.WidgetToken,
                "x-active-organization-id": authData.ActiveOrganizationID === undefined ? undefined : String(authData.ActiveOrganizationID),
                "x-auth-token":             authData.XAuthToken,
            });

            return data;
        }

        return undefined;
    }

    // createStreamInOut sets up a stream to a streaming API endpoint.
    async createStreamInOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamInOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamInOut(this.baseURL + path + queryString, headers);
    }

    // createStreamIn sets up a stream to a streaming API endpoint.
    async createStreamIn<Response>(path: string, params?: CallParameters): Promise<StreamIn<Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamIn(this.baseURL + path + queryString, headers);
    }

    // createStreamOut sets up a stream to a streaming API endpoint.
    async createStreamOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamOut(this.baseURL + path + queryString, headers);
    }

    // callTypedAPI makes an API call, defaulting content type to "application/json"
    public async callTypedAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        return this.callAPI(method, path, body, {
            ...params,
            headers: { "Content-Type": "application/json", ...params?.headers }
        });
    }

    // callAPI is used by each generated API method to actually make the request
    public async callAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        let { query, headers, ...rest } = params ?? {}
        const init = {
            ...this.requestInit,
            ...rest,
            method,
            body: body ?? null,
        }

        // Merge our headers with any predefined headers
        init.headers = {...this.headers, ...init.headers, ...headers}

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                init.headers = {...init.headers, ...authData.headers};
            }
        }

        // Make the actual request
        const queryString = query ? '?' + encodeQuery(query) : ''
        const response = await this.fetcher(this.baseURL+path+queryString, init)

        // handle any error responses
        if (!response.ok) {
            // try and get the error message from the response body
            let body: APIErrorResponse = { code: ErrCode.Unknown, message: `request failed: status ${response.status}` }

            // if we can get the structured error we should, otherwise give a best effort
            try {
                const text = await response.text()

                try {
                    const jsonBody = JSON.parse(text)
                    if (isAPIErrorResponse(jsonBody)) {
                        body = jsonBody
                    } else {
                        body.message += ": " + JSON.stringify(jsonBody)
                    }
                } catch {
                    body.message += ": " + text
                }
            } catch (e) {
                // otherwise we just append the text to the error message
                body.message += ": " + String(e)
            }

            throw new APIError(response.status, body)
        }

        return response
    }
}

/**
 * APIErrorDetails represents the response from an Encore API in the case of an error
 */
interface APIErrorResponse {
    code: ErrCode
    message: string
    details?: any
}

function isAPIErrorResponse(err: any): err is APIErrorResponse {
    return (
        err !== undefined && err !== null &&
        isErrCode(err.code) &&
        typeof(err.message) === "string" &&
        (err.details === undefined || err.details === null || typeof(err.details) === "object")
    )
}

function isErrCode(code: any): code is ErrCode {
    return code !== undefined && Object.values(ErrCode).includes(code)
}

/**
 * APIError represents a structured error as returned from an Encore application.
 */
export class APIError extends Error {
    /**
     * The HTTP status code associated with the error.
     */
    public readonly status: number

    /**
     * The Encore error code
     */
    public readonly code: ErrCode

    /**
     * The error details
     */
    public readonly details?: any

    constructor(status: number, response: APIErrorResponse) {
        // extending errors causes issues after you construct them, unless you apply the following fixes
        super(response.message);

        // set error name as constructor name, make it not enumerable to keep native Error behavior
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/new.target#new.target_in_constructors
        Object.defineProperty(this, 'name', {
            value:        'APIError',
            enumerable:   false,
            configurable: true,
        })

        // fix the prototype chain
        if ((Object as any).setPrototypeOf == undefined) {
            (this as any).__proto__ = APIError.prototype
        } else {
            Object.setPrototypeOf(this, APIError.prototype);
        }

        // capture a stack trace
        if ((Error as any).captureStackTrace !== undefined) {
            (Error as any).captureStackTrace(this, this.constructor);
        }

        this.status = status
        this.code = response.code
        this.details = response.details
    }
}

/**
 * Typeguard allowing use of an APIError's fields'
 */
export function isAPIError(err: any): err is APIError {
    return err instanceof APIError;
}

export enum ErrCode {
    /**
     * OK indicates the operation was successful.
     */
    OK = "ok",

    /**
     * Canceled indicates the operation was canceled (typically by the caller).
     *
     * Encore will generate this error code when cancellation is requested.
     */
    Canceled = "canceled",

    /**
     * Unknown error. An example of where this error may be returned is
     * if a Status value received from another address space belongs to
     * an error-space that is not known in this address space. Also
     * errors raised by APIs that do not return enough error information
     * may be converted to this error.
     *
     * Encore will generate this error code in the above two mentioned cases.
     */
    Unknown = "unknown",

    /**
     * InvalidArgument indicates client specified an invalid argument.
     * Note that this differs from FailedPrecondition. It indicates arguments
     * that are problematic regardless of the state of the system
     * (e.g., a malformed file name).
     *
     * This error code will not be generated by the gRPC framework.
     */
    InvalidArgument = "invalid_argument",

    /**
     * DeadlineExceeded means operation expired before completion.
     * For operations that change the state of the system, this error may be
     * returned even if the operation has completed successfully. For
     * example, a successful response from a server could have been delayed
     * long enough for the deadline to expire.
     *
     * The gRPC framework will generate this error code when the deadline is
     * exceeded.
     */
    DeadlineExceeded = "deadline_exceeded",

    /**
     * NotFound means some requested entity (e.g., file or directory) was
     * not found.
     *
     * This error code will not be generated by the gRPC framework.
     */
    NotFound = "not_found",

    /**
     * AlreadyExists means an attempt to create an entity failed because one
     * already exists.
     *
     * This error code will not be generated by the gRPC framework.
     */
    AlreadyExists = "already_exists",

    /**
     * PermissionDenied indicates the caller does not have permission to
     * execute the specified operation. It must not be used for rejections
     * caused by exhausting some resource (use ResourceExhausted
     * instead for those errors). It must not be
     * used if the caller cannot be identified (use Unauthenticated
     * instead for those errors).
     *
     * This error code will not be generated by the gRPC core framework,
     * but expect authentication middleware to use it.
     */
    PermissionDenied = "permission_denied",

    /**
     * ResourceExhausted indicates some resource has been exhausted, perhaps
     * a per-user quota, or perhaps the entire file system is out of space.
     *
     * This error code will be generated by the gRPC framework in
     * out-of-memory and server overload situations, or when a message is
     * larger than the configured maximum size.
     */
    ResourceExhausted = "resource_exhausted",

    /**
     * FailedPrecondition indicates operation was rejected because the
     * system is not in a state required for the operation's execution.
     * For example, directory to be deleted may be non-empty, an rmdir
     * operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FailedPrecondition, Aborted, and Unavailable:
     *  (a) Use Unavailable if the client can retry just the failing call.
     *  (b) Use Aborted if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FailedPrecondition if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FailedPrecondition
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FailedPrecondition if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     *
     * This error code will not be generated by the gRPC framework.
     */
    FailedPrecondition = "failed_precondition",

    /**
     * Aborted indicates the operation was aborted, typically due to a
     * concurrency issue like sequencer check failures, transaction aborts,
     * etc.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     */
    Aborted = "aborted",

    /**
     * OutOfRange means operation was attempted past the valid range.
     * E.g., seeking or reading past end of file.
     *
     * Unlike InvalidArgument, this error indicates a problem that may
     * be fixed if the system state changes. For example, a 32-bit file
     * system will generate InvalidArgument if asked to read at an
     * offset that is not in the range [0,2^32-1], but it will generate
     * OutOfRange if asked to read from an offset past the current
     * file size.
     *
     * There is a fair bit of overlap between FailedPrecondition and
     * OutOfRange. We recommend using OutOfRange (the more specific
     * error) when it applies so that callers who are iterating through
     * a space can easily look for an OutOfRange error to detect when
     * they are done.
     *
     * This error code will not be generated by the gRPC framework.
     */
    OutOfRange = "out_of_range",

    /**
     * Unimplemented indicates operation is not implemented or not
     * supported/enabled in this service.
     *
     * This error code will be generated by the gRPC framework. Most
     * commonly, you will see this error code when a method implementation
     * is missing on the server. It can also be generated for unknown
     * compression algorithms or a disagreement as to whether an RPC should
     * be streaming.
     */
    Unimplemented = "unimplemented",

    /**
     * Internal errors. Means some invariants expected by underlying
     * system has been broken. If you see one of these errors,
     * something is very broken.
     *
     * This error code will be generated by the gRPC framework in several
     * internal error conditions.
     */
    Internal = "internal",

    /**
     * Unavailable indicates the service is currently unavailable.
     * This is a most likely a transient condition and may be corrected
     * by retrying with a backoff. Note that it is not always safe to retry
     * non-idempotent operations.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     *
     * This error code will be generated by the gRPC framework during
     * abrupt shutdown of a server process or network connection.
     */
    Unavailable = "unavailable",

    /**
     * DataLoss indicates unrecoverable data loss or corruption.
     *
     * This error code will not be generated by the gRPC framework.
     */
    DataLoss = "data_loss",

    /**
     * Unauthenticated indicates the request does not have valid
     * authentication credentials for the operation.
     *
     * The gRPC framework will generate this error code when the
     * authentication metadata is invalid or a Credentials callback fails,
     * but also expect authentication middleware to generate it.
     */
    Unauthenticated = "unauthenticated",
}
